/// <reference path="../scripts/definition/angularjs/angular.d.ts" />
angular.module('DoctorApp', [
    'ngRoute',
    'filters',
    'cfp.loadingBar',
    'gd.ui.jsonexplorer',
    'jackrabbitsgroup.angular-multiselect',
    'ui.bootstrap',
    'schemaForm',
    'angular-cache',
    'ui.tinymce',
    'infinite-scroll',
    'ngclipboard',
    'multipleSelect',
    'moment-picker'
])
    .config([
    '$httpProvider', function ($httpProvider) {
        $httpProvider.interceptors.push('authInterceptorService');
    }
])
    .config([
    'cfpLoadingBarProvider', function (cfpLoadingBarProvider) {
        cfpLoadingBarProvider.includeSpinner = true;
        cfpLoadingBarProvider.includeBar = true;
    }
])
    .config([
    'CacheFactoryProvider', function (CacheFactoryProvider) {
        angular.extend(CacheFactoryProvider.defaults, { maxAge: 2 * 60 * 1000 });
    }
]);
/// <reference path="../../scripts/definition/angularjs/angular.d.ts" />
var Common = (function () {
    function Common() {
    }
    Common.isNumber = function (n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
    };
    Common.concatWithoutDuplicates = function () {
        var items = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            items[_i - 0] = arguments[_i];
        }
        var res = [];
        for (var i = 0; i < items.length; i++) {
            var list = items[i];
            for (var j = 0; j < list.length; j++) {
                if (!Common.isContains(res, list[j])) {
                    res.push(list[j]);
                }
            }
        }
        return res;
    };
    Common.getIndexBy = function (array, name, value) {
        for (var i = 0; i < array.length; i++) {
            if (array[i][name] === value) {
                return i;
            }
        }
        return -1;
    };
    Common.isContains = function (source, element) {
        if (Array.isArray(source)) {
            for (var i = 0; i < source.length; i++) {
                if (Array.isArray(element)) {
                    for (var j = 0; j < element.length; j++) {
                        if (angular.equals(source[i], element[j])) {
                            return true;
                        }
                    }
                }
                else {
                    if (angular.equals(source[i], element)) {
                        return true;
                    }
                }
            }
            return false;
        }
        if (typeof source == "string") {
            return source.indexOf(element) > -1;
        }
        throw new Error("Method Common.Contains is not defined for " + typeof source);
    };
    Common.Enum = function (enums) {
        console.warn('Method is deprecated. Common.Enum');
        for (var i in enums) {
            this[i] = enums[i];
        }
    };
    Common.toArray = function (obj) {
        var res = [];
        Object.keys(obj)
            .map(function (value, index) {
            res[index] = { key: value, value: obj[value] };
        });
        return res;
    };
    Common.toDictionaryObject = function (array) {
        var res = {};
        array.forEach(function (i) {
            if (i.key != '') {
                res[i.key] = i.value;
            }
        });
        return res;
    };
    Common.parseBoolean = function (value) {
        if (!value) {
            return false;
        }
        return value.toLowerCase() === 'true';
    };
    return Common;
})();
angular.module('DoctorApp')
    .service('common', function () {
    return Common;
});
if (!String.prototype.endsWith) {
    String.prototype.endsWith = function (suffix) {
        return this.indexOf(suffix, this.length - suffix.length) !== -1;
    };
}
if (!String.prototype.startsWith) {
    String.prototype.startsWith = function (str) {
        return this.indexOf(str) === 0;
    };
}
if (!String.prototype.contains) {
    String.prototype.contains = function (str) {
        return this.indexOf(str) > -1;
    };
}
if (!String.prototype.insertAt) {
    String.prototype.insertAt = function (char, pos) {
        return this.slice(0, pos) + char + this.slice(pos);
    };
}

/// <reference path="../../scripts/definition/angularjs/angular.d.ts" />
angular.module('DoctorApp')
    .directive('calcButton', function () {
    return {
        restrict: 'C',
        link: function (scope, element, attrs) {
            element.click(function () {
                scope.$apply(function () {
                    scope.model.quantity = "" + scope.model.quantity + element.text();
                });
            });
        }
    };
});
angular.module('DoctorApp')
    .directive('clearIcon', ["$compile", function ($compile) {
    return {
        require: 'ngModel',
        restrict: 'EA',
        link: function (scope, elem, attrs) {
            var model = attrs.ngModel;
            var template = '<span ng-click=\"clearText(\'' +
                model +
                '\')\" class="clearIcon style="display:none;">x</span>';
            elem.parent().append($compile(template)(scope));
            var clearIconToggle = function (toggleParam) {
                if (elem.val().trim().length)
                    elem.next().css("display", "inline");
                else {
                    if (elem.next().css("display") === "inline")
                        elem.next().css("display", "none");
                }
            };
            var clearText = function (clearParam) {
                elem.val('');
                clearIconToggle(clearParam);
            };
            elem.on("focus", function (event) {
                clearIconToggle(model);
            });
            elem.on("keyup", function (event) {
                clearIconToggle(model);
            });
            elem.next().on("click", function (event) {
                elem.val('');
                elem.next().css("display", "none");
            });
        }
    };
}]);
/// <reference path="../../scripts/definition/angularjs/angular.d.ts" />
angular.module('DoctorApp')
    .directive('iconDegreeCount', ['homeService', function () {
        return {
            scope: {
                count: '=',
                white: '=',
                image: '='
            },
            restrict: 'E',
            template: '<div style="float: left; margin-right: 2px; min-width:52px; cursor: pointer">' +
                '<div style="float: left; width:33px; height:33px; background-color: #f26722; border-radius: 5px; background-repeat: no-repeat; background-position: center; background-size: contain; background-image: url({{::image}});">' +
                '</div>' +
                '<div ng-if="count" ng-style="{\'color\': white?\'#fff\':\'#f26722\'}" style="float:right; font-size: 14px; font-weight: bold; margin-top: -10px;" ng-bind="count"></div>' +
                '</div>',
        };
    }])
    .directive('ripple', ['$timeout', function ($timeout) {
        return {
            restrict: 'C',
            link: function (scope, element, attrs) {
                $(element).on('click', function (event) {
                    event.preventDefault();
                    var $div = $('<div/>'), btnOffset = $(this).offset(), xPos = event.pageX - btnOffset.left, yPos = event.pageY - btnOffset.top;
                    $div.addClass('ripple-effect');
                    var $ripple = $(".ripple-effect");
                    $ripple.css("height", $(this).height());
                    $ripple.css("width", $(this).height());
                    $div
                        .css({
                        top: yPos - ($ripple.height() / 2),
                        left: xPos - ($ripple.width() / 2),
                        background: $(this).data("ripple-color")
                    })
                        .appendTo($(this));
                    $timeout(function () {
                        $div.remove();
                    }, 1000);
                });
            }
        };
    }])
    .directive('patientsInWaitingRoom', ['homeService', 'locationService', '$routeParams', '$rootScope', 'modalService',
    function (homeService, locationService, $routeParams, $rootScope, modalService) {
        return {
            scope: {
                white: '='
            },
            restrict: 'EA',
            template: "\n\t\t\t\t\t<icon-degree-count ng-click=\"goToHome()\" ng-if=\"count > 0\" count=\"count\" white=\"white\" image=\"'styles/images/waiting-patient.png'\">\n\t\t\t\t\t</icon-degree-count>",
            link: function (scope, element, attr) {
                var practiceId = $routeParams.practiceId;
                var getWaitingPatients = function () {
                    homeService.getCachedCheckInPatients(practiceId)
                        .then(function (checkedInPatients) {
                        scope.count = checkedInPatients.filter(function (patient) { return patient.Status === 1; }).length;
                    });
                };
                var CheckedInPatientsUpdated$ = $rootScope.$on('CheckedInPatientsUpdated', function ($e, checkedInPatients) {
                    scope.count = checkedInPatients.filter(function (patient) { return patient.Status === 1; }).length;
                });
                scope.count = 0;
                scope.$on('$destroy', function () {
                    CheckedInPatientsUpdated$();
                });
                scope.goToHome = function () {
                    if (practiceId) {
                        modalService.confirm('You currently have <b>' + scope.count + '</b> patient' + (scope.count > 1 ? "s" : "") + ' in the waiting room.<br><br>Are you sure you would like to go back to the waiting room?')
                            .then(function () {
                            locationService.goToHome(practiceId);
                        });
                    }
                };
                getWaitingPatients();
            }
        };
    }]);
/// <reference path="../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../scripts/definition/moment/moment-node.d.ts" />
var DatePickerModule;
(function (DatePickerModule) {
    var Config = (function () {
        function Config() {
        }
        Config.init = function (config) {
            config.format = config.format || Config.DEFAULT_FORMAT;
        };
        Config.DEFAULT_FORMAT = 'yy-mm-dd';
        return Config;
    })();
    DatePickerModule.Config = Config;
    var Link = (function () {
        function Link(scope, element, attrs, ngModelCtrl, transclude) {
            scope.config = scope.config || new Config();
            Config.init(scope.config);
            Link.init(scope, element, ngModelCtrl);
        }
        Link.init = function (scope, element, ngModelCtrl) {
            var input = element.find('input');
            var icon = element.find('.calanderico');
            var inputElement = angular.element(input[0]);
            Link.initWatcherModel(scope, ngModelCtrl, inputElement);
            Link.initDatePicker(scope, ngModelCtrl, inputElement, icon);
            Link.initWatcherConfig(scope, inputElement);
        };
        Link.initWatcherModel = function (scope, ngModelCtrl, inputElement) {
            var stop = scope.$watch(function () {
                return ngModelCtrl.$modelValue;
            }, function () {
                var date = ngModelCtrl.$modelValue;
                if (Link.moment.isMoment(date)) {
                    inputElement.datepicker('setDate', date.toDate());
                }
            });
        };
        Link.initDatePicker = function (scope, ngModelCtrl, inputElement, icon) {
            var element = inputElement;
            element.datepicker({
                dateFormat: scope.config.format,
                onSelect: function (date) {
                    scope.$apply(function () {
                        var v_date = element.datepicker('getDate');
                        var d = Link.moment(v_date);
                        ngModelCtrl.$setViewValue(d);
                    });
                }
            });
            icon.click(function () {
                inputElement.datepicker("show");
            });
        };
        Link.initWatcherConfig = function (scope, element) {
            var _this = this;
            scope.$watch('config', function () {
                element.datepicker("option", "dateFormat", scope.config.format);
                if (scope.config.changeMonth) {
                    element.datepicker("option", "changeMonth", scope.config.changeMonth);
                }
                if (scope.config.changeYear) {
                    element.datepicker("option", "changeYear", scope.config.changeYear);
                    element.datepicker("option", "yearRange", "1930:" + _this.moment().year());
                }
                if (scope.config.max) {
                    element.datepicker("option", "maxDate", scope.config.max.toDate());
                }
                if (scope.config.min) {
                    element.datepicker("option", "minDate", scope.config.min.toDate());
                }
            }, true);
        };
        return Link;
    })();
    var Directive = (function () {
        function Directive(moment) {
            this.template = '<div class="date-picker" ng-class="{\'has-error\': isRequired && formSubmitted && !model} {\'desirable\': isRequired}">' +
                '<span class="calanderico mouse-pointer"></span>' +
                '<input ng-model="model" ng-value="model | date: config.format" ng-required="isRequired" type="text" style="border: none" readonly ng-class="{\'desirable\': isRequired}"/>' +
                '</div>';
            this.link = Link;
            this.require = 'ngModel';
            this.restrict = 'E';
            this.scope = {
                model: '=ngModel',
                formSubmitted: '=?',
                isRequired: '=?',
                config: '=?'
            };
            Link.moment = moment;
        }
        Directive.factory = function () {
            var methodFactory = function (moment) {
                "ngInject";
                return new Directive(moment);
            };
            methodFactory.$inject = ["moment"];
            return methodFactory;
        };
        return Directive;
    })();
    DatePickerModule.Directive = Directive;
})(DatePickerModule || (DatePickerModule = {}));
angular.module('DoctorApp')
    .directive('datePicker', DatePickerModule.Directive.factory());
var _this = this;
/// <reference path="../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../scripts/definition/moment/moment-node.d.ts" />
angular.module('DoctorApp')
    .directive('ngPlaceholder', [
    '$document',
    function ($document) {
        "use strict";
        return {
            restrict: 'A',
            scope: {
                placeholder: '=ngPlaceholder'
            },
            link: function (scope, elem, attr) {
                scope.$watch('placeholder', function () {
                    elem[0].placeholder = scope.placeholder;
                });
            }
        };
    }
])
    .directive('autoFocus', [
    '$timeout', function ($timeout) {
        "use strict";
        return {
            link: function ($scope, $element, attr) {
                if (attr.autoFocus === "true" || attr.autoFocus === '') {
                    var timeout = parseInt(attr.autofocusTimeOut) || 1000;
                    $timeout(function () {
                        var scrollCont = $('.container-view');
                        var scrollY = scrollCont.scrollTop();
                        $element[0].focus();
                        scrollCont.scrollTop(scrollY);
                    }, timeout);
                }
            }
        };
    }
])
    .directive('setPlaceholder', [
    '$timeout', function ($timeout) {
        "use strict";
        return {
            link: function ($scope, $element, attr) {
                $timeout(function () {
                    var inputText = attr.setPlaceholder || '';
                    $element.find('input')[0].placeholder = inputText;
                });
            }
        };
    }
])
    .directive('slideable', function () {
    "use strict";
    return {
        restrict: 'C',
        compile: function (element, attr) {
            var contents = element.html();
            element.html('<div class="slideable_content" style="margin:0 !important; padding:0 !important" >' +
                contents +
                '</div>');
            return function postLink(scope, element, attrs) {
                attrs.duration = (!attrs.duration) ? '0.5s' : attrs.duration;
                attrs.easing = (!attrs.easing) ? 'ease-in-out' : attrs.easing;
                element.css({
                    'overflow': 'hidden',
                    'height': '0',
                    'transitionProperty': 'height',
                    'transitionDuration': attrs.duration,
                    'transitionTimingFunction': attrs.easing
                });
            };
        }
    };
})
    .directive('slideToggle', function () {
    "use strict";
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            var target = document.querySelector(attrs.slideToggle);
            attrs.expanded = false;
            element.bind('click', function () {
                var content = target.querySelector('.slideable_content');
                if (!attrs.expanded) {
                    content.style.border = '1px solid rgba(0,0,0,0)';
                    var y = content.clientHeight;
                    content.style.border = 0;
                    target.style.height = y + 'px';
                }
                else {
                    target.style.height = '0px';
                }
                attrs.expanded = !attrs.expanded;
            });
        }
    };
})
    .directive('customDatePicker', function () {
    "use strict";
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function (scope, element, attrs, ngModelCtrl) {
            console.warn('Jquery will be remove. Main.CustomDatePicker');
            angular.element(element[0]).datepicker({
                dateFormat: 'd MM, yy ',
                onSelect: function (date) {
                    scope.$apply(function () {
                        var v_date = element.datepicker('getDate');
                        ngModelCtrl.$setViewValue(v_date);
                    });
                },
                maxDate: new Date()
            });
        }
    };
})
    .directive('datePicker', [
    'moment', function (moment) {
        "use strict";
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attrs, ngModelCtrl) {
                var DATE_PATTERN_MOMENT = 'DD MMMM, YYYY';
                var DATE_PATTERN = 'dd MM, yy';
                $(element[0]).datepicker({
                    dateFormat: DATE_PATTERN,
                    onSelect: function (date) {
                        scope.$apply(function () {
                            var v_date = element.datepicker('getDate');
                            ngModelCtrl.$setViewValue(moment(v_date).format(DATE_PATTERN_MOMENT));
                        });
                    },
                    maxDate: new Date()
                });
            }
        };
    }
])
    .directive('smartSelect', [
    '$filter', '$timeout', function ($filter, $timeout) {
        "use strict";
        return {
            restrict: 'E',
            require: 'ngModel',
            scope: {
                isDisabled: '=',
                isRequired: '=',
                items: '=',
                change: '&',
                model: '=ngModel'
            },
            template: '<div dropdown is-open="showDrop">' +
                '<div class="input-wrapper">' +
                '<input ng-disabled="isDisabled" ng-readonly="isDisabled" ng-required="isRequired" class="btn-group form-control desirable"' +
                'ng-model="value"' +
                'type="text" tabindex="{{::tab}}"' +
                'ng-focus="showDrop=true;$event.preventDefault();$event.stopPropagation();valueCopy=\'\' "' +
                'ng-click="showDrop=true;$event.preventDefault();$event.stopPropagation();valueCopy=\'\' "/>' +
                '</div>' +
                '<ul class="dropdown-menu desirable" ng-show="(items | filter:value).length">' +
                '<li ng-if="useFirst===\'All\'" ng-click="onChange(item[option]); $parent.model=\'*\'; $parent.value=\'All\'" class="mouse-pointer usual-field">All</li>' +
                '<li ng-if="useFirst===\'empty\'" ng-click="onChange(item[option]); $parent.model=\'\'; $parent.value=\'\'" class="mouse-pointer usual-field empty-field"></li>' +
                '<li ng-repeat="item in items | filter:valueCopy"' +
                'ng-click="$parent.model=item[option]; $parent.value=item[label]; onChange(item[option]);"' +
                'class="mouse-pointer usual-field"' +
                'ng-bind="::item[label]">' +
                '</li>' +
                '</ul>' +
                '</div>',
            link: function (scope, element, attrs, ctrl) {
                scope.label = attrs.label;
                scope.option = attrs.option;
                scope.value = '';
                scope.useFirst = attrs.useFirst;
                scope.tab = parseInt(attrs.tabIndex);
                var itemsFirstAdded = false;
                var filterKey = {};
                var updateView = function () {
                    if (scope.model === null || scope.model === undefined || scope.model === '') {
                        scope.value = '';
                    }
                    else if (scope.model === '*') {
                        scope.value = 'All';
                    }
                    else {
                        filterKey[scope.option] = scope.model;
                        var value = $filter("filter")(scope.items, filterKey);
                        if (value && value.length) {
                            scope.value = value[0][scope.label];
                        }
                    }
                };
                scope.onChange = function (value) {
                    if (attrs.ngChange) {
                        ctrl.$setViewValue(value);
                    }
                };
                var interval = null;
                scope.$watch("value", function () {
                    scope.valueCopy = scope.value;
                    if (scope.change) {
                        $timeout.cancel(interval);
                        interval = $timeout(function () {
                            interval = null;
                            var item = $filter("filter")(scope.items, scope.model)[0];
                            if (!item || item && item[scope.label] !== scope.value) {
                                scope.change({ data: scope.value });
                            }
                        }, 500);
                    }
                });
                scope.$watch("showDrop", function () {
                    if (scope.showDrop === false) {
                        updateView();
                    }
                });
                scope.$watch('items', function () {
                    if (scope.model !== undefined && scope.items && scope.items.length && !itemsFirstAdded) {
                        updateView();
                        itemsFirstAdded = true;
                    }
                });
                scope.$watch('model', function () {
                    if (scope.items && scope.items.length) {
                        updateView();
                    }
                });
            }
        };
    }
])
    .directive('datepickerVisitOutcomes', [
    'moment', function (moment) {
        "use strict";
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attrs, ngModelCtrl) {
                console.warn('Jquery will be remove. Main.CustomDatePicker');
                var dateFormatMoment = "DD/MM/YYYY";
                var minDate = moment(attrs.minDate);
                element.datepicker({
                    dateFormat: 'dd/mm/yy'
                });
                if (minDate.isValid()) {
                    element.datepicker('option', 'minDate', minDate.toDate());
                }
                ngModelCtrl.$formatters.push(function (dateMoment) {
                    return dateMoment.format(dateFormatMoment);
                });
                ngModelCtrl.$parsers.push(function (dateString) {
                    return moment(dateString, dateFormatMoment);
                });
            }
        };
    }
])
    .directive('ngTab', function () {
    "use strict";
    return {
        restrict: 'A',
        link: function (scope, elem, attrs) {
            if (attrs.ngTab == "last") {
                elem.on('keydown', function (event) {
                    if (event.which == 9) {
                        event.preventDefault();
                        var first = angular.element("[ng-tab=first]");
                        first.select();
                        first.focus();
                    }
                });
            }
        }
    };
})
    .directive('ngLastDayVisitsExpand', [
    '$timeout', function ($timeout) {
        "use strict";
        return {
            restrict: 'A',
            link: function (scope, element, attr) {
                if (scope.$last === true) {
                    $timeout(function () {
                        angular.element('#toggle0').click();
                    });
                }
            }
        };
    }
])
    .directive('consultationContainer', function () {
    "use strict";
    return {
        restrict: 'A',
        link: function (scope, element, attr) {
            angular.element('.container').addClass("consultation-container");
            angular.element('body').addClass("portrait");
        }
    };
})
    .directive('searchContainer', function () {
    "use strict";
    return {
        restrict: 'A',
        link: function (scope, element, attr) {
            angular.element('.container').removeClass("consultation-container");
        }
    };
})
    .directive('statusicon', [
    'infrastructureService', '$interval', '$rootScope', function (infrastructureService, $interval, $rootScope) {
        "use strict";
        return {
            restrict: 'C',
            link: function (scope, element, attrs) {
                var stopTime;
                function updateNetworkState() {
                    var image = element.css('background-image');
                    var i = image.indexOf('.png');
                    infrastructureService.getNetworkState()
                        .then(function (response) {
                        if (response.Sucess === false) {
                            element.css('background-image', 'url(styles/images/status/3.png)');
                        }
                        else {
                            var url = "url(styles/images/status/@1.png)".replace('@1', response.Data);
                            element.css('background-image', url);
                        }
                    });
                }
                if (GlobalVar.displayNetworkStatus) {
                    updateNetworkState();
                    stopTime = $interval(updateNetworkState, 5000);
                    element.on('$destroy', function () {
                        $interval.cancel(stopTime);
                    });
                }
            }
        };
    }
])
    .directive('selectebleRows', function () {
    "use strict";
    return {
        restrict: 'A',
        link: function (scope, element, attr) {
            scope.$watch(function (scope) {
                return scope.selectedIndex;
            }, function (newValue, oldValue) {
                if (oldValue != -1) {
                    var oldRow = $(element.children()[oldValue]);
                    oldRow.removeClass("rowodd");
                    oldRow.addClass("roweven");
                }
                if (newValue != -1) {
                    var newRow = $(element.children()[newValue]);
                    newRow.removeClass("roweven");
                    newRow.addClass("rowodd");
                }
            });
        }
    };
})
    .directive('thankYou', [
    '$rootScope', 'encounterServiceNew', 'httpService', 'showDialog', '$window', function ($rootScope, encounterServiceNew, httpService, showDialog, $window) {
        "use strict";
        return {
            restrict: 'AE',
            link: function (scope, element, attrs) {
                $rootScope.$watch('showThankYou', function (newValue, oldValue) {
                    if (newValue) {
                        var healthIdVisit = encounterServiceNew.getHealthIDVisit();
                        scope.healthIDVisit = healthIdVisit;
                        if (healthIdVisit.status === EncounterModule.Controller.NOT_VIEWED) {
                            scope.goToHealthID = function () {
                                httpService.get("v1/" +
                                    healthIdVisit.practiceId +
                                    "/healthid/patient/" +
                                    healthIdVisit.patientId)
                                    .then(function (response) {
                                    $rootScope.showThankYou = false;
                                    if (!response.token) {
                                        showDialog.error(response.message);
                                    }
                                    else {
                                        var newWindow = $window.open(response.link, "HealthID");
                                    }
                                })
                                    .catch(function (error) {
                                    $rootScope.showThankYou = false;
                                });
                            };
                        }
                    }
                });
            }
        };
    }
])
    .directive('progressScreen', [
    '$rootScope', function ($rootScope) {
        "use strict";
        return {
            restrict: 'C',
            link: function (scope, element, attrs) {
                $rootScope.$watch(function ($rootScope) {
                    return $rootScope.showProgressScreen;
                }, function (newValue, oldValue) {
                    if (newValue) {
                        $(element).fadeIn();
                    }
                    else {
                        $(element).fadeOut();
                    }
                });
            }
        };
    }
])
    .directive('hideMobileKeyboard', function () {
    "use strict";
    return {
        restrict: 'A',
        link: function (scope, element, attr) {
            $(element)
                .on("focus", function () {
                $(_this).blur();
            });
        }
    };
})
    .directive('validateTemplateOrder', function () {
    "use strict";
    return {
        restrict: 'A',
        link: function (scope, element, attr) {
            $(element)
                .on("blur", function () {
                scope.validateOrder();
            });
        }
    };
})
    .directive('hideFocus', function () {
    "use strict";
    return {
        restrict: 'A',
        link: function (scope, element, attr) {
            $(element)
                .on("focus", function () {
                if (scope.firstFocus) {
                    $(_this).val("");
                    $(_this).blur();
                    scope.firstFocus = false;
                }
            });
        }
    };
})
    .directive('hookKeyboard', [
    '$document', function ($document) {
        "use strict";
        return {
            restrict: 'E',
            replace: true,
            scope: true,
            link: function (scope, element, attr) {
                $document.on('keypress', function (e) {
                    return false;
                });
                $document.on('keydown', function (e) {
                    scope.$apply(scope.keyDown(e));
                });
                scope.$on('$destroy', function () {
                    $document.off('keypress');
                    $document.off('keydown');
                });
            }
        };
    }
])
    .directive('selectOnClick', ['$window', function ($window) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                element.on('click', function () {
                    if (!$window.getSelection().toString()) {
                        _this.setSelectionRange(0, _this.value.length);
                    }
                });
            }
        };
    }])
    .directive('execOnEnter', function () {
    return function (scope, element, attrs) {
        element.bind("keydown keypress", function (event) {
            if (event.which === 13) {
                scope.$apply(function () {
                    scope.$eval(attrs.execOnEnter);
                });
                event.preventDefault();
            }
        });
    };
})
    .directive('stringToNumber', function () {
    return {
        require: 'ngModel',
        link: function (scope, element, attrs, ngModel) {
            ngModel.$parsers.push(function (value) {
                if (value === 0)
                    return 0;
                return parseFloat(value || '');
            });
            ngModel.$formatters.push(function (value) {
                if (isNaN(value))
                    return;
                return parseFloat(value);
            });
        }
    };
})
    .directive('showTab', function () {
    return {
        link: function (scope, element, attrs) {
            element.click(function (e) {
                e.preventDefault();
                $(element).tabs('show');
            });
        }
    };
})
    .directive('onError', function () {
    return {
        scope: {
            onError: '='
        },
        link: function (scope, element, attrs) {
            element.bind('error', function () {
                if (scope.onError !== undefined) {
                    scope.$apply(function () {
                        scope.onError = true;
                    });
                }
            });
        }
    };
})
    .directive('fnSrc', function () {
    return {
        scope: {
            fnSrc: '&',
            fnSrcError: '=',
        },
        link: function (scope, element, attrs) {
            scope.fnSrc()
                .then(function (url) {
                if (url) {
                    element.attr("src", url);
                    scope.fnSrcError = false;
                }
                else {
                    scope.fnSrcError = true;
                }
            });
            element.bind('error', function () {
                if (scope.fnSrcError !== undefined) {
                    scope.$apply(function () {
                        scope.fnSrcError = true;
                    });
                }
            });
        }
    };
})
    .directive('squareAvatar', function () {
    return {
        scope: {
            fnUrl: '&',
            squareAvatar: '=',
            srcError: '=',
        },
        template: "<img style='display:none' ng-src='{{url}}'/>",
        link: function (scope, element, attrs) {
            var size = attrs.size || 100;
            var draw = function (url) {
                if (url) {
                    element.css('background-image', "url('" + url + "')");
                    element.css('background-size', "cover");
                    element.css('background-position', "center center");
                    element.css('width', size + 'px');
                    element.css('height', size + 'px');
                    scope.url = url;
                    scope.srcError = false;
                }
                else {
                    scope.srcError = true;
                }
            };
            if (scope.fnUrl && attrs.fnUrl) {
                scope.fnUrl().then(draw);
            }
            else {
                if (scope.squareAvatar) {
                    draw(scope.squareAvatar);
                }
                scope.$watch('squareAvatar', function () {
                    draw(scope.squareAvatar);
                });
            }
            element.find('img').bind('error', function () {
                if (scope.srcError !== undefined) {
                    scope.$apply(function () {
                        scope.srcError = true;
                    });
                }
            });
        }
    };
});
/// <reference path="../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../scripts/definition/jquery/jquery.d.ts" />
angular.module('DoctorApp')
    .directive('depcodeMask', function () {
    "use strict";
    return {
        restrict: 'A',
        link: function ($scope, element, attrs) {
            $(function () {
                $(element[0]).mask("99", { placeholder: "" });
            });
        }
    };
})
    .directive('dateMask', function () {
    "use strict";
    return {
        restrict: 'A',
        link: function ($scope, element, attrs) {
            $(function () {
                $(element[0]).mask("99/99/9999");
            });
        }
    };
}).directive('alphaNumericMask', function () {
    "use strict";
    return {
        restrict: 'A',
        link: function ($scope, element, attrs) {
            $.mask.definitions.a = "[a-zA-Z0-9]";
            $(function () {
                $(element[0]).mask("aaa?aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa", { placeholder: "" });
            });
        }
    };
})
    .directive('numberMaxLength', function () {
    "use strict";
    return {
        restrict: 'A',
        link: {
            pre: function (scope, element, attrs) {
                if (!attrs.maxlength) {
                    return;
                }
                element.on('input', function (event) {
                    var object = event.target;
                    if (object.value.length > object.maxLength) {
                        object.value = Number(object.value.slice(0, object.maxLength));
                    }
                });
            }
        }
    };
})
    .directive('regExInput', function () {
    "use strict";
    return {
        restrict: 'A',
        require: "?ngPattern",
        scope: { ngPattern: '=?' },
        link: function (scope, element) {
            if (!scope.ngPattern) {
                return;
            }
            element.bind('keypress', function (event) {
                var regex = new RegExp(scope.ngPattern);
                var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
                var resultStr = event.target['value'].insertAt(key, event.target['selectionEnd']);
                if (!regex.test(resultStr)) {
                    event.preventDefault();
                    return false;
                }
            });
        }
    };
})
    .directive('numbersMask', function () {
    "use strict";
    return {
        restrict: 'A',
        link: function ($scope, element, attrs) {
            $(function () {
                $(element[0]).mask("9?9999999999999999", { placeholder: "" });
            });
        }
    };
})
    .directive('phoneMask', function () {
    "use strict";
    return {
        restrict: 'A',
        link: function ($scope, element, attrs) {
            $(function () {
                $(element[0]).mask("9?99 999 99999999999999999999", { placeholder: "" });
            });
        }
    };
})
    .directive('dateTimeMask', function () {
    "use strict";
    return {
        restrict: 'A',
        link: function ($scope, element, attrs) {
            $(function () {
                $(element[0]).mask("99/99/9999 99:99");
            });
        }
    };
});
/// <reference path="../../scripts/definition/angularjs/angular.d.ts" />
angular.module('DoctorApp')
    .directive('passwordStrength', function () {
    return {
        require: 'ngModel',
        link: function (scope, elm, attrs, ctrl) {
            ctrl.$parsers.unshift(function (viewValue) {
                var containsDigitFunc = function (value) {
                    return /[0-9]+/.test(value);
                };
                var containsSpecialSymbolsFunc = function (value) {
                    return /[$-/:-?{-~!"^_`\[\]]/g.test(value);
                };
                var containsUpperLetterFunc = function (value) {
                    return /[A-Z]+/.test(value);
                };
                var containsLowerLetterFunc = function (value) {
                    return /[a-z]+/.test(value);
                };
                var containsUpperLetter = containsUpperLetterFunc(viewValue);
                var containsLowerLetter = containsLowerLetterFunc(viewValue);
                var containsDigit = containsDigitFunc(viewValue);
                var hasSpecialSymbol = containsSpecialSymbolsFunc(viewValue);
                ctrl.$setValidity('containsUpperLetter', containsUpperLetter);
                ctrl.$setValidity('containsLowerLetter', containsLowerLetter);
                ctrl.$setValidity('containsDigit', containsDigit);
                ctrl.$setValidity('hasSpecialSymbol', hasSpecialSymbol);
                if (containsUpperLetter && containsLowerLetter && containsDigit && hasSpecialSymbol) {
                    return viewValue;
                }
                else {
                    return undefined;
                }
            });
        }
    };
});
var ScrollUp;
(function (ScrollUp) {
    var Link = (function () {
        function Link(scope, element, attrs) {
            attrs.scrollto = attrs.scrollto || '.load-line';
            attrs.container = attrs.container || '.container-view';
            scope.small = Object.getOwnPropertyNames(attrs).indexOf('small') > -1;
            Link.$timeout(function () {
                $('.scrolltop').stop(true, true).fadeOut(0);
                $(attrs.container)
                    .scroll(function () {
                    if ($(attrs.container).scrollTop() > 50) {
                        $('.scrolltop:hidden').stop(true, true).fadeIn();
                    }
                    else {
                        $('.scrolltop').stop(true, true).fadeOut();
                    }
                });
            }, 400);
            $(function () {
                $(".scroll")
                    .click(function () {
                    $(attrs.container)
                        .animate({
                        scrollTop: $(attrs.scrollto).offset().top
                    }, "1000");
                    return false;
                });
            });
        }
        return Link;
    })();
    var Directive = (function () {
        function Directive() {
        }
        Directive.factory = function () {
            var methodFactory = function ($timeout) {
                "ngInject";
                var directive = {};
                Link.$timeout = $timeout;
                directive.restrict = 'AE';
                directive.scope = {};
                directive.link = Link;
                directive.template =
                    '<div class="scrolltop" ng-class="{\'small\': small}">' +
                        '<div class="scroll icon">' +
                        '<div class="arrow-block">' +
                        '<i class="fa fa-4x fa-arrow-up"></i>' +
                        '<span class="f22 fontbold">Top</span>' +
                        '</div>' +
                        '</div>' +
                        '</div>';
                return directive;
            };
            methodFactory.$inject = ["$timeout"];
            return methodFactory;
        };
        return Directive;
    })();
    ScrollUp.Directive = Directive;
})(ScrollUp || (ScrollUp = {}));
angular.module('DoctorApp')
    .directive('scrollUp', ScrollUp.Directive.factory());
/// <reference path="../../scripts/definition/angularjs/angular.d.ts" />
var Shortcut;
(function (Shortcut) {
    var Link = (function () {
        function Link(scope, element, attrs, ngModelCtrl, transclude) {
            if (angular.isFunction(scope.keyPress)) {
                Link.$document.on('keypress', function (e) {
                    scope.keyPress({ event: e });
                });
            }
            if (angular.isFunction(scope.keyDown)) {
                Link.$document.on('keydown', function (e) {
                    scope.keyDown({ event: e });
                });
            }
            scope.$on('$destroy', function () {
                Link.$document.off('keypress');
                Link.$document.off('keydown');
            });
        }
        return Link;
    })();
    var Directive = (function () {
        function Directive() {
        }
        Directive.factory = function () {
            var methodFactory = function ($document) {
                "ngInject";
                Link.$document = $document;
                var directive = {};
                directive.restrict = 'E';
                directive.replace = true;
                directive.scope = {
                    keyDown: '&',
                    keyPress: '&'
                };
                directive.link = Link;
                return directive;
            };
            methodFactory.$inject = ["$document"];
            return methodFactory;
        };
        return Directive;
    })();
    Shortcut.Directive = Directive;
})(Shortcut || (Shortcut = {}));
angular.module('DoctorApp')
    .directive('shortcut', Shortcut.Directive.factory());
/// <reference path="../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../scripts/definition/moment/moment-node.d.ts" />
angular.module('filters', [])
    .filter('truncate', function () {
    'use strict';
    return function (text, length, end) {
        if (isNaN(length)) {
            length = 10;
        }
        if (!text) {
            return '';
        }
        if (!end) {
            end = "...";
        }
        if (text.length <= length || text.length - end.length <= length) {
            return text;
        }
        else {
            return String(text).substring(0, length - end.length) + end;
        }
    };
})
    .filter('titlecase', function () { return function (input) {
    if (!input) {
        return '';
    }
    var words = input.split(' ');
    for (var i = 0; i < words.length; i++) {
        words[i] = words[i].toLowerCase();
        words[i] = words[i].charAt(0).toUpperCase() + words[i].slice(1);
    }
    return words.join(' ');
}; })
    .filter('startFrom', function () {
    return function (input, start) {
        start = +start;
        return input.slice(start);
    };
})
    .filter('wordwrap', function () {
    return function (input) {
        var str = [];
        var uppers = [];
        var i;
        for (i = 1; i < input.length; i++) {
            var character = input[i];
            if (!((!isNaN(character * 1)) || (character == character.toLowerCase()))) {
                if (character == character.toUpperCase()) {
                    uppers.push(i);
                }
            }
        }
        uppers.push(input.length);
        if (uppers.length > 1) {
            var start = 0;
            var end = uppers[0];
            for (i = 0; i < uppers.length; i++) {
                str.push(input.slice(start, end));
                start = uppers[i];
                end = uppers[i + 1];
            }
            return str.join(" ");
        }
        return input;
    };
})
    .filter('dateFormat', [
    'moment', function (moment) {
        return function (str, firstParameter, secondParameter, isToday) {
            var inputPattern;
            var outputPattern;
            if (secondParameter) {
                inputPattern = firstParameter;
                outputPattern = secondParameter;
            }
            else {
                outputPattern = firstParameter;
            }
            var date = moment.utc(str, inputPattern);
            if (!date.isValid()) {
                return str;
            }
            if (isToday) {
                var today = moment.utc().startOf('day');
                if (date.isSame(today, 'd')) {
                    return date.startOf('second').fromNow();
                }
            }
            return date.format(outputPattern);
        };
    }
])
    .filter('dateFormatLocal', [
    'moment', function (moment) {
        return function (str, firstParameter, secondParameter, isToday) {
            var inputPattern;
            var outputPattern;
            if (secondParameter) {
                inputPattern = firstParameter;
                outputPattern = secondParameter;
            }
            else {
                outputPattern = firstParameter;
            }
            var date = moment.utc(str, inputPattern);
            if (!date.isValid()) {
                return str;
            }
            if (isToday) {
                var today = moment.utc().startOf('day');
                if (date.isSame(today, 'd')) {
                    return date.startOf('second').fromNow();
                }
            }
            return date.local().format(outputPattern);
        };
    }
])
    .filter('splitGuid', function () {
    return function (input) {
        if (input) {
            input = input.replace(/-/g, ' - ');
        }
        return input;
    };
})
    .filter('orderFilter', function () { return function (items, criterion, attr) {
    var tmp = [];
    for (var i in items) {
        var item = items[i];
        var searchValue = item[attr] && item[attr].split(":")[0];
        if (criterion.indexOf(searchValue) >= 0) {
            tmp.push(item);
        }
    }
    return tmp;
}; })
    .filter('objectLength', function () { return function (object) {
    var count = 0;
    for (var i in object) {
        count++;
    }
    return count;
}; })
    .filter('truncateDate', function () { return function (date) {
    if (date) {
        return date.replace("00:00:00", "");
    }
    return '';
}; })
    .filter('ageByBirthDay', [
    'moment', function (moment) {
        return function (str) {
            var date = moment(str);
            if (!date.isValid()) {
                return str;
            }
            var diff = moment().diff(str, 'years', false);
            return diff > 0 ? diff + ' years' : moment().diff(str, 'month', false) + ' months';
        };
    }
])
    .filter('birthDayToday', [
    'moment', function (moment) {
        return function (str) {
            var date = moment(str);
            if (!date.isValid()) {
                return str;
            }
            var today = moment();
            var DOB = moment(str).year(today.year());
            return today.isSame(DOB, 'd');
        };
    }
])
    .filter('divideCamel', function () { return function (text, textCase) {
    var dividedText = text && text.replace(/([A-Z])/g, ' $1').toString() || "";
    if (textCase === 'toUpperCase')
        return dividedText.toUpperCase();
    else if (textCase === 'toLowerCase')
        return dividedText.toLowerCase();
    else
        return dividedText;
}; })
    .filter('removeHTMLTags', function () { return function (text) {
    if (text) {
        return text
            .replace(/<[^>]+>/gm, ' ')
            .replace(/\s\s+/g, ' ')
            .replace(/&nbsp;/g, ' ')
            .replace(/[<>]/g, '');
    }
    return '';
}; })
    .filter('fileExtension', function () { return function (filename, error) {
    var fileImg = "";
    var filePath = "styles/images/file-types/";
    filename = filename || "";
    if (filename.indexOf(".pdf") > 0) {
        fileImg = filePath + "pdf.png";
    }
    else if (filename.indexOf(".jpg") > 0 || filename.indexOf(".jpeg") > 0 || filename.indexOf(".gif") > 0 || filename.indexOf(".png") > 0) {
        if (error) {
            fileImg = filePath + "image.png";
        }
    }
    else if (filename.indexOf(".xls") > 0 || filename.indexOf(".xlsx") > 0) {
        fileImg = filePath + "excel.png";
    }
    else if (filename.indexOf(".ppt") > 0 || filename.indexOf(".pptx") > 0) {
        fileImg = filePath + "powerpoint.png";
    }
    else if (filename.indexOf(".doc") > 0 || filename.indexOf(".docx") > 0) {
        fileImg = filePath + "word.png";
    }
    else if (filename.indexOf(".thumb") > 0) {
        fileImg = filename;
        if (error) {
            fileImg = filePath + "image.png";
        }
    }
    else {
        fileImg = filePath + "file.png";
    }
    return fileImg || filename;
}; })
    .filter('imgToThumb', function () { return function (filename) {
    filename = filename || "";
    if (filename.indexOf('file-types') < 0) {
        return filename.replace(/\.(jpg|jpeg|png)/, '.thumb');
    }
    return filename;
}; })
    .filter('newLineIfMultilined', function () { return function (text) {
    if (text.search(/\n/ig) > -1) {
        text = '\n' + text;
    }
    return text;
}; });
//TODO remove from global scope and add to module app
var consultationDateFormat = 'MM/dd/yyyy HH:mm:ss';
var DATE_TIME_PATTERN = 'MM/DD/YYYY HH:mm:ss';
var ServerDateFormat = 'YYYY-MM-DD[T]HH:mm:ss[Z]';
var PatientDateFormat = 'dd/MM/yyyy';
var serverDateFormat = 'YYYY-MM-DD';
var appControllers = {};
var appServices = {};
var test = "s";
var globalProviders = [];
var clinicalGlobalProviders = [];
/// <reference path="../scripts/definition/angularjs/angular.d.ts" />
angular.module('DoctorApp')
    .config(["$routeProvider", function ($routeProvider) {
    "ngInject";
    $routeProvider
        .when('/:practiceId/home', {
        controller: 'HomeController',
        templateUrl: 'screens/home/home.html'
    })
        .when('/:practiceId/invoice/:patientVisitId', {
        controller: 'InvoiceController',
        templateUrl: 'screens/consultation/invoice/invoice.html'
    })
        .when('/:practiceId/encounter/:patientVisitId', {
        controller: 'EncounterController',
        templateUrl: 'screens/consultation/encounter/encounter.html'
    })
        .when('/:practiceId/create-patient', {
        controller: 'PatientCreateController',
        templateUrl: 'screens/patient/patient.html'
    })
        .when('/:practiceId/templates', {
        controller: 'TemplatesController',
        templateUrl: 'screens/templates/templates.html'
    })
        .when('/:practiceId/template', {
        controller: 'CreateTemplateController',
        templateUrl: 'screens/template/template.html'
    })
        .when('/:practiceId/template/:templateId', {
        controller: 'EditTemplateController',
        templateUrl: 'screens/template/template.html'
    })
        .when('/:practiceId/search-diagnosis', {
        controller: 'SearchDiagnosisController',
        templateUrl: 'screens/searches/search-diagnosis/search-diagnosis.html'
    })
        .when('/:practiceId/search-procedure', {
        controller: 'SearchProcedureController',
        templateUrl: 'screens/searches/search-procedure/search-procedure.html'
    })
        .when('/:practiceId/search-medicine', {
        controller: 'SearchMedicineController',
        templateUrl: 'screens/searches/search-medicine/search-medicine.html'
    })
        .when('/:practiceId/search-consumable', {
        controller: 'SearchConsumableController',
        templateUrl: 'screens/searches/search-consumable/search-consumable.html'
    })
        .when('/:practiceId/search-prescription', {
        controller: 'SearchPrescriptionController',
        templateUrl: 'screens/searches/search-prescription/search-prescription.html'
    })
        .when('/:practiceId/search-medical-insurer-procedure', {
        controller: 'SearchMIProcedureController',
        templateUrl: 'screens/searches/search-medical-insurer-procedure/medical-insurer-procedure.html'
    })
        .when('/login', {
        controller: 'LoginController',
        templateUrl: 'screens/login/login.html'
    })
        .when('/:practiceId/patient/:patientId', {
        controller: 'PatientEditController',
        templateUrl: 'screens/patient/patient.html'
    })
        .when('/audit', {
        controller: 'AuditController',
        templateUrl: 'screens/audit/audit.html'
    })
        .when('/audit-events', {
        controller: 'EventController',
        templateUrl: 'screens/audit/audit-events.html'
    })
        .when('/audit-events/tenantId/:tenantId/aggregateId/:aggregateId', {
        controller: 'EventController',
        templateUrl: 'screens/audit/audit-events.html'
    })
        .when('/events/:tenantId', {
        controller: 'TenantEventController',
        templateUrl: 'screens/audit/audit-tenant-events.html'
    })
        .when('/events/:tenantId/:aggregateId', {
        controller: 'EventController',
        templateUrl: 'screens/audit/audit-events.html'
    })
        .when('/events/:tenantId/from/:dateFrom/to/:dateTo', {
        controller: 'TenantEventController',
        templateUrl: 'screens/audit/audit-tenant-events.html'
    })
        .when('/:practiceId/patient-visits', {
        controller: 'PatientVisitsController',
        templateUrl: 'screens/patient-visits/patient-visits.html'
    })
        .when('/claim-response/:claimId', {
        controller: 'ClaimResponseController',
        templateUrl: 'screens/claim-response/claim-response.html'
    })
        .when('/users', {
        controller: 'UsersController',
        templateUrl: 'screens/users/users.html'
    })
        .when('/users/:practiceId', {
        controller: 'UsersController',
        templateUrl: 'screens/users/users.html'
    })
        .when('/user', {
        controller: 'UserCreateController',
        templateUrl: 'screens/user/user.html'
    })
        .when('/user/:userId', {
        controller: 'UserEditController',
        templateUrl: 'screens/user/user.html'
    })
        .when('/:practiceId/address-book', {
        controller: 'ClinicalAddressBookController',
        templateUrl: 'screens/address-book/address-book.html'
    })
        .when('/:practiceId/address-book/create', {
        controller: 'ClinicalAddressBookCreateController',
        templateUrl: 'screens/address-book/address-book-entry.html'
    })
        .when('/:practiceId/address-book/entry/:entryId', {
        controller: 'ClinicalAddressBookEditController',
        templateUrl: 'screens/address-book/address-book-entry.html'
    })
        .when('/speciality-rules', {
        controller: 'SpecialityRulesController',
        templateUrl: 'screens/speciality-rules/speciality-rules.html'
    })
        .when('/speciality-rule', {
        controller: 'SpecialityRuleCreateController',
        templateUrl: 'screens/speciality-rules/speciality-rule.html'
    })
        .when('/speciality-rule/:specialityCode', {
        controller: 'SpecialityRuleEditController',
        templateUrl: 'screens/speciality-rules/speciality-rule.html'
    })
        .when('/:practiceId/change-password/:userId', {
        controller: 'ChangePasswordController',
        templateUrl: 'screens/change-password/change-password.html'
    })
        .when('/:practiceId/account/:userId', {
        controller: 'UserAccountController',
        templateUrl: 'screens/user-account/user-account.html'
    })
        .when('/practices', {
        controller: 'PracticesController',
        templateUrl: 'screens/practices/practices.html'
    })
        .when('/practice', {
        controller: 'PracticeCreateController',
        templateUrl: 'screens/practice/practice.html'
    })
        .when('/practice/:practiceId', {
        controller: 'PracticeEditController',
        templateUrl: 'screens/practice/practice.html'
    })
        .when('/practice-options/:practiceId', {
        controller: 'PracticeOptionsController',
        templateUrl: 'screens/practice-options/practice-options.html'
    })
        .when('/public-keys', {
        controller: 'PublicKeysController',
        templateUrl: 'screens/public-keys/public-keys.html'
    })
        .when('/search-diagnosis#clinical', {
        controller: 'ClinicalSearchDiagnosis',
        templateUrl: 'screens/searches/search-diagnosis/search-diagnosis.html'
    })
        .when('/search-procedure#clinical', {
        controller: 'ClinicalSearchProcedure',
        templateUrl: 'screens/searches/search-procedure/search-procedure.html'
    })
        .when('/search-medicine#clinical', {
        controller: 'ClinicalSearchMedicine',
        templateUrl: 'screens/searches/search-medicine/search-medicine.html'
    })
        .when('/search-consumable#clinical', {
        controller: 'ClinicalSearchConsumable',
        templateUrl: 'screens/searches/search-consumable/search-consumable.html'
    })
        .when('/:practiceId/notifications-bulk-send', {
        controller: 'NotificationSendController',
        templateUrl: 'screens/notifications-bulk-send/notifications-bulk-send.html'
    })
        .when('/:practiceId/clinical-template', {
        controller: 'ClinicalCreateTemplateController',
        templateUrl: 'screens/clinical-template/clinical-template.html'
    })
        .when('/:practiceId/clinical-template/:templateId', {
        controller: 'ClinicalEditTemplateController',
        templateUrl: 'screens/clinical-template/clinical-template.html'
    })
        .when('/:practiceId/clinical-templates', {
        controller: 'ClinicalTemplatesController',
        templateUrl: 'screens/clinical-templates/clinical-templates.html'
    })
        .when('/:practiceId/template-bulk-import', {
        controller: 'TemplateImportModule',
        templateUrl: 'screens/template-bulk-import/template-bulk-import.html'
    })
        .when('/clinical-practices', {
        controller: 'ClinicalPractices',
        templateUrl: 'screens/clinical-practices/clinical-practices.html'
    })
        .when('/:practiceId/clinical-visit-outcomes', {
        controller: 'ClinicalVisitOutcomesController',
        templateUrl: 'screens/clinical-visit-outcomes/clinical-visit-outcomes.html'
    })
        .when('/:practiceId/consultation-reports/:patientId/sicknote', {
        controller: 'ConsultationSiknoteController',
        templateUrl: 'screens/consultation/reports/report-siknote.html'
    })
        .when('/:practiceId/consultation-reports/:patientId/prescription', {
        controller: 'ConsultationPrescriptionController',
        templateUrl: 'screens/consultation/reports/report-prescription.html'
    })
        .when('/:practiceId/clinical-message-center', {
        controller: 'ClinicalMessageCenterController',
        templateUrl: 'screens/clinical-message-center/clinical-message-center.html'
    })
        .when('/:practiceId/clinical-pathology-report/:reportId', {
        controller: 'ClinicalReport',
        templateUrl: 'screens/clinical-report/clinical-report.html'
    })
        .when('/:practiceId/clinical-pathology-report-workflow/:reportId/:urgent', {
        controller: 'ClinicalReportWorkflow',
        templateUrl: 'screens/clinical-report-workflow/clinical-report-workflow.html'
    })
        .when('/:practiceId/clinical-dashboard/:patientId', {
        controller: 'ClinicalDashboardController',
        templateUrl: 'screens/clinical-dashboard/dashboard.html'
    })
        .when('/:practiceId/health-id/:patientId', {
        controller: 'HealthIDController',
        templateUrl: 'screens/health-id/healthid.html'
    })
        .when('/card-readers', {
        controller: 'CardReadersController',
        templateUrl: 'screens/card-reader/card-readers.html'
    })
        .when('/card-reader', {
        controller: 'CardReaderCreateController',
        templateUrl: 'screens/card-reader/card-reader.html'
    })
        .when('/tenant/:tenantId/card-reader/:cardreaderId', {
        controller: 'CardReaderEditController',
        templateUrl: 'screens/card-reader/card-reader.html'
    })
        .when('/card-payments', {
        controller: 'CardPaymentsController',
        templateUrl: 'screens/card-payments/card-payments.html'
    })
        .when('/card-payment', {
        controller: 'CardPaymentController',
        templateUrl: 'screens/card-payments/card-payment.html'
    })
        .when('/communication-templates', {
        controller: 'CommunicationTemplatesUpdateController',
        templateUrl: 'screens/communication-template-update/communication-template-update.html'
    })
        .when('/tenants', {
        controller: 'TenantController',
        templateUrl: 'screens/tenant/tenant-list.html'
    })
        .when('/tenant', {
        controller: 'CreateTenantController',
        templateUrl: 'screens/tenant/tenant-create.html'
    })
        .when('/tenant/:tenantId', {
        controller: 'EditTenantController',
        templateUrl: 'screens/tenant/tenant-create.html'
    })
        .when('/failed-invoices', {
        controller: 'FailedInvoicesController',
        templateUrl: 'screens/failed-invoices/failed-invoices.html'
    })
        .when('/sent-invoices/:sentDate', {
        controller: 'SentInvoicesController',
        templateUrl: 'screens/sent-invoices/sent-invoices.html'
    })
        .when('/test-api/:url', {
        controller: 'TestApiController',
        templateUrl: 'screens/test-api/test-api.html'
    })
        .when('/test-api', {
        controller: 'TestApiController',
        templateUrl: 'screens/test-api/test-api.html'
    })
        .when('/timers', {
        controller: 'TimerController',
        templateUrl: 'screens/timer/timer-list.html'
    })
        .when('/timer', {
        controller: 'SetTimerController',
        templateUrl: 'screens/timer/timer-create.html'
    })
        .when('/test', {
        controller: 'TestController',
        templateUrl: 'screens/test/test.html'
    })
        .when('/:practiceId/medical-history/:patientId', {
        controller: 'MedicalHistoryController',
        templateUrl: 'screens/patient-medical-history/medical-history.html'
    })
        .when('/:practiceId/power-bi/:reportId', {
        controller: 'PowerBIController',
        templateUrl: 'screens/powerbi/powerbi.html'
    })
        .when('/:practiceId/power-bi-list/', {
        controller: 'PowerBIListController',
        templateUrl: 'screens/powerbi/powerbi-list.html'
    })
        .when('/:practiceId/health-doc/:patientId', {
        controller: 'HealthDocController',
        templateUrl: 'screens/health-doc/healthdoc.html'
    })
        .when('/:practiceId/patient-file/:documentId', {
        controller: 'PatientFileController',
        templateUrl: 'screens/health-doc/healthdoc.html'
    })
        .otherwise({ redirectTo: '/' + StorageModule.Service.EMPTY_PRACTICE_ID + '/home' });
}]);
/// <reference path="../../scripts/definition/angularjs/angular.d.ts" />
var StorageModule;
(function (StorageModule) {
    var MyStorage = (function () {
        function MyStorage(storage) {
            this.storage = storage;
        }
        MyStorage.prototype.set = function (key, value) {
            this.storage.setItem(key, angular.toJson(value));
        };
        MyStorage.prototype.get = function (key, defaultValue) {
            return (angular.fromJson(this.storage.getItem(key)) || defaultValue);
        };
        MyStorage.prototype.remove = function (key) {
            this.storage.removeItem(key);
        };
        return MyStorage;
    })();
    StorageModule.MyStorage = MyStorage;
    var AuthorizationData = (function () {
        function AuthorizationData() {
        }
        return AuthorizationData;
    })();
    StorageModule.AuthorizationData = AuthorizationData;
    var User = (function () {
        function User() {
        }
        User.ADMIN_ROLE = 'system-admin';
        User.DOCTOR_ROLE = 'doctor';
        User.FRONT_OFFICE = 'front-office-user';
        User.PRACTICING_NURSE = "practicing-nurse";
        User.TRIAGE_NURSE = "triage-nurse";
        return User;
    })();
    StorageModule.User = User;
    var Practice = (function () {
        function Practice() {
        }
        return Practice;
    })();
    StorageModule.Practice = Practice;
    var Service = (function () {
        Service.$inject = ["$window"];
        function Service($window) {
            "ngInject";
            this.$window = $window;
            this.localStorage = new MyStorage($window.localStorage);
            this.sessionStorage = new MyStorage($window.sessionStorage);
        }
        Service.prototype.getLocalStorage = function () {
            return this.localStorage;
        };
        Service.prototype.getSessionStorage = function () {
            return this.sessionStorage;
        };
        Service.prototype.getUser = function () {
            return this.getLocalStorage().get(Service.USER_KEY) || {};
        };
        Service.prototype.setUser = function (user) {
            this.getLocalStorage().set(Service.USER_KEY, user);
        };
        Service.prototype.getPractice = function () {
            return this.getSessionStorage().get(Service.PRACTICE_KEY) || {};
        };
        Service.prototype.setPractice = function (practice) {
            this.getSessionStorage().set(Service.PRACTICE_KEY, practice);
        };
        Service.prototype.getPracticeId = function () {
            var practice = this.getPractice();
            if (practice.id) {
                return practice.id;
            }
            return Service.EMPTY_PRACTICE_ID;
        };
        Service.prototype.setPracticeId = function (practiceId) {
            var practice = this.getPractice();
            practice.id = practiceId;
            this.setPractice(practice);
        };
        Service.prototype.getAuthorizationData = function () {
            return this.getLocalStorage().get(Service.AUTHORIZATION_DATA) || {};
        };
        Service.prototype.setAuthorizationData = function (authData) {
            this.getLocalStorage().set(Service.AUTHORIZATION_DATA, authData);
        };
        Service.prototype.setBackPath = function (path) {
            var practice = this.getPractice();
            practice.path = path;
            this.getSessionStorage().set(Service.PRACTICE_KEY, practice);
        };
        Service.prototype.getBackPath = function () {
            var practice = this.getPractice();
            return practice.path;
        };
        Service.prototype.setBackHash = function (hash) {
            var practice = this.getPractice();
            practice.hash = hash;
            this.getSessionStorage().set(Service.PRACTICE_KEY, practice);
        };
        Service.prototype.getBackHash = function () {
            var practice = this.getPractice();
            return practice.hash;
        };
        Service.prototype.getEmptyPracticeId = function () {
            return Service.EMPTY_PRACTICE_ID;
        };
        Service.prototype.getParam = function (key) {
            return this.getSessionStorage().get(key);
        };
        Service.prototype.setParam = function (key, data) {
            this.getSessionStorage().set(key, data);
        };
        Service.prototype.clear = function () {
            this.getLocalStorage().remove(Service.USER_KEY);
            this.getLocalStorage().remove(Service.AUTHORIZATION_DATA);
            this.getSessionStorage().remove(Service.PRACTICE_KEY);
        };
        Service.PRACTICE_KEY = 'practice';
        Service.USER_KEY = 'user-details';
        Service.BACK_PATH_KEY = 'back-path';
        Service.AUTHORIZATION_DATA = 'authorization_data';
        Service.EMPTY_PRACTICE_ID = '00000000-0000-0000-0000-000000000001';
        Service.ZERO_PRACTICE_ID = '00000000-0000-0000-0000-000000000000';
        return Service;
    })();
    StorageModule.Service = Service;
})(StorageModule || (StorageModule = {}));
angular.module('DoctorApp')
    .service('storageService', StorageModule.Service);
var resultApi;
(function (resultApi) {
    var ResultApi = (function () {
        function ResultApi(data) {
            this.Data = data;
            this.Sucess = true;
            this.Links = [];
        }
        return ResultApi;
    })();
    resultApi.ResultApi = ResultApi;
    var LinkApi = (function () {
        function LinkApi() {
        }
        return LinkApi;
    })();
    resultApi.LinkApi = LinkApi;
})(resultApi || (resultApi = {}));
/// <reference path="../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="auth-service.ts" />
var HttpModule;
(function (HttpModule) {
    var Service = (function () {
        Service.$inject = ["$http", "CacheFactory", "$q", "showDialog", "cfpLoadingBar", "promiseService", "$location", "authService", "storageService"];
        function Service($http, CacheFactory, $q, showDialog, cfpLoadingBar, promiseService, $location, authService, storageService) {
            "ngInject";
            this.$http = $http;
            this.CacheFactory = CacheFactory;
            this.$q = $q;
            this.showDialog = showDialog;
            this.cfpLoadingBar = cfpLoadingBar;
            this.promiseService = promiseService;
            this.$location = $location;
            this.authService = authService;
            this.storageService = storageService;
        }
        Service.prototype.get = function (url, config, notShowError) {
            var _this = this;
            this.cfpLoadingBar.start();
            var cacheId = config && config.cache;
            if (cacheId) {
                config.cache = undefined;
                var cacheFectory = this.getCache(cacheId);
                var cache = cacheFectory.get(cacheId);
                if (cache && cache.resp) {
                    var deferred = this.$q.defer();
                    deferred.resolve(cache.resp);
                    return deferred.promise
                        .then(function (response) {
                        return _this.handleSuccess(response);
                    });
                }
            }
            var request = this.$http.get(GlobalVar.serverURL + url, config);
            return request
                .then(function (response) {
                if (cacheId) {
                    cacheFectory.put(cacheId, { resp: response });
                }
                return _this.handleSuccess(response);
            }, function (error) {
                return _this.handleError(error, notShowError);
            });
        };
        Service.prototype.post = function (url, data, config, notShowError) {
            var _this = this;
            this.cfpLoadingBar.start();
            var request = this.$http.post(GlobalVar.serverURL + url, data, config);
            return request
                .then(function (response) {
                return _this.handleSuccess(response);
            }, function (error) {
                return _this.handleError(error, notShowError);
            });
        };
        Service.prototype.remove = function (url, data) {
            var _this = this;
            this.cfpLoadingBar.start();
            var request = this.$http({
                method: "delete",
                url: GlobalVar.serverURL + url,
                data: data
            });
            return request
                .then(function (response) {
                return _this.handleSuccess(response);
            }, function (error) {
                return _this.handleError(error);
            });
        };
        Service.prototype.put = function (url, data) {
            var _this = this;
            this.cfpLoadingBar.start();
            var request = this.$http({
                method: "put",
                url: GlobalVar.serverURL + url,
                data: data,
            });
            return request
                .then(function (response) {
                return _this.handleSuccess(response);
            }, function (error) {
                return _this.handleError(error);
            });
        };
        Service.prototype.handleError = function (response, notShowError) {
            var showError = !notShowError;
            this.cfpLoadingBar.complete();
            if (!angular.isObject(response.data) || !response.data.message) {
                if (angular.isNumber(response.status)) {
                    if ((response.status == 400) || (response.status === 0) || (response.statusText === "")) {
                        if (showError) {
                            this.showDialog.error("Service unavailable. Please check Internet connectivity and try again.");
                        }
                        return this.$q.reject("Service unavailable. Please check Internet connectivity and try again.");
                    }
                    else if ((response.status == 500) && response.data.ExceptionMessage && response.data.Message) {
                        if (showError) {
                            this.showDialog.error(response.data.Message + " " + response.data.ExceptionMessage);
                        }
                        return (this.$q.reject(response.data.Message + " " + response.data.ExceptionMessage));
                    }
                    else if (response.status == 404 && !response.statusText) {
                        if (showError) {
                            this.showDialog.error("Not found.");
                        }
                    }
                    else if (response.status == 401) {
                        var currentPath = this.$location.path();
                        if (currentPath !== '/login') {
                            this.showDialog.error("Your session has expired, please login again.");
                            this.authService.logOut();
                        }
                    }
                    else if (response.status == 402) {
                        if (showError) {
                            var currentPath = this.$location.path();
                            if (currentPath !== '/login') {
                                this.showDialog.error("Unable to find active treating doctor, please contact support.");
                                if (this.authService.isAdmin()) {
                                    this.authService.toDefaulPath();
                                }
                                else {
                                    this.authService.logOut();
                                }
                            }
                        }
                    }
                    else if (response.status == 403) {
                        if (showError) {
                            var currentPath = this.$location.path();
                            this.showDialog.error("Access to content not allowed");
                            this.authService.toDefaulPath();
                        }
                    }
                    else {
                        if (showError) {
                            this.showDialog.error(response.statusText);
                        }
                    }
                    return (this.$q.reject(response.statusText));
                }
                if (showError) {
                    this.showDialog.error("Internal Server Error.");
                }
                return (this.$q.reject("An unknown error occurred."));
            }
            if (showError) {
                this.showDialog.error(response.data.message);
            }
            return (this.$q.reject(response.data.message));
        };
        Service.prototype.handleSuccess = function (response) {
            this.cfpLoadingBar.complete();
            return response.data;
        };
        Service.prototype.getCache = function (cacheId) {
            var cacheFactory = this.CacheFactory.get(cacheId);
            if (!cacheFactory) {
                return this.CacheFactory(cacheId, {
                    maxAge: 120 * 60 * 1000,
                    deleteOnExpire: 'aggressive',
                    storageMode: 'memory'
                });
            }
            return cacheFactory;
        };
        Service.prototype.resetCache = function (cacheId) {
            var cache = this.getCache(cacheId);
            if (cache.get(cacheId)) {
                cache.destroy(cacheId);
            }
        };
        return Service;
    })();
    HttpModule.Service = Service;
})(HttpModule || (HttpModule = {}));
angular.module('DoctorApp')
    .service('httpService', HttpModule.Service);
/// <reference path="../../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../../../scripts/definition/moment/moment-node.d.ts" />
/// <reference path="../result-api.ts" />
/// <reference path="../../http-service.ts" />
/// <reference path="../../storage-service.ts" />
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Domain;
(function (Domain) {
    var Patient;
    (function (Patient_1) {
        var DoctorAppSystem = 'DoctorAppUI';
        var PatientEvent = (function () {
            function PatientEvent() {
                this.Patient = new Patient();
            }
            return PatientEvent;
        })();
        Patient_1.PatientEvent = PatientEvent;
        var PatientInWaitingRoom = (function (_super) {
            __extends(PatientInWaitingRoom, _super);
            function PatientInWaitingRoom() {
                _super.apply(this, arguments);
            }
            return PatientInWaitingRoom;
        })(PatientEvent);
        Patient_1.PatientInWaitingRoom = PatientInWaitingRoom;
        var Patient = (function () {
            function Patient(patientId) {
                this.PatientId = patientId;
                this.PatientDetails = new PatientDetails();
                this.PatientAccountDetails = new PatientAccountDetails();
            }
            return Patient;
        })();
        Patient_1.Patient = Patient;
        var PatientDetails = (function () {
            function PatientDetails() {
            }
            return PatientDetails;
        })();
        Patient_1.PatientDetails = PatientDetails;
        var PatientAccountDetails = (function () {
            function PatientAccountDetails() {
                this.MedicalAidMainMemberDetails = new MedicalAidMainMemberDetails();
            }
            return PatientAccountDetails;
        })();
        Patient_1.PatientAccountDetails = PatientAccountDetails;
        var MedicalAidMainMemberDetails = (function () {
            function MedicalAidMainMemberDetails() {
            }
            return MedicalAidMainMemberDetails;
        })();
        Patient_1.MedicalAidMainMemberDetails = MedicalAidMainMemberDetails;
        var CancelPatientVisit = (function () {
            function CancelPatientVisit() {
                this.CorrelationIds = [];
                this.OriginatedSystem = DoctorAppSystem;
            }
            return CancelPatientVisit;
        })();
        Patient_1.CancelPatientVisit = CancelPatientVisit;
        var CreatePatient = (function () {
            function CreatePatient() {
                this.PatientVo = new Patient();
                this.CorrelationIds = [];
                this.OriginatedSystem = DoctorAppSystem;
            }
            return CreatePatient;
        })();
        Patient_1.CreatePatient = CreatePatient;
        var CheckPatientResult = (function () {
            function CheckPatientResult() {
            }
            return CheckPatientResult;
        })();
        Patient_1.CheckPatientResult = CheckPatientResult;
        var CheckInPatientVisit = (function () {
            function CheckInPatientVisit() {
                this.PatientEventDetails = new PatientEvent();
                this.CorrelationIds = [];
                this.OriginatedSystem = DoctorAppSystem;
            }
            return CheckInPatientVisit;
        })();
        Patient_1.CheckInPatientVisit = CheckInPatientVisit;
        var Option = (function () {
            function Option() {
            }
            return Option;
        })();
        Patient_1.Option = Option;
        var Plan = (function () {
            function Plan() {
                this.Options = [];
            }
            return Plan;
        })();
        Patient_1.Plan = Plan;
        var MedicalAid = (function () {
            function MedicalAid(name) {
                this.Name = name;
                this.Plans = [];
            }
            return MedicalAid;
        })();
        Patient_1.MedicalAid = MedicalAid;
        var Service = (function () {
            Service.$inject = ["httpService", "storageService", "moment"];
            function Service(httpService, storageService, moment) {
                "ngInject";
                this.httpService = httpService;
                this.storageService = storageService;
                this.moment = moment;
            }
            Service.prototype.getPatientById = function (practiceId, patientId) {
                return this.httpService.get(this.getUrl(practiceId) + 'patients/' + patientId);
            };
            Service.prototype.getPatientsByName = function (practiceId, text) {
                return this.httpService.get(this.getUrl(practiceId) + 'patients/' + encodeURIComponent(text));
            };
            Service.prototype.removePatient = function (practiceId, patientId) {
                return this.httpService.remove(this.getUrl(practiceId) + 'patients/' + patientId);
            };
            Service.prototype.getFamilyMembers = function (practiceId, patientId) {
                return this.httpService.get(this.getUrl(practiceId) + 'patients/' + patientId + '/members');
            };
            Service.prototype.getMasterPatientsByName = function (practiceId, text) {
                return this.httpService.get('v1/' + practiceId + '/patientmaster/patients/' + encodeURIComponent(text));
            };
            Service.prototype.createPatient = function (practiceId, updateAccount, patient, looseValidation) {
                if (looseValidation === void 0) { looseValidation = false; }
                var body = {
                    PatientVo: patient,
                    UpdateOtherPatientsAccountDetails: updateAccount,
                    LooseValidation: looseValidation,
                    CorrelationIds: [],
                    OriginatedSystem: DoctorAppSystem
                };
                return this.httpService.post(this.getUrl(practiceId) + 'patients', body);
            };
            Service.prototype.changePatient = function (practiceId, updateAccount, patient, looseValidation) {
                if (looseValidation === void 0) { looseValidation = false; }
                var body = {
                    PatientVo: patient,
                    LooseValidation: looseValidation,
                    UpdateOtherPatientsAccountDetails: updateAccount,
                    CorrelationIds: [],
                    OriginatedSystem: DoctorAppSystem
                };
                return this.httpService.post(this.getUrl(practiceId) + 'patients/' + patient.PatientId, body);
            };
            Service.prototype.getPatientByAccNo = function (practiceId, accountNo) {
                return this.httpService.get(this.getUrl(practiceId) + 'account/' + accountNo);
            };
            Service.prototype.cancelPatientEvent = function (practiceId, patientEventId) {
                var cancel = {
                    PatientEventId: patientEventId,
                    Reason: 'deleted by ' + this.storageService.getUser().name,
                    OriginatedSystem: DoctorAppSystem
                };
                return this.httpService.post('v1/' + practiceId + '/patientevent/patientevents/cancelpatientvisit', cancel);
            };
            Service.prototype.checkPatientVisit = function (practiceId, checkInPatient) {
                var event = new PatientEvent();
                event.PatientEventId = '00000000-0000-0000-0000-000000000000';
                event.PracticeId = practiceId;
                event.Patient = checkInPatient;
                event.ScheduledTime = "0001-01-01T00:00:00";
                event.CheckInTime = this.moment().utc().format();
                event.CheckedIn = true;
                var body = new CheckInPatientVisit();
                body.PracticeId = practiceId;
                body.PatientEventDetails = event;
                return this.httpService.post('v1/' + practiceId + '/patientevent/patientevents/checkinpatientvisit', body);
            };
            Service.prototype.addToWaitingRoom = function (practiceId, patientId) {
                return this.httpService
                    .post('v1/' + practiceId + '/patientevent/waitingroom/' + patientId + '/checkin', {});
            };
            Service.prototype.captureEncounter = function (practiceId, patientId) {
                return this.httpService
                    .post('v1/' + practiceId + '/patientevent/waitingroom/' + patientId + '/capture', {});
            };
            Service.prototype.getCheckInPatients = function (practiceId) {
                return this.httpService.get('v1/' + practiceId + '/patientevent/waitingroom');
            };
            Service.prototype.getWaitingRoomPatients = function (practiceId) {
                return this.httpService.get('v1/' + practiceId + '/patientevent/waitingroom/summary').then(function (resp) {
                    return resp.map(function (r) {
                        var pwr = angular.extend(new PatientInWaitingRoom(), r.PatientEvent);
                        pwr.HasQuote = r.HasQuote;
                        pwr.HasSummmaryOfCare = r.HasSummmaryOfCare;
                        return pwr;
                    });
                });
            };
            Service.prototype.importPatientAndCheckIn = function (practiceId, patient) {
                var body = new CreatePatient();
                body.PatientVo = patient;
                return this.httpService.post('v1/' + practiceId + '/patientevent/patientevents/importpatientandcheckin', body);
            };
            Service.prototype.getMedSchemes = function (practiceId) {
                return this.httpService.get(this.getUrl(practiceId) + 'medschemes');
            };
            Service.prototype.getUrl = function (practiceId) {
                return 'v1/' + practiceId + '/patient/';
            };
            return Service;
        })();
        Patient_1.Service = Service;
    })(Patient = Domain.Patient || (Domain.Patient = {}));
})(Domain || (Domain = {}));
angular.module('DoctorApp')
    .service('patientDomain', Domain.Patient.Service);
/// <reference path="../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../services/api/domain/patient.ts" />
var LocationModule;
(function (LocationModule) {
    var Service = (function () {
        Service.$inject = ["$rootScope", "$location"];
        function Service($rootScope, $location) {
            "ngInject";
            this.$rootScope = $rootScope;
            this.$location = $location;
            this.homePath = '/';
            this.practicesPath = '/practices';
            this.practiceCreatePath = '/practice';
            this.practiceEditPath = '/practice';
            this.practiceOptionsPath = '/practice-options';
            this.clinicalDashboardPath = '/clinical-dashboard';
            this.clinicalMessageCenter = '/clinical-message-center';
            this.clinicalPathalogyReport = '/clinical-pathology-report';
            this.clinicalPathologyReportWorkflow = '/clinical-pathology-report-workflow';
            this.createPatientPath = '/create-patient';
            this.patientVisits = '/patient-visits';
            this.changePatientPath = '/patient';
            this.loginPath = '/login';
            this.claimResponse = '/claim-response';
            this.cardReader = '/card-reader';
            this.visitOutcomes = '/clinical-visit-outcomes';
        }
        Service.prototype.goToHome = function (practiceId) {
            this.$location.path(this.homePath + practiceId + '/home');
        };
        Service.prototype.goToPractices = function () {
            this.$location.path(this.practicesPath);
        };
        Service.prototype.goToCreatePractice = function () {
            this.$location.path(this.practiceCreatePath);
        };
        Service.prototype.goToEditPractice = function (practiceId) {
            this.$location.path(this.practiceEditPath + '/' + practiceId);
        };
        Service.prototype.goToPracticeOptions = function (practiceId) {
            this.$location.path(this.practiceOptionsPath + '/' + practiceId);
        };
        Service.prototype.goToClinicalDashboard = function (practiceId, patientId) {
            this.$location.path('/' + practiceId + this.clinicalDashboardPath + '/' + patientId);
        };
        Service.prototype.goToClinicalMessageCenter = function (practiceId) {
            this.$location.path('/' + practiceId + this.clinicalMessageCenter);
        };
        Service.prototype.goToClinicalPathalogyReport = function (practiceId, pathologyReportId) {
            this.$location.path('/' + practiceId + this.clinicalPathalogyReport + '/' + pathologyReportId);
        };
        Service.prototype.goToClinicalPathologyReportWorkflow = function (practiceId, workflowId) {
            this.$location.path('/' + practiceId + this.clinicalPathologyReportWorkflow + '/' + workflowId + '/false');
        };
        Service.prototype.goToHealthId = function (practiceId, patientId) {
            this.$location.path('/' + practiceId + '/health-id/' + patientId);
        };
        Service.prototype.goToHealthDoc = function (practiceId, patientId) {
            this.$location.path('/' + practiceId + '/health-doc/' + patientId);
        };
        Service.prototype.goToPatientFile = function (practiceId, documentId) {
            this.$location.path('/' + practiceId + '/patient-file/' + documentId);
        };
        Service.prototype.goToClinicalVisitOutcomes = function (practiceId) {
            this.$location.path('/' + practiceId + this.visitOutcomes);
        };
        Service.prototype.goToConsultationReport = function (practiceId, patientId, type) {
            if (type === EncounterModule.ReportType.Prescription) {
                this.$location.path('/' + practiceId + '/consultation-reports/' + patientId + '/prescription');
            }
            else if (type === EncounterModule.ReportType.MedicalCertificate) {
                this.$location.path('/' + practiceId + '/consultation-reports/' + patientId + '/sicknote');
            }
        };
        Service.prototype.goToCreateClinicalTemplate = function (practiceId) {
            this.$location.path('/' + practiceId + '/clinical-template');
        };
        Service.prototype.goToEditClinicalTemplate = function (practiceId, templateId) {
            this.$location.path('/' + practiceId + '/clinical-template/' + templateId);
        };
        Service.prototype.goToAddressBook = function (practiceId) {
            this.$location.path('/' + practiceId + '/address-book');
        };
        Service.prototype.goToCreateAddressBook = function (practiceId) {
            this.$location.path('/' + practiceId + '/address-book/create');
        };
        Service.prototype.goToEditAddressBook = function (practiceId, entryId) {
            this.$location.path('/' + practiceId + '/address-book/entry/' + entryId);
        };
        Service.prototype.goToClinicalTemplates = function (practiceId, templateId) {
            this.$location.path('/' + practiceId + '/clinical-templates');
        };
        Service.prototype.goToTemplatesBulkImport = function (practiceId) {
            this.$location.path('/' + practiceId + '/template-bulk-import');
        };
        Service.prototype.goToCreatePatient = function (practiceId) {
            this.$location.path('/' + practiceId + this.createPatientPath);
        };
        Service.prototype.goToChangePatient = function (practiceId, patientId) {
            this.$location.path('/' + practiceId + this.changePatientPath + '/' + patientId);
        };
        Service.prototype.goToPatientVisits = function (practiceId) {
            this.$location.path('/' + practiceId + this.patientVisits);
        };
        Service.prototype.goToLogin = function () {
            this.$location.path(this.loginPath);
        };
        Service.prototype.gotToClaimResponse = function (claimId) {
            this.$location.path(this.claimResponse + '/' + claimId);
        };
        Service.prototype.goToCardReaderCreate = function () {
            this.$location.path(this.cardReader);
        };
        Service.prototype.gotToTestApi = function () {
            this.$location.path("/test-api");
        };
        Service.prototype.goToSpecialityRules = function () {
            this.$location.path("/speciality-rules");
        };
        Service.prototype.goToCreateSpecialityRule = function () {
            this.$location.path("/speciality-rule");
        };
        Service.prototype.goToEditSpecialityRule = function (code) {
            this.$location.path("/speciality-rule/" + code);
        };
        Service.prototype.gotToAudit = function () {
            this.$location.path("/audit");
        };
        Service.prototype.goToPublicKeys = function () {
            this.$location.path("/public-keys");
        };
        Service.prototype.goToCardReaders = function () {
            this.$location.path("/card-readers");
        };
        Service.prototype.goToCardPayments = function () {
            this.$location.path("/card-payments");
        };
        Service.prototype.goToTenants = function () {
            this.$location.path("/tenants");
        };
        Service.prototype.goToCreateTenant = function () {
            this.$location.path("/tenant");
        };
        Service.prototype.goToEditTenant = function (tenantId) {
            this.$location.path("/tenant/" + tenantId);
        };
        Service.prototype.goToUsers = function (practiceId) {
            this.$location.path("/users/" + (practiceId || ''));
        };
        Service.prototype.goToFailedInvoices = function () {
            this.$location.path('/failed-invoices');
        };
        Service.prototype.goToCardReaderEdit = function (tenantId, cardReaderId) {
            this.$location.path('/tenant/' + tenantId + "/card-reader/" + cardReaderId);
        };
        Service.prototype.goToInvoice = function (practiceId, patientEventId) {
            this.$location.path('/' + practiceId + '/invoice/' + patientEventId);
        };
        Service.prototype.goToMedicalHistory = function (practiceId, patientId) {
            this.$location.path('/' + practiceId + '/medical-history/' + patientId);
        };
        Service.prototype.goToEncounter = function (practiceId, patientEventId) {
            this.$location.path('/' + practiceId + '/encounter/' + patientEventId);
        };
        Service.prototype.goToAccount = function (practiceId, userId) {
            this.$location.path('/' + practiceId + '/account/' + userId);
        };
        Service.prototype.goToChangePassword = function (practiceId, userId) {
            this.$location.path('/' + practiceId + '/change-password/' + userId);
        };
        Service.prototype.goToNotificationsBulkSend = function (practiceId) {
            this.$location.path('/' + practiceId + '/notifications-bulk-send');
        };
        Service.prototype.goToTemplates = function (practiceId) {
            this.$location.path('/' + practiceId + '/templates');
        };
        Service.prototype.goToCreateTemplate = function (practiceId) {
            this.$location.path('/' + practiceId + '/template');
        };
        Service.prototype.goToEditTemplate = function (practiceId, templateId) {
            this.$location.path('/' + practiceId + '/template/' + templateId);
        };
        Service.prototype.setAbsoluteServerUrl = function (report) {
            return report && report.replace("{{absoluteServerUrl}}", this.getAbsoluteServerUrl());
        };
        Service.prototype.getAbsoluteServerUrl = function () {
            var absoluteUrl = this.$location.absUrl();
            return absoluteUrl.substr(0, absoluteUrl.length - this.$location.url().length - 1);
        };
        Service.prototype.goToTenantEvents = function (tenantId, dateFrom, dateTo) {
            if (!dateFrom || !dateTo) {
                this.$location.path('/events/' + tenantId);
            }
            else {
                this.$location.path('/events/' + tenantId + '/from/' + dateFrom + '/to/' + dateTo);
            }
        };
        Service.prototype.goToAuditEvents = function (tenantId, aggregateId) {
            this.$location.path('/events/' + tenantId.replace(new RegExp(":", "g"), "_") + "/" + aggregateId);
        };
        Service.prototype.goToPowerBi = function (practiceId) {
            this.$location.path('/' + practiceId + '/power-bi-list');
        };
        Service.prototype.goToPowerBiReport = function (practiceId, reportId) {
            this.$location.path('/' + practiceId + '/power-bi/' + reportId);
        };
        Service.prototype.goToCreateTimer = function () {
            this.$location.path('/timer');
        };
        Service.prototype.goToTimers = function () {
            this.$location.path('/timers');
        };
        Service.prototype.goToCreateUser = function () {
            this.$location.path('/user');
        };
        Service.prototype.goToEditUser = function (userId) {
            this.$location.path('/user/' + userId);
        };
        return Service;
    })();
    LocationModule.Service = Service;
})(LocationModule || (LocationModule = {}));
angular.module('DoctorApp')
    .service('locationService', LocationModule.Service);
/// <reference path="../../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../http-service.ts" />
/// <reference path="../../auth-service.ts" />
var Domain;
(function (Domain) {
    var Account;
    (function (Account) {
        var Claim = (function () {
            function Claim() {
            }
            return Claim;
        })();
        Account.Claim = Claim;
        var User = (function () {
            function User() {
                this.Claims = [];
            }
            return User;
        })();
        Account.User = User;
        var ChangeUserPassword = (function () {
            function ChangeUserPassword() {
            }
            return ChangeUserPassword;
        })();
        Account.ChangeUserPassword = ChangeUserPassword;
        var Service = (function () {
            Service.$inject = ["httpService", "authService", "$q"];
            function Service(httpService, authService, $q) {
                "ngInject";
                this.httpService = httpService;
                this.authService = authService;
                this.$q = $q;
            }
            Service.prototype.getPractices = function () {
                return this.httpService.get(this.getUrl() + '/account/practices');
            };
            Service.prototype.createUser = function (user) {
                return this.httpService.post(this.getUrl() + '/account/users', user);
            };
            Service.prototype.getUsers = function () {
                return this.httpService.get(this.getUrl() + '/account/users');
            };
            Service.prototype.getUsersPage = function (filter, pageCount, pageSize) {
                return this.httpService.get(this.getUrl() + '/account/users' + (filter && filter.trim() ? '/' + filter + '/search' : '') + '?$top=' + pageSize + '&$skip=' + pageCount * pageSize);
            };
            Service.prototype.updateUser = function (user) {
                return this.httpService.put(this.getUrl() + '/account/users/' + user.UserId, user);
            };
            Service.prototype.getUser = function (userId) {
                return this.httpService.get(this.getUrl() + '/account/users/' + userId);
            };
            Service.prototype.getUserByName = function (userName) {
                return this.httpService.get(this.getUrl() + '/account/users/byName/' + userName);
            };
            Service.prototype.deleteUser = function (userId) {
                return this.httpService.remove(this.getUrl() + '/account/users/' + userId);
            };
            Service.prototype.changeUserPassword = function (changeRequest) {
                return this.httpService.post(this.getUrl() + '/account/users/' + changeRequest.UserId + '/password', changeRequest);
            };
            Service.prototype.init = function () {
                return this.httpService.post(this.getUrl() + '/account/initialise');
            };
            Service.prototype.getUrl = function () {
                return 'v1/authentication';
            };
            return Service;
        })();
        Account.Service = Service;
    })(Account = Domain.Account || (Domain.Account = {}));
})(Domain || (Domain = {}));
angular.module('DoctorApp')
    .service('accountDomain', Domain.Account.Service);
/// <reference path="../../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../../../scripts/definition/moment/moment-node.d.ts" />
/// <reference path="../../../services/api/result-api.ts" />
/// <reference path="../../../services/auth-service.ts" />
/// <reference path="../../../services/http-service.ts" />
var Domain;
(function (Domain) {
    var Billing;
    (function (Billing) {
        var Template = (function () {
            function Template(templateId) {
                this.TemplateId = templateId;
                this.InvoiceLineItemsVo = new InvoiceLineItems();
            }
            return Template;
        })();
        Billing.Template = Template;
        var InvoiceHeader = (function () {
            function InvoiceHeader() {
                this.Diagnosis = [];
            }
            return InvoiceHeader;
        })();
        Billing.InvoiceHeader = InvoiceHeader;
        var Diagnosis = (function () {
            function Diagnosis() {
            }
            return Diagnosis;
        })();
        Billing.Diagnosis = Diagnosis;
        var LineItem = (function () {
            function LineItem() {
            }
            return LineItem;
        })();
        Billing.LineItem = LineItem;
        var Invoice = (function () {
            function Invoice() {
                this.Provider = new Domain.Billing.Provider();
                this.PatientEventDetails = new Domain.Patient.PatientEvent();
                this.InvoiceLineItems = new InvoiceLineItems();
            }
            return Invoice;
        })();
        Billing.Invoice = Invoice;
        var InvoiceLineItems = (function () {
            function InvoiceLineItems() {
                this.InvoiceHeader = new InvoiceHeader();
                this.LineItems = [];
            }
            return InvoiceLineItems;
        })();
        Billing.InvoiceLineItems = InvoiceLineItems;
        var Provider = (function () {
            function Provider(practiceId) {
                this.PracticeId = practiceId;
                this.NetworkedSchemes = [];
                this.ManualPricingSchemes = [];
            }
            return Provider;
        })();
        Billing.Provider = Provider;
        var SchemeObject = (function () {
            function SchemeObject(name) {
                this.name = name;
            }
            return SchemeObject;
        })();
        Billing.SchemeObject = SchemeObject;
        var ClaimFinancials = (function () {
            function ClaimFinancials() {
            }
            return ClaimFinancials;
        })();
        Billing.ClaimFinancials = ClaimFinancials;
        var Transaction = (function () {
            function Transaction() {
            }
            return Transaction;
        })();
        Billing.Transaction = Transaction;
        var Response = (function () {
            function Response() {
            }
            return Response;
        })();
        Billing.Response = Response;
        var LineItemFinancials = (function () {
            function LineItemFinancials() {
            }
            return LineItemFinancials;
        })();
        Billing.LineItemFinancials = LineItemFinancials;
        var SupportingProviderVo = (function () {
            function SupportingProviderVo() {
            }
            SupportingProviderVo.prototype.FullName = function () {
                return (this.Title || "") + " " + this.Name + " " + this.Surname;
            };
            return SupportingProviderVo;
        })();
        Billing.SupportingProviderVo = SupportingProviderVo;
        var ProviderBranchVo = (function () {
            function ProviderBranchVo() {
            }
            return ProviderBranchVo;
        })();
        Billing.ProviderBranchVo = ProviderBranchVo;
        var LineItemFees = (function () {
            function LineItemFees() {
            }
            return LineItemFees;
        })();
        Billing.LineItemFees = LineItemFees;
        var LineItemRef = (function () {
            function LineItemRef() {
            }
            return LineItemRef;
        })();
        Billing.LineItemRef = LineItemRef;
        var DUR = (function () {
            function DUR() {
            }
            return DUR;
        })();
        Billing.DUR = DUR;
        var LineItemInfo = (function () {
            function LineItemInfo() {
            }
            return LineItemInfo;
        })();
        Billing.LineItemInfo = LineItemInfo;
        var ClaimResponseLineItem = (function () {
            function ClaimResponseLineItem() {
            }
            return ClaimResponseLineItem;
        })();
        Billing.ClaimResponseLineItem = ClaimResponseLineItem;
        var LineItemWithStatus = (function () {
            function LineItemWithStatus() {
            }
            return LineItemWithStatus;
        })();
        Billing.LineItemWithStatus = LineItemWithStatus;
        var ClaimResponseDetails = (function () {
            function ClaimResponseDetails() {
            }
            return ClaimResponseDetails;
        })();
        Billing.ClaimResponseDetails = ClaimResponseDetails;
        var ClaimResponse = (function () {
            function ClaimResponse() {
            }
            return ClaimResponse;
        })();
        Billing.ClaimResponse = ClaimResponse;
        var InvoiceLineItemsWithStatus = (function () {
            function InvoiceLineItemsWithStatus() {
            }
            return InvoiceLineItemsWithStatus;
        })();
        Billing.InvoiceLineItemsWithStatus = InvoiceLineItemsWithStatus;
        var Event = (function () {
            function Event() {
            }
            return Event;
        })();
        Billing.Event = Event;
        var ProviderVo = (function () {
            function ProviderVo() {
            }
            return ProviderVo;
        })();
        Billing.ProviderVo = ProviderVo;
        var InvoiceSendingStatus = (function () {
            function InvoiceSendingStatus() {
            }
            return InvoiceSendingStatus;
        })();
        Billing.InvoiceSendingStatus = InvoiceSendingStatus;
        var InvoiceWithStatus = (function () {
            function InvoiceWithStatus() {
            }
            return InvoiceWithStatus;
        })();
        Billing.InvoiceWithStatus = InvoiceWithStatus;
        var SpecialityRule = (function () {
            function SpecialityRule() {
                this.MutuallyExclusiveCodes = [];
                this.PrefixChargeCodesOnClaim = false;
            }
            return SpecialityRule;
        })();
        Billing.SpecialityRule = SpecialityRule;
        var DeactivateSpecialityRule = (function () {
            function DeactivateSpecialityRule() {
            }
            return DeactivateSpecialityRule;
        })();
        Billing.DeactivateSpecialityRule = DeactivateSpecialityRule;
        var FeatureAllows = (function () {
            function FeatureAllows() {
                this.AllowDiagnosis = true;
                this.AllowMedicine = false;
                this.AllowProcedure = true;
                this.AllowPrescription = false;
                this.AllowConsumable = false;
                this.AllowReferralDoctor = false;
                this.AllowAssistingDoctor = false;
                this.AllowReferralLetter = false;
                this.AllowMyTemplates = true;
                this.AllowMedicalCertificate = false;
                this.AllowHospitalClaim = true;
                this.AllowDayClinicClaim = false;
                this.AllowMedicalInsurance = true;
                this.AllowClinicalMetric = false;
            }
            return FeatureAllows;
        })();
        Billing.FeatureAllows = FeatureAllows;
        var CommunicationTemplate = (function () {
            function CommunicationTemplate() {
            }
            return CommunicationTemplate;
        })();
        Billing.CommunicationTemplate = CommunicationTemplate;
        var Service = (function () {
            Service.$inject = ["httpService", "authService"];
            function Service(httpService, authService) {
                "ngInject";
                this.httpService = httpService;
                this.authService = authService;
            }
            Service.prototype.getInvoices = function () {
                return this.httpService.get(this.getUrl() + 'invoices');
            };
            Service.prototype.getInvoice = function (invoiceId) {
                return this.httpService.get(this.getUrl() + 'invoices/' + invoiceId);
            };
            Service.prototype.getInvoiceWithStatus = function (invoiceId) {
                return this.httpService.get(this.getUrl() + 'invoices/' + invoiceId + '/status');
            };
            Service.prototype.getTemplatesByInvoice = function (invoiceId) {
                return this.httpService.get(this.getUrl() + 'invoices/' + invoiceId + '/templates');
            };
            Service.prototype.getTemplates = function () {
                return this.httpService.get(this.getUrl() + 'invoicetemplates');
            };
            Service.prototype.getTemplate = function (templateId) {
                return this.httpService.get(this.getUrl() + 'invoicetemplates/' + templateId);
            };
            Service.prototype.submitInvoice = function (invoice) {
                var body = {
                    InvoiceVo: invoice,
                    CorrelationIds: []
                };
                return this.httpService.post(this.getUrl() + 'invoices/' + invoice.InvoiceId, body);
            };
            Service.prototype.saveTemplate = function (template) {
                var body = {
                    InvoiceTemplateVo: template,
                    CorrelationIds: []
                };
                return this.httpService.post(this.getUrl() + 'invoicetemplates', body);
            };
            Service.prototype.updateTemplate = function (template) {
                var body = {
                    InvoiceTemplateVo: template,
                    CorrelationIds: []
                };
                return this.httpService.post(this.getUrl() + 'invoicetemplates/' + template.TemplateId, body);
            };
            Service.prototype.removeTemplate = function (templateId) {
                return this.httpService.remove(this.getUrl() + 'invoicetemplates/' + templateId);
            };
            Service.prototype.mergeInvoiceHospital = function (invoiceId, invoiceLineItems) {
                var body = {
                    OriginalInstruction: invoiceLineItems,
                    CorrelationIds: []
                };
                return this.httpService.post(this.getUrl() + 'invoices/' + invoiceId + '/mergeinvoicehospitalindicator', body);
            };
            Service.prototype.mergeInvoiceLineItems = function (invoiceId, invoiceLineItems, template) {
                var body = {
                    InvoiceId: invoiceId,
                    PracticeId: this.getPracticeId,
                    OriginalInstruction: invoiceLineItems,
                    NewInstruction: template,
                    CorrelationIds: []
                };
                return this.httpService.post(this.getUrl() + 'invoices/' + invoiceId + '/mergeinvoicelineitems', body);
            };
            Service.prototype.mergeTemplateLineItems = function (invoiceLineItems, template, invoiceId) {
                var body = {
                    InvoiceId: invoiceId,
                    PracticeId: this.getPracticeId,
                    OriginalInstruction: invoiceLineItems,
                    NewInstruction: template,
                    CorrelationIds: []
                };
                return this.httpService.post(this.getUrl() + 'mergeinvoicelineitems', body);
            };
            Service.prototype.sendInvoiceManually = function (practiceId, invoiceid, reason) {
                return this.httpService.post('v1/' + practiceId + '/billing/invoices/' + invoiceid + "/sendmanually", {});
            };
            Service.prototype.retrySendingInvoice = function (practiceId, invoiceid, reason) {
                return this.httpService.post('v1/' + practiceId + '/billing/invoices/' + invoiceid + "/retry", { Reason: reason });
            };
            Service.prototype.abortSendingInvoice = function (practiceId, invoiceid, reason) {
                return this.httpService.post('v1/' + practiceId + '/billing/invoices/' + invoiceid + "/abort", { Reason: reason });
            };
            Service.prototype.getFailedInvoices = function () {
                return this.httpService.get("v1/billing/invoices/failed");
            };
            Service.prototype.getSentInvoices = function (date) {
                return this.httpService.get("v1/billing/invoices/sent/sentDate/" + date.format('YYYY-MM-DD'));
            };
            Service.prototype.getCommunicationTemplates = function () {
                return this.httpService.get("v1/infrastructure/communicationtemplates");
            };
            Service.prototype.updateCommunicationTemplate = function (template) {
                return this.httpService.post('v1/infrastructure/communicationtemplates/' + template.TemplateId, template);
            };
            Service.prototype.getSpecialityRules = function () {
                return this.httpService.get('v1/billing/specialityrules');
            };
            Service.prototype.getSpecialityRulesByCode = function (code) {
                return this.httpService.get(this.getUrl() + 'specialityrules/' + code);
            };
            Service.prototype.updateSpecialityRule = function (rule) {
                return this.httpService.post('v1/billing/specialityrule/update', rule);
            };
            Service.prototype.deactivateSpecialityRule = function (deactivateRule) {
                return this.httpService.post('v1/billing/specialityrule/deactivate/', deactivateRule);
            };
            Service.prototype.createProvider = function (provider) {
                var body = {
                    ProviderConfiguration: provider,
                    CorrelationIds: []
                };
                return this.httpService.post('v1/billing/providers', body);
            };
            Service.prototype.updateProvider = function (provider) {
                var body = {
                    ProviderConfiguration: provider,
                    Reason: 'Updated from Florence UI',
                    CorrelationIds: []
                };
                return this.httpService.post('v1/billing/providers/' + provider.PracticeId, body);
            };
            Service.prototype.deleteProvider = function (providerId) {
                var body = {
                    PracticeId: providerId,
                    Reason: 'Deleted from Florence UI',
                    CorrelationIds: []
                };
                return this.httpService.remove('v1/billing/providers/' + providerId, body);
            };
            Service.prototype.getProviders = function () {
                return this.httpService.get('v1/billing/providers');
            };
            Service.prototype.getProvidersFiltered = function (filter, pageCount, pageSize) {
                return this.httpService.get('v1/billing/providers/' + filter + '?$top=' + pageSize + '&$skip=' + pageCount * pageSize);
            };
            Service.prototype.getProvidersPage = function (pageCount, pageSize) {
                return this.httpService.get('v1/billing/providers' + '?$top=' + pageSize + '&$skip=' + pageCount * pageSize);
            };
            Service.prototype.getDoctorsByBillingNumber = function (practiceId, type) {
                return this.httpService.get('v1/billing/supportingproviders/' + practiceId + '/' + type);
            };
            Service.prototype.getBranches = function (practiceId) {
                return this.httpService.get('v1/' + practiceId + '/billing/branches');
            };
            Service.prototype.getProvider = function (practiceId) {
                return this.httpService.get('v1/billing/provider/' + practiceId);
            };
            Service.prototype.getProviderById = function (providerId) {
                return this.httpService.get('v1/billing/provider/' + providerId);
            };
            Service.prototype.setOptions = function (providerId, options) {
                var body = {
                    ProviderId: providerId,
                    Options: options,
                    CorrelationIds: []
                };
                return this.httpService.post('v1/' + providerId + '/billing/providers/setoptions', body);
            };
            Service.prototype.setProviderOption = function (providerId, options) {
                var body = {
                    Options: options,
                    CorrelationIds: []
                };
                return this.httpService.post('v2/' + providerId + '/billing/providers/preferences', body);
            };
            Service.prototype.cancelInvoice = function (invoiceId) {
                return this.httpService.post(this.getUrl() + 'invoices/' + invoiceId + '/cancel');
            };
            Service.prototype.getUrl = function () {
                return 'v1/' + this.getPracticeId() + '/billing/';
            };
            Service.prototype.getPracticeId = function () {
                return this.authService.getPracticeId();
            };
            return Service;
        })();
        Billing.Service = Service;
    })(Billing = Domain.Billing || (Domain.Billing = {}));
})(Domain || (Domain = {}));
angular.module('DoctorApp')
    .service('billingDomain', Domain.Billing.Service);
/// <reference path="../../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../../../scripts/definition/moment/moment-node.d.ts" />
/// <reference path="billing.ts" />
/// <reference path="patient.ts" />
/// <reference path="../result-api.ts" />
var Domain;
(function (Domain) {
    var Clinical;
    (function (Clinical) {
        var Encounter = (function () {
            function Encounter() {
                this.Provider = new Domain.Billing.Provider();
                this.PatientEventDetails = new Domain.Patient.PatientEvent();
                this.EncounterLineItems = new EncounterLineItems();
                this.EncounterFollowUp = new EncounterFollowUp();
                this.MedicationsAdministered = new MedicationPrescription();
                this.MedicationsDispensed = new MedicationPrescription();
                this.MedicationsPrescribed = new MedicationPrescription();
                this.MedicalCertificate = new MedicalCertificate();
            }
            return Encounter;
        })();
        Clinical.Encounter = Encounter;
        var MergeEncounterValidationError = (function () {
            function MergeEncounterValidationError() {
            }
            return MergeEncounterValidationError;
        })();
        Clinical.MergeEncounterValidationError = MergeEncounterValidationError;
        var MergeEncounterResult = (function () {
            function MergeEncounterResult() {
            }
            return MergeEncounterResult;
        })();
        Clinical.MergeEncounterResult = MergeEncounterResult;
        var MedicationPrescription = (function () {
            function MedicationPrescription() {
                this.Provider = new Domain.Billing.Provider();
                this.Patient = new Domain.Patient.Patient();
                this.MedicationPrescriptionLines = [];
            }
            return MedicationPrescription;
        })();
        Clinical.MedicationPrescription = MedicationPrescription;
        var MedicationPrescriptionLine = (function () {
            function MedicationPrescriptionLine() {
                this.Diagnosis = [];
            }
            return MedicationPrescriptionLine;
        })();
        Clinical.MedicationPrescriptionLine = MedicationPrescriptionLine;
        var EncounterFollowUp = (function () {
            function EncounterFollowUp() {
                this.FollowUpReasons = [];
            }
            return EncounterFollowUp;
        })();
        Clinical.EncounterFollowUp = EncounterFollowUp;
        var TemplateCreate = (function () {
            function TemplateCreate() {
                this.EncounterTemplate = new Template();
                this.CorrelationIds = [];
            }
            return TemplateCreate;
        })();
        Clinical.TemplateCreate = TemplateCreate;
        var Template = (function () {
            function Template() {
                this.EncounterLineItems = new EncounterLineItems();
                this.MedicationPrescriptionLines = [];
            }
            return Template;
        })();
        Clinical.Template = Template;
        var EncounterLineItems = (function () {
            function EncounterLineItems() {
                this.EncounterHeader = new EncounterHeader();
                this.LineItems = [];
            }
            return EncounterLineItems;
        })();
        Clinical.EncounterLineItems = EncounterLineItems;
        var EncounterHeader = (function () {
            function EncounterHeader() {
                this.Diagnosis = [];
            }
            return EncounterHeader;
        })();
        Clinical.EncounterHeader = EncounterHeader;
        var Diagnosis = (function () {
            function Diagnosis() {
            }
            return Diagnosis;
        })();
        Clinical.Diagnosis = Diagnosis;
        var LineItem = (function () {
            function LineItem() {
            }
            return LineItem;
        })();
        Clinical.LineItem = LineItem;
        var AddressBookEntry = (function () {
            function AddressBookEntry() {
            }
            return AddressBookEntry;
        })();
        Clinical.AddressBookEntry = AddressBookEntry;
        var Address = (function () {
            function Address() {
            }
            return Address;
        })();
        Clinical.Address = Address;
        var ModifierInfo = (function () {
            function ModifierInfo() {
            }
            return ModifierInfo;
        })();
        Clinical.ModifierInfo = ModifierInfo;
        var ModifierRequiredParams = (function () {
            function ModifierRequiredParams() {
            }
            return ModifierRequiredParams;
        })();
        Clinical.ModifierRequiredParams = ModifierRequiredParams;
        var MedicalCertificate = (function () {
            function MedicalCertificate() {
                this.Diagnoses = [];
                this.Patient = new Domain.Patient.Patient();
                this.Provider = new Domain.Billing.Provider();
            }
            return MedicalCertificate;
        })();
        Clinical.MedicalCertificate = MedicalCertificate;
        var MedicalInsurer = (function () {
            function MedicalInsurer() {
            }
            return MedicalInsurer;
        })();
        Clinical.MedicalInsurer = MedicalInsurer;
        var MedicalInsurance = (function () {
            function MedicalInsurance() {
            }
            return MedicalInsurance;
        })();
        Clinical.MedicalInsurance = MedicalInsurance;
        var ClinicalMetric = (function () {
            function ClinicalMetric() {
            }
            return ClinicalMetric;
        })();
        Clinical.ClinicalMetric = ClinicalMetric;
        var PathologyReportWorkflow = (function () {
            function PathologyReportWorkflow() {
            }
            return PathologyReportWorkflow;
        })();
        Clinical.PathologyReportWorkflow = PathologyReportWorkflow;
        var PatientPathologyResultDeliveryStatus = (function () {
            function PatientPathologyResultDeliveryStatus() {
            }
            return PatientPathologyResultDeliveryStatus;
        })();
        Clinical.PatientPathologyResultDeliveryStatus = PatientPathologyResultDeliveryStatus;
        var PatientPathologyResult = (function () {
            function PatientPathologyResult() {
            }
            return PatientPathologyResult;
        })();
        Clinical.PatientPathologyResult = PatientPathologyResult;
        var PatientDashboardEvent = (function () {
            function PatientDashboardEvent() {
            }
            return PatientDashboardEvent;
        })();
        Clinical.PatientDashboardEvent = PatientDashboardEvent;
        var PatientDashboard = (function () {
            function PatientDashboard() {
            }
            return PatientDashboard;
        })();
        Clinical.PatientDashboard = PatientDashboard;
        var PatientDocument = (function () {
            function PatientDocument() {
            }
            return PatientDocument;
        })();
        Clinical.PatientDocument = PatientDocument;
        var Provider = (function () {
            function Provider() {
                this.NetworkedSchemes = [];
                this.ManualPricingSchemes = [];
            }
            return Provider;
        })();
        Clinical.Provider = Provider;
        var Communication = (function () {
            function Communication() {
            }
            return Communication;
        })();
        Clinical.Communication = Communication;
        var ReferralTemplate = (function () {
            function ReferralTemplate() {
            }
            return ReferralTemplate;
        })();
        Clinical.ReferralTemplate = ReferralTemplate;
        (function (ReportStatusType) {
            ReportStatusType[ReportStatusType["OPEN"] = 0] = "OPEN";
            ReportStatusType[ReportStatusType["READ"] = 1] = "READ";
            ReportStatusType[ReportStatusType["URGENT"] = 2] = "URGENT";
        })(Clinical.ReportStatusType || (Clinical.ReportStatusType = {}));
        var ReportStatusType = Clinical.ReportStatusType;
        var ReportStatusTypeUtil = (function () {
            function ReportStatusTypeUtil() {
            }
            ReportStatusTypeUtil.getName = function (statusType) {
                return this.NAMES[statusType];
            };
            ReportStatusTypeUtil.NAMES = [
                'Open',
                'Read',
                'Urgent'
            ];
            return ReportStatusTypeUtil;
        })();
        Clinical.ReportStatusTypeUtil = ReportStatusTypeUtil;
        var PatientAllergies = (function () {
            function PatientAllergies() {
            }
            return PatientAllergies;
        })();
        Clinical.PatientAllergies = PatientAllergies;
        var PatientChronicConditions = (function () {
            function PatientChronicConditions() {
            }
            return PatientChronicConditions;
        })();
        Clinical.PatientChronicConditions = PatientChronicConditions;
        var Token = (function () {
            function Token() {
            }
            return Token;
        })();
        Clinical.Token = Token;
        var PatientCondition = (function () {
            function PatientCondition() {
            }
            return PatientCondition;
        })();
        Clinical.PatientCondition = PatientCondition;
        var Condition = (function () {
            function Condition() {
            }
            return Condition;
        })();
        Clinical.Condition = Condition;
        var Allergy = (function () {
            function Allergy() {
            }
            return Allergy;
        })();
        Clinical.Allergy = Allergy;
        var PatientAllergy = (function () {
            function PatientAllergy() {
            }
            return PatientAllergy;
        })();
        Clinical.PatientAllergy = PatientAllergy;
        var Service = (function () {
            Service.$inject = ["httpService", "authService", "moment", "$q"];
            function Service(httpService, authService, moment, $q) {
                "ngInject";
                this.httpService = httpService;
                this.authService = authService;
                this.moment = moment;
                this.$q = $q;
            }
            Service.prototype.getEncounters = function (practiceId) {
                return this.httpService.get(this.getUrl(practiceId) + 'encounters');
            };
            Service.prototype.getEncounter = function (practiceId, encounterId) {
                return this.httpService.get(this.getUrl(practiceId) + 'encounters/' + encounterId);
            };
            Service.prototype.getEncounterByPatientVisit = function (practiceId, patientVisitId, config, notShowError) {
                return this.httpService.get(this.getUrl(practiceId) + 'encounters/bypatientvisitid/' + patientVisitId, config, notShowError);
            };
            Service.prototype.getTemplatesByEncounter = function (practiceId, encounterId) {
                return this.httpService.get(this.getUrl(practiceId) + 'encounters/' + encounterId + '/templates', { cache: 'getTemplatesByEncounter' + practiceId });
            };
            Service.prototype.invalidateEncounterTemplateCache = function (practiceId) {
                this.httpService.resetCache('getTemplatesByEncounter' + practiceId);
            };
            Service.prototype.importMultipleTemplates = function (practiceId, items, importType, onlyValidate) {
                var body = {
                    RawData: items,
                    ImportType: importType,
                    OnlyValidate: onlyValidate
                };
                return this.httpService.post(this.getUrl(practiceId) + 'encountertemplates/import/bulk', body);
            };
            Service.prototype.getTemplates = function (practiceId) {
                return this.httpService.get(this.getUrl(practiceId) + 'encountertemplates', { cache: 'getTemplatesByEncounter' + practiceId });
            };
            Service.prototype.getTemplate = function (practiceId, templateId) {
                return this.httpService.get(this.getUrl(practiceId) + 'encountertemplates/' + templateId);
            };
            Service.prototype.getHistoricalMetrics = function (practiceId, patientId) {
                return this.httpService.get(this.getUrl(practiceId) + 'patient/' + patientId + "/metrics");
            };
            Service.prototype.submitEncounter = function (practiceId, encounter) {
                var wrapper = new WrapperVo(encounter, []);
                return this.httpService.post(this.getUrl(practiceId) + 'encounters/' + encounter.EncounterId, wrapper);
            };
            Service.prototype.setupPrice = function (practiceId, encounter) {
                return this.httpService.post(this.getUrl(practiceId) + 'encounters/' + encounter.EncounterId + '/price', encounter);
            };
            Service.prototype.validateEncounter = function (practiceId, encounter) {
                var wrapper = new WrapperVo(encounter, []);
                return this.httpService.post(this.getUrl(practiceId) + 'encounters/' + encounter.EncounterId + '/validate', wrapper);
            };
            Service.prototype.mergeLineItemsByEncounter = function (practiceId, encounter, template) {
                var body = {
                    EncounterId: encounter.EncounterId,
                    OriginalInstruction: encounter,
                    NewInstruction: template,
                    CorrelationIds: []
                };
                return this.httpService.post(this.getUrl(practiceId) +
                    'encounters/' +
                    encounter.EncounterId +
                    '/mergeencounterlineitems', body);
            };
            Service.prototype.mergeLineItemsByTemplates = function (practiceId, mainTemplate, template) {
                var body = {
                    OriginalInstruction: mainTemplate,
                    NewInstruction: template,
                    CorrelationIds: []
                };
                return this.httpService.post(this.getUrl(practiceId) +
                    'encountertemplates/' +
                    mainTemplate.TemplateId +
                    '/mergelineitems', body);
            };
            Service.prototype.getPrescriptionReport = function (practiceId, encounter, type) {
                if (type === void 0) { type = "html"; }
                if (type === "pdf") {
                    return this.httpService.post(this.getUrl(practiceId) + "prescription/report/" + type, encounter, { responseType: 'arraybuffer' });
                }
                return this.httpService.post(this.getUrl(practiceId) + "prescription/report", encounter);
            };
            Service.prototype.getPrescriptionHistory = function (practiceId, patientId) {
                return this.httpService.get(this.getUrl(practiceId) +
                    "patient/" +
                    patientId +
                    "/encounters/withprescriptions");
            };
            Service.prototype.getMedicacalSertificate = function (practiceId, encounter, type) {
                if (type === void 0) { type = "html"; }
                if (type === "pdf") {
                    return this.httpService.post(this.getUrl(practiceId) + "medicalcertificate/report/" + type, encounter, { responseType: 'arraybuffer' });
                }
                return this.httpService.post(this.getUrl(practiceId) + "medicalcertificate/report/" + type, encounter);
            };
            Service.prototype.sendCommunicationByEmail = function (practiceId, patientId, body, notShowError) {
                return this.httpService.post(this.getUrl(practiceId) + "patient/" + patientId + "/sendcommunication", body, null, notShowError);
            };
            Service.prototype.mergeHospitalIndicator = function (practiceId, encounterId, lineItems) {
                var request = {
                    OriginalInstruction: lineItems,
                    CorrelationIds: []
                };
                return this.httpService.post(this.getUrl(practiceId) +
                    'encounters/' +
                    encounterId +
                    '/mergeencounterhospitalindicator', request);
            };
            Service.prototype.mergePlaceOfService = function (practiceId, encounterId, lineItems) {
                var request = {
                    OriginalInstruction: lineItems,
                    CorrelationIds: []
                };
                return this.httpService.post(this.getUrl(practiceId) +
                    'encounters/' +
                    encounterId +
                    '/changeplaceofservice', request);
            };
            Service.prototype.getAddressBook = function (practiceId, lookupfilter, pageNo, pageSize) {
                if (lookupfilter === void 0) { lookupfilter = ''; }
                return this.httpService.get(this.getUrl(practiceId) + 'addressbook/' + lookupfilter + '?$top=' + pageSize + '&$skip=' + pageNo * pageSize);
            };
            Service.prototype.getAddressBookFavourites = function (practiceId) {
                return this.httpService.get(this.getUrl(practiceId) + 'addressbook/favourite');
            };
            Service.prototype.getAddressBookEntry = function (practiceId, entryId) {
                return this.httpService.get(this.getUrl(practiceId) + 'addressbook/byId/' + entryId);
            };
            Service.prototype.addAddressBookEntry = function (practiceId, entry) {
                var request = {
                    AddressBookEntry: entry
                };
                return this.httpService.post(this.getUrl(practiceId) + 'addressbook/', request);
            };
            Service.prototype.updateAddressBookEntry = function (practiceId, entry) {
                var request = {
                    AddressBookEntry: entry
                };
                return this.httpService.post(this.getUrl(practiceId) + 'addressbook/' + entry.AddressBookEntryId, request);
            };
            Service.prototype.removeAddressBookEntry = function (practiceId, entryId) {
                return this.httpService.remove(this.getUrl(practiceId) + 'addressbook/' + entryId);
            };
            Service.prototype.createTemplate = function (practiceId, template) {
                var request = {
                    EncounterTemplate: template,
                    CorrelationIds: []
                };
                return this.httpService.post(this.getUrl(practiceId) + 'encountertemplates', request);
            };
            Service.prototype.saveEncounter = function (practiceId, encounter) {
                var wrapper = new WrapperVo(encounter, []);
                return this.httpService.post(this.getUrl(practiceId) + 'encounters/' + encounter.EncounterId + '/save', wrapper);
            };
            Service.prototype.updateTemplate = function (practiceId, template) {
                var request = {
                    EncounterTemplate: template,
                    CorrelationIds: []
                };
                return this.httpService.post(this.getUrl(practiceId) +
                    'encountertemplates/' +
                    template.TemplateId, request);
            };
            Service.prototype.removeTemplate = function (practiceId, templateId) {
                return this.httpService.remove(this.getUrl(practiceId) + 'encountertemplates/' + templateId);
            };
            Service.prototype.removeTemplatesByType = function (practiceId, type) {
                return this.httpService.remove(this.getUrl(practiceId) + 'encountertemplates/' + type);
            };
            Service.prototype.removeTemplates = function (practiceId) {
                return this.httpService.remove(this.getUrl(practiceId) + 'encountertemplates/bulkdelete');
            };
            Service.prototype.getPathologyReports = function (practiceId, searchText) {
                return this.httpService.get(this.getUrl(practiceId) + "pathologyreports/" + searchText);
            };
            Service.prototype.getPathologyReportWorkflows = function (practiceId, startDate, endDate, statusType) {
                var query = this.getUrl(practiceId) + "pathologyreportworkflows";
                if (this.isValidMoment(startDate) && this.isValidMoment(endDate)) {
                    query += "/fromdate/" + startDate.format('YYYY-MM-DD') + "/todate/" + endDate.format('YYYY-MM-DD');
                }
                if (!angular.isUndefined(statusType)) {
                    query += "/status/" + ReportStatusTypeUtil.getName(statusType);
                }
                return this.httpService.get(query);
            };
            Service.prototype.getPathologyReportWorkflowsForProvider = function (practiceId, providerId) {
                var query = this.getUrl(practiceId) + "pathologyreportworkflows/linkedpatients";
                return this.httpService.get(query);
            };
            Service.prototype.getUndeliveredPathResults = function (practiceId) {
                var query = this.getUrl(practiceId) + "pathologyreports/status/undelivered";
                return this.httpService.get(query);
            };
            Service.prototype.getPathologyReportPatient = function (practiceId, reportId) {
                return this.httpService.get("v1/" + practiceId + "/clinical/pathologyreports/" + reportId + "/patient");
            };
            Service.prototype.markPathologyReportsAsRead = function (practiceId, workflowIds) {
                return this.httpService
                    .post("v1/" + practiceId + "/clinical/pathologyreportworkflows/", JSON.stringify(workflowIds));
            };
            Service.prototype.getPathologyReportWorkflowsCount = function (practiceId) {
                var status = ReportStatusTypeUtil.getName(ReportStatusType.OPEN);
                var query = this.getUrl(practiceId) + "pathologyreportworkflows/status/" + status + "/count";
                return this.httpService.get(query);
            };
            Service.prototype.mergeReferralItemsByTemplate = function (practiceId, templateId) {
                return this.httpService.post(this.getUrl(practiceId) +
                    'encountertemplates/' +
                    templateId +
                    '/mergelineitems');
            };
            Service.prototype.comunnicationByEncounter = function (practiceId, encounterId, communicationId) {
                return this.httpService.post(this.getUrl(practiceId) +
                    'encounters/' +
                    encounterId +
                    '/communications/' +
                    communicationId);
            };
            Service.prototype.comunnicationByIndex = function (practiceId, encounterId, communicationId, indexId) {
                return this.httpService.post(this.getUrl(practiceId) +
                    'encounters/' +
                    encounterId +
                    '/communications/' +
                    communicationId +
                    '/' +
                    indexId);
            };
            Service.prototype.getEncounterReferrals = function (practiceId, encounterTemplateId) {
                return this.httpService.get(this.getUrl(practiceId) +
                    'encountertemplates/' +
                    encounterTemplateId +
                    '/referrals');
            };
            Service.prototype.refreshEncounter = function (practiceId, encounterType, encounter) {
                var body = {
                    EncounterType: encounterType,
                    Encounter: encounter
                };
                return this.httpService.post(this.getUrl(practiceId) + 'encounters/' + encounter.EncounterId + '/refresh', body);
            };
            Service.prototype.updateEncounterCommunicationBody = function (practiceId, encounterId, communicationId, templateBody, subject) {
                var body = {
                    PracticeId: practiceId,
                    EncounterId: encounterId,
                    CommunicationId: communicationId,
                    Content: templateBody,
                    Title: subject
                };
                return this.httpService.post(this.getUrl(practiceId) +
                    'encounters/' +
                    encounterId +
                    '/communications/' +
                    communicationId +
                    '/0', body);
            };
            Service.prototype.deliverPathResult = function (practiceId, pathologyReportId) {
                var body = {
                    PracticeId: practiceId,
                    PathologyReportId: pathologyReportId,
                };
                return this.httpService.post("v1/" + practiceId + "/clinical/pathologyreports/" + pathologyReportId + "/redeliver", body);
            };
            Service.prototype.ignorePathResult = function (practiceId, pathologyReportId) {
                var body = {
                    PracticeId: practiceId,
                    PathologyReportId: pathologyReportId,
                };
                return this.httpService.post("v1/" + practiceId + "/clinical/pathologyreports/" + pathologyReportId + "/ignore", body);
            };
            Service.prototype.renderEncounterCommunication = function (practiceId, encounterId, templateId, encounter) {
                return this.httpService.post(this.getUrl(practiceId) +
                    'encounters/' +
                    encounterId +
                    '/communications/' +
                    templateId, encounter);
            };
            Service.prototype.getEncounterCommunicationBody = function (practiceId, encounterId, templateId) {
                return this.httpService.get(this.getUrl(practiceId) +
                    'encounters/' +
                    encounterId +
                    '/communications/' +
                    templateId +
                    '/0');
            };
            Service.prototype.getModifierInfo = function (practiceId, code) {
                return this.httpService.get(this.getUrl(practiceId) + 'modifiers/' + code + '/info', null, true);
            };
            Service.prototype.getModifierRequiredInfo = function (practiceId, code) {
                return this.httpService.get(this.getUrl(practiceId) + 'modifiers/' + code + '/requiredinfo', null, true);
            };
            Service.prototype.inviteDoctor = function (practiceId, body) {
                return this.httpService.post(this.getUrl(practiceId) + 'referrals/invite', body);
            };
            Service.prototype.getProviderById = function (practiceId) {
                return this.httpService.get('v1/clinical/provider/' + practiceId);
            };
            Service.prototype.getProviders = function () {
                return this.httpService.get('v1/clinical/providers');
            };
            Service.prototype.isValidMoment = function (date) {
                return this.moment.isMoment(date) && date.isValid();
            };
            Service.prototype.getUrl = function (practiceId) {
                return 'v1/' + practiceId + '/clinical/';
            };
            Service.prototype.getCacheTime = function () {
            };
            Service.DATE_PATTERN = "YYYY-MM-DD";
            return Service;
        })();
        Clinical.Service = Service;
        var WrapperVo = (function () {
            function WrapperVo(encounter, correlation) {
                this.EncounterVo = encounter;
                this.CorrelationIds = correlation;
            }
            return WrapperVo;
        })();
        Clinical.WrapperVo = WrapperVo;
        var RequestMergeEncounter = (function () {
            function RequestMergeEncounter() {
                this.OriginalInstruction = new Encounter();
                this.NewInstruction = new Template();
                this.CorrelationIds = [];
            }
            return RequestMergeEncounter;
        })();
        Clinical.RequestMergeEncounter = RequestMergeEncounter;
        var RequestMergeTemplate = (function () {
            function RequestMergeTemplate() {
                this.OriginalInstruction = new Template();
                this.NewInstruction = new Template();
                this.CorrelationIds = [];
            }
            return RequestMergeTemplate;
        })();
        Clinical.RequestMergeTemplate = RequestMergeTemplate;
        var AccountInfo = (function () {
            function AccountInfo() {
            }
            return AccountInfo;
        })();
        Clinical.AccountInfo = AccountInfo;
    })(Clinical = Domain.Clinical || (Domain.Clinical = {}));
})(Domain || (Domain = {}));
angular.module('DoctorApp')
    .service('clinicalDomain', Domain.Clinical.Service);
var EventType;
(function (EventType) {
    EventType[EventType["DIAGNOSIS"] = 0] = "DIAGNOSIS";
    EventType[EventType["PROCEDURE"] = 1] = "PROCEDURE";
    EventType[EventType["MEDICINE"] = 2] = "MEDICINE";
    EventType[EventType["CONSUMABLE"] = 3] = "CONSUMABLE";
    EventType[EventType["PRESCRIPTION"] = 4] = "PRESCRIPTION";
    EventType[EventType["FOLLOWUP"] = 5] = "FOLLOWUP";
    EventType[EventType["CLINICAL_NOTE"] = 6] = "CLINICAL_NOTE";
    EventType[EventType["COMMUNICATION"] = 7] = "COMMUNICATION";
    EventType[EventType["MEDICAL_INSURANCE_PROCEDURE"] = 8] = "MEDICAL_INSURANCE_PROCEDURE";
    EventType[EventType["CLINICAL_METRIC"] = 9] = "CLINICAL_METRIC";
    EventType[EventType["MODIFIER"] = 10] = "MODIFIER";
    EventType[EventType["PROVIDER_NOTE"] = 11] = "PROVIDER_NOTE";
})(EventType || (EventType = {}));
var EventTypeUtil = (function () {
    function EventTypeUtil() {
    }
    EventTypeUtil.getTypeById = function (id) {
        switch (id) {
            case 0:
                return EventType.DIAGNOSIS;
            case 1:
                return EventType.PROCEDURE;
            case 2:
                return EventType.MEDICINE;
            case 3:
                return EventType.CONSUMABLE;
            case 4:
                return EventType.PRESCRIPTION;
            case 5:
                return EventType.FOLLOWUP;
            case 6:
                return EventType.CLINICAL_NOTE;
            case 7:
                return EventType.COMMUNICATION;
            case 8:
                return EventType.MEDICAL_INSURANCE_PROCEDURE;
            case 9:
                return EventType.CLINICAL_METRIC;
            case 10:
                return EventType.MODIFIER;
            case 11:
                return EventType.PROVIDER_NOTE;
            default:
                throw new Error('EventType not found.id=[' + id + ']');
        }
    };
    EventTypeUtil.getTypeByName = function (name) {
        switch (name) {
            case 'Diagnosis':
                return EventType.DIAGNOSIS;
            case 'Procedure':
                return EventType.PROCEDURE;
            case 'MedicalInsuranceProcedure':
                return EventType.MEDICAL_INSURANCE_PROCEDURE;
            case 'Medicine':
                return EventType.MEDICINE;
            case 'Consumable':
                return EventType.CONSUMABLE;
            case 'Prescription':
                return EventType.PRESCRIPTION;
            case 'FollowUp':
                return EventType.FOLLOWUP;
            case 'ClinicalNote':
                return EventType.CLINICAL_NOTE;
            case 'Communication':
                return EventType.COMMUNICATION;
            case 'ClinicalMetric':
                return EventType.CLINICAL_METRIC;
            case 'Modifier':
                return EventType.MODIFIER;
            case 'ProviderNote':
                return EventType.PROVIDER_NOTE;
            default:
                throw new Error('EventType not found.id=[' + name + ']');
        }
    };
    EventTypeUtil.getNameByType = function (type) {
        switch (type) {
            case EventType.DIAGNOSIS:
                return 'Diagnosis';
            case EventType.PROCEDURE:
                return 'Procedure';
            case EventType.MEDICAL_INSURANCE_PROCEDURE:
                return 'MedicalInsuranceProcedure';
            case EventType.MEDICINE:
                return 'Medicine';
            case EventType.CONSUMABLE:
                return 'Consumable';
            case EventType.PRESCRIPTION:
                return 'Prescription';
            case EventType.COMMUNICATION:
                return 'Communication';
            case EventType.CLINICAL_METRIC:
                return 'ClinicalMetric';
            case EventType.MODIFIER:
                return 'Modifier';
            case EventType.PROVIDER_NOTE:
                return 'ProviderNote';
            default:
                throw new Error('EventType not found.EventType=[' + type + ']');
        }
    };
    return EventTypeUtil;
})();
/// <reference path="../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="api/domain/billing.ts" />
var ProviderModule;
(function (ProviderModule) {
    var Options = (function () {
        function Options() {
        }
        return Options;
    })();
    ProviderModule.Options = Options;
    var Service = (function () {
        Service.$inject = ["billingDomain"];
        function Service(billingDomain) {
            "ngInject";
            this.billingDomain = billingDomain;
        }
        Service.prototype.getProviderOptions = function (practiceId) {
            var _this = this;
            return this.billingDomain.getProvider(practiceId)
                .then(function (provider) {
                if (provider) {
                    return _this.buildProviderOptions(provider);
                }
                return new Options();
            });
        };
        Service.prototype.getProvider = function (practiceId) {
            return this.billingDomain.getProvider(practiceId)
                .then(function (provider) {
                if (provider) {
                    return provider;
                }
                return null;
            });
        };
        Service.prototype.saveProviderOption = function (practiceId, key, value) {
            var option = new Options();
            option[key] = value;
            return this.billingDomain.setProviderOption(practiceId, option);
        };
        Service.prototype.buildProviderOptions = function (provider) {
            var options = provider.Options;
            if (!options) {
                options = {};
            }
            var providerOptions = new Options();
            providerOptions.isEnabledForClinicalResults = true;
            providerOptions.isEnabledForClinicalPatientVisitOutcome = Common
                .parseBoolean(options.IsEnabledForClinicalPatientVisitOutcome);
            providerOptions.isEnabledForMedicalCertificates = Common
                .parseBoolean(options.IsEnabledForMedicalCertificates);
            providerOptions.isDisabledForDisplayingPatientFinancialInformation = Common
                .parseBoolean(options.IsDisabledForDisplayingPatientFinancialInformation);
            providerOptions.isEnabledForMedicationPrescriptions = Common
                .parseBoolean(options.IsEnabledForMedicationPrescriptions);
            providerOptions.isEnabledForDisplayingPrices = Common.parseBoolean(options.IsEnabledForDisplayingPrices) &&
                !((provider.PracticeXRef || '').startsWith("iHealth"));
            providerOptions.isDispensing = provider.DispensingDoctor === 'Yes';
            providerOptions.healthIDProviderCredentials = options.HealthIDProviderCredentials;
            providerOptions.consultationCustomLayoutOrder = options.ConsultationCustomLayoutOrder;
            providerOptions.displayPatientTimeLine = Common.parseBoolean(options.DisplayPatientTimeLine);
            providerOptions.healthDocEnabled = Common.parseBoolean(options.HealthDocEnabled);
            providerOptions.isPowerBIEnabled = Common.parseBoolean(options.IsPowerBIEnabled);
            providerOptions.isHealthbridgeClinicalEnabled = Common.parseBoolean(options.IsHealthbridgeClinicalEnabled) || Common.parseBoolean(options.IsHealthbridgeClinicalLiteEnabled);
            providerOptions.isDrAppAccessAllowed = Common.parseBoolean(options.IsDrAppAccessAllowed);
            providerOptions.HomePage = options.HomePage;
            providerOptions.myPatientFilesEnabled = Common.parseBoolean(options.MyPatienFilesEnabled);
            providerOptions.lastSeenImportantNotice = options.LastSeenImportantNotice;
            return providerOptions;
        };
        return Service;
    })();
    ProviderModule.Service = Service;
})(ProviderModule || (ProviderModule = {}));
angular.module('DoctorApp')
    .service('providerService', ProviderModule.Service);
var SearchModule;
(function (SearchModule) {
    (function (SearchType) {
        SearchType[SearchType["DIAGNOSIS"] = 0] = "DIAGNOSIS";
        SearchType[SearchType["PROCEDURE"] = 1] = "PROCEDURE";
        SearchType[SearchType["MEDICINE"] = 2] = "MEDICINE";
        SearchType[SearchType["CONSUMABLE"] = 3] = "CONSUMABLE";
        SearchType[SearchType["PRESCRIPTION"] = 4] = "PRESCRIPTION";
        SearchType[SearchType["MIPROCEDURE"] = 5] = "MIPROCEDURE";
    })(SearchModule.SearchType || (SearchModule.SearchType = {}));
    var SearchType = SearchModule.SearchType;
    var SearchTypeUtil = (function () {
        function SearchTypeUtil() {
        }
        SearchTypeUtil.getName = function (searchType) {
            return this.NAMES[searchType];
        };
        SearchTypeUtil.getType = function (searchType) {
            return this.TYPES[searchType];
        };
        SearchTypeUtil.NAMES = [
            'diagnosis',
            'procedure',
            'medicine',
            'consumable',
            'prescription',
            'miprocedure'
        ];
        SearchTypeUtil.TYPES = [
            'AdhocDiagnosis',
            'AdhocProcedure',
            'AdhocMedicine',
            'AdhocConsumable',
            'AdhocPrescription',
            'AdhocMedicalInsuranceProcedure'
        ];
        return SearchTypeUtil;
    })();
    SearchModule.SearchTypeUtil = SearchTypeUtil;
})(SearchModule || (SearchModule = {}));
var TrackingModule;
(function (TrackingModule) {
    var User = (function () {
        function User(options) {
            this.PracticeId = options.PracticeId;
            this.UserName = options.UserName;
            this.ClientVersion = options.ClientVersion;
        }
        return User;
    })();
    TrackingModule.User = User;
    var LineItem = (function (_super) {
        __extends(LineItem, _super);
        function LineItem(options) {
            _super.call(this, options);
            this.EncounterId = options.EncounterId;
            this.ItemCode = options.ItemCode;
        }
        return LineItem;
    })(User);
    TrackingModule.LineItem = LineItem;
    var PatientBase = (function () {
        function PatientBase(options) {
            this.PatientId = options.PatientId;
        }
        return PatientBase;
    })();
    TrackingModule.PatientBase = PatientBase;
    var Patient = (function (_super) {
        __extends(Patient, _super);
        function Patient(options) {
            _super.call(this, options);
            this.PatientId = options.PatientId;
        }
        return Patient;
    })(User);
    TrackingModule.Patient = Patient;
    var PatientEvent = (function (_super) {
        __extends(PatientEvent, _super);
        function PatientEvent(options) {
            _super.call(this, options);
            this.PatientEventId = options.PatientEventId;
            this.CheckInTime = options.CheckInTime;
        }
        return PatientEvent;
    })(Patient);
    TrackingModule.PatientEvent = PatientEvent;
    var PathReport = (function (_super) {
        __extends(PathReport, _super);
        function PathReport(options) {
            _super.call(this, options);
            this.ReportId = options.ReportId;
        }
        return PathReport;
    })(User);
    TrackingModule.PathReport = PathReport;
    var PathReportDashboard = (function (_super) {
        __extends(PathReportDashboard, _super);
        function PathReportDashboard(options) {
            _super.call(this, options);
            this.ReportId = options.ReportId;
            this.Date = options.Date;
        }
        return PathReportDashboard;
    })(Patient);
    TrackingModule.PathReportDashboard = PathReportDashboard;
    var DashboardLineItem = (function (_super) {
        __extends(DashboardLineItem, _super);
        function DashboardLineItem(options) {
            _super.call(this, options);
            this.PatientId = options.PatientId;
            this.Date = options.Date;
        }
        return DashboardLineItem;
    })(LineItem);
    TrackingModule.DashboardLineItem = DashboardLineItem;
    var MedicalCertificate = (function (_super) {
        __extends(MedicalCertificate, _super);
        function MedicalCertificate(options) {
            _super.call(this, options);
            this.EncounterId = options.EncounterId;
            this.Diagnoses = options.Diagnoses;
            this.Date = options.Date;
        }
        return MedicalCertificate;
    })(Patient);
    TrackingModule.MedicalCertificate = MedicalCertificate;
})(TrackingModule || (TrackingModule = {}));
/// <reference path="../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../services/api/domain/clinical.ts" />
/// <reference path="../screens/searches/search-type.ts" />
/// <reference path="../services/api/tracking-type.ts" />
var TrackingModule;
(function (TrackingModule) {
    var type = SearchModule.SearchType;
    var util = SearchModule.SearchTypeUtil;
    var Service = (function () {
        Service.$inject = ["storageService", "$location"];
        function Service(storageService, $location) {
            "ngInject";
            this.storageService = storageService;
            this.$location = $location;
            this.appInsights = window['appInsights'];
            angular.extend(this.appInsights.config, GlobalVar.applicationInsightOptions);
        }
        Service.prototype.itemAddedToEncounter = function (encounter, template) {
            this.templateEvent('addedToEncounter', encounter, template);
        };
        Service.prototype.logHbcRedirect = function () {
            this.trackEvent('hbc_redirect', {});
        };
        Service.prototype.removedLineItemFromEncounter = function (encounter, item, type) {
            this.trackLineItemEvent('removedFromEncounter', encounter, item, type);
        };
        Service.prototype.openedDetailsDialog = function (encounter, item, type) {
            this.trackLineItemEvent('openedDetailsDialog', encounter, item, type);
        };
        Service.prototype.openedPatientDetails = function (patient) {
            this.patientDetailsEvent('openedPatientDetails', patient);
        };
        Service.prototype.defineUser = function (userId) {
            this.appInsights.setAuthenticatedUserContext(userId);
        };
        Service.prototype.editedPatientDetails = function (patient) {
            this.patientDetailsEvent('editedPatientDetails', patient);
        };
        Service.prototype.openedPatientDashboard = function (patientEvent) {
            this.patientDashboardEvent('openedPatientDashboard', patientEvent);
        };
        Service.prototype.openedPathReportWorkflow = function (reportId) {
            this.pathReportEvent('openedPathReportWorkflow', reportId);
        };
        Service.prototype.openedPathReport = function (reportId) {
            this.pathReportEvent('openedPathReport', reportId);
        };
        Service.prototype.clickedOnPatientDashboardItem = function (patientId, date, encounter, item, type) {
            this.trackClickedOnPatientDashboardItem('clickedOnPatientDashboardItem', patientId, date, encounter, item, type);
        };
        Service.prototype.clickedOnPatientDashboardPathReport = function (patientId, reportId, date) {
            this.pathReportDashboardEvent("clickedOnPatientDashboardPathReport", patientId, reportId, date);
        };
        Service.prototype.clickedOnPatientDashboardMedicalCertificate = function (encounterId, patientId, description, date) {
            var diagnoses = this.parseMedicalCertificateDiagnosis(description);
            var data = new TrackingModule.MedicalCertificate({
                Date: date,
                EncounterId: encounterId,
                Diagnoses: diagnoses,
                PracticeId: this.getPracticeId(),
                PatientId: patientId,
                UserName: this.getUserName(),
                ClientVersion: GlobalVar.clientVersion
            });
            this.trackEvent("clickedOnPatientDashboardMedicalCertificate", data);
        };
        Service.prototype.editedNotes = function (eventName, encounter) {
            var data = {
                EncounterId: encounter.EncounterId,
                PracticeId: encounter.PatientEventDetails.PracticeId,
                UserName: this.getUserName()
            };
            this.trackEvent(eventName, data);
        };
        Service.prototype.onViewChanged = function () {
            var viewName = this.$location.path();
            var url = this.$location.absUrl();
            var practice = this.storageService.getPractice();
            var properties = {
                practiceId: practice.id,
                billingPracticeNumber: practice.billingPrNo,
                treatingPracticeNumber: practice.treatingPrNo,
                practiceName: practice.name,
                userName: this.getUserName(),
                clientVersion: GlobalVar.clientVersion
            };
            this.appInsights.trackPageView(viewName, url, properties);
        };
        Service.prototype.openedPatientTelehealthFromDashboard = function (patientEvent) {
            this.patientDashboardEvent('virtual-consult-open', patientEvent);
        };
        Service.prototype.patientDetailsEvent = function (eventName, patient) {
            var data = new TrackingModule.Patient({
                PracticeId: patient.PracticeId,
                PatientId: patient.PatientId,
                UserName: this.getUserName(),
                ClientVersion: GlobalVar.clientVersion
            });
            this.trackEvent(eventName, data);
        };
        Service.prototype.patientDashboardEvent = function (eventName, patientEvent) {
            var data = new TrackingModule.PatientEvent({
                PracticeId: patientEvent.PracticeId,
                PatientId: patientEvent.Patient.PatientId,
                UserName: this.getUserName(),
                PatientEventId: patientEvent.PatientEventId,
                CheckInTime: patientEvent.CheckInTime,
                ClientVersion: GlobalVar.clientVersion
            });
            this.trackEvent(eventName, data);
        };
        Service.prototype.pathReportDashboardEvent = function (eventName, patientId, reportId, date) {
            var data = new TrackingModule.PathReportDashboard({
                Date: date,
                UserName: this.getUserName(),
                ReportId: reportId,
                PracticeId: this.getPracticeId(),
                PatientId: patientId,
                ClientVersion: GlobalVar.clientVersion
            });
            this.trackEvent(eventName, data);
        };
        Service.prototype.pathReportEvent = function (eventName, reportId) {
            var data = new TrackingModule.PathReport({
                UserName: this.getUserName(),
                ReportId: reportId,
                PracticeId: this.getPracticeId(),
                ClientVersion: GlobalVar.clientVersion
            });
            this.trackEvent(eventName, data);
        };
        Service.prototype.trackLineItemEvent = function (eventName, encounter, item, type) {
            var practiceId = '';
            var encounterId = '';
            if (encounter) {
                encounterId = encounter.EncounterId;
                if (encounter.PatientEventDetails) {
                    practiceId = encounter.PatientEventDetails.PracticeId;
                }
            }
            var data = new TrackingModule.LineItem({
                PracticeId: practiceId,
                UserName: this.getUserName(),
                EncounterId: encounterId,
                ItemCode: "",
                ClientVersion: GlobalVar.clientVersion
            });
            this.lineItemEvent(eventName, data, item, type);
        };
        Service.prototype.trackClickedOnPatientDashboardItem = function (eventName, patientId, date, encounter, item, type) {
            var data = new TrackingModule.DashboardLineItem({
                Date: date,
                PatientId: patientId,
                PracticeId: encounter.PatientEventDetails.PracticeId,
                UserName: this.getUserName(),
                EncounterId: encounter.EncounterId,
                ItemCode: "",
                ClientVersion: GlobalVar.clientVersion
            });
            this.lineItemEvent(eventName, data, item, type);
        };
        Service.prototype.lineItemEvent = function (eventName, data, item, type) {
            switch (type) {
                case EventType.PROCEDURE:
                    this.trackItem(eventName + 'Procedure', data, item.ChargeCode);
                    break;
                case EventType.MEDICINE:
                    this.trackItem(eventName + 'Medicine', data, item.NappiCode);
                    break;
                case EventType.CONSUMABLE:
                    this.trackItem(eventName + 'Consumable', data, item.NappiCode);
                    break;
                case EventType.PRESCRIPTION:
                    this.trackItem(eventName + 'Prescription', data, item.NappiCode);
                    break;
                case EventType.DIAGNOSIS:
                    this.trackItem(eventName + 'Diagnosis', data, item.DiagnosisCode);
                    break;
            }
        };
        Service.prototype.templateEvent = function (eventName, encounter, template) {
            var data = new TrackingModule.LineItem({
                PracticeId: encounter.PatientEventDetails.PracticeId,
                UserName: this.getUserName(),
                EncounterId: encounter.EncounterId,
                ItemCode: "",
                ClientVersion: GlobalVar.clientVersion
            });
            switch (template.TemplateType) {
                case util.getType(type.PROCEDURE):
                    this.trackItem(eventName + 'Procedure', data, template.EncounterLineItems.LineItems[0].ChargeCode);
                    break;
                case util.getType(type.MEDICINE):
                    this.trackItem(eventName + 'Medicine', data, template.EncounterLineItems.LineItems[0].NappiCode);
                    break;
                case util.getType(type.CONSUMABLE):
                    this.trackItem(eventName + 'Consumable', data, template.EncounterLineItems.LineItems[0].NappiCode);
                    break;
                case util.getType(type.PRESCRIPTION):
                    this.trackItem(eventName + 'Prescription', data, template.MedicationPrescriptionLines[0].NappiCode);
                    break;
                case util.getType(type.DIAGNOSIS):
                    this.trackItem(eventName + 'Diagnosis', data, template.EncounterLineItems.EncounterHeader.Diagnosis[0].DiagnosisCode);
                    break;
            }
        };
        Service.prototype.parseMedicalCertificateDiagnosis = function (description) {
            var diagnosis = description.replace(/\s+/g, "").replace("MedicalCertificate:", "");
            return diagnosis;
        };
        Service.prototype.trackEvent = function (eventName, data) {
            var practice = this.storageService.getPractice();
            data.BillingPracticeNumber = practice.billingPrNo;
            data.TreatingPracticeNumber = practice.treatingPrNo;
            this.appInsights.trackEvent(eventName, data);
        };
        Service.prototype.trackItem = function (eventName, data, code) {
            data.ItemCode = code;
            this.trackEvent(eventName, data);
        };
        Service.prototype.getUserName = function () {
            return this.storageService.getUser().name;
        };
        Service.prototype.getPracticeId = function () {
            return this.storageService.getPracticeId();
        };
        return Service;
    })();
    TrackingModule.Service = Service;
})(TrackingModule || (TrackingModule = {}));
angular.module('DoctorApp')
    .service('trackingService', TrackingModule.Service);
/// <reference path="../../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../../../scripts/definition/angular-bootstrap/angular-ui-bootstrap.d.ts" />
/// <reference path="../../../services/api/event-type.ts" />
var ModalModule;
(function (ModalModule) {
    (function (ModalHeight) {
        ModalHeight[ModalHeight["_300px"] = 0] = "_300px";
        ModalHeight[ModalHeight["_400px"] = 1] = "_400px";
        ModalHeight[ModalHeight["_430px"] = 2] = "_430px";
        ModalHeight[ModalHeight["_500px"] = 3] = "_500px";
        ModalHeight[ModalHeight["_600px"] = 4] = "_600px";
        ModalHeight[ModalHeight["_700px"] = 5] = "_700px";
        ModalHeight[ModalHeight["_800px"] = 6] = "_800px";
    })(ModalModule.ModalHeight || (ModalModule.ModalHeight = {}));
    var ModalHeight = ModalModule.ModalHeight;
    (function (ModalWidth) {
        ModalWidth[ModalWidth["_100px"] = 0] = "_100px";
        ModalWidth[ModalWidth["_125px"] = 1] = "_125px";
        ModalWidth[ModalWidth["_150px"] = 2] = "_150px";
        ModalWidth[ModalWidth["_175px"] = 3] = "_175px";
        ModalWidth[ModalWidth["_200px"] = 4] = "_200px";
        ModalWidth[ModalWidth["_225px"] = 5] = "_225px";
        ModalWidth[ModalWidth["_250px"] = 6] = "_250px";
        ModalWidth[ModalWidth["_275px"] = 7] = "_275px";
        ModalWidth[ModalWidth["_300px"] = 8] = "_300px";
        ModalWidth[ModalWidth["_325px"] = 9] = "_325px";
        ModalWidth[ModalWidth["_350px"] = 10] = "_350px";
        ModalWidth[ModalWidth["_375px"] = 11] = "_375px";
        ModalWidth[ModalWidth["_400px"] = 12] = "_400px";
        ModalWidth[ModalWidth["_425px"] = 13] = "_425px";
        ModalWidth[ModalWidth["_450px"] = 14] = "_450px";
        ModalWidth[ModalWidth["_475px"] = 15] = "_475px";
        ModalWidth[ModalWidth["_500px"] = 16] = "_500px";
        ModalWidth[ModalWidth["_525px"] = 17] = "_525px";
        ModalWidth[ModalWidth["_550px"] = 18] = "_550px";
        ModalWidth[ModalWidth["_575px"] = 19] = "_575px";
        ModalWidth[ModalWidth["_600px"] = 20] = "_600px";
        ModalWidth[ModalWidth["_625px"] = 21] = "_625px";
        ModalWidth[ModalWidth["_650px"] = 22] = "_650px";
        ModalWidth[ModalWidth["_675px"] = 23] = "_675px";
        ModalWidth[ModalWidth["_700px"] = 24] = "_700px";
        ModalWidth[ModalWidth["_725px"] = 25] = "_725px";
        ModalWidth[ModalWidth["_750px"] = 26] = "_750px";
        ModalWidth[ModalWidth["_775px"] = 27] = "_775px";
        ModalWidth[ModalWidth["_800px"] = 28] = "_800px";
        ModalWidth[ModalWidth["_825px"] = 29] = "_825px";
        ModalWidth[ModalWidth["_850px"] = 30] = "_850px";
        ModalWidth[ModalWidth["_875px"] = 31] = "_875px";
        ModalWidth[ModalWidth["_900px"] = 32] = "_900px";
        ModalWidth[ModalWidth["_925px"] = 33] = "_925px";
        ModalWidth[ModalWidth["_950px"] = 34] = "_950px";
        ModalWidth[ModalWidth["_975px"] = 35] = "_975px";
        ModalWidth[ModalWidth["_1000px"] = 36] = "_1000px";
        ModalWidth[ModalWidth["_1025px"] = 37] = "_1025px";
        ModalWidth[ModalWidth["_1050px"] = 38] = "_1050px";
        ModalWidth[ModalWidth["_1075px"] = 39] = "_1075px";
        ModalWidth[ModalWidth["_1100px"] = 40] = "_1100px";
        ModalWidth[ModalWidth["_1125px"] = 41] = "_1125px";
        ModalWidth[ModalWidth["_1150px"] = 42] = "_1150px";
        ModalWidth[ModalWidth["_1175px"] = 43] = "_1175px";
        ModalWidth[ModalWidth["_1200px"] = 44] = "_1200px";
    })(ModalModule.ModalWidth || (ModalModule.ModalWidth = {}));
    var ModalWidth = ModalModule.ModalWidth;
    var Controller = (function () {
        function Controller(model, config) {
            this.model = model;
            this.config = config;
        }
        return Controller;
    })();
    ModalModule.Controller = Controller;
    var Config = (function () {
        function Config(title, url, pdf) {
            this.title = title;
            this.url = url;
            this.pdf = pdf;
        }
        return Config;
    })();
    ModalModule.Config = Config;
    var Service = (function () {
        Service.$inject = ["$modal", "$templateCache"];
        function Service($modal, $templateCache) {
            "ngInject";
            this.$modal = $modal;
            this.$templateCache = $templateCache;
            this.cacheParam = "?ver=@@clientVersion";
        }
        Service.prototype.warning = function (message, width) {
            var templateUrl = "screens/components/modal/dialog/warning-dialog.html" + this.cacheParam;
            var instruction = {
                size: "sm",
                backdrop: "static",
                templateUrl: templateUrl,
                controller: "ModalController",
                resolve: {
                    model: function () {
                        return {
                            message: message
                        };
                    }
                }
            };
            if (width) {
                delete instruction.size;
                instruction.windowClass = ModalView.getModalWidthClass(width);
            }
            var modalInstance = this.$modal.open(instruction);
            return modalInstance.result;
        };
        Service.prototype.confirm = function (message, width, hasClose, labels) {
            var templateUrl = "screens/components/modal/dialog/confirm-dialog.html" + this.cacheParam;
            var instruction = {
                size: "sm",
                backdrop: "static",
                templateUrl: templateUrl,
                controller: "ModalController",
                resolve: {
                    model: function () {
                        return {
                            message: message,
                            labels: labels,
                            hasClose: hasClose
                        };
                    }
                }
            };
            if (width) {
                delete instruction.size;
                instruction.windowClass = ModalView.getModalWidthClass(width);
            }
            var modalInstance = this.$modal.open(instruction);
            return modalInstance.result;
        };
        Service.prototype.leaveEncounterConfirm = function () {
            var templateUrl = 'screens/consultation/modal/dialog/leave-confirmation.html' + this.cacheParam;
            var instruction = {
                backdrop: 'static',
                windowClass: ModalView.getModalWidthClass(ModalWidth._450px),
                templateUrl: templateUrl,
                controller: 'ModalController',
                resolve: {
                    model: function () { }
                }
            };
            var modalInstance = this.$modal.open(instruction);
            return modalInstance.result;
        };
        Service.prototype.info = function (message, width) {
            var templateUrl = 'screens/components/modal/dialog/info-dialog.html' + this.cacheParam;
            var instruction = {
                backdrop: "static",
                size: "sm",
                templateUrl: templateUrl,
                controller: "ModalController",
                resolve: {
                    model: function () {
                        return {
                            message: message
                        };
                    }
                }
            };
            if (width) {
                delete instruction.size;
                instruction.windowClass = ModalView.getModalWidthClass(width);
            }
            var modalInstance = this.$modal.open(instruction);
            return modalInstance.result;
        };
        Service.prototype.error = function (message, width) {
            var template = '<div class="modal-header middle-child"><h3 class="modal-title">Note</h3></div><div id="modal-body" class="modal-body"><p class="fontdarkgrey" style="white-space: pre-line;">{{model.message}}</p></div><div class="modal-footer"> <button class="btn" type="button" ng-click="ok()">OK</button></div>';
            var instruction = {
                backdrop: "static",
                size: "sm",
                template: template,
                controller: "ModalController",
                resolve: {
                    model: function () {
                        return {
                            message: message
                        };
                    }
                }
            };
            if (width) {
                delete instruction.size;
                instruction.windowClass = ModalView.getModalWidthClass(width);
            }
            var modalInstance = this.$modal.open(instruction);
            return modalInstance.result;
        };
        Service.prototype.cellPhone = function () {
            var templateUrl = "screens/components/modal/dialog/cell-phone.html" + this.cacheParam;
            var instruction = {
                backdrop: "static",
                windowClass: "cellphone-modal-window",
                templateUrl: templateUrl,
                controller: "CellPhoneController",
                resolve: {
                    model: function () {
                        return {};
                    }
                }
            };
            var modalInstance = this.$modal.open(instruction);
            return modalInstance.result;
        };
        Service.prototype.openNumbers = function (type, title, config, number, useZerro) {
            var templateUrl = "screens/components/modal/dialog/numbers.html" + this.cacheParam;
            var instruction = {
                backdrop: "static",
                windowClass: "numbers-modal-window",
                templateUrl: templateUrl,
                controller: "NumbersController",
                resolve: {
                    controller: function () {
                        var model = { type: type, title: title, useZerro: useZerro };
                        if (number) {
                            angular.extend(model, { number: number });
                        }
                        return model;
                    }
                }
            };
            if (config) {
                angular.extend({}, instruction, config);
            }
            var modalInstance = this.$modal.open(instruction);
            return modalInstance.result;
        };
        Service.prototype.openDetailsItem = function (model, type, validateOptions, settings) {
            var config = this.getConfigForEventType(type);
            config.validateOptions = validateOptions;
            return this.openDetails(model, config, settings);
        };
        Service.prototype.openPrescriptionHistory = function (model) {
            var templateUrl = "screens/consultation/modal/dialog/prescription-history.html" + this.cacheParam;
            var config = new Config("Previously Prescribed", templateUrl);
            return this.openDetails(model, config);
        };
        Service.prototype.openSupportingProvider = function (model, provider, type) {
            var templateUrl = "screens/consultation/modal/dialog/supporting-provider.html" + this.cacheParam;
            var instruction = {
                backdrop: "static",
                windowClass: ModalView.getModalWidthClass(ModalWidth._600px),
                templateUrl: templateUrl,
                controller: "SupportingProviderController",
                resolve: {
                    model: function () {
                        return {
                            providers: model,
                            provider: provider,
                            type: type
                        };
                    }
                }
            };
            var modalInstance = this.$modal.open(instruction);
            return modalInstance.result;
        };
        Service.prototype.openSpecificRuleWarn = function (message, refreshPrice, width) {
            var templateUrl = "screens/consultation/modal/dialog/specificrules-warning.html" + this.cacheParam;
            var instruction = {
                backdrop: "static",
                size: "sm",
                templateUrl: templateUrl,
                controller: "SpecificRuleWarningController",
                resolve: {
                    model: function () {
                        return {
                            message: message,
                            refreshPrice: refreshPrice
                        };
                    }
                }
            };
            if (width) {
                delete instruction.size;
                instruction.windowClass = ModalView.getModalWidthClass(width);
            }
            var modalInstance = this.$modal.open(instruction);
            return modalInstance.result;
        };
        Service.prototype.openSubTemplates = function (subGroup, setTemplate) {
            var templateUrl = "screens/components/modal/dialog/sub-templates.html" + this.cacheParam;
            var instruction = {
                backdrop: "static",
                windowClass: ModalView.getModalWidthClass(ModalWidth._800px),
                templateUrl: templateUrl,
                controller: "ModalController",
                resolve: {
                    model: function () {
                        return {
                            subgroup: subGroup,
                            setTemplate: setTemplate
                        };
                    }
                }
            };
            var modalInstance = this.$modal.open(instruction);
            return modalInstance.result;
        };
        Service.prototype.getReportPatients = function (patients, reportId) {
            var templateUrl = "screens/clinical-report/modal/dialog/report-patient.html" + this.cacheParam;
            var instruction = {
                backdrop: "static",
                windowClass: ModalView.getModalWidthClass(ModalWidth._600px),
                templateUrl: templateUrl,
                controller: "ReportPatientController",
                resolve: {
                    model: function () {
                        return {
                            patients: patients,
                            reportId: reportId
                        };
                    }
                }
            };
            var modalInstance = this.$modal.open(instruction);
            return modalInstance.result;
        };
        Service.prototype.openLetterEditor = function (communication, communicationTemplateBody) {
            var templateUrl = "screens/consultation/modal/dialog/letter-editor.html" + this.cacheParam;
            var instruction = {
                backdrop: "static",
                windowClass: ModalView.getModalWidthClass(ModalWidth._800px),
                templateUrl: templateUrl,
                controller: "LetterEditorController",
                resolve: {
                    model: function () {
                        return {
                            communication: communication,
                            templateBody: communicationTemplateBody
                        };
                    }
                }
            };
            var modalInstance = this.$modal.open(instruction);
            return modalInstance.result;
        };
        Service.prototype.openCommunicationTemplates = function (templates) {
            var templateUrl = "screens/consultation/modal/dialog/communication-templates.html" + this.cacheParam;
            var instruction = {
                backdrop: "static",
                windowClass: ModalView.getModalWidthClass(ModalWidth._700px),
                templateUrl: templateUrl,
                controller: "CommunicationTemplatesController",
                resolve: {
                    model: function () {
                        return {
                            templates: templates
                        };
                    }
                }
            };
            var modalInstance = this.$modal.open(instruction);
            return modalInstance.result;
        };
        Service.prototype.openLetterTemplates = function (templates) {
            var templateUrl = "screens/consultation/modal/dialog/letter-templates.html" + this.cacheParam;
            var instruction = {
                backdrop: "static",
                windowClass: ModalView.getModalWidthClass(ModalWidth._700px),
                templateUrl: templateUrl,
                controller: "RefferalTemplatesController",
                resolve: {
                    model: function () {
                        return {
                            templates: templates
                        };
                    }
                }
            };
            var modalInstance = this.$modal.open(instruction);
            return modalInstance.result;
        };
        Service.prototype.openAddressBookSearch = function () {
            var templateUrl = "screens/address-book/modal/dialog/address-book.html" + this.cacheParam;
            var instruction = {
                backdrop: "static",
                windowClass: ModalView.getModalWidthClass(ModalWidth._700px),
                templateUrl: templateUrl,
                controller: "ClinicalAddressBookSearchController"
            };
            var modalInstance = this.$modal.open(instruction);
            return modalInstance.result;
        };
        Service.prototype.showReportDialog = function (type, bodies, pdfFunction, patientId) {
            var wrapper = "screens/components/modal/dialog/reports.html";
            var config = this.getConfigUrlForReportType(type);
            var model = {
                type: type,
                templateBodies: bodies,
                pdfListener: pdfFunction,
                patientId: patientId
            };
            var instruction = {
                backdrop: "static",
                windowClass: ModalView.getModalWidthClass(ModalWidth._750px),
                templateUrl: wrapper,
                controller: "ModalInstanceController",
                resolve: {
                    controller: function () {
                        return new Controller(model, config);
                    }
                }
            };
            var modalInstance = this.$modal.open(instruction);
            return modalInstance.result;
        };
        Service.prototype.showCaptureHealthDocDialog = function (url, title) {
            var wrapper = "screens/components/modal/dialog/capture-healthdoc.html";
            var config = new Config(title, url);
            var model = {
                captureHealthDoc: true
            };
            var instruction = {
                backdrop: "static",
                windowClass: "responsive-modal " + ModalView.getModalHeightClass(ModalHeight._800px),
                templateUrl: wrapper,
                controller: "ModalInstanceController",
                resolve: {
                    controller: function () {
                        return new Controller(model, config);
                    }
                }
            };
            var modalInstance = this.$modal.open(instruction);
            return modalInstance.result;
        };
        Service.prototype.showReceiptDialog = function (title, body) {
            var wrapper = "screens/components/modal/dialog/reports.html";
            var template = "screens/components/modal/dialog/receipt-dialog.html";
            var model = {
                receipt: {
                    title: title,
                    body: body
                }
            };
            var instruction = {
                backdrop: "static",
                windowClass: ModalView.getModalWidthClass(ModalWidth._325px),
                templateUrl: wrapper,
                controller: "ModalInstanceController",
                resolve: {
                    controller: function () {
                        return new Controller(model, new Config("Receipt", template));
                    }
                }
            };
            var modalInstance = this.$modal.open(instruction);
            return modalInstance.result;
        };
        Service.prototype.showInviteDoctorDialog = function () {
            var templateUrl = "screens/user-account/modal/dialog/invite-doctor.html" + this.cacheParam;
            var instruction = {
                backdrop: "static",
                windowClass: ModalView.getModalWidthClass(ModalWidth._600px),
                templateUrl: templateUrl,
                controller: "InviteDoctorController",
                resolve: {
                    model: function () {
                        return {};
                    }
                }
            };
            var modalInstance = this.$modal.open(instruction);
            return modalInstance.result;
        };
        Service.prototype.showMedicalInsuranceDetails = function (encounter) {
            var templateUrl = "screens/consultation/modal/dialog/medical-insurance-details.html" + this.cacheParam;
            var instruction = {
                backdrop: "static",
                windowClass: ModalView.getModalWidthClass(ModalWidth._700px),
                templateUrl: templateUrl,
                controller: "MedicalInsuranceController",
                resolve: {
                    model: function () {
                        return {
                            encounter: encounter
                        };
                    }
                }
            };
            var modalInstance = this.$modal.open(instruction);
            return modalInstance.result;
        };
        Service.prototype.showConditionsDetails = function () {
            var templateUrl = "screens/patient-medical-history/modal/dialog/conditions.html" + this.cacheParam;
            var instruction = {
                backdrop: "static",
                windowClass: ModalView.getModalWidthClass(ModalWidth._750px),
                templateUrl: templateUrl,
                controller: "ConditionsController",
                resolve: {
                    model: function () {
                        return {};
                    }
                }
            };
            var modalInstance = this.$modal.open(instruction);
            return modalInstance.result;
        };
        Service.prototype.showNotification = function (notification) {
            var templateUrl = "screens/components/modal/dialog/notification.html" + this.cacheParam;
            var instruction = {
                backdrop: "true",
                windowClass: ModalView.getModalWidthClass(ModalWidth._650px),
                templateUrl: templateUrl,
                controller: "NotificationController",
                resolve: {
                    model: function () {
                        return {
                            notification: notification
                        };
                    }
                }
            };
            var modalInstance = this.$modal.open(instruction);
            return modalInstance.result;
        };
        Service.prototype.sendReportByEmail = function (patient, provider, attachments, emailSubject, showWarning) {
            if (showWarning === void 0) { showWarning = true; }
            var templateUrl = "screens/consultation/modal/dialog/email-report.html" + this.cacheParam;
            var instruction = {
                backdrop: "static",
                windowClass: ModalView.getModalWidthClass(ModalWidth._600px),
                templateUrl: templateUrl,
                controller: "EmailReportController",
                resolve: {
                    model: function () {
                        return {
                            patient: patient,
                            provider: provider,
                            showWarning: showWarning,
                            emailSubject: emailSubject,
                            attachments: attachments
                        };
                    }
                }
            };
            var modalInstance = this.$modal.open(instruction);
            return modalInstance.result;
        };
        Service.prototype.showSummaryOfCare = function () {
            var templateUrl = "screens/consultation/modal/dialog/summary-of-care.html" + this.cacheParam;
            var instruction = {
                backdrop: "static",
                windowClass: ModalView.getModalWidthClass(ModalWidth._800px),
                templateUrl: templateUrl,
                controller: "SummaryOFCareController",
                resolve: {
                    model: function () {
                        return {};
                    }
                }
            };
            var modalInstance = this.$modal.open(instruction);
            return modalInstance.result;
        };
        Service.prototype.showModifierDetails = function (encounter, modifier, assistingDoctor, noEdit) {
            var templateUrl = "screens/consultation/modifiers/modal/dialog/modifier-details.html" + this.cacheParam;
            var instruction = {
                backdrop: "static",
                windowClass: ModalView.getModalWidthClass(ModalWidth._800px),
                templateUrl: templateUrl,
                controller: "ModifierController",
                resolve: {
                    model: function () {
                        return {
                            encounter: encounter,
                            modifier: modifier,
                            assistingDoctor: assistingDoctor,
                            noEdit: noEdit
                        };
                    }
                }
            };
            var modalInstance = this.$modal.open(instruction);
            return modalInstance.result;
        };
        Service.prototype.getConfigUrlForReportType = function (type) {
            switch (type) {
                case EncounterModule.ReportType.All:
                    return new Config("Medical certificate and prescription reports");
                case EncounterModule.ReportType.Prescription:
                    return new Config("Prescription report");
                case EncounterModule.ReportType.MedicalCertificate:
                    return new Config("Medical certificate report");
                case EncounterModule.ReportType.Communication:
                    return new Config("Referral report");
            }
        };
        Service.prototype.getConfigForEventType = function (type) {
            var mainPath = "screens/consultation/modal/dialog/";
            switch (type) {
                case EventType.PROCEDURE:
                    return new Config("Procedure details", mainPath + "procedure-details.html" + this.cacheParam);
                case EventType.MEDICINE:
                    return new Config("Medicine details", mainPath + "medicine-details.html" + this.cacheParam);
                case EventType.CONSUMABLE:
                    return new Config("Consumable details", mainPath + "consumable-details.html" + this.cacheParam);
                case EventType.PRESCRIPTION:
                    return new Config("Prescription details", mainPath + "prescription-details.html" + this.cacheParam);
                default:
                    var name = EventTypeUtil.getNameByType(type);
                    throw new Error("For " + name + " type window not found");
            }
        };
        Service.prototype.openDetails = function (model, config, settings) {
            var wrapper = "screens/components/modal/dialog/details.html" + this.cacheParam;
            return this.openModalWindow(model, config, wrapper, settings);
        };
        Service.prototype.openDialog = function (dataObject, controller, config, settings) {
            var instruction = {
                backdrop: "static",
                size: "md",
                templateUrl: config.url,
                controller: controller,
                resolve: {
                    model: function () {
                        return dataObject;
                    }
                }
            };
            if (settings) {
                angular.extend({}, instruction, settings);
            }
            var modalInstance = this.$modal.open(instruction);
            return modalInstance.result;
        };
        Service.prototype.openModalWindow = function (model, config, wrapper, settings) {
            model = angular.copy(model);
            var instruction = {
                backdrop: "static",
                templateUrl: wrapper,
                controller: "ModalInstanceController",
                resolve: {
                    controller: function () {
                        return new Controller(model, config);
                    }
                }
            };
            if (settings) {
                instruction = angular.extend({}, instruction, settings);
            }
            var modalInstance = this.$modal.open(instruction);
            return modalInstance.result;
        };
        return Service;
    })();
    ModalModule.Service = Service;
    var ModalView = (function () {
        function ModalView() {
        }
        ModalView.getModalHeightClass = function (height) {
            var classHeight;
            switch (height) {
                case ModalHeight._300px:
                    classHeight = "custom-modal-body-height-300";
                    break;
                case ModalHeight._400px:
                    classHeight = "custom-modal-body-height-400";
                    break;
                case ModalHeight._430px:
                    classHeight = "custom-modal-body-height-430";
                    break;
                case ModalHeight._500px:
                    classHeight = "custom-modal-body-height-500";
                    break;
                case ModalHeight._600px:
                    classHeight = "custom-modal-body-height-600";
                    break;
                case ModalHeight._700px:
                    classHeight = "custom-modal-body-height-700";
                    break;
                case ModalHeight._800px:
                    classHeight = "custom-modal-body-height-800";
                    break;
            }
            return classHeight;
        };
        ModalView.getModalWidthClass = function (width) {
            var classWidth;
            switch (width) {
                case ModalWidth._100px:
                    classWidth = "custom-modal-width-100";
                    break;
                case ModalWidth._125px:
                    classWidth = "custom-modal-width-125";
                    break;
                case ModalWidth._150px:
                    classWidth = "custom-modal-width-150";
                    break;
                case ModalWidth._175px:
                    classWidth = "custom-modal-width-175";
                    break;
                case ModalWidth._200px:
                    classWidth = "custom-modal-width-200";
                    break;
                case ModalWidth._225px:
                    classWidth = "custom-modal-width-225";
                    break;
                case ModalWidth._250px:
                    classWidth = "custom-modal-width-250";
                    break;
                case ModalWidth._275px:
                    classWidth = "custom-modal-width-275";
                    break;
                case ModalWidth._300px:
                    classWidth = "custom-modal-width-300";
                    break;
                case ModalWidth._325px:
                    classWidth = "custom-modal-width-325";
                    break;
                case ModalWidth._350px:
                    classWidth = "custom-modal-width-350";
                    break;
                case ModalWidth._375px:
                    classWidth = "custom-modal-width-375";
                    break;
                case ModalWidth._400px:
                    classWidth = "custom-modal-width-400";
                    break;
                case ModalWidth._425px:
                    classWidth = "custom-modal-width-425";
                    break;
                case ModalWidth._450px:
                    classWidth = "custom-modal-width-450";
                    break;
                case ModalWidth._475px:
                    classWidth = "custom-modal-width-475";
                    break;
                case ModalWidth._500px:
                    classWidth = "custom-modal-width-500";
                    break;
                case ModalWidth._525px:
                    classWidth = "custom-modal-width-525";
                    break;
                case ModalWidth._550px:
                    classWidth = "custom-modal-width-550";
                    break;
                case ModalWidth._575px:
                    classWidth = "custom-modal-width-575";
                    break;
                case ModalWidth._600px:
                    classWidth = "custom-modal-width-600";
                    break;
                case ModalWidth._625px:
                    classWidth = "custom-modal-width-625";
                    break;
                case ModalWidth._650px:
                    classWidth = "custom-modal-width-650";
                    break;
                case ModalWidth._675px:
                    classWidth = "custom-modal-width-675";
                    break;
                case ModalWidth._700px:
                    classWidth = "custom-modal-width-700";
                    break;
                case ModalWidth._725px:
                    classWidth = "custom-modal-width-725";
                    break;
                case ModalWidth._750px:
                    classWidth = "custom-modal-width-750";
                    break;
                case ModalWidth._775px:
                    classWidth = "custom-modal-width-775";
                    break;
                case ModalWidth._800px:
                    classWidth = "custom-modal-width-800";
                    break;
                case ModalWidth._825px:
                    classWidth = "custom-modal-width-825";
                    break;
                case ModalWidth._850px:
                    classWidth = "custom-modal-width-850";
                    break;
                case ModalWidth._875px:
                    classWidth = "custom-modal-width-875";
                    break;
                case ModalWidth._900px:
                    classWidth = "custom-modal-width-900";
                    break;
                case ModalWidth._925px:
                    classWidth = "custom-modal-width-925";
                    break;
                case ModalWidth._950px:
                    classWidth = "custom-modal-width-950";
                    break;
                case ModalWidth._975px:
                    classWidth = "custom-modal-width-975";
                    break;
                case ModalWidth._1000px:
                    classWidth = "custom-modal-width-1000";
                    break;
                case ModalWidth._1025px:
                    classWidth = "custom-modal-width-1025";
                    break;
                case ModalWidth._1050px:
                    classWidth = "custom-modal-width-1050";
                    break;
                case ModalWidth._1075px:
                    classWidth = "custom-modal-width-1075";
                    break;
                case ModalWidth._1100px:
                    classWidth = "custom-modal-width-1100";
                    break;
                case ModalWidth._1125px:
                    classWidth = "custom-modal-width-1125";
                    break;
                case ModalWidth._1150px:
                    classWidth = "custom-modal-width-1150";
                    break;
                case ModalWidth._1175px:
                    classWidth = "custom-modal-width-1175";
                    break;
                case ModalWidth._1200px:
                    classWidth = "custom-modal-width-1200";
                    break;
            }
            return classWidth;
        };
        return ModalView;
    })();
    ModalModule.ModalView = ModalView;
})(ModalModule || (ModalModule = {}));
angular.module("DoctorApp")
    .service("modalService", ModalModule.Service);
/// <reference path="../../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../encounter/encounter-service.ts"/>
var ConsultationReportModule;
(function (ConsultationReportModule) {
    var ConsultationReport = (function () {
        function ConsultationReport(type, reportBody) {
            this.type = type;
            this.reportBody = reportBody;
        }
        return ConsultationReport;
    })();
    ConsultationReportModule.ConsultationReport = ConsultationReport;
    var Service = (function () {
        Service.$inject = ["encounterServiceNew", "modalService", "$q", "clinicalDomain", "locationService", "patientService", "billingDomain", "dashboardService", "$location", "$window"];
        function Service(encounterServiceNew, modalService, $q, clinicalDomain, locationService, patientService, billingDomain, dashboardService, $location, $window) {
            "ngInject";
            this.encounterServiceNew = encounterServiceNew;
            this.modalService = modalService;
            this.$q = $q;
            this.clinicalDomain = clinicalDomain;
            this.locationService = locationService;
            this.patientService = patientService;
            this.billingDomain = billingDomain;
            this.dashboardService = dashboardService;
            this.$location = $location;
            this.$window = $window;
        }
        Service.prototype.isNext = function (type) {
            var reports = this.encounterServiceNew.isAnyConsultationReport();
            return reports.length > 0 && reports.indexOf(type) < reports.length - 1;
        };
        Service.prototype.changeScreen = function (practiceId, patientId, way, currentReportType) {
            var encounter = this.encounterServiceNew.getEncounter();
            var reports = this.encounterServiceNew.isAnyConsultationReport();
            if (way === Service.NEXT) {
                if (reports.indexOf(currentReportType) + 1 < reports.length) {
                    this.locationService.goToConsultationReport(practiceId, patientId, reports[reports.indexOf(currentReportType) + 1]);
                }
                else {
                    this.encounterServiceNew.submitEncounter(practiceId, encounter);
                }
            }
            else if (way === Service.PREW) {
                this.$window.history.back();
            }
        };
        Service.prototype.getReportBody = function (type, practiceId) {
            var that = this;
            var encounter = this.encounterServiceNew.getEncounter();
            if (!encounter) {
                return this.$q.reject();
            }
            if (type === EncounterModule.ReportType.MedicalCertificate) {
                return this.clinicalDomain.getMedicacalSertificate(practiceId, encounter)
                    .then(function (response) {
                    return that.locationService.setAbsoluteServerUrl(response.Data);
                });
            }
            else if (type === EncounterModule.ReportType.Prescription) {
                return this.clinicalDomain.getPrescriptionReport(practiceId, encounter)
                    .then(function (response) {
                    return that.locationService.setAbsoluteServerUrl(response.Data);
                });
            }
            return this.$q.reject();
        };
        Service.prototype.sendReportByEmail = function (practiceId, patientId, attachment) {
            var _this = this;
            var that = this;
            this.$q.all([
                that.patientService.getPatientById(practiceId, patientId),
                that.billingDomain.getProvider(practiceId)
            ])
                .then(function (response) {
                var patient = response[0];
                var provider = response[1];
                _this.modalService.sendReportByEmail(patient, provider, attachment, "Documents from " + provider.PracticeName);
            });
        };
        Service.prototype.openPdf = function (practiceId, report) {
            var newWindow = this.$window.open('about:blank', "_blank");
            this.dashboardService.reportLinkFromHtmlToPdf(practiceId, report).then(function (link) {
                newWindow.location.href = link;
            });
        };
        Service.prototype.getReportStringType = function (reportType) {
            if (reportType === EncounterModule.ReportType.MedicalCertificate) {
                return "Medical Certificate";
            }
            if (reportType === EncounterModule.ReportType.Prescription) {
                return "Prescription";
            }
            return "";
        };
        Service.PREW = "prew";
        Service.NEXT = "next";
        return Service;
    })();
    ConsultationReportModule.Service = Service;
})(ConsultationReportModule || (ConsultationReportModule = {}));
angular.module("DoctorApp")
    .service("consultationReportService", ConsultationReportModule.Service);
/// <reference path="../../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../result-api.ts" />
var Domain;
(function (Domain) {
    var Tenant;
    (function (Tenant) {
        var TenantVo = (function () {
            function TenantVo() {
            }
            return TenantVo;
        })();
        Tenant.TenantVo = TenantVo;
        var Service = (function () {
            Service.$inject = ["httpService"];
            function Service(httpService) {
                "ngInject";
                this.httpService = httpService;
            }
            Service.prototype.getTenantList = function () {
                return this.httpService.get(this.getUrl());
            };
            Service.prototype.getTenant = function (tenantId) {
                return this.httpService.get(this.getUrl() + tenantId);
            };
            Service.prototype.createTenant = function (tenant) {
                var tenantRequest = new TenantRequest(tenant);
                return this.httpService.post(this.getUrl(), tenantRequest);
            };
            Service.prototype.updateTenant = function (tenant) {
                var tenantRequest = new TenantRequest(tenant);
                return this.httpService.post(this.getUrl() + tenant.TenantId, tenantRequest);
            };
            Service.prototype.deleteTenant = function (tenantId) {
                return this.httpService.remove(this.getUrl() + tenantId);
            };
            Service.prototype.getUrl = function () {
                return 'v1/infrastructure/tenant/';
            };
            return Service;
        })();
        Tenant.Service = Service;
        var TenantRequest = (function () {
            function TenantRequest(tenant) {
                this.TenantVo = tenant;
            }
            return TenantRequest;
        })();
    })(Tenant = Domain.Tenant || (Domain.Tenant = {}));
})(Domain || (Domain = {}));
angular.module('DoctorApp')
    .service('tenantDomainService', Domain.Tenant.Service);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../services/http-service.ts" />
/// <reference path="../../services/api/domain/tenant.ts" />
var DashboardModule;
(function (DashboardModule) {
    var Service = (function () {
        Service.$inject = ["httpService", "tenantDomainService", "authService", "clinicalDomain", "moment", "providerService", "$http", "patientDomain", "storageService", "patientEventDomain"];
        function Service(httpService, tenantDomainService, authService, clinicalDomain, moment, providerService, $http, patientDomain, storageService, patientEventDomain) {
            "ngInject";
            this.httpService = httpService;
            this.tenantDomainService = tenantDomainService;
            this.authService = authService;
            this.clinicalDomain = clinicalDomain;
            this.moment = moment;
            this.providerService = providerService;
            this.$http = $http;
            this.patientDomain = patientDomain;
            this.storageService = storageService;
            this.patientEventDomain = patientEventDomain;
        }
        Service.prototype.getTenants = function () {
            return this.tenantDomainService.getTenantList()
                .then(function (response) {
                if (response) {
                    return response;
                }
                return [];
            });
        };
        Service.prototype.getEncounter = function (practiceId, encounterId) {
            return this.clinicalDomain.getEncounter(practiceId, encounterId);
        };
        Service.prototype.getEncounterCommunicationBody = function (practiceId, templateId) {
            return this.clinicalDomain
                .getEncounterCommunicationBody(practiceId, '00000000-0000-0000-0000-000000000000', templateId);
        };
        Service.prototype.getPrescriptionReport = function (practiceId, encounter) {
            return this.clinicalDomain.getPrescriptionReport(practiceId, encounter);
        };
        Service.prototype.getPrescriptionReportPdf = function (practiceId, encounter) {
            return this.clinicalDomain.getPrescriptionReport(practiceId, encounter, "pdf");
        };
        Service.prototype.reportFromHtmlToPdf = function (html) {
            return this.httpService.post("v1/report/htmltopdf", JSON.stringify(html), { responseType: 'blob' });
        };
        Service.prototype.reportLinkFromHtmlToPdf = function (practiceId, html) {
            var _this = this;
            return this.httpService.post("v1/report/savehtmltopdf", JSON.stringify(html))
                .then(function (response) {
                return _this.getDocumentUrl(practiceId, response.Data);
            });
        };
        Service.prototype.getMedicalCertificateReport = function (practiceId, encounter) {
            return this.clinicalDomain.getMedicacalSertificate(practiceId, encounter);
        };
        Service.prototype.getMedicalCertificateReportPdf = function (practiceId, encounter) {
            return this.clinicalDomain.getMedicacalSertificate(practiceId, encounter, "pdf");
        };
        Service.prototype.getPatientDashboard = function (practiceId, patientId) {
            return this.httpService.get("v1/" + practiceId + "/clinical/patientdashboards/" + patientId);
        };
        Service.prototype.getActiveVisit = function (practiceId, patientId) {
            return this.patientEventDomain.getPatientEventByPatientId(practiceId, patientId);
        };
        Service.prototype.getPatientDashboardHeader = function (practiceId, patientId) {
            return this.httpService.get("v1/" + practiceId + "/clinical/patientdashboards/" + patientId + "/header");
        };
        Service.prototype.getHealthDocToken = function (practiceId) {
            return this.httpService.get("v1/infrastructure/" + practiceId + "/tokenproviders");
        };
        Service.prototype.addToWaitingRoom = function (practiceId, patientId) {
            return this.patientDomain.addToWaitingRoom(practiceId, patientId);
        };
        Service.prototype.captureEncounter = function (practiceId, patientId) {
            return this.patientDomain.captureEncounter(practiceId, patientId);
        };
        Service.prototype.getPatientFamilyMembers = function (practiceId, patientId) {
            return this.patientDomain.getFamilyMembers(practiceId, patientId);
        };
        Service.prototype.loadPatientFiles = function (practiceId, patientId) {
            return this.httpService.get("v1/" + practiceId + "/clinical/patientdocument/" + patientId);
        };
        Service.prototype.getQuoteReport = function (practiceId, patientId) {
            return this.httpService.get("v1/" + practiceId + "/clinical/patient/" + patientId + "/quote/pdf", { responseType: 'blob' });
        };
        Service.prototype.getQuoteReportUrl = function (practiceId, patientId) {
            return GlobalVar.serverURL + "v1/" + practiceId + "/clinical/patient/" + patientId + "/quote/pdf";
        };
        Service.prototype.removeDocument = function (practiceId, documentId) {
            return this.httpService.remove("v1/" + practiceId + "/clinical/patientdocument/" + documentId);
        };
        Service.prototype.getDocumentUrl = function (practiceId, fileUrl) {
            if (fileUrl && fileUrl.length > 0) {
                return GlobalVar.serverURL +
                    "v1/document?url=" +
                    fileUrl +
                    "&access_token=" +
                    this.storageService.getAuthorizationData().token +
                    "&practiceId=" +
                    practiceId;
            }
            else {
                return "";
            }
        };
        Service.prototype.getDocumentInfoById = function (practiceId, documentId) {
            return this.httpService.get("v1/" + practiceId + "/clinical/patientdocument/byId/" + documentId);
        };
        Service.prototype.removeAvatarCache = function (practiceId, patientId) {
            this.httpService.resetCache('avatar-' + practiceId + ':' + patientId);
        };
        Service.prototype.getAvatar = function (practiceId, patientId) {
            return this.httpService.get("v1/" + practiceId + "/clinical/patientdocument/" + patientId + '/avatar', { cache: 'avatar-' + practiceId + ':' + patientId });
        };
        Service.prototype.getAccountFinancialInfo = function (practiceId, patientId) {
            return this.httpService.get("support/" + practiceId + "/patient/" + patientId + '/account/info');
        };
        Service.prototype.loadExternalData = function (practiceId, patientId) {
            return this.httpService.post("support/" + practiceId + "/patient/" + patientId + '/externaldata/load');
        };
        return Service;
    })();
    DashboardModule.Service = Service;
})(DashboardModule || (DashboardModule = {}));
angular.module('DoctorApp')
    .service('dashboardService', DashboardModule.Service);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../services/http-service.ts" />
/// <reference path="../../services/auth-service.ts" />
var SearchModule;
(function (SearchModule) {
    var Service = (function () {
        Service.$inject = ["httpService"];
        function Service(httpService) {
            "ngInject";
            this.httpService = httpService;
        }
        Service.prototype.encodeSearchText = function (text) {
            return encodeURIComponent(text).replace(/%/g, '!!!');
        };
        Service.prototype.getProcedures = function (practiceId, invoiceid, procedureSearchString) {
            return this.httpService.get("v1/" + practiceId + "/billing/invoices/" + invoiceid + "/lookupprocedure/" + this.encodeSearchText(procedureSearchString));
        };
        Service.prototype.getDiagnoses = function (practiceId, invoiceid, diagnosesSearchString) {
            return this.httpService.get("v1/" + practiceId + "/billing/invoices/" + invoiceid + "/lookupdiagnosis/" + this.encodeSearchText(diagnosesSearchString));
        };
        Service.prototype.getDiagnosesRanking = function (practiceId, invoiceid, diagnosesSearchString) {
            return this.httpService.get("v1/" + practiceId + "/billing/invoices/" + invoiceid + "/lookupdiagnosisranking/" + this.encodeSearchText(diagnosesSearchString));
        };
        Service.prototype.getMedicine = function (practiceId, invoiceid, medicineSearchString) {
            return this.httpService.get("v1/" + practiceId + "/billing/invoices/" + invoiceid + "/lookupmedicine/" + this.encodeSearchText(medicineSearchString));
        };
        Service.prototype.getConsumable = function (practiceId, invoiceid, consumableSearchString) {
            return this.httpService.get("v1/" + practiceId + "/billing/invoices/" + invoiceid + "/lookupconsumable/" + this.encodeSearchText(consumableSearchString));
        };
        Service.prototype.getClinicalProcedures = function (practiceId, encounterid, procedureSearchString, dateOfService) {
            return this.httpService.get("v1/" + practiceId + "/clinical/encounters/" + encounterid + "/lookupprocedure/" + this.encodeSearchText(procedureSearchString) + "/dos/" + dateOfService);
        };
        Service.prototype.getClinicalDiagnoses = function (practiceId, encounterid, diagnosesSearchString) {
            return this.httpService.get("v1/" + practiceId + "/clinical/encounters/" + encounterid + "/lookupdiagnosis/" + this.encodeSearchText(diagnosesSearchString));
        };
        Service.prototype.getClinicalDiagnosesRanking = function (practiceId, encounterid, diagnosesSearchString) {
            return this.httpService.get("v1/" + practiceId + "/clinical/encounters/" + encounterid + "/lookupdiagnosisranking/" + this.encodeSearchText(diagnosesSearchString));
        };
        Service.prototype.getClinicalMedicine = function (practiceId, encounterid, medicineSearchString) {
            return this.httpService.get("v1/" + practiceId + "/clinical/encounters/" + encounterid + "/lookupmedicine/" + this.encodeSearchText(medicineSearchString));
        };
        Service.prototype.getClinicalConsumable = function (practiceId, encounterid, consumableSearchString) {
            return this.httpService.get("v1/" + practiceId + "/clinical/encounters/" + encounterid + "/lookupconsumable/" + this.encodeSearchText(consumableSearchString));
        };
        Service.prototype.getClinicalPrescription = function (practiceId, encounterId, text) {
            return this.httpService.get("v1/" + practiceId + "/clinical/encounters/" + encounterId + "/lookupprescription/" + this.encodeSearchText(text));
        };
        Service.prototype.getInsurerProcedures = function (practiceId, encounterId, insurerXref) {
            return this.httpService.get("v1/" + practiceId + "/clinical/encounters/" + encounterId + '/lookupmedicalinsurerprocedure/' + insurerXref);
        };
        Service.prototype.getClinicalModifier = function (practiceId, encounterId, modifierSearchString) {
            return this.httpService.get("v1/" + practiceId + "/clinical/encounters/" + encounterId + '/lookupmodifier/' + this.encodeSearchText(modifierSearchString));
        };
        Service.prototype.saveSelectedTemplate = function (template) {
            this.selectedTemplate = template;
        };
        Service.prototype.getSelectedTemplate = function () {
            return this.selectedTemplate;
        };
        return Service;
    })();
    SearchModule.Service = Service;
})(SearchModule || (SearchModule = {}));
angular.module('DoctorApp')
    .service('searchService', SearchModule.Service);
/// <reference path="../../scripts/definition/angularjs/angular.d.ts" />
var DialogModule;
(function (DialogModule) {
    var Service = (function () {
        Service.$inject = ["$rootScope", "$q", "$compile", "$templateCache", "$http"];
        function Service($rootScope, $q, $compile, $templateCache, $http) {
            "ngInject";
            this.$rootScope = $rootScope;
            this.$q = $q;
            this.$compile = $compile;
            this.$templateCache = $templateCache;
            this.$http = $http;
            this.dialogs = {};
        }
        Service.prototype.open = function (id, template, model, options) {
            var _this = this;
            if (!angular.isDefined(id)) {
                throw "dialogService requires id in call to open";
            }
            if (!angular.isDefined(template)) {
                throw "dialogService requires template in call to open";
            }
            if (!angular.isDefined(model)) {
                model = null;
            }
            var dialogOptions = {};
            if (angular.isDefined(options)) {
                angular.extend(dialogOptions, options);
            }
            var dialog = { scope: null, ref: null, deferred: this.$q.defer() };
            this.loadTemplate(template)
                .then(function (dialogTemplate) {
                dialog.scope = _this.$rootScope.$new();
                dialog.scope.model = model;
                var dialogLinker = _this.$compile(dialogTemplate);
                dialog.ref = $(dialogLinker(dialog.scope));
                var customCloseFn = dialogOptions.close;
                dialogOptions.close = function (event, ui) {
                    if (customCloseFn) {
                        customCloseFn(event, ui);
                    }
                    _this.cleanup(id);
                };
                dialog.ref.dialog(dialogOptions);
                dialog.ref.dialog("open");
                _this.dialogs[id] = dialog;
            }, function (error) {
                throw error;
            });
            return dialog.deferred.promise;
        };
        Service.prototype.close = function (id, result) {
            var dialog = this.getExistingDialog(id);
            dialog.deferred.resolve(result);
            dialog.ref.dialog("close");
        };
        Service.prototype.cancel = function (id) {
            var dialog = this.getExistingDialog(id);
            dialog.deferred.reject();
            dialog.ref.dialog("close");
        };
        Service.prototype.loadTemplate = function (template) {
            var _this = this;
            var deferred = this.$q.defer();
            var html = this.$templateCache.get(template);
            if (angular.isDefined(html)) {
                html = html.trim();
                deferred.resolve(html);
            }
            else {
                return this.$http.get(template, { cache: this.$templateCache })
                    .then(function (response) {
                    var html = response.data;
                    if (!html || !html.length) {
                        return _this.$q.reject("Template " + template + " was not found");
                    }
                    html = html.trim();
                    _this.$templateCache.put(template, html);
                    return html;
                }, function () {
                    return _this.$q.reject("Template " + template + " was not found");
                });
            }
            return deferred.promise;
        };
        Service.prototype.cleanup = function (id) {
            var dialog = this.getExistingDialog(id);
            dialog.deferred.reject();
            dialog.scope.$destroy();
            dialog.ref.remove();
            delete this.dialogs[id];
        };
        Service.prototype.getExistingDialog = function (id) {
            var dialog = this.dialogs[id];
            if (!angular.isDefined(dialog)) {
                throw "DialogService does not have a reference to dialog id " + id;
            }
            return dialog;
        };
        return Service;
    })();
    DialogModule.Service = Service;
})(DialogModule || (DialogModule = {}));
angular.module('DoctorApp')
    .service('dialogService', DialogModule.Service);
/// <reference path="../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../scripts/definition/jquery-ui/jqueryui.d.ts" />
/// <reference path="../screens/components/modal/modal-service.ts" />
/// <reference path="../services/dialog-service.ts" />
var ShowDialogModule;
(function (ShowDialogModule) {
    var Service = (function () {
        Service.$inject = ["modalService"];
        function Service(modalService) {
            "ngInject";
            this.modalService = modalService;
        }
        Service.prototype.error = function (errorDetails, width) {
            return this.modalService.error(errorDetails, width);
        };
        Service.prototype.info = function (message, width) {
            return this.modalService.info(message, width);
        };
        Service.prototype.warning = function (message) {
            return this.showWarningDialog(message);
        };
        Service.prototype.cellPhone = function () {
            return this.modalService.cellPhone();
        };
        Service.prototype.showWarningDialog = function (info) {
            console.warn('Method is deprecated. [show-dialog.showWarningDialog()]');
            return this.modalService.warning(info);
        };
        Service.prototype.confirm = function (message, width, hasClose, labels) {
            return this.modalService.confirm(message, width, hasClose, labels);
        };
        return Service;
    })();
    ShowDialogModule.Service = Service;
})(ShowDialogModule || (ShowDialogModule = {}));
angular.module('DoctorApp')
    .service('showDialog', ShowDialogModule.Service);
/// <reference path="../../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../../services/api/domain/clinical.ts" />
/// <reference path="../../../services/api/domain/billing.ts" />
/// <reference path="../../searches/search-service.ts" />
var TemplateModule;
(function (TemplateModule) {
    var TemplatePanelController = (function () {
        TemplatePanelController.$inject = ["$scope", "$filter", "$location", "templatePanelService", "searchService", "modalService", "$routeParams"];
        function TemplatePanelController($scope, $filter, $location, templatePanelService, searchService, modalService, $routeParams) {
            "ngInject";
            var _this = this;
            this.$scope = $scope;
            this.$filter = $filter;
            this.$location = $location;
            this.templatePanelService = templatePanelService;
            this.searchService = searchService;
            this.modalService = modalService;
            this.$routeParams = $routeParams;
            $scope.groups = [];
            $scope.$watch('list', function () {
                $scope.groups = _this.buildGroups($scope.list);
                $scope.selectGroup($scope.groups[0]);
            });
            $scope.$watchCollection('allows', function () {
                if ($scope.allows) {
                    var noGroupSelected = true;
                    for (var _i = 0, _a = Object.keys($scope.allows); _i < _a.length; _i++) {
                        var allowKey = _a[_i];
                        for (var _b = 0, _c = $scope.groups; _b < _c.length; _b++) {
                            var group = _c[_b];
                            if (group.allowParam === allowKey) {
                                group.allowed = $scope.allows[allowKey];
                            }
                            if (noGroupSelected && group.allowed) {
                                noGroupSelected = false;
                                _this.$scope.selectGroup(group);
                            }
                        }
                    }
                }
            });
            this.updateStyle();
            $scope.selectGroup = function (group) {
                var groups = $scope.groups;
                for (var i = 0; i < groups.length; i++) {
                    groups[i].select = false;
                }
                group.select = true;
            };
            $scope.searchSelect = function (path) {
                if ($scope.control.searchSelect) {
                    $scope.control.searchSelect();
                }
                $location.path(path);
                if ($scope.control && $scope.control.isClinical) {
                    $location.hash('clinical');
                }
            };
            $scope.selectTemplateItem = function (item) {
                if (item.TemplateId) {
                    $scope.control.selectTemplate(item);
                }
                else {
                    _this.openSubItemDialog(item);
                }
            };
        }
        TemplatePanelController.prototype.buildGroups = function (templates) {
            var templateGroups = [
                new TemplateModule.GroupTemplate('Diagnosis', '/' + this.$routeParams.practiceId + '/search-diagnosis', 'diagnosisico', "AllowDiagnosis"),
                new TemplateModule.GroupTemplate('Procedure', '/' + this.$routeParams.practiceId + '/search-procedure', 'procedureico', "AllowProcedure"),
                new TemplateModule.GroupTemplate('Medicine', '/' + this.$routeParams.practiceId + '/search-medicine', 'medicineico', "AllowMedicine"),
                new TemplateModule.GroupTemplate('Consumable', '/' + this.$routeParams.practiceId + '/search-consumable', 'consumableico', "AllowConsumable")
            ];
            var control = this.$scope.control;
            if (control.isClinical && control.isPrescription) {
                templateGroups.push(new TemplateModule.GroupTemplate('Prescription', '/' + this.$routeParams.practiceId + '/search-prescription', 'prescriptionico', "AllowPrescription"));
            }
            var res = [];
            for (var i = 0; i < templateGroups.length; i++) {
                res[i] = this.buildGroupTemplate(templates, templateGroups[i]);
            }
            return res;
        };
        TemplatePanelController.prototype.updateStyle = function () {
            var count = 3;
            var control = this.$scope.control;
            if (control.isMedicine) {
                count++;
            }
            if (control.isClinical && control.isPrescription) {
                count++;
            }
            var width = 100 / count;
            this.$scope.style = { 'width': width + '%' };
        };
        TemplatePanelController.prototype.buildGroupTemplate = function (templs, groupSetting) {
            var group = new TemplateModule.Group();
            group.templates = this.templatePanelService.mixTemplateAndSubGroups(templs, groupSetting.name);
            group.name = groupSetting.name;
            group.path = groupSetting.path;
            group.allowParam = groupSetting.allowParam;
            group.allowed = true;
            group.select = false;
            group.icon = groupSetting.icon;
            return group;
        };
        TemplatePanelController.prototype.openSubItemDialog = function (item) {
            this.modalService.openSubTemplates(item, this.$scope.control.selectTemplate);
        };
        TemplatePanelController.factory = function () {
            var instance = function () {
                var directive = {};
                directive.restrict = 'E';
                directive.scope = {
                    list: '=',
                    control: '=',
                    height: '=',
                    allows: '='
                };
                directive.templateUrl = 'screens/components/template-panel/template-panel.html';
                directive.controller = TemplatePanelController;
                return directive;
            };
            return instance;
        };
        return TemplatePanelController;
    })();
    TemplateModule.TemplatePanelController = TemplatePanelController;
})(TemplateModule || (TemplateModule = {}));
angular.module('DoctorApp')
    .directive('templatePanel', TemplateModule.TemplatePanelController.factory());
/// <reference path="../../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../../../scripts/definition/moment/moment-node.d.ts" />
/// <reference path="../../clinical-template/clinical-template-service.ts" />
/// <reference path="../../../services/api/event-type.ts"/>
/// <reference path="../../../services/api/domain/patient.ts"/>
/// <reference path="../../../screens/searches/search-service.ts" />
/// <reference path="../../../services/show-dialog.ts"/>
/// <reference path="../../../screens/components/template-panel/template-panel.ts"/>
/// <reference path="encounter-service.ts" />
/// <reference path="../../../run.ts" />
var EncounterModule;
(function (EncounterModule) {
    var Template = Domain.Clinical.Template;
    var FeatureAllows = Domain.Billing.FeatureAllows;
    var SupportingProviderVo = Domain.Billing.SupportingProviderVo;
    var Controller = (function () {
        Controller.$inject = ["$scope", "$rootScope", "$routeParams", "$location", "locationService", "encounterServiceNew", "practiceService", "clinicalTemplateServiceNew", "dashboardService", "storageService", "searchService", "showDialog", "$log", "$filter", "$q", "moment", "templatePanelService", "$compile", "modalService", "trackingService"];
        function Controller($scope, $rootScope, $routeParams, $location, locationService, encounterServiceNew, practiceService, clinicalTemplateServiceNew, dashboardService, storageService, searchService, showDialog, $log, $filter, $q, moment, templatePanelService, $compile, modalService, trackingService) {
            "ngInject";
            var _this = this;
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.$routeParams = $routeParams;
            this.$location = $location;
            this.locationService = locationService;
            this.encounterServiceNew = encounterServiceNew;
            this.practiceService = practiceService;
            this.clinicalTemplateServiceNew = clinicalTemplateServiceNew;
            this.dashboardService = dashboardService;
            this.storageService = storageService;
            this.searchService = searchService;
            this.showDialog = showDialog;
            this.$log = $log;
            this.$filter = $filter;
            this.$q = $q;
            this.moment = moment;
            this.templatePanelService = templatePanelService;
            this.$compile = $compile;
            this.modalService = modalService;
            this.trackingService = trackingService;
            this.catchError = function (error) {
                _this.$log.error(error);
            };
            this.hasMatchingItem = function (arr1, arr2) {
                var retval = false;
                arr1.forEach(function (e1) { return arr2.forEach(function (e2) {
                    if (e1 === e2) {
                        retval = true;
                    }
                }); });
                return retval;
            };
            $scope.currentConsultationTab = Controller.CONSULTATION;
            $scope.clinicalMetricsOptions = {};
            $scope.fullSchemeName = "";
            this.$scope.currentDate = this.moment();
            $scope.selectTemplate = function (template) {
                if (template.TemplateId) {
                    _this.addTemplateToEncounter(template);
                }
                else {
                    _this.modalService.openSubTemplates(template, $scope.selectTemplate);
                }
            };
            $scope.selectHospital = function () {
                encounterServiceNew.mergePlaceOfService(_this.$routeParams.practiceId, $scope.encounter);
            };
            $scope.goToMedicalHistory = function () {
                _this.populateClinicalMetrics();
                var patientId = $scope.encounter.PatientEventDetails.Patient.PatientId;
                locationService.goToMedicalHistory($routeParams.practiceId, patientId);
            };
            $scope.minAllergiesWidth = function () {
                var wrapperPadding = 20 + 2;
                var allergiesCount = $scope.patientDashboard.Allergies.length;
                if (allergiesCount > 3) {
                    return Math.ceil(allergiesCount / 3) * 70 + wrapperPadding;
                }
                else {
                    var padding = allergiesCount < 3 ? 40 : 0;
                    return Math.ceil(allergiesCount / 2) * 70 + padding;
                }
            };
            $scope.getProcedureAndModifiers = function (lineItems) {
                var filteredItems = lineItems &&
                    lineItems.filter(function (item) { return item.LineType === "Modifier" ||
                        item.LineType === "Procedure"; });
                return filteredItems;
            };
            $scope.minConditionWidth = function () {
                var wrapperPadding = 20 + 1;
                var allergiesCount = $scope.patientDashboard.Allergies &&
                    $scope.patientDashboard.Allergies.length ||
                    0;
                var conditionsCount = $scope.patientDashboard.ChronicConditions.length;
                if (conditionsCount > 3 || allergiesCount) {
                    return Math.ceil(conditionsCount / 3) * 150 + wrapperPadding;
                }
                else {
                    var padding = conditionsCount < 3 ? 40 : 0;
                    return Math.ceil(conditionsCount / 2) * 150 + padding;
                }
            };
            $scope.isNotAuxiliary = function () {
                var auxPractices = ["086", "089"];
                var encounter = $scope.encounter;
                if (encounter && encounter.Provider) {
                    return auxPractices.indexOf(encounter.Provider.SpecialityCode) == -1;
                }
                return false;
            };
            $scope.back = function () {
                if (encounterServiceNew.isEncounterChanged()) {
                    _this.modalService.leaveEncounterConfirm().then(function (result) {
                        if (result) {
                            $scope.save();
                        }
                        else {
                            encounterServiceNew.clearEncounterCache();
                            $rootScope.back();
                        }
                    }, function () {
                    });
                }
                else {
                    $rootScope.back();
                }
            };
            $scope.selectConsultationTab = function (tab) {
                $scope.currentConsultationTab = tab;
                if (tab === Controller.CONSULTATION) {
                }
                else if (tab === Controller.METRICS) {
                    var patientId = _this.$scope.encounter.PatientEventDetails.Patient.PatientId;
                    _this.encounterServiceNew.getHistoricalMetrics(_this.$routeParams.practiceId, patientId)
                        .then(function (r) { return _this.$scope.clinicalMetricsOptions.historicalMetrics = r; });
                }
            };
            $scope.openReferralTemplates = function () {
                var templates = _this.$scope.memoryRefferalTemplates;
                _this.modalService.openCommunicationTemplates(templates)
                    .then(function (template) {
                    var items = angular.copy(template);
                    _this.addTemplateToEncounter(items);
                });
            };
            $scope.editCommunicationItem = function (communication) {
                var practiceId = _this.$routeParams.practiceId;
                var templateBody = _this.encounterServiceNew.getCommunicationBodyById(communication.CommunicationId);
                if (!templateBody) {
                    _this.encounterServiceNew.getReferralHtml(practiceId, $scope.encounter, communication)
                        .then(function (response) {
                        _this.encounterServiceNew.setCommunicationBodyById(communication.CommunicationId, response);
                        _this.editReferralTemplate(communication);
                    });
                }
                else {
                    _this.editReferralTemplate(communication);
                }
            };
            $scope.removeLine = function (obj, typeStr) {
                var type = EventTypeUtil.getTypeByName(typeStr);
                encounterServiceNew.removeLine(_this.$scope.encounter, obj, type);
            };
            $scope.isDOBValid = function () {
                return _this.$scope.encounter && moment(_this.$scope.encounter.PatientEventDetails.Patient.PatientDetails.DateOfBirth) < moment();
            };
            $scope.selectBranch = function (branch) {
                _this.$scope.encounter.BranchXRef = branch.BranchXRef;
            };
            $scope.showLineDetails = function (obj, typeStr) {
                var validateOptions = {
                    isPricing: $scope.options.isEnabledForDisplayingPrices,
                    specificRule: $scope.specificRule,
                    medicalAidInvoice: $scope.encounter.EncounterType === "MedicalAidInvoice",
                    isDiscoveryKayCare: $scope.fullSchemeName.indexOf("DISCOVERY KEYCARE") > -1,
                    refreshPrice: $scope.refreshEncounterPrice
                };
                var type = EventTypeUtil.getTypeByName(typeStr);
                encounterServiceNew.showLineItem(_this.$scope, obj, type, validateOptions)
                    .then(function (response) {
                    if (type === EventType.MODIFIER) {
                        var modifier = response;
                        if (modifier && modifier.ChargeCode === '0009') {
                            $scope.assistingDoctorIndicator = true;
                        }
                        encounterServiceNew.refreshEncounter($routeParams.practiceId, null, $scope.encounter)
                            .then(function (refreshedEncounter) {
                            if (refreshedEncounter) {
                                $scope.encounter = refreshedEncounter;
                                _this.updateClinicalMetrics(refreshedEncounter);
                            }
                            else {
                                _this.modalService.error("Failed to add modifier");
                            }
                        });
                    }
                    if (type === EventType.PROCEDURE) {
                        var procedure = obj;
                        $scope.encounter.EncounterLineItems.LineItems
                            .forEach(function (lineItem) {
                            if (lineItem.LineType === "Modifier" &&
                                lineItem.LineNum === procedure.LineNum + 1) {
                                encounterServiceNew
                                    .refreshEncounter($routeParams.practiceId, null, $scope.encounter)
                                    .then(function (refreshedEncounter) {
                                    if (refreshedEncounter) {
                                        $scope.encounter = refreshedEncounter;
                                    }
                                    else {
                                        _this.modalService.error("Failed to refresh price");
                                    }
                                });
                            }
                        });
                    }
                    _this.updateMedicineStatus();
                });
            };
            $scope.refreshEncounterPrice = function (line) {
                var oldLine = _this.$filter('filter')($scope.encounter.EncounterLineItems.LineItems, { NappiCode: line.NappiCode }, true);
                if (oldLine && oldLine.length > 0) {
                    var indexOf = $scope.encounter.EncounterLineItems.LineItems.indexOf(oldLine[0]);
                    $scope.encounter.EncounterLineItems.LineItems[indexOf] = line;
                }
                return encounterServiceNew.priceEncounter(_this.$routeParams.practiceId, $scope.encounter, line)
                    .then(function (response) {
                    if (response.Sucess) {
                        var updatedLine = _this.$filter('filter')(response.Data.EncounterLineItems.LineItems, { NappiCode: line.NappiCode }, true);
                        if (updatedLine && updatedLine.length > 0) {
                            line.TotalIncVat = updatedLine[0].TotalIncVat;
                        }
                        return updatedLine;
                    }
                    return null;
                });
            };
            $scope.addModifiers = function () {
                modalService.showModifierDetails($scope.encounter, null, $scope.assistingDoctor)
                    .then(function (modifier) {
                    if (modifier && modifier.ChargeCode === '0009') {
                        $scope.assistingDoctorIndicator = true;
                    }
                    encounterServiceNew.refreshEncounter($routeParams.practiceId, null, $scope.encounter)
                        .then(function (refreshedEncounter) {
                        if (refreshedEncounter) {
                            $scope.encounter = refreshedEncounter;
                            _this.updateClinicalMetrics(refreshedEncounter);
                            encounterServiceNew.setEncounter(refreshedEncounter);
                        }
                        else {
                            _this.modalService.error("Failed to add modifier");
                        }
                    });
                });
            };
            $scope.openPrescriptionHistory = function () {
                var patientId = $scope.encounter.PatientEventDetails.Patient.PatientId;
                encounterServiceNew.getPrescriptionHistory($routeParams.practiceId, patientId)
                    .then(function (response) {
                    _this.modalService.openPrescriptionHistory(response)
                        .then(function (repeatPrescriptions) {
                        var template = new Template();
                        template.MedicationPrescriptionLines = repeatPrescriptions;
                        template.TemplateType = "RepeatScript";
                        _this.addTemplateToEncounter(template);
                    });
                });
            };
            $scope.togglePrimaryDiagnosis = function (index, diagnosis) {
                encounterServiceNew.toggleDiagnosis($scope.encounter.EncounterLineItems.EncounterHeader.Diagnosis, index);
            };
            $scope.updateReferringDoctor = function (provider) {
                $scope.encounter.ReferringDoctorName = provider && provider.FriendlyName;
                $scope.encounter.ReferringDoctorPracticeNumber = provider && provider.TreatingPracticeNumber;
            };
            $scope.updateAssistingDoctor = function (provider) {
                $scope.encounter.AssistingDoctorName = provider && provider.FriendlyName;
                $scope.encounter.AssistingDoctorPracticeNumber = provider && provider.TreatingPracticeNumber;
            };
            $scope.onReferringDoctorIndicatorChange = function () {
                if ($scope.referringDoctorIndicator) {
                    if ($scope.isIHealthProvider) {
                        _this.openReferringSupportingProvider(null);
                    }
                    else {
                        _this.encounterServiceNew.getSupportingProviders(_this.$routeParams.practiceId, "Referring")
                            .then(function (providers) {
                            _this.openReferringSupportingProvider(providers);
                        });
                    }
                }
                else {
                    _this.$scope.referringDoctor = null;
                    _this.$scope.updateReferringDoctor(null);
                }
            };
            $scope.onAssistingDoctorIndicatorChange = function () {
                if ($scope.assistingDoctorIndicator) {
                    if ($scope.isIHealthProvider) {
                        _this.openAssistingSupportingProvider(null);
                    }
                    else {
                        _this.encounterServiceNew.getSupportingProviders(_this.$routeParams.practiceId, "Assisting")
                            .then(function (providers) {
                            _this.openAssistingSupportingProvider(providers);
                        });
                    }
                }
                else {
                    _this.$scope.assistingDoctor = null;
                    _this.$scope.updateAssistingDoctor(null);
                }
            };
            $scope.selectPlaceOfService = function (value) {
                $scope.encounter.EncounterLineItems.EncounterHeader.HospitalIndicator =
                    value === Controller.INPATIENT_HOSPITAL;
                encounterServiceNew.mergePlaceOfService(_this.$routeParams.practiceId, $scope.encounter);
            };
            $scope.selectPatient = function () {
                _this.populateClinicalMetrics();
                var patientId = $scope.encounter.PatientEventDetails.Patient.PatientId;
                locationService.goToChangePatient($routeParams.practiceId, patientId);
            };
            $scope.completeEncounter = function (visitOutcome) {
                $scope.encounter.ClinicalMetrics = $scope.clinicalMetricsOptions.getClinicalMetrics();
                if (!$scope.clinicalMetricsOptions.validate()) {
                    return;
                }
                var consultationDate = moment(_this.encounterServiceNew.getConsultationDate());
                var diff = moment().diff(consultationDate, 'days');
                if (!_this.$scope.timeOfServiceStr && diff > 0) {
                    showDialog.warning("Please capture the Time of Service for the patient visit.");
                    return;
                }
                if ($scope.referringDoctorIndicator) {
                    if (!$scope.encounter.ReferringDoctorName ||
                        !$scope.encounter.ReferringDoctorPracticeNumber) {
                        showDialog.warning("Please provide correct referring doctor’s details");
                        return;
                    }
                }
                else {
                    $scope.encounter.ReferringDoctorName = null;
                    $scope.encounter.ReferringDoctorPracticeNumber = null;
                }
                if ($scope.assistingDoctorIndicator) {
                    if (!$scope.encounter.AssistingDoctorName ||
                        !$scope.encounter.AssistingDoctorPracticeNumber) {
                        showDialog.warning("Please provide correct assisting doctor’s details");
                        return;
                    }
                }
                else {
                    $scope.encounter.AssistingDoctorName = null;
                    $scope.encounter.AssistingDoctorPracticeNumber = null;
                }
                if ($scope.encounter.EncounterLineItems.EncounterHeader.HospitalIndicator &&
                    !$scope.encounter.EncounterLineItems.EncounterHeader.ClaimAuthorizationNumber) {
                    showDialog.warning("Please provide authorization number");
                    return;
                }
                var nextStepAction = function (goToVisitOutcome, validPlaceOfService) {
                    if (validPlaceOfService === void 0) { validPlaceOfService = true; }
                    var hasTelehealthProcedures = _this.hasMatchingItem($scope.encounter.EncounterLineItems.LineItems.map(function (m) { return m.ChargeCode; }), Controller.PROCEDURES_NOT_TELEHEALT_SPECIFIC);
                    if (validPlaceOfService && hasTelehealthProcedures && _this.$scope.encounter.EncounterLineItems.EncounterHeader.PlaceOfService !== 2) {
                        showDialog.confirm("Would you like to change the place of service to Telehealth?", null, false, ['Yes', 'No'])
                            .then(function () {
                            _this.$scope.encounter.EncounterLineItems.EncounterHeader.PlaceOfService = 2;
                            nextStepAction(visitOutcome, false);
                        }).catch(function () { return nextStepAction(visitOutcome, false); });
                    }
                    else {
                        if (goToVisitOutcome) {
                            _this.goToNext();
                        }
                        else {
                            _this.submitEncounter();
                        }
                    }
                };
                _this.updateMedicationPrices();
                if (_this.$scope.encounter.EncounterType === Controller.MEDICAL_INSURANCE) {
                    if (!$scope.encounter.MedicalInsurance.PatientIdentityNo ||
                        !$scope.encounter.MedicalInsurance.PolicyNo ||
                        $scope.encounter.MedicalInsurance.MedicalInsurer == null) {
                        modalService.showMedicalInsuranceDetails(_this.$scope.encounter)
                            .then(function (medicalInsurance) {
                            _this.$scope.encounter.MedicalInsurance = medicalInsurance;
                            _this.encounterServiceNew.setEncounter(_this.$scope.encounter);
                            nextStepAction(visitOutcome);
                        });
                    }
                    else {
                        nextStepAction(visitOutcome);
                    }
                }
                else if (_this.$scope.encounter.EncounterLineItems.LineItems.length === 0 ||
                    _this.$filter('filter')(_this.$scope.encounter.EncounterLineItems.LineItems, { LineType: EventTypeUtil.getNameByType(EventType.PROCEDURE) }, false).length ===
                        0) {
                    showDialog.confirm("You have not selected any procedures for this patient. If you proceed an invoice " +
                        "will not be created and this patient will not be billed. Would you like to continue?")
                        .then(function () {
                        nextStepAction(visitOutcome);
                    });
                }
                else {
                    nextStepAction(visitOutcome);
                }
            };
            $scope.loadInsurerProcedures = function () {
                var encounter = _this.$scope.encounter;
                modalService.showMedicalInsuranceDetails(encounter)
                    .then(function (medicalInsurance) {
                    $scope.encounter.MedicalInsurance = medicalInsurance;
                    _this.getInsurerProcedures();
                });
            };
            $scope.showMedicalInsuranceDetails = function () {
                modalService.showMedicalInsuranceDetails(_this.$scope.encounter)
                    .then(function (medicalInsurance) {
                    if (!angular.equals($scope.encounter.MedicalInsurance, medicalInsurance)) {
                        $scope.encounter.MedicalInsurance = medicalInsurance;
                        encounterServiceNew.refreshEncounter($routeParams.practiceId, $scope.encounterType, $scope.encounter)
                            .then(function (encounter) {
                            $scope.encounter = encounter;
                            _this.getInsurerProcedures();
                        });
                    }
                });
            };
            $scope.searchInsurerProcedures = function () {
                $location.path('/' + _this.$routeParams.practiceId + '/search-medical-insurer-procedure');
                $location.hash('clinical');
            };
            $scope.changeEncounterType = function () {
                var nonMedicalInsuranceTypes = [
                    Controller.MEDICAL_AID_CLAIM,
                    Controller.CASHCLAIM,
                    Controller.ZEROCLAIM
                ];
                if (nonMedicalInsuranceTypes.indexOf($scope.encounterType) > -1 &&
                    nonMedicalInsuranceTypes.indexOf($scope.encounter.EncounterType) > -1) {
                    $scope.encounter.EncounterType = $scope.encounterType;
                }
                else {
                    modalService.confirm("The invoice type has changed to <b>" +
                        $scope.encounterType.replace(/([A-Z])/g, ' $1').toLowerCase() +
                        "</b> <br><br>All captured information will be cleared." +
                        "<br><br>Click OK to continue", ModalModule.ModalWidth._400px)
                        .then(function () {
                        encounterServiceNew.refreshEncounter($routeParams.practiceId, $scope.encounterType, $scope.encounter)
                            .then(function (encounter) {
                            $scope.encounter = encounter;
                            _this.encounterServiceNew.setEncounter(_this.$scope.encounter);
                            _this.getInsurerProcedures();
                            _this.applyMedicalInsuranseAllows();
                        });
                    })
                        .catch(function () {
                        $scope.encounterType = $scope.encounter.EncounterType;
                    });
                }
            };
            $scope.save = function () {
                _this.appendTimeOfService();
                $scope.encounter.ClinicalMetrics = $scope.clinicalMetricsOptions.getClinicalMetrics();
                _this.encounterServiceNew.saveEncounter(_this.$routeParams.practiceId, $scope.encounter)
                    .then(function (response) {
                    if (response.Sucess) {
                        encounterServiceNew.clearEncounterCache();
                        locationService.goToHome(_this.$routeParams.practiceId);
                    }
                    else {
                        showDialog.error(response.ResponseMessage, ModalModule.ModalWidth._500px);
                    }
                })
                    .catch(function (error) {
                    showDialog.error(error, ModalModule.ModalWidth._500px);
                });
            };
            $scope.changeHospitalDate = function (first) {
                if (first) {
                    $scope.configTo.min = $scope.admissionDate;
                }
                else {
                    $scope.configFrom.max = $scope.dischargeDate;
                }
                _this.updateHospitalDates();
            };
            $scope.switchHospitalDates = function () {
                $scope.showHospitalDates = !$scope.showHospitalDates;
                if ($scope.showHospitalDates) {
                    _this.$scope.admissionDate = _this.encounterServiceNew.getConsultationDate();
                    _this.$scope.dischargeDate = _this.encounterServiceNew.getConsultationDate();
                }
                else {
                    _this.$scope.admissionDate = null;
                    _this.$scope.dischargeDate = null;
                }
                _this.updateHospitalDates();
            };
            $scope.onTimeOfServiceChange = function (newValue, oldValue) {
                _this.appendTimeOfService();
            };
            $scope.changeConsultationDate = function (date) {
                var consMoment = moment(new Date(date));
                encounterServiceNew.setConsultationDate(consMoment);
                $scope.consultationDate = consMoment.format(Controller.DATE_OUT_PATTERN);
                $scope.encounter.EncounterLineItems.EncounterHeader.DateOfService = consMoment.format();
                _this.appendTimeOfService();
                var certificate = $scope.encounter.MedicalCertificate;
                if (certificate) {
                    certificate.ExaminationDate = consMoment.format();
                }
                _this.encounterServiceNew.getSpecificRule(_this.$routeParams.practiceId, $scope.encounter.PatientEventDetails.Patient.PatientId, consMoment.format('YYYY-MM-DD'))
                    .then(function (response) {
                    _this.$scope.specificRule = response.Data;
                });
            };
            $scope.clickWarning = function () {
                if ($scope.specificRule) {
                    showDialog.warning($scope.specificRule.Description);
                }
            };
            $scope.clickInvalidCodeWarning = function () {
                showDialog.warning("The following code(s) are no longer valid: " +
                    "<br>" +
                    $scope.invalidCodes.map(function (item) {
                        return item.Code + " " + item.Description.slice(0, 20).concat('...');
                    })
                        .join("<br>"));
            };
            $scope.refreshPrice = function () {
                $rootScope.showWaitingScreen = true;
                _this.updateMedicationPrices();
                encounterServiceNew.priceEncounter(_this.$routeParams.practiceId, $scope.encounter)
                    .then(function (response) {
                    if (response.Sucess === false) {
                        if (response.ResponseCode === 500) {
                            $scope.updatePricingErrorMessage = "Unable to price invoice, please try again later";
                        }
                        else if (response.ResponseCode === 400 || response.ResponseCode > 500) {
                            $scope.updatePricingErrorMessage = response.ResponseMessage;
                        }
                        _this.modalService.error($scope.updatePricingErrorMessage);
                        $scope.encounter.EncounterLineItems.LineItems
                            .filter(function (item) { return item.LineType === "Procedure"; })
                            .forEach(function (procedure) {
                            procedure.Amount = 0;
                        });
                    }
                    else {
                        $scope.updatePricingErrorMessage = "";
                    }
                })
                    .finally(function () {
                    $rootScope.showWaitingScreen = false;
                });
            };
            $scope.clickPricingError = function (errorMessage) {
                _this.modalService.error(errorMessage);
            };
            $scope.openSickNote = function (openForEdit) {
                if (!openForEdit && $scope.encounter.MedicalCertificate) {
                    $scope.encounter.MedicalCertificate = null;
                    return;
                }
                encounterServiceNew.openSickNote($scope.encounter)
                    .then(function (encounter) {
                    $scope.encounter.MedicalCertificate = encounter.MedicalCertificate;
                });
            };
            $scope.getListDiagnoses = function () {
                var diagnoses = $scope.encounter.MedicalCertificate.Diagnoses;
                if (diagnoses) {
                    return diagnoses.map(function (item) {
                        return item.DiagnosisCode;
                    })
                        .join(',');
                }
                return '';
            };
            $scope.goToDashboard = function () {
                _this.populateClinicalMetrics();
                trackingService.openedPatientDashboard($scope.encounter.PatientEventDetails);
                locationService.goToClinicalDashboard($routeParams.practiceId, $scope.encounter.PatientEventDetails.Patient.PatientId);
            };
            $scope.$watch('encounter.EncounterLineItems.EncounterHeader.HospitalIndicator', function () {
                var encounterHeader = $scope.encounter.EncounterLineItems.EncounterHeader;
                var date = _this.encounterServiceNew.getConsultationDate();
                if (encounterHeader.HospitalIndicator) {
                    _this.updateHospitalDates();
                    var configFrom = new DatePickerModule.Config();
                    configFrom.format = 'dd MM, yy';
                    configFrom.max = _this.$scope.dischargeDate;
                    _this.$scope.configFrom = configFrom;
                    var configTo = new DatePickerModule.Config();
                    configTo.format = 'dd MM, yy';
                    configTo.min = _this.$scope.admissionDate;
                    _this.$scope.configTo = configTo;
                }
            });
            $scope.$watchCollection('encounter.EncounterLineItems.LineItems', function () {
                $scope.totalPrice = encounterServiceNew
                    .getTotalPrice($scope.encounter.EncounterLineItems.LineItems);
                _this.updateMedicineStatus();
            });
            $scope.editedNote = function (eventType, note) {
                if (note) {
                    trackingService.editedNotes(eventType, $scope.encounter);
                }
            };
            $scope.summaryOfCareClick = function (value, type) {
                var message = '';
                switch (type) {
                    case 'ChronicConditions':
                        message = '<div class="flexbox"><span class="conditionsico mr-3"></span><span class="mt-2">' + value.join(', ') + '</span></div>';
                        break;
                    case 'Allergies':
                        message = '<div class="flexbox"><span class="allergiesico mr-3"></span><span class="mt-2">' + value.join(', ') + '</span></div>';
                        break;
                    case 'AllergiesNote':
                        message = '<div class="flexbox"><span class="notesico mr-3"></span><span class="mt-2">' + value + '</span></div>';
                        break;
                    case 'ClinicalNotes':
                        message = '<div class="flexbox"><span class="notesico mr-3"></span><span class="mt-2">' + value + '</span></div>';
                        break;
                    default:
                        return;
                }
                if (message.length > 6) {
                    _this.modalService.info(message, ModalModule.ModalWidth._600px);
                }
            };
            $scope.schemeRuleHeadWarning = function () {
                modalService.warning('Your visit contains one or more medicine items that are not on ' +
                    'the Discovery KeyCare acute formulary. Please check your ' +
                    'medicine items for more information.', ModalModule.ModalWidth._500px);
            };
            $scope.showModifierWarning = function (line) {
                var keys = Object.keys(line.Responses);
                var values = keys.map(function (v) { return line.Responses[v]; });
                showDialog.warning(values.join());
            };
            $scope.captureDocuments = function (first) {
                var token = _this.storageService.getAuthorizationData().token;
                var category = first ? 'Billing Instruction' : 'Clinical Notes';
                var patientDocument = $scope.encounter.PatientDocuments &&
                    $scope.encounter.PatientDocuments.filter(function (doc) { return doc.Category === category; }).shift();
                var url = GlobalVar.patientFilesUrl +
                    "deeplink-login" +
                    "?practice_id=" +
                    $routeParams.practiceId +
                    "&patient_id=" +
                    $scope.encounter.PatientEventDetails.Patient.PatientId +
                    "&category=" +
                    category +
                    "&reference_id=" +
                    $scope.encounter.EncounterId +
                    "&token=" +
                    token +
                    "&random=" +
                    (new Date()).getTime() +
                    Math.floor(Math.random() * 1000000);
                var showCaptureHealthDocDialog = function () {
                    modalService.showCaptureHealthDocDialog(url, "myPatientFiles")
                        .then(function (capturedDocumentId) {
                        if (capturedDocumentId) {
                            return _this.dashboardService.getDocumentInfoById($routeParams.practiceId, capturedDocumentId);
                        }
                        return null;
                    })
                        .then(function (document) {
                        if (document) {
                            if (first) {
                                $scope.billingInstructionThumbnail =
                                    _this.dashboardService.getDocumentUrl(_this.$routeParams.practiceId, document.DocumentUrl);
                            }
                            else {
                                $scope.clinicalNoteThumbnail =
                                    _this.dashboardService.getDocumentUrl(_this.$routeParams.practiceId, document.DocumentUrl);
                            }
                            if (!$scope.encounter.PatientDocuments) {
                                $scope.encounter.PatientDocuments = [];
                            }
                            var wasInside = false;
                            $scope.encounter.PatientDocuments.map(function (doc) {
                                if (doc.Category === category) {
                                    wasInside = true;
                                    return {
                                        Category: category,
                                        DocumentUrl: document.DocumentUrl
                                    };
                                }
                                return doc;
                            });
                            if (!wasInside) {
                                $scope.encounter.PatientDocuments.push(angular.extend(new Domain.Clinical.PatientDocument, {
                                    Category: category,
                                    DocumentUrl: document.DocumentUrl
                                }));
                            }
                        }
                    });
                };
                if (patientDocument && patientDocument.DocumentUrl) {
                    modalService
                        .confirm("Previously attached image will be replaced with newly uploaded.<br>Are you sure you want to continue?")
                        .then(function () {
                        return _this.dashboardService.removeDocument($routeParams.practiceId, patientDocument.DocumentUrl.match(/(\/.*?(\/))(.*?)(?=\.)/).pop());
                    })
                        .then(function () {
                        if (first) {
                            $scope.billingInstructionThumbnail = "";
                        }
                        else {
                            $scope.clinicalNoteThumbnail = "";
                        }
                        $scope.encounter.PatientDocuments.splice($scope.encounter.PatientDocuments.indexOf(patientDocument), 1);
                        showCaptureHealthDocDialog();
                    });
                }
                else {
                    showCaptureHealthDocDialog();
                }
            };
            this.init();
        }
        Controller.prototype.appendTimeOfService = function () {
            var consultationDate = this.moment(this.encounterServiceNew.getConsultationDate()).local();
            if (this.$scope.timeOfServiceStr) {
                var timePart = this.moment.utc(this.$scope.timeOfServiceStr, ['h:m a', 'H:m']);
                consultationDate.hour(timePart.hour()).minute(timePart.minute());
                this.encounterServiceNew.setConsultationDate(consultationDate);
                this.$scope.encounter.EncounterLineItems.EncounterHeader.DateOfService = consultationDate.utc().format(ServerDateFormat);
            }
        };
        Controller.prototype.init = function () {
            var _this = this;
            this.$rootScope.showProgressScreen = true;
            this.$scope.refferalTemplates = [];
            this.$scope.myTemplates = [];
            this.$scope.templates = [];
            this.$scope.encounter = new Domain.Clinical.Encounter();
            this.$scope.totalPrice = 0;
            var patientEventId = this.$routeParams.patientVisitId;
            this.encounterServiceNew.getProvider(this.$routeParams.practiceId)
                .then(function (provider) {
                _this.$scope.isIHealthProvider = (provider.PracticeXRef || '').startsWith("iHealth");
                return _this.encounterServiceNew.getProviderOptions(provider);
            })
                .then(function (options) {
                _this.$scope.options = options;
                _this.$scope.controlTemplate = {
                    selectTemplate: function (template) {
                        _this.$scope.selectTemplate(template);
                    },
                    searchSelect: function () {
                        _this.populateClinicalMetrics();
                    },
                    isMedicine: options.isDispensing,
                    isClinical: true,
                    isPrescription: options.isEnabledForMedicationPrescriptions
                };
                _this.$scope.myPatientFilesEnabled = options.myPatientFilesEnabled;
                _this.applyUserDefinedLayout();
            });
            this.clinicalTemplateServiceNew.getTemplatesByEncounter(this.$routeParams.practiceId, patientEventId)
                .then(function (templates) {
                _this.$scope.templates = templates;
                _this.$scope.memoryRefferalTemplates = _this
                    .$filter('filter')(templates, { TemplateType: Controller.COMMUNICATIONS }, true);
                var myTemplates = templates.filter(function (template) { return template.TemplateType === Controller.MY_TEMPLATE; });
                _this.$scope.myTemplates = _this.templatePanelService.mixTemplateAndSubGroups(myTemplates, Controller.MY_TEMPLATE);
                _this.encounterServiceNew.getRefferalTemplates(_this.$routeParams.practiceId, '00000000-0000-0000-0000-000000000000')
                    .then(function (referrals) {
                    var template = referrals[0];
                    var clinicalTemplate = new Domain.Clinical.Template();
                    clinicalTemplate.Caption = template.TemplateName;
                    clinicalTemplate.Description = "Built-in Referral";
                    clinicalTemplate.TemplateId = '00000000-0000-0000-0000-100000000000';
                    clinicalTemplate.PracticeId = template.PracticeId;
                    clinicalTemplate.TemplateType = template.TemplateName;
                    var communication = new Domain.Clinical.Communication();
                    communication.CommunicationTemplateId = template.TemplateId;
                    communication.CommunicationId = '00000000-0000-0000-0000-000000000000';
                    communication.Type = template.TemplateName;
                    communication.Title = template.TemplateName;
                    clinicalTemplate.Communications = [communication];
                    _this.$scope.memoryRefferalTemplates.push(clinicalTemplate);
                });
            })
                .catch(this.catchError);
            this.loadEncounter(patientEventId)
                .then(function (encounter) {
                _this.$scope.encounter = encounter;
                _this.updateAccount(encounter.PatientEventDetails);
                _this.updateClinicalMetrics(encounter);
                _this.initConsultationDate(encounter);
                _this.updatePractice(encounter);
                _this.initSaveTemplate();
                _this.searchService.eventId = encounter.EncounterId;
                _this.getInsurerProcedures();
                _this.applySpecialityRules()
                    .finally(function () {
                    _this.$rootScope.showProgressScreen = false;
                });
                var patientId = encounter.PatientEventDetails.Patient.PatientId;
                _this.$scope.referringDoctorIndicator = encounter.ReferringDoctorName != null ||
                    encounter.ReferringDoctorPracticeNumber != null;
                _this.$scope.referringDoctor = new SupportingProviderVo();
                _this.$scope.referringDoctor.FriendlyName = encounter.ReferringDoctorName;
                _this.$scope.referringDoctor.TreatingPracticeNumber = encounter.ReferringDoctorPracticeNumber;
                if (encounter.EncounterLineItems.EncounterHeader.HospitalIndicator) {
                    var admissionDate = encounter.EncounterLineItems.EncounterHeader.AdmissionDateTime;
                    var dischargeDate = encounter.EncounterLineItems.EncounterHeader.DischargeDateTime;
                    _this.$scope.admissionDate = admissionDate ? _this.moment(admissionDate) : null;
                    _this.$scope.dischargeDate = dischargeDate ? _this.moment(dischargeDate) : null;
                    _this.$scope.showHospitalDates = !!(admissionDate || dischargeDate);
                    encounter.EncounterLineItems.EncounterHeader.PlaceOfService = Controller.INPATIENT_HOSPITAL;
                }
                if (!encounter.EncounterLineItems.EncounterHeader.PlaceOfService) {
                    encounter.EncounterLineItems.EncounterHeader.PlaceOfService = Controller.CONSULTING_ROOMS;
                }
                _this.$scope.assistingDoctorIndicator = encounter.AssistingDoctorName != null ||
                    encounter.AssistingDoctorPracticeNumber != null;
                _this.$scope.assistingDoctor = new SupportingProviderVo();
                _this.$scope.assistingDoctor.FriendlyName = encounter.AssistingDoctorName;
                _this.$scope.assistingDoctor.TreatingPracticeNumber = encounter.AssistingDoctorPracticeNumber;
                if (_this.$scope.encounter.PatientDocuments) {
                    var billingIstr = _this.$scope.encounter.PatientDocuments
                        .filter(function (doc) { return doc.Category === 'Billing Instruction'; })
                        .shift();
                    var clinicalnotes = _this.$scope.encounter.PatientDocuments
                        .filter(function (doc) { return doc.Category === 'Clinical Notes'; })
                        .shift();
                    _this.$scope.billingInstructionThumbnail = billingIstr
                        ? _this.dashboardService.getDocumentUrl(_this.$routeParams.practiceId, billingIstr.DocumentUrl)
                        : '';
                    _this.$scope.clinicalNoteThumbnail = clinicalnotes
                        ? _this.dashboardService.getDocumentUrl(_this.$routeParams.practiceId, clinicalnotes.DocumentUrl)
                        : '';
                }
                _this.dashboardService.getAvatar(_this.$routeParams.practiceId, _this.$scope.encounter.PatientEventDetails.Patient.PatientId)
                    .then(function (patientDocument) {
                    if (patientDocument) {
                        _this.$scope.avatar = _this.dashboardService.getDocumentUrl(_this.$scope.encounter.PatientEventDetails.Patient.PatientId, patientDocument.ThumbnailUrl) + "&r=" + patientDocument.FileName;
                    }
                });
                _this.encounterServiceNew.getProviderBranches(_this.$routeParams.practiceId).then(function (branches) {
                    _this.$scope.providerBranches = branches;
                    if (branches.length > 0) {
                        _this.$scope.encounter.BranchXRef = _this.$scope.encounter.BranchXRef || _this.$scope.providerBranches[0].BranchXRef;
                        _this.$scope.branchXRef = _this.$scope.encounter.BranchXRef;
                        for (var i = 0; i < _this.$scope.providerBranches.length; i++) {
                            var branch = _this.$scope.providerBranches[i];
                            if (branch.BranchXRef == _this.$scope.branchXRef) {
                            }
                        }
                    }
                });
                return _this.encounterServiceNew.getSpecificRule(_this.$routeParams.practiceId, patientId, _this.getDateOfService(encounter).format('YYYY-MM-DD'));
            })
                .then(function (response) {
                if (response.Sucess) {
                    _this.$scope.specificRule = response.Data;
                }
                else {
                    _this.$log.error(response);
                }
            })
                .catch(function (e) {
                _this.$rootScope.showProgressScreen = false;
                _this.catchError(e);
            });
        };
        Controller.prototype.applySpecialityRules = function () {
            var _this = this;
            var specialityCode = this.encounterServiceNew.originalEncounter.Provider.SpecialityCode;
            return this.encounterServiceNew.getSpecialityRuleByCode(specialityCode)
                .then(function (response) {
                var allows = new FeatureAllows();
                if (response && response.Options) {
                    for (var optionId in response.Options) {
                        var optionValue = response.Options[optionId];
                        if (allows.hasOwnProperty(optionId)) {
                            allows[optionId] = optionValue.toLowerCase() === "true";
                        }
                    }
                }
                _this.$scope.featuresAllows = allows;
                _this.$scope.memoryFeaturesAllows = allows;
                _this.applyMedicalInsuranseAllows();
            });
        };
        Controller.prototype.applyMedicalInsuranseAllows = function () {
            if (this.$scope.encounter.EncounterType === Controller.MEDICAL_INSURANCE) {
                this.$scope.featuresAllows = this.encounterServiceNew.getMedicalInsuranseAllows();
            }
            else {
                this.$scope.featuresAllows = this.$scope.memoryFeaturesAllows;
            }
        };
        Controller.prototype.getInsurerProcedures = function () {
            var _this = this;
            if (this.$scope.encounter.EncounterType === Controller.MEDICAL_INSURANCE &&
                this.$scope.encounter.MedicalInsurance) {
                var insurerXRef = null;
                if (this.$scope.encounter.MedicalInsurance.MedicalInsurer != null) {
                    insurerXRef = this.$scope.encounter.MedicalInsurance.MedicalInsurer.InsurerXRef;
                }
                this.encounterServiceNew.getInsurerProcedures(this.$routeParams.practiceId, this.$scope.encounter.EncounterId, insurerXRef).then(function (response) {
                    _this.encounterServiceNew.setMemoryInsurerProcedures(response);
                    _this.$scope.insurerProcedures = response;
                });
            }
        };
        Controller.prototype.openReferringSupportingProvider = function (providers) {
            var _this = this;
            this.modalService
                .openSupportingProvider(providers, this.$scope.referringDoctor, "Referring Provider")
                .then(function (provider) {
                _this.$scope.referringDoctor = provider;
                _this.$scope.updateReferringDoctor(provider);
            });
        };
        Controller.prototype.openAssistingSupportingProvider = function (providers) {
            var _this = this;
            this.modalService
                .openSupportingProvider(providers, this.$scope.assistingDoctor, "Assisting Provider")
                .then(function (provider) {
                _this.$scope.assistingDoctor = provider;
                _this.$scope.updateAssistingDoctor(provider);
            });
        };
        Controller.prototype.populateClinicalMetrics = function () {
            this.$scope.encounter.ClinicalMetrics = this.$scope.clinicalMetricsOptions.getClinicalMetrics();
        };
        Controller.prototype.updateMedicationPrices = function () {
            var lineItems = this.$scope.encounter.EncounterLineItems.LineItems;
            if (this.$scope.specificRule && lineItems) {
                for (var i = 0; i < lineItems.length; i++) {
                    if (lineItems[i].LineType === "Medicine" && this.$scope.specificRule.ZeroMedicine ||
                        lineItems[i].LineType === "Consumable" && this.$scope.specificRule.ZeroConsumable) {
                        if (lineItems[i].TotalIncVat === 0) {
                            lineItems[i].PriceOverride = !lineItems[i].ChronicIndicator;
                            lineItems[i].TotalIncVat = 0.00;
                        }
                    }
                }
            }
        };
        Controller.prototype.editReferralTemplate = function (communication) {
            var _this = this;
            var communicationTemplateBody = this.encounterServiceNew
                .getCommunicationBodyById(communication.CommunicationId);
            this.modalService.openLetterEditor(communication, communicationTemplateBody)
                .then(function (response) {
                var practiceId = _this.$scope.encounter.PatientEventDetails.PracticeId;
                _this.encounterServiceNew
                    .setCommunicationBodyById(communication.CommunicationId, response.templateBody);
                communication.Title = response.communication.Title;
                _this.encounterServiceNew.updateCommunicationBody(practiceId, _this.$scope.encounter.EncounterId, communication);
            });
        };
        Controller.prototype.applyUserDefinedLayout = function () {
            var options = this.$scope.options;
            var customLayoutOrder = options.consultationCustomLayoutOrder || '';
            var items = customLayoutOrder.split(",");
            var allowedIds = ['1', '2', '3', '4'];
            if (items.length !== 4) {
                items = allowedIds;
            }
            var newOrderItems = [];
            for (var k = 0; k < items.length; k++) {
                var itemConfig = items[k].split(":");
                var containerId = itemConfig[0].trim();
                var height = itemConfig.length === 2 ? parseInt(itemConfig[1]) : 0;
                if (allowedIds.indexOf(containerId) !== -1) {
                    newOrderItems.push({ id: containerId, height: height });
                }
            }
            this.$scope.customLayoutOrder = newOrderItems;
        };
        Controller.prototype.updateAccount = function (patientEvent) {
            var _this = this;
            var savePatient = this.$rootScope.selectedPatient;
            if (savePatient) {
                patientEvent.Patient = savePatient;
            }
            var patient = patientEvent.Patient;
            this.$scope.accountDetails = patient.PatientAccountDetails;
            this.$scope.fullName = patient.PatientDetails.FirstName + ' ' + patient.PatientDetails.Surname;
            var scheme = '';
            if (patient.PatientAccountDetails) {
                scheme = patient.PatientAccountDetails.MedicalAidName;
                if (patient.PatientAccountDetails.MedicalAidPlan) {
                    scheme = scheme.concat(" / " + patient.PatientAccountDetails.MedicalAidPlan);
                    if (patient.PatientAccountDetails.MedicalAidPlanOption) {
                        scheme = scheme.concat(" / " + patient.PatientAccountDetails.MedicalAidPlanOption);
                    }
                }
            }
            if (this.$scope.encounter.MedicalInsurance && patient.PatientDetails.IdentityNo) {
                this.$scope.encounter.MedicalInsurance.PatientIdentityNo = patient.PatientDetails.IdentityNo;
            }
            this.$scope.fullSchemeName = scheme || "";
            this.dashboardService.getPatientDashboardHeader(this.$routeParams.practiceId, patient.PatientId)
                .then(function (response) {
                if (response) {
                    _this.$scope.patientDashboard = response;
                }
            });
        };
        Controller.prototype.initSaveTemplate = function () {
            var selectedTemplate = this.searchService.getSelectedTemplate();
            if (selectedTemplate) {
                this.addTemplateToEncounter(selectedTemplate);
            }
        };
        Controller.prototype.addTemplateToEncounter = function (template) {
            var _this = this;
            return this.encounterServiceNew.addTemplateToEncounter(this.$routeParams.practiceId, this.$scope.encounter, template)
                .then(function (result) {
                _this.$scope.encounter = result.MergedEncounter;
                _this.$scope.encounter.ClinicalMetrics = _this.$scope.clinicalMetricsOptions.getClinicalMetrics();
                _this.encounterServiceNew.setEncounter(_this.$scope.encounter);
                _this.$scope.invalidCodes = result.Errors;
                _this.searchService.saveSelectedTemplate(null);
                if (template.Communications != null && template.Communications.length > 0) {
                    var communication = _this.$scope.encounter.Communications[_this.$scope.encounter.Communications.length - 1];
                    _this.$scope.editCommunicationItem(communication);
                }
                return _this.$scope.encounter;
            });
        };
        Controller.prototype.loadEncounter = function (patientEventId) {
            var _this = this;
            var practiceId = this.$routeParams.practiceId;
            return this.encounterServiceNew.getEncounterByPatientEventId(practiceId, patientEventId, true)
                .then(function (encounterResponse) {
                var encounter = _this.encounterServiceNew.getEncounter();
                if (encounter &&
                    encounter.PatientEventDetails.PatientEventId === patientEventId &&
                    encounter.EncounterId === encounterResponse.EncounterId) {
                    encounter.PatientEventDetails = encounterResponse.PatientEventDetails;
                    return _this.$q.when(encounter);
                }
                _this.encounterServiceNew.clearEncounterCache();
                _this.encounterServiceNew.setEncounter(encounterResponse);
                _this.encounterServiceNew.setOriginalEncounter(encounterResponse);
                return encounterResponse;
            })
                .catch(function (error) {
                _this.$log.error(error);
                _this.locationService.goToInvoice(practiceId, patientEventId);
                return null;
            });
        };
        Controller.prototype.updatePractice = function (encounter) {
            var patient = this.$rootScope.selectedPatient;
            if (patient) {
                encounter.PatientEventDetails.Patient = patient;
                this.$rootScope.selectedPatient = null;
            }
            this.setEncounterType(encounter);
        };
        Controller.prototype.setEncounterType = function (encounter) {
            if (!encounter.EncounterType) {
                encounter.EncounterType = Controller.MEDICAL_AID_CLAIM;
            }
            if (encounter.PatientEventDetails.Patient.PatientAccountDetails.IsCashAccount &&
                encounter.EncounterType == Controller.MEDICAL_AID_CLAIM) {
                encounter.EncounterType = Controller.CASHCLAIM;
            }
            this.$scope.encounterType = encounter.EncounterType;
        };
        Controller.prototype.updateMedicineStatus = function () {
            var chronicChecked = 0;
            var notAllowed = 0;
            var medicineItems = this.$filter('filter')(this.$scope.encounter.EncounterLineItems.LineItems, { LineType: EventTypeUtil.getNameByType(EventType.MEDICINE) });
            for (var _i = 0; _i < medicineItems.length; _i++) {
                var lineItem = medicineItems[_i];
                if (lineItem.SchemeRule === Controller.NOT_ALLOWED) {
                    notAllowed++;
                    if (lineItem.ChronicIndicator) {
                        chronicChecked++;
                    }
                }
            }
            this.$scope.medicineSchemeWarning = !(chronicChecked === notAllowed) && notAllowed > 0;
        };
        Controller.prototype.updateClinicalMetrics = function (encounter) {
            this.$scope.clinicalMetricsOptions.gender =
                this.$scope.encounter.PatientEventDetails.Patient.PatientDetails.Gender;
            this.$scope.clinicalMetricsOptions.metrics = this.$scope.encounter.ClinicalMetrics;
        };
        Controller.prototype.initConsultationDate = function (encounter) {
            var consDate = this.encounterServiceNew.getConsultationDate();
            if (!consDate) {
                consDate = this.getDateOfService(encounter);
                this.encounterServiceNew.setConsultationDate(consDate);
            }
            this.$scope.timeOfServiceStr = consDate.minutes() == 0 && consDate.hours() == 0 ? "" : consDate.local().format('LT');
            this.$scope.consultationDate = consDate.local().format(Controller.DATE_OUT_PATTERN);
        };
        Controller.prototype.updateHospitalDates = function () {
            if (this.$scope.admissionDate && this.$scope.admissionDate.isValid()) {
                this.$scope.encounter.EncounterLineItems.EncounterHeader.AdmissionDateTime =
                    this.$scope.admissionDate.hours(12).minutes(0).format();
            }
            else {
                this.$scope.encounter.EncounterLineItems.EncounterHeader.AdmissionDateTime = null;
            }
            if (this.$scope.dischargeDate && this.$scope.dischargeDate.isValid()) {
                this.$scope.encounter.EncounterLineItems.EncounterHeader.DischargeDateTime =
                    this.$scope.dischargeDate.hours(13).minutes(0).format();
            }
            else {
                this.$scope.encounter.EncounterLineItems.EncounterHeader.DischargeDateTime = null;
            }
        };
        Controller.prototype.getDateOfService = function (encounter) {
            var dateOfService = this.getValidDate(encounter.EncounterLineItems.EncounterHeader.DateOfService);
            if (!dateOfService && encounter && encounter.PatientEventDetails) {
                var event = encounter.PatientEventDetails;
                dateOfService = this.getValidDate(event.CheckInTime) || this.getValidDate(event.ScheduledTime);
            }
            if (dateOfService) {
                return dateOfService;
            }
            return this.moment.utc();
        };
        Controller.prototype.goToNext = function () {
            var _this = this;
            this.encounterServiceNew.next(this.$routeParams.practiceId, this.$scope.encounter)
                .catch(function (error) {
                _this.showDialog.error(error.ResponseMessage)
                    .then(function () {
                    if (error.ResponseCode === 511) {
                        var patientId = _this.$scope.encounter.PatientEventDetails.Patient.PatientId;
                        _this.locationService.goToChangePatient(_this.$routeParams.practiceId, patientId);
                    }
                });
            });
        };
        Controller.prototype.submitEncounter = function () {
            var _this = this;
            var encounter = this.$scope.encounter;
            var practiceId = this.$routeParams.practiceId;
            var patientId = encounter.PatientEventDetails.Patient.PatientId;
            var consultationReports = this.encounterServiceNew.isAnyConsultationReport(encounter);
            if (consultationReports.length > 0) {
                this.locationService.goToConsultationReport(practiceId, patientId, consultationReports[0]);
            }
            else {
                this.encounterServiceNew.submitEncounter(practiceId, encounter)
                    .then(function () {
                    _this.locationService.goToHome(practiceId);
                })
                    .catch(function (error) {
                    _this.showDialog.error(error, ModalModule.ModalWidth._500px);
                });
            }
        };
        Controller.prototype.getValidDate = function (dateStr) {
            var date = this.moment.utc(dateStr);
            if (date.isValid()) {
                return date;
            }
        };
        Controller.MY_TEMPLATE = 'MyTemplate';
        Controller.COMMUNICATIONS = 'Communications';
        Controller.DATE_OUT_PATTERN = 'D MMMM, YYYY';
        Controller.MEDICAL_AID_CLAIM = 'MedicalAidInvoice';
        Controller.CASHCLAIM = 'CashInvoice';
        Controller.ZEROCLAIM = 'NoChargeInvoice';
        Controller.MEDICAL_INSURANCE = 'MedicalInsurance';
        Controller.NOT_ALLOWED = 'not allowed';
        Controller.NOT_APPLICABLE = 'not applicable';
        Controller.ALLOWED = 'allowed';
        Controller.NOT_SUPPORTED = 'not supported';
        Controller.VIEWED = 'viewed';
        Controller.NOT_VIEWED = 'not viewed';
        Controller.CONSULTATION = "consultation";
        Controller.METRICS = "clinical metrics";
        Controller.CONSULTING_ROOMS = 11;
        Controller.INPATIENT_HOSPITAL = 21;
        Controller.DAY_CLINIC = 24;
        Controller.PROCEDURES_NOT_TELEHEALT_SPECIFIC = ['0130', 'VCONM', 'VCOMS', 'VCOMSC'];
        return Controller;
    })();
    EncounterModule.Controller = Controller;
})(EncounterModule || (EncounterModule = {}));
angular.module('DoctorApp')
    .controller('EncounterController', EncounterModule.Controller);
/// <reference path="../../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../../../scripts/definition/moment/moment-node.d.ts" />
/// <reference path="../../../services/api/domain/clinical.ts" />
/// <reference path="../../../services/api/result-api.ts" />
/// <reference path="../../../services/api/event-type.ts" />
/// <reference path="../../../services/provider-service.ts" />
/// <reference path="../../../services/tracking-service.ts" />
/// <reference path="../../components/modal/modal-service.ts"/>
/// <reference path="../reports/report-service.ts"/>
/// <reference path="../../../common/common.ts"/>
/// <reference path="../../clinical-dashboard/dashboard-service.ts"/>
/// <reference path="encounter.ts"/>
var EncounterModule;
(function (EncounterModule) {
    var FeatureAllows = Domain.Billing.FeatureAllows;
    (function (ReportType) {
        ReportType[ReportType["All"] = 0] = "All";
        ReportType[ReportType["Prescription"] = 1] = "Prescription";
        ReportType[ReportType["MedicalCertificate"] = 2] = "MedicalCertificate";
        ReportType[ReportType["Communication"] = 3] = "Communication";
    })(EncounterModule.ReportType || (EncounterModule.ReportType = {}));
    var ReportType = EncounterModule.ReportType;
    var HealthIDVisit = (function () {
        function HealthIDVisit() {
            this.practiceId = '';
            this.patientId = '';
            this.status = EncounterModule.Controller.NOT_SUPPORTED;
        }
        return HealthIDVisit;
    })();
    EncounterModule.HealthIDVisit = HealthIDVisit;
    var ValidateOptions = (function () {
        function ValidateOptions() {
        }
        return ValidateOptions;
    })();
    EncounterModule.ValidateOptions = ValidateOptions;
    var Service = (function () {
        Service.$inject = ["clinicalDomain", "modalService", "locationService", "$timeout", "dashboardService", "$window", "searchService", "$rootScope", "$q", "billingDomain", "funderConfiguration", "providerService", "showDialog", "trackingService"];
        function Service(clinicalDomain, modalService, locationService, $timeout, dashboardService, $window, searchService, $rootScope, $q, billingDomain, funderConfiguration, providerService, showDialog, trackingService) {
            "ngInject";
            this.clinicalDomain = clinicalDomain;
            this.modalService = modalService;
            this.locationService = locationService;
            this.$timeout = $timeout;
            this.dashboardService = dashboardService;
            this.$window = $window;
            this.searchService = searchService;
            this.$rootScope = $rootScope;
            this.$q = $q;
            this.billingDomain = billingDomain;
            this.funderConfiguration = funderConfiguration;
            this.providerService = providerService;
            this.showDialog = showDialog;
            this.trackingService = trackingService;
            this.communicationTemplates = [];
            this.healthIDVisit = new HealthIDVisit();
        }
        Service.prototype.getProviderOptions = function (provider) {
            return this.providerService.buildProviderOptions(provider);
        };
        Service.prototype.getProvider = function (providerId) {
            return this.billingDomain.getProvider(providerId);
        };
        Service.prototype.getTotalPrice = function (lineItems) {
            if (!lineItems) {
                return 0;
            }
            var total = 0;
            for (var i = 0; i < lineItems.length; i++) {
                if (lineItems[i].Amount) {
                    total += lineItems[i].Amount;
                }
                else if (lineItems[i].TotalIncVat) {
                    total += lineItems[i].TotalIncVat;
                }
            }
            return total;
        };
        Service.prototype.clearEncounterCache = function () {
            this.setEncounter(null);
            this.setOriginalEncounter(null);
            this.setConsultationDate(null);
            this.setMemoryInsurerProcedures(null);
        };
        Service.prototype.setConsultationDate = function (date) {
            this.consultationDate = date;
        };
        Service.prototype.getConsultationDate = function () {
            return this.consultationDate;
        };
        Service.prototype.setEncounter = function (newEncounter) {
            this.encounter = newEncounter;
        };
        Service.prototype.setOriginalEncounter = function (newEncounter) {
            this.originalEncounter = angular.copy(newEncounter);
        };
        Service.prototype.isEncounterChanged = function () {
            return this.originalEncounter.Status !== "Finalised" &&
                this.originalEncounter.Status !== "Cancelled" &&
                this.originalEncounter.Status !== "Completed" &&
                !angular.equals(this.encounter, this.originalEncounter);
        };
        Service.prototype.getEncounter = function () {
            return this.encounter;
        };
        Service.prototype.setPatientEvent = function (patientEventDetails) {
            this.patientEventDetails = patientEventDetails;
        };
        Service.prototype.getPatientEvent = function () {
            return this.patientEventDetails;
        };
        Service.prototype.getRefferalTemplates = function (practiceId, encounterId) {
            return this.clinicalDomain.getEncounterReferrals(practiceId, encounterId);
        };
        Service.prototype.getReferralHtml = function (practiceId, encounter, communication) {
            return this.clinicalDomain
                .renderEncounterCommunication(practiceId, encounter.EncounterId, communication.CommunicationId, encounter)
                .then(function (response) {
                return response.Data;
            });
        };
        Service.prototype.updateCommunicationBody = function (practiceId, encounterId, communication) {
            var communicationBody = this.getCommunicationBodyById(communication.CommunicationId);
            return this.clinicalDomain
                .updateEncounterCommunicationBody(practiceId, encounterId, communication.CommunicationId, communicationBody, communication.Title)
                .then(function (response) {
                return response.Data;
            });
        };
        Service.prototype.getCommunicationBodyById = function (communicationId) {
            return this.communicationTemplates[communicationId];
        };
        Service.prototype.setCommunicationBodyById = function (communicationId, templateBody) {
            this.communicationTemplates[communicationId] = templateBody;
        };
        Service.prototype.getTemplatesByEncounter = function (practiceId, encounterId) {
            return this.clinicalDomain.getTemplatesByEncounter(practiceId, encounterId);
        };
        Service.prototype.getSupportingProviders = function (practiceId, type) {
            return this.billingDomain.getDoctorsByBillingNumber(practiceId, type);
        };
        Service.prototype.getProviderBranches = function (practiceId) {
            return this.billingDomain.getBranches(practiceId);
        };
        Service.prototype.getEncounterByPatientEventId = function (practiceId, patientEventId, notShowError) {
            return this.clinicalDomain.getEncounterByPatientVisit(practiceId, patientEventId, null, notShowError);
        };
        Service.prototype.getEncounterById = function (practiceId, encounterId) {
            return this.clinicalDomain.getEncounter(practiceId, encounterId);
        };
        Service.prototype.getHistoricalMetrics = function (practiceId, patientId) {
            return this.clinicalDomain.getHistoricalMetrics(practiceId, patientId);
        };
        Service.prototype.addTemplateToEncounter = function (practiceId, encounter, template) {
            var _this = this;
            if (template.TemplateType === 'Diagnosis' && template.EncounterLineItems.EncounterHeader) {
                var diagnoses = template.EncounterLineItems.EncounterHeader.Diagnosis;
                for (var i = 0; i < diagnoses.length; i++) {
                    diagnoses[i].PrimaryIndicator = false;
                }
            }
            return this.clinicalDomain.mergeLineItemsByEncounter(practiceId, encounter, template)
                .then(function (response) {
                if (response.Sucess) {
                    _this.trackingService.itemAddedToEncounter(encounter, template);
                    _this.setUpPrimaryIndicator(response.Data.MergedEncounter.EncounterLineItems.EncounterHeader
                        .Diagnosis);
                    return response.Data;
                }
                return null;
            });
        };
        Service.prototype.setUpPrimaryIndicator = function (diagnoses) {
            if (diagnoses) {
                var setUp = false;
                for (var i = 0; i < diagnoses.length; i++) {
                    if (diagnoses[i].PrimaryIndicator) {
                        if (setUp) {
                            diagnoses[i].PrimaryIndicator = false;
                        }
                        setUp = true;
                    }
                }
                if (!setUp && diagnoses.length) {
                    diagnoses[0].PrimaryIndicator = true;
                }
            }
        };
        Service.prototype.removeLine = function (encounter, obj, type) {
            switch (type) {
                case EventType.DIAGNOSIS:
                    this.removeDiagnosisFromEncounter(encounter, obj);
                    break;
                case EventType.PRESCRIPTION:
                    this.removePrescriptionFromEncounter(encounter, obj);
                    break;
                case EventType.COMMUNICATION:
                    this.removeObjFromArray(encounter.Communications, obj);
                    break;
                case EventType.PROCEDURE:
                    this.removeProcedureFromEncounter(encounter, obj);
                    break;
                case EventType.MODIFIER:
                    this.removeModifierFromEncounter(encounter, obj);
                    break;
                default:
                    this.removeLineItemFromEncounter(encounter, obj);
            }
            this.setEncounter(encounter);
            this.trackingService.removedLineItemFromEncounter(encounter, obj, type);
        };
        Service.prototype.removeDiagnosisFromEncounter = function (encounter, diagnosis) {
            var diagnoses = encounter.EncounterLineItems.EncounterHeader.Diagnosis;
            this.removeObjFromArray(diagnoses, diagnosis);
            if (diagnosis.PrimaryIndicator && diagnoses.length) {
                diagnoses[0].PrimaryIndicator = true;
            }
            if (encounter.MedicalCertificate) {
                this.removeDiagnosis(encounter.MedicalCertificate.Diagnoses, diagnosis);
            }
            if (encounter.MedicationsPrescribed) {
                var lines = encounter.MedicationsPrescribed.MedicationPrescriptionLines;
                for (var i = 0; i < lines.length; i++) {
                    var diags = lines[i].Diagnosis;
                    this.removeDiagnosis(diags, diagnosis);
                }
            }
        };
        Service.prototype.removeModifierFromEncounter = function (encounter, line) {
            var lines = encounter.EncounterLineItems.LineItems;
            for (var i = 0; i < lines.length; i++) {
                if (lines[i].LineType === "Procedure" || lines[i].LineType === "Modifier") {
                    lines[i].Amount = 0;
                    lines[i].TotalIncVat = 0;
                    lines[i].PriceOverride = lines[i].LineType === "Procedure" ? false : lines[i].PriceOverride;
                }
            }
            this.removeObjFromArray(lines, line);
        };
        Service.prototype.removeProcedureFromEncounter = function (encounter, line) {
            var _this = this;
            var lines = encounter.EncounterLineItems.LineItems;
            var items = [line];
            for (var i = lines.indexOf(line) + 1; i < lines.length; i++) {
                if (lines[i].LineType === "Modifier") {
                    items.push(lines[i]);
                }
                else {
                    break;
                }
            }
            var hasModifiers = items.some(function (item) { return item.LineType === "Modifier"; });
            if (hasModifiers) {
                this.modalService.confirm("Removing this procedure will also remove the modifiers associated to them")
                    .then(function () {
                    for (var j = 0; j < items.length; j++) {
                        _this.removeObjFromArray(lines, items[j]);
                    }
                });
            }
            else {
                this.removeObjFromArray(lines, line);
            }
        };
        Service.prototype.removeLineItemFromEncounter = function (encounter, line) {
            var lines = encounter.EncounterLineItems.LineItems;
            this.removeObjFromArray(lines, line);
        };
        Service.prototype.removePrescriptionFromEncounter = function (encounter, line) {
            var lines = encounter.MedicationsPrescribed.MedicationPrescriptionLines;
            this.removeObjFromArray(lines, line);
        };
        Service.prototype.removeObjFromArray = function (arr, obj) {
            var index = arr.indexOf(obj);
            if (index > -1) {
                arr.splice(index, 1);
            }
        };
        Service.prototype.removeDiagnosis = function (diagnoses, diagnosis) {
            for (var i = 0; i < diagnoses.length; i++) {
                if (diagnoses[i].DiagnosisCode == diagnosis.DiagnosisCode) {
                    diagnoses.splice(i, 1);
                    break;
                }
            }
        };
        Service.prototype.getPrescriptionHistory = function (practiceId, patientId) {
            return this.clinicalDomain.getPrescriptionHistory(practiceId, patientId);
        };
        Service.prototype.showLineItem = function ($scope, obj, type, validateOptions) {
            var _this = this;
            switch (type) {
                case EventType.MODIFIER:
                    this.trackingService.openedDetailsDialog(this.encounter, obj, type);
                    if (obj) {
                        return this.clinicalDomain.getModifierInfo(this.encounter.PatientEventDetails.PracticeId, obj.ChargeCode)
                            .then(function (modifierInfo) {
                            var requiredParams = modifierInfo.RequiredParameters;
                            if (!((modifierInfo.ImplementationStatus === "Calculated" ||
                                modifierInfo.ImplementationStatus === "Parameters") &&
                                requiredParams.length === 0)) {
                                return _this.modalService.showModifierDetails(_this.encounter, obj, $scope.assistingDoctor);
                            }
                            _this.modalService.error("No additional modifier data required");
                        }, function () {
                            return _this.modalService.showModifierDetails(_this.encounter, obj, $scope.assistingDoctor);
                        });
                    }
                    return this.modalService.showModifierDetails(this.encounter, null, $scope.assistingDoctor);
                case EventType.PRESCRIPTION:
                    var prescriptionLine = obj;
                    this.trackingService.openedDetailsDialog(this.encounter, obj, type);
                    this.modalService
                        .openDetailsItem(prescriptionLine, type, validateOptions)
                        .then(function (model) {
                        angular.extend(prescriptionLine, model);
                    });
                    break;
                case EventType.DIAGNOSIS:
                    break;
                default:
                    var line = obj;
                    this.trackingService.openedDetailsDialog(this.encounter, obj, type);
                    return this.modalService
                        .openDetailsItem(line, type, validateOptions)
                        .then(function (model) {
                        if (!model.PriceOverride) {
                            if (model.LineType === 'Procedure') {
                                var priceByOne = line.TotalIncVat / line.ChargeQuan;
                                model.TotalIncVat = priceByOne * model.ChargeQuan;
                                model.Amount = priceByOne * model.ChargeQuan;
                            }
                            else {
                                model.TotalIncVat = line.TotalExcVat || model.TotalIncVat || 0;
                                model.UnitPrice = line.UnitPrice || model.UnitPrice || 0;
                                model.TotalExcVat = model.TotalExcVat || model.TotalExcVat || 0;
                            }
                        }
                        angular.extend(line, model);
                        $scope.totalPrice = _this
                            .getTotalPrice(_this.encounter.EncounterLineItems.LineItems);
                        return line;
                    });
            }
            return this.$q.reject();
        };
        Service.prototype.toggleDiagnosis = function (diagnoses, index) {
            for (var i = 0; i < diagnoses.length; i++) {
                diagnoses[i].PrimaryIndicator = false;
            }
            diagnoses[index].PrimaryIndicator = true;
            this.$timeout(function () {
                var diagnosis = angular.copy(diagnoses[index]);
                diagnoses.splice(index, 1);
                diagnoses.unshift(diagnosis);
            }, 400);
        };
        Service.prototype.mergePlaceOfService = function (practiceId, encounter) {
            return this.clinicalDomain
                .mergePlaceOfService(practiceId, encounter.EncounterId, encounter.EncounterLineItems)
                .then(function (response) {
                if (response.Sucess) {
                    encounter.EncounterLineItems = response.Data;
                    return encounter;
                }
            });
        };
        Service.prototype.setMemoryInsurerProcedures = function (procedures) {
            this.memoryInsurerProcedures = procedures;
        };
        Service.prototype.getMemoryInsurerProcedures = function () {
            return this.memoryInsurerProcedures;
        };
        Service.prototype.getInsurerProcedures = function (practiceId, encounterId, insurerXref) {
            return this.searchService.getInsurerProcedures(practiceId, encounterId, insurerXref);
        };
        Service.prototype.refreshEncounter = function (practiceId, encounterType, encounter) {
            return this.clinicalDomain.refreshEncounter(practiceId, encounterType, encounter)
                .then(function (response) {
                if (response.Sucess === true) {
                    encounter = response.Data;
                    return encounter;
                }
            });
        };
        Service.prototype.submitEncounter = function (practiceId, encounter) {
            var _this = this;
            var that = this;
            that.$rootScope.showProgressScreen = true;
            return this.clinicalDomain.submitEncounter(practiceId, encounter)
                .then(function (response) {
                if (response.Sucess === false) {
                    return that.$q.reject(response.ResponseMessage);
                }
                else {
                    that.$rootScope.showThankYou = true;
                    _this.healthIDVisit.status = response.Data.HealthIDViewed;
                    if (encounter && encounter.EncounterType === 'MedicalInsurance') {
                        _this.healthIDVisit.status = EncounterModule.Controller.NOT_SUPPORTED;
                    }
                    _this.healthIDVisit.practiceId = practiceId;
                    _this.healthIDVisit.patientId = encounter.PatientEventDetails.Patient.PatientId;
                    that.setConsultationDate(null);
                    that.setEncounter(null);
                    return response.Data;
                }
            })
                .finally(function () {
                that.$rootScope.showProgressScreen = false;
            });
        };
        Service.prototype.getHealthIDVisit = function () {
            return this.healthIDVisit;
        };
        Service.prototype.saveEncounter = function (practiceId, encounter) {
            return this.clinicalDomain.saveEncounter(practiceId, encounter);
        };
        Service.prototype.priceEncounter = function (practiceId, encounter, lineItem) {
            return this.clinicalDomain.setupPrice(practiceId, encounter)
                .then(function (response) {
                if (response.Sucess) {
                    var encounterResponse = response.Data;
                    if (lineItem) {
                        for (var item in encounter.EncounterLineItems.LineItems) {
                            if (encounter.EncounterLineItems.LineItems[item].NappiCode === lineItem.NappiCode) {
                                encounter.EncounterLineItems.LineItems[item] = encounterResponse.EncounterLineItems.LineItems
                                    .filter(function (i) { return i.NappiCode === lineItem.NappiCode; }).pop();
                            }
                        }
                    }
                    else {
                        encounter.EncounterLineItems.LineItems = encounterResponse.EncounterLineItems.LineItems;
                    }
                }
                return response;
            });
        };
        Service.prototype.getSpecialityRuleByCode = function (code) {
            return this.billingDomain.getSpecialityRulesByCode(code);
        };
        Service.prototype.next = function (practiceId, encounter) {
            var _this = this;
            var that = this;
            return this.clinicalDomain.validateEncounter(practiceId, encounter)
                .then(function (response) {
                if (response.Sucess === false) {
                    if (response.ResponseCode === 530) {
                        _this.showDialog
                            .confirm("You have already completed a patient visit for this patient on the selected day.  " +
                            "You may continue to finalise this encounter, " +
                            "which may result in a duplicate invoice and claim being sent.  Would you like to continue?")
                            .then(function () {
                            that.locationService.goToClinicalVisitOutcomes(practiceId);
                        });
                    }
                    else {
                        return that.$q.reject(response);
                    }
                }
                else {
                    var data = response.Data;
                    that.locationService.goToClinicalVisitOutcomes(practiceId);
                }
            });
        };
        Service.prototype.getMedicalInsuranseAllows = function () {
            var allows = new FeatureAllows();
            allows.AllowMedicine = false;
            allows.AllowConsumable = false;
            allows.AllowPrescription = false;
            allows.AllowDiagnosis = false;
            allows.AllowProcedure = false;
            allows.AllowMyTemplates = false;
            allows.AllowMedicalInsurance = true;
            return allows;
        };
        Service.prototype.openSickNote = function (encounter) {
            var config = new ModalModule.Config('Sick note', 'screens/consultation/modal/dialog/sicknote-details.html');
            return this.modalService.openDetails(encounter, config);
        };
        Service.prototype.isAnyConsultationReport = function (encounter) {
            var reports = [];
            encounter = encounter || this.getEncounter();
            if (encounter) {
                if (encounter.MedicationsPrescribed &&
                    encounter.MedicationsPrescribed.MedicationPrescriptionLines &&
                    encounter.MedicationsPrescribed.MedicationPrescriptionLines.length) {
                    reports.push(ReportType.Prescription);
                }
                if (encounter.MedicalCertificate) {
                    reports.push(ReportType.MedicalCertificate);
                }
                return reports;
            }
            return [];
        };
        Service.prototype.mergeReports = function (prescriptionReport, sicknoteReport) {
            var separator = '<div style="page-break-after:always;"></div>';
            var printTopIndent = '<div class="head-indent"></div>';
            var prescriptionA = prescriptionReport.substr(0, prescriptionReport.lastIndexOf("</body>"));
            var prescriptionB = prescriptionReport.substr(prescriptionReport.lastIndexOf("</body>"));
            var sickNoteContent = sicknoteReport.substr(sicknoteReport.lastIndexOf("<body>") + 6, sicknoteReport.length -
                sicknoteReport.substr(0, sicknoteReport.lastIndexOf("<body>") + 6).length -
                sicknoteReport.substr(sicknoteReport.lastIndexOf("</body>")).length);
            return prescriptionA + separator + printTopIndent + sickNoteContent + prescriptionB;
        };
        Service.prototype.createHiddenReportFrame = function (data) {
            var container = angular.element('.container');
            var date = new Date();
            var postfix = date.getMilliseconds() + '' + date.getSeconds();
            var frameUnicId = 'print_frame' + postfix;
            var frame = '<iframe id="' + frameUnicId + '" scrolling="yes" style="display: none"></iframe>';
            container.append(frame);
            var report = angular.element('#' + frameUnicId);
            this.$timeout(function () {
                var body = report.contents().find('body');
                body.html(data);
            }, 100);
            return frameUnicId;
        };
        Service.prototype.printReport = function (frameId) {
            var report = angular.element('#' + frameId);
            var printContents = document.getElementById(frameId).contentWindow;
            setTimeout(function () {
                printContents.focus();
            }, 50);
            setTimeout(function () {
                printContents.print();
                report.remove();
            }, 100);
        };
        Service.prototype.getSpecificRule = function (practiceId, code, dateOfService) {
            return this.funderConfiguration.getSpecificRule(practiceId, code, dateOfService);
        };
        Service.DATE_PATTERN = "YYYY-MM-DD";
        return Service;
    })();
    EncounterModule.Service = Service;
})(EncounterModule || (EncounterModule = {}));
angular.module('DoctorApp')
    .service('encounterServiceNew', EncounterModule.Service);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../consultation/encounter/encounter-service.ts" />
/// <reference path="../../services/api/result-api.ts" />
/// <reference path="../../services/api/domain/clinical.ts" />
/// <reference path="../../services/api/event-type.ts" />
var ClinicalTemplateModule;
(function (ClinicalTemplateModule) {
    var Service = (function () {
        Service.$inject = ["httpService", "$q", "clinicalDomain"];
        function Service(httpService, $q, clinicalDomain) {
            "ngInject";
            this.httpService = httpService;
            this.$q = $q;
            this.clinicalDomain = clinicalDomain;
            this.encounter = new Domain.Clinical.Encounter();
            this.templates = [];
        }
        Service.prototype.setMainTemplate = function (mainTemplate) {
            this.mainTemplate = mainTemplate;
        };
        Service.prototype.getMainTemplate = function () {
            return this.mainTemplate;
        };
        Service.prototype.setTemplates = function (newTemplates) {
            this.templates = newTemplates;
        };
        Service.prototype.getTemplates = function () {
            return this.templates;
        };
        Service.prototype.execGetPracticeTemplate = function (practiceId, templateId) {
            var isExists = !!this.mainTemplate;
            if (isExists) {
                var deferred = this.$q.defer();
                deferred.resolve(this.mainTemplate);
                return deferred.promise;
            }
            return this.clinicalDomain.getTemplate(practiceId, templateId);
        };
        Service.prototype.getTemplatesByEncounter = function (practiceId, encounterId) {
            return this.clinicalDomain.getTemplatesByEncounter(practiceId, encounterId);
        };
        Service.prototype.loadPracticeTemplates = function (practiceId) {
            this.clinicalDomain.invalidateEncounterTemplateCache(practiceId);
            return this.clinicalDomain.getTemplates(practiceId);
        };
        Service.prototype.saveTemplate = function (practiceId, template) {
            return this.clinicalDomain.createTemplate(practiceId, template);
        };
        Service.prototype.updateTemplate = function (practiceId, template) {
            return this.clinicalDomain.updateTemplate(practiceId, template);
        };
        Service.prototype.removeTemplate = function (practiceId, template) {
            return this.clinicalDomain.removeTemplate(practiceId, template.TemplateId);
        };
        Service.prototype.removeTemplatesByType = function (practiceId, type) {
            return this.clinicalDomain.removeTemplatesByType(practiceId, type);
        };
        Service.prototype.removeTemplates = function (practiceId) {
            return this.clinicalDomain.removeTemplates(practiceId);
        };
        Service.prototype.mergeTemplates = function (practiceId, oldTemplate, newTemplate) {
            return this.mergeLineItems(practiceId, oldTemplate, newTemplate);
        };
        Service.prototype.mergeLineItems = function (practiceId, mainTemplate, template) {
            return this.clinicalDomain.mergeLineItemsByTemplates(practiceId, mainTemplate, template);
        };
        Service.prototype.removeLineFromTemplate = function (mainTemplate, obj, type) {
            switch (type) {
                case EventType.DIAGNOSIS:
                    var diagnoses = mainTemplate.EncounterLineItems.EncounterHeader.Diagnosis;
                    var diagnosis = obj;
                    this.removeObjFromArray(diagnoses, diagnosis);
                    if (diagnosis.PrimaryIndicator && diagnoses.length) {
                        diagnoses[0].PrimaryIndicator = true;
                    }
                    break;
                case EventType.PRESCRIPTION:
                    var prescriptions = mainTemplate.MedicationPrescriptionLines;
                    var prescription = obj;
                    this.removeObjFromArray(prescriptions, prescription);
                    break;
                case EventType.COMMUNICATION:
                    var communications = mainTemplate.Communications;
                    var communication = obj;
                    this.removeObjFromArray(communications, communication);
                    break;
                default:
                    var lines = mainTemplate.EncounterLineItems.LineItems;
                    var line = obj;
                    this.removeObjFromArray(lines, line);
            }
        };
        Service.prototype.removeObjFromArray = function (arr, obj) {
            var index = arr.indexOf(obj);
            if (index > -1) {
                arr.splice(index, 1);
            }
        };
        return Service;
    })();
    ClinicalTemplateModule.Service = Service;
})(ClinicalTemplateModule || (ClinicalTemplateModule = {}));
angular.module('DoctorApp')
    .service('clinicalTemplateServiceNew', ClinicalTemplateModule.Service);
/// <reference path="../../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../../../scripts/definition/moment/moment-node.d.ts" />
/// <reference path="../../../services/api/result-api.ts" />
/// <reference path="../../../services/http-service.ts" />
/// <reference path="../../../services/auth-service.ts" />
var InvoiceModule;
(function (InvoiceModule) {
    var Service = (function () {
        Service.$inject = ["billingDomain", "funderConfiguration", "moment"];
        function Service(billingDomain, funderConfiguration, moment) {
            "ngInject";
            this.billingDomain = billingDomain;
            this.funderConfiguration = funderConfiguration;
            this.moment = moment;
        }
        Service.prototype.setConsultationDate = function (date) {
            this.consultationDate = date;
        };
        Service.prototype.getConsultationDate = function () {
            return this.consultationDate;
        };
        Service.prototype.setInvoice = function (newInvoice) {
            this.invoice = newInvoice;
        };
        Service.prototype.getInvoice = function () {
            return this.invoice;
        };
        Service.prototype.loadInvoice = function (patientEventId) {
            return this.billingDomain.getInvoice(patientEventId);
        };
        Service.prototype.addTemplateToEvent = function (invoice, template) {
            if (template.InvoiceLineItemsVo && template.InvoiceLineItemsVo.InvoiceHeader) {
                var diagnoses = template.InvoiceLineItemsVo.InvoiceHeader.Diagnosis;
                for (var i = 0; i < diagnoses.length; i++) {
                    diagnoses[i].PrimaryIndicator = false;
                }
            }
            var that = this;
            return this.mergeInvoiceLineItems(invoice.InvoiceId, invoice.InvoiceLineItems, template)
                .then(function (response) {
                if (response.Sucess == true) {
                    that.setUpPrimaryIndicator(response.Data.InvoiceHeader.Diagnosis);
                    invoice.InvoiceLineItems = response.Data;
                    return invoice;
                }
            });
        };
        Service.prototype.setUpPrimaryIndicator = function (diagnoses) {
            var setUp = false;
            for (var i = 0; i < diagnoses.length; i++) {
                if (diagnoses[i].PrimaryIndicator) {
                    if (setUp) {
                        diagnoses[i].PrimaryIndicator = false;
                    }
                    setUp = true;
                }
            }
            if (!setUp && diagnoses.length) {
                diagnoses[0].PrimaryIndicator = true;
            }
        };
        Service.prototype.removeDiagnosisFromInvoice = function (invoice, diagnosis) {
            var diagnoses = invoice.InvoiceLineItems.InvoiceHeader.Diagnosis;
            this.removeObjFromArray(diagnoses, diagnosis);
            if (diagnosis.PrimaryIndicator && diagnoses.length) {
                diagnoses[0].PrimaryIndicator = true;
            }
        };
        Service.prototype.removeLineItemFromInvoice = function (invoice, line) {
            var lines = invoice.InvoiceLineItems.LineItems;
            this.removeObjFromArray(lines, line);
        };
        Service.prototype.removeObjFromArray = function (arr, obj) {
            var index = arr.indexOf(obj);
            if (index > -1) {
                arr.splice(index, 1);
            }
        };
        Service.prototype.mergeInvoiceLineItems = function (invoiceId, invoiceLineItems, template) {
            return this.billingDomain.mergeInvoiceLineItems(invoiceId, invoiceLineItems, template);
        };
        Service.prototype.mergeHospital = function (invoice) {
            return this.billingDomain.mergeInvoiceHospital(invoice.InvoiceId, invoice.InvoiceLineItems)
                .then(function (response) {
                invoice.InvoiceLineItems = response.Data;
                return invoice;
            });
        };
        Service.prototype.submitInvoice = function (invoice) {
            return this.billingDomain.submitInvoice(invoice);
        };
        Service.prototype.getSpecificRule = function (practiceId, code) {
            return this.funderConfiguration.getSpecificRule(practiceId, code, null);
        };
        return Service;
    })();
    InvoiceModule.Service = Service;
})(InvoiceModule || (InvoiceModule = {}));
angular.module('DoctorApp')
    .service('invoiceService', InvoiceModule.Service);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../screens/consultation/invoice/invoice-service.ts" />
/// <reference path="../../common/common.ts" />
var TemplateModule;
(function (TemplateModule) {
    var Service = (function () {
        Service.$inject = ["httpService", "$q", "invoiceService", "billingDomain"];
        function Service(httpService, $q, invoiceService, billingDomain) {
            "ngInject";
            this.httpService = httpService;
            this.$q = $q;
            this.invoiceService = invoiceService;
            this.billingDomain = billingDomain;
        }
        Service.prototype.setMainTemplate = function (template) {
            this.mainTemplate = template;
        };
        Service.prototype.getMainTemplate = function () {
            return this.mainTemplate;
        };
        Service.prototype.execGetPracticeTemplate = function (templateId) {
            return this.billingDomain.getTemplate(templateId);
        };
        Service.prototype.loadInvoiceTemplates = function (invoiceId) {
            return this.billingDomain.getTemplatesByInvoice(invoiceId);
        };
        Service.prototype.loadPracticeTemplates = function () {
            return this.billingDomain.getTemplates();
        };
        Service.prototype.saveTemplate = function (template) {
            return this.billingDomain.saveTemplate(template);
        };
        Service.prototype.updateTemplate = function (template) {
            return this.billingDomain.updateTemplate(template);
        };
        Service.prototype.removeTemplate = function (template) {
            return this.billingDomain.removeTemplate(template.TemplateId);
        };
        Service.prototype.mergeTemplates = function (mainTemplate, newTemplate) {
            return this.billingDomain.mergeTemplateLineItems(mainTemplate.InvoiceLineItemsVo, newTemplate)
                .then(function (response) {
                mainTemplate.InvoiceLineItemsVo = response.Data;
            });
        };
        Service.prototype.removeTemplateFromTemplate = function (mainTemplate, template, type) {
            var copyMainTemplate = angular.copy(mainTemplate);
            var invoiceLineItems = copyMainTemplate.InvoiceLineItemsVo;
            var findIndex = -1;
            if (type == "Diagnosis") {
                var diagnosis = invoiceLineItems.InvoiceHeader.Diagnosis;
                var primaryD = false;
                for (var i = 0; i < diagnosis.length; i++) {
                    if (template.DiagnosisCode == diagnosis[i].DiagnosisCode) {
                        primaryD = template.PrimaryIndicator === true;
                        findIndex = i;
                        break;
                    }
                }
                if (findIndex !== -1) {
                    diagnosis.splice(findIndex, 1);
                    if (diagnosis[0]) {
                        diagnosis[0].PrimaryIndicator = primaryD;
                    }
                }
            }
            else {
                var lineItems = invoiceLineItems.LineItems;
                for (i = 0; i < lineItems.length; i++) {
                    if (template.NappiCode == lineItems[i].NappiCode) {
                        findIndex = i;
                        break;
                    }
                }
                if (findIndex !== -1) {
                    lineItems.splice(findIndex, 1);
                }
            }
            return copyMainTemplate;
        };
        return Service;
    })();
    TemplateModule.Service = Service;
})(TemplateModule || (TemplateModule = {}));
angular.module('DoctorApp')
    .service('invoiceTemplateService', TemplateModule.Service);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../../scripts/definition/moment/moment-node.d.ts" />
/// <reference path="../../services/http-service.ts" />
/// <reference path="../../run.ts" />
/// <reference path="../../screens/clinical-template/clinical-template-service.ts" />
/// <reference path="../../screens/template/template-service.ts" />
var PatientModule;
(function (PatientModule) {
    var Service = (function () {
        Service.$inject = ["invoiceService", "encounterServiceNew", "locationService", "patientDomain", "billingDomain"];
        function Service(invoiceService, encounterServiceNew, locationService, patientDomain, billingDomain) {
            "ngInject";
            this.invoiceService = invoiceService;
            this.encounterServiceNew = encounterServiceNew;
            this.locationService = locationService;
            this.patientDomain = patientDomain;
            this.billingDomain = billingDomain;
            this.patientEventID = '';
        }
        Service.prototype.concatPatient = function (name, surname) {
            return name + ' ' + surname;
        };
        Service.prototype.getPatients = function (practiceId, patientName) {
            return this.patientDomain.getPatientsByName(practiceId, patientName);
        };
        Service.prototype.getPatientsFromNationalDb = function (practiceId, patientName) {
            return this.patientDomain.getMasterPatientsByName(practiceId, patientName);
        };
        Service.prototype.checkPatientIn = function (practiceId, patient) {
            return this.patientDomain.checkPatientVisit(practiceId, patient);
        };
        Service.prototype.claimResponse = function (patientEvent) {
            var _this = this;
            return this.billingDomain.getInvoice(patientEvent.PatientEventId)
                .then(function (newInvoice) {
                _this.locationService.gotToClaimResponse(newInvoice.InvoiceId);
            });
        };
        Service.prototype.getPracticeXRef = function (providerId) {
            return this.billingDomain.getProvider(providerId)
                .then(function (provider) {
                return provider.PracticeXRef;
            });
        };
        Service.prototype.cancelPatientEvent = function (practiceId, patientEvent) {
            return this.patientDomain.cancelPatientEvent(practiceId, patientEvent.PatientEventId);
        };
        Service.prototype.createNewPatient = function (practiceId, updateAccount, patient, looseValidation) {
            if (looseValidation === void 0) { looseValidation = false; }
            return this.patientDomain.createPatient(practiceId, updateAccount === 1, patient, looseValidation);
        };
        Service.prototype.changePatient = function (practiceId, updateAccount, patient, looseValidation) {
            if (looseValidation === void 0) { looseValidation = false; }
            return this.patientDomain.changePatient(practiceId, updateAccount === 1, patient, looseValidation);
        };
        Service.prototype.getPatientById = function (practiceId, patientId) {
            return this.patientDomain.getPatientById(practiceId, patientId);
        };
        Service.prototype.getPatientByAccNo = function (practiceId, accountId) {
            return this.patientDomain.getPatientByAccNo(practiceId, accountId);
        };
        Service.prototype.addToWaitingRoom = function (practiceId, patientId) {
            return this.patientDomain.addToWaitingRoom(practiceId, patientId);
        };
        Service.prototype.getMedicalAids = function (practiceId) {
            return this.patientDomain.getMedSchemes(practiceId);
        };
        Service.prototype.removePatient = function (practiceId, patient) {
            return this.patientDomain.removePatient(practiceId, patient.PatientId);
        };
        Service.prototype.auditEvent = function (practiceId, patientEvent) {
            var _this = this;
            this.encounterServiceNew.getEncounterByPatientEventId(practiceId, patientEvent.PatientEventId)
                .then(function (response) {
                _this.locationService.goToAuditEvents(patientEvent.PracticeId, response.EncounterId);
            });
        };
        Service.prototype.setPreCreatedPatient = function (patient) {
            this.preCreatedPatient = patient;
        };
        Service.prototype.getPreCreatedPatient = function () {
            return this.preCreatedPatient;
        };
        Service.prototype.clearPatientDetails = function (patient) {
            patient.PatientXRef = null;
            patient.PatientId = "";
            patient.PatientDetails.FirstName = "";
            patient.PatientDetails.Surname = "";
            patient.PatientDetails.DateOfBirth = "";
            patient.PatientDetails.ContactNo = "";
            patient.PatientDetails.IdentityNo = "";
            patient.PatientDetails.EmailAddress = "";
            patient.PatientDetails.Gender = "Male";
            patient.PatientDetails.Title = "Mr";
            patient.FileNo = "";
            patient.PatientAccountDetails.MedicalAidDependentCode = "";
            return patient;
        };
        Service.prototype.parseSaId = function (id) {
            var idNumber = id || "";
            var year = +(idNumber.substr(0, 2));
            var currentYear = +(new Date().getFullYear().toString().substr(2, 2));
            var tempDate = new Date(year <= currentYear ? 2000 + year : year, idNumber.substr(2, 2) - 1, idNumber.substr(4, 2));
            var idDate = tempDate.getDate();
            var idMonth = tempDate.getMonth() + 1;
            var idYear = tempDate.getFullYear();
            var fullDate = idYear +
                "/" +
                (idMonth < 10 ? '0' + idMonth : idMonth) +
                "/" +
                (idDate < 10 ? '0' + idDate : idDate);
            var genderCode = idNumber.substr(6, 4);
            var gender = parseInt(genderCode) < 5000 ? "Female" : "Male";
            return { date: fullDate, gender: gender };
        };
        return Service;
    })();
    PatientModule.Service = Service;
})(PatientModule || (PatientModule = {}));
angular.module('DoctorApp')
    .service('patientService', PatientModule.Service);
/// <reference path="../../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../http-service.ts" />
/// <reference path="../../auth-service.ts" />
var Domain;
(function (Domain) {
    var FunderConfiguration;
    (function (FunderConfiguration) {
        var SpecificRule = (function () {
            function SpecificRule() {
            }
            return SpecificRule;
        })();
        FunderConfiguration.SpecificRule = SpecificRule;
        var Service = (function () {
            Service.$inject = ["httpService", "authService"];
            function Service(httpService, authService) {
                "ngInject";
                this.httpService = httpService;
                this.authService = authService;
            }
            Service.prototype.getSpecificRule = function (practiceId, patientId, dateOfService) {
                return this.httpService.get('v1/' + practiceId + '/patient/funderconfigurations/specificrules/' + patientId + '/' + dateOfService);
            };
            return Service;
        })();
        FunderConfiguration.Service = Service;
    })(FunderConfiguration = Domain.FunderConfiguration || (Domain.FunderConfiguration = {}));
})(Domain || (Domain = {}));
angular.module('DoctorApp')
    .service('funderConfiguration', Domain.FunderConfiguration.Service);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../patient/patient-service.ts" />
/// <reference path="../../services/show-dialog.ts" />
/// <reference path="../../services/api/domain/account.ts" />
/// <reference path="../../services/api/domain/funder-configuration.ts" />
var PracticeModule;
(function (PracticeModule) {
    var SchemeObject = Domain.Billing.SchemeObject;
    var Option = (function () {
        function Option(number, name, item) {
            this.val = number;
            this.name = name;
            this.item = item;
        }
        return Option;
    })();
    PracticeModule.Option = Option;
    var Service = (function () {
        Service.$inject = ["billingDomain", "accountDomain", "patientDomain", "locationService", "$rootScope", "storageService", "signalrService", "providerService"];
        function Service(billingDomain, accountDomain, patientDomain, locationService, $rootScope, storageService, signalrService, providerService) {
            "ngInject";
            this.billingDomain = billingDomain;
            this.accountDomain = accountDomain;
            this.patientDomain = patientDomain;
            this.locationService = locationService;
            this.$rootScope = $rootScope;
            this.storageService = storageService;
            this.signalrService = signalrService;
            this.providerService = providerService;
        }
        Service.prototype.getMedSchemes = function (practiceId) {
            return this.patientDomain.getMedSchemes(practiceId);
        };
        Service.prototype.buildManualSchemes = function (items) {
            items = angular.copy(items);
            items.unshift(new Domain.Patient.MedicalAid(Service.ALL));
            return this.buildSchemes(items);
        };
        Service.prototype.buildSchemes = function (items) {
            var res = [];
            for (var i = 0; i < items.length; i++) {
                res[i] = new Option(i, items[i].Name, items[i]);
            }
            return res;
        };
        Service.prototype.getSchemeValues = function (schemes, options) {
            return this.getValues(schemes, options);
        };
        Service.prototype.getManualSchemeValues = function (schemes, options) {
            var values = this.getValues(schemes, options);
            return this.filterSchemesForAll(values);
        };
        Service.prototype.getValues = function (numbers, options) {
            var res = [];
            for (var i = 0; i < numbers.length; i++) {
                var number = numbers[i];
                for (var j = 0; j < options.length; j++) {
                    if (number == options[j].val) {
                        res[res.length] = options[j].name;
                        break;
                    }
                }
            }
            return res;
        };
        Service.prototype.filterSchemesForAll = function (schemes) {
            for (var i = 0; i < schemes.length; i++) {
                if (schemes[i] === Service.ALL) {
                    return ['*'];
                }
            }
            return schemes;
        };
        Service.prototype.convertSchemesToArrObjects = function (allSchemes, selectSchemes) {
            var res = [];
            for (var i = 0; i < allSchemes.length; i++) {
                for (var j = 0; j < selectSchemes.length; j++) {
                    var sc = allSchemes[i] == "*" ? "ALL" : allSchemes[i];
                    if (sc == selectSchemes[j].name) {
                        res[res.length] = new SchemeObject(selectSchemes[j].name);
                    }
                }
            }
            return res;
        };
        Service.prototype.convertSchemesToArrStrings = function (selectedSchemes, optionSchemes) {
            var res = [];
            for (var i = 0; i < selectedSchemes.length; i++) {
                var sc = (selectedSchemes[i].name === 'ALL') ? "*" : selectedSchemes[i].name;
                if (sc == "*") {
                    res = [];
                    res.push(sc);
                    break;
                }
                for (var j = 0; j < optionSchemes.length; j++) {
                    if (sc == optionSchemes[j].name) {
                        res.push(optionSchemes[j].name);
                        break;
                    }
                }
            }
            return res;
        };
        Service.prototype.setLocalPractice = function (practice, redirectToHome) {
            console.warn('Method is deprecated. practice-service.setLocalPractice');
            if (practice) {
                var oldPractice = this.storageService.getPractice();
                oldPractice.id = practice.PracticeId;
                oldPractice.name = practice.TreatingDoctorName;
                oldPractice.billingPrNo = practice.PracticeNumber;
                oldPractice.treatingPrNo = practice.TreatingPracticeNumber;
                this.storageService.setPractice(oldPractice);
            }
            this.updateLocalPractice(practice.PracticeId, redirectToHome);
        };
        Service.prototype.updateLocalPractice = function (practiceId, redirectToHome) {
            var _this = this;
            this.providerService.getProviderOptions(practiceId)
                .then(function (options) {
                _this.$rootScope.isClinical = options.isEnabledForClinicalResults;
            });
            this.signalrService.setPractice(practiceId);
            if (redirectToHome) {
                this.locationService.goToHome(practiceId);
            }
        };
        Service.prototype.updateLocalPracticeById = function (practiceId) {
            var _this = this;
            return this.getPracticeById(practiceId)
                .then(function (loadPractice) {
                var practice = _this.storageService.getPractice();
                if (loadPractice) {
                    practice.id = loadPractice.PracticeId;
                    practice.xref = loadPractice.PracticeXRef;
                    practice.treatingPrNo = loadPractice.TreatingPracticeNumber;
                    practice.billingPrNo = loadPractice.PracticeNumber;
                    practice.name = loadPractice.TreatingDoctorName || loadPractice.PracticeName;
                }
                else {
                    practice.id = _this.storageService.getEmptyPracticeId();
                    practice.name = '';
                }
                _this.storageService.setPractice(practice);
                return practice;
            });
        };
        Service.prototype.getSpecialityRules = function () {
            return this.billingDomain.getSpecialityRules();
        };
        Service.prototype.createPractice = function (practice) {
            return this.billingDomain.createProvider(practice);
        };
        Service.prototype.updatePractice = function (Practice) {
            return this.billingDomain.updateProvider(Practice);
        };
        Service.prototype.deletePractice = function (practiceId) {
            return this.billingDomain.deleteProvider(practiceId);
        };
        Service.prototype.getPractices = function () {
            return this.accountDomain.getPractices();
        };
        Service.prototype.getAllPractices = function () {
            return this.billingDomain.getProviders();
        };
        Service.prototype.getCommunicationTemplates = function () {
            return this.billingDomain.getCommunicationTemplates();
        };
        Service.prototype.updateCommunicationTemplate = function (template) {
            return this.billingDomain.updateCommunicationTemplate(template);
        };
        Service.prototype.getProvidersPage = function (pageCount, pageSize) {
            return this.billingDomain.getProvidersPage(pageCount, pageSize);
        };
        Service.prototype.getProvidersPageAndSearch = function (search, pageCount, pageSize) {
            if (search) {
                return this.billingDomain.getProvidersFiltered(search, pageCount, pageSize);
            }
            return this.getProvidersPage(pageCount, pageSize);
        };
        Service.prototype.getPracticeById = function (practiceId) {
            return this.billingDomain.getProviderById(practiceId);
        };
        Service.prototype.saveOptions = function (providerId, options) {
            return this.billingDomain.setOptions(providerId, options);
        };
        Service.ALL = 'ALL';
        return Service;
    })();
    PracticeModule.Service = Service;
})(PracticeModule || (PracticeModule = {}));
angular.module('DoctorApp')
    .service('practiceService', PracticeModule.Service);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../services/auth-service.ts" />
/// <reference path="../../services/api/domain/account.ts" />
/// <reference path="../../screens/practice/practice-service.ts" />
/// <reference path="../../config.ts" />
var LoginModule;
(function (LoginModule) {
    var LoginResult = (function () {
        function LoginResult() {
        }
        return LoginResult;
    })();
    LoginModule.LoginResult = LoginResult;
    var Service = (function () {
        Service.$inject = ["practiceService", "storageService", "$http", "$q", "accountDomain", "providerService"];
        function Service(practiceService, storageService, $http, $q, accountDomain, providerService) {
            "ngInject";
            this.practiceService = practiceService;
            this.storageService = storageService;
            this.$http = $http;
            this.$q = $q;
            this.accountDomain = accountDomain;
            this.providerService = providerService;
        }
        Service.prototype.login = function (username, password) {
            var url = GlobalVar.serverURL;
            var clientId = GlobalVar.clientId;
            var body = "grant_type=password&username=" + username +
                "&password=" + password +
                "&client_id=" + clientId;
            return this.$http.post(url + 'v1/authentication/account/login', body, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
        };
        Service.prototype.getUser = function (userId) {
            return this.accountDomain.getUser(userId);
        };
        Service.prototype.getUserDefaultPractice = function () {
            return this.practiceService.getPractices()
                .then(function (practices) {
                if (practices.length) {
                    return practices[0];
                }
                return null;
            });
        };
        Service.prototype.getPracticeDetails = function (practiceId) {
            return this.practiceService.getPracticeById(practiceId);
        };
        Service.prototype.getStartPage = function (practiceId) {
            return this.providerService.getProviderOptions(practiceId)
                .then(function (options) {
                return options.HomePage;
            });
        };
        return Service;
    })();
    LoginModule.Service = Service;
})(LoginModule || (LoginModule = {}));
angular.module('DoctorApp')
    .service('loginService', LoginModule.Service);
/// <reference path="../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="storage-service.ts" />
/// <reference path="location-service.ts" />
/// <reference path="../screens/login/login-service.ts" />
var AuthModule;
(function (AuthModule) {
    var TokenDetails = (function () {
        function TokenDetails(header, payload, tokenDetails) {
            this.header = header;
            this.payload = payload;
            this.tokenDetails = tokenDetails;
        }
        return TokenDetails;
    })();
    AuthModule.TokenDetails = TokenDetails;
    var Service = (function () {
        Service.$inject = ["storageService", "$window", "$location", "locationService", "showDialog", "$log", "$rootScope"];
        function Service(storageService, $window, $location, locationService, showDialog, $log, $rootScope) {
            "ngInject";
            this.storageService = storageService;
            this.$window = $window;
            this.$location = $location;
            this.locationService = locationService;
            this.showDialog = showDialog;
            this.$log = $log;
            this.$rootScope = $rootScope;
        }
        Service.prototype.init = function (_loginService_) {
            var _this = this;
            this.loginService = _loginService_;
            this.$window.onfocus = function () {
                _this.$rootScope.$apply(function () {
                    _this.refreshAuthorization();
                });
            };
            this.refreshAuthorization();
        };
        Service.prototype.toDefaulPath = function (backPath) {
            var user = this.storageService.getUser();
            var practiceId, isAdmin;
            if (user.role) {
                practiceId = user.role[0].split('/')[0];
                isAdmin = user.role[0].split('/')[1] === StorageModule.User.ADMIN_ROLE;
            }
            else {
                practiceId = this.storageService.getPracticeId();
                isAdmin = practiceId === StorageModule.Service.EMPTY_PRACTICE_ID;
            }
            if (backPath && backPath !== '/') {
                this.$location.path(backPath);
                return;
            }
            if (isAdmin) {
                this.locationService.goToAccount(StorageModule.Service.EMPTY_PRACTICE_ID, user.userId);
            }
            else {
                this.locationService.goToHome(practiceId);
            }
        };
        Service.prototype.goToStartPage = function () {
            var _this = this;
            var user = this.storageService.getUser();
            var backPath = this.storageService.getBackPath();
            if (user && user.role) {
                var practiceId = user.role[0].split('/')[0];
                var roleName = user.role[0].split('/')[1];
                if (roleName === StorageModule.User.ADMIN_ROLE) {
                    this.toDefaulPath(backPath);
                    return;
                }
                this.loginService.getStartPage(practiceId)
                    .then(function (startPage) {
                    _this.loginService.getUser(user.userId)
                        .then(function (user) {
                        if (user.RequirePasswordChange) {
                            _this.locationService.goToChangePassword(practiceId, user.UserId);
                        }
                        else {
                            if (startPage) {
                                _this.$location.path(_this.parseProviderHomeUrl(startPage));
                            }
                            else {
                                _this.toDefaulPath(backPath);
                            }
                        }
                    });
                });
            }
            else {
                this.toDefaulPath(backPath);
            }
        };
        Service.prototype.logOut = function () {
            this.storageService.clear();
            this.goToPath(this.locationService.loginPath, '');
        };
        Service.prototype.refreshAuthorization = function () {
            var _this = this;
            var user = this.storageService.getUser();
            if (!user || !user.isAuth) {
                this.goToPath(this.locationService.loginPath, '');
                return;
            }
            var doctorId = this.storageService.getPractice().id;
            if (doctorId) {
                if (this.$location.path() === this.locationService.loginPath) {
                    var backPath = this.storageService.getBackPath() || this.locationService.homePath;
                    this.goToPath(backPath, this.storageService.getBackHash());
                }
            }
            else {
                this.goToPath(this.locationService.loginPath, '');
                this.loginService.getUserDefaultPractice()
                    .then(function (practiceId) {
                    if (!practiceId) {
                        _this.showDialog.error("Unable to find active treating doctor, please contact support.");
                        _this.storageService.clear();
                    }
                    else {
                        _this.loginService.getPracticeDetails(practiceId).then(function (practice) {
                            _this.loadPracticeForUser(practice);
                            _this.goToStartPage();
                        });
                    }
                })
                    .catch(function () {
                    var user = _this.storageService.getUser();
                    _this.$log.error('Failed to find practice for [' + user.name + '] user');
                    _this.goToPath(_this.locationService.loginPath, '');
                });
            }
        };
        Service.prototype.parseProviderHomeUrl = function (url) {
            var user = this.storageService.getUser();
            var updatedUrl = url.replace(':practiceId', this.getPracticeId());
            updatedUrl = updatedUrl.replace(':userId', user.userId);
            return updatedUrl;
        };
        Service.prototype.isAdmin = function () {
            var user1 = this.storageService.getUser();
            return user1 && user1.role.length > 0 && user1.role[0].split('/')[1] === StorageModule.User.ADMIN_ROLE;
        };
        Service.prototype.loadPracticeForUser = function (loadPractice) {
            var practice = this.storageService.getPractice();
            if (loadPractice) {
                practice.id = loadPractice.PracticeId;
                practice.xref = loadPractice.PracticeXRef;
                practice.billingPrNo = loadPractice.PracticeNumber;
                practice.treatingPrNo = loadPractice.TreatingPracticeNumber;
                practice.name = loadPractice.TreatingDoctorName || loadPractice.PracticeName;
            }
            this.storageService.setPractice(practice);
        };
        Service.prototype.goToPath = function (newPath, newHash) {
            var oldPath = this.$location.path();
            if (oldPath === newPath) {
                return;
            }
            if (newPath === this.locationService.loginPath) {
                var oldHash = this.$location.hash();
                this.storageService.setBackPath(oldPath);
                this.storageService.setBackHash(oldHash);
            }
            this.$location.path(newPath);
            this.$location.hash(newHash);
        };
        Service.prototype.getPracticeId = function () {
            return this.storageService.getPracticeId();
        };
        Service.prototype.parseTokenDetails = function (tokenDetails) {
            var splitToken = tokenDetails.split('.');
            var tokenHeader = angular.fromJson(atob(splitToken[0]));
            var tokenPayload = angular.fromJson(atob(splitToken[1]));
            if (!(tokenPayload.role instanceof Array)) {
                tokenPayload.role = [tokenPayload.role];
            }
            return new TokenDetails(tokenHeader, tokenPayload, tokenDetails);
        };
        return Service;
    })();
    AuthModule.Service = Service;
})(AuthModule || (AuthModule = {}));
angular.module('DoctorApp')
    .service('authService', AuthModule.Service);
/// <reference path="../../scripts/definition/angularjs/angular.d.ts" />
var SignalrModule;
(function (SignalrModule) {
    var Service = (function () {
        Service.$inject = ["$rootScope", "httpService", "$q"];
        function Service($rootScope, httpService, $q) {
            "ngInject";
            this.$rootScope = $rootScope;
            this.httpService = httpService;
            this.$q = $q;
        }
        Service.prototype.setPractice = function (practiceId) {
            if (practiceId && this.practiceId !== practiceId) {
                this.practiceId = practiceId;
                this.init();
            }
        };
        Service.prototype.init = function () {
            var _this = this;
            if (this.connection) {
                this.connection.stop();
            }
            this.getSignalRToken(this.practiceId, 'signalr')
                .then(function (accessToken) {
                _this.connection = new signalR.HubConnectionBuilder()
                    .withUrl(accessToken.ServiceUrl, { accessTokenFactory: function () { return accessToken.Token; } })
                    .build();
                _this.connection.on("processMessage", function (data) {
                    if (data) {
                        switch (data.Type) {
                            case "WaitingRoomUpdated":
                                _this.$rootScope.$emit('WaitingRoomUpdated');
                                break;
                            case "NotificationsUpdated":
                                _this.$rootScope.$emit('NotificationsUpdated');
                                break;
                            case "EncounterTemplateUpdated":
                                _this.$rootScope.$emit('EncounterTemplateUpdated');
                                break;
                            case "PathReportReceived":
                                _this.$rootScope.$emit('PathReportReceived');
                                break;
                        }
                    }
                });
                _this.connection.start()
                    .then(function (res) { console.log(res); })
                    .catch(function (err) { console.error(err.toString()); });
            });
        };
        Service.prototype.getSignalRToken = function (practiceId, type) {
            return this.httpService.get("v1/infrastructure/" + practiceId + "/tokenproviders/" + type);
        };
        return Service;
    })();
    SignalrModule.Service = Service;
})(SignalrModule || (SignalrModule = {}));
angular.module('DoctorApp')
    .service('signalrService', SignalrModule.Service);
/// <reference path="../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="services/auth-service.ts" />
/// <reference path="services/show-dialog.ts" />
/// <reference path="screens/patient/patient-service.ts" />
/// <reference path="services/signalr-service.ts" />
var App;
(function (App) {
    (function (VersionDiff) {
        VersionDiff[VersionDiff["Mandatory"] = 0] = "Mandatory";
        VersionDiff[VersionDiff["NoMandatory"] = 1] = "NoMandatory";
        VersionDiff[VersionDiff["NoDiff"] = 2] = "NoDiff";
    })(App.VersionDiff || (App.VersionDiff = {}));
    var VersionDiff = App.VersionDiff;
    var Run = (function () {
        Run.$inject = ["$rootScope", "$location", "locationService", "authService", "patientService", "showDialog", "signalrService", "$window", "loginService", "$templateCache", "trackingService", "storageService"];
        function Run($rootScope, $location, locationService, authService, patientService, showDialog, signalrService, $window, loginService, $templateCache, trackingService, storageService) {
            "ngInject";
            $rootScope.versionDifference = VersionDiff.NoDiff;
            $rootScope.showPaymentStatuses = false;
            $rootScope.showProgressScreen = false;
            $rootScope.showWaitingScreen = false;
            $rootScope.showThankYou = false;
            authService.init(loginService);
            $rootScope.$on('$locationChangeStart', function (event, nextRoute, currentRoute) {
                var user = storageService.getUser();
                var practiceId = user && user.role && user.role[0].split('/')[0];
                var isHomePage = nextRoute.search('home') > -1;
                var isLoginPage = nextRoute.search('login') > -1;
                var nextRoutePart = nextRoute.match(/#\/[\w-]+\/[\w-]+/);
                var currentRoutePart = currentRoute.match(/#\/[\w-]+\/[\w-]+/);
                var isSamePage = nextRoutePart && currentRoutePart && nextRoutePart[0] === currentRoutePart[0];
                if (practiceId !== '*') {
                    signalrService.setPractice(practiceId);
                    if ($rootScope.versionDifference === VersionDiff.NoMandatory && !isHomePage && !isLoginPage && !isSamePage) {
                        showDialog.confirm('There is currently a new version available.  In order to avoid issues and errors, we highly recommend that you refresh now', null, false, ['Ok', 'Ignore'])
                            .then(function () {
                            window.location.reload(true);
                        });
                    }
                    else if ($rootScope.versionDifference === VersionDiff.Mandatory && !isHomePage && !isLoginPage && !isSamePage) {
                        event.preventDefault();
                        showDialog.info('There is a new version available.  You will need to update in order to continue working.')
                            .then(function () {
                            window.location.reload(true);
                        });
                    }
                }
                else if ($location.path() === '/') {
                    event.preventDefault();
                    authService.goToStartPage();
                }
            });
            $rootScope.$on('$stateChangeStart', function (event, toState, toParams) {
                authService.refreshAuthorization();
            });
            $rootScope.logOut = function () {
                var message = "Are you sure want to log out ?";
                showDialog.confirm(message)
                    .then(function () {
                    authService.logOut();
                });
            };
            $rootScope.quantities = [
                { amount: 1 }, { amount: 2 }, { amount: 3 }, { amount: 4 }, { amount: 5 }, { amount: 6 }, { amount: 7 },
                { amount: 8 }, { amount: 9 }, { amount: 10 }
            ];
            $rootScope.back = function (removeHash) {
                $window.history.back();
            };
            $rootScope.goToHome = function () {
                $rootScope.showThankYou = false;
                locationService.goToHome(authService.getPracticeId());
            };
            $rootScope.goToPayments = function () {
                $rootScope.showThankYou = false;
                locationService.goToCardPayments();
            };
            $templateCache.put("template/modal/window.html", "<div modal-render=\"{{$isRendered}}\" tabindex=\"-1\" role=\"dialog\" class=\"modal\"\n" +
                "    modal-animation-class=\"fade\"\n" +
                "    modal-in-class=\"in\"\n" +
                "    ng-style=\"{'z-index': 1050 + index*10}\" ng-click=\"close($event)\">\n" +
                "    <div class=\"modal-dialog\" ng-class=\"size ? 'modal-' + size : ''\"><div class=\"modal-content\" modal-transclude></div></div>\n" +
                "</div>\n" +
                "");
            $rootScope.$on('$locationChangeSuccess', function () {
                trackingService.onViewChanged();
            });
        }
        return Run;
    })();
    App.Run = Run;
})(App || (App = {}));
angular.module('DoctorApp')
    .run(App.Run);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../services/api/result-api.ts" />
/// <reference path="../../services/api/domain/clinical.ts" />
/// <reference path="../../services/api/event-type.ts" />
var ClinicalAddressBookModule;
(function (ClinicalAddressBookModule) {
    var Service = (function () {
        Service.$inject = ["httpService", "$q", "usageService", "storageService", "clinicalDomain"];
        function Service(httpService, $q, usageService, storageService, clinicalDomain) {
            "ngInject";
            this.httpService = httpService;
            this.$q = $q;
            this.usageService = usageService;
            this.storageService = storageService;
            this.clinicalDomain = clinicalDomain;
            this.templates = [];
        }
        Service.prototype.loadPracticeAddressBook = function (practiceId, lookupfilter, pageNo, pageSize) {
            if (pageNo === void 0) { pageNo = 0; }
            if (pageSize === void 0) { pageSize = 10; }
            return this.clinicalDomain.getAddressBook(practiceId, lookupfilter, pageNo, pageSize);
        };
        Service.prototype.loadPracticeAddressBookFavourites = function (practiceId) {
            return this.clinicalDomain.getAddressBookFavourites(practiceId);
        };
        Service.prototype.getAddressBookEntry = function (practiceId, entryId) {
            return this.clinicalDomain.getAddressBookEntry(practiceId, entryId);
        };
        Service.prototype.addContact = function (practiceId, entry) {
            this.usageService.useAddressBook(practiceId, this.storageService.getUser().userLogin, UsageModule.ActionType.NewContact, entry);
            return this.clinicalDomain.addAddressBookEntry(practiceId, entry);
        };
        Service.prototype.updateContact = function (practiceId, entry) {
            this.usageService.useAddressBook(practiceId, this.storageService.getUser().userLogin, UsageModule.ActionType.UpdateContact, entry);
            return this.clinicalDomain.updateAddressBookEntry(practiceId, entry);
        };
        Service.prototype.removeContact = function (practiceId, entry) {
            this.usageService.useAddressBook(practiceId, this.storageService.getUser().userLogin, UsageModule.ActionType.DeleteContact, entry);
            return this.clinicalDomain.removeAddressBookEntry(practiceId, entry.AddressBookEntryId);
        };
        return Service;
    })();
    ClinicalAddressBookModule.Service = Service;
})(ClinicalAddressBookModule || (ClinicalAddressBookModule = {}));
angular.module('DoctorApp')
    .service('addressBookService', ClinicalAddressBookModule.Service);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../services/show-dialog.ts" />
/// <reference path="address-book-service.ts" />
/// <reference path="../../run.ts" />
var ClinicalAddressBookModule;
(function (ClinicalAddressBookModule) {
    var AddressBook = Domain.Clinical.AddressBookEntry;
    var CreateController = (function () {
        CreateController.$inject = ["$scope", "$rootScope", "$routeParams", "locationService", "storageService", "addressBookService", "showDialog"];
        function CreateController($scope, $rootScope, $routeParams, locationService, storageService, addressBookService, showDialog) {
            "ngInject";
            var _this = this;
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.$routeParams = $routeParams;
            this.locationService = locationService;
            this.storageService = storageService;
            this.addressBookService = addressBookService;
            this.showDialog = showDialog;
            this.$scope.addressBookEntity = new AddressBook();
            $scope.save = function (isValid) {
                if (isValid) {
                    addressBookService.addContact($routeParams.practiceId, _this.$scope.addressBookEntity).then(function () {
                        $rootScope.back();
                    });
                }
                else {
                    showDialog.error("Please enter valid info in the highlighted fields");
                }
            };
        }
        return CreateController;
    })();
    ClinicalAddressBookModule.CreateController = CreateController;
})(ClinicalAddressBookModule || (ClinicalAddressBookModule = {}));
angular.module('DoctorApp')
    .controller('ClinicalAddressBookCreateController', ClinicalAddressBookModule.CreateController);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../services/show-dialog.ts" />
/// <reference path="address-book-service.ts" />
/// <reference path="../../run.ts" />
var ClinicalAddressBookModule;
(function (ClinicalAddressBookModule) {
    var EditController = (function () {
        EditController.$inject = ["$scope", "$rootScope", "$routeParams", "locationService", "storageService", "addressBookService", "showDialog"];
        function EditController($scope, $rootScope, $routeParams, locationService, storageService, addressBookService, showDialog) {
            "ngInject";
            var _this = this;
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.$routeParams = $routeParams;
            this.locationService = locationService;
            this.storageService = storageService;
            this.addressBookService = addressBookService;
            this.showDialog = showDialog;
            var entryId = this.$routeParams.entryId;
            this.addressBookService.getAddressBookEntry(this.$routeParams.practiceId, entryId)
                .then(function (entity) {
                _this.$scope.addressBookEntity = entity;
            });
            $scope.save = function (isValid) {
                if (isValid) {
                    addressBookService.updateContact($routeParams.practiceId, _this.$scope.addressBookEntity).then(function () {
                        $rootScope.back();
                    });
                }
                else {
                    showDialog.error("Please enter valid info in the highlighted fields");
                }
            };
        }
        return EditController;
    })();
    ClinicalAddressBookModule.EditController = EditController;
})(ClinicalAddressBookModule || (ClinicalAddressBookModule = {}));
angular.module('DoctorApp')
    .controller('ClinicalAddressBookEditController', ClinicalAddressBookModule.EditController);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../services/show-dialog.ts" />
/// <reference path="address-book-service.ts" />
/// <reference path="../../run.ts" />
var ClinicalAddressBookModule;
(function (ClinicalAddressBookModule) {
    var SearchController = (function () {
        SearchController.$inject = ["$scope", "$rootScope", "$routeParams", "locationService", "addressBookService", "showDialog", "$modalInstance"];
        function SearchController($scope, $rootScope, $routeParams, locationService, addressBookService, showDialog, $modalInstance) {
            "ngInject";
            var _this = this;
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.$routeParams = $routeParams;
            this.locationService = locationService;
            this.addressBookService = addressBookService;
            this.showDialog = showDialog;
            this.$modalInstance = $modalInstance;
            $scope.cancel = function () {
                $modalInstance.dismiss('cancel');
            };
            $scope.ok = function () {
                $modalInstance.close($scope.selectedContact);
            };
            $scope.goToEditContact = function (contact) {
                locationService.goToEditAddressBook($routeParams.practiceId, contact.AddressBookEntryId);
            };
            $scope.toggleFavourite = function (entry) {
                if (!entry.IsFavourite && $scope.favouriteContacts.length >= 5) {
                    showDialog.info("You can't have more than 5 favourite contacts.");
                    return;
                }
                entry.IsFavourite = !entry.IsFavourite;
                _this.addressBookService.updateContact($routeParams.practiceId, entry).then(function () {
                    if (_this.$scope.searchText) {
                        _this.$scope.search();
                    }
                    else {
                        _this.loadFavourites();
                    }
                });
            };
            $scope.search = function () {
                if (_this.$scope.searchText) {
                    _this.addressBookService.loadPracticeAddressBook(_this.$routeParams.practiceId, _this.$scope.searchText)
                        .then(function (entities) {
                        _this.$scope.entities = entities;
                    });
                }
                else {
                    _this.$scope.entities = _this.$scope.favouriteContacts;
                }
            };
            $scope.selectContact = function (entry) {
                $scope.selectedContact = entry;
            };
            $scope.removeContact = function (entry) {
                showDialog.confirm('Are you sure want to delete contact: ' + entry.Name + ' ' + entry.Surname)
                    .then(function () { return _this.addressBookService.removeContact($routeParams.practiceId, entry); })
                    .catch(function () {
                })
                    .then(function () {
                    _this.init();
                })
                    .catch(function (error) {
                    showDialog.error(error);
                });
            };
            $scope.$on('$routeChangeStart', function () {
                $modalInstance.close();
            });
            this.init();
        }
        SearchController.prototype.init = function () {
            this.loadFavourites();
        };
        SearchController.prototype.loadFavourites = function () {
            var _this = this;
            this.addressBookService.loadPracticeAddressBookFavourites(this.$routeParams.practiceId)
                .then(function (entities) {
                _this.$scope.favouriteContacts = entities;
                _this.$scope.entities = _this.$scope.favouriteContacts;
            });
        };
        return SearchController;
    })();
    ClinicalAddressBookModule.SearchController = SearchController;
})(ClinicalAddressBookModule || (ClinicalAddressBookModule = {}));
angular.module('DoctorApp')
    .controller('ClinicalAddressBookSearchController', ClinicalAddressBookModule.SearchController);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../services/show-dialog.ts" />
/// <reference path="address-book-service.ts" />
/// <reference path="../../run.ts" />
var ClinicalAddressBookModule;
(function (ClinicalAddressBookModule) {
    var Controller = (function () {
        Controller.$inject = ["$scope", "$rootScope", "$routeParams", "locationService", "storageService", "addressBookService", "showDialog"];
        function Controller($scope, $rootScope, $routeParams, locationService, storageService, addressBookService, showDialog) {
            "ngInject";
            var _this = this;
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.$routeParams = $routeParams;
            this.locationService = locationService;
            this.storageService = storageService;
            this.addressBookService = addressBookService;
            this.showDialog = showDialog;
            $scope.search = function () {
                _this.$scope.entities = [];
                $scope.pageNo = 0;
                _this.loadEntities();
            };
            $scope.loadNextPage = function () {
                if (!$scope.allPagesLoaded && !$scope.isRunningPage) {
                    $scope.pageNo = $scope.pageNo + 1;
                    $scope.isRunningPage = true;
                    _this.loadEntities();
                }
            };
            $scope.goToEditContact = function (contact) {
                locationService.goToEditAddressBook($routeParams.practiceId, contact.AddressBookEntryId);
            };
            $scope.toggleFavourite = function (entry) {
                if (!entry.IsFavourite && $scope.favouriteContacts.length >= 5) {
                    showDialog.info("You can't have more than 5 favourite contacts.");
                    return;
                }
                entry.IsFavourite = !entry.IsFavourite;
                _this.addressBookService.updateContact($routeParams.practiceId, entry).then(function () {
                    _this.loadFavourites();
                });
            };
            $scope.goToCreateContact = function () {
                locationService.goToCreateAddressBook($routeParams.practiceId);
            };
            $scope.removeContact = function (entry) {
                showDialog.confirm('Are you sure want to delete contact: ' + entry.Name + ' ' + entry.Surname)
                    .then(function () { return _this.addressBookService.removeContact($routeParams.practiceId, entry); })
                    .catch(function () {
                })
                    .then(function () {
                    _this.loadEntities();
                })
                    .catch(function (error) {
                    showDialog.error(error);
                });
            };
            this.init();
        }
        Controller.prototype.init = function () {
            this.$scope.entities = [];
            this.$scope.searchText = '';
            this.$scope.pageSize = 10;
            this.$scope.pageNo = 0;
            this.$scope.allPagesLoaded = false;
            this.loadFavourites();
            this.$scope.search();
            this.setAdminRules();
        };
        Controller.prototype.loadFavourites = function () {
            var _this = this;
            this.addressBookService.loadPracticeAddressBookFavourites(this.$routeParams.practiceId)
                .then(function (entities) {
                _this.$scope.favouriteContacts = entities;
            });
        };
        Controller.prototype.loadEntities = function () {
            var _this = this;
            this.addressBookService.loadPracticeAddressBook(this.$routeParams.practiceId, this.$scope.searchText, this.$scope.pageNo, this.$scope.pageSize)
                .then(function (page) {
                if (page) {
                    for (var i = 0; i < page.length; i++) {
                        _this.$scope.entities.push(page[i]);
                    }
                }
                _this.$scope.allPagesLoaded = !page || page.length !== _this.$scope.pageSize;
                _this.$scope.isRunningPage = false;
            });
        };
        Controller.prototype.setAdminRules = function () {
            var user = this.storageService.getUser();
            this.$scope.isAdmin = user.role.indexOf('*') > -1;
        };
        return Controller;
    })();
    ClinicalAddressBookModule.Controller = Controller;
})(ClinicalAddressBookModule || (ClinicalAddressBookModule = {}));
angular.module('DoctorApp')
    .controller('ClinicalAddressBookController', ClinicalAddressBookModule.Controller);
/// <reference path="../../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../http-service.ts" />
/// <reference path="../../auth-service.ts" />
var Domain;
(function (Domain) {
    var Event;
    (function (Event_1) {
        var Event = (function () {
            function Event() {
                this.CorrelationIds = [];
            }
            return Event;
        })();
        Event_1.Event = Event;
        var EventResult = (function () {
            function EventResult() {
            }
            return EventResult;
        })();
        Event_1.EventResult = EventResult;
        var Service = (function () {
            Service.$inject = ["httpService", "authService", "$q"];
            function Service(httpService, authService, $q) {
                "ngInject";
                this.httpService = httpService;
                this.authService = authService;
                this.$q = $q;
            }
            Service.prototype.getEventsByNode = function (nodeId, count) {
                return this.httpService.get(this.getUrl() + 'nodes/' + nodeId + '/events/top/' + count);
            };
            Service.prototype.getEvents = function () {
                return this.httpService.get(this.getUrl() + 'events');
            };
            Service.prototype.getTopEvents = function (count) {
                return this.httpService.get(this.getUrl() + 'events' + '?$top=' + count);
            };
            Service.prototype.getEventsByAggregatId = function (tenantId, aggregatId) {
                return this.httpService.get('v1/' + tenantId + '/audit/events/' + aggregatId);
            };
            Service.prototype.getNodes = function () {
                return this.httpService.get(this.getUrl() + 'nodes');
            };
            Service.prototype.getTenantEvents = function (tenantId, fromDate, toDate) {
                return this.httpService.get(this.getUrl() + 'events/' + tenantId + '/from/' + fromDate + '/to/' + toDate);
            };
            Service.prototype.getUrl = function () {
                return 'v1/audit/';
            };
            return Service;
        })();
        Event_1.Service = Service;
    })(Event = Domain.Event || (Domain.Event = {}));
})(Domain || (Domain = {}));
angular.module('DoctorApp')
    .service('eventDomain', Domain.Event.Service);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../services/api/domain/event.ts" />
var AuditModule;
(function (AuditModule) {
    var Service = (function () {
        Service.$inject = ["httpService", "billingDomain", "eventDomain"];
        function Service(httpService, billingDomain, eventDomain) {
            "ngInject";
            this.httpService = httpService;
            this.billingDomain = billingDomain;
            this.eventDomain = eventDomain;
        }
        Service.prototype.getEvents = function (nodeId, count) {
            if (nodeId === Service.ALL || !nodeId) {
                return this.eventDomain.getTopEvents(count);
            }
            return this.eventDomain.getEventsByNode(nodeId, count);
        };
        Service.prototype.getEventsForAggregateId = function (tenantId, aggregateId) {
            return this.eventDomain.getEventsByAggregatId(tenantId, aggregateId);
        };
        Service.prototype.getNodes = function () {
            return this.eventDomain.getNodes()
                .then(function (nodes) {
                var result = nodes;
                result.unshift(Service.ALL);
                return result;
            });
        };
        Service.prototype.getProvider = function (practiceId) {
            return this.billingDomain.getProvider(practiceId);
        };
        Service.ALL = 'All';
        return Service;
    })();
    AuditModule.Service = Service;
})(AuditModule || (AuditModule = {}));
angular.module('DoctorApp')
    .service('auditService', AuditModule.Service);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="audit-service.ts" />
/// <reference path="../../run.ts" />
var AuditModule;
(function (AuditModule) {
    var EventController = (function () {
        EventController.$inject = ["$rootScope", "$scope", "auditService", "$filter", "locationService", "$routeParams"];
        function EventController($rootScope, $scope, auditService, $filter, locationService, $routeParams) {
            "ngInject";
            var _this = this;
            this.$rootScope = $rootScope;
            this.$scope = $scope;
            this.auditService = auditService;
            this.$filter = $filter;
            this.locationService = locationService;
            this.$routeParams = $routeParams;
            $scope.tenantId = $routeParams.tenantId;
            $scope.aggregateId = $routeParams.aggregateId;
            $scope.historyIndex = window.history.length;
            $scope.back = function () {
                var newPosition = window.history.length;
                window.history.go(-(newPosition - $scope.historyIndex + 1));
            };
            $scope.search = function () {
                locationService.goToAuditEvents($scope.tenantId, $scope.aggregateId);
                if (_this.$scope.tenantId === $routeParams.tenantId &&
                    _this.$scope.aggregateId === $routeParams.aggregateId) {
                    _this.search();
                }
            };
            $scope.showEventDetails = function (index) {
                $scope.jsonDetails = $scope.events[index];
                $scope.selectedIndex = index;
            };
            $scope.changeSearch = function (text) {
                var events = text ? $filter('filter')(_this.allEvents, text) : _this.allEvents;
                $scope.events = events.slice(0, $scope.count);
            };
            this.init();
        }
        EventController.prototype.init = function () {
            this.$scope.events = [];
            this.$scope.searchText = "";
            this.$scope.jsonDetails = {};
            this.search();
        };
        EventController.prototype.search = function () {
            var _this = this;
            if (this.$scope.tenantId && this.$scope.aggregateId) {
                this.auditService.getEventsForAggregateId(this.$scope.tenantId, this.$scope.aggregateId)
                    .then(function (events) {
                    _this.allEvents = events;
                    _this.$scope.changeSearch();
                    _this.$scope.showEventDetails(0);
                });
            }
        };
        return EventController;
    })();
    AuditModule.EventController = EventController;
})(AuditModule || (AuditModule = {}));
angular.module('DoctorApp')
    .controller('EventController', AuditModule.EventController);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="audit-service.ts" />
/// <reference path="../../run.ts" />
var AuditModule;
(function (AuditModule) {
    var TenantEventController = (function () {
        TenantEventController.$inject = ["$rootScope", "$scope", "auditService", "$filter", "moment", "eventDomain", "locationService", "$routeParams"];
        function TenantEventController($rootScope, $scope, auditService, $filter, moment, eventDomain, locationService, $routeParams) {
            "ngInject";
            var _this = this;
            this.$rootScope = $rootScope;
            this.$scope = $scope;
            this.auditService = auditService;
            this.$filter = $filter;
            this.moment = moment;
            this.eventDomain = eventDomain;
            this.locationService = locationService;
            this.$routeParams = $routeParams;
            $scope.tenantId = $routeParams.tenantId;
            $scope.historyIndex = window.history.length;
            $scope.back = function () {
                var newPosition = window.history.length;
                window.history.go(-(newPosition - $scope.historyIndex + 1));
            };
            $scope.goToTenantEvents = function () {
                var dateFrom = _this.moment(_this.$scope.dateFrom).format(serverDateFormat);
                var dateTo = _this.moment(_this.$scope.dateTo).format(serverDateFormat);
                locationService.goToTenantEvents($scope.tenantId, dateFrom, dateTo);
            };
            $scope.showEventDetails = function (index) {
                if ($scope.events.length) {
                    $scope.jsonDetails = $scope.events[index];
                    $scope.selectedIndex = index;
                }
            };
            $scope.openAuditEvents = function (event) {
                var practices = [];
                _this.getPracticeIds(event, practices);
                var practiceId = practices.length && practices[0] || StorageModule.Service.EMPTY_PRACTICE_ID;
                _this.locationService.goToAuditEvents(event.EventDetails.BucketPrefix + ":" + practiceId, event.EventDetails.AggregateId);
            };
            $scope.changeSearch = function (text) {
                var events = text ? $filter('filter')(_this.allEvents, text) : _this.allEvents;
                $scope.events = events.slice(0, $scope.count);
                $scope.showEventDetails(0);
                if (text && text === 'EncounterTemplate') {
                    _this.matchJSON('EncounterTemplate');
                }
            };
            $scope.changeFilterByDate = function (first) {
                if (first) {
                    $scope.configTo.min = $scope.dateFrom;
                }
                else {
                    $scope.configFrom.max = $scope.dateTo;
                }
            };
            $scope.setPracticeEvents = function (checkPracticeEvents) {
                if (checkPracticeEvents) {
                    $scope.tenantId = $scope.provider.PracticeTenantId;
                }
                else {
                    $scope.tenantId = $scope.provider.PracticeId;
                }
            };
            this.init();
        }
        TenantEventController.prototype.init = function () {
            var _this = this;
            this.$scope.events = [];
            this.$scope.searchText = "";
            this.$scope.jsonDetails = {};
            this.$scope.checkPracticeEvents = false;
            this.setDefaultDates();
            this.search();
            var practiceId = this.$routeParams.tenantId.substring(this.$routeParams.tenantId.lastIndexOf("_") + 1);
            this.auditService.getProvider(practiceId)
                .then(function (provider) {
                if (provider) {
                    _this.$scope.provider = provider;
                    _this.$scope.checkPracticeEvents = _this.$scope.tenantId === _this.$scope.provider.PracticeTenantId;
                }
            });
        };
        TenantEventController.prototype.matchJSON = function (item) {
            var endJson = [];
            for (var _i = 0, _a = this.$scope.events; _i < _a.length; _i++) {
                var event = _a[_i];
                var encounterTemplate = event.EventDetails[item];
                endJson.push(encounterTemplate);
                this.$scope.templatesJSON = JSON.stringify(endJson);
            }
        };
        TenantEventController.prototype.setDefaultDates = function () {
            if (!this.$routeParams.dateFrom || !this.$routeParams.dateTo) {
                var now = this.moment.utc();
                var daysBefore = 1;
                var tommorow = 1;
                now.add(tommorow, 'days');
                this.$scope.dateTo = this.moment(now);
                this.$scope.dateFrom = now.subtract(daysBefore + tommorow, 'days');
            }
            else {
                this.$scope.dateTo = this.moment(this.$routeParams.dateTo);
                this.$scope.dateFrom = this.moment(this.$routeParams.dateFrom);
            }
            var dateFormat = 'dd MM, yy';
            var configFrom = new DatePickerModule.Config();
            configFrom.format = dateFormat;
            configFrom.max = this.$scope.dateTo;
            this.$scope.configFrom = configFrom;
            var configTo = new DatePickerModule.Config();
            configTo.format = dateFormat;
            configTo.min = this.$scope.dateFrom;
            this.$scope.configTo = configTo;
        };
        TenantEventController.prototype.getPracticeIds = function (event, result) {
            if (event) {
                if (event.hasOwnProperty('PracticeId')) {
                    result.push(event['PracticeId']);
                }
                for (var i = 0; i < Object.keys(event).length; i++) {
                    if (typeof event[Object.keys(event)[i]] == "object") {
                        this.getPracticeIds(event[Object.keys(event)[i]], result);
                    }
                }
            }
        };
        TenantEventController.prototype.search = function () {
            var _this = this;
            if (this.$scope.tenantId && this.$scope.dateFrom && this.$scope.dateTo) {
                var dateFrom = this.moment(this.$scope.dateFrom).format(serverDateFormat);
                var dateTo = this.moment(this.$scope.dateTo).format(serverDateFormat);
                this.eventDomain.getTenantEvents(this.$scope.tenantId, dateFrom, dateTo)
                    .then(function (events) {
                    _this.allEvents = events;
                    _this.$scope.changeSearch();
                    _this.$scope.showEventDetails(0);
                });
            }
        };
        return TenantEventController;
    })();
    AuditModule.TenantEventController = TenantEventController;
})(AuditModule || (AuditModule = {}));
angular.module('DoctorApp')
    .controller('TenantEventController', AuditModule.TenantEventController);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="audit-service.ts" />
/// <reference path="../../run.ts" />
var AuditModule;
(function (AuditModule) {
    var Controller = (function () {
        Controller.$inject = ["$rootScope", "$scope", "auditService", "$filter", "locationService"];
        function Controller($rootScope, $scope, auditService, $filter, locationService) {
            "ngInject";
            var _this = this;
            this.$rootScope = $rootScope;
            this.$scope = $scope;
            this.auditService = auditService;
            this.$filter = $filter;
            this.locationService = locationService;
            $scope.historyIndex = window.history.length;
            $scope.back = function () {
                var newPosition = window.history.length;
                window.history.go(-(newPosition - $scope.historyIndex + 1));
            };
            $scope.updateNodes = function () {
                _this.auditService.getNodes()
                    .then(function (nodes) {
                    $scope.nodes = nodes;
                    $scope.node = nodes[0];
                    $scope.getEvents();
                });
            };
            $scope.tenantEvents = function (event) {
                var practices = [];
                _this.getPracticeIds(event, practices);
                var practiceId = practices.length && practices[0] || StorageModule.Service.EMPTY_PRACTICE_ID;
                locationService.goToTenantEvents(practiceId);
            };
            $scope.getEvents = function () {
                auditService.getEvents($scope.node, $scope.count)
                    .then(function (events) {
                    _this.allEvents = events;
                    $scope.changeSearch($scope.searchText);
                    _this.$scope.showEventDetails(0);
                });
            };
            $scope.showEventDetails = function (index) {
                $scope.jsonDetails = $scope.events[index];
                $scope.selectedIndex = index;
            };
            $scope.openAuditEvents = function (event) {
                var practices = [];
                _this.getPracticeIds(event, practices);
                var practiceId = practices.length && practices[0] || StorageModule.Service.ZERO_PRACTICE_ID;
                _this.locationService.goToAuditEvents(event.EventDetails.BucketPrefix + ":" + practiceId, event.EventDetails.AggregateId);
            };
            $scope.changeSearch = function (text) {
                var events = text ? $filter('filter')(_this.allEvents, text) : _this.allEvents;
                $scope.events = events.slice(0, $scope.count);
                _this.$scope.showEventDetails(0);
            };
            this.init();
        }
        Controller.prototype.init = function () {
            this.$scope.nodes = [];
            this.$scope.events = [];
            this.$scope.node = 0;
            this.$scope.searchText = "";
            this.$scope.jsonDetails = {};
            this.$scope.counts = [200, 500, 1000, 5000, 10000];
            this.$scope.count = this.$scope.counts[0];
            this.$scope.updateNodes();
        };
        Controller.prototype.getPracticeIds = function (event, result) {
            if (event) {
                if (event.hasOwnProperty('PracticeId')) {
                    result.push(event['PracticeId']);
                }
                else if (event.hasOwnProperty('TenantId')) {
                    result.push(event['TenantId']);
                }
                else if (event.hasOwnProperty('PracticeTenantId')) {
                    result.push(event['PracticeTenantId']);
                }
                for (var i = 0; i < Object.keys(event).length; i++) {
                    if (typeof event[Object.keys(event)[i]] == "object") {
                        this.getPracticeIds(event[Object.keys(event)[i]], result);
                    }
                }
            }
        };
        return Controller;
    })();
    AuditModule.Controller = Controller;
})(AuditModule || (AuditModule = {}));
angular.module('DoctorApp')
    .controller('AuditController', AuditModule.Controller);
/// <reference path="../../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../http-service.ts" />
/// <reference path="../../auth-service.ts" />
var Domain;
(function (Domain) {
    var CardPayment;
    (function (CardPayment_1) {
        var CardReader = (function () {
            function CardReader() {
            }
            return CardReader;
        })();
        CardPayment_1.CardReader = CardReader;
        var TransactionDetails = (function () {
            function TransactionDetails() {
            }
            return TransactionDetails;
        })();
        CardPayment_1.TransactionDetails = TransactionDetails;
        var TransactionResult = (function () {
            function TransactionResult() {
            }
            return TransactionResult;
        })();
        CardPayment_1.TransactionResult = TransactionResult;
        var CardPayment = (function () {
            function CardPayment() {
                this.CardReader = new CardReader();
                this.TransactionDetails = new TransactionDetails();
                this.TransactionResult = new TransactionResult();
            }
            return CardPayment;
        })();
        CardPayment_1.CardPayment = CardPayment;
        var CardPaymentStatus = (function () {
            function CardPaymentStatus() {
                this.CardPayment = new CardPayment();
            }
            return CardPaymentStatus;
        })();
        CardPayment_1.CardPaymentStatus = CardPaymentStatus;
        var CardPaymentsByDate = (function () {
            function CardPaymentsByDate() {
                this.CardPayments = [];
            }
            return CardPaymentsByDate;
        })();
        CardPayment_1.CardPaymentsByDate = CardPaymentsByDate;
        var CardPaymentFilter = (function () {
            function CardPaymentFilter() {
            }
            return CardPaymentFilter;
        })();
        CardPayment_1.CardPaymentFilter = CardPaymentFilter;
        var Service = (function () {
            Service.$inject = ["httpService", "authService", "$q"];
            function Service(httpService, authService, $q) {
                "ngInject";
                this.httpService = httpService;
                this.authService = authService;
                this.$q = $q;
            }
            Service.prototype.submitCardPayment = function (payment) {
                var tenantId = payment.TenantId;
                return this.httpService.post("v1/" + tenantId + "/cardprocessing/cardpayments", payment);
            };
            Service.prototype.getCardPayment = function (tenantId, paymentId) {
                return this.httpService.get("v1/" + tenantId + "/cardprocessing/cardpayments/" + paymentId);
            };
            Service.prototype.getCardPaymentsByFilter = function (tenantId, filter) {
                return this.httpService.post("v1/" + tenantId + "/cardprocessing/cardpayments/filter", filter);
            };
            Service.prototype.getCardPayments = function (tenantId) {
                return this.httpService.get("v1/" + tenantId + "/cardprocessing/cardpayments");
            };
            Service.prototype.getCardReaders = function (tenantId) {
                return this.httpService.get("v1/" + tenantId + "/cardprocessing/cardreaders");
            };
            Service.prototype.getCardReader = function (tenantId, cardReaderId) {
                return this.httpService.get("v1/" + tenantId + "/cardprocessing/cardreaders/" + cardReaderId);
            };
            Service.prototype.submitCardReader = function (cardReader) {
                var tenantId = cardReader.TenantId;
                return this.httpService.post("v1/" + tenantId + "/cardprocessing/cardreaders", cardReader);
            };
            Service.prototype.updateCardReader = function (cardReader) {
                var tenantId = cardReader.TenantId;
                return this.httpService.post("v1/" + tenantId + "/cardprocessing/cardreaders/" + cardReader.CardReaderId, cardReader);
            };
            Service.prototype.deleteCardReader = function (tenantId, cardReaderId) {
                return this.httpService.remove("v1/" + tenantId + "/cardprocessing/cardreaders/" + cardReaderId);
            };
            return Service;
        })();
        CardPayment_1.Service = Service;
    })(CardPayment = Domain.CardPayment || (Domain.CardPayment = {}));
})(Domain || (Domain = {}));
angular.module('DoctorApp')
    .service('cardPaymentDomain', Domain.CardPayment.Service);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../services/http-service.ts" />
/// <reference path="../../services/auth-service.ts" />
/// <reference path="../../services/api/domain/card-payment.ts" />
var CardPaymentModule;
(function (CardPaymentModule) {
    var Service = (function () {
        Service.$inject = ["httpService", "authService", "cardPaymentDomain"];
        function Service(httpService, authService, cardPaymentDomain) {
            "ngInject";
            this.httpService = httpService;
            this.authService = authService;
            this.cardPaymentDomain = cardPaymentDomain;
            this.paymentResult = null;
            this.payment = null;
        }
        Service.prototype.setPayment = function (payment) {
            this.payment = payment;
        };
        Service.prototype.getPayment = function () {
            return this.payment;
        };
        Service.prototype.setPaymentResult = function (payment) {
            this.paymentResult = payment;
        };
        Service.prototype.getPaymentResult = function () {
            return this.paymentResult;
        };
        Service.prototype.requestCardPayment = function (payment) {
            return this.cardPaymentDomain.submitCardPayment(payment);
        };
        Service.prototype.getCardPaymentStatus = function (tenantId, paymentId) {
            return this.cardPaymentDomain.getCardPayment(tenantId, paymentId);
        };
        Service.prototype.getAllCardPayments = function (tenantId) {
            return this.cardPaymentDomain.getCardPayments(tenantId);
        };
        Service.prototype.getAllCardPaymentsByFilter = function (tenantId, filter) {
            return this.cardPaymentDomain.getCardPaymentsByFilter(tenantId, filter);
        };
        Service.prototype.getCardreaders = function (tenantId) {
            return this.cardPaymentDomain.getCardReaders(tenantId);
        };
        Service.prototype.getCardreader = function (tenantId, cardreaderId) {
            return this.cardPaymentDomain.getCardReader(tenantId, cardreaderId);
        };
        Service.prototype.createCardreader = function (cardreader) {
            return this.cardPaymentDomain.submitCardReader(cardreader);
        };
        Service.prototype.updateCardreader = function (cardreader) {
            return this.cardPaymentDomain.updateCardReader(cardreader);
        };
        Service.prototype.deleteCardreader = function (tenantId, cardReaderId) {
            return this.cardPaymentDomain.deleteCardReader(tenantId, cardReaderId);
        };
        return Service;
    })();
    CardPaymentModule.Service = Service;
})(CardPaymentModule || (CardPaymentModule = {}));
angular.module('DoctorApp')
    .service('cardPaymentService', CardPaymentModule.Service);
var CardPaymentModule;
(function (CardPaymentModule) {
    (function (PaymentStatus) {
        PaymentStatus[PaymentStatus["UNKNOWN"] = 0] = "UNKNOWN";
        PaymentStatus[PaymentStatus["PAYMENT_REQUESTED"] = 1] = "PAYMENT_REQUESTED";
        PaymentStatus[PaymentStatus["PAYMENT_INITIATED"] = 2] = "PAYMENT_INITIATED";
        PaymentStatus[PaymentStatus["PAYMENT_IN_PROGRESS"] = 3] = "PAYMENT_IN_PROGRESS";
        PaymentStatus[PaymentStatus["PAYMENT_FAILED"] = 4] = "PAYMENT_FAILED";
        PaymentStatus[PaymentStatus["PAYMENT_FINALISED"] = 5] = "PAYMENT_FINALISED";
    })(CardPaymentModule.PaymentStatus || (CardPaymentModule.PaymentStatus = {}));
    var PaymentStatus = CardPaymentModule.PaymentStatus;
    (function (TransactionStatus) {
        TransactionStatus[TransactionStatus["UNDEFINED"] = 0] = "UNDEFINED";
        TransactionStatus[TransactionStatus["AUTHORISED"] = 1] = "AUTHORISED";
        TransactionStatus[TransactionStatus["DECLINED"] = 2] = "DECLINED";
        TransactionStatus[TransactionStatus["PROCESSED"] = 3] = "PROCESSED";
        TransactionStatus[TransactionStatus["FAILED"] = 4] = "FAILED";
        TransactionStatus[TransactionStatus["CANCELLED"] = 5] = "CANCELLED";
    })(CardPaymentModule.TransactionStatus || (CardPaymentModule.TransactionStatus = {}));
    var TransactionStatus = CardPaymentModule.TransactionStatus;
    var StatusUtil = (function () {
        function StatusUtil() {
        }
        StatusUtil.getPaymentName = function (status) {
            return this.PAYMENT_NAMES[status] || this.PAYMENT_NAMES[0];
        };
        StatusUtil.getTransactionName = function (status) {
            return this.TRANSACTION_NAMES[status] || this.TRANSACTION_NAMES[0];
        };
        StatusUtil.PAYMENT_NAMES = [
            "Unknown",
            "PaymentRequested",
            "PaymentInitiated",
            "PaymentInProgress",
            "PaymentFailed",
            "PaymentFinalised",
        ];
        StatusUtil.TRANSACTION_NAMES = [
            "Undefined",
            "Authorised",
            "Declined",
            "Processed",
            "Failed",
            "Cancelled",
        ];
        return StatusUtil;
    })();
    CardPaymentModule.StatusUtil = StatusUtil;
})(CardPaymentModule || (CardPaymentModule = {}));
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../run.ts" />
/// <reference path="card-payment-service.ts" />
var CardPaymentModule;
(function (CardPaymentModule) {
    var CardPaymentController = (function () {
        CardPaymentController.$inject = ["$scope", "$rootScope", "locationService", "cardPaymentService"];
        function CardPaymentController($scope, $rootScope, locationService, cardPaymentService) {
            "ngInject";
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.locationService = locationService;
            this.cardPaymentService = cardPaymentService;
            if (!$scope.paymentResult) {
                locationService.goToHome(StorageModule.Service.EMPTY_PRACTICE_ID);
            }
            $scope.printReceipt = function (receipt) {
                var mywindow = window.open('', 'my div', 'height=400,width=200');
                mywindow.document.write(receipt);
                mywindow.document.close();
                mywindow.focus();
                mywindow.print();
                mywindow.close();
            };
            this.init();
        }
        CardPaymentController.prototype.init = function () {
            this.$scope.title = 'Card payment details';
            this.$scope.paymentResult = this.cardPaymentService.getPaymentResult();
        };
        return CardPaymentController;
    })();
    CardPaymentModule.CardPaymentController = CardPaymentController;
})(CardPaymentModule || (CardPaymentModule = {}));
angular.module('DoctorApp')
    .controller('CardPaymentController', CardPaymentModule.CardPaymentController);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../services/http-service.ts" />
var ClaimResponseModule;
(function (ClaimResponseModule) {
    var Service = (function () {
        Service.$inject = ["httpService", "billingDomain"];
        function Service(httpService, billingDomain) {
            "ngInject";
            this.httpService = httpService;
            this.billingDomain = billingDomain;
        }
        Service.prototype.getClaimResponse = function (invoiceId) {
            return this.billingDomain.getInvoiceWithStatus(invoiceId);
        };
        Service.prototype.getInvoices = function () {
            return this.billingDomain.getInvoices();
        };
        Service.prototype.cancelInvoice = function (invoiceId) {
            return this.billingDomain.cancelInvoice(invoiceId);
        };
        return Service;
    })();
    ClaimResponseModule.Service = Service;
})(ClaimResponseModule || (ClaimResponseModule = {}));
angular.module('DoctorApp')
    .service('claimResponseService', ClaimResponseModule.Service);
var ClaimResponseModule;
(function (ClaimResponseModule) {
    (function (ClaimResponseType) {
        ClaimResponseType[ClaimResponseType["CREATED"] = 0] = "CREATED";
        ClaimResponseType[ClaimResponseType["UPDATED"] = 1] = "UPDATED";
        ClaimResponseType[ClaimResponseType["SUBMITTED"] = 2] = "SUBMITTED";
        ClaimResponseType[ClaimResponseType["PRICED"] = 3] = "PRICED";
        ClaimResponseType[ClaimResponseType["FINALIZED"] = 4] = "FINALIZED";
        ClaimResponseType[ClaimResponseType["CLAIM_SENT_TO_MA"] = 5] = "CLAIM_SENT_TO_MA";
        ClaimResponseType[ClaimResponseType["CLAIM_REJECTED"] = 6] = "CLAIM_REJECTED";
        ClaimResponseType[ClaimResponseType["MA_RESPONSE_RECEIVED"] = 7] = "MA_RESPONSE_RECEIVED";
        ClaimResponseType[ClaimResponseType["MANUAL_PROCESSING"] = 8] = "MANUAL_PROCESSING";
        ClaimResponseType[ClaimResponseType["INVOICE_CANCELLED"] = 9] = "INVOICE_CANCELLED";
        ClaimResponseType[ClaimResponseType["INVOICE_FORWARDED_TO_EXTERNAL_SYSTEM"] = 10] = "INVOICE_FORWARDED_TO_EXTERNAL_SYSTEM";
        ClaimResponseType[ClaimResponseType["CLAIM_REVERSAL_SENT"] = 11] = "CLAIM_REVERSAL_SENT";
    })(ClaimResponseModule.ClaimResponseType || (ClaimResponseModule.ClaimResponseType = {}));
    var ClaimResponseType = ClaimResponseModule.ClaimResponseType;
    var TypeUtil = (function () {
        function TypeUtil() {
        }
        TypeUtil.NAMES = [
            "Created",
            "Updated",
            "Submitted",
            "Priced",
            "Finalized",
            "Claim Sent to MA",
            "Claim Rejected",
            "MA Response Received",
            "Manual Processing",
            "Invoice Cancelled",
            "Invoice forwarded to external system",
            "Claim Reversal Sent"
        ];
        return TypeUtil;
    })();
    ClaimResponseModule.TypeUtil = TypeUtil;
})(ClaimResponseModule || (ClaimResponseModule = {}));
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../card-payments/card-payment-service.ts" />
/// <reference path="../../run.ts" />
/// <reference path="claim-response-service.ts" />
/// <reference path="claim-response-type.ts" />
var ClaimResponseModule;
(function (ClaimResponseModule) {
    var TransactionDetails = (function () {
        function TransactionDetails() {
        }
        return TransactionDetails;
    })();
    ClaimResponseModule.TransactionDetails = TransactionDetails;
    var Payment = (function () {
        function Payment() {
            this.TransactionDetails = new ClaimResponseModule.TransactionDetails();
        }
        return Payment;
    })();
    ClaimResponseModule.Payment = Payment;
    var PaymentRequest = (function () {
        function PaymentRequest() {
            this.payment = new ClaimResponseModule.Payment();
        }
        return PaymentRequest;
    })();
    ClaimResponseModule.PaymentRequest = PaymentRequest;
    var Controller = (function () {
        Controller.$inject = ["$scope", "$rootScope", "claimResponseService", "locationService", "showDialog", "patientService", "$filter", "modalService", "cardPaymentService", "$routeParams"];
        function Controller($scope, $rootScope, claimResponseService, locationService, showDialog, patientService, $filter, modalService, cardPaymentService, $routeParams) {
            "ngInject";
            var _this = this;
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.claimResponseService = claimResponseService;
            this.locationService = locationService;
            this.showDialog = showDialog;
            this.patientService = patientService;
            this.$filter = $filter;
            this.modalService = modalService;
            this.cardPaymentService = cardPaymentService;
            this.$routeParams = $routeParams;
            this.getTotalClaimed = function () {
                var total = 0;
                for (var i = 0; i < _this.$scope.invoiceLines.length; i++) {
                    total += Number(_this.$scope.invoiceLines[i].TotalIncVat);
                }
                return total;
            };
            $scope.hasResponse = function () {
                return $scope.invoice.InvoiceLineItemsWithStatusVo !== undefined;
            };
            $scope.concatPatient = function (patientDetails) {
                var result = (patientDetails.FirstName || '') + ' ' + (patientDetails.Surname || '');
                return $filter('truncate')($filter('titlecase')(result), 50);
            };
            $scope.refresh = function () {
                _this.updateClaimResponse(_this.claimId);
            };
            $scope.cancelInvoice = function () {
                var noValid = _this.checkValidStatus($scope.invoice.Status);
                if (noValid) {
                    showDialog.info(noValid);
                }
                else {
                    showDialog.confirm("Do you want to cancel this invoice ?")
                        .then(function () {
                        return claimResponseService.cancelInvoice($scope.invoice.InvoiceId);
                    })
                        .then(function (response) {
                        if (response.Sucess === false) {
                            showDialog.info(response.ResponseMessage);
                        }
                        else {
                            showDialog.info("Invoice was canceled.");
                            $scope.refresh();
                        }
                    });
                }
            };
            $scope.$watch('paymentRequest.submited', function (newValue) {
                if (newValue) {
                    cardPaymentService.setPayment($scope.invoice);
                    locationService.goToCardPayments();
                }
            });
            $scope.pay = function () {
                var invoice = $scope.invoice.InvoiceLineItemsWithStatusVo;
                var amount = (invoice.MaPayableAmount + invoice.PatientLiable == 0) ? $scope.totalInvoice : invoice.PatientLiable;
                if (amount) {
                    _this.paymentRequest.payment.TransactionDetails.Amount = amount;
                }
                modalService.openNumbers('int', 'Manual payment')
                    .then(function (res) {
                    _this.paymentRequest.payment.TransactionDetails.Amount = res;
                });
            };
            this.init();
        }
        Controller.prototype.init = function () {
            this.claimId = this.$routeParams.claimId;
            this.$scope.invoice = new Domain.Billing.InvoiceWithStatus();
            this.$scope.invoiceLines = [];
            this.$scope.status = '';
            this.$scope.placeOfService = '';
            this.$scope.totalInvoice = 0;
            var request = new ClaimResponseModule.PaymentRequest();
            request.payment.CustomerReference = 'Customer reference';
            request.payment.TransactionDetails.Amount = 0;
            request.payment.TransactionDetails.Currency = 'ZAR';
            request.payment.TransactionDetails.BudgetMonths = 0;
            request.submited = false;
            this.paymentRequest = request;
            this.updateClaimResponse(this.claimId);
        };
        Controller.prototype.checkValidStatus = function (status) {
            switch (status) {
                case ClaimResponseModule.ClaimResponseType.INVOICE_CANCELLED:
                    return 'The invoice has already been canceled and cannot be canceled again.';
                case ClaimResponseModule.ClaimResponseType.CLAIM_SENT_TO_MA:
                case ClaimResponseModule.ClaimResponseType.CLAIM_REJECTED:
                case ClaimResponseModule.ClaimResponseType.MA_RESPONSE_RECEIVED:
                case ClaimResponseModule.ClaimResponseType.MANUAL_PROCESSING:
                    return null;
                default:
                    return 'The invoice cannot be canceled before sending it. To cancel invoice please cancel patient visit.';
            }
        };
        Controller.prototype.getClaimResponseStatus = function (status) {
            return ClaimResponseModule.TypeUtil.NAMES[status];
        };
        Controller.prototype.updateClaimResponse = function (claimId) {
            var _this = this;
            this.$scope.invoice = new Domain.Billing.InvoiceWithStatus();
            this.$scope.invoiceLines = [];
            this.$scope.status = '';
            this.$scope.placeOfService = '';
            this.$scope.totalInvoice = 0;
            this.claimResponseService.getClaimResponse(claimId)
                .then(function (response) {
                _this.$scope.invoice = response;
                _this.$scope.invoiceLines = response.InvoiceLineItemsWithStatusVo.LineItemWithStatusVos;
                _this.$scope.placeOfService = _this.getPlacesOfService(_this.$scope.invoice.InvoiceLineItemsWithStatusVo.InvoiceHeader.HospitalIndicator);
                _this.$scope.status = _this.getClaimResponseStatus(_this.$scope.invoice.Status);
                _this.$scope.totalInvoice = _this.getTotalClaimed();
            });
        };
        Controller.prototype.getPlacesOfService = function (indicator) {
            if (indicator) {
                return "Hospital";
            }
            return "Practice";
        };
        return Controller;
    })();
    ClaimResponseModule.Controller = Controller;
})(ClaimResponseModule || (ClaimResponseModule = {}));
angular.module('DoctorApp')
    .controller('ClaimResponseController', ClaimResponseModule.Controller);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../services/api/domain/tenant.ts" />
/// <reference path="../../services/api/domain/card-payment.ts" />
/// <reference path="../claim-response/claim-response.ts" />
/// <reference path="card-payment-status.ts" />
var CardPaymentModule;
(function (CardPaymentModule) {
    var PaymentReceipt = (function () {
        function PaymentReceipt() {
        }
        return PaymentReceipt;
    })();
    CardPaymentModule.PaymentReceipt = PaymentReceipt;
    var PaymentResult = (function () {
        function PaymentResult() {
        }
        return PaymentResult;
    })();
    CardPaymentModule.PaymentResult = PaymentResult;
    var CardPaymentsController = (function () {
        CardPaymentsController.$inject = ["$scope", "$rootScope", "cardPaymentService", "locationService", "modalService", "$filter", "$sce", "$interval", "$routeParams", "tenantDomainService", "moment"];
        function CardPaymentsController($scope, $rootScope, cardPaymentService, locationService, modalService, $filter, $sce, $interval, $routeParams, tenantDomainService, moment) {
            "ngInject";
            var _this = this;
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.cardPaymentService = cardPaymentService;
            this.locationService = locationService;
            this.modalService = modalService;
            this.$filter = $filter;
            this.$sce = $sce;
            this.$interval = $interval;
            this.$routeParams = $routeParams;
            this.tenantDomainService = tenantDomainService;
            this.moment = moment;
            $scope.showReceipt = function (title, receipt) {
                var body = $sce.trustAsHtml(receipt);
                modalService.showReceiptDialog(title, body);
            };
            $scope.getTransactionStatusName = function (s) {
                return CardPaymentModule.StatusUtil.getTransactionName(s);
            };
            $scope.getPaymentStatusName = function (s) {
                return CardPaymentModule.StatusUtil.getPaymentName(s);
            };
            $scope.updateCardpayments = function () {
                var cardPaymentFilter = new Domain.CardPayment.CardPaymentFilter();
                cardPaymentFilter.DateFrom = $scope.dateFrom.format();
                cardPaymentFilter.DateTo = $scope.dateTo.format();
                cardPaymentFilter.IncludeAllTransactions = $scope.includeAllTransactions;
                cardPaymentService.getAllCardPaymentsByFilter($scope.currentTenantId, cardPaymentFilter)
                    .then(function (response) {
                    $scope.cardpaymentsInMemory = response;
                    $scope.changeSearchText($scope.searchText);
                });
            };
            $scope.changeSearchText = function (text) {
                $scope.cardpayments = text
                    ? $filter('filter')($scope.cardpaymentsInMemory, text)
                    : $scope.cardpaymentsInMemory;
            };
            $scope.stopInterval = function () {
                if (angular.isDefined(_this.stop)) {
                    $rootScope.showPaymentStatuses = false;
                    $rootScope.paymentStatus = "";
                    $rootScope.transactionStatus = "";
                    $rootScope.showProgressScreen = false;
                    $interval.cancel(_this.stop);
                    _this.stop = undefined;
                }
            };
            $scope.$watch(function (scope) {
                return _this.paymentRequest.submited;
            }, function (newValue, oldValue) {
                if (newValue) {
                    $scope.pay();
                }
            });
            $scope.pay = function () {
                cardPaymentService.setPayment(null);
                _this.paymentRequest.submited = false;
                $rootScope.showProgressScreen = true;
                _this.paymentRequest.payment.PaymentDate = _this.moment().format();
                _this.paymentRequest.payment.TenantId = $scope.currentTenantId;
                var tenantId = $scope.currentTenantId;
                cardPaymentService.requestCardPayment(_this.paymentRequest.payment)
                    .then(function (response) {
                    if (response.Sucess === false) {
                        $rootScope.showProgressScreen = false;
                        modalService.error("Failed to make payment: " + response.ResponseMessage);
                    }
                    else {
                        var paymentId = response.Data;
                        _this.stop = _this.$interval(function (index) {
                            _this.getPaymentStatus(tenantId, paymentId);
                        }, 3000, 60, true);
                        $scope.$on('$destroy', function () {
                            $scope.stopInterval();
                        });
                    }
                });
            };
            $scope.changeFilterByDate = function (first) {
                if (first) {
                    $scope.configTo.min = $scope.dateFrom;
                }
                else {
                    $scope.configFrom.max = $scope.dateTo;
                }
                $scope.updateCardpayments();
            };
            var that = this;
            $scope.changeFilter = function () {
                that.setDefaultFilterValues();
                $scope.updateCardpayments();
            };
            $scope.takePayment = function () {
                _this.modalService.openNumbers('int', 'Manual payment')
                    .then(function (res) {
                    _this.paymentRequest.payment.TransactionDetails.Amount = res;
                    $scope.pay();
                });
            };
            this.init();
        }
        CardPaymentsController.prototype.init = function () {
            this.$scope.currentTenantId = "";
            this.$scope.tenants = [];
            this.$scope.cardpaymentsInMemory = [];
            this.$scope.cardpayments = [];
            this.$scope.searchText = '';
            this.cardPaymentService.setPaymentResult(null);
            this.setDefaultFilterValues();
            var request = new ClaimResponseModule.PaymentRequest();
            request.payment.CustomerReference = 'CR22222';
            request.payment.TransactionDetails.Amount = 0;
            request.payment.TransactionDetails.Currency = 'ZAR';
            request.payment.TransactionDetails.BudgetMonths = 0;
            request.submited = false;
            this.paymentRequest = request;
            var payment = this.cardPaymentService.getPayment();
            if (payment) {
                this.paymentRequest = payment;
                this.$scope.pay();
            }
            else {
                this.getTenantsAndPayments();
            }
        };
        CardPaymentsController.prototype.setDefaultFilterValues = function () {
            var now = this.moment.utc();
            this.$scope.dateTo = this.moment(now);
            this.$scope.dateFrom = now.subtract(30, 'days');
            var configFrom = new DatePickerModule.Config();
            configFrom.format = CardPaymentsController.DATE_PATTERN;
            configFrom.max = this.$scope.dateTo;
            this.$scope.configFrom = configFrom;
            var configTo = new DatePickerModule.Config();
            configTo.format = CardPaymentsController.DATE_PATTERN;
            configTo.min = this.$scope.dateFrom;
            this.$scope.configTo = configTo;
            this.$scope.includeAllTransactions = false;
        };
        CardPaymentsController.prototype.getPaymentStatus = function (tenantId, paymentId) {
            var _this = this;
            this.cardPaymentService.getCardPaymentStatus(tenantId, paymentId)
                .then(function (cardPaymentResult) {
                _this.$rootScope.showPaymentStatuses = true;
                _this.$rootScope.paymentStatus = _this.$scope.getPaymentStatusName(cardPaymentResult.Status);
                _this.$rootScope.transactionStatus = (cardPaymentResult.CardPayment.TransactionResult)
                    ? _this.$scope
                        .getTransactionStatusName(cardPaymentResult.CardPayment.TransactionResult.TransactionStatus)
                    : _this.$scope.getTransactionStatusName(0);
                if (cardPaymentResult.Status == 4 || cardPaymentResult.Status == 5) {
                    _this.$scope.stopInterval();
                    _this.showPaymentResult(cardPaymentResult);
                }
            });
        };
        CardPaymentsController.prototype.getTenantsAndPayments = function () {
            var _this = this;
            this.tenantDomainService.getTenantList()
                .then(function (response) {
                if (response) {
                    _this.$scope.tenants = response;
                    if (response.length > 0) {
                        _this.$scope.currentTenantId = response[0].TenantId;
                        _this.$scope.updateCardpayments();
                    }
                }
            });
        };
        CardPaymentsController.prototype.showPaymentResult = function (result) {
            var paymentResult = {
                "PaymentStatus": this.$scope.getPaymentStatusName(result.Status),
                "TransactionStatus": this.$scope
                    .getTransactionStatusName(result.CardPayment.TransactionResult.TransactionStatus),
                "CustomerReceipt": {
                    "HtmlText": "",
                    "Object": ""
                },
                "MerchantReceipt": {
                    "HtmlText": "",
                    "Object": ""
                },
                "SignatureReceipt": {
                    "HtmlText": "",
                    "Object": ""
                }
            };
            var transactionResult = result.CardPayment.TransactionResult;
            if (transactionResult) {
                if (transactionResult.CustomerReceipt) {
                    paymentResult.CustomerReceipt.HtmlText = transactionResult.CustomerReceipt;
                    paymentResult.CustomerReceipt.Object = this.$sce.trustAsHtml(transactionResult.CustomerReceipt);
                }
                if (transactionResult.MerchantReceipt) {
                    paymentResult.MerchantReceipt.HtmlText = transactionResult.MerchantReceipt;
                    paymentResult.MerchantReceipt.Object = this.$sce.trustAsHtml(transactionResult.MerchantReceipt);
                }
                if (transactionResult.SignatureReceipt) {
                    paymentResult.SignatureReceipt.HtmlText = transactionResult.SignatureReceipt;
                    paymentResult.SignatureReceipt.Object = this.$sce.trustAsHtml(transactionResult.SignatureReceipt);
                }
            }
            this.cardPaymentService.setPaymentResult(paymentResult);
            this.locationService.goToCardPayments();
        };
        CardPaymentsController.DATE_PATTERN = 'dd MM, yy';
        return CardPaymentsController;
    })();
    CardPaymentModule.CardPaymentsController = CardPaymentsController;
})(CardPaymentModule || (CardPaymentModule = {}));
angular.module('DoctorApp')
    .controller('CardPaymentsController', CardPaymentModule.CardPaymentsController);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../services/show-dialog.ts" />
/// <reference path="../../screens/card-payments/card-payment-service.ts" />
/// <reference path="../../services/api/domain/tenant.ts" />
var CardReaderModule;
(function (CardReaderModule) {
    var CardReaderCreateController = (function () {
        CardReaderCreateController.$inject = ["$scope", "locationService", "showDialog", "cardPaymentService", "tenantDomainService"];
        function CardReaderCreateController($scope, locationService, showDialog, cardPaymentService, tenantDomainService) {
            "ngInject";
            this.$scope = $scope;
            this.locationService = locationService;
            this.showDialog = showDialog;
            this.cardPaymentService = cardPaymentService;
            this.tenantDomainService = tenantDomainService;
            $scope.create = true;
            $scope.title = 'Create card reader';
            $scope.tenants = [];
            $scope.done = function (isValid) {
                if (isValid) {
                    saveCardreader($scope.cardreader);
                }
            };
            function getTenants() {
                tenantDomainService.getTenantList().then(function (response) {
                    $scope.tenants = response;
                });
            }
            function saveCardreader(cardreader) {
                cardPaymentService.createCardreader(cardreader).then(function (response) {
                    if (response.Sucess === false) {
                        showDialog.error(response.ResponseMessage);
                    }
                    else {
                        showDialog.info("The new card reader was successfully created.");
                        locationService.goToCardPayments();
                    }
                });
            }
            (function init() {
                $scope.cardreader = {
                    "CardReaderId": "",
                    "TenantId": "",
                    "NodeId": 0,
                    "Identifier": "",
                    "SerialNumber": "",
                    "Address": "",
                    "Port": "",
                    "ConnectionMethod": 1,
                    "SharedSecret": "",
                    "NodeVersion": ""
                };
                getTenants();
            })();
        }
        return CardReaderCreateController;
    })();
    CardReaderModule.CardReaderCreateController = CardReaderCreateController;
})(CardReaderModule || (CardReaderModule = {}));
angular.module('DoctorApp')
    .controller('CardReaderCreateController', CardReaderModule.CardReaderCreateController);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../services/show-dialog.ts" />
/// <reference path="../../services/api/domain/tenant.ts" />
/// <reference path="../../screens/card-payments/card-payment-service.ts" />
var CardReaderModule;
(function (CardReaderModule) {
    var CardReaderEditController = (function () {
        CardReaderEditController.$inject = ["$scope", "locationService", "showDialog", "cardPaymentService", "$routeParams", "tenantDomainService"];
        function CardReaderEditController($scope, locationService, showDialog, cardPaymentService, $routeParams, tenantDomainService) {
            "ngInject";
            this.$scope = $scope;
            this.locationService = locationService;
            this.showDialog = showDialog;
            this.cardPaymentService = cardPaymentService;
            this.$routeParams = $routeParams;
            this.tenantDomainService = tenantDomainService;
            $scope.title = 'Edit card reader';
            $scope.tenants = [];
            $scope.done = function (isValid) {
                if (isValid) {
                    if ($scope.cardreader.ConnectionMethod == 5) {
                        $scope.cardreader.Address = "";
                    }
                    saveCardreader($scope.cardreader);
                }
            };
            function getTenants() {
                tenantDomainService.getTenantList().then(function (response) {
                    $scope.tenants = response;
                });
            }
            function saveCardreader(cardreader) {
                cardPaymentService.updateCardreader(cardreader).then(function (response) {
                    if (response.Sucess === false) {
                        showDialog.error(response.ResponseMessage);
                    }
                    else {
                        locationService.goToCardPayments();
                    }
                });
            }
            (function init() {
                getTenants();
                cardPaymentService.getCardreader($routeParams.tenantId, $routeParams.cardreaderId).then(function (response) {
                    if (response) {
                        $scope.cardreader = response;
                    }
                    else {
                        locationService.goToCardPayments();
                    }
                });
            })();
        }
        return CardReaderEditController;
    })();
    CardReaderModule.CardReaderEditController = CardReaderEditController;
})(CardReaderModule || (CardReaderModule = {}));
angular.module('DoctorApp')
    .controller('CardReaderEditController', CardReaderModule.CardReaderEditController);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../services/http-service.ts" />
/// <reference path="../../services/api/domain/tenant.ts" />
var CardReaderModule;
(function (CardReaderModule) {
    var Service = (function () {
        Service.$inject = ["httpService", "tenantDomainService"];
        function Service(httpService, tenantDomainService) {
            "ngInject";
            this.httpService = httpService;
            this.tenantDomainService = tenantDomainService;
        }
        Service.prototype.getTenants = function () {
            return this.tenantDomainService.getTenantList()
                .then(function (response) {
                if (response) {
                    return response;
                }
                return [];
            });
        };
        return Service;
    })();
    CardReaderModule.Service = Service;
})(CardReaderModule || (CardReaderModule = {}));
angular.module('DoctorApp')
    .service('cardReaderService', CardReaderModule.Service);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../card-payments/card-payment-service.ts" />
/// <reference path="../../services/api/domain/tenant.ts" />
/// <reference path="../../services/api/domain/card-payment.ts" />
/// <reference path="../../run.ts" />
/// <reference path="card-reader-service.ts" />
var CardReaderModule;
(function (CardReaderModule) {
    var CardReadersController = (function () {
        CardReadersController.$inject = ["$scope", "$rootScope", "cardPaymentService", "showDialog", "$filter", "locationService", "cardReaderService"];
        function CardReadersController($scope, $rootScope, cardPaymentService, showDialog, $filter, locationService, cardReaderService) {
            "ngInject";
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.cardPaymentService = cardPaymentService;
            this.showDialog = showDialog;
            this.$filter = $filter;
            this.locationService = locationService;
            this.cardReaderService = cardReaderService;
            $scope.goToCreateCardReader = function () {
                locationService.goToCardReaderCreate();
            };
            $scope.goToEditCardReader = function (cardreader) {
                locationService.goToCardReaderEdit(cardreader.TenantId, cardreader.CardReaderId);
            };
            $scope.deleteCardReader = function (cardReader) {
                showDialog.confirm("Are you sure want to delete card reader: " + cardReader.Identifier)
                    .then(function () {
                    return cardPaymentService.deleteCardreader(cardReader.TenantId, cardReader.CardReaderId);
                })
                    .then(function (response) {
                    if (response.Sucess === false) {
                        showDialog.error(response.ResponseMessage);
                    }
                    else {
                        $scope.updateCardReaders();
                        showDialog.info("The card reader: " + cardReader.Identifier + " was successfully deleted.");
                    }
                });
            };
            $scope.updateCardReaders = function () {
                cardPaymentService.getCardreaders($scope.currentTenantId)
                    .then(function (response) {
                    $scope.cardreadersInMemory = response;
                    $scope.changeSearchText($scope.searchText);
                });
            };
            $scope.changeSearchText = function (text) {
                $scope.cardreaders = text ? $filter('filter')($scope.cardreadersInMemory, text) : $scope.cardreadersInMemory;
            };
            this.init();
        }
        CardReadersController.prototype.init = function () {
            this.$scope.currentTenantId = "";
            this.$scope.tenants = [];
            this.$scope.cardreaders = [];
            this.$scope.cardreadersInMemory = [];
            this.$scope.searchText = '';
            this.getTenantsAndCardReaders();
        };
        CardReadersController.prototype.getTenantsAndCardReaders = function () {
            var _this = this;
            this.cardReaderService.getTenants()
                .then(function (response) {
                _this.$scope.tenants = response;
                if (response.length) {
                    _this.$scope.currentTenantId = response[0].TenantId;
                    _this.$scope.updateCardReaders();
                }
            });
        };
        return CardReadersController;
    })();
    CardReaderModule.CardReadersController = CardReadersController;
})(CardReaderModule || (CardReaderModule = {}));
angular.module('DoctorApp')
    .controller('CardReadersController', CardReaderModule.CardReadersController);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../services/location-service.ts" />
/// <reference path="../../services/api/domain/account.ts" />
/// <reference path="../../services/show-dialog.ts" />
var PasswordChangeModule;
(function (PasswordChangeModule) {
    var ConfirmPassword = (function () {
        function ConfirmPassword() {
        }
        return ConfirmPassword;
    })();
    PasswordChangeModule.ConfirmPassword = ConfirmPassword;
    var ChangePasswordController = (function () {
        ChangePasswordController.$inject = ["$scope", "$rootScope", "showDialog", "$routeParams", "storageService", "locationService", "accountDomain"];
        function ChangePasswordController($scope, $rootScope, showDialog, $routeParams, storageService, locationService, accountDomain) {
            "ngInject";
            var _this = this;
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.showDialog = showDialog;
            this.$routeParams = $routeParams;
            this.storageService = storageService;
            this.locationService = locationService;
            this.accountDomain = accountDomain;
            $scope.userId = $routeParams.userId;
            $scope.back = function () {
                if ($scope.isAllowedBack === false) {
                    storageService.clear();
                }
                $rootScope.back();
            };
            $scope.ok = function (isValid) {
                var messages = [];
                if ($scope.changePasswordForm.newPassword.$error.hasSpecialSymbol) {
                    messages.push('- At least one special character');
                }
                if ($scope.changePasswordForm.newPassword.$error.containsDigit) {
                    messages.push('- At least one digit');
                }
                if ($scope.changePasswordForm.newPassword.$error.containsLowerLetter) {
                    messages.push('- At least one Lowercase letter');
                }
                if ($scope.changePasswordForm.newPassword.$error.containsUpperLetter) {
                    messages.push('- At least one Uppercase letter');
                }
                if (!isValid) {
                    if (messages.length > 0) {
                        showDialog.error("Please enter a valid password to meet the following rules:\n" + messages.join('\n'), ModalModule.ModalWidth._375px);
                    }
                    else if ($scope.changePasswordForm.confirmPassword.$error.required ||
                        $scope.changePasswordForm.confirmPassword.$error.notMatched) {
                        showDialog.error("Please enter valid confirm password.");
                    }
                    return;
                }
                if ($scope.user.oldPassword && $scope.user.newPassword) {
                    var request = new Domain.Account.ChangeUserPassword();
                    request.UserId = $scope.userId;
                    request.NewPassword = $scope.user.newPassword;
                    request.OldPassword = $scope.user.oldPassword;
                    _this.accountDomain.changeUserPassword(request)
                        .then(function () {
                        _this.locationService.goToHome($routeParams.practiceId);
                    });
                }
            };
            $scope.changePassword = function () {
                if ($scope.user && $scope.user.confirmPassword) {
                    $scope.changePasswordForm.confirmPassword.matched = $scope.user.confirmPassword === $scope.user.newPassword;
                    $scope.changePasswordForm.confirmPassword.$setValidity('notMatched', $scope.changePasswordForm.confirmPassword.matched);
                }
            };
            this.accountDomain.getUser($routeParams.userId)
                .then(function (user) {
                $scope.isAllowedBack = !user.RequirePasswordChange;
            });
            $scope.user = {
                oldPassword: "",
                newPassword: "",
                confirmPassword: ""
            };
        }
        return ChangePasswordController;
    })();
    PasswordChangeModule.ChangePasswordController = ChangePasswordController;
})(PasswordChangeModule || (PasswordChangeModule = {}));
angular.module('DoctorApp')
    .controller('ChangePasswordController', PasswordChangeModule.ChangePasswordController);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../services/show-dialog.ts" />
/// <reference path="../../run.ts" />
/// <reference path="../consultation/encounter/encounter-service.ts" />
/// <reference path="dashboard-service.ts" />
var DashboardModule;
(function (DashboardModule) {
    var PatientDashboardEvent = Domain.Clinical.PatientDashboardEvent;
    var HealthDocResponse = (function () {
        function HealthDocResponse() {
        }
        return HealthDocResponse;
    })();
    DashboardModule.HealthDocResponse = HealthDocResponse;
    var HealthDocEvent = (function (_super) {
        __extends(HealthDocEvent, _super);
        function HealthDocEvent() {
            _super.apply(this, arguments);
        }
        return HealthDocEvent;
    })(PatientDashboardEvent);
    DashboardModule.HealthDocEvent = HealthDocEvent;
    var Controller = (function () {
        Controller.$inject = ["$scope", "$http", "$filter", "$rootScope", "$routeParams", "$window", "$log", "httpService", "encounterServiceNew", "clinicalReportService", "showDialog", "moment", "$q", "dashboardService", "patientService", "locationService", "providerService", "trackingService", "storageService", "modalService", "usageService"];
        function Controller($scope, $http, $filter, $rootScope, $routeParams, $window, $log, httpService, encounterServiceNew, clinicalReportService, showDialog, moment, $q, dashboardService, patientService, locationService, providerService, trackingService, storageService, modalService, usageService) {
            "ngInject";
            var _this = this;
            this.$scope = $scope;
            this.$http = $http;
            this.$filter = $filter;
            this.$rootScope = $rootScope;
            this.$routeParams = $routeParams;
            this.$window = $window;
            this.$log = $log;
            this.httpService = httpService;
            this.encounterServiceNew = encounterServiceNew;
            this.clinicalReportService = clinicalReportService;
            this.showDialog = showDialog;
            this.moment = moment;
            this.$q = $q;
            this.dashboardService = dashboardService;
            this.patientService = patientService;
            this.locationService = locationService;
            this.providerService = providerService;
            this.trackingService = trackingService;
            this.storageService = storageService;
            this.modalService = modalService;
            this.usageService = usageService;
            $scope.inputFormat = 'YYYY-MM-DD HH:mm:ss';
            $scope.dateFormatByMinutes = 'YYYY-MM-DD HH:mm';
            $scope.outputFormat = 'DD MMM, YYYY';
            $scope.outputFormatTime = 'LT';
            $scope.isEnabledHealthID = false;
            $scope.collapseSummary = true;
            $scope.collapseVisit = true;
            $scope.collapseMembers = true;
            $scope.collapseFinancial = true;
            $scope.collapseFinancialIHealth = true;
            $scope.selectedOrder = [];
            $scope.orderFormat = 'Type';
            $scope.prescriptionDetails = [];
            $scope.familyMembers = [];
            $scope.loading = true;
            $scope.displayEncounterLink = encounterServiceNew.getPatientEvent() != null;
            $scope.isVirtualConsult = false;
            $scope.checkHealthDocCategory = function (order) {
                for (var orderItem in $scope.healthDocCategories) {
                    $scope.healthDocCategories[orderItem]
                        .selected = order.name === $scope.healthDocCategories[orderItem].name;
                }
                var groups = [];
                _this.filteringPatientEvents();
                if (order.name !== 'All') {
                    for (var _i = 0, _a = $scope.groups; _i < _a.length; _i++) {
                        var group = _a[_i];
                        var groupCopy = angular.copy(group);
                        groupCopy.thumbnailList = $filter('filter')(groupCopy.thumbnailList, function (value) {
                            return value.Code === order.name || value.Category === order.name;
                        });
                        if (groupCopy.thumbnailList.length) {
                            groups.push(groupCopy);
                        }
                    }
                    $scope.groups = groups;
                }
            };
            $scope.patient = {
                PracticeId: '',
                PatientId: '',
                FirstName: '',
                Surname: '',
                MedicalAidName: '',
                IdentityNo: '',
                DateOfBirth: '',
                LastVisitDate: '',
                Age: 0,
                Created: false,
                Allergies: [],
                NoAllergies: false,
                ChronicConditions: [],
                AllergiesNote: '',
                ClinicalNotes: '',
                PatientDashboardEventsCount: 0,
                PatientDashboardEvents: []
            };
            $scope.healtDocEvents = [];
            $scope.orders = {
                Diagnosis: { name: 'Diagnosis', value: 0 },
                ClinicalNote: { name: 'ClinicalNote', value: 1 },
                Procedure: { name: 'Procedure', value: 2 },
                Modifier: { name: 'Modifier', value: 2 },
                MedicalInsuranceProcedure: { name: 'MedicalInsuranceProcedure', value: 3 },
                Consumable: { name: 'Consumable', value: 4 },
                Medicine: { name: 'Medicine', value: 5 },
                PrescriptionLine: { name: 'PrescriptionLine', value: 6 },
                MedicalCertificate: { name: 'MedicalCertificate', value: 7 },
                PathologyTest: { name: 'PathologyTest', value: 8 },
                HealthDoc: { name: 'HealthDoc', value: 9 },
                Communication: { name: 'Communication', value: 10 },
                FollowUp: { name: 'FollowUp', value: 11 },
                VisitFollowUpSmsSent: { name: 'VisitFollowUpSmsSent', value: 12 },
                PathResultsFollowUpSmsSent: { name: 'PathResultsFollowUpSmsSent', value: 12 },
                PathResultsNormalSmsSent: { name: 'PathResultsNormalSmsSent', value: 12 },
                ClinicalMetric: { name: 'ClinicalMetric', value: 13 },
                ProviderNote: { name: 'ProviderNote', value: 14 },
                PatientFile: { name: 'PatientFile', value: 15 },
            };
            $scope.orderGroups = [
                {
                    name: 'All',
                    data: [
                        $scope.orders['Procedure'],
                        $scope.orders['MedicalInsuranceProcedure'],
                        $scope.orders['Modifier'],
                        $scope.orders['Consumable'],
                        $scope.orders['Diagnosis'],
                        $scope.orders['ClinicalNote'],
                        $scope.orders['ProviderNote'],
                        $scope.orders['FollowUp'],
                        $scope.orders['PrescriptionLine'],
                        $scope.orders['MedicalCertificate'],
                        $scope.orders['Medicine'],
                        $scope.orders['PathologyTest'],
                        $scope.orders['Communication'],
                        $scope.orders['HealthDoc'],
                        $scope.orders['PatientFile'],
                        $scope.orders['VisitFollowUpSmsSent'],
                        $scope.orders['PathResultsFollowUpSmsSent'],
                        $scope.orders['PathResultsNormalSmsSent'],
                        $scope.orders['ClinicalMetric']
                    ],
                    selected: true
                },
                { name: 'Dx', selected: false, data: [$scope.orders['Diagnosis']] },
                { name: 'Notes', selected: false, data: [$scope.orders['ClinicalNote'], $scope.orders['ProviderNote']] },
                { name: 'Clinical metrics', selected: false, data: [$scope.orders['ClinicalMetric']] },
                {
                    name: 'Rx',
                    selected: false,
                    data: [
                        $scope.orders['Medicine'], $scope.orders['PrescriptionLine']
                    ]
                },
                { name: 'Lab', selected: false, data: [$scope.orders['PathologyTest']] },
                { name: 'Documents', selected: false, data: [$scope.orders['HealthDoc'], $scope.orders['PatientFile']] }
            ];
            $scope.hidePathLineHeader = function (name) {
                return !name.toLowerCase().contains('ampath') &&
                    !name.toLowerCase().contains('lancet') &&
                    !name.toLowerCase().contains('drs dietrich');
            };
            $scope.getPathLogoByEvent = function (event) {
                if (event.ParentDescription.toLowerCase().contains('ampath'))
                    return 'ampath';
                if (event.ParentDescription.toLowerCase().contains('lancet'))
                    return 'lancet';
                return 'pathcare';
            };
            $scope.selectPatient = function () {
                var patientId = $scope.patient.PatientId;
                locationService.goToChangePatient($routeParams.practiceId, patientId);
            };
            $scope.openPdfReport = function (report) {
                var newWindow = _this.$window.open('about:blank', "_blank");
                _this.dashboardService.reportLinkFromHtmlToPdf($routeParams.practiceId, report).then(function (link) {
                    newWindow.location.href = link;
                });
            };
            $scope.openQuoteReport = function () {
                var token = _this.storageService.getAuthorizationData().token;
                var url = _this.dashboardService.getQuoteReportUrl($routeParams.practiceId, $scope.visit.Patient.PatientXRef);
                _this.$window.open(url + "?access_token=" + token, "_blank");
            };
            $scope.getEventDetails = function (event) {
                switch (event.Type) {
                    case "PrescriptionLine":
                        dashboardService.getEncounter($routeParams.practiceId, event.ParentReferenceId)
                            .then(function (encounter) {
                            dashboardService.getPrescriptionReport($routeParams.practiceId, encounter)
                                .then(function (response) {
                                var report = locationService.setAbsoluteServerUrl(response.Data);
                                modalService.showReportDialog(EncounterModule.ReportType.Prescription, [report], function (report) {
                                    $scope.openPdfReport(report);
                                }, $scope.patient.PatientId);
                                trackingService.clickedOnPatientDashboardItem($routeParams.practiceId, event.DateTime, encounter, { NappiCode: event.Code }, EventTypeUtil.getTypeByName('Prescription'));
                            });
                        });
                        break;
                    case "MedicalCertificate":
                        dashboardService.getEncounter($routeParams.practiceId, event.ParentReferenceId)
                            .then(function (encounter) {
                            dashboardService.getMedicalCertificateReport($routeParams.practiceId, encounter)
                                .then(function (response) {
                                var report = locationService.setAbsoluteServerUrl(response.Data);
                                modalService.showReportDialog(EncounterModule.ReportType.MedicalCertificate, [report], function (report) {
                                    $scope.openPdfReport(report);
                                }, $scope.patient.PatientId);
                                trackingService.clickedOnPatientDashboardMedicalCertificate(event.ParentReferenceId, $routeParams.practiceId, event.Narrative, event.DateTime);
                            });
                        });
                        break;
                    case "FollowUp":
                    case "ClinicalNote":
                    case "Diagnosis":
                    case "Procedure":
                    case "Modifier":
                    case "MedicalInsuranceProcedure":
                    case "Medicine":
                    case "Consumable":
                        if (event.ValueFlag == "mymps") {
                            showDialog.info("This clinical information was imported from Mymps and no further details are available.");
                        }
                        else {
                            dashboardService.getEncounter($routeParams.practiceId, event.ParentReferenceId)
                                .then(function (encounter) {
                                var item = {
                                    ChargeCode: event.Code,
                                    NappiCode: event.Code,
                                    DiagnosisCode: event.Code
                                };
                                trackingService.clickedOnPatientDashboardItem($routeParams.practiceId, event.DateTime, encounter, item, EventTypeUtil.getTypeByName(event.Type));
                                locationService.goToEncounter(encounter.PatientEventDetails.PracticeId, encounter.PatientEventDetails.PatientEventId);
                            });
                        }
                        break;
                    case "PathResultsFollowUpSmsSent":
                    case "PathResultsNormalSmsSent":
                    case "VisitFollowUpSmsSent":
                        showDialog.info("SMS sent to patient: " + event.Description);
                        break;
                    case "Communication":
                        dashboardService.getEncounterCommunicationBody($routeParams.practiceId, event.ParentReferenceId)
                            .then(function (body) {
                            modalService.showReportDialog(EncounterModule.ReportType.Communication, [body], function (body) {
                                $scope.openPdfReport(body);
                            }, $scope.patient.PatientId);
                        });
                        break;
                    case "PathologyTest":
                        trackingService.clickedOnPatientDashboardPathReport($routeParams.practiceId, event.PathologyReportId, event.DateTime);
                        usageService.openedPathReport($routeParams.practiceId, event.PathologyReportId, event.DateTime);
                        locationService.goToClinicalPathalogyReport($routeParams.practiceId, event.PathologyReportId);
                        break;
                    case Controller.HEALTH_DOC_TYPE:
                        storageService.setParam(Controller.HEALTH_DOC_TYPE, event);
                        locationService.goToHealthDoc($routeParams.practiceId, $routeParams.patientId);
                        break;
                    case Controller.PATIENT_FILE_TYPE:
                        locationService.goToPatientFile($routeParams.practiceId, event.ParentReferenceId);
                        usageService.openPatientFiles($routeParams.practiceId, event.PatientId, event.ParentReferenceId, storageService.getUser().userLogin);
                        break;
                }
            };
            $scope.captureDocuments = function () {
                if ($scope.myPatientFilesEnabled) {
                    $scope.capturePatientFiles();
                }
            };
            $scope.openAvatarInMyPatientFiles = function () {
                var token = _this.storageService.getAuthorizationData().token;
                var url = GlobalVar.patientFilesUrl +
                    "deeplink-login" +
                    "?navigateTo=page-capture-avatar" +
                    "&practice_id=" +
                    $routeParams.practiceId +
                    "&patient_id=" +
                    $routeParams.patientId +
                    "&token=" +
                    token;
                modalService.showCaptureHealthDocDialog(url, 'Patient Picture')
                    .then(function () {
                    _this.dashboardService.removeAvatarCache(_this.$routeParams.practiceId, _this.$routeParams.patientId);
                    _this.refreshAvatar();
                });
            };
            $scope.openPatientFileDetails = function (item) {
                var token = _this.storageService.getAuthorizationData().token;
                var url = GlobalVar.patientFilesUrl +
                    "deeplink-login" +
                    "?navigateTo=page-document-preview" +
                    "&practice_id=" +
                    $routeParams.practiceId +
                    "&patient_id=" +
                    item.PatientId +
                    "&token=" +
                    token +
                    "&document_id=" +
                    item.ParentReferenceId;
                var newWindow = _this.$window.open(url, "_blank");
            };
            $scope.capturePatientFiles = function () {
                var token = _this.storageService.getAuthorizationData().token;
                var url = GlobalVar.patientFilesUrl +
                    "deeplink-login" +
                    "?practice_id=" +
                    $routeParams.practiceId +
                    "&patient_id=" +
                    $scope.patient.PatientId +
                    "&token=" +
                    token +
                    "&random=" +
                    (new Date()).getTime() +
                    Math.floor(Math.random() * 1000000);
                "";
                modalService.showCaptureHealthDocDialog(url, 'Capture myPatientFiles')
                    .then(function () {
                    return _this.dashboardService.getPatientDashboard($routeParams.practiceId, $scope.patient.PatientId);
                })
                    .then(function (response) {
                    if (response) {
                        _this.$scope.patient = response;
                        _this.displayPatientEvents();
                    }
                });
            };
            $scope.isDOBValid = function () {
                return _this.$scope.patient && moment(_this.$scope.patient.DateOfBirth) < moment();
            };
            $scope.copyEventDetails = function (event) {
                $scope.prescriptionDetails.push(event);
            };
            $scope.hasPrescriptionDetails = function (event) {
                for (var _i = 0, _a = $scope.prescriptionDetails; _i < _a.length; _i++) {
                    var detail = _a[_i];
                    if (event.ParentReferenceId === detail.ParentReferenceId &&
                        event.Narrative === detail.Narrative) {
                        return true;
                    }
                }
                return false;
            };
            $scope.goToHealthId = function () {
                _this.openHealthIdForPatient($routeParams.practiceId, $scope.patient.PatientId);
                usageService.openHealthID($routeParams.practiceId, $routeParams.patientId);
            };
            $scope.goToMedicalHistory = function () {
                locationService.goToMedicalHistory($routeParams.practiceId, $scope.patient.PatientId);
            };
            $scope.goToEncounter = function () {
                dashboardService.captureEncounter($routeParams.practiceId, $scope.patient.PatientId)
                    .then(function (response) {
                    if (response.Sucess) {
                        locationService.goToEncounter($routeParams.practiceId, response.Data.PatientEventId);
                    }
                    else {
                        showDialog.error(response.ResponseMessage);
                    }
                });
            };
            $scope.goToHome = function () {
                locationService.goToHome($routeParams.practiceId);
            };
            $scope.checkGroup = function (orderGroupItem) {
                for (var group in $scope.orderGroups) {
                    $scope.orderGroups[group].selected = $scope.orderGroups[group].name === orderGroupItem.name;
                }
                $scope.selectedOrder = [];
                for (var _i = 0, _a = orderGroupItem.data; _i < _a.length; _i++) {
                    var order = _a[_i];
                    $scope.selectedOrder.push(order.name);
                }
                _this.filteringPatientEvents();
            };
            $scope.openTelehealth = function () {
                if (!_this.$scope.isVirtualConsult) {
                    return;
                }
                window.open(_this.$scope.visit.VideoChatLink);
                trackingService.openedPatientTelehealthFromDashboard(_this.$scope.visit);
            };
            this.$scope.loadExtraData = function () {
                _this.dashboardService.loadExternalData($routeParams.practiceId, $routeParams.patientId)
                    .then(function (res) {
                    _this.dashboardService.getPatientDashboard(_this.$routeParams.practiceId, _this.$routeParams.patientId)
                        .then(function (response) {
                        if (response) {
                            _this.$scope.patient = response;
                            _this.displayPatientEvents();
                        }
                    });
                });
            };
            this.$scope.getFinancialInfo = function () {
                _this.dashboardService.getAccountFinancialInfo($routeParams.practiceId, $routeParams.patientId)
                    .then(function (info) {
                    _this.$scope.accountInfo = info;
                    _this.$scope.collapseFinancial = !(info && (info.LastBenefitCheckStatus || info.IsSuspended ||
                        info.AccountLiable > 0));
                    _this.$scope.financialInformationAvailable = !_this.$scope.collapseFinancial;
                });
            };
            $scope.addFamilyMember = function () {
                _this.patientService.getPatientById($routeParams.practiceId, $routeParams.patientId)
                    .then(function (mainPatient) {
                    var patient = _this.patientService.clearPatientDetails(mainPatient);
                    _this.patientService.setPreCreatedPatient(patient);
                    locationService.goToCreatePatient($routeParams.practiceId);
                });
            };
            $scope.toMemberDashboard = function (patient) {
                clinicalReportService.getPatientDashboard($routeParams.practiceId, patient.PatientId);
            };
            this.init();
        }
        Controller.prototype.init = function () {
            var _this = this;
            for (var orderName in this.$scope.orders) {
                this.$scope.selectedOrder.push(orderName);
            }
            this.dashboardService.getPatientFamilyMembers(this.$routeParams.practiceId, this.$routeParams.patientId)
                .then(function (members) {
                if (members) {
                    _this.$scope.collapseMembers = !members.length;
                    _this.$scope.familyMembers = _this
                        .$filter('orderBy')(members, 'PatientAccountDetails.MedicalAidDependentCode');
                }
            });
            this.patientService.getPatientById(this.$routeParams.practiceId, this.$routeParams.patientId)
                .then(function (patient) {
                var scheme = '';
                if (patient.PatientAccountDetails) {
                    scheme = patient.PatientAccountDetails.MedicalAidName;
                    if (patient.PatientAccountDetails.MedicalAidPlan) {
                        scheme = scheme.concat(" / " + patient.PatientAccountDetails.MedicalAidPlan);
                        if (patient.PatientAccountDetails.MedicalAidPlanOption) {
                            scheme = scheme.concat(" / " + patient.PatientAccountDetails.MedicalAidPlanOption);
                        }
                    }
                }
                _this.$scope.fullSchemeName = scheme;
            });
            this.dashboardService.getActiveVisit(this.$routeParams.practiceId, this.$routeParams.patientId)
                .then(function (visit) {
                _this.$scope.collapseFinancialIHealth = !(visit && visit.QuoteXRef);
                _this.$scope.financialInformationAvailable = !_this.$scope.collapseFinancialIHealth;
                _this.$scope.isVirtualConsult = !!visit.VideoChatLink;
                if (visit) {
                    _this.$scope.visit = visit;
                }
            });
            this.refreshAvatar();
            this.dashboardService.getPatientDashboard(this.$routeParams.practiceId, this.$routeParams.patientId)
                .then(function (response) {
                if (response) {
                    _this.$scope.patient = response;
                    _this.$scope.isSummaryCareRecordExist =
                        !!(response.AllergiesNote ||
                            response.ClinicalNotes ||
                            response.NoAllergies ||
                            response.Allergies && response.Allergies.length ||
                            response.ChronicConditions && response.ChronicConditions.length);
                    _this.$scope.collapseSummary = !_this.$scope.isSummaryCareRecordExist;
                    _this.providerService.getProvider(_this.$routeParams.practiceId)
                        .then(function (provider) {
                        var options = provider && _this.providerService.buildProviderOptions(provider);
                        var healthIdProviderCredentials = options.healthIDProviderCredentials;
                        if (healthIdProviderCredentials) {
                            var healthIdSupported = [
                                'ANGLO MEDICAL SCHEME', 'ANGLO VAAL', 'BANKMED', 'BANKMED ISOLESO',
                                'BMW EMPLOYEES MEDICAL', 'DISCOVERY', 'DISCOVERY ISOLESO', 'DISCOVERY KEYCARE',
                                'DISCOVERY PRIMARY', 'DISCOVERY DRC', 'LA HEALTH', 'LONMIN', 'MEDIMED',
                                'MALCOR', 'MALCOR ENABLEMED', 'NASPERS', 'QUANTUM', 'REMEDI',
                                'REMEDI PPN', 'RETAIL MEDICAL AID', 'SAB MEDICAL SCHEME', 'TFG MEDICAL SCHEME', 'TSOGO SUN GROUP',
                                'UNIVERSITY OF KZN', 'WITSMED', 'WITSMED ISOLESO'
                            ];
                            var medicalAidName = _this.$scope.patient.MedicalAidName;
                            _this.$scope.isEnabledHealthID = healthIdSupported.indexOf(medicalAidName) !== -1;
                        }
                        _this.$scope.isHealthDocEnabled = options.healthDocEnabled;
                        _this.$scope.myPatientFilesEnabled = options.myPatientFilesEnabled;
                        _this.$scope.mympsProvider = provider.PracticeXRef && !provider.PracticeXRef.contains("iHealth");
                        _this.$scope.showFinancialInformation = !options.isDisabledForDisplayingPatientFinancialInformation &&
                            _this.$scope.mympsProvider;
                        if (_this.$scope.showFinancialInformation) {
                            _this.$scope.getFinancialInfo();
                        }
                        _this.$scope.showFinancialInformationIHealth = provider.PracticeXRef && provider.PracticeXRef.contains("iHealth");
                        if (options.healthDocEnabled) {
                            _this.displayPatientEvents();
                        }
                        else {
                            _this.displayPatientEvents();
                        }
                    });
                }
                else {
                    _this.$scope.loading = false;
                }
            });
        };
        Controller.prototype.openHealthIdForPatient = function (practiceId, patientId) {
            var _this = this;
            this.providerService.getProviderOptions(practiceId)
                .then(function (options) {
                var healthIdProviderCredentials = options.healthIDProviderCredentials;
                if (healthIdProviderCredentials) {
                    _this.httpService.get("v1/" +
                        practiceId +
                        "/healthid/patient/" +
                        patientId)
                        .then(function (response) {
                        if (!response.token) {
                            _this.showDialog.error(response.message);
                        }
                        else {
                            var newWindow = _this.$window.open(response.link, "HealthID");
                        }
                    });
                }
            });
        };
        Controller.prototype.refreshAvatar = function () {
            var _this = this;
            this.dashboardService.getAvatar(this.$routeParams.practiceId, this.$routeParams.patientId)
                .then(function (patientDocument) {
                if (patientDocument) {
                    _this.$scope.avatar = _this.dashboardService.getDocumentUrl(_this.$routeParams.practiceId, patientDocument.ThumbnailUrl) + "&r=" + patientDocument.FileName;
                    _this.$scope.avatarOnError = false;
                }
            });
        };
        Controller.prototype.displayPatientEvents = function () {
            var _this = this;
            this.$scope.collapseVisit = false;
            var allEvents = this.$scope.patient.PatientDashboardEvents.concat(this.$scope.healtDocEvents);
            var groupedEventsByDate = this.groupByDate(allEvents, 'DateTime');
            var groups = this.orderBy(this.toArray(groupedEventsByDate));
            var categories = [];
            for (var key in groups) {
                var item = groups[key];
                var fullList = item.list;
                item.list = this.$filter('filter')(fullList, function (f) {
                    return f.Type !== Controller.HEALTH_DOC_TYPE && f.Type !== Controller.PATIENT_FILE_TYPE;
                });
                item.thumbnailList = this.$filter('filter')(fullList, function (f) {
                    return f.Type === Controller.HEALTH_DOC_TYPE || f.Type === Controller.PATIENT_FILE_TYPE;
                }).map(function (list) {
                    if (list.Type === Controller.PATIENT_FILE_TYPE) {
                        var newListItem = angular.copy(list);
                        if (categories.indexOf(list.Code) === -1) {
                            categories.push(list.Code);
                        }
                        newListItem.Thumbnail = _this.dashboardService.getDocumentUrl(_this.$routeParams.practiceId, list.Thumbnail || list.Narrative);
                        return newListItem;
                    }
                    else {
                        return list;
                    }
                });
            }
            this.$scope.healthDocCategories = this.setCategoriesObjects(categories);
            this.$scope.patientEventsByDate = groups;
            this.filteringPatientEvents();
        };
        Controller.prototype.groupByParent = function (arr) {
            var res = {};
            for (var i = 0; i < arr.length; i++) {
                var value = arr[i]["ParentDescription"] || '';
                if (!res[value]) {
                    res[value] = [];
                }
                var group = res[value];
                group[group.length] = arr[i];
            }
            return this.toArray(res);
        };
        Controller.prototype.groupByDate = function (arr, name) {
            var res = {};
            for (var i = 0; i < arr.length; i++) {
                var value = arr[i][name];
                value = this.moment.utc(value).format(this.$scope.dateFormatByMinutes);
                if (!res[value]) {
                    res[value] = [];
                }
                var group = res[value];
                group[group.length] = arr[i];
            }
            return res;
        };
        Controller.prototype.orderByParent = function (groups) {
            for (var i = 0; i < groups.length; i++) {
                groups[i].list = this.$filter('orderBy')(groups[i].list, "ParentReferenceId");
            }
            return groups;
        };
        Controller.prototype.orderByClimeTime = function (groups) {
            var _this = this;
            var that = this;
            for (var i = 0; i < groups.length; i++) {
                groups[i].list = this.$filter('orderBy')(groups[i].list, function (value) {
                    var date = moment(value.DateTime, that.$scope.inputFormat);
                    if (date.isValid) {
                        return date.format('X');
                    }
                    _this.$log.error('Date[' +
                        value.name +
                        '] not valid for pattern[' +
                        that.$scope.inputFormat +
                        ']');
                    return moment().format('X');
                });
            }
            return groups;
        };
        Controller.prototype.filteringPatientEvents = function () {
            var group = angular.copy(this.$scope.patientEventsByDate);
            var checkedEvents = [];
            for (var i = 0; i < group.length; i++) {
                var filteredItems = this.$filter('orderFilter')(group[i].list, this.$scope.selectedOrder, this.$scope.orderFormat);
                group[i].list = this.groupByParent(filteredItems);
                group[i].thumbnailList = this.$filter('orderFilter')(group[i].thumbnailList, this.$scope.selectedOrder, this.$scope.orderFormat);
                if (Object.keys(group[i].list).length > 0 || Object.keys(group[i].thumbnailList).length > 0) {
                    checkedEvents.push(group[i]);
                }
            }
            this.$scope.loading = false;
            this.$scope.groups = checkedEvents;
        };
        Controller.prototype.toArray = function (obj) {
            var res = [];
            Object.keys(obj)
                .map(function (value, index) {
                res[index] = { name: value, list: obj[value] };
            });
            return res;
        };
        Controller.prototype.orderBy = function (groups) {
            var _this = this;
            var that = this;
            var byParentLineNum = function (value) {
                return value.Type === 'Diagnosis' || value["ParentLineNum"];
            };
            var byParent = "ParentReferenceId";
            var byEventsDate = function (value) {
                var date = moment(value.name, ServerDateFormat);
                if (date.isValid) {
                    return date.format();
                }
                _this.$log.error('Date[' + value.name + '] not valid for pattern[' + ServerDateFormat + ']');
                return moment().format('X');
            };
            var byDate = function (value) {
                var date = moment(value.DateTime, that.$scope.inputFormat);
                if (date.isValid) {
                    return date.format('X');
                }
                _this.$log.error('Date[' + value.name + '] not valid for pattern[' + that.$scope.inputFormat + ']');
                return moment().format('X');
            };
            var byType = function (value) {
                var order = _this.$scope.orders[value.Type.split(":")[0]];
                if (angular.isUndefined(order)) {
                    _this.$log.warn('Order for [' + value.Type + '] not set');
                    return 99;
                }
                return order.value;
            };
            var byDateTime = function (value) {
                var date = moment(value.DateTime, that.$scope.inputFormat);
                if (date.isValid) {
                    return date.format('X');
                }
                _this.$log.error('Date[' + value.name + '] not valid for pattern[' + that.$scope.inputFormat + ']');
                return moment().format('X');
            };
            groups = this.$filter('orderBy')(groups, byEventsDate, true);
            for (var i = 0; i < groups.length; i++) {
                groups[i].list = this.$filter('orderBy')(groups[i].list, [byDate, byParent, byParentLineNum, byType, byDateTime]);
            }
            return groups;
        };
        Controller.prototype.setCategoriesObjects = function (categories) {
            var categoryObjects = [];
            for (var _i = 0; _i < categories.length; _i++) {
                var category = categories[_i];
                categoryObjects.push({
                    name: category,
                    selected: false
                });
            }
            if (categories.length > 1) {
                categoryObjects.unshift({ name: 'All', selected: true });
            }
            else if (categories.length === 1) {
                categoryObjects[0].selected = true;
            }
            return categoryObjects;
        };
        Controller.HEALTH_DOC_TYPE = "HealthDoc";
        Controller.PATIENT_FILE_TYPE = "PatientFile";
        return Controller;
    })();
    DashboardModule.Controller = Controller;
})(DashboardModule || (DashboardModule = {}));
angular.module('DoctorApp')
    .controller('ClinicalDashboardController', DashboardModule.Controller);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../services/http-service.ts" />
/// <reference path="../../services/auth-service.ts" />
/// <reference path="../../global.ts" />
var ClinicalMessageCenterModule;
(function (ClinicalMessageCenterModule) {
    var Service = (function () {
        Service.$inject = ["httpService", "$filter", "$routeParams", "authService", "$rootScope", "clinicalDomain"];
        function Service(httpService, $filter, $routeParams, authService, $rootScope, clinicalDomain) {
            "ngInject";
            this.httpService = httpService;
            this.$filter = $filter;
            this.$routeParams = $routeParams;
            this.authService = authService;
            this.$rootScope = $rootScope;
            this.clinicalDomain = clinicalDomain;
            this.currentPractice = null;
        }
        Service.prototype.getPathologyReports = function (practiceId, searchText) {
            return this.clinicalDomain.getPathologyReports(practiceId, searchText);
        };
        Service.prototype.getPathologyReportWorkflows = function (practiceId, startDate, endDate, statusType) {
            return this.clinicalDomain.getPathologyReportWorkflows(practiceId, startDate, endDate, statusType);
        };
        Service.prototype.getPathologyReportWorkflowsForProvider = function (practiceId) {
            return this.clinicalDomain.getPathologyReportWorkflowsForProvider(practiceId, practiceId);
        };
        Service.prototype.getUndeliveredPathResults = function (practiceId) {
            return this.clinicalDomain.getUndeliveredPathResults(practiceId);
        };
        Service.prototype.getPathologyReportPatient = function (practiceId, reportId) {
            return this.clinicalDomain.getPathologyReportPatient(practiceId, reportId);
        };
        Service.prototype.markPathologyReportsAsRead = function (practiceId, workflowIds) {
            return this.clinicalDomain.markPathologyReportsAsRead(practiceId, workflowIds);
        };
        Service.prototype.deliverPathResult = function (practiceId, pathologyReportId) {
            return this.clinicalDomain.deliverPathResult(practiceId, pathologyReportId);
        };
        Service.prototype.ignorePathResult = function (practiceId, pathologyReportId) {
            return this.clinicalDomain.ignorePathResult(practiceId, pathologyReportId);
        };
        return Service;
    })();
    ClinicalMessageCenterModule.Service = Service;
})(ClinicalMessageCenterModule || (ClinicalMessageCenterModule = {}));
angular.module('DoctorApp')
    .service('clinicalMessageCenterService', ClinicalMessageCenterModule.Service);
/// <reference path="../../scripts/definition/angularjs/angular.d.ts" />
var MemoryModule;
(function (MemoryModule) {
    var ClinicalMessageCenter = (function () {
        function ClinicalMessageCenter() {
        }
        return ClinicalMessageCenter;
    })();
    MemoryModule.ClinicalMessageCenter = ClinicalMessageCenter;
    var Practices = (function () {
        function Practices() {
        }
        return Practices;
    })();
    MemoryModule.Practices = Practices;
    var PublicKeys = (function () {
        function PublicKeys() {
        }
        return PublicKeys;
    })();
    MemoryModule.PublicKeys = PublicKeys;
    var Home = (function () {
        function Home() {
        }
        return Home;
    })();
    MemoryModule.Home = Home;
    var Service = (function () {
        function Service() {
            this.clinicalMessageCenter = new ClinicalMessageCenter();
            this.practices = new Practices();
            this.home = new Home();
            this.publicKeys = new PublicKeys();
        }
        return Service;
    })();
    MemoryModule.Service = Service;
})(MemoryModule || (MemoryModule = {}));
angular.module('DoctorApp')
    .service('memoryService', MemoryModule.Service);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../screens/consultation/encounter/encounter-service.ts" />
/// <reference path="../../services/memory-service.ts" />
/// <reference path="clinical-message-center-service.ts" />
var ClinicalMessageCenterModule;
(function (ClinicalMessageCenterModule) {
    var ReportStatusType = Domain.Clinical.ReportStatusType;
    var Controller = (function () {
        Controller.$inject = ["$scope", "$filter", "$location", "locationService", "showDialog", "memoryService", "moment", "clinicalMessageCenterService", "storageService", "patientService", "$routeParams"];
        function Controller($scope, $filter, $location, locationService, showDialog, memoryService, moment, clinicalMessageCenterService, storageService, patientService, $routeParams) {
            "ngInject";
            var _this = this;
            this.$scope = $scope;
            this.$filter = $filter;
            this.$location = $location;
            this.locationService = locationService;
            this.showDialog = showDialog;
            this.memoryService = memoryService;
            this.moment = moment;
            this.clinicalMessageCenterService = clinicalMessageCenterService;
            this.storageService = storageService;
            this.patientService = patientService;
            this.$routeParams = $routeParams;
            $scope.search = function (searchText) {
                memoryService.clinicalMessageCenter.searchText = searchText;
                $scope.showNoResultMessage = false;
                if (!searchText) {
                    $scope.pathologyReportWorkflows = [];
                    return;
                }
                clinicalMessageCenterService.getPathologyReports($routeParams.practiceId, searchText)
                    .then(function (response) {
                    $scope.pathologyReportWorkflows = _this.convertPathologyReportWorkflow(response);
                    $scope.showNoResultMessage = !response.length;
                });
            };
            $scope.changeTab = function (tab) {
                $location.hash(tab);
            };
            $scope.back = function () {
                $location.hash("");
                locationService.goToHome($routeParams.practiceId);
            };
            $scope.addPatientReport = function (report) {
                _this.clinicalMessageCenterService.getPathologyReportPatient($routeParams.practiceId, report.PathologyReportId)
                    .then(function (patient) {
                    if (patient) {
                        patient.NavigationFrom = "UndeliveredPathReports";
                        _this.patientService.setPreCreatedPatient(patient);
                        locationService.goToCreatePatient($routeParams.practiceId);
                    }
                });
            };
            $scope.deliverReport = function (report) {
                _this.clinicalMessageCenterService.deliverPathResult($routeParams.practiceId, report.PathologyReportId)
                    .then(function (response) {
                    if (response.Sucess) {
                        locationService.goToClinicalPathologyReportWorkflow($routeParams.practiceId, response.Data);
                    }
                    else {
                        _this.showDialog.showWarningDialog(response.ResponseMessage);
                    }
                });
            };
            $scope.ignoreReport = function (report) {
                showDialog.confirm('Are you sure you want to ignore report for ' + report.PatientFullName + '?')
                    .then(function () {
                    _this.clinicalMessageCenterService.ignorePathResult($routeParams.practiceId, report.PathologyReportId)
                        .then(function () { return _this.initTabSelection(); });
                });
            };
            $scope.ignoreAll = function () {
                var items = _this.$scope.undeliveredPathResults;
                if (items.length > 0) {
                    showDialog.confirm('Are you sure you want to ignore all undelivered reports?')
                        .then(function () {
                        for (var i = 0; i < items.length; i++) {
                            var reportId = items[i].PathologyReportId;
                            _this.clinicalMessageCenterService.ignorePathResult(_this.$routeParams.practiceId, reportId)
                                .then(function () { return _this.initTabSelection(); });
                        }
                    });
                }
            };
            $scope.setAllItemsRead = function () {
                var items = _this.$scope.pathologyReportWorkflows.map(function (r) { return r.PathologyReportWorkflowId; });
                if (items.length) {
                    var tab = _this.$location.hash();
                    var categoryName = "All unread";
                    switch (tab) {
                        case 'day':
                            categoryName = "Today's unread";
                            break;
                        case 'week':
                            categoryName = "This week’s unread";
                            break;
                    }
                    showDialog.confirm('Are you sure you want to mark as read "' + categoryName + '" reports?')
                        .then(function () {
                        _this.clinicalMessageCenterService.markPathologyReportsAsRead(_this.$routeParams.practiceId, items)
                            .then(function () { return _this.initTabSelection(); });
                    });
                }
            };
            this.initTabSelection();
        }
        Controller.prototype.initTabSelection = function () {
            var tab = this.$location.hash();
            if (!tab) {
                tab = 'week';
                this.$location.hash(tab);
                return;
            }
            this.$scope.tabselection = tab;
            if (tab == 'search') {
                this.$scope.searchText = this.memoryService.clinicalMessageCenter.searchText;
                this.$scope.search(this.$scope.searchText);
                return;
            }
            this.updatePathologyReportWorkflows(tab);
        };
        Controller.prototype.updatePathologyReportWorkflows = function (tabName) {
            var _this = this;
            this.$scope.showNoResultMessage = false;
            if (tabName == "mypatients") {
                this.clinicalMessageCenterService.getPathologyReportWorkflowsForProvider(this.$routeParams.practiceId)
                    .then(function (response) {
                    _this.$scope.pathologyReportWorkflows = response;
                    _this.$scope.showNoResultMessage = !response.length;
                });
            }
            else if (tabName == "undelivered") {
                this.clinicalMessageCenterService.getUndeliveredPathResults(this.$routeParams.practiceId)
                    .then(function (response) {
                    _this.$scope.undeliveredPathResults = response;
                    _this.$scope.showNoResultMessage = !response.length;
                });
            }
            else {
                var params = this.getParamsForReport(tabName);
                this.clinicalMessageCenterService.getPathologyReportWorkflows(this.$routeParams.practiceId, params.startDate, params.endDate, params.statusType)
                    .then(function (response) {
                    _this.$scope.pathologyReportWorkflows = response;
                    _this.$scope.showNoResultMessage = !response.length;
                });
            }
        };
        Controller.prototype.getParamsForReport = function (tabName) {
            var res = {};
            res.statusType = ReportStatusType.OPEN;
            if (tabName == "day") {
                res.startDate = this.moment();
                res.endDate = this.moment().add(1, 'days');
            }
            if (tabName == "week") {
                res.startDate = this.moment().subtract(7, 'days');
                res.endDate = this.moment().add(1, 'days');
            }
            if (tabName == 'urgent') {
                res.statusType = ReportStatusType.URGENT;
            }
            return res;
        };
        Controller.prototype.convertPathologyReportWorkflow = function (pathologyReports) {
            var res = [];
            for (var i = 0; i < pathologyReports.length; i++) {
                res[res.length] = this.convert(pathologyReports[i]);
            }
            return res;
        };
        Controller.prototype.convert = function (pathologyReport) {
            return {
                OriginalMessage: null,
                PathologyReportWorkflowId: pathologyReport.PatientReportId,
                PatientName: pathologyReport.PatientFullName,
                ReceivedDate: pathologyReport.ReportDate,
                Departments: pathologyReport.Departments,
                ReportLabName: pathologyReport.PathLab,
                WorkflowStatusType: null,
                isPathologyReport: true,
                PatientDateOfBirth: pathologyReport.PatientDateOfBirth
            };
        };
        return Controller;
    })();
    ClinicalMessageCenterModule.Controller = Controller;
})(ClinicalMessageCenterModule || (ClinicalMessageCenterModule = {}));
angular.module('DoctorApp')
    .controller('ClinicalMessageCenterController', ClinicalMessageCenterModule.Controller);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../services/http-service.ts" />
/// <reference path="../../services/auth-service.ts" />
/// <reference path="../../global.ts" />
var ClinicalPracticesModule;
(function (ClinicalPracticesModule) {
    var Service = (function () {
        Service.$inject = ["locationService", "storageService", "$rootScope", "clinicalDomain", "accountDomain", "providerService"];
        function Service(locationService, storageService, $rootScope, clinicalDomain, accountDomain, providerService) {
            "ngInject";
            this.locationService = locationService;
            this.storageService = storageService;
            this.$rootScope = $rootScope;
            this.clinicalDomain = clinicalDomain;
            this.accountDomain = accountDomain;
            this.providerService = providerService;
            this.currentPractice = null;
        }
        Service.prototype.setLocalPractice = function (practice, redirectToHome) {
            if (practice) {
                var oldPractice = this.storageService.getPractice();
                oldPractice.id = practice.PracticeId;
                oldPractice.name = practice.PracticeName;
                this.storageService.setPractice(oldPractice);
            }
            this.updateLocalPractice(practice.PracticeId, redirectToHome);
        };
        Service.prototype.updateLocalPractice = function (practiceId, redirectToHome) {
            var _this = this;
            console.warn('Method is deprecated. [clinical-practices-service.updateLocalPractice]');
            this.providerService.getProviderOptions(practiceId)
                .then(function (options) {
                _this.$rootScope.isClinical = options.isEnabledForClinicalResults;
            });
            if (redirectToHome) {
                this.locationService.goToHome(practiceId);
            }
        };
        Service.prototype.getPractices = function () {
            return this.accountDomain.getPractices();
        };
        Service.prototype.getAllPractices = function () {
            return this.clinicalDomain.getProviders();
        };
        Service.prototype.getPracticeById = function (practiceId) {
            return this.clinicalDomain.getProviderById(practiceId);
        };
        return Service;
    })();
    ClinicalPracticesModule.Service = Service;
})(ClinicalPracticesModule || (ClinicalPracticesModule = {}));
angular.module('DoctorApp')
    .service('clinicalPracticesService', ClinicalPracticesModule.Service);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="clinical-practices-service.ts" />
var ClinicalPracticesModule;
(function (ClinicalPracticesModule) {
    var Controller = (function () {
        Controller.$inject = ["$scope", "clinicalPracticesService"];
        function Controller($scope, clinicalPracticesService) {
            "ngInject";
            $scope.practices = [];
            $scope.getPractices = function () {
                clinicalPracticesService.getAllPractices()
                    .then(function (response) {
                    if (response) {
                        $scope.practices = response;
                    }
                });
            };
            $scope.goToPractice = function (practice) {
            };
            $scope.init = function () {
                $scope.getPractices();
            };
        }
        return Controller;
    })();
    ClinicalPracticesModule.Controller = Controller;
})(ClinicalPracticesModule || (ClinicalPracticesModule = {}));
angular.module('DoctorApp')
    .controller('ClinicalPractices', ClinicalPracticesModule.Controller);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../services/http-service.ts" />
/// <reference path="../../services/api/domain/tenant.ts" />
var ClinicalReportWorkflowModule;
(function (ClinicalReportWorkflowModule) {
    var PathologyReportNotifications = (function () {
        function PathologyReportNotifications() {
        }
        return PathologyReportNotifications;
    })();
    ClinicalReportWorkflowModule.PathologyReportNotifications = PathologyReportNotifications;
    var PatalogyReportResponce = (function () {
        function PatalogyReportResponce() {
        }
        return PatalogyReportResponce;
    })();
    ClinicalReportWorkflowModule.PatalogyReportResponce = PatalogyReportResponce;
    var PatalogyReportResponceLink = (function () {
        function PatalogyReportResponceLink() {
        }
        return PatalogyReportResponceLink;
    })();
    ClinicalReportWorkflowModule.PatalogyReportResponceLink = PatalogyReportResponceLink;
    var Service = (function () {
        Service.$inject = ["httpService", "billingDomain"];
        function Service(httpService, billingDomain) {
            "ngInject";
            this.httpService = httpService;
            this.billingDomain = billingDomain;
        }
        Service.prototype.getReportWorkflowHtml = function (practiceId, reportId) {
            return (this.httpService
                .get("v1/" + practiceId + "/clinical/pathologyreportworkflows/" + reportId + "/html"));
        };
        Service.prototype.getDoctorName = function (practiceId) {
            return this.billingDomain.getProvider(practiceId).then(function (s) { return s.TreatingDoctorName; });
        };
        Service.prototype.getProvider = function (practiceId) {
            return this.billingDomain.getProvider(practiceId);
        };
        Service.prototype.submitPathologyReportWorkflow = function (practiceId, workflowId, isHighPriority, isCallPatient, isNotifyPatient, patientCellPhone, message) {
            var body = {
                PracticeId: practiceId,
                PathologyReportWorkflowId: workflowId,
                HighPriority: isHighPriority,
                NotifyPatientThatResultsNormal: isNotifyPatient,
                FollowUpAppointmentRequired: isCallPatient,
                FollowUpPatientCellphone: patientCellPhone,
                FollowUpText: message
            };
            return (this.httpService
                .post("v1/" + practiceId + "/clinical/pathologyreportworkflows/" + workflowId, body));
        };
        Service.prototype.getReportWorkflow = function (practiceId, workflowId) {
            return (this.httpService.get("v1/" + practiceId + "/clinical/pathologyreportworkflows/" + workflowId));
        };
        return Service;
    })();
    ClinicalReportWorkflowModule.Service = Service;
})(ClinicalReportWorkflowModule || (ClinicalReportWorkflowModule = {}));
angular.module('DoctorApp')
    .service('clinicalReportWorkflowService', ClinicalReportWorkflowModule.Service);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../services/memory-service.ts" />
/// <reference path="clinical-report-workflow-service.ts" />
/// <reference path="../../common/extend.ts" />
var ClinicalReportWorkflowModule;
(function (ClinicalReportWorkflowModule) {
    var Reminder = (function () {
        function Reminder() {
        }
        return Reminder;
    })();
    ClinicalReportWorkflowModule.Reminder = Reminder;
    var Block = (function () {
        function Block() {
        }
        return Block;
    })();
    ClinicalReportWorkflowModule.Block = Block;
    var Controller = (function () {
        Controller.$inject = ["$scope", "$location", "locationService", "showDialog", "clinicalReportWorkflowService", "clinicalReportService", "$timeout", "dashboardService", "$window", "$routeParams", "modalService", "memoryService", "$q", "$filter"];
        function Controller($scope, $location, locationService, showDialog, clinicalReportWorkflowService, clinicalReportService, $timeout, dashboardService, $window, $routeParams, modalService, memoryService, $q, $filter) {
            "ngInject";
            var _this = this;
            this.$scope = $scope;
            this.$location = $location;
            this.locationService = locationService;
            this.showDialog = showDialog;
            this.clinicalReportWorkflowService = clinicalReportWorkflowService;
            this.clinicalReportService = clinicalReportService;
            this.$timeout = $timeout;
            this.dashboardService = dashboardService;
            this.$window = $window;
            this.$routeParams = $routeParams;
            this.modalService = modalService;
            this.memoryService = memoryService;
            this.$q = $q;
            this.$filter = $filter;
            var template = '<iframe id="frame-report" class="report-pathology"></iframe>';
            $('#report-container').append(template);
            var that = this;
            var REMINDERS = 0;
            var NOTIFICATIONS = 1;
            var reportId = $routeParams.reportId;
            var urgent = $routeParams.urgent == 'true';
            var reportOriginalBody;
            $scope.messageSent = false;
            $scope.list = [
                {
                    name: 'Reminders',
                    icon: 'glyphicon-repeat',
                    items: [
                        { val: urgent, desc: "follow up later" }
                    ]
                }, {
                    name: 'SMS patient',
                    icon: 'glyphicon-envelope',
                    items: [
                        { val: false, desc: "set up appointment" },
                        { val: false, desc: "notify results are normal" }
                    ]
                }
            ];
            clinicalReportWorkflowService.getReportWorkflow($routeParams.practiceId, reportId)
                .then(function (reportWorkflowResponse) {
                $scope.reportWorkflow = reportWorkflowResponse;
                var html = reportWorkflowResponse.OriginalMessage;
                var style = html.contains('ampath') ? 'ampath-report' : 'lancet-report';
                var $report = $('#frame-report');
                var $reportContainer = $('#report-container');
                $reportContainer.addClass(style);
                reportOriginalBody = html;
                var body = $report.contents().find('body');
                body.html(html);
            });
            ;
            $scope.printReport = function () {
                var mywindow = window.open('', 'my div', 'height=500,width=840');
                var head = '<head>' +
                    document.getElementById('frame-report').contentDocument.getElementsByTagName('head')[0].innerHTML +
                    '</head>';
                var body = '<body>' +
                    document.getElementById('frame-report').contentDocument.getElementsByTagName('body')[0].innerHTML +
                    '</body>';
                mywindow.document.open();
                mywindow.document.write(head);
                mywindow.document.write(body);
                _this.$timeout(function () {
                    mywindow.document.close();
                    mywindow.focus();
                    mywindow.print();
                    mywindow.close();
                }, 100);
            };
            $scope.getPatient = function () {
                if ($scope.reportWorkflow) {
                    clinicalReportService
                        .getPatientsByPathologyReport($routeParams.practiceId, $scope.reportWorkflow.PathologyReportId)
                        .then(function (patients) {
                        if (patients.length === 1) {
                            var patient = patients[0];
                            _this.clinicalReportService.getPatientDashboard($routeParams.practiceId, patient.PatientId);
                        }
                        else {
                            _this.modalService.getReportPatients(patients, $scope.reportWorkflow.PathologyReportId);
                        }
                    });
                }
            };
            $scope.send = function () {
                _this.clinicalReportWorkflowService.getProvider(_this.$routeParams.practiceId).then(function (provider) {
                    var patient = new Domain.Patient.Patient();
                    patient.PatientId = $scope.reportWorkflow.PathologyReportId;
                    patient.PatientDetails = new Domain.Patient.PatientDetails();
                    patient.PatientDetails.FirstName = $scope.reportWorkflow.PatientName;
                    patient.PatientDetails.Surname = "";
                    _this.modalService.sendReportByEmail(patient, provider, [
                        {
                            Title: "Pathology Result",
                            Type: "Pathology Report",
                            HtmlBody: reportOriginalBody
                        }
                    ], "Pathology results from " + provider.PracticeName, false);
                });
            };
            $scope.done = function () {
                var isHighPriority = $scope.list[REMINDERS].items[0].val;
                var isNotifyPatient = $scope.list[NOTIFICATIONS].items[0].val;
                var isCallPatient = $scope.list[NOTIFICATIONS].items[1].val;
                if (isNotifyPatient || isCallPatient) {
                    var notificationMessage = $scope.notificationMessage;
                    that.getPatientCellPhone($scope.reportWorkflow.PatientContactNo)
                        .then(function (cellPhone) {
                        that.markReportAsRead(reportId, isHighPriority, isNotifyPatient, isCallPatient, cellPhone, notificationMessage);
                    });
                }
                else {
                    that.markReportAsRead(reportId, isHighPriority, isNotifyPatient, isCallPatient, "", "")
                        .then(function () {
                        that.$scope.back();
                    });
                }
            };
            $scope.save = function () {
                var newWindow = _this.$window.open('about:blank', "_blank");
                _this.dashboardService.reportLinkFromHtmlToPdf($routeParams.practiceId, reportOriginalBody).then(function (link) {
                    newWindow.location.href = link;
                });
            };
            $scope.back = function () {
                var tab = memoryService.clinicalMessageCenter.tabSelect;
                $location.hash(tab);
                locationService.goToClinicalMessageCenter($routeParams.practiceId);
            };
            $scope.selectReminder = function (j, i) {
                var val = angular.copy($scope.list[j].items[i].val);
                that.setRemindersToFalse($scope.list, j);
                $scope.list[j].items[i].val = !val;
                _this.showSmsMessageIfRequired();
            };
            $scope.selectReminderVal = function (j, i) {
                var val = angular.copy($scope.list[j].items[i].val);
                that.setRemindersToFalse($scope.list, j);
                $scope.list[j].items[i].val = val;
                _this.showSmsMessageIfRequired();
            };
            $scope.$watch('notificationMessage', function () {
                if ($scope.notificationMessage) {
                    $scope.charsLeft = 160 - $scope.notificationMessage.length;
                }
            });
        }
        Controller.prototype.generateSmsMessage = function (doctorName) {
            if (!this.$scope.reportWorkflow) {
                return '';
            }
            var patientName = this.$filter('titlecase')(this.$scope.reportWorkflow.PatientName.replace('  ', ' '));
            var isNotifyPatient = this.$scope.list[1].items[0].val;
            var message = "Hi {0}, {1} has received your pathology results which are normal. " +
                "Should further results be received Dr will contact you.";
            if (isNotifyPatient) {
                message = "Hi {0}, {1} has received your pathology results. " +
                    "Please go to see the Doctor for a follow up visit. Thank you";
            }
            message = message.replace("{0}", patientName).replace("{1}", doctorName);
            return message.substring(0, 160);
        };
        Controller.prototype.showSmsMessageIfRequired = function () {
            var _this = this;
            this.$scope.displayNotificationsTemplate = this.$scope.list[1].items[0].val ||
                this.$scope.list[1].items[1].val;
            if (this.$scope.displayNotificationsTemplate) {
                if (this.$scope.doctorName) {
                    this.$scope.notificationMessage = this.generateSmsMessage(this.$scope.doctorName);
                }
                else {
                    this.clinicalReportWorkflowService.getDoctorName(this.$routeParams.practiceId).then(function (doctorName) {
                        _this.$scope.notificationMessage = _this.generateSmsMessage(doctorName || '');
                        _this.$scope.doctorName = doctorName;
                    });
                }
            }
        };
        Controller.prototype.setRemindersToFalse = function (list, blockIndex) {
            var items = list[blockIndex].items;
            for (var i = 0; i < items.length; i++) {
                items[i].val = false;
            }
        };
        Controller.prototype.getPatientCellPhone = function (patientContactNo) {
            if (patientContactNo) {
                return this.$q.when(patientContactNo);
            }
            else {
                return this.showDialog.cellPhone()
                    .then(function (cellPhone) {
                    if (cellPhone) {
                        return cellPhone;
                    }
                });
            }
        };
        Controller.prototype.markReportAsRead = function (reportId, isHighPriority, isNotifyPatient, isCallPatient, patientCellPhone, message) {
            var that = this;
            return that.clinicalReportWorkflowService
                .submitPathologyReportWorkflow(this.$routeParams.practiceId, reportId, isHighPriority, isNotifyPatient, isCallPatient, patientCellPhone, message)
                .then(function (response) {
                if (response.Sucess === false) {
                    that.showDialog.error(response.ResponseMessage);
                }
                else {
                    that.$scope.messageSent = true;
                }
            });
        };
        return Controller;
    })();
    ClinicalReportWorkflowModule.Controller = Controller;
})(ClinicalReportWorkflowModule || (ClinicalReportWorkflowModule = {}));
angular.module('DoctorApp')
    .controller('ClinicalReportWorkflow', ClinicalReportWorkflowModule.Controller);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../services/http-service.ts" />
/// <reference path="../../services/api/domain/tenant.ts" />
var ClinicalReportModule;
(function (ClinicalReportModule) {
    var Service = (function () {
        Service.$inject = ["httpService", "providerService", "billingDomain", "locationService"];
        function Service(httpService, providerService, billingDomain, locationService) {
            "ngInject";
            this.httpService = httpService;
            this.providerService = providerService;
            this.billingDomain = billingDomain;
            this.locationService = locationService;
        }
        Service.prototype.getReportHtml = function (practiceId, reportId) {
            return this.httpService.get("v1/" + practiceId + "/clinical/pathologyreports/" + reportId + "/html");
        };
        Service.prototype.getProvider = function (practiceId) {
            return this.billingDomain.getProvider(practiceId);
        };
        Service.prototype.getPatientsByPathologyReport = function (practiceId, reportId) {
            return this.httpService.get("v1/" + practiceId + "/clinical/pathologyreports/" + reportId + "/linkedpatients");
        };
        Service.prototype.getPathologyReportPatient = function (practiceId, reportId) {
            return this.httpService.get("v1/" + practiceId + "/clinical/pathologyreports/" + reportId + "/patient");
        };
        Service.prototype.getPatientDashboard = function (practiceId, patientId) {
            var _this = this;
            this.providerService.getProviderOptions(practiceId)
                .then(function (options) {
                if (options.isEnabledForClinicalResults) {
                    _this.locationService.goToClinicalDashboard(practiceId, patientId);
                }
                else {
                    _this.locationService.goToInvoice(practiceId, patientId);
                }
            });
        };
        return Service;
    })();
    ClinicalReportModule.Service = Service;
})(ClinicalReportModule || (ClinicalReportModule = {}));
angular.module('DoctorApp')
    .service('clinicalReportService', ClinicalReportModule.Service);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../screens/consultation/encounter/encounter-service.ts" />
/// <reference path="../../services/memory-service.ts" />
/// <reference path="clinical-report-service.ts" />
/// <reference path="../../common/extend.ts" />
var ClinicalReportModule;
(function (ClinicalReportModule) {
    var Controller = (function () {
        Controller.$inject = ["$scope", "$rootScope", "clinicalReportService", "$routeParams", "dashboardService", "$window", "$timeout", "modalService"];
        function Controller($scope, $rootScope, clinicalReportService, $routeParams, dashboardService, $window, $timeout, modalService) {
            "ngInject";
            var _this = this;
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.clinicalReportService = clinicalReportService;
            this.$routeParams = $routeParams;
            this.dashboardService = dashboardService;
            this.$window = $window;
            this.$timeout = $timeout;
            this.modalService = modalService;
            var reportId = $routeParams.reportId;
            var reportOriginalBody;
            var template = '<iframe id="frame-report" class="report-pathology"></iframe>';
            $('#report-container').append(template);
            clinicalReportService.getReportHtml($routeParams.practiceId, reportId)
                .then(function (html) {
                var style = html.contains('ampath') ? 'ampath-report' : 'lancet-report';
                var $report = $('#frame-report');
                var $reportContainer = $('#report-container');
                $reportContainer.addClass(style);
                reportOriginalBody = html;
                var body = $report.contents().find('body');
                body.html(html);
            });
            $scope.getPatient = function () {
                clinicalReportService.getPatientsByPathologyReport($routeParams.practiceId, $routeParams.reportId)
                    .then(function (patients) {
                    if (patients.length === 1) {
                        var patient = patients[0];
                        _this.clinicalReportService.getPatientDashboard(_this.$routeParams.practiceId, patient.PatientId);
                    }
                    else {
                        _this.modalService.getReportPatients(patients, reportId);
                    }
                });
            };
            $scope.send = function () {
                _this.clinicalReportService.getProvider(_this.$routeParams.practiceId).then(function (provider) {
                    _this.clinicalReportService.getPathologyReportPatient(_this.$routeParams.practiceId, _this.$routeParams.reportId)
                        .then(function (patient) {
                        _this.modalService.sendReportByEmail(patient, provider, [
                            {
                                Title: "Pathology Result",
                                Type: "Pathology Report",
                                HtmlBody: reportOriginalBody
                            }
                        ], "Pathology results from " + provider.PracticeName, false);
                    });
                });
            };
            $scope.printReport = function () {
                var mywindow = window.open('', 'my div', 'height=500,width=840');
                var head = '<head>' +
                    document.getElementById('frame-report').contentDocument.getElementsByTagName('head')[0].innerHTML +
                    '</head>';
                var body = '<body>' +
                    document.getElementById('frame-report').contentDocument.getElementsByTagName('body')[0].innerHTML +
                    '</body>';
                mywindow.document.open();
                mywindow.document.write(head);
                mywindow.document.write(body);
                _this.$timeout(function () {
                    mywindow.document.close();
                    mywindow.focus();
                    mywindow.print();
                    mywindow.close();
                }, 100);
            };
            $scope.save = function () {
                var newWindow = _this.$window.open('about:blank', "_blank");
                _this.dashboardService.reportLinkFromHtmlToPdf($routeParams.practiceId, reportOriginalBody).then(function (link) {
                    newWindow.location.href = link;
                });
            };
            $scope.historyIndex = window.history.length;
            $scope.back = function () {
                var newPosition = window.history.length;
                window.history.go(-(newPosition - $scope.historyIndex + 1));
            };
        }
        return Controller;
    })();
    ClinicalReportModule.Controller = Controller;
})(ClinicalReportModule || (ClinicalReportModule = {}));
angular.module('DoctorApp')
    .controller('ClinicalReport', ClinicalReportModule.Controller);
var ReportPatientModalModule;
(function (ReportPatientModalModule) {
    var ReportPatientController = (function () {
        ReportPatientController.$inject = ["model", "$scope", "patientService", "clinicalReportService", "locationService", "$filter", "$modalInstance", "$routeParams"];
        function ReportPatientController(model, $scope, patientService, clinicalReportService, locationService, $filter, $modalInstance, $routeParams) {
            "ngInject";
            var _this = this;
            this.$scope = $scope;
            this.patientService = patientService;
            this.clinicalReportService = clinicalReportService;
            this.locationService = locationService;
            this.$filter = $filter;
            this.$modalInstance = $modalInstance;
            this.$routeParams = $routeParams;
            $scope.patients = this.getPatients(model.patients);
            $scope.toPatientDashboard = function (patient) {
                clinicalReportService.getPatientDashboard($routeParams.practiceId, patient.PatientId);
                $scope.cancel();
            };
            $scope.createNewPatient = function () {
                _this.clinicalReportService.getPathologyReportPatient($routeParams.practiceId, model.reportId)
                    .then(function (patient) {
                    if (patient) {
                        _this.patientService.setPreCreatedPatient(patient);
                        locationService.goToCreatePatient($routeParams.practiceId);
                        $scope.cancel();
                    }
                });
            };
            $scope.cancel = function () {
                $modalInstance.dismiss();
            };
        }
        ReportPatientController.prototype.getPatients = function (patients) {
            for (var _i = 0; _i < patients.length; _i++) {
                var patient = patients[_i];
                patient.DateOfBirth = moment.utc(patient.DateOfBirth).format('DD/MM/YYYY');
                patient.LastVisitDate = patient.LastVisitDate &&
                    moment.utc(patient.LastVisitDate).format(DATE_TIME_PATTERN);
            }
            return patients;
        };
        return ReportPatientController;
    })();
    ReportPatientModalModule.ReportPatientController = ReportPatientController;
})(ReportPatientModalModule || (ReportPatientModalModule = {}));
angular.module('DoctorApp')
    .controller('ReportPatientController', ReportPatientModalModule.ReportPatientController);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../components/template-panel/template-panel.ts" />
/// <reference path="clinical-template-service.ts" />
/// <reference path="../../run.ts" />
/// <reference path="../../services/show-dialog.ts" />
/// <reference path="../../screens/searches/search-service.ts" />
/// <reference path="../consultation/encounter/encounter-service.ts" />
/// <reference path="../../services/api/event-type.ts" />
/// <reference path="../components/modal/modal-service.ts"/>
var ClinicalTemplateModule;
(function (ClinicalTemplateModule) {
    var ControllerAbstract = (function () {
        ControllerAbstract.$inject = ["$scope", "$rootScope", "showDialog", "$filter", "searchService", "clinicalTemplateServiceNew", "modalService", "encounterServiceNew", "clinicalDomain", "$routeParams"];
        function ControllerAbstract($scope, $rootScope, showDialog, $filter, searchService, clinicalTemplateServiceNew, modalService, encounterServiceNew, clinicalDomain, $routeParams) {
            "ngInject";
            var _this = this;
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.showDialog = showDialog;
            this.$filter = $filter;
            this.searchService = searchService;
            this.clinicalTemplateServiceNew = clinicalTemplateServiceNew;
            this.modalService = modalService;
            this.encounterServiceNew = encounterServiceNew;
            this.clinicalDomain = clinicalDomain;
            this.$routeParams = $routeParams;
            var that = this;
            $scope.controlTemplate = {
                selectTemplate: function (template) {
                    $scope.selectTemplate(template);
                },
                isClinical: true,
                isMedicine: true,
                isPrescription: true
            };
            $scope.saveTemplate = function () {
                var error = that.validTemplate($scope.mainTemplate);
                if (error) {
                    showDialog.error(error);
                }
                else {
                    var request = $scope.create
                        ? clinicalTemplateServiceNew.saveTemplate($routeParams.practiceId, $scope.mainTemplate)
                        : clinicalTemplateServiceNew.updateTemplate($routeParams.practiceId, $scope.mainTemplate);
                    request.then(function (response) {
                        if (response.Sucess === false) {
                            showDialog.error(response.ResponseMessage);
                        }
                        else {
                            clinicalDomain.invalidateEncounterTemplateCache($routeParams.practiceId);
                            clinicalTemplateServiceNew.setMainTemplate(null);
                            $rootScope.back();
                        }
                    });
                }
            };
            $scope.templateTypeChanged = function () {
                var groupTemplates = $filter('filter')($scope.templates, { TemplateType: $scope.mainTemplate.TemplateType });
                groupTemplates = $filter('orderBy')(groupTemplates, '-SortOrder');
                $scope.tempSortOrder = groupTemplates[0] ? (1 + groupTemplates[0].SortOrder) : 0;
                $scope.mainTemplate.SortOrder = $scope.tempSortOrder;
            };
            $scope.removeTemplate = function (template, type) {
                var eventType = EventTypeUtil.getTypeByName(type);
                clinicalTemplateServiceNew.removeLineFromTemplate($scope.mainTemplate, template, eventType);
            };
            $scope.selectTemplate = function (template) {
                clinicalTemplateServiceNew.mergeTemplates($routeParams.practiceId, $scope.mainTemplate, template)
                    .then(function (response) {
                    if (response.Data) {
                        $scope.mainTemplate = response.Data;
                        clinicalTemplateServiceNew.setMainTemplate($scope.mainTemplate);
                    }
                    else if (response.ResponseCode === 500) {
                        _this.showDialog.error(response.ResponseMessage);
                    }
                });
            };
            $scope.showQuantity = function (item) {
                modalService.openNumbers('int', 'Enter prescription')
                    .then(function (res) {
                    item.Quantity = res;
                });
            };
            $scope.validateOrder = function () {
                var templateType = $scope.mainTemplate.TemplateType;
                var error = that.validateOrder($scope.mainTemplate, templateType, $scope.templates);
                if (error) {
                    $scope.mainTemplate.SortOrder = $scope.tempSortOrder;
                    showDialog.error(error);
                }
            };
            $scope.openPrescription = function (prescription) {
                var validationOptions = new EncounterModule.ValidateOptions();
                validationOptions.isPricing = false;
                modalService.openDetailsItem(prescription, EventType.PRESCRIPTION, validationOptions).then(function (response) {
                    angular.extend(prescription, response);
                });
            };
            $scope.showLineDetails = function (obj, typeStr) {
                var validationOptions = new EncounterModule.ValidateOptions();
                validationOptions.isPricing = true;
                var type = EventTypeUtil.getTypeByName(typeStr);
                encounterServiceNew.showLineItem($scope, obj, type, validationOptions);
            };
            $scope.openRefferalTemplates = function () {
                var templateId = _this.$routeParams.templateId || '00000000-0000-0000-0000-000000000000';
                _this.encounterServiceNew.getRefferalTemplates(_this.$routeParams.practiceId, templateId)
                    .then(function (templates) {
                    return _this.modalService.openLetterTemplates(templates);
                })
                    .then(function (template) {
                    var clinicalTemplate = new Domain.Clinical.Template();
                    clinicalTemplate.TemplateId = template.TemplateId;
                    clinicalTemplate.PracticeId = template.PracticeId;
                    clinicalTemplate.TemplateType = template.TemplateName;
                    var communication = new Domain.Clinical.Communication();
                    communication.CommunicationTemplateId = template.TemplateId;
                    communication.CommunicationId = '00000000-0000-0000-0000-000000000000';
                    communication.Type = template.TemplateName;
                    communication.Title = template.TemplateName;
                    clinicalTemplate.Communications = [communication];
                    _this.$scope.selectTemplate(clinicalTemplate);
                });
            };
            $scope.addModifiers = function () {
                var encounter = new Domain.Clinical.Encounter();
                encounter.EncounterId = '00000000-0000-0000-0000-000000000000';
                encounter.EncounterLineItems.LineItems = $scope.mainTemplate.EncounterLineItems.LineItems;
                modalService.showModifierDetails(encounter, null, null, true);
            };
            $scope.$watchCollection('mainTemplate.EncounterLineItems.LineItems', function () {
                if ($scope.mainTemplate) {
                    var lineItems = $scope.mainTemplate.EncounterLineItems.LineItems;
                    $scope.procedureAndModifiers = lineItems &&
                        lineItems.filter(function (item) { return item.LineType === "Modifier" ||
                            item.LineType === "Procedure"; });
                }
            });
        }
        ControllerAbstract.prototype.validTemplate = function (template) {
            if (!template.SortOrder && template.SortOrder !== 0) {
                return "Sort order is empty!";
            }
            else {
                var templateType = this.$scope.mainTemplate.TemplateType;
                return this.validateOrder(this.$scope.mainTemplate, templateType, this.$scope.templates);
            }
        };
        ControllerAbstract.prototype.validateOrder = function (mainTemplate, templateType, templates) {
            var order = mainTemplate.SortOrder;
            var groupTemplates = this.$filter('filter')(templates, { TemplateType: templateType });
            if (groupTemplates.length && order != this.$scope.tempSortOrder) {
                for (var i = 0; i < groupTemplates.length; i++) {
                    var template = groupTemplates[i];
                    if (template.TemplateId != mainTemplate.TemplateId && template.SortOrder == order) {
                        return "This order number already used by template : " + groupTemplates[i].Caption;
                    }
                }
            }
            return null;
        };
        ControllerAbstract.prototype.updateTemplate = function () {
            var _this = this;
            var saveTemplate = this.searchService.getSelectedTemplate();
            if (saveTemplate) {
                this.clinicalTemplateServiceNew
                    .mergeTemplates(this.$routeParams.practiceId, this.$scope.mainTemplate, saveTemplate)
                    .then(function (template) {
                    _this.$scope.mainTemplate = template.Data;
                    _this.clinicalTemplateServiceNew.setMainTemplate(template.Data);
                    _this.searchService.eventId = template.TemplateId;
                    _this.searchService.saveSelectedTemplate(null);
                });
            }
        };
        ControllerAbstract.prototype.init = function () {
            this.$scope.templates = [];
        };
        return ControllerAbstract;
    })();
    ClinicalTemplateModule.ControllerAbstract = ControllerAbstract;
})(ClinicalTemplateModule || (ClinicalTemplateModule = {}));
angular.module('DoctorApp')
    .controller('ClinicalTemplateAbstractController', ClinicalTemplateModule.ControllerAbstract);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="clinical-template-abstract.ts" />
var ClinicalTemplateModule;
(function (ClinicalTemplateModule) {
    var CreateController = (function () {
        CreateController.$inject = ["$scope", "$controller", "$routeParams"];
        function CreateController($scope, $controller, $routeParams) {
            "ngInject";
            this.$scope = $scope;
            this.$controller = $controller;
            this.$routeParams = $routeParams;
            this.parent = $controller('ClinicalTemplateAbstractController', { $scope: $scope });
            angular.extend(this, this.parent);
            this.init();
        }
        CreateController.prototype.init = function () {
            var that = this;
            that.parent.init();
            that.parent.clinicalTemplateServiceNew.loadPracticeTemplates(this.$routeParams.practiceId)
                .then(function (templates) {
                that.$scope.templates = templates;
            });
            that.initMainTemplate();
            that.$scope.create = true;
        };
        CreateController.prototype.initMainTemplate = function () {
            var that = this;
            var saveTemplate = that.parent.clinicalTemplateServiceNew.getMainTemplate();
            if (!saveTemplate || !saveTemplate.EncounterLineItems) {
                saveTemplate = new Domain.Clinical.Template();
                that.$scope.mainTemplate = saveTemplate;
                that.parent.clinicalTemplateServiceNew.setMainTemplate(saveTemplate);
            }
            else {
                that.$scope.mainTemplate = saveTemplate;
            }
            that.$scope.mainTemplate.TemplateId = '00000000-0000-0000-0000-000000000000';
            that.$scope.mainTemplate.TemplateType = 'MyTemplate';
            that.$scope.tempSortOrder = that.$scope.mainTemplate.SortOrder;
            that.parent.updateTemplate();
        };
        return CreateController;
    })();
    ClinicalTemplateModule.CreateController = CreateController;
})(ClinicalTemplateModule || (ClinicalTemplateModule = {}));
angular.module('DoctorApp')
    .controller('ClinicalCreateTemplateController', ClinicalTemplateModule.CreateController);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="clinical-template-abstract.ts" />
var ClinicalTemplateModule;
(function (ClinicalTemplateModule) {
    var ControllerEdit = (function () {
        ControllerEdit.$inject = ["$scope", "locationService", "$routeParams", "$q", "$controller"];
        function ControllerEdit($scope, locationService, $routeParams, $q, $controller) {
            "ngInject";
            this.$scope = $scope;
            this.locationService = locationService;
            this.$routeParams = $routeParams;
            this.$q = $q;
            this.$controller = $controller;
            this.parent = $controller('ClinicalTemplateAbstractController', { $scope: $scope });
            angular.extend(this, this.parent);
            this.init();
        }
        ControllerEdit.prototype.init = function () {
            var that = this;
            that.parent.init();
            that.$scope.create = false;
            var templateId = that.$routeParams.templateId;
            that.$q
                .all([
                that.parent.clinicalTemplateServiceNew.execGetPracticeTemplate(that.$routeParams.practiceId, templateId),
                that.parent.clinicalTemplateServiceNew.loadPracticeTemplates(that.$routeParams.practiceId)
            ])
                .then(function (response) {
                that.$scope.mainTemplate = response[0];
                that.$scope.templates = response[1];
                var template = that.$scope.mainTemplate;
                if (!template || !template.EncounterLineItems) {
                    that.locationService.goToClinicalTemplates(that.$routeParams.practiceId);
                }
                that.parent.clinicalTemplateServiceNew.setMainTemplate(that.$scope.mainTemplate);
                that.$scope.tempSortOrder = template.SortOrder;
                that.parent.updateTemplate();
            })
                .catch(function (error) {
                that.locationService.goToClinicalTemplates(that.$routeParams.practiceId);
            });
        };
        return ControllerEdit;
    })();
    ClinicalTemplateModule.ControllerEdit = ControllerEdit;
})(ClinicalTemplateModule || (ClinicalTemplateModule = {}));
angular.module('DoctorApp')
    .controller('ClinicalEditTemplateController', ClinicalTemplateModule.ControllerEdit);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../services/api/domain/clinical.ts" />
/// <reference path="../../screens/consultation/invoice/invoice-service.ts" />
/// <reference path="../../common/common.ts" />
var TemplatesModule;
(function (TemplatesModule) {
    var Service = (function () {
        Service.$inject = ["$q", "$filter", "$rootScope", "storageService", "billingDomain", "clinicalDomain"];
        function Service($q, $filter, $rootScope, storageService, billingDomain, clinicalDomain) {
            "ngInject";
            var _this = this;
            this.$q = $q;
            this.$filter = $filter;
            this.$rootScope = $rootScope;
            this.storageService = storageService;
            this.billingDomain = billingDomain;
            this.clinicalDomain = clinicalDomain;
            $rootScope.$on('EncounterTemplateUpdated', function () {
                var practiceId = storageService.getPracticeId();
                if (practiceId) {
                    _this.clinicalDomain.invalidateEncounterTemplateCache(practiceId);
                }
            });
        }
        Service.prototype.search = function (loadTemplates, text) {
            if (text && text.length) {
                var searchTemplates = [];
                for (var i = 0; i < Service.SEARCH_FIELDS.length; i++) {
                    var templates = this.$filter('filter')(loadTemplates, (_a = {}, _a[Service.SEARCH_FIELDS[i]] = text, _a));
                    searchTemplates = Common.concatWithoutDuplicates(searchTemplates, templates);
                }
                return searchTemplates;
            }
            else {
                return loadTemplates;
            }
            var _a;
        };
        Service.prototype.removeTemplate = function (template) {
            var that = this;
            return this.billingDomain.removeTemplate(template.TemplateId).then(function (response) {
                if (response.Sucess === true) {
                    return that.$q.when(template.TemplateId);
                }
                else {
                    return that.$q.reject(response.ResponseMessage);
                }
            });
        };
        Service.prototype.removeClinicalTemplate = function (practiceId, template) {
            var that = this;
            return this.clinicalDomain.removeTemplate(practiceId, template.TemplateId)
                .then(function (response) {
                if (response.Sucess === true) {
                    that.clinicalDomain.invalidateEncounterTemplateCache(practiceId);
                    return that.$q.when(template.TemplateId);
                }
                else {
                    return that.$q.reject(response.ResponseMessage);
                }
            });
        };
        Service.SEARCH_FIELDS = ['TemplateId', 'Caption', 'TemplateType', 'SortOrder'];
        return Service;
    })();
    TemplatesModule.Service = Service;
})(TemplatesModule || (TemplatesModule = {}));
angular.module('DoctorApp')
    .service('templatesService', TemplatesModule.Service);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../services/show-dialog.ts" />
/// <reference path="../templates/templates-service.ts" />
/// <reference path="../clinical-template/clinical-template-service.ts" />
/// <reference path="../../run.ts" />
var ClinicalTemplatesModule;
(function (ClinicalTemplatesModule) {
    var Controller = (function () {
        Controller.$inject = ["$scope", "$rootScope", "$routeParams", "locationService", "clinicalTemplateServiceNew", "storageService", "templatesService", "showDialog"];
        function Controller($scope, $rootScope, $routeParams, locationService, clinicalTemplateServiceNew, storageService, templatesService, showDialog) {
            "ngInject";
            var _this = this;
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.$routeParams = $routeParams;
            this.locationService = locationService;
            this.clinicalTemplateServiceNew = clinicalTemplateServiceNew;
            this.storageService = storageService;
            this.templatesService = templatesService;
            this.showDialog = showDialog;
            var that = this;
            $scope.search = function (text) {
                $scope.dynamicTemplates = text && text.length
                    ? templatesService.search($scope.templatesInMemory, text)
                    : $scope.templatesInMemory;
                $scope.templates = _this.initScrollingItems($scope.dynamicTemplates);
                $scope.templateTypes = ['All'];
                if ($scope.templates.length) {
                    $scope.templates.forEach(function (template) {
                        if ($scope.templateTypes.indexOf(template.TemplateType) === -1 &&
                            template.TemplateType !== null) {
                            $scope.templateTypes.push(template.TemplateType);
                        }
                    });
                }
                $scope.currentTemplateType = $scope.templateTypes.length > 1 &&
                    $scope.templateTypes.indexOf($scope.currentTemplateType) > -1
                    ? $scope.currentTemplateType
                    : 'All';
            };
            $scope.loadMore = function () {
                var templatesCount = $scope.templates.length;
                if (templatesCount) {
                    for (var i = 0; i < $scope.loadTemplatesPerScroll; i++) {
                        var template = $scope.dynamicTemplates[templatesCount + i];
                        if (template) {
                            $scope.templates.push(template);
                            if ($scope.templateTypes.indexOf(template.TemplateType) === -1 &&
                                template.TemplateType !== null) {
                                $scope.templateTypes.push(template.TemplateType);
                            }
                        }
                    }
                }
            };
            $scope.goToEditTemplate = function (template) {
                clinicalTemplateServiceNew.setMainTemplate(null);
                locationService.goToEditClinicalTemplate($routeParams.practiceId, template.TemplateId);
            };
            $scope.goToCreateTemplate = function () {
                clinicalTemplateServiceNew.setMainTemplate(null);
                locationService.goToCreateClinicalTemplate($routeParams.practiceId);
            };
            $scope.removeTemplatesByType = function () {
                showDialog.confirm('Are you sure you want to delete ' + $scope.currentTemplateType.toLowerCase() + ' templates?')
                    .then(function () {
                    clinicalTemplateServiceNew.removeTemplatesByType($routeParams.practiceId, $scope.currentTemplateType)
                        .then(function () {
                        $scope.currentTemplateType = 'All';
                        that.loadTemplates();
                    })
                        .catch(function (error) {
                        if (error) {
                            showDialog.error(error);
                        }
                    });
                })
                    .catch(function (error) {
                    if (error) {
                        showDialog.error(error);
                    }
                });
            };
            $scope.removeTemplate = function (template) {
                showDialog.confirm('Are you sure want to delete template: ' + template.Caption)
                    .then(function () { return that.templatesService.removeClinicalTemplate($routeParams.practiceId, template); })
                    .catch(function () {
                })
                    .then(function () {
                    that.loadTemplates();
                })
                    .catch(function (error) {
                    showDialog.error(error);
                });
            };
            this.init();
        }
        Controller.prototype.init = function () {
            this.$scope.startTemplatesCount = 28;
            this.$scope.loadTemplatesPerScroll = 3;
            this.$scope.templates = [];
            this.$scope.templatesInMemory = [];
            this.$scope.dynamicTemplates = [];
            this.$scope.templateTypes = ['All'];
            this.$scope.currentTemplateType = 'All';
            this.loadTemplates();
            this.setAdminRules();
        };
        Controller.prototype.loadTemplates = function () {
            var that = this;
            that.clinicalTemplateServiceNew.loadPracticeTemplates(this.$routeParams.practiceId)
                .then(function (templates) {
                that.$scope.templatesInMemory = templates;
                that.$scope.search();
            });
        };
        Controller.prototype.setAdminRules = function () {
            var user = this.storageService.getUser();
            this.$scope.isAdmin = user.role.indexOf('*') > -1;
        };
        Controller.prototype.initScrollingItems = function (templates) {
            var initTemplates = [];
            for (var i = 0; i < this.$scope.startTemplatesCount; i++) {
                if (templates[i]) {
                    initTemplates.push(templates[i]);
                }
            }
            return initTemplates;
        };
        return Controller;
    })();
    ClinicalTemplatesModule.Controller = Controller;
})(ClinicalTemplatesModule || (ClinicalTemplatesModule = {}));
angular.module('DoctorApp')
    .controller('ClinicalTemplatesController', ClinicalTemplatesModule.Controller);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../../scripts/definition/moment/moment-node.d.ts" />
/// <reference path="../consultation/encounter/encounter-service.ts" />
/// <reference path="clinical-visit-outcomes-service.ts" />
/// <reference path="../../run.ts" />
/// <reference path="../../services/show-dialog.ts" />
/// <reference path="../../global.ts" />
var ClinicalVisitOutcomes;
(function (ClinicalVisitOutcomes) {
    var VisitReason = (function () {
        function VisitReason(desc) {
            this.val = false;
            this.desc = desc;
        }
        return VisitReason;
    })();
    ClinicalVisitOutcomes.VisitReason = VisitReason;
    var RemindItem = (function () {
        function RemindItem(name, count, type) {
            this.name = name;
            if (count && type) {
                this.params = [count, type];
            }
        }
        return RemindItem;
    })();
    ClinicalVisitOutcomes.RemindItem = RemindItem;
    var Controller = (function () {
        Controller.$inject = ["$scope", "$filter", "$rootScope", "locationService", "showDialog", "encounterServiceNew", "patientService", "clinicalVisitOutcomesService", "$timeout", "moment", "$window", "$q", "$routeParams"];
        function Controller($scope, $filter, $rootScope, locationService, showDialog, encounterServiceNew, patientService, clinicalVisitOutcomesService, $timeout, moment, $window, $q, $routeParams) {
            "ngInject";
            var _this = this;
            this.$scope = $scope;
            this.$filter = $filter;
            this.$rootScope = $rootScope;
            this.locationService = locationService;
            this.showDialog = showDialog;
            this.encounterServiceNew = encounterServiceNew;
            this.patientService = patientService;
            this.clinicalVisitOutcomesService = clinicalVisitOutcomesService;
            this.$timeout = $timeout;
            this.moment = moment;
            this.$window = $window;
            this.$q = $q;
            this.$routeParams = $routeParams;
            var that = this;
            that.init();
            $scope.changeReason = function (reason) {
                reason.val = !reason.val;
                $scope.remindPatient.message = _this.generateSmsMessage();
            };
            $scope.updateMessage = function () {
                $scope.remindPatient.message = _this.generateSmsMessage();
            };
            $scope.changeItem = function (remindValue) {
                if (remindValue.name === Controller.NONE) {
                    _this.clearReasonsSelected();
                }
                else if ($scope.remindPatient.value.name === Controller.NONE) {
                    $scope.remindPatient.reasonsForFollowUpVisits[Controller.FOLLOW_UP].val = true;
                }
                $scope.remindPatient.value = remindValue;
            };
            $scope.complete = function () {
                if (!_this.validate()) {
                    showDialog.error("Please select a reason for the patient’s next visit");
                    return;
                }
                var encounter = _this.$scope.encounter;
                var encounterFollowUp = clinicalVisitOutcomesService.getEncounterFollowUp($scope.remindPatient);
                encounter.EncounterFollowUp = encounterFollowUp;
                if ($scope.remindPatient.value.name !== Controller.NONE) {
                    _this.getPatientCellPhone(encounter)
                        .then(function (cellPhone) {
                        encounter.EncounterFollowUp.FollowUpPatientCellphone = cellPhone;
                        _this.complete($routeParams.practiceId, encounter);
                    });
                }
                else {
                    _this.complete($routeParams.practiceId, encounter);
                }
            };
            $scope.$watch('remindPatient.message', function () {
                if ($scope.remindPatient && $scope.remindPatient.message) {
                    $scope.charsLeft = 160 - $scope.remindPatient.message.length;
                }
            });
            $scope.$watch('remindPatient.value.name', function () {
                var patient = $scope.remindPatient;
                if (patient) {
                    $scope.isVisibleDate = patient.value.name === Controller.OTHER;
                    $scope.isDisablesReasons = patient.value.name === Controller.NONE;
                    $scope.remindPatient.message = _this.generateSmsMessage();
                }
            });
            $scope.$watch('remindPatient.date', function () {
                if ($scope.remindPatient) {
                    $scope.remindPatient.message = _this.generateSmsMessage();
                }
            });
        }
        Controller.prototype.init = function () {
            var encounter = this.encounterServiceNew.getEncounter();
            var remindGroups = this.clinicalVisitOutcomesService.getRemindList();
            if (!encounter) {
                this.$rootScope.back();
                return;
            }
            this.$scope.encounter = encounter;
            this.$scope.minDate = this.moment().format();
            this.$scope.patientRemindsList = remindGroups;
            this.$scope.showReports = this.encounterServiceNew.isAnyConsultationReport(encounter).length > 0;
            var remindPatient = this.clinicalVisitOutcomesService.createRemindPatient();
            remindPatient.value = this.getRemindItemByName(remindGroups, remindPatient.value.name);
            this.$scope.remindPatient = remindPatient;
            this.$scope.remindPatient.message = this.generateSmsMessage();
        };
        Controller.prototype.generateSmsMessage = function () {
            var encounter = this.encounterServiceNew.getEncounter();
            if (!encounter) {
                return '';
            }
            var patientName = "";
            if (encounter.PatientEventDetails &&
                encounter.PatientEventDetails.Patient &&
                encounter.PatientEventDetails.Patient.PatientDetails) {
                patientName = encounter.PatientEventDetails.Patient.PatientDetails.FirstName;
            }
            var doctorName = encounter.Provider.TreatingDoctorName || "";
            var date = this.clinicalVisitOutcomesService.getFollowupDate(this.$scope.remindPatient);
            var reason = this.clinicalVisitOutcomesService
                .getSelectedReasons(this.$scope.remindPatient.reasonsForFollowUpVisits)
                .join(", ");
            var message = "Hi {0}, you are due to see {1}, don't forget to go before {2} for {3}"
                .replace("{0}", this.$filter('titlecase')(patientName))
                .replace("{1}", doctorName)
                .replace("{2}", date)
                .replace("{3}", reason);
            return message.substring(0, Controller.SMS_LENGTH);
        };
        Controller.prototype.complete = function (practiceId, encounter) {
            var _this = this;
            var consultationReports = this.encounterServiceNew.isAnyConsultationReport(encounter);
            if (consultationReports.length > 0) {
                var patientId = encounter.PatientEventDetails.Patient.PatientId;
                this.locationService.goToConsultationReport(practiceId, patientId, consultationReports[0]);
            }
            else {
                this.encounterServiceNew.submitEncounter(practiceId, encounter)
                    .then(function () {
                    _this.locationService.goToHome(_this.$routeParams.practiceId);
                })
                    .catch(function (error) {
                    _this.showDialog.error(error);
                });
            }
        };
        Controller.prototype.getRemindItemByName = function (remindGroups, name) {
            for (var i = 0; i < remindGroups.length; i++) {
                var remindList = remindGroups[0];
                for (var j = 0; j < remindList.length; j++) {
                    if (remindList[j].name == name) {
                        return remindList[j];
                    }
                }
            }
            return remindGroups[0][0];
        };
        Controller.prototype.clearReasonsSelected = function () {
            var reasons = this.$scope.remindPatient.reasonsForFollowUpVisits;
            for (var i = 0; i < reasons.length; i++) {
                reasons[i].val = false;
            }
        };
        Controller.prototype.validate = function () {
            var remind = this.$scope.remindPatient;
            if (remind.value.name === Controller.NONE) {
                return true;
            }
            for (var i = 0; i < remind.reasonsForFollowUpVisits.length; i++) {
                if (remind.reasonsForFollowUpVisits[i].val) {
                    return true;
                }
            }
            return false;
        };
        Controller.prototype.getPatientCellPhone = function (encounter) {
            var currentCellPhone = encounter.PatientEventDetails.Patient.PatientDetails.ContactNo;
            if (currentCellPhone) {
                return this.$q.when(currentCellPhone);
            }
            else {
                return this.showDialog.cellPhone()
                    .then(function (cellPhone) {
                    if (cellPhone) {
                        return cellPhone;
                    }
                });
            }
        };
        Controller.NONE = "None";
        Controller.OTHER = "Other";
        Controller.FOLLOW_UP = 1;
        Controller.SMS_LENGTH = 160;
        return Controller;
    })();
    ClinicalVisitOutcomes.Controller = Controller;
})(ClinicalVisitOutcomes || (ClinicalVisitOutcomes = {}));
angular.module('DoctorApp')
    .controller('ClinicalVisitOutcomesController', ClinicalVisitOutcomes.Controller);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="clinical-visit-outcomes.ts" />
/// <reference path="../../global.ts" />
var ClinicalVisitOutcomes;
(function (ClinicalVisitOutcomes) {
    var Service = (function () {
        Service.$inject = ["moment"];
        function Service(moment) {
            "ngInject";
            this.moment = moment;
        }
        Service.prototype.createRemindPatient = function () {
            return {
                value: this.getRemindList()[0][0],
                date: this.moment(),
                message: "",
                reasonsForFollowUpVisits: this.getListReasons()
            };
        };
        Service.prototype.getRemindList = function () {
            return [
                [
                    new ClinicalVisitOutcomes.RemindItem(ClinicalVisitOutcomes.Controller.NONE),
                    new ClinicalVisitOutcomes.RemindItem('1 week', 1, 'weeks'),
                    new ClinicalVisitOutcomes.RemindItem('2 weeks', 2, 'weeks'),
                    new ClinicalVisitOutcomes.RemindItem('3 weeks', 3, 'weeks'),
                    new ClinicalVisitOutcomes.RemindItem('1 month', 1, 'month')
                ], [
                    new ClinicalVisitOutcomes.RemindItem('3 months', 3, 'month'),
                    new ClinicalVisitOutcomes.RemindItem('6 months', 6, 'month'),
                    new ClinicalVisitOutcomes.RemindItem('1 year', 1, 'years'),
                    new ClinicalVisitOutcomes.RemindItem(ClinicalVisitOutcomes.Controller.OTHER)
                ]
            ];
        };
        Service.prototype.getListReasons = function () {
            return [
                new ClinicalVisitOutcomes.VisitReason('General visit'),
                new ClinicalVisitOutcomes.VisitReason('Follow-up visit'),
                new ClinicalVisitOutcomes.VisitReason('Repeat script'),
                new ClinicalVisitOutcomes.VisitReason('General screening'),
                new ClinicalVisitOutcomes.VisitReason('Diabetes'),
                new ClinicalVisitOutcomes.VisitReason('Hypertension'),
                new ClinicalVisitOutcomes.VisitReason('COPD'),
                new ClinicalVisitOutcomes.VisitReason('Asthma'),
                new ClinicalVisitOutcomes.VisitReason('Other')
            ];
        };
        Service.prototype.getEncounterFollowUp = function (remind) {
            var followUp = new Domain.Clinical.EncounterFollowUp();
            followUp.FollowUpRequired = remind.value.name !== ClinicalVisitOutcomes.Controller.NONE;
            if (followUp.FollowUpRequired) {
                followUp.FollowUpReasons = this.getSelectedReasons(remind.reasonsForFollowUpVisits);
                followUp.DueDateForFollowUp = this.getFollowupDate(remind);
                followUp.FollowUpMessage = remind.message;
            }
            return followUp;
        };
        Service.prototype.getSelectedReasons = function (visits) {
            var items = [];
            for (var i = 0; i < visits.length; i++) {
                var reason = visits[i];
                if (reason.val) {
                    items.push(reason.desc);
                }
            }
            return items;
        };
        Service.prototype.getFollowupDate = function (remind) {
            if (remind.value.name === ClinicalVisitOutcomes.Controller.OTHER) {
                return remind.date.format(serverDateFormat);
            }
            else if (remind.value.name !== ClinicalVisitOutcomes.Controller.NONE) {
                return this.getDateFromForm(this.moment(), remind.value.params);
            }
            return "";
        };
        Service.prototype.getDateFromForm = function (dateMoment, params) {
            var inc = params[0];
            var nameField = params[1];
            return this.moment(dateMoment).add(inc, nameField).format(serverDateFormat);
        };
        return Service;
    })();
    ClinicalVisitOutcomes.Service = Service;
})(ClinicalVisitOutcomes || (ClinicalVisitOutcomes = {}));
angular.module('DoctorApp')
    .service('clinicalVisitOutcomesService', ClinicalVisitOutcomes.Service);
var TemplatesCommunicationModule;
(function (TemplatesCommunicationModule) {
    var CommunicationTemplatesUpdateController = (function () {
        CommunicationTemplatesUpdateController.$inject = ["$scope", "$q", "$filter", "moment", "$timeout", "modalService", "practiceService"];
        function CommunicationTemplatesUpdateController($scope, $q, $filter, moment, $timeout, modalService, practiceService) {
            "ngInject";
            var _this = this;
            this.$scope = $scope;
            this.$q = $q;
            this.$filter = $filter;
            this.moment = moment;
            this.$timeout = $timeout;
            this.modalService = modalService;
            this.practiceService = practiceService;
            $scope.tinymceOptions = {
                selector: 'textarea',
                plugins: 'link table preview code template paste',
                toolbar: 'code | template | undo redo | bold italic | fontsizeselect | bullist numlist outdent indent | alignleft aligncenter alignright | file',
                fontsize_formats: '8pt 10pt 12pt 14pt 18pt 24pt 36pt',
                skin_url: GlobalVar.isProd ? 'styles/tinymce/skins/lightgray' : '',
                visual: false,
                browser_spellcheck: true,
                contextmenu: false,
                statusbar: false,
                paste_data_images: true,
                valid_children: "+body[style],+body,+head",
                extended_valid_elements: 'body,head',
                init_instance_callback: function (editor) {
                    var contentWraper = $(editor.contentAreaContainer);
                    var content = $(editor.iframeElement);
                    var interval;
                    editor.on('change', function () {
                        if (interval) {
                            $timeout.cancel(interval);
                        }
                        interval = $timeout(function () {
                            var content = editor.getContent();
                            if (content.search(/<img src\=\"/g) > -1) {
                                $scope.body = editor.getContent().replace(/<img src\=\"/g, '<img style="max-width:100%" src="');
                            }
                        }, 100);
                    });
                    content.css('min-height', 400);
                    contentWraper.css('overflow', 'auto');
                }
            };
            $scope.onTemplateSelected = function () {
                $scope.templateSelected = angular.copy($scope.templateList.filter(function (i) { return i.TemplateId == $scope.selectedTemplateId; }).pop());
            };
            $scope.updateTemplate = function () {
                if ($scope.body.length > 0) {
                    practiceService.updateCommunicationTemplate($scope.templateSelected)
                        .then(function (result) {
                        modalService.info('Successfully updated info ' + result.Data);
                        _this.loadTemplates();
                    });
                }
                else {
                    modalService.error('Please enter all required info');
                }
            };
            this.loadTemplates();
        }
        CommunicationTemplatesUpdateController.prototype.loadTemplates = function () {
            var _this = this;
            this.practiceService.getCommunicationTemplates()
                .then(function (templates) {
                if (templates) {
                    _this.$scope.templateList = _this.$filter('orderBy')(angular.copy(templates), "TemplateIdentifier");
                    if (_this.$scope.selectedTemplateId) {
                        _this.$scope.onTemplateSelected();
                    }
                    else {
                        _this.$scope.templateSelected = _this.$scope.templateList[0];
                        _this.$scope.selectedTemplateId = _this.$scope.templateSelected.TemplateId;
                    }
                    _this.$scope.body = _this.$scope.templateSelected.TemplateBody;
                }
            });
        };
        return CommunicationTemplatesUpdateController;
    })();
    TemplatesCommunicationModule.CommunicationTemplatesUpdateController = CommunicationTemplatesUpdateController;
})(TemplatesCommunicationModule || (TemplatesCommunicationModule = {}));
angular.module('DoctorApp')
    .controller('CommunicationTemplatesUpdateController', TemplatesCommunicationModule.CommunicationTemplatesUpdateController);
/// <reference path="../../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../../../scripts/definition/moment/moment-node.d.ts" />
/// <reference path="../../../services/memory-service.ts" />
var ClinicalMessageCenterModule;
(function (ClinicalMessageCenterModule) {
    var PatientList = (function () {
        function PatientList() {
        }
        return PatientList;
    })();
    ClinicalMessageCenterModule.PatientList = PatientList;
    var MessageTabController = (function () {
        MessageTabController.$inject = ["$scope", "$location", "usageService", "memoryService", "moment", "$routeParams"];
        function MessageTabController($scope, $location, usageService, memoryService, moment, $routeParams) {
            "ngInject";
            var _this = this;
            this.$scope = $scope;
            this.$location = $location;
            this.usageService = usageService;
            this.memoryService = memoryService;
            this.moment = moment;
            this.$routeParams = $routeParams;
            $scope.list = [];
            $scope.$watch('reports', function (newValue, oldValue) {
                if (!$scope.reports) {
                    return;
                }
                var list = [];
                for (var i = 0; i < $scope.reports.length; i++) {
                    var report = $scope.reports[i];
                    report.ReceivedDate = _this.formatDate(report.ReceivedDate);
                    report.CollectionDate = _this.formatDate(report.CollectionDate);
                    report.PatientDateOfBirth = _this.formatDate(report.PatientDateOfBirth);
                    _this.insertReport(list, report);
                }
                $scope.list = list;
            });
            $scope.choseReport = function (report) {
                memoryService.clinicalMessageCenter.tabSelect = $location.hash();
                $location.hash('');
                var uri = report.isPathologyReport ? '/clinical-pathology-report/' : '/clinical-pathology-report-workflow/';
                var end = report.isPathologyReport ? '' : '/' + $scope.urgent;
                if (report.isPathologyReport) {
                    _this.usageService.openedPathReport($routeParams.practiceId, report.PathologyReportWorkflowId, report.ReceivedDate);
                }
                else {
                    _this.usageService.openedPathReportWorkflow($routeParams.practiceId, report.PathologyReportWorkflowId, report.ReceivedDate);
                }
                $location.path('/' + $routeParams.practiceId + uri + report.PathologyReportWorkflowId + end);
            };
        }
        MessageTabController.prototype.insertReport = function (list, report) {
            var number = this.getNumberOfList(list, report);
            var item = list[number];
            if (item) {
                item.reports[item.reports.length] = report;
            }
            else {
                list[number] = {
                    PatientName: report.PatientName,
                    PatientDateOfBirth: report.PatientDateOfBirth,
                    reports: [report]
                };
            }
        };
        MessageTabController.prototype.formatDate = function (date) {
            var dateMoment = this.moment(date, "YYYY-MM-DD HH:mm:ss");
            if (dateMoment.isValid()) {
                return dateMoment.format("YYYY-MM-DD");
            }
            return date;
        };
        MessageTabController.prototype.getNumberOfList = function (list, report) {
            for (var j = 0; j < list.length; j++) {
                var item = list[j];
                if (report.PatientName.toUpperCase() == item.PatientName.toUpperCase() && report.PatientDateOfBirth == item.PatientDateOfBirth) {
                    return j;
                }
            }
            return list.length;
        };
        return MessageTabController;
    })();
    ClinicalMessageCenterModule.MessageTabController = MessageTabController;
})(ClinicalMessageCenterModule || (ClinicalMessageCenterModule = {}));
angular.module('DoctorApp')
    .directive('clinicalMessageTab', function () {
    return {
        restrict: 'E',
        scope: {
            reports: '=',
            urgent: '=',
            type: '='
        },
        templateUrl: 'screens/components/clinical-message-tab/clinical-message-tab.html',
        controller: ClinicalMessageCenterModule.MessageTabController
    };
});
/// <reference path="../../../../scripts/definition/angularjs/angular.d.ts" />
var ClinicalMetricsModule;
(function (ClinicalMetricsModule) {
    var Controller = (function () {
        Controller.$inject = ["$scope", "moment", "showDialog", "$q"];
        function Controller($scope, moment, showDialog, $q) {
            "ngInject";
            var _this = this;
            this.$scope = $scope;
            this.moment = moment;
            this.showDialog = showDialog;
            this.$q = $q;
            var metricPattern = /^(\+{1,4}|\d+)((\.|\,)\d{1,4})?$/;
            $scope.model = {};
            $scope.clinicalMetricsSchema = [
                {
                    groupName: 'General',
                    groupTitle: 'General',
                    isCollapsible: true,
                    className: 'general-group-class',
                    items: [
                        {
                            type: 'number',
                            uom: '°C',
                            min: 10,
                            max: 50,
                            maxlength: 5,
                            name: 'Temperature',
                            id: 'Temperature',
                            step: 0.1,
                            mask: /^(50|([1-4][0-9])((\.|\,)\d{1,2})?)$/,
                            validationMessage: {
                                pattern: 'Please specify a valid value for Temperature: 10-50 °C'
                            }
                        },
                        {
                            type: 'text',
                            uom: 'mmHg',
                            name: 'Blood pressure',
                            id: 'BloodPressure',
                            maxlength: 7,
                            mask: /^(300|[1-2][0-9][0-9]|[0-9][0-9]|[0-9])(\\|\/)(200|1[0-9][0-9]|[0-9][0-9]|[0-9])$/,
                            placeholder: 'Systolic/Diastolic',
                            validationMessage: {
                                pattern: 'Please specify a valid value for Blood pressure: (0-300)/(0-200)'
                            }
                        },
                        {
                            type: 'number',
                            uom: 'bpm',
                            min: 0,
                            max: 300,
                            maxlength: 3,
                            mask: /^(300|[0-9]|[1-9][0-9]|[1-2][0-9][0-9])$/,
                            name: 'Pulse rate',
                            id: 'PulseRate',
                            validationMessage: {
                                pattern: 'Please specify a valid value for Pulse rate: 0-300 bpm'
                            }
                        },
                        {
                            type: 'select-composite',
                            uom: 'bpm',
                            name: 'Radial pulse',
                            id: 'RadialPulse',
                            min: 0,
                            max: 300,
                            maxlength: 3,
                            mask: /^(300|[0-9]|[1-9][0-9]|[1-2][0-9][0-9])$/,
                            options: ['Left', 'Right'],
                            validate: 'validateCompsiteSelect',
                            validationMessage: {
                                pattern: 'Please specify a valid value for Radial pulse: 0-300 bpm',
                                emptyValue: 'Please capture a value for Radial pulse.',
                                emptyType: 'Please specify whether the Radial pulse test result was ‘Left’ or ‘Right’.'
                            }
                        },
                        {
                            type: 'number',
                            uom: 'Breaths per min',
                            min: 0,
                            max: 100,
                            maxlength: 5,
                            mask: /^(100|([0-9]{1,2}((\.|\,)\d{1,2})?))$/,
                            name: 'Respiratory rate',
                            id: 'RespiratoryRate',
                            validationMessage: {
                                pattern: 'Please specify a valid value for Respiratory Rate: 0-100'
                            }
                        },
                        {
                            type: 'number',
                            uom: '%',
                            min: 0,
                            max: 100,
                            maxlength: 5,
                            mask: /^(100|([0-9]{1,2}((\.|\,)\d{1,2})?))$/,
                            name: 'SPO2',
                            id: 'SPO2',
                            validationMessage: {
                                pattern: 'Please specify a valid value for SPO2: 0-100%'
                            }
                        },
                        { type: 'separator' },
                        {
                            type: 'select',
                            name: 'Smoker',
                            id: 'Smoker',
                            options: ['Yes', 'No', 'Ex. smoker']
                        },
                        {
                            type: 'number',
                            uom: '',
                            name: 'Fagerström Test',
                            id: 'FND',
                            min: 0,
                            max: 10,
                            mask: /^(100|[0-9]|[1-9][0-9])$/,
                            maxlength: 2,
                            validationMessage: {
                                pattern: 'Please specify a valid value for Fagerström Nicotine Dependence: 0-10'
                            }
                        },
                        {
                            type: 'select',
                            name: 'Pregnancy test',
                            id: 'PregnancyTest',
                            options: ['Positive', 'Negative'],
                            condition: "PregnancyVisibilityCondition"
                        },
                        { type: 'separator' },
                        {
                            type: 'number',
                            uom: 'cm',
                            name: 'Height',
                            id: 'Height',
                            min: 0,
                            max: 300,
                            maxlength: 7,
                            mask: /^(300|(([0-9]|[1-9][0-9]|[1-2][0-9][0-9])((\.|\,)\d{1,3})?))$/,
                            onchange: 'updateBMI',
                            validationMessage: {
                                pattern: 'Please specify a valid value for Height: 0-300 cm'
                            }
                        },
                        {
                            type: 'number',
                            uom: 'kg',
                            name: 'Weight',
                            id: 'Weight',
                            min: 0,
                            max: 300,
                            maxlength: 7,
                            mask: /^(300|(([0-9]|[1-9][0-9]|[1-2][0-9][0-9])((\.|\,)\d{1,3})?))$/,
                            onchange: 'updateBMI',
                            validationMessage: {
                                pattern: 'Please specify a valid value for Weight: 0-300kg'
                            }
                        },
                        { type: 'calculate-label', name: 'BMI', uom: '' },
                        { type: 'separator' },
                        {
                            type: 'select-composite',
                            uom: 'mmol/L',
                            name: 'Blood glucose test',
                            id: 'BloodGlucoseTest',
                            min: 0,
                            max: 150,
                            maxlength: 5,
                            mask: /^(150|(([0-9]|[1-9][0-9]|1[0-4][0-9])((\.|\,)\d{1,2})?))$/,
                            options: ['Random', 'Fasting'],
                            validate: 'validateCompsiteSelect',
                            validationMessage: {
                                pattern: 'Please specify a valid value for Blood glucose: 0-150 mmol/L',
                                emptyValue: 'Please capture a value for Blood glucose test.',
                                emptyType: 'Please specify whether the blood glucose test result was ‘Fasting’ or ‘Random’.'
                            }
                        },
                        {
                            type: 'number',
                            uom: '%',
                            name: 'HbA1c',
                            id: 'HbA1c',
                            min: 0,
                            max: 100,
                            mask: /^(100|[0-9]|[1-9][0-9])$/,
                            maxlength: 3,
                            validationMessage: {
                                pattern: 'Please specify a valid value for HbA1c: 0-100%'
                            }
                        },
                        {
                            type: 'select-composite',
                            uom: 'mmol/L',
                            name: 'Total Cholesterol test',
                            id: 'CholesterolTest',
                            min: 0,
                            max: 20,
                            maxlength: 5,
                            mask: /^(20|(([0-9]|1[0-9])((\.|\,)\d{1,2})?))$/,
                            options: ['Random', 'Fasting'],
                            validate: 'validateCompsiteSelect',
                            validationMessage: {
                                pattern: 'Please specify a valid value for Total Cholesterol test: 0-20 mmol/L',
                                emptyValue: 'Please capture a value for Cholesterol test.',
                                emptyType: 'Please specify whether the Cholesterol test result was ‘Fasting’ or ‘Random’.'
                            }
                        },
                        {
                            type: 'number',
                            uom: 'mmol/L',
                            name: 'HDL',
                            id: 'HDL',
                            min: 0,
                            max: 10,
                            mask: /^(10|([0-9])((\.|\,)\d{1,2})?)$/,
                            maxlength: 3,
                            validationMessage: {
                                pattern: 'Please specify a valid value for HDL: 0-10 mmol/L'
                            }
                        },
                        {
                            type: 'number',
                            uom: 'mmol/L',
                            name: 'LDL',
                            id: 'LDL',
                            min: 0,
                            max: 10,
                            mask: /^(10|([0-9])((\.|\,)\d{1,2})?)$/,
                            maxlength: 3,
                            validationMessage: {
                                pattern: 'Please specify a valid value for LDL: 0-10 mmol/L'
                            }
                        },
                        {
                            type: 'number',
                            uom: 'mmol/L',
                            name: 'Triglycerides',
                            id: 'Triglycerides',
                            min: 0,
                            max: 10,
                            mask: /^(10|([0-9])((\.|\,)\d{1,2})?)$/,
                            maxlength: 3,
                            validationMessage: {
                                pattern: 'Please specify a valid value for Triglycerides: 0-10 mmol/L'
                            }
                        },
                        {
                            type: 'text',
                            uom: '',
                            name: 'Micral test',
                            id: 'MicralTest',
                            maxlength: 500,
                            mask: ''
                        },
                        {
                            type: 'text',
                            uom: '',
                            name: 'ECG test',
                            id: 'ECGtest',
                            maxlength: 500,
                            mask: ''
                        }
                    ]
                },
                {
                    groupName: 'Urine dipstick',
                    groupTitle: 'Urine dipstick',
                    isCollapsible: true,
                    isCollapsed: true,
                    className: 'group2-class',
                    items: [
                        {
                            type: 'checkbox',
                            name: 'Nothing abnormal detected',
                            id: 'NothingAbnormalDetected',
                            action: 'switch'
                        },
                        { type: 'space-separator' },
                        {
                            type: 'checkbox-composite',
                            name: 'Bilirubin',
                            id: 'Bilirubin',
                            maxlength: 4,
                            mask: metricPattern,
                            onchange: 'changeUrine',
                            validate: 'validateUrineMeasure',
                            validationMessage: {
                                pattern: 'Please specify a valid value for Bilirubin measurement: decimal/++++',
                                required: 'Please specify Bilirubin measurement on the urine dipstick pane.'
                            }
                        },
                        {
                            type: 'checkbox-composite',
                            name: 'Blood',
                            id: 'Blood',
                            maxlength: 4,
                            mask: metricPattern,
                            onchange: 'changeUrine',
                            validate: 'validateUrineMeasure',
                            validationMessage: {
                                pattern: 'Please specify a valid value for Blood measurement: decimal/++++',
                                required: 'Please specify Blood measurement on the urine dipstick pane.'
                            }
                        },
                        {
                            type: 'checkbox-composite',
                            name: 'Glucose',
                            id: 'Glucose',
                            maxlength: 4,
                            mask: metricPattern,
                            onchange: 'changeUrine',
                            validate: 'validateUrineMeasure',
                            validationMessage: {
                                pattern: 'Please specify a valid value for Glucose measurement: decimal/++++',
                                required: 'Please specify Glucose measurement on the urine dipstick pane.'
                            }
                        },
                        {
                            type: 'checkbox-composite',
                            name: 'White blood cells',
                            id: 'WhiteBloodCells',
                            maxlength: 4,
                            mask: metricPattern,
                            onchange: 'changeUrine',
                            validate: 'validateUrineMeasure',
                            validationMessage: {
                                pattern: 'PPlease specify a valid value for White blood cells measurement: decimal/++++',
                                required: 'Please specify White blood cells measurement on the urine dipstick pane.'
                            }
                        },
                        {
                            type: 'checkbox-composite',
                            name: 'Haemoglobin',
                            id: 'Haemoglobin',
                            maxlength: 4,
                            mask: metricPattern,
                            onchange: 'changeUrine',
                            validate: 'validateUrineMeasure',
                            validationMessage: {
                                pattern: 'Please specify a valid value for Haemoglobin measurement: decimal/++++',
                                required: 'Please specify Haemoglobin measurement on the urine dipstick pane.'
                            }
                        },
                        {
                            type: 'checkbox-composite',
                            name: 'Ketones',
                            id: 'Ketones',
                            maxlength: 4,
                            mask: metricPattern,
                            onchange: 'changeUrine',
                            validate: 'validateUrineMeasure',
                            validationMessage: {
                                pattern: 'Please specify a valid value for Ketones measurement: decimal/++++',
                                required: 'Please specify Ketones measurement on the urine dipstick pane.'
                            }
                        },
                        {
                            type: 'checkbox-composite',
                            name: 'Nitrites',
                            id: 'Nitrites',
                            maxlength: 4,
                            mask: metricPattern,
                            onchange: 'changeUrine',
                            validate: 'validateUrineMeasure',
                            validationMessage: {
                                pattern: 'Please specify a valid value for Nitrites measurement: decimal/++++',
                                required: 'Please specify Nitrites measurement on the urine dipstick pane.'
                            }
                        },
                        {
                            type: 'checkbox-composite',
                            name: 'pH',
                            id: 'pH',
                            maxlength: 4,
                            mask: /^(\+|[0-9]|1[1-4])((\.|\,)\d)?$/,
                            onchange: 'changeUrine',
                            validate: 'validateUrineMeasure',
                            validationMessage: {
                                pattern: 'Please specify a valid value for pH measurement: + or decimal',
                                required: 'Please specify pH measurement on the urine dipstick pane.'
                            }
                        },
                        {
                            type: 'checkbox-composite',
                            name: 'Protein',
                            id: 'Protein',
                            maxlength: 4,
                            mask: metricPattern,
                            onchange: 'changeUrine',
                            validate: 'validateUrineMeasure',
                            validationMessage: {
                                pattern: 'Please specify a valid value for Protein measurement: decimal/++++',
                                required: 'Please specify Protein measurement on the urine dipstick pane.'
                            }
                        },
                        {
                            type: 'checkbox-composite',
                            name: 'Urobilinogen',
                            id: 'Urobilinogen',
                            maxlength: 4,
                            mask: metricPattern,
                            onchange: 'changeUrine',
                            validate: 'validateUrineMeasure',
                            validationMessage: {
                                pattern: 'Please specify a valid value for Urobilinogen measurement: decimal/++++',
                                required: 'Please specify Urobilinogen measurement on the urine dipstick pane.'
                            }
                        }
                    ]
                }
            ];
            var clinicalMetricFuncs = {
                PregnancyVisibilityCondition: function () {
                    return $scope.clinicalMetricsOptions.gender === 'Female';
                },
                updateBMI: function () {
                    var result = '';
                    var w = $scope.model["Weight"];
                    var h = $scope.model["Height"];
                    if (w && h && w.Value && h.Value) {
                        var sh = Math.pow(Number(h.Value) / 100, 2);
                        result = (Math.round(Number(w.Value) / sh)).toString();
                    }
                    $scope.model["BMI"] = $scope.model["BMI"] || {};
                    $scope.model["BMI"].CalculatedValue = result;
                },
                changeUrine: function (metric, e) {
                    if ($scope.model[metric.name].Value && $scope.model[metric.name].Checked === undefined) {
                        $scope.model[metric.name].Checked = true;
                    }
                    if (e && $scope.model[metric.name].Checked) {
                        e.target.nextElementSibling.nextElementSibling.firstElementChild.focus();
                    }
                    if ($scope.model[metric.name].Checked === false) {
                        $scope.model[metric.name].Value = undefined;
                        $scope.model[metric.name].Checked = undefined;
                    }
                },
                validateCompsiteSelect: function (metric, model) {
                    model.required = Boolean(Common.isNumber(model.Value) || model.Type);
                    if (!Common.isNumber(model.Value) && model.Type) {
                        return metric.validationMessage.emptyValue;
                    }
                    if (Common.isNumber(model.Value) && !model.Type) {
                        return metric.validationMessage.emptyType;
                    }
                },
                validateUrineMeasure: function (metric, model) {
                    model.required = Boolean(model.Checked || !model.Value);
                    if (model.Checked && !model.Value) {
                        return metric.validationMessage.required;
                    }
                }
            };
            function getClinicalMetrics() {
                var array = new Array();
                if ($scope.model) {
                    for (var key in $scope.model) {
                        if ($scope.model.hasOwnProperty(key)) {
                            if ($scope.model[key].Value === undefined && $scope.model[key].Type === undefined) {
                                continue;
                            }
                            $scope.clinicalMetricsSchema.forEach(function (group) {
                                group.items.forEach(function (m) {
                                    if (m.name === key) {
                                        var metric = new Domain.Clinical.ClinicalMetric();
                                        metric.Group = group.groupName;
                                        metric.Name = key;
                                        metric.TestDate = moment().format(DATE_TIME_PATTERN);
                                        metric.Type = $scope.model[key].Type;
                                        metric.Unit = m.uom;
                                        metric.Value = $scope.model[key].Value;
                                        array.push(metric);
                                    }
                                });
                            });
                        }
                    }
                }
                return array;
            }
            function validateClinicalMetrics() {
                var errors = [];
                $scope.clinicalMetricsSchema.forEach(function (g) {
                    g.items.forEach(function (metric) {
                        var form = $scope.clinicalMetricsForm['value_' + metric.id];
                        if (form && form.$error.pattern) {
                            errors.push(metric.validationMessage.pattern);
                        }
                        if (metric.validate) {
                            var model = $scope.model[metric.name];
                            if (model) {
                                var errorMsg = $scope.evalMetricFunction(metric.validate, metric, model);
                                if (errorMsg) {
                                    errors.push(errorMsg);
                                }
                            }
                        }
                    });
                });
                if (errors.length === 0) {
                    return true;
                }
                else if (errors.length === 1) {
                    showDialog.warning(errors[0]);
                }
                else {
                    showDialog.warning("Please provide correct clinical metrics");
                }
                return false;
            }
            $scope.getMetricById = function (id) {
                for (var i = 0; i < $scope.clinicalMetricsSchema.length; i++) {
                    var g = $scope.clinicalMetricsSchema[i];
                    for (var j = 0; j < g.items.length; j++) {
                        if (g.items[j].id === id) {
                            return g.items[j];
                        }
                    }
                }
            };
            $scope.$watch('clinicalMetricsOptions', function () {
                if ($scope.clinicalMetricsOptions.historicalMetrics) {
                    var historical = $scope.clinicalMetricsOptions.historicalMetrics;
                    for (var i = 0; i < historical.length; i++) {
                        var key = historical[i].Name;
                        $scope.model[key] = $scope.model[key] || {};
                        $scope.model[key].Old = historical[i];
                        var oldMeasure = moment(historical[i].TestDate).format('D MMM, YYYY: ');
                        if (historical[i].Type) {
                            oldMeasure += historical[i].Type + " ";
                        }
                        if (historical[i].Value != null) {
                            oldMeasure += historical[i].Value + " ";
                        }
                        if (historical[i].Unit) {
                            oldMeasure += historical[i].Unit;
                        }
                        $scope.model[key].OldMeasure = oldMeasure;
                    }
                }
                if ($scope.clinicalMetricsOptions.metrics) {
                    var metrics = $scope.clinicalMetricsOptions.metrics;
                    for (var i = 0; i < metrics.length; i++) {
                        $scope.model[metrics[i].Name] = $scope.model[metrics[i].Name] || {};
                        var model = $scope.model[metrics[i].Name];
                        model.Value = metrics[i].Value;
                        model.Type = metrics[i].Type;
                        model.Checked = Boolean(model.Value);
                    }
                }
                var groupsToUpdate = $scope.clinicalMetricsSchema.filter(function (v) { return v.items.some(function (m) { return m.type.indexOf('calculate') !== -1; }); });
                groupsToUpdate.forEach(function (g) {
                    g.items.forEach(function (m) { return $scope.evalMetricFunction(m.onchange); });
                });
                $scope.clinicalMetricsSchema.forEach(function (g) {
                    g.items.forEach(function (m) {
                        m.isVisible = $scope.evalMetricFunction(m.condition);
                    });
                });
                $scope.clinicalMetricsOptions.getClinicalMetrics = getClinicalMetrics;
                $scope.clinicalMetricsOptions.validate = validateClinicalMetrics;
            }, true);
            $scope.populateWithHistorical = function (metric) {
                var model = $scope.model[metric.name];
                if (model && model.Old) {
                    model.Value = model.Old.Value;
                    model.Type = model.Old.Type;
                    if (metric.onchange) {
                        $scope.evalMetricFunction(metric.onchange, metric);
                    }
                }
            };
            $scope.evalMetricFunction = function (functionName) {
                var args = [];
                for (var _i = 1; _i < arguments.length; _i++) {
                    args[_i - 1] = arguments[_i];
                }
                if (clinicalMetricFuncs[functionName]) {
                    return clinicalMetricFuncs[functionName].apply(_this, args);
                }
                return true;
            };
            $scope.getTempalte = function (metric) { return "cm-" + metric.type + ".html"; };
        }
        Controller.factory = function () {
            var instance = function () {
                var directive = {};
                directive.restrict = 'E';
                directive.scope = {
                    metrics: '=',
                    clinicalMetricsOptions: '='
                };
                directive.templateUrl = 'screens/components/clinical-metrics/clinical-metrics.html';
                directive.controller = Controller;
                return directive;
            };
            return instance;
        };
        return Controller;
    })();
    ClinicalMetricsModule.Controller = Controller;
})(ClinicalMetricsModule || (ClinicalMetricsModule = {}));
angular.module('DoctorApp')
    .directive('clinicalMetrics', ClinicalMetricsModule.Controller.factory());
/// <reference path="../../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../../run.ts" />
/// <reference path="../../../screens/practice/practice-service.ts" />
var HomeHeaderModule;
(function (HomeHeaderModule) {
    var HomeHeaderController = (function () {
        HomeHeaderController.$inject = ["$rootScope", "$scope", "practiceService", "storageService", "locationService", "showDialog", "$window", "$routeParams", "providerService"];
        function HomeHeaderController($rootScope, $scope, practiceService, storageService, locationService, showDialog, $window, $routeParams, providerService) {
            "ngInject";
            var _this = this;
            this.$rootScope = $rootScope;
            this.$scope = $scope;
            this.practiceService = practiceService;
            this.storageService = storageService;
            this.locationService = locationService;
            this.showDialog = showDialog;
            this.$window = $window;
            this.$routeParams = $routeParams;
            this.providerService = providerService;
            if (angular.isUndefined($rootScope.isClinical)) {
                practiceService.updateLocalPractice($routeParams.practiceId);
            }
            this.init();
            $scope.displayNetworkStatus = GlobalVar.displayNetworkStatus;
            $scope.user = storageService.getUser();
            $scope.today = new Date();
            $scope.goToClinicalMessageCenter = function () {
                locationService.goToClinicalMessageCenter($routeParams.practiceId);
            };
            $scope.goToPowerBi = function () {
                var practiceId = $routeParams.practiceId;
                locationService.goToPowerBi(practiceId);
            };
            $scope.goToPatientVisits = function () {
                locationService.goToPatientVisits($routeParams.practiceId);
            };
            $scope.refreshPage = function () {
                $window.location.reload();
            };
            $scope.goToAccount = function () {
                if (_this.$scope.user.userId) {
                    _this.locationService.goToAccount($routeParams.practiceId, _this.$scope.user.userId);
                }
                else {
                    _this.showDialog.error("Please logout and login again into system to open this page.");
                }
            };
        }
        HomeHeaderController.prototype.init = function () {
            var _this = this;
            var practiceId = this.$routeParams.practiceId;
            this.providerService.getProviderOptions(practiceId)
                .then(function (options) {
                _this.$scope.isPowerBIEnabled = options.isPowerBIEnabled;
            });
        };
        return HomeHeaderController;
    })();
    HomeHeaderModule.HomeHeaderController = HomeHeaderController;
})(HomeHeaderModule || (HomeHeaderModule = {}));
angular.module('DoctorApp')
    .directive('homeHeader', function () {
    return {
        restrict: 'E',
        templateUrl: 'screens/components/home-header/home-header.html',
        controller: HomeHeaderModule.HomeHeaderController
    };
});
/// <reference path="../../../../scripts/definition/angularjs/angular.d.ts" />
var ModalModule;
(function (ModalModule) {
    var CellPhoneController = (function () {
        CellPhoneController.$inject = ["$scope", "modalService", "$modalInstance", "model"];
        function CellPhoneController($scope, modalService, $modalInstance, model) {
            "ngInject";
            $scope.openCellPhoneDialog = function () {
                modalService.openNumbers('cellphone', 'Enter cellphone')
                    .then(function (cellPhone) {
                    if (cellPhone) {
                        $scope.model = cellPhone;
                    }
                });
            };
            $scope.ok = function () {
                if ($scope.model) {
                    $modalInstance.close($scope.model);
                }
            };
            $scope.cancel = function () {
                $modalInstance.dismiss();
            };
            $scope.model = "";
        }
        return CellPhoneController;
    })();
    ModalModule.CellPhoneController = CellPhoneController;
})(ModalModule || (ModalModule = {}));
angular.module('DoctorApp')
    .controller('CellPhoneController', ModalModule.CellPhoneController);
/// <reference path="../../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../../screens/components/modal/modal-service.ts" />
/// <reference path="../../../services/dialog-service.ts" />
var ModalModule;
(function (ModalModule) {
    var ModalController = (function () {
        ModalController.$inject = ["$scope", "$modalInstance", "model"];
        function ModalController($scope, $modalInstance, model) {
            "ngInject";
            $scope.labels = model && model.labels || ['Ok', 'Cancel'];
            $scope.ok = function () {
                $modalInstance.close($scope.model);
            };
            $scope.cancel = function () {
                $modalInstance.dismiss();
            };
            $scope.yes = function () {
                $modalInstance.close(true);
            };
            $scope.no = function () {
                $modalInstance.close(false);
            };
            $scope.close = function () {
                $modalInstance.dismiss();
            };
            $scope.model = model;
        }
        return ModalController;
    })();
    ModalModule.ModalController = ModalController;
})(ModalModule || (ModalModule = {}));
angular.module('DoctorApp')
    .controller('ModalController', ModalModule.ModalController);
/// <reference path="../../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../../screens/components/modal/modal-service.ts" />
/// <reference path="../../../services/dialog-service.ts" />
var ModalModule;
(function (ModalModule) {
    var ModalInstanceController = (function () {
        ModalInstanceController.$inject = ["$scope", "$sce", "$modalInstance", "$q", "$routeParams", "$timeout", "dialogService", "modalService", "controller", "usageService", "patientService", "billingDomain", "encounterServiceNew", "$compile"];
        function ModalInstanceController($scope, $sce, $modalInstance, $q, $routeParams, $timeout, dialogService, modalService, controller, usageService, patientService, billingDomain, encounterServiceNew, $compile) {
            "ngInject";
            var _this = this;
            this.$scope = $scope;
            this.$sce = $sce;
            this.$modalInstance = $modalInstance;
            this.$q = $q;
            this.$routeParams = $routeParams;
            this.$timeout = $timeout;
            this.dialogService = dialogService;
            this.modalService = modalService;
            this.controller = controller;
            this.usageService = usageService;
            this.patientService = patientService;
            this.billingDomain = billingDomain;
            this.encounterServiceNew = encounterServiceNew;
            this.$compile = $compile;
            $scope.ok = function () {
                $modalInstance.close($scope.model);
            };
            $scope.cancel = function () {
                $modalInstance.dismiss('cancel');
            };
            $scope.download = function (attachment) {
                if (controller.model.pdfListener) {
                    controller.model.pdfListener(attachment.HtmlBody);
                }
            };
            $scope.sendEmail = function () {
                var that = _this;
                $q.all([
                    that.patientService.getPatientById($routeParams.practiceId, $scope.model.patientId),
                    that.billingDomain.getProvider(_this.$routeParams.practiceId)
                ])
                    .then(function (response) {
                    var patient = response[0];
                    var provider = response[1];
                    _this.sendReportByEmail(patient, provider);
                });
            };
            $scope.print = function () {
                if (controller.model.receipt) {
                    _this.printRecept(controller.model.receipt.body);
                }
                else {
                    _this.printData('report-frame');
                }
            };
            $scope.model = controller.model;
            $scope.config = controller.config;
            $scope.title = controller.config.title;
            $scope.displayDownload = controller.model.pdfListener != null;
            $scope.displaySend = $scope.model.patientId != null;
            $scope.attachments = [];
            var observeCrossMessage = function (e) {
                if (typeof e.data === "string" && (e.data.search(/([\w\d]+-){4}[\w\d]+/) >= 0) || e.data === 'null') {
                    var message = e.data;
                    if (message === 'null') {
                        $scope.cancel();
                    }
                    else {
                        $modalInstance.close(e.data);
                    }
                    window.removeEventListener("message", observeCrossMessage);
                }
            };
            var url = controller.config.url;
            var body;
            if (controller.model.type === EncounterModule.ReportType.All) {
                var prescriptionReport = controller.model.templateBodies[0];
                var sicknoteReport = controller.model.templateBodies[1];
                body = encounterServiceNew.mergeReports(prescriptionReport, sicknoteReport);
                $scope.attachments = [
                    {
                        Title: "Prescription report",
                        Type: "Prescription",
                        HtmlBody: controller.model.templateBodies[0]
                    },
                    {
                        Title: "Medical Certificate Report",
                        Type: "Medical Certificate",
                        HtmlBody: controller.model.templateBodies[1]
                    }
                ];
            }
            else {
                body = controller.model.templateBodies && controller.model.templateBodies[0];
                if (body) {
                    $scope.attachments.push({
                        Title: controller.config.title,
                        Type: controller.config.title.replace(' report', ''),
                        HtmlBody: controller.model.templateBodies[0]
                    });
                }
            }
            if (url) {
                if ($scope.model.captureHealthDoc) {
                    this.injectHtmlByOutUrl(url);
                    window.addEventListener("message", observeCrossMessage, false);
                }
                else {
                    this.injectHtmlByUrl(url);
                }
            }
            if (body) {
                this.injectHtmlIntoReport(body);
            }
            $scope.$on('$routeChangeStart', function () {
                $modalInstance.close();
            });
        }
        ModalInstanceController.prototype.sendReportByEmail = function (patient, provider) {
            this.modalService.sendReportByEmail(patient, provider, this.$scope.attachments, "Documents from " + provider.PracticeName);
        };
        ModalInstanceController.prototype.injectHtmlByOutUrl = function (url) {
            this.$scope.link = this.$sce.trustAsResourceUrl(url);
            var template = '<iframe id="iframe-container" ng-src="{{link}}" style="width: 100%; height: calc(100% - 5px); border: medium none;"></iframe>';
            this.appendTemplate(template);
        };
        ModalInstanceController.prototype.injectHtmlByUrl = function (url) {
            var _this = this;
            this.dialogService.loadTemplate(url)
                .then(function (template) {
                _this.appendTemplate(template);
            });
        };
        ModalInstanceController.prototype.appendTemplate = function (template) {
            var linkFn = this.$compile(template);
            var e = linkFn(this.$scope);
            this.$timeout(function () {
                var container = $('#modal-body');
                container.append(e);
            }, 100);
        };
        ModalInstanceController.prototype.injectHtmlIntoReport = function (html) {
            var _this = this;
            var template = '<iframe id="report-frame" scrolling="no"></iframe>';
            this.$timeout(function () {
                var container = angular.element(document)
                    .find("#modal-body");
                container.append(template);
                _this.$timeout(function () {
                    var reportIframe = angular.element(document).find("#report-frame");
                    if (html.indexOf('<head>') > -1) {
                        reportIframe.contents()
                            .find('head')
                            .append(html.slice(html.indexOf('<head>') + 6, html.indexOf('</head>')));
                    }
                    if (html.indexOf('<body>') > -1) {
                        reportIframe.contents()
                            .find('body')
                            .append(html.slice(html.indexOf('<body>') + 6, html.indexOf('</body>')));
                    }
                    else {
                        reportIframe.contents()
                            .find('body')
                            .append(html);
                    }
                    var contentHeight = reportIframe.contents().find('body').height();
                    var reportPadding = 60;
                    var containerPadding = reportPadding + 20;
                    container.height(contentHeight + containerPadding + 'px');
                    reportIframe.height(contentHeight + reportPadding + 'px');
                });
            });
        };
        ModalInstanceController.prototype.printRecept = function (body) {
            var mywindow = window.open('', 'my div', 'height=400,width=200');
            mywindow.document.open();
            mywindow.document.write(body);
            mywindow.document.close();
            mywindow.focus();
            mywindow.print();
            mywindow.close();
        };
        ModalInstanceController.prototype.printData = function (frame) {
            var iframe = document.getElementById(frame);
            if (iframe && iframe.contentDocument) {
                var mywindow = window.open('', 'my div', 'height=500,width=750');
                var head = '<head>' + iframe.contentDocument.getElementsByTagName('head')[0].innerHTML + '</head>';
                var body = '<body>' + iframe.contentDocument.getElementsByTagName('body')[0].innerHTML + '</body>';
                mywindow.document.open();
                mywindow.document.write(head);
                mywindow.document.write(body);
                this.$timeout(function () {
                    mywindow.document.close();
                    mywindow.focus();
                    mywindow.print();
                    mywindow.close();
                }, 100);
            }
        };
        return ModalInstanceController;
    })();
    ModalModule.ModalInstanceController = ModalInstanceController;
})(ModalModule || (ModalModule = {}));
angular.module('DoctorApp')
    .controller('ModalInstanceController', ModalModule.ModalInstanceController);
var NotificationModule;
(function (NotificationModule) {
    var Controller = (function () {
        Controller.$inject = ["model", "$scope", "$modalInstance", "$timeout", "$compile", "notificationService", "clinicalDomain", "$routeParams"];
        function Controller(model, $scope, $modalInstance, $timeout, $compile, notificationService, clinicalDomain, $routeParams) {
            "ngInject";
            var _this = this;
            this.$scope = $scope;
            this.$modalInstance = $modalInstance;
            this.$timeout = $timeout;
            this.$compile = $compile;
            this.notificationService = notificationService;
            this.clinicalDomain = clinicalDomain;
            this.$routeParams = $routeParams;
            $scope.ok = function () {
                _this.close();
            };
            $scope.cancel = function () {
                $modalInstance.dismiss('cancel');
            };
            $scope.doAction = function (action) {
                _this.parseAction(action);
            };
            this.init(model);
        }
        Controller.prototype.init = function (model) {
            this.$scope.model = model;
            var body = this.$scope.model.notification.Body;
            var linkFn = this.$compile(body);
            var e = linkFn(this.$scope);
            this.$timeout(function () {
                var container = $('#modal-body');
                container.append(e);
            });
        };
        Controller.prototype.parseAction = function (action) {
            switch (action.Name) {
                case "Invite Doctor":
                    this.notificationService.inviteDoctor(this.$routeParams.practiceId);
                    break;
            }
            this.notificationService.notificationAction(this.$routeParams.practiceId, this.$scope.model.notification.NotificationId, action);
        };
        Controller.prototype.close = function () {
            var _this = this;
            var notification = this.$scope.model.notification;
            this.notificationService.markNotificationViewed(notification.ProviderId, notification.NotificationId)
                .then(function () {
                _this.$modalInstance.close(_this.$scope.model);
            });
        };
        return Controller;
    })();
    NotificationModule.Controller = Controller;
})(NotificationModule || (NotificationModule = {}));
angular.module('DoctorApp')
    .controller('NotificationController', NotificationModule.Controller);
/// <reference path="../../../../scripts/definition/angularjs/angular.d.ts" />
var ModalModule;
(function (ModalModule) {
    var NumbersController = (function () {
        NumbersController.$inject = ["$scope", "$modalInstance", "controller", "$filter"];
        function NumbersController($scope, $modalInstance, controller, $filter) {
            "ngInject";
            var that = this;
            $scope.text = controller.number || '';
            $scope.title = controller.title;
            $scope.type = controller.type;
            $scope.useZerro = controller.useZerro;
            console.warn('Key code move to service. Numbers.ModalModule');
            var keyCodes = [
                { val: "0", keyCode: 96 },
                { val: "1", keyCode: 97 },
                { val: "2", keyCode: 98 },
                { val: "3", keyCode: 99 },
                { val: "4", keyCode: 100 },
                { val: "5", keyCode: 101 },
                { val: "6", keyCode: 102 },
                { val: "7", keyCode: 103 },
                { val: "8", keyCode: 104 },
                { val: "9", keyCode: 105 },
                { val: "enter", keyCode: 13 },
                { val: "backspace", keyCode: 8 },
                { val: "escape", keyCode: 27 },
                { val: "0", keyCode: 48 },
                { val: "1", keyCode: 49 },
                { val: "2", keyCode: 50 },
                { val: "3", keyCode: 51 },
                { val: "4", keyCode: 52 },
                { val: "5", keyCode: 53 },
                { val: "6", keyCode: 54 },
                { val: "7", keyCode: 55 },
                { val: "8", keyCode: 56 },
                { val: "9", keyCode: 57 }
            ];
            if ($scope.type == "decimal") {
                keyCodes.push({ val: ".", keyCode: 190 }, { val: ".", keyCode: 110 });
            }
            var parseKeyCode = function (code) {
                var search = $filter('filter')(keyCodes, { keyCode: code }, true);
                if (search.length == 0)
                    return false;
                return search[0].val;
            };
            $scope.ok = function () {
                if (that.isValidValue($scope.type, $scope.text, $scope.useZerro)) {
                    $modalInstance.close(that.typeConverting($scope.type, $scope.text));
                }
            };
            $scope.cancel = function () {
                $modalInstance.dismiss('cancel');
            };
            $scope.delete = function () {
                $scope.text = (('' + $scope.text).length > 0) ? ('' + $scope.text).substr(0, ('' + $scope.text).length - 1) : '' + $scope.text;
            };
            $scope.clickButton = function (char) {
                var limit = that.getInputLimit($scope.type);
                if ($scope.text.length < limit) {
                    $scope.text += char;
                }
                if ($scope.type !== 'cellphone' && $scope.text.length === 2 && $scope.text.charAt(1) !== '.' && $scope.text.charAt(0) === '0') {
                }
                var pointsInText = $scope.text.match(/\./g);
                $scope.text = pointsInText && pointsInText.length > 1 ? $scope.text.replace(/\.$/, '') : $scope.text;
            };
            $scope.clear = function () {
                $scope.text = '';
            };
            $scope.keyDown = function (event) {
                var code = event.keyCode;
                event.preventDefault();
                var value = parseKeyCode(code);
                if (!value)
                    return false;
                if (value.length == 1) {
                    $scope.clickButton(value);
                }
                else {
                    switch (value) {
                        case "enter":
                            $scope.ok();
                            break;
                        case "backspace":
                            $scope.delete();
                            break;
                        case "escape":
                            $scope.cancel();
                            break;
                    }
                }
            };
        }
        NumbersController.prototype.isValidValue = function (type, value, useZerro) {
            switch (type) {
                case "cellphone":
                    return (value !== '');
                case "int":
                case "decimal":
                    return ((value !== '') && (useZerro || '' + (value).substr(0) !== '0') && ('' + (value).substr(0) !== '0.'));
            }
            return true;
        };
        NumbersController.prototype.typeConverting = function (type, value) {
            switch (type) {
                case "cellphone":
                    return String(value);
                case "int":
                case "decimal":
                    return Number(value);
            }
            return true;
        };
        NumbersController.prototype.getInputLimit = function (type) {
            switch (type) {
                case "cellphone":
                    return 10;
                case "int":
                    break;
                case "decimal":
                    return 12;
            }
            return 13;
        };
        return NumbersController;
    })();
    ModalModule.NumbersController = NumbersController;
})(ModalModule || (ModalModule = {}));
angular.module('DoctorApp')
    .controller('NumbersController', ModalModule.NumbersController);
/// <reference path="../../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../../../scripts/definition/moment/moment-node.d.ts" />
/// <reference path="../../../directives/date-picker.ts" />
var PeriodModule;
(function (PeriodModule) {
    var Link = (function () {
        function Link(scope, element, attrs) {
            this.scope = scope;
            Link.init(scope);
            scope.changeDate = function (isFirst) {
            };
        }
        Link.init = function (scope) {
            scope.configFrom = new DatePickerModule.Config();
            scope.configFrom.format = scope.config.format;
            scope.configTo = new DatePickerModule.Config();
            scope.configTo.format = scope.config.format;
        };
        Link.updateMaxMin = function (scope) {
            scope.configTo.min = scope.from;
            scope.configFrom.max = scope.to;
        };
        return Link;
    })();
    PeriodModule.Link = Link;
    var Directive = (function () {
        function Directive() {
            this.scope = {
                from: '=',
                to: '=',
                config: '=',
                change: '&'
            };
            this.template = '<div class="period">' +
                '<div class="from">' +
                '<span>From</span>' +
                '<date-picker ng-model="from" config="configFrom" ng-change="changeDate(true)"></date-picker>' +
                '</div>' +
                '<div class="to">' +
                '<span>To</span>' +
                '<date-picker ng-model="to" config="configTo" ng-change="changeDate(false)"></date-picker>' +
                '</div>' +
                '</div>';
            this.restrict = 'E';
            this.link = Link;
        }
        Directive.factory = function () {
            return function () {
                return new Directive();
            };
        };
        return Directive;
    })();
    PeriodModule.Directive = Directive;
})(PeriodModule || (PeriodModule = {}));
angular.module('DoctorApp')
    .directive('period', PeriodModule.Directive.factory());
/// <reference path="../../../../scripts/definition/angularjs/angular.d.ts" />
angular.module('DoctorApp')
    .directive('scrollTable', [function () {
        return {
            restrict: 'A',
            compile: function compile(tElement, tAttributes) {
                var thead = tElement.find('thead');
                var tbody = tElement.find('tbody');
                var wrapper = angular.element('<div class="scroll-table"></div>');
                var tableBody = angular.element('<table></table>');
                tableBody.append(tbody);
                wrapper.append(tableBody);
                tElement.remove('tbody');
                tElement.after(wrapper);
            }
        };
    }]);
/// <reference path="../../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../../services/show-dialog.ts" />
var SearchPanelModule;
(function (SearchPanelModule) {
    var Controller = (function () {
        Controller.$inject = ["$scope", "showDialog"];
        function Controller($scope, showDialog) {
            "ngInject";
            $scope.model = {
                searchText: $scope.config.searchText || '',
                isLoading: false
            };
            $scope.list = [];
            $scope.changeSearch = function (isButton) {
                var text = $scope.model.searchText;
                if (text && text.length) {
                    var promise = $scope.onChange(text);
                    if (promise) {
                        $scope.model.isLoading = true;
                        promise.then(function () {
                            $scope.model.isLoading = false;
                        });
                    }
                }
                else if (isButton) {
                    showDialog.error("Please enter at least one character into search field.");
                }
            };
            if ($scope.model.searchText.length > 0) {
                $scope.changeSearch(false);
            }
            $scope.selectItem = function (object) {
                if (!$scope.config.notClearField) {
                    $scope.model.searchText = '';
                }
                $scope.config.searchText = $scope.model.searchText;
                $scope.onSelect(object);
            };
            $scope.selectLineItem = function (object) {
                if ($scope.config.lineClick) {
                    $scope.selectItem(object);
                }
            };
        }
        return Controller;
    })();
    SearchPanelModule.Controller = Controller;
})(SearchPanelModule || (SearchPanelModule = {}));
angular.module('DoctorApp')
    .directive('searchPanel', function () {
    return {
        restrict: 'E',
        transclude: true,
        scope: {
            config: '=',
            list: '=',
            onChange: '=',
            onSelect: '='
        },
        link: function (scope, element, attrs) {
            scope.$watch('list', function () {
                for (var _i = 0, _a = scope.list; _i < _a.length; _i++) {
                    var row = _a[_i];
                    for (var _b = 0, _c = row.fields; _b < _c.length; _b++) {
                        var cell = _c[_b];
                        if (cell.value === EncounterModule.Controller.ALLOWED) {
                            cell.value = '<span class="f22 fa fa-check fontgreen"></span>';
                        }
                        else if (cell.value === EncounterModule.Controller.NOT_ALLOWED || cell.value === EncounterModule.Controller.NOT_APPLICABLE) {
                            cell.value = '';
                        }
                    }
                }
            });
        },
        templateUrl: 'screens/components/search-panel/search-panel.html',
        controller: SearchPanelModule.Controller
    };
});
/// <reference path="../../../../scripts/definition/angularjs/angular.d.ts" />
var summaryPanel;
(function (summaryPanel) {
    var Controller = (function () {
        Controller.$inject = ["$scope", "$filter"];
        function Controller($scope, $filter) {
            "ngInject";
            this.$scope = $scope;
            this.$filter = $filter;
        }
        Controller.factory = function () {
            var instance = function () {
                var directive = {};
                directive.restrict = 'E';
                directive.scope = {
                    lineItems: '=',
                };
                directive.templateUrl = 'screens/components/summary-panel/summary-panel.html';
                directive.controller = Controller;
                return directive;
            };
            return instance;
        };
        return Controller;
    })();
    summaryPanel.Controller = Controller;
})(summaryPanel || (summaryPanel = {}));
angular.module('DoctorApp')
    .directive('summaryPanel', summaryPanel.Controller.factory());
var TemplateModule;
(function (TemplateModule) {
    var GroupTemplate = (function () {
        function GroupTemplate(name, path, icon, allowParam) {
            this.name = name;
            this.path = path;
            this.icon = icon;
            this.allowParam = allowParam;
        }
        return GroupTemplate;
    })();
    TemplateModule.GroupTemplate = GroupTemplate;
    var SubGroup = (function () {
        function SubGroup(Caption, SortOrder, templates) {
            this.Caption = Caption;
            this.SortOrder = SortOrder;
            this.templates = templates;
        }
        return SubGroup;
    })();
    TemplateModule.SubGroup = SubGroup;
    var Group = (function () {
        function Group() {
        }
        return Group;
    })();
    TemplateModule.Group = Group;
    var TemplatePanelService = (function () {
        TemplatePanelService.$inject = ["$filter"];
        function TemplatePanelService($filter) {
            "ngInject";
            this.$filter = $filter;
        }
        TemplatePanelService.prototype.mixTemplateAndSubGroups = function (templs, type) {
            var templatesCopy = angular.copy(templs);
            var typedTemplates = templatesCopy.filter(function (template) { return template.TemplateType === type; });
            var templates = typedTemplates.filter(function (template) { return template.Caption && template.Caption.indexOf('|') === -1; });
            var subGroups = this.buildSubGroups(typedTemplates);
            for (var _i = 0; _i < subGroups.length; _i++) {
                var sgroup = subGroups[_i];
                templates.push(sgroup);
            }
            return templates;
        };
        TemplatePanelService.prototype.buildSubGroups = function (templates) {
            var subGroupName = 0;
            var subItemName = 1;
            var subGroups = [];
            templates = this.$filter('filter')(templates, function (value) {
                var caption = '';
                if (value.Caption && value.Caption.indexOf('|') > 0) {
                    caption = value.Caption;
                }
                return caption;
            }, true);
            templates = this.$filter('orderBy')(templates, '-SortOrder', true);
            for (var _i = 0; _i < templates.length; _i++) {
                var template = templates[_i];
                var captionItems = this.getCaptionItems(template.Caption);
                var subGroup = this.getSubGroupByCaption(captionItems[subGroupName], subGroups);
                if (!subGroup || subGroup.Caption !== captionItems[subGroupName]) {
                    subGroup = new SubGroup(captionItems[subGroupName], template.SortOrder, []);
                    subGroup.TemplateType = template.TemplateType;
                    subGroups.push(subGroup);
                }
                template.Caption = captionItems[subItemName];
                subGroup.templates.push(template);
            }
            return subGroups;
        };
        TemplatePanelService.prototype.getSubGroupByCaption = function (caption, subGroups) {
            for (var _i = 0; _i < subGroups.length; _i++) {
                var subGroup = subGroups[_i];
                if (subGroup.Caption === caption) {
                    return subGroup;
                }
            }
            return null;
        };
        TemplatePanelService.prototype.getCaptionItems = function (caption) {
            var clearCaption = caption.replace(' | ', '|').replace('| ', '|').replace(' |', '|');
            return clearCaption.split('|');
        };
        return TemplatePanelService;
    })();
    TemplateModule.TemplatePanelService = TemplatePanelService;
})(TemplateModule || (TemplateModule = {}));
angular.module('DoctorApp')
    .service('templatePanelService', TemplateModule.TemplatePanelService);
/// <reference path="../../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../../../scripts/definition/moment/moment-node.d.ts" />
/// <reference path="../../../services/api/domain/patient.ts"/>
/// <reference path="../../../screens/searches/search-service.ts" />
/// <reference path="../encounter/encounter-service.ts" />
/// <reference path="../../../services/show-dialog.ts"/>
/// <reference path="../../../screens/components/template-panel/template-panel.ts"/>
/// <reference path="../../../run.ts"/>
/// <reference path="../../template/template-service.ts"/>
/// <reference path="invoice-service.ts"/>
var InvoiceModule;
(function (InvoiceModule) {
    var Controller = (function () {
        Controller.$inject = ["$scope", "$rootScope", "$routeParams", "locationService", "invoiceService", "practiceService", "patientService", "invoiceTemplateService", "searchService", "showDialog", "$timeout", "$log", "$filter", "$q", "moment", "encounterServiceNew", "modalService"];
        function Controller($scope, $rootScope, $routeParams, locationService, invoiceService, practiceService, patientService, invoiceTemplateService, searchService, showDialog, $timeout, $log, $filter, $q, moment, encounterServiceNew, modalService) {
            "ngInject";
            var _this = this;
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.$routeParams = $routeParams;
            this.locationService = locationService;
            this.invoiceService = invoiceService;
            this.practiceService = practiceService;
            this.patientService = patientService;
            this.invoiceTemplateService = invoiceTemplateService;
            this.searchService = searchService;
            this.showDialog = showDialog;
            this.$timeout = $timeout;
            this.$log = $log;
            this.$filter = $filter;
            this.$q = $q;
            this.moment = moment;
            this.encounterServiceNew = encounterServiceNew;
            this.modalService = modalService;
            $scope.selectTemplate = function (template) {
                invoiceService.addTemplateToEvent($scope.invoice, template);
            };
            $scope.selectHospital = function () {
                invoiceService.mergeHospital($scope.invoice);
            };
            $scope.isNotAuxiliary = function () {
                var auxPractices = ["086", "089"];
                var invoice = $scope.invoice;
                if (invoice && invoice.Provider) {
                    return auxPractices.indexOf(invoice.Provider.SpecialityCode) == -1;
                }
                return false;
            };
            $scope.removeDiagnosis = function (diagnosis) {
                invoiceService.removeDiagnosisFromInvoice($scope.invoice, diagnosis);
            };
            $scope.removeLine = function (line) {
                invoiceService.removeLineItemFromInvoice($scope.invoice, line);
            };
            $scope.togglePrimaryDiagnosis = function (index) {
                var diagnoses = $scope.invoice.InvoiceLineItems.InvoiceHeader.Diagnosis;
                for (var i = 0; i < diagnoses.length; i++) {
                    diagnoses[i].PrimaryIndicator = false;
                }
                diagnoses[index].PrimaryIndicator = true;
            };
            $scope.selectPatient = function () {
                var patientId = $scope.invoice.PatientEventDetails.Patient.PatientId;
                locationService.goToChangePatient($routeParams.practiceId, patientId);
            };
            var setupHospitalIndicator = this.setupInvoice;
            $scope.submitInvoice = function () {
                setupHospitalIndicator($scope.invoice.InvoiceLineItems.InvoiceHeader, $scope);
                $scope.invoiceSent = true;
                $rootScope.showProgressScreen = true;
                $timeout(function () {
                    invoiceService.submitInvoice($scope.invoice)
                        .then(function (response) {
                        $scope.invoiceSent = false;
                        $rootScope.showProgressScreen = false;
                        if (response.Sucess === false) {
                            showDialog.error(response.ResponseMessage, ModalModule.ModalWidth._500px);
                        }
                        else {
                            invoiceService.setConsultationDate(null);
                            invoiceService.setInvoice(null);
                            $rootScope.showThankYou = true;
                            locationService.goToHome($routeParams.practiceId);
                        }
                    });
                }, 1000);
            };
            $scope.isDOBValid = function () {
                return _this.$scope.invoice && moment(_this.$scope.invoice.PatientEventDetails.Patient.PatientDetails.DateOfBirth) < moment();
            };
            $scope.changeConsultationDate = function (date) {
                var consMoment = moment(new Date(date));
                $scope.consultationDate = consMoment.format(Controller.DATE_OUT_PATTERN);
                invoiceService.setConsultationDate(consMoment);
            };
            $scope.showQuantityCalc = function (i, type) {
                var item = $filter('filter')($scope.invoice.InvoiceLineItems.LineItems, { LineType: type })[i];
                modalService.openNumbers('int', 'Enter quantity')
                    .then(function (quantity) {
                    if (quantity) {
                        item.ChargeQuan = quantity;
                    }
                });
            };
            $scope.clickWarning = function () {
                showDialog.warning($scope.specificRule);
            };
            this.init();
        }
        Controller.prototype.setupInvoice = function (invoiceHeader, $scope) {
            var date = this.moment($scope.consultationDate, Controller.DATE_OUT_PATTERN);
            if (!date.isValid()) {
                this.$log.error('Date[' + $scope.consultationDate + '] not valid');
                date = this.moment();
            }
            if (invoiceHeader.HospitalIndicator) {
                $scope.invoice.InvoiceLineItems.InvoiceHeader.AdmissionDateTime = date.hours(12).minutes(0).format();
                $scope.invoice.InvoiceLineItems.InvoiceHeader.DischargeDateTime = date.hours(13).minutes(0).format();
            }
            invoiceHeader.DateOfService = date.hours(0).format();
        };
        Controller.prototype.init = function () {
            var _this = this;
            var that = this;
            that.$scope.myTemplates = [];
            that.$scope.templates = [];
            that.encounterServiceNew.getProvider(this.$routeParams.practiceId)
                .then(function (provider) {
                return that.encounterServiceNew.getProviderOptions(provider);
            })
                .then(function (options) {
                _this.$scope.controlTemplate = {
                    selectTemplate: function (template) {
                        that.$scope.selectTemplate(template);
                    },
                    isMedicine: options.isDispensing,
                    isClinical: false,
                    isPrescription: false
                };
            });
            that.patientEventId = that.$routeParams.patientVisitId;
            that.invoiceTemplateService.loadInvoiceTemplates(this.patientEventId)
                .then(function (templates) {
                _this.$scope.templates = templates;
                _this.$scope.myTemplates = _this.$filter('filter')(templates, { TemplateType: "MyTemplate" }, true);
            })
                .catch(that.catchError);
            that.loadInvoice(that.patientEventId)
                .then(function (invoice) {
                _this.$scope.invoice = invoice;
                _this.updateAccount(invoice.PatientEventDetails);
                _this.initConsultationDate(invoice);
                _this.updatePractice(invoice);
                _this.initSaveTemplate();
                _this.searchService.eventId = invoice.InvoiceId;
                return _this.updateSpecificRules(_this.$routeParams.practiceId, invoice.PatientEventDetails.Patient);
            })
                .catch(that.catchError);
        };
        Controller.prototype.updateAccount = function (patientEvent) {
            var savePatient = this.$rootScope.selectedPatient;
            if (savePatient) {
                patientEvent.Patient = savePatient;
            }
            var patient = patientEvent.Patient;
            this.$scope.accountDetails = patient.PatientAccountDetails;
            this.$scope.fullName = patient.PatientDetails.FirstName + ' ' + patient.PatientDetails.Surname;
        };
        Controller.prototype.updateSpecificRules = function (practiceId, patient) {
            var _this = this;
            var patientId = patient.PatientId;
            return this.invoiceService.getSpecificRule(practiceId, patientId)
                .then(function (response) {
                if (response.Sucess) {
                    _this.$scope.specificRule = response.Data ? response.Data.Description : null;
                }
                else {
                    _this.$log.error(response);
                }
            });
        };
        Controller.prototype.initSaveTemplate = function () {
            var _this = this;
            var that = this;
            var selectedTemplate = that.searchService.getSelectedTemplate();
            if (selectedTemplate) {
                that.invoiceService.addTemplateToEvent(that.$scope.invoice, selectedTemplate)
                    .then(function () {
                    _this.searchService.saveSelectedTemplate(null);
                })
                    .catch(that.catchError);
            }
        };
        Controller.prototype.loadInvoice = function (patientEventId) {
            var _this = this;
            var that = this;
            var invoice = that.invoiceService.getInvoice();
            if (invoice && invoice.PatientEventDetails.PatientEventId == patientEventId) {
                return this.$q.when(invoice);
            }
            that.invoiceService.setInvoice(null);
            that.invoiceService.setConsultationDate(null);
            return this.invoiceService.loadInvoice(patientEventId)
                .then(function (invoice) {
                _this.invoiceService.setInvoice(invoice);
                return invoice;
            });
        };
        Controller.prototype.updatePractice = function (invoice) {
            var patient = this.$rootScope.selectedPatient;
            if (patient) {
                invoice.PatientEventDetails.Patient = patient;
                this.$rootScope.selectedPatient = null;
            }
        };
        Controller.prototype.initConsultationDate = function (invoice) {
            var consDate = this.invoiceService.getConsultationDate();
            if (consDate) {
                this.$scope.consultationDate = consDate.format(Controller.DATE_OUT_PATTERN);
            }
            else {
                if (invoice && invoice.PatientEventDetails) {
                    var event = invoice.PatientEventDetails;
                    var eventDate = event.CheckInTime || event.ScheduledTime;
                }
                var eventDateMoment = this.moment(eventDate);
                var date = eventDateMoment.isValid() ? eventDateMoment : this.moment();
                var consultationDate = date.format(Controller.DATE_OUT_PATTERN);
                this.invoiceService.setConsultationDate(date);
                this.$scope.consultationDate = consultationDate;
            }
        };
        Controller.prototype.catchError = function (error) {
            this.$log.error(error);
        };
        Controller.DATE_OUT_PATTERN = 'D MMMM, YYYY';
        return Controller;
    })();
    InvoiceModule.Controller = Controller;
})(InvoiceModule || (InvoiceModule = {}));
angular.module('DoctorApp')
    .controller('InvoiceController', InvoiceModule.Controller);
var CommunicationModule;
(function (CommunicationModule) {
    var CommunicationTemplatesController = (function () {
        CommunicationTemplatesController.$inject = ["model", "$scope", "modalService", "$modalInstance"];
        function CommunicationTemplatesController(model, $scope, modalService, $modalInstance) {
            "ngInject";
            this.$scope = $scope;
            this.modalService = modalService;
            this.$modalInstance = $modalInstance;
            $scope.templates = model.templates;
            $scope.cancel = function () {
                $modalInstance.dismiss('cancel');
            };
            $scope.addTemplate = function (template) {
                $modalInstance.close(template);
            };
        }
        return CommunicationTemplatesController;
    })();
    CommunicationModule.CommunicationTemplatesController = CommunicationTemplatesController;
})(CommunicationModule || (CommunicationModule = {}));
angular.module('DoctorApp')
    .controller('CommunicationTemplatesController', CommunicationModule.CommunicationTemplatesController);
/// <reference path="../../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../../screens/components/modal/modal-service.ts" />
/// <reference path="../../../services/dialog-service.ts" />
/// <reference path="../../address-book/address-book-service.ts" />
var ModalModule;
(function (ModalModule) {
    var KeyValue = (function () {
        function KeyValue(init) {
            Object.assign(this, init);
        }
        return KeyValue;
    })();
    var EmailReportController = (function () {
        EmailReportController.$inject = ["$scope", "model", "$rootScope", "$sce", "$modalInstance", "$routeParams", "modalService", "usageService", "storageService", "addressBookService", "clinicalDomain", "$compile"];
        function EmailReportController($scope, model, $rootScope, $sce, $modalInstance, $routeParams, modalService, usageService, storageService, addressBookService, clinicalDomain, $compile) {
            "ngInject";
            var _this = this;
            this.$scope = $scope;
            this.model = model;
            this.$rootScope = $rootScope;
            this.$sce = $sce;
            this.$modalInstance = $modalInstance;
            this.$routeParams = $routeParams;
            this.modalService = modalService;
            this.usageService = usageService;
            this.storageService = storageService;
            this.addressBookService = addressBookService;
            this.clinicalDomain = clinicalDomain;
            this.$compile = $compile;
            $scope.body = "Hi " +
                model.patient.PatientDetails.FirstName +
                " " +
                model.patient.PatientDetails.Surname +
                ",<br><br>" +
                "Please find attached your" +
                model.attachments.map(function (attachment) { return " " + attachment.Type; }) +
                ".<br><br>" +
                "Should you have any queries, please contact " +
                model.provider.PracticeName +
                " on " +
                model.provider.ContactNumber +
                ". <br><br>" +
                "Thank you, <br>" +
                model.provider.TreatingDoctorName;
            clinicalDomain.getProviderById(this.$routeParams.practiceId).then(function (p) {
                $scope.doctorEmail = p.EmailAddress;
                $scope.changeSendTo();
            });
            $scope.send = function (isValid) {
                if (isValid) {
                    model.subject = $scope.subject;
                    model.body = $scope.body;
                    $rootScope.showWaitingScreen = true;
                    var patientId = model.patient.PatientId;
                    var patientEmail = model.patient.PatientDetails.EmailAddress;
                    var body = {
                        Subject: model.subject,
                        Recipient: $scope.selectedEmails.map(function (elem) { return elem.id; }).join(","),
                        Body: model.body,
                        Attachments: model.attachments
                    };
                    _this.clinicalDomain.sendCommunicationByEmail(_this.$routeParams.practiceId, patientId, body, true)
                        .then(function (response) {
                        $rootScope.showWaitingScreen = false;
                        if (response.Sucess) {
                            _this.usageService.sendEmail(_this.$routeParams.practiceId, model.subject, patientEmail, model.body);
                            $scope.selectedEmails.forEach(function (e) {
                                var index = Common.getIndexBy($scope.favouriteContacts, "EmailAddress", e.id);
                                if (index > -1) {
                                    _this.usageService.useAddressBook(_this.$routeParams.practiceId, _this.storageService.getUser().userLogin, UsageModule.ActionType.UseContact, _this.$scope.favouriteContacts[index]);
                                }
                            });
                            _this.modalService.info("Email was successfully sent.").then(function (r) {
                                $modalInstance.close(model);
                            });
                        }
                        else {
                            _this.modalService.error("Failed to send email: " + response.ResponseMessage);
                        }
                    }, function (error) {
                        $rootScope.showWaitingScreen = false;
                        _this.modalService.error("There was a problem sending the email, please try again. If the problem persists, please contact support.");
                    });
                }
                else {
                    modalService.error("Please provide the required form details.");
                }
            };
            $scope.openContactSearch = function () {
                modalService.openAddressBookSearch().then(function (contact) {
                    if (contact) {
                        var item = _this.adaptContact(contact);
                        if (!$scope.selectedEmails.some(function (i) { return i.id === item.id; })) {
                            $scope.selectedEmails.push(item);
                            _this.usageService.useAddressBook(_this.$routeParams.practiceId, _this.storageService.getUser().userLogin, UsageModule.ActionType.UseContact, contact);
                        }
                    }
                });
                ;
            };
            $scope.changeSendTo = function () {
                var patientEmail;
                var doctorEmail;
                var index;
                if (_this.$scope.doctorEmail) {
                    doctorEmail = new KeyValue({ id: $scope.doctorEmail, name: $scope.doctorEmail });
                    index = Common.getIndexBy($scope.selectedEmails, "id", doctorEmail.id);
                    if (_this.$scope.sendToMe) {
                        if (index === -1) {
                            $scope.selectedEmails.push(doctorEmail);
                        }
                    }
                    else {
                        if (index > -1) {
                            $scope.selectedEmails.splice(index, 1);
                        }
                    }
                }
                if (_this.$scope.patientEmail) {
                    patientEmail = new KeyValue({ id: $scope.patientEmail, name: $scope.patientEmail });
                    index = Common.getIndexBy($scope.selectedEmails, "id", patientEmail.id);
                    if (_this.$scope.sendToPatient) {
                        if (index === -1) {
                            $scope.selectedEmails.push(patientEmail);
                        }
                    }
                    else {
                        if (index > -1) {
                            $scope.selectedEmails.splice(index, 1);
                        }
                    }
                }
            };
            $scope.addContact = function () {
                var container = angular.element(document).find('multiple-autocomplete');
                var inputCtrl = container.find('input')[0];
                var inputVal = inputCtrl.value;
                if (inputVal) {
                    var newValue = { id: inputVal, name: inputVal };
                    $scope.selectedEmails.push(newValue);
                    inputCtrl.value = "";
                    _this.resetSuggestedList();
                }
            };
            $scope.autocompleteKeyUp = function (event) {
                var searchvalue = event.target.value;
                if (event.keyCode == 13) {
                    var newValue = { id: searchvalue, name: searchvalue };
                    $scope.selectedEmails.push(newValue);
                    event.target.value = "";
                    _this.resetSuggestedList();
                }
                else {
                    if (!searchvalue) {
                        _this.resetSuggestedList();
                    }
                    else {
                        _this.addressBookService.loadPracticeAddressBook(_this.$routeParams.practiceId, searchvalue).then(function (entities) {
                            $scope.suggestedContacts = entities.map(_this.adaptContact);
                        });
                    }
                }
            };
            $scope.tinymceOptions = {
                selector: 'textarea',
                plugins: 'link table preview',
                toolbar: 'undo redo | bold italic | fontsizeselect | bullist numlist outdent indent | alignleft aligncenter alignright | file',
                fontsize_formats: '8pt 10pt 12pt 14pt 18pt 24pt 36pt',
                skin_url: GlobalVar.isProd ? 'styles/tinymce/skins/lightgray' : '',
                visual: false,
                browser_spellcheck: true,
                contextmenu: false,
                statusbar: false,
                valid_children: "+body[style],+body,+head",
                extended_valid_elements: 'body,head',
                init_instance_callback: function (editor) {
                    var contentWraper = $(editor.contentAreaContainer);
                    var content = $(editor.iframeElement);
                    var height = content.contents().find('body').height();
                    var padding = 50;
                    content.height(height + padding + 'px');
                    contentWraper.css('max-height', '50vh');
                    contentWraper.css('overflow', 'auto');
                }
            };
            $scope.cancel = function () {
                $modalInstance.dismiss('cancel');
            };
            $scope.$on('$routeChangeStart', function () {
                $modalInstance.close();
            });
            this.init();
        }
        EmailReportController.prototype.init = function () {
            this.$scope.suggestedContacts = [];
            this.$scope.selectedEmails = [];
            this.$scope.sendToMe = true;
            this.$scope.sendToPatient = false;
            this.$scope.title = "Send email";
            this.$scope.subject = this.model.emailSubject;
            this.$scope.showWarning = this.model.showWarning;
            this.$scope.patientEmail = this.model.patient.PatientDetails.EmailAddress;
            this.$scope.changeSendTo();
            this.loadFavourites();
        };
        EmailReportController.prototype.resetSuggestedList = function () {
            var array = this.$scope.favouriteContacts.map(this.adaptContact);
            this.$scope.suggestedContacts = array;
        };
        EmailReportController.prototype.adaptContact = function (contact) {
            var contactName = "";
            if (contact.Name && contact.OrganizationName) {
                contactName = contact.Name + " " + contact.Surname + " (" + contact.OrganizationName + ")";
            }
            else if (contact.OrganizationName) {
                contactName = contact.OrganizationName;
            }
            else {
                contactName = contact.Name + " " + contact.Surname;
            }
            return new KeyValue({
                id: contact.EmailAddress,
                name: contactName
            });
        };
        EmailReportController.prototype.loadFavourites = function () {
            var _this = this;
            this.addressBookService.loadPracticeAddressBookFavourites(this.$routeParams.practiceId)
                .then(function (entities) {
                _this.$scope.favouriteContacts = entities;
                _this.resetSuggestedList();
            });
        };
        return EmailReportController;
    })();
    ModalModule.EmailReportController = EmailReportController;
})(ModalModule || (ModalModule = {}));
angular.module('DoctorApp')
    .controller('EmailReportController', ModalModule.EmailReportController);
var LetterEditorModule;
(function (LetterEditorModule) {
    var LetterEditorController = (function () {
        LetterEditorController.$inject = ["model", "$scope", "$window", "showDialog", "$modalInstance", "dashboardService", "$routeParams", "modalService"];
        function LetterEditorController(model, $scope, $window, showDialog, $modalInstance, dashboardService, $routeParams, modalService) {
            "ngInject";
            var _this = this;
            this.$scope = $scope;
            this.$window = $window;
            this.showDialog = showDialog;
            this.$modalInstance = $modalInstance;
            this.dashboardService = dashboardService;
            this.$routeParams = $routeParams;
            this.modalService = modalService;
            $scope.tinymceModel = model.templateBody || ' ';
            $scope.caption = model.communication.Type;
            $scope.title = model.communication.Title;
            $scope.done = function (isValid) {
                if (!isValid) {
                    return;
                }
                model.templateBody = $scope.tinymceModel;
                model.communication.Title = $scope.title;
                $modalInstance.close(model);
            };
            $scope.cancel = function () {
                $modalInstance.dismiss();
            };
            $scope.print = function () {
                var tinymceModel = $scope.tinymceModel;
                modalService.showReportDialog(EncounterModule.ReportType.Communication, [tinymceModel], function (tinymceModel) {
                    var new_window = _this.$window.open('about:blank', "_blank");
                    _this.dashboardService.reportLinkFromHtmlToPdf($routeParams.practiceId, tinymceModel).then(function (link) {
                        new_window.location.href = link;
                    });
                }, model.communication.PatientId);
            };
            $scope.tinymceOptions = {
                selector: 'textarea',
                plugins: 'link table preview print',
                toolbar: 'undo redo | bold italic | fontsizeselect | bullist numlist outdent indent | alignleft aligncenter alignright | file',
                fontsize_formats: '8pt 10pt 12pt 14pt 18pt 24pt 36pt',
                skin_url: GlobalVar.isProd ? 'styles/tinymce/skins/lightgray' : '',
                visual: false,
                browser_spellcheck: true,
                contextmenu: false,
                statusbar: false,
                valid_children: "+body[style],+body,+head",
                extended_valid_elements: 'body,head',
                init_instance_callback: function (editor) {
                    var contentWraper = $(editor.contentAreaContainer);
                    var content = $(editor.iframeElement);
                    var height = content.contents().find('body').height();
                    var padding = 50;
                    content.height(height + padding + 'px');
                    contentWraper.css('max-height', '50vh');
                    contentWraper.css('overflow', 'auto');
                }
            };
        }
        return LetterEditorController;
    })();
    LetterEditorModule.LetterEditorController = LetterEditorController;
})(LetterEditorModule || (LetterEditorModule = {}));
angular.module('DoctorApp')
    .controller('LetterEditorController', LetterEditorModule.LetterEditorController);
var RefferalTemplatesModule;
(function (RefferalTemplatesModule) {
    var RefferalTemplatesController = (function () {
        RefferalTemplatesController.$inject = ["model", "$scope", "modalService", "$modalInstance"];
        function RefferalTemplatesController(model, $scope, modalService, $modalInstance) {
            "ngInject";
            this.$scope = $scope;
            this.modalService = modalService;
            this.$modalInstance = $modalInstance;
            $scope.templates = model.templates;
            $scope.cancel = function () {
                $modalInstance.dismiss('cancel');
            };
            $scope.addTemplate = function (template) {
                $modalInstance.close(template);
            };
        }
        return RefferalTemplatesController;
    })();
    RefferalTemplatesModule.RefferalTemplatesController = RefferalTemplatesController;
})(RefferalTemplatesModule || (RefferalTemplatesModule = {}));
angular.module('DoctorApp')
    .controller('RefferalTemplatesController', RefferalTemplatesModule.RefferalTemplatesController);
var MedicalInsuranceModule;
(function (MedicalInsuranceModule) {
    var MedicalInsuranceController = (function () {
        MedicalInsuranceController.$inject = ["model", "$modalInstance", "$routeParams", "$filter", "encounterServiceNew", "locationService", "httpService", "patientEventDomain", "modalService", "$scope"];
        function MedicalInsuranceController(model, $modalInstance, $routeParams, $filter, encounterServiceNew, locationService, httpService, patientEventDomain, modalService, $scope) {
            "ngInject";
            var _this = this;
            this.model = model;
            this.$modalInstance = $modalInstance;
            this.$routeParams = $routeParams;
            this.$filter = $filter;
            this.encounterServiceNew = encounterServiceNew;
            this.locationService = locationService;
            this.httpService = httpService;
            this.patientEventDomain = patientEventDomain;
            this.modalService = modalService;
            this.$scope = $scope;
            $scope.title = "Medical insurance details";
            $scope.medicalInsurerXRef = model.encounter.MedicalInsurance
                && model.encounter.MedicalInsurance.MedicalInsurer
                && model.encounter.MedicalInsurance.MedicalInsurer.InsurerXRef;
            $scope.medicalInsurance = angular.copy(model.encounter.MedicalInsurance) || {
                MedicalInsurer: null,
                Broker: "",
                PolicyNo: "",
                PatientIdentityNo: ""
            };
            $scope.openNumberDialog = function () {
                modalService.openNumbers('int', 'Enter number', null, $scope.medicalInsurance.PatientIdentityNo)
                    .then(function (patientIdentityNo) {
                    if (patientIdentityNo) {
                        $scope.medicalInsurance.PatientIdentityNo = patientIdentityNo.toString();
                    }
                });
            };
            $scope.selectMedicalInsurer = function (medicalInsurerId) {
                $scope.medicalInsurance.MedicalInsurer = _this.getMedicalInsurerByXref(medicalInsurerId);
            };
            $scope.editPatientIdentityNo = function () {
                var patientId = model.encounter.PatientEventDetails.Patient.PatientId;
                model.encounter.MedicalInsurance = $scope.medicalInsurance;
                $modalInstance.dismiss('cancel');
                _this.encounterServiceNew.setEncounter(model.encounter);
                locationService.goToChangePatient($routeParams.practiceId, patientId);
            };
            $scope.done = function () {
                if (!$scope.medicalInsurance.PatientIdentityNo ||
                    !$scope.medicalInsurance.PolicyNo ||
                    !$scope.medicalInsurance.MedicalInsurer ||
                    ($scope.medicalInsurance.MedicalInsurer && !$scope.medicalInsurance.MedicalInsurer.InsurerXRef)) {
                    modalService.error("Please provide the required medical insurer invoice details.");
                }
                else {
                    $modalInstance.close($scope.medicalInsurance);
                }
            };
            $scope.cancel = function () {
                $modalInstance.dismiss('cancel');
            };
            this.init();
        }
        MedicalInsuranceController.prototype.init = function () {
            var _this = this;
            if (this.$scope.medicalInsurance.MedicalInsurer) {
                this.$scope.medicalInsurance.MedicalInsurer.InsurerXRef =
                    this.$scope.medicalInsurance.MedicalInsurer.InsurerXRef ||
                        this.model.encounter.PatientEventDetails.Patient.PatientDetails.IdentityNo;
            }
            this.patientEventDomain.getMedicalinsurers(this.$routeParams.practiceId)
                .then(function (medicalInsurers) {
                _this.$scope.medicalInsurers = medicalInsurers;
                if (_this.$scope.medicalInsurerXRef) {
                    _this.$scope.medicalInsurance.MedicalInsurer = _this.getMedicalInsurerByXref(_this.$scope.medicalInsurerXRef);
                }
            });
        };
        MedicalInsuranceController.prototype.getMedicalInsurerByXref = function (Xref) {
            var medicalInsurersByXref = this.$filter('filter')(this.$scope.medicalInsurers, Xref);
            if (medicalInsurersByXref.length > 0) {
                return medicalInsurersByXref[0];
            }
            return null;
        };
        return MedicalInsuranceController;
    })();
    MedicalInsuranceModule.MedicalInsuranceController = MedicalInsuranceController;
})(MedicalInsuranceModule || (MedicalInsuranceModule = {}));
angular.module('DoctorApp')
    .controller('MedicalInsuranceController', MedicalInsuranceModule.MedicalInsuranceController);
/// <reference path="../../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../components/modal/modal-service.ts" />
var ModalModule;
(function (ModalModule) {
    var Variable = (function () {
        function Variable(name, count, type, units) {
            this.name = name;
            this.count = count;
            this.type = type;
            this.units = units;
        }
        return Variable;
    })();
    var Instruction = (function () {
        function Instruction(name, oppositeName) {
            this.name = name;
            this.oppositeName = oppositeName;
        }
        return Instruction;
    })();
    var Group = (function () {
        function Group(name, types, items) {
            this.name = name;
            this.types = types;
            this.items = items;
        }
        return Group;
    })();
    var VConfig = (function (_super) {
        __extends(VConfig, _super);
        function VConfig() {
            _super.apply(this, arguments);
        }
        return VConfig;
    })(ModalModule.Config);
    var DetailsController = (function () {
        DetailsController.$inject = ["$scope", "modalService"];
        function DetailsController($scope, modalService) {
            "ngInject";
            var instructions = this.createInstructions();
            $scope.maxQuantity = 200;
            $scope.showQuantityWarning = false;
            $scope.zeroPricing = $scope.config.validateOptions.specificRule && ($scope.config.validateOptions.specificRule.ZeroMedicine && $scope.model.LineType === 'Medicine' ||
                $scope.config.validateOptions.specificRule.ZeroConsumable && $scope.model.LineType === 'Consumable') &&
                $scope.config.validateOptions.medicalAidInvoice;
            $scope.openNumbersDialog = function (valueName) {
                modalService.openNumbers('decimal', 'Enter number')
                    .then(function (quantity) {
                    if (quantity) {
                        $scope.model[valueName] = quantity;
                    }
                });
            };
            $scope.openPriceDialog = function () {
                modalService.openNumbers('decimal', 'Enter price', null, null, true)
                    .then(function (price) {
                    $scope.model.PriceOverride = true;
                    $scope.model.TotalIncVat = price;
                    $scope.model.Amount = price;
                });
            };
            $scope.openDialog = function (valueName) {
                modalService.openNumbers('int', 'Enter number')
                    .then(function (quantity) {
                    if (quantity) {
                        $scope.model[valueName] = quantity;
                    }
                });
            };
            $scope.refreshPrice = function () {
                $scope.model.PriceOverride = false;
                $scope.config.validateOptions.refreshPrice($scope.model);
            };
            $scope.openQuantityDialog = function () {
                modalService.openNumbers('int', 'Enter quantity')
                    .then(function (quantity) {
                    if (quantity) {
                        $scope.model.ChargeQuan = quantity;
                    }
                });
            };
            $scope.maxQuantityWarning = function () {
                modalService.warning('Please note that the maximum allowable quantity' +
                    'on the Discovery KeyCare acute formulary is ' +
                    $scope.maxQuantity +
                    'ml.').then(function () {
                });
            };
            $scope.clickItem = function (groupIndex, variable) {
                switch (groupIndex) {
                    case 0:
                        $scope.model.DosageUnit = variable.count;
                        $scope.model.DosageType = variable.type;
                        break;
                    case 1:
                        $scope.model.FrequencyUnit = variable.units === -1 ? $scope.model.FrequencyUnit : variable.units;
                        $scope.model.PeriodUnit = variable.count === -1 ? $scope.model.PeriodUnit : variable.count;
                        $scope.model.PeriodType = variable.type === '' ? $scope.model.PeriodType : variable.type;
                        for (var _i = 0; _i < instructions.length; _i++) {
                            var instruction = instructions[_i];
                            if (instruction.name === variable.name || instruction.oppositeName === variable.name) {
                                var oppositeName = (variable.name === instruction.name) ? instruction.oppositeName : instruction.name;
                                var additionalInst = $scope.model.DispensingInstructions || "";
                                additionalInst = additionalInst.replace(oppositeName, variable.name);
                                if (additionalInst.indexOf(variable.name) === -1) {
                                    additionalInst = variable.name + " " + additionalInst;
                                }
                                $scope.model.DispensingInstructions = additionalInst;
                            }
                        }
                        break;
                    case 2:
                        $scope.model.DurationUnit = variable.count;
                        $scope.model.DurationType = variable.type;
                        break;
                }
            };
            $scope.model.validate = function () {
                if (!$scope.model.DosageUnit) {
                    modalService.warning("Some schemes require prescription details for medicines");
                }
            };
            $scope.groups = [
                this.createDosageGroup(),
                this.createFrequencyGroup(),
                this.createDurationGroup()
            ];
        }
        DetailsController.prototype.createVariables = function () {
            return [
                this.createDosageGroup(),
                this.createFrequencyGroup(),
                this.createDurationGroup()
            ];
        };
        DetailsController.prototype.createInstructions = function () {
            var instructions = [
                new Instruction('Mane', 'Nocte'),
                new Instruction('a.c.', 'p.c.'),
                new Instruction('STAT', 'prn')
            ];
            return instructions;
        };
        DetailsController.prototype.createDosageGroup = function () {
            var dosageTypes = [
                'g', 'l', 'ointment', 'drops', 'mcg', 'µg', 'mg', 'ml', 'tablets', 'pack', 'puffs', 'units', 'ampules',
                'sprays', 'capsules', 'vial', 'sachet'
            ];
            var items = [
                new Variable('10mg', 10, dosageTypes[6], 0),
                new Variable('100mg', 100, dosageTypes[6], 0),
                new Variable('300mg', 300, dosageTypes[6], 0),
                new Variable('250mg', 250, dosageTypes[6], 0),
                new Variable('500mg', 500, dosageTypes[6], 0),
                new Variable('1000mg', 1000, dosageTypes[6], 0),
                new Variable('1tb', 1, dosageTypes[8], 0),
                new Variable('2tb', 2, dosageTypes[8], 0),
                new Variable('3tb', 3, dosageTypes[8], 0),
                new Variable('1cap', 1, dosageTypes[14], 0),
                new Variable('2cap', 2, dosageTypes[14], 0),
                new Variable('3cap', 3, dosageTypes[14], 0)
            ];
            return new Group('Dosage', dosageTypes, items);
        };
        DetailsController.prototype.createFrequencyGroup = function () {
            var frequencyTypes = ['hour', 'day', 'week', 'month'];
            var items = [
                new Variable('Daily', 1, frequencyTypes[1], 1),
                new Variable('BD', 1, frequencyTypes[1], 2),
                new Variable('TDS', 1, frequencyTypes[1], 3),
                new Variable('QID', 1, frequencyTypes[1], 4),
                new Variable('Q4h', 4, frequencyTypes[0], 1),
                new Variable('Q6h', 6, frequencyTypes[0], 1),
                new Variable('Q8h', 8, frequencyTypes[0], 1)
            ];
            return new Group('Frequency', frequencyTypes, items);
        };
        DetailsController.prototype.createDurationGroup = function () {
            var durationTypes = ['hour', 'day', 'week', 'month'];
            var items = [
                new Variable('1/7', 1, durationTypes[1], 0),
                new Variable('3/7', 3, durationTypes[1], 0),
                new Variable('5/7', 5, durationTypes[1], 0),
                new Variable('1/52', 1, durationTypes[2], 0),
                new Variable('2/52', 2, durationTypes[2], 0),
                new Variable('3/52', 3, durationTypes[2], 0),
                new Variable('4/52', 4, durationTypes[2], 0),
                new Variable('5/52', 5, durationTypes[2], 0),
                new Variable('6/52', 6, durationTypes[2], 0),
                new Variable('1/12', 1, durationTypes[3], 0),
                new Variable('3/12', 3, durationTypes[3], 0),
                new Variable('6/12', 6, durationTypes[3], 0)
            ];
            return new Group('Duration', durationTypes, items);
        };
        return DetailsController;
    })();
    ModalModule.DetailsController = DetailsController;
})(ModalModule || (ModalModule = {}));
angular.module('DoctorApp')
    .controller('ModalDetailsController', ModalModule.DetailsController);
/// <reference path="../../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../../../scripts/definition/moment/moment-node.d.ts" />
/// <reference path="../encounter/encounter.ts" />
var details;
(function (details) {
    var GroupsModel = (function () {
        function GroupsModel(value, ischecked) {
            this.isChecked = ischecked || false;
            this.value = value;
        }
        return GroupsModel;
    })();
    details.GroupsModel = GroupsModel;
    var Group = (function () {
        function Group() {
            this.prescriptionLines = [];
        }
        return Group;
    })();
    details.Group = Group;
    var PrescriptionHistoryController = (function () {
        PrescriptionHistoryController.$inject = ["$scope"];
        function PrescriptionHistoryController($scope) {
            "ngInject";
            var _this = this;
            this.$scope = $scope;
            $scope.groups = this.getGroups($scope.model);
            $scope.groupClick = function (group) {
                var prescrLines = group.prescriptionLines;
                for (var _i = 0; _i < prescrLines.length; _i++) {
                    var line = prescrLines[_i];
                    line.isChecked = group.date.isChecked;
                }
                $scope.model = _this.getPrescriptionLines();
                $scope.$parent['model'] = $scope.model;
            };
            $scope.lineClick = function (group) {
                var prescrLines = group.prescriptionLines;
                var checkedLines = 0;
                for (var _i = 0; _i < prescrLines.length; _i++) {
                    var line = prescrLines[_i];
                    checkedLines = line.isChecked ? checkedLines + 1 : checkedLines;
                }
                group.date.isChecked = checkedLines === prescrLines.length;
                $scope.model = _this.getPrescriptionLines();
                $scope.$parent['model'] = $scope.model;
            };
        }
        PrescriptionHistoryController.prototype.getPrescriptionLines = function () {
            var lines = [];
            var groups = this.$scope.groups;
            for (var _i = 0; _i < groups.length; _i++) {
                var group = groups[_i];
                for (var _a = 0, _b = group.prescriptionLines; _a < _b.length; _a++) {
                    var line = _b[_a];
                    if (line.isChecked) {
                        lines.push(line.value);
                    }
                }
            }
            return lines;
        };
        PrescriptionHistoryController.prototype.getGroups = function (model) {
            var groups = [];
            for (var _i = 0; _i < model.length; _i++) {
                var encounter = model[_i];
                var prescriptionLines = encounter.MedicationsPrescribed.MedicationPrescriptionLines;
                var group = new Group();
                var date = encounter.MedicationsPrescribed.IssuedDate.split('T')[0];
                var diagnosis = encounter.EncounterLineItems.EncounterHeader.Diagnosis;
                var diagnisisCodes = '';
                if (diagnosis.length) {
                    diagnisisCodes = ' ';
                    for (var _a = 0; _a < diagnosis.length; _a++) {
                        var item = diagnosis[_a];
                        diagnisisCodes += item.DiagnosisCode + (diagnosis.indexOf(item) < diagnosis.length - 1 ? ', ' : '');
                    }
                }
                group.date = new GroupsModel(date + diagnisisCodes);
                for (var _b = 0; _b < prescriptionLines.length; _b++) {
                    var prescLine = prescriptionLines[_b];
                    group.prescriptionLines.push(new GroupsModel(prescLine));
                }
                groups.push(group);
            }
            return groups;
        };
        return PrescriptionHistoryController;
    })();
    details.PrescriptionHistoryController = PrescriptionHistoryController;
})(details || (details = {}));
angular.module('DoctorApp')
    .controller('PrescriptionHistoryController', details.PrescriptionHistoryController);
/// <reference path="../../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../../../scripts/definition/moment/moment-node.d.ts" />
/// <reference path="../encounter/encounter.ts" />
var details;
(function (details) {
    var Variable = (function () {
        function Variable(name, count, type, units) {
            this.name = name;
            this.count = count;
            this.type = type;
            this.units = units;
        }
        return Variable;
    })();
    var Instruction = (function () {
        function Instruction(name, oppositeName) {
            this.name = name;
            this.oppositeName = oppositeName;
        }
        return Instruction;
    })();
    var Group = (function () {
        function Group(name, types, items) {
            this.name = name;
            this.types = types;
            this.items = items;
        }
        return Group;
    })();
    var PrescriptionModalDetailsController = (function () {
        PrescriptionModalDetailsController.$inject = ["$scope", "modalService"];
        function PrescriptionModalDetailsController($scope, modalService) {
            "ngInject";
            var _this = this;
            this.$scope = $scope;
            this.modalService = modalService;
            var instructions = this.createInstructions();
            $scope.openDialog = function (valueName, useZero) {
                if (useZero === void 0) { useZero = false; }
                modalService.openNumbers('int', 'Enter number', null, null, useZero)
                    .then(function (quantity) {
                    $scope.model[valueName] = quantity;
                });
            };
            $scope.openNumbersDialog = function (valueName) {
                modalService.openNumbers('decimal', 'Enter number')
                    .then(function (quantity) {
                    if (quantity) {
                        $scope.model[valueName] = quantity;
                    }
                });
            };
            $scope.onChronicChange = function () {
                _this.$scope.model.Repeat = (_this.$scope.model.ChronicIndicator) ? 6 : 0;
            };
            $scope.clickItem = function (groupIndex, variable) {
                switch (groupIndex) {
                    case 0:
                        $scope.model.DosageUnits = variable.count;
                        $scope.model.DosageType = variable.type;
                        break;
                    case 1:
                        $scope.model.FrequencyUnits = variable.units === -1 ? $scope.model.FrequencyUnits : variable.units;
                        $scope.model.PeriodUnit = variable.count === -1 ? $scope.model.PeriodUnit : variable.count;
                        $scope.model.PeriodType = variable.type === '' ? $scope.model.PeriodType : variable.type;
                        for (var _i = 0; _i < instructions.length; _i++) {
                            var instruction = instructions[_i];
                            if (instruction.name === variable.name || instruction.oppositeName === variable.name) {
                                var oppositeName = (variable.name === instruction.name) ? instruction.oppositeName : instruction.name;
                                var additionalInst = $scope.model.DispensingInstructions || "";
                                additionalInst = additionalInst.replace(oppositeName, variable.name);
                                if (additionalInst.indexOf(variable.name) === -1) {
                                    additionalInst = variable.name + " " + additionalInst;
                                }
                                $scope.model.DispensingInstructions = additionalInst;
                            }
                        }
                        break;
                    case 2:
                        if (variable.name == "3/12" || variable.name == "6/12") {
                            $scope.model.Repeat = variable.count;
                            $scope.model.DurationType = variable.type;
                            $scope.model.DurationUnit = 1;
                        }
                        else {
                            $scope.model.DurationUnit = variable.count;
                            $scope.model.DurationType = variable.type;
                        }
                        break;
                }
            };
            $scope.groups = this.createVariables();
        }
        PrescriptionModalDetailsController.prototype.createVariables = function () {
            return [
                this.createDosageGroup(),
                this.createFrequencyGroup(),
                this.createDurationGroup()
            ];
        };
        PrescriptionModalDetailsController.prototype.createInstructions = function () {
            var instructions = [
                new Instruction('Mane', 'Nocte'),
                new Instruction('a.c.', 'p.c.'),
                new Instruction('STAT', 'prn'),
                new Instruction('PRN', 'PRN')
            ];
            return instructions;
        };
        PrescriptionModalDetailsController.prototype.createDosageGroup = function () {
            var dosageTypes = [
                'g', 'l', 'ointment', 'drops', 'mcg', 'µg', 'mg', 'ml', 'tablets', 'pack', 'puffs', 'units', 'ampules',
                'sprays', 'capsules', 'vial', 'sachet', 'cream', 'suppository'
            ];
            var items = [
                new Variable('10mg', 10, dosageTypes[6], 0),
                new Variable('100mg', 100, dosageTypes[6], 0),
                new Variable('300mg', 300, dosageTypes[6], 0),
                new Variable('250mg', 250, dosageTypes[6], 0),
                new Variable('500mg', 500, dosageTypes[6], 0),
                new Variable('1000mg', 1000, dosageTypes[6], 0),
                new Variable('1tb', 1, dosageTypes[8], 0),
                new Variable('2tb', 2, dosageTypes[8], 0),
                new Variable('3tb', 3, dosageTypes[8], 0),
                new Variable('1cap', 1, dosageTypes[14], 0),
                new Variable('2cap', 2, dosageTypes[14], 0),
                new Variable('3cap', 3, dosageTypes[14], 0)
            ];
            return new Group('Dosage', dosageTypes, items);
        };
        PrescriptionModalDetailsController.prototype.createFrequencyGroup = function () {
            var frequencyTypes = ['hour', 'day', 'week', 'month'];
            var items = [
                new Variable('Daily', 1, frequencyTypes[1], 1),
                new Variable('BD', 1, frequencyTypes[1], 2),
                new Variable('TDS', 1, frequencyTypes[1], 3),
                new Variable('QID', 1, frequencyTypes[1], 4),
                new Variable('Q4h', 4, frequencyTypes[0], 1),
                new Variable('Q6h', 6, frequencyTypes[0], 1),
                new Variable('Q8h', 8, frequencyTypes[0], 1),
                new Variable('Mane', 1, frequencyTypes[1], 1),
                new Variable('Nocte', 1, frequencyTypes[1], 1),
                new Variable('STAT', -1, '', -1),
                new Variable('PRN', -1, '', -1),
                new Variable('p.c.', -1, '', -1),
                new Variable('a.c.', -1, '', -1)
            ];
            return new Group('Frequency', frequencyTypes, items);
        };
        PrescriptionModalDetailsController.prototype.createDurationGroup = function () {
            var durationTypes = ['hour', 'day', 'week', 'month'];
            var items = [
                new Variable('1/7', 1, durationTypes[1], 0),
                new Variable('3/7', 3, durationTypes[1], 0),
                new Variable('5/7', 5, durationTypes[1], 0),
                new Variable('1/52', 1, durationTypes[2], 0),
                new Variable('2/52', 2, durationTypes[2], 0),
                new Variable('3/52', 3, durationTypes[2], 0),
                new Variable('4/52', 4, durationTypes[2], 0),
                new Variable('5/52', 5, durationTypes[2], 0),
                new Variable('6/52', 6, durationTypes[2], 0),
                new Variable('1/12', 1, durationTypes[3], 0),
                new Variable('3/12', 3, durationTypes[3], 0),
                new Variable('6/12', 6, durationTypes[3], 0)
            ];
            return new Group('Duration', durationTypes, items);
        };
        return PrescriptionModalDetailsController;
    })();
    details.PrescriptionModalDetailsController = PrescriptionModalDetailsController;
})(details || (details = {}));
angular.module('DoctorApp')
    .controller('PrescriptionModalDetailsController', details.PrescriptionModalDetailsController);
/// <reference path="../../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../../../scripts/definition/moment/moment-node.d.ts" />
/// <reference path="../encounter/encounter.ts" />
/// <reference path="../encounter/encounter-service.ts" />
var details;
(function (details) {
    var Item = (function () {
        function Item(diagnosis, turn) {
            this.diagnosis = diagnosis;
            this.turn = turn;
        }
        return Item;
    })();
    var SicknoteController = (function () {
        SicknoteController.$inject = ["$scope", "modalService", "moment", "encounterServiceNew"];
        function SicknoteController($scope, modalService, moment, encounterServiceNew) {
            "ngInject";
            this.$scope = $scope;
            this.modalService = modalService;
            this.moment = moment;
            this.encounterServiceNew = encounterServiceNew;
            var that = this;
            $scope.toggleDiagnosis = function (item) {
                var list = $scope.model.MedicalCertificate.Diagnoses;
                if (item.turn) {
                    list.push(item.diagnosis);
                }
                else {
                    that.removeDiagnosis(list, item.diagnosis);
                }
            };
            $scope.$watch('fromDate', function () {
                $scope.model.MedicalCertificate.FromDate = $scope.fromDate.format();
                if ($scope.model.MedicalCertificate.FromDate > $scope.model.MedicalCertificate.ToDate) {
                    $scope.toDate = $scope.fromDate;
                }
            });
            $scope.$watch('toDate', function () {
                $scope.model.MedicalCertificate.ToDate = $scope.toDate.format();
            });
            this.initMedicalCertificate();
            this.init();
        }
        SicknoteController.prototype.init = function () {
            var diagnoses = this.$scope.model.EncounterLineItems.EncounterHeader.Diagnosis;
            var diagnosesSelected = this.$scope.model.MedicalCertificate.Diagnoses;
            var items = [];
            for (var i = 0; i < diagnoses.length; i++) {
                var turn = this.containsDiagnosis(diagnoses[i], diagnosesSelected);
                items[items.length] = new Item(diagnoses[i], turn);
            }
            this.$scope.items = items;
            var certificate = this.$scope.model.MedicalCertificate;
            if (certificate && certificate.FromDate && certificate.ToDate) {
                this.$scope.fromDate = this.moment.utc(certificate.FromDate);
                this.$scope.toDate = this.moment.utc(certificate.ToDate);
            }
            else {
                this.$scope.fromDate = this.moment.utc();
                this.$scope.toDate = this.moment.utc();
            }
        };
        SicknoteController.prototype.containsDiagnosis = function (obj, list) {
            for (var i = 0; i < list.length; i++) {
                if (list[i].DiagnosisCode == obj.DiagnosisCode) {
                    return true;
                }
            }
            return false;
        };
        SicknoteController.prototype.removeDiagnosis = function (list, item) {
            for (var i = 0; i < list.length; i++) {
                if (list[i].DiagnosisCode == item.DiagnosisCode) {
                    list.splice(i, 1);
                    return true;
                }
            }
            return false;
        };
        SicknoteController.prototype.initMedicalCertificate = function () {
            if (this.$scope.model.MedicalCertificate) {
                return;
            }
            var encounterObj = this.$scope.model;
            var medCer = new Domain.Clinical.MedicalCertificate();
            medCer.FromDate = this.moment().format();
            medCer.ToDate = this.moment().format();
            medCer.Diagnoses = encounterObj.EncounterLineItems.EncounterHeader.Diagnosis.slice();
            medCer.Patient = encounterObj.PatientEventDetails.Patient;
            medCer.Provider = encounterObj.Provider;
            medCer.CreatedDate = this.moment().format();
            medCer.ExaminationDate = this.encounterServiceNew.getConsultationDate().format();
            this.$scope.model.MedicalCertificate = medCer;
        };
        return SicknoteController;
    })();
    details.SicknoteController = SicknoteController;
})(details || (details = {}));
angular.module('DoctorApp')
    .controller('SicknoteDetailsController', details.SicknoteController);
/// <reference path="../../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../../screens/components/modal/modal-service.ts" />
/// <reference path="../../../services/dialog-service.ts" />
var ModalModule;
(function (ModalModule) {
    var SpecificRuleWarningController = (function () {
        SpecificRuleWarningController.$inject = ["$scope", "$modalInstance", "model"];
        function SpecificRuleWarningController($scope, $modalInstance, model) {
            "ngInject";
            $scope.labels = model && model.labels || ['Ok', 'Cancel'];
            $scope.ok = function () {
                $modalInstance.close($scope.model);
            };
            $scope.cancel = function () {
                $modalInstance.dismiss();
            };
            $scope.getPrice = function () {
                model.refreshPrice();
                $modalInstance.close();
            };
            $scope.model = model;
        }
        return SpecificRuleWarningController;
    })();
    ModalModule.SpecificRuleWarningController = SpecificRuleWarningController;
})(ModalModule || (ModalModule = {}));
angular.module('DoctorApp')
    .controller('SpecificRuleWarningController', ModalModule.SpecificRuleWarningController);
/// <reference path="../../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../../../scripts/definition/moment/moment-node.d.ts" />
/// <reference path="../encounter/encounter.ts" />
var SupportingModule;
(function (SupportingModule) {
    var SupportingProviderController = (function () {
        SupportingProviderController.$inject = ["model", "$scope", "$filter", "showDialog", "$modalInstance"];
        function SupportingProviderController(model, $scope, $filter, showDialog, $modalInstance) {
            "ngInject";
            this.$scope = $scope;
            this.$filter = $filter;
            this.showDialog = showDialog;
            this.$modalInstance = $modalInstance;
            $scope.model = model;
            $scope.providers = model.providers;
            $scope.provider = this.getProvider(model.providers, model.provider);
            $scope.done = function (item) {
                if (item && item.FriendlyName && item.TreatingPracticeNumber) {
                    item.IsNew = true;
                    $scope.selectProvider(item);
                }
                else {
                    showDialog.warning("Please provide correct doctor’s details");
                }
            };
            $scope.selectProvider = function (item) {
                $modalInstance.close(item);
            };
            $scope.cancel = function () {
                $modalInstance.dismiss();
            };
        }
        SupportingProviderController.prototype.getProvider = function (providers, provider) {
            if (!provider) {
                return null;
            }
            var supportingProvider = this.$filter("filter")(providers, {
                TreatingPracticeNumber: provider.TreatingPracticeNumber
            });
            if (supportingProvider && supportingProvider.length > 0) {
                return null;
            }
            return provider;
        };
        return SupportingProviderController;
    })();
    SupportingModule.SupportingProviderController = SupportingProviderController;
})(SupportingModule || (SupportingModule = {}));
angular.module('DoctorApp')
    .controller('SupportingProviderController', SupportingModule.SupportingProviderController);
var ModifierModule;
(function (ModifierModule) {
    var Checkbox = (function () {
        function Checkbox(value, ischecked) {
            this.isChecked = ischecked;
            this.value = value;
        }
        return Checkbox;
    })();
    ModifierModule.Checkbox = Checkbox;
    var ApplyModifierController = (function () {
        ApplyModifierController.$inject = ["$scope", "modalService", "$filter"];
        function ApplyModifierController($scope, modalService, $filter) {
            "ngInject";
            var _this = this;
            this.$scope = $scope;
            this.modalService = modalService;
            this.$filter = $filter;
            $scope.checkboxes = this.getCheckboxes();
            this.updateSelectionProcedures();
            $scope.select = function (value) {
                _this.updateSelectionProcedures();
            };
            $scope.setItemsState = function (state) {
                _this.$scope.checkboxes.forEach(function (c) { return c.isChecked = state; });
                _this.updateSelectionProcedures();
            };
        }
        ApplyModifierController.prototype.updateSelectionProcedures = function () {
            var active = this.$scope.checkboxes.filter(function (ch) { return ch.isChecked; });
            var lines = active.map(function (checkbox) { return checkbox.value; });
            this.$scope.onSelected(lines);
        };
        ApplyModifierController.prototype.getCheckboxes = function () {
            if (this.$scope.encounter) {
                var encounter = this.$scope.encounter;
                var procedures = this.$filter('filter')(encounter.EncounterLineItems.LineItems, { LineType: 'Procedure' });
                return procedures.map(function (procedure) { return new Checkbox(procedure, false); });
            }
        };
        ApplyModifierController.factory = function () {
            var instance = function () {
                var directive = {};
                directive.restrict = 'EA';
                directive.scope = {
                    encounter: '=',
                    onSelected: '=',
                    options: '='
                };
                directive.templateUrl = 'screens/consultation/modifiers/modal/dialog/apply-modifier.html';
                directive.controller = ApplyModifierController;
                return directive;
            };
            return instance;
        };
        return ApplyModifierController;
    })();
    ModifierModule.ApplyModifierController = ApplyModifierController;
})(ModifierModule || (ModifierModule = {}));
angular.module('DoctorApp')
    .directive('applyModifier', ModifierModule.ApplyModifierController.factory());
var ModifierModule;
(function (ModifierModule) {
    var AssistingController = (function () {
        AssistingController.$inject = ["$scope", "moment", "$filter", "modalService", "$routeParams"];
        function AssistingController($scope, moment, $filter, modalService, $routeParams) {
            "ngInject";
            var _this = this;
            this.$scope = $scope;
            this.moment = moment;
            this.$filter = $filter;
            this.modalService = modalService;
            this.$routeParams = $routeParams;
            $scope.AssistingDoctorName = $scope.encounter.AssistingDoctorName;
            $scope.AssistingDoctorPracticeNumber = $scope.encounter.AssistingDoctorPracticeNumber;
            $scope.assistingDoctor = $scope.assistingDoctor || new Domain.Billing.SupportingProviderVo();
            $scope.updateAssistingDoctor = function () {
                if ($scope.AssistingDoctorPracticeNumber && $scope.AssistingDoctorName) {
                    $scope.assistingDoctor.IsNew = true;
                    $scope.assistingDoctor.FriendlyName = $scope.AssistingDoctorName;
                    $scope.assistingDoctor.TreatingPracticeNumber = $scope.AssistingDoctorPracticeNumber;
                    $scope.encounter.AssistingDoctorName = $scope.AssistingDoctorName;
                    $scope.encounter.AssistingDoctorPracticeNumber = $scope.AssistingDoctorPracticeNumber;
                }
            };
            $scope.options.validate = function () {
                var validated = $scope.AssistingDoctorPracticeNumber &&
                    $scope.AssistingDoctorName;
                if (!validated) {
                    _this.modalService.error("Please enter valid info in fields");
                }
                return validated;
            };
        }
        AssistingController.factory = function () {
            var instance = function () {
                var directive = {};
                directive.restrict = 'EAC';
                directive.scope = {
                    modifier: '=',
                    encounter: '=',
                    assistingDoctor: '=',
                    options: "="
                };
                directive.templateUrl = 'screens/consultation/modifiers/modal/dialog/modifier-0009.html';
                directive.controller = AssistingController;
                return directive;
            };
            return instance;
        };
        return AssistingController;
    })();
    ModifierModule.AssistingController = AssistingController;
})(ModifierModule || (ModifierModule = {}));
angular.module('DoctorApp')
    .directive('modifier0009', ModifierModule.AssistingController.factory());
var ModifierModule;
(function (ModifierModule) {
    var BMIController = (function () {
        BMIController.$inject = ["$scope", "modalService"];
        function BMIController($scope, modalService) {
            "ngInject";
            this.$scope = $scope;
            this.modalService = modalService;
            $scope.modifier.Parameters = $scope.modifier.Parameters || { Length: "0", Weight: "0" };
            $scope.BMI = $scope.modifier.Parameters.Weight / Math.pow($scope.modifier.Parameters.Length, 2) || 0;
            $scope.openNumbersDialog = function (name) {
                modalService.openNumbers('decimal', 'Enter number', null, $scope.modifier.Parameters[name])
                    .then(function (value) {
                    if (value) {
                        $scope.modifier.Parameters[name] = value;
                        $scope.BMI = $scope.modifier.Parameters.Weight / Math.pow($scope.modifier.Parameters.Length, 2);
                    }
                });
            };
            $scope.options.validate = function () {
                return true;
            };
        }
        BMIController.factory = function () {
            var instance = function () {
                var directive = {};
                directive.restrict = 'EAC';
                directive.scope = {
                    modifier: '=',
                    options: "="
                };
                directive.templateUrl = 'screens/consultation/modifiers/modal/dialog/modifier-0018.html';
                directive.controller = BMIController;
                return directive;
            };
            return instance;
        };
        return BMIController;
    })();
    ModifierModule.BMIController = BMIController;
})(ModifierModule || (ModifierModule = {}));
angular.module('DoctorApp')
    .directive('modifier0018', ModifierModule.BMIController.factory());
var ModifierModule;
(function (ModifierModule) {
    var AnaestheticController = (function () {
        AnaestheticController.$inject = ["$scope", "moment", "$filter", "encounterServiceNew", "modalService", "$routeParams"];
        function AnaestheticController($scope, moment, $filter, encounterServiceNew, modalService, $routeParams) {
            "ngInject";
            var _this = this;
            this.$scope = $scope;
            this.moment = moment;
            this.$filter = $filter;
            this.encounterServiceNew = encounterServiceNew;
            this.modalService = modalService;
            this.$routeParams = $routeParams;
            $scope.units = 0;
            $scope.totalPrice = 0;
            $scope.modifier.DurationType = $scope.modifier.DurationType || 'Units';
            $scope.modifier.Parameters = $scope.modifier.Parameters || {};
            if ($scope.requiredParams) {
                $scope.requiredParams.forEach(function (param) {
                    if (param.FieldName === 'anaestheticRCF') {
                        $scope.modifier.Parameters.anaestheticRCF = 0;
                    }
                });
            }
            $scope.options.validate = function () {
                return true;
            };
            $scope.refreshDates = function (newDate, oldDate, isStart) {
                var date = _this.moment.utc(newDate).format('YYYY-MM-DD[T]HH:mm:ss[Z]');
                if (isStart) {
                    _this.$scope.modifier.ChargeStart = date;
                }
                else {
                    _this.$scope.modifier.ChargeEnd = date;
                }
                _this.$scope.refreshMinutes();
            };
            $scope.refreshMinutes = function () {
                var minutes = _this.moment($scope.endDate).diff(_this.moment($scope.startDate), "minutes");
                $scope.minutes = minutes > 0 ? minutes : 0;
            };
            $scope.initDates = function () {
                var consultationDate = _this.encounterServiceNew.getEncounter().EncounterLineItems.EncounterHeader.DateOfService;
                var chargeStart = _this.moment.utc(_this.$scope.modifier.ChargeStart || consultationDate, ServerDateFormat).local();
                var chargeEnd = _this.moment.utc(_this.$scope.modifier.ChargeEnd || consultationDate, ServerDateFormat).local();
                _this.$scope.startDate = chargeStart;
                _this.$scope.endDate = chargeEnd;
                _this.$scope.refreshMinutes();
            };
            $scope.initDates();
        }
        AnaestheticController.factory = function () {
            var instance = function () {
                var directive = {};
                directive.restrict = 'EAC';
                directive.scope = {
                    modifier: '=',
                    requiredParams: '=',
                    options: "="
                };
                directive.templateUrl = 'screens/consultation/modifiers/modal/dialog/modifier-0036.html';
                directive.controller = AnaestheticController;
                return directive;
            };
            return instance;
        };
        return AnaestheticController;
    })();
    ModifierModule.AnaestheticController = AnaestheticController;
})(ModifierModule || (ModifierModule = {}));
angular.module('DoctorApp')
    .directive('modifier0036', ModifierModule.AnaestheticController.factory());
var ModifierModule;
(function (ModifierModule) {
    var Model = (function () {
        function Model() {
        }
        return Model;
    })();
    ModifierModule.Model = Model;
    var ModifierController = (function () {
        ModifierController.$inject = ["$scope", "$modalInstance", "clinicalDomain", "searchService", "modalService", "$routeParams", "model"];
        function ModifierController($scope, $modalInstance, clinicalDomain, searchService, modalService, $routeParams, model) {
            "ngInject";
            var _this = this;
            this.$scope = $scope;
            this.$modalInstance = $modalInstance;
            this.clinicalDomain = clinicalDomain;
            this.searchService = searchService;
            this.modalService = modalService;
            this.$routeParams = $routeParams;
            this.model = model;
            $scope.editOptions = {
                validate: null,
                editMode: false
            };
            $scope.pages = this.resetPages();
            $scope.pageNum = 1;
            $scope.page = ModifierController.SEARCH_PAGE;
            $scope.modifier = model.modifier;
            $scope.searchText = '';
            $scope.editOptions.editMode = model.modifier !== null;
            if ($scope.editOptions.editMode) {
                $scope.page = ModifierController.EDIT_PAGE;
                $scope.currentModifier = $scope.modifier;
                $scope.pages = this.removePage($scope.pages, ModifierController.SEARCH_PAGE);
                $scope.pages = this.removePage($scope.pages, ModifierController.APPLY_PAGE);
            }
            this.changePage($scope.pageNum);
            $scope.model = model;
            $scope.selectModifier = function (modifier, searchtext) {
                $scope.currentModifier = modifier;
                $scope.searchText = searchtext;
                if (model.noEdit) {
                    $scope.pages = _this.removePage($scope.pages, ModifierController.EDIT_PAGE);
                    var lineItems = model.encounter.EncounterLineItems.LineItems;
                    var noProcedures = !lineItems.length || !lineItems.filter(function (item) { return item.LineType === 'Procedure'; }).length;
                    if (noProcedures) {
                        $scope.pages = _this.removePage($scope.pages, ModifierController.APPLY_PAGE);
                    }
                    $scope.next();
                }
                else {
                    clinicalDomain.getModifierInfo($routeParams.practiceId, modifier.ChargeCode)
                        .then(function (modifierInfo) {
                        var requiredParams = modifierInfo.RequiredParameters;
                        $scope.requiredParams = requiredParams;
                        if ((modifierInfo.ImplementationStatus === "Calculated" || modifierInfo.ImplementationStatus === "Parameters") &&
                            requiredParams.length === 0) {
                            $scope.pages = _this.removePage($scope.pages, ModifierController.EDIT_PAGE);
                        }
                        $scope.next();
                    }, function (reason) {
                        $scope.next();
                    });
                }
            };
            $scope.onSelectedProceduresDone = function (procedures) {
                $scope.selectedProcedures = procedures;
            };
            $scope.prev = function () {
                if ($scope.pageNum > 1) {
                    $scope.pageNum--;
                    if ($scope.pageNum === 1) {
                        $scope.editOptions.validate = null;
                    }
                    _this.changePage($scope.pageNum);
                }
            };
            $scope.next = function () {
                if ($scope.pageNum < $scope.pages.length) {
                    if (_this.$scope.pages[$scope.pageNum] === ModifierController.APPLY_PAGE &&
                        $scope.editOptions.validate &&
                        !$scope.editOptions.validate()) {
                        return;
                    }
                    $scope.pageNum++;
                    _this.changePage($scope.pageNum);
                }
                else if ($scope.pageNum === $scope.pages.length) {
                    if ($scope.editOptions.validate && !$scope.editOptions.validate()) {
                        return;
                    }
                    if (!$scope.model.modifier) {
                        var originalLineItems = $scope.model.encounter.EncounterLineItems.LineItems;
                        var hasApplyScreen = $scope.pages.some(function (page) { return page === ModifierController.APPLY_PAGE; });
                        if (!hasApplyScreen) {
                            originalLineItems.push($scope.currentModifier);
                        }
                        else {
                            if (!$scope.selectedProcedures.length) {
                                _this.modalService
                                    .confirm("You have not selected any procedure lines, would you like to add the modifier to the end?")
                                    .then(function (dr) {
                                    var procedures = originalLineItems.filter(function (i) { return i.LineType === 'Procedure'; });
                                    $scope.selectedProcedures.push(procedures[procedures.length - 1]);
                                    _this.applyModifiersToSelectedProcedures();
                                    $modalInstance.close($scope.currentModifier);
                                });
                                return;
                            }
                            else {
                                _this.applyModifiersToSelectedProcedures();
                            }
                        }
                    }
                    $modalInstance.close($scope.currentModifier);
                }
            };
            $scope.cancel = function () {
                $modalInstance.dismiss();
            };
        }
        ModifierController.prototype.applyModifiersToSelectedProcedures = function () {
            var originalLineItems = this.$scope.model.encounter.EncounterLineItems.LineItems;
            for (var _i = 0, _a = this.$scope.selectedProcedures; _i < _a.length; _i++) {
                var item = _a[_i];
                var indexForInsert = originalLineItems.indexOf(item) +
                    this.getModifieresCountAfterProcedures(originalLineItems, item) + 1;
                originalLineItems.splice(indexForInsert, 0, this.$scope.currentModifier);
            }
        };
        ModifierController.prototype.getModifieresCountAfterProcedures = function (lines, procedure) {
            var count = 0;
            for (var i = lines.indexOf(procedure) + 1; i < lines.length; i++) {
                if (lines[i].LineType === "Modifier") {
                    count++;
                }
                else {
                    return count;
                }
            }
            return count;
        };
        ModifierController.prototype.changePage = function (currentPageNumb) {
            var currentPage = this.$scope.pages[currentPageNumb - 1];
            if (currentPage === 'search') {
                this.$scope.pages = this.resetPages();
            }
            if (currentPage === 'edit') {
                var modifier = this.$scope.currentModifier;
                this.$scope.modifierDirective = this.getModifierByChargeCode(modifier.ChargeCode);
            }
            this.$scope.page = currentPage;
        };
        ModifierController.prototype.resetPages = function () {
            return [
                'search',
                'edit',
                'apply'
            ];
        };
        ModifierController.prototype.removePage = function (pages, pageName) {
            return pages.filter(function (page) { return page !== pageName; });
        };
        ModifierController.prototype.getModifierByChargeCode = function (chargeCode) {
            if (chargeCode === '0036' || chargeCode === '0039') {
                return 'modifier0036';
            }
            if (chargeCode === '0009' || chargeCode === '0018') {
                return 'modifier' + chargeCode;
            }
            return 'modifierOthers';
        };
        ModifierController.SEARCH_PAGE = 'search';
        ModifierController.EDIT_PAGE = 'edit';
        ModifierController.APPLY_PAGE = 'apply';
        return ModifierController;
    })();
    ModifierModule.ModifierController = ModifierController;
})(ModifierModule || (ModifierModule = {}));
angular.module('DoctorApp')
    .controller('ModifierController', ModifierModule.ModifierController);
var ModifierModule;
(function (ModifierModule) {
    var OthersController = (function () {
        OthersController.$inject = ["$scope", "moment", "$filter", "providerService", "modalService", "encounterServiceNew", "$routeParams"];
        function OthersController($scope, moment, $filter, providerService, modalService, encounterServiceNew, $routeParams) {
            "ngInject";
            var _this = this;
            this.$scope = $scope;
            this.moment = moment;
            this.$filter = $filter;
            this.providerService = providerService;
            this.modalService = modalService;
            this.encounterServiceNew = encounterServiceNew;
            this.$routeParams = $routeParams;
            $scope.modifier.Parameters = $scope.modifier.Parameters || { UnitType: 'Units', Units: 1 };
            $scope.modifier.DurationType = $scope.modifier.DurationType || 'Units';
            $scope.unitTypes = [
                { name: "Units" },
                { name: "Days" },
                { name: "Hours" },
                { name: "Kilometres" },
                { name: "Minutes" },
                { name: "Seconds" }
            ].filter(function (unitType) { return $scope.modifier.ChargeCode === "0013" || unitType.name !== "Kilometres"; });
            $scope.openUnitsDialog = function () {
                modalService.openNumbers('int', 'Enter units', null, null, false)
                    .then(function (units) {
                    if (units && units > 0 && units < 10000) {
                        $scope.modifier.Parameters.Units = units;
                    }
                });
            };
            $scope.openQuantityDialog = function () {
                modalService.openNumbers('int', 'Enter quantity')
                    .then(function (quantity) {
                    if (quantity) {
                        $scope.modifier.ChargeQuan = quantity;
                    }
                });
            };
            $scope.openPriceDialog = function () {
                modalService.openNumbers('decimal', 'Enter price', null, null, true)
                    .then(function (price) {
                    if (price) {
                        $scope.modifier.PriceOverride = true;
                        $scope.modifier.Amount = price;
                        $scope.modifier.TotalIncVat = price;
                    }
                });
            };
            $scope.options.validate = function () {
                if (!$scope.modifier.Parameters.Units ||
                    $scope.modifier.Parameters.Units < 1 ||
                    $scope.modifier.Parameters.Units > 10000) {
                    return false;
                }
                if ($scope.requiredParams && $scope.requiredParams.length) {
                    var validated = false;
                    $scope.requiredParams.forEach(function (param) {
                        Object.getOwnPropertyNames($scope.modifier).forEach(function (key) {
                            if (param.Required && key.toLowerCase() === param.FieldName.toLowerCase() && $scope.modifier[key]) {
                                validated = true;
                            }
                        });
                        Object.getOwnPropertyNames($scope.modifier.Parameters).forEach(function (key) {
                            if (param.Required && key.toLowerCase() === param.FieldName.toLowerCase() && $scope.modifier.Parameters[key]) {
                                validated = true;
                            }
                        });
                    });
                    if (!validated) {
                        _this.modalService.error("Please enter valid info in fields");
                        return false;
                    }
                }
                return true;
            };
            this.providerService.getProviderOptions(this.$routeParams.practiceId)
                .then(function (options) {
                $scope.isShowPrice = options.isEnabledForDisplayingPrices;
            });
            $scope.refreshDates = function (newDate, oldDate, isStart) {
                var date = _this.moment.utc(newDate).format('YYYY-MM-DD[T]HH:mm:ss[Z]');
                if (isStart) {
                    _this.$scope.modifier.ChargeStart = date;
                }
                else {
                    _this.$scope.modifier.ChargeEnd = date;
                }
                _this.$scope.refreshMinutes();
            };
            $scope.refreshMinutes = function () {
                var minutes = _this.moment($scope.endDate).diff(_this.moment($scope.startDate), "minutes");
                $scope.minutes = minutes > 0 ? minutes : 0;
            };
            $scope.initDates = function () {
                var consultationDate = _this.encounterServiceNew.getEncounter().EncounterLineItems.EncounterHeader.DateOfService;
                var chargeStart = _this.moment.utc(_this.$scope.modifier.ChargeStart || consultationDate, ServerDateFormat).local();
                var chargeEnd = _this.moment.utc(_this.$scope.modifier.ChargeEnd || consultationDate, ServerDateFormat).local();
                _this.$scope.startDate = chargeStart;
                _this.$scope.endDate = chargeEnd;
                _this.$scope.refreshMinutes();
            };
            $scope.initDates();
        }
        OthersController.factory = function () {
            var instance = function () {
                var directive = {};
                directive.restrict = 'EA';
                directive.scope = {
                    modifier: '=',
                    requiredParams: '=',
                    options: "="
                };
                directive.templateUrl = 'screens/consultation/modifiers/modal/dialog/modifier-others.html';
                directive.controller = OthersController;
                return directive;
            };
            return instance;
        };
        return OthersController;
    })();
    ModifierModule.OthersController = OthersController;
})(ModifierModule || (ModifierModule = {}));
angular.module('DoctorApp')
    .directive('modifierOthers', ModifierModule.OthersController.factory());
var ModifierModule;
(function (ModifierModule) {
    var SearchModifierController = (function () {
        SearchModifierController.$inject = ["$scope", "searchService", "$routeParams"];
        function SearchModifierController($scope, searchService, $routeParams) {
            "ngInject";
            var _this = this;
            this.$scope = $scope;
            this.searchService = searchService;
            this.$routeParams = $routeParams;
            $scope.search = function (searchText) {
                return searchService.getClinicalModifier($routeParams.practiceId, $scope.encounterId, searchText)
                    .then(function (modifiers) {
                    $scope.config.caption = searchText;
                    $scope.list = _this.customizeList(modifiers);
                });
            };
            $scope.selectModifier = function (modifier) {
                $scope.onSelect(modifier, $scope.config.searchText);
            };
            $scope.config = {
                searchText: $scope.searchtext,
                notClearField: true,
                lineClick: true,
                caption: $scope.searchtext,
                minLength: 3,
                title: [
                    { columnName: 'Charge code', style: { width: 115 + 'px' }, hstyle: { width: 115 + 'px' } },
                    { columnName: 'Description', style: {}, hstyle: {} }
                ],
                placeholder: { value: 'Please type in a modifier description or charge code' }
            };
        }
        SearchModifierController.prototype.customizeList = function (list) {
            var clist = [];
            var fields = ['ChargeCode', 'ChargeDesc'];
            for (var _i = 0; _i < list.length; _i++) {
                var listItem = list[_i];
                var item = {
                    fields: [],
                    object: listItem
                };
                for (var _a = 0; _a < fields.length; _a++) {
                    var field = fields[_a];
                    item.fields.push({
                        value: (function () {
                            if (listItem[field].length > 200) {
                                return listItem[field].slice(0, 200).concat('...');
                            }
                            return listItem[field];
                        })()
                    });
                }
                clist.push(item);
            }
            return clist;
        };
        SearchModifierController.factory = function () {
            var instance = function () {
                var directive = {};
                directive.restrict = 'EA';
                directive.scope = {
                    onSelect: '=',
                    searchtext: '=',
                    encounterId: '='
                };
                directive.templateUrl = 'screens/consultation/modifiers/modal/dialog/search-modifier.html';
                directive.controller = SearchModifierController;
                return directive;
            };
            return instance;
        };
        return SearchModifierController;
    })();
    ModifierModule.SearchModifierController = SearchModifierController;
})(ModifierModule || (ModifierModule = {}));
angular.module('DoctorApp')
    .directive('searchModifier', ModifierModule.SearchModifierController.factory());
var ConsultationReportModule;
(function (ConsultationReportModule) {
    var ControllerAbstract = (function () {
        ControllerAbstract.$inject = ["$scope", "$timeout", "$routeParams", "consultationReportService"];
        function ControllerAbstract($scope, $timeout, $routeParams, consultationReportService) {
            "ngInject";
            var _this = this;
            this.$scope = $scope;
            this.$timeout = $timeout;
            this.$routeParams = $routeParams;
            this.consultationReportService = consultationReportService;
            $scope.next = function () {
                _this.consultationReportService.changeScreen($routeParams.practiceId, $routeParams.patientId, ConsultationReportModule.Service.NEXT, _this.reportType);
            };
            $scope.back = function () {
                _this.consultationReportService.changeScreen($routeParams.practiceId, $routeParams.patientId, ConsultationReportModule.Service.PREW, _this.reportType);
            };
            $scope.sendEmail = function (title) {
                if (title === void 0) { title = ""; }
                var attachment = {
                    Title: title,
                    Type: _this.consultationReportService.getReportStringType(_this.reportType),
                    HtmlBody: $scope.reportHtml
                };
                _this.consultationReportService.sendReportByEmail($routeParams.practiceId, $routeParams.patientId, [attachment]);
            };
            $scope.print = function () {
                var mywindow = window.open('', 'my div', 'height=500,width=750');
                mywindow.document.open();
                mywindow.document.write($scope.reportHtml);
                _this.$timeout(function () {
                    mywindow.document.close();
                    mywindow.focus();
                    mywindow.print();
                    mywindow.close();
                }, 200);
            };
            $scope.save = function () {
                _this.consultationReportService.openPdf($routeParams.practiceId, $scope.reportHtml);
            };
        }
        ControllerAbstract.prototype.init = function () {
            var _this = this;
            this.$scope.isNext = this.consultationReportService.isNext(this.reportType);
            return this.consultationReportService.getReportBody(this.reportType, this.$routeParams.practiceId)
                .then(function (reportHtml) {
                _this.$scope.reportHtml = reportHtml || "";
                return _this.$scope.reportHtml;
            })
                .catch(function (result) {
                _this.$scope.reportHtml = "";
                return result;
            });
        };
        ControllerAbstract.prototype.injectHtmlIntoReport = function (html) {
            var _this = this;
            var template = '<iframe id="report-frame" scrolling="no"></iframe>';
            this.$timeout(function () {
                var container = angular.element(document).find("#report-container");
                container.append(template);
                _this.$timeout(function () {
                    var reportIframe = angular.element(document).find("#report-frame");
                    if (html.indexOf('<head>') > -1) {
                        reportIframe.contents()
                            .find('head')
                            .append(html.slice(html.indexOf('<head>') + 6, html.indexOf('</head>')));
                    }
                    if (html.indexOf('<body>') > -1) {
                        reportIframe.contents()
                            .find('body')
                            .append(html.slice(html.indexOf('<body>') + 6, html.indexOf('</body>')));
                    }
                    else {
                        reportIframe.contents()
                            .find('body')
                            .append(html);
                    }
                    var contentHeight = reportIframe.contents().find('body').height();
                    var reportPadding = 20;
                    reportIframe.height(contentHeight + reportPadding + 'px');
                });
            });
        };
        return ControllerAbstract;
    })();
    ConsultationReportModule.ControllerAbstract = ControllerAbstract;
})(ConsultationReportModule || (ConsultationReportModule = {}));
angular.module("DoctorApp")
    .controller("ConsultationReportController", ConsultationReportModule.ControllerAbstract);
/// <reference path="../../../../scripts/definition/angularjs/angular.d.ts" />
var ConsultationReportModule;
(function (ConsultationReportModule) {
    var PrescriptionController = (function (_super) {
        __extends(PrescriptionController, _super);
        PrescriptionController.$inject = ["$scope", "$timeout", "$routeParams", "consultationReportService", "$controller"];
        function PrescriptionController($scope, $timeout, $routeParams, consultationReportService, $controller) {
            "ngInject";
            var _this = this;
            this.$scope = $scope;
            this.$timeout = $timeout;
            this.$routeParams = $routeParams;
            this.consultationReportService = consultationReportService;
            this.$controller = $controller;
            _super.call(this, $scope, $timeout, $routeParams, consultationReportService);
            var parent = $controller('ConsultationReportController', { $scope: $scope });
            angular.extend(this, parent);
            $scope.title = "Prescription letter";
            this.reportType = parent.reportType = EncounterModule.ReportType.Prescription;
            this.init()
                .then(function (reportHtml) {
                _this.injectHtmlIntoReport(reportHtml);
            });
        }
        return PrescriptionController;
    })(ConsultationReportModule.ControllerAbstract);
    ConsultationReportModule.PrescriptionController = PrescriptionController;
})(ConsultationReportModule || (ConsultationReportModule = {}));
angular.module('DoctorApp')
    .controller('ConsultationPrescriptionController', ConsultationReportModule.PrescriptionController);
/// <reference path="../encounter/encounter-service.ts"/>
/// <reference path="../../../../scripts/definition/angularjs/angular.d.ts" />
var ConsultationReportModule;
(function (ConsultationReportModule) {
    var SiknoteController = (function (_super) {
        __extends(SiknoteController, _super);
        SiknoteController.$inject = ["$scope", "$timeout", "$routeParams", "consultationReportService", "$controller"];
        function SiknoteController($scope, $timeout, $routeParams, consultationReportService, $controller) {
            "ngInject";
            var _this = this;
            this.$scope = $scope;
            this.$timeout = $timeout;
            this.$routeParams = $routeParams;
            this.consultationReportService = consultationReportService;
            this.$controller = $controller;
            _super.call(this, $scope, $timeout, $routeParams, consultationReportService);
            var parent = $controller('ConsultationReportController', { $scope: $scope });
            angular.extend(this, parent);
            this.reportType = parent.reportType = EncounterModule.ReportType.MedicalCertificate;
            var reportHeader = "";
            $scope.title = "Medical certificate letter";
            $scope.editHtml = "";
            $scope.tinymceOptions = {
                selector: 'textarea',
                plugins: 'link table preview',
                toolbar: 'undo redo | bold italic | fontsizeselect | bullist numlist outdent indent | alignleft aligncenter alignright | file',
                fontsize_formats: '8pt 10pt 12pt 14pt 18pt 24pt 36pt',
                skin_url: GlobalVar.isProd ? 'styles/tinymce/skins/lightgray' : '',
                visual: false,
                browser_spellcheck: true,
                contextmenu: false,
                statusbar: false,
                valid_children: "+body,+head",
                extended_valid_elements: 'body,head',
                init_instance_callback: function (editor) {
                    _this.editorInst = editor;
                    var interval;
                    editor.on('change', function () {
                        if (interval) {
                            $timeout.cancel(interval);
                        }
                        interval = $timeout(function () {
                            $scope.reportHtml = parent.reportHtml = "<head>" + reportHeader + "</head>" + "<body>" + editor.getContent() + "</body>";
                        }, 100);
                    });
                    _this.configEditor();
                }
            };
            this.init()
                .then(function (reportHtml) {
                if (reportHtml) {
                    reportHeader = reportHtml.slice(reportHtml.indexOf('<head>') + 6, reportHtml.indexOf('</head>'));
                    _this.$scope.editHtml = reportHtml;
                    _this.configEditor();
                }
            });
        }
        SiknoteController.prototype.configEditor = function () {
            var _this = this;
            this.$timeout(function () {
                if (_this.editorInst) {
                    var contentWraper = $(_this.editorInst.contentAreaContainer);
                    var content = $(_this.editorInst.iframeElement);
                    var height = content.contents().find('body').height();
                    var padding = 100;
                    content.height(height + padding + 'px');
                    contentWraper.css('overflow', 'auto');
                }
            }, 100);
        };
        return SiknoteController;
    })(ConsultationReportModule.ControllerAbstract);
    ConsultationReportModule.SiknoteController = SiknoteController;
})(ConsultationReportModule || (ConsultationReportModule = {}));
angular.module('DoctorApp')
    .controller('ConsultationSiknoteController', ConsultationReportModule.SiknoteController);
var FailedInvoices;
(function (FailedInvoices) {
    var FailedInvoicesController = (function () {
        FailedInvoicesController.$inject = ["$scope", "httpService", "billingDomain", "modalService", "locationService", "$routeParams"];
        function FailedInvoicesController($scope, httpService, billingDomain, modalService, locationService, $routeParams) {
            "ngInject";
            var _this = this;
            this.$scope = $scope;
            this.httpService = httpService;
            this.billingDomain = billingDomain;
            this.modalService = modalService;
            this.locationService = locationService;
            this.$routeParams = $routeParams;
            $scope.list = [];
            $scope.send = function (invoice) {
                _this.billingDomain.sendInvoiceManually(invoice.PracticeId, invoice.InvoiceId, null)
                    .then(function () {
                    $scope.init();
                });
            };
            $scope.retryAllAutomatic = function () {
                for (var _i = 0, _a = _this.$scope.list; _i < _a.length; _i++) {
                    var invoice = _a[_i];
                    if (invoice.SendingType == "automatic") {
                        _this.$scope.retry(invoice);
                    }
                }
            };
            $scope.retry = function (invoice) {
                _this.billingDomain.retrySendingInvoice(invoice.PracticeId, invoice.InvoiceId, invoice.Reason)
                    .then(function (response) {
                    if (!response.Sucess) {
                        modalService.error(response.ResponseMessage);
                    }
                });
            };
            $scope.abort = function (invoice) {
                modalService.confirm("Are you sure want to abort sending invoice")
                    .then(function () {
                    return _this.billingDomain.abortSendingInvoice(invoice.PracticeId, invoice.InvoiceId, null);
                })
                    .then(function (response) {
                    if (!response.Sucess) {
                        modalService.error(response.ResponseMessage);
                    }
                    else {
                        $scope.init();
                    }
                });
            };
            $scope.openFullText = function (reason) {
                if (reason.length > 34) {
                    modalService.info(reason, ModalModule.ModalWidth._550px);
                }
            };
            $scope.openInvoice = function (item) {
                _this.locationService.goToAuditEvents("BIL:INV:" + item.PracticeId, item.InvoiceId);
            };
            $scope.init = function () {
                _this.billingDomain.getFailedInvoices()
                    .then(function (list) {
                    $scope.list = list;
                });
            };
            $scope.init();
        }
        return FailedInvoicesController;
    })();
    FailedInvoices.FailedInvoicesController = FailedInvoicesController;
})(FailedInvoices || (FailedInvoices = {}));
angular.module('DoctorApp')
    .controller('FailedInvoicesController', FailedInvoices.FailedInvoicesController);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../services/show-dialog.ts" />
/// <reference path="../../run.ts" />
var HealthDocModule;
(function (HealthDocModule) {
    var Controller = (function () {
        Controller.$inject = ["$sce", "$scope", "$rootScope", "$routeParams", "$log", "providerService", "authService", "httpService", "showDialog", "usageService", "dashboardService", "storageService"];
        function Controller($sce, $scope, $rootScope, $routeParams, $log, providerService, authService, httpService, showDialog, usageService, dashboardService, storageService) {
            "ngInject";
            this.$sce = $sce;
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.$routeParams = $routeParams;
            this.$log = $log;
            this.providerService = providerService;
            this.authService = authService;
            this.httpService = httpService;
            this.showDialog = showDialog;
            this.usageService = usageService;
            this.dashboardService = dashboardService;
            this.storageService = storageService;
            $scope.isNoFile = false;
            $scope.title = "Health Doc";
            $scope.historyIndex = window.history.length;
            $scope.back = function () {
                var newPosition = window.history.length;
                window.history.go(-(newPosition - $scope.historyIndex + 1));
            };
            var param = storageService.getParam("HealthDoc");
            $scope.link = (param) ? this.$sce.trustAsResourceUrl(param.Description) : "";
            usageService.openHealthDocs($routeParams.practiceId, $routeParams.patientId);
        }
        return Controller;
    })();
    HealthDocModule.Controller = Controller;
})(HealthDocModule || (HealthDocModule = {}));
angular.module('DoctorApp')
    .controller('HealthDocController', HealthDocModule.Controller);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../services/show-dialog.ts" />
/// <reference path="../../run.ts" />
var HealthDocModule;
(function (HealthDocModule) {
    var PatientFileController = (function () {
        PatientFileController.$inject = ["$sce", "$scope", "$rootScope", "$routeParams", "$log", "providerService", "authService", "$timeout", "httpService", "showDialog", "usageService", "dashboardService", "storageService"];
        function PatientFileController($sce, $scope, $rootScope, $routeParams, $log, providerService, authService, $timeout, httpService, showDialog, usageService, dashboardService, storageService) {
            "ngInject";
            var _this = this;
            this.$sce = $sce;
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.$routeParams = $routeParams;
            this.$log = $log;
            this.providerService = providerService;
            this.authService = authService;
            this.$timeout = $timeout;
            this.httpService = httpService;
            this.showDialog = showDialog;
            this.usageService = usageService;
            this.dashboardService = dashboardService;
            this.storageService = storageService;
            var startWidth = 0;
            $scope.zoom = 100;
            $scope.isFit = false;
            $scope.enableZooming = false;
            $scope.isNoFile = false;
            $scope.title = "myPatientFiles";
            $scope.historyIndex = window.history.length;
            $scope.back = function () {
                var newPosition = window.history.length;
                window.history.go(-(newPosition - $scope.historyIndex + 1));
            };
            $scope.zoomIn = function () {
                if ($scope.enableZooming) {
                    var img = $('#iframe-container').contents().find('img');
                    var currentWidth = img.width();
                    $scope.isFit = false;
                    img.width(currentWidth + currentWidth / 4);
                    var zoom = img.width() / startWidth;
                    $scope.zoom = Math.round((zoom > 2 ? 2 : zoom) * 100);
                }
            };
            $scope.zoomOut = function () {
                if ($scope.enableZooming) {
                    var img = $('#iframe-container').contents().find('img');
                    var currentWidth = img.width();
                    img.width(currentWidth - currentWidth / 4);
                    $scope.isFit = false;
                    var zoom = img.width() / startWidth;
                    $scope.zoom = Math.round((zoom < 0.1 ? 0.1 : zoom) * 100);
                }
            };
            $scope.fit = function () {
                if ($scope.enableZooming) {
                    var img = $('#iframe-container').contents().find('img');
                    img.width('100%');
                    $scope.isFit = true;
                    var zoom = img.width() / startWidth;
                    $scope.zoom = Math.round(zoom * 100);
                }
            };
            $scope.realSize = function () {
                if ($scope.enableZooming) {
                    var img = $('#iframe-container').contents().find('img');
                    $scope.isFit = false;
                    img.width(startWidth);
                    var zoom = img.width() / startWidth;
                    $scope.zoom = Math.round((zoom < 0.1 ? 0.1 : zoom) * 100);
                }
            };
            this.dashboardService.getDocumentInfoById($routeParams.practiceId, $routeParams.documentId)
                .then(function (documentInfo) {
                var documentUrl = _this.dashboardService.getDocumentUrl($routeParams.practiceId, documentInfo.DocumentUrl);
                $scope.link = _this.$sce.trustAsResourceUrl(documentUrl);
                var isImg = documentUrl.search(/.(jpg|png|jpeg|JPEG|JPG|PNG)/) > -1;
                if (isImg) {
                    $timeout(function () {
                        var body = $('#iframe-container').contents().find('body');
                        body.css('text-align', 'center');
                        startWidth = body.find("img").width();
                        body.find("img").css('height', 'auto');
                        $scope.isFit = false;
                        $scope.zoom = 100;
                        $scope.enableZooming = true;
                    }, 1000);
                }
            });
        }
        return PatientFileController;
    })();
    HealthDocModule.PatientFileController = PatientFileController;
})(HealthDocModule || (HealthDocModule = {}));
angular.module('DoctorApp')
    .controller('PatientFileController', HealthDocModule.PatientFileController);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../services/show-dialog.ts" />
/// <reference path="../../run.ts" />
var HealthIdModule;
(function (HealthIdModule) {
    var Controller = (function () {
        Controller.$inject = ["$sce", "$scope", "$rootScope", "$routeParams", "$log", "providerService", "authService", "httpService", "usageService", "showDialog"];
        function Controller($sce, $scope, $rootScope, $routeParams, $log, providerService, authService, httpService, usageService, showDialog) {
            "ngInject";
            this.$sce = $sce;
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.$routeParams = $routeParams;
            this.$log = $log;
            this.providerService = providerService;
            this.authService = authService;
            this.httpService = httpService;
            this.usageService = usageService;
            this.showDialog = showDialog;
            var patientId = $routeParams.patientId;
            $scope.historyIndex = window.history.length;
            $scope.back = function () {
                var newPosition = window.history.length;
                window.history.go(-(newPosition - $scope.historyIndex + 1));
            };
            this.openHealthIdForPatient($routeParams.practiceId, patientId);
            usageService.openHealthID($routeParams.practiceId, $routeParams.patientId);
        }
        Controller.prototype.openHealthIdForPatient = function (practiceId, patientId) {
            var _this = this;
            this.providerService.getProviderOptions(practiceId)
                .then(function (options) {
                var healthIdProviderCredentials = options.healthIDProviderCredentials;
                if (healthIdProviderCredentials) {
                    _this.httpService.get("v1/" +
                        practiceId +
                        "/healthid/patient/" +
                        patientId)
                        .then(function (response) {
                        _this.$scope.link = _this.$sce.trustAsResourceUrl(response.link);
                        if (!response.token) {
                            _this.showDialog.error(response.message);
                        }
                    });
                }
            });
        };
        return Controller;
    })();
    HealthIdModule.Controller = Controller;
})(HealthIdModule || (HealthIdModule = {}));
angular.module('DoctorApp')
    .controller('HealthIDController', HealthIdModule.Controller);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../services/api/domain/patient.ts" />
/// <reference path="../../screens/patient/patient-service.ts" />
/// <reference path="../../services/memory-service.ts" />
var home;
(function (home) {
    var Service = (function () {
        Service.$inject = ["patientDomain", "$q", "storageService", "$rootScope", "$timeout", "$http", "memoryService", "providerService", "locationService", "clinicalDomain", "encounterServiceNew"];
        function Service(patientDomain, $q, storageService, $rootScope, $timeout, $http, memoryService, providerService, locationService, clinicalDomain, encounterServiceNew) {
            "ngInject";
            var _this = this;
            this.patientDomain = patientDomain;
            this.$q = $q;
            this.storageService = storageService;
            this.$rootScope = $rootScope;
            this.$timeout = $timeout;
            this.$http = $http;
            this.memoryService = memoryService;
            this.providerService = providerService;
            this.locationService = locationService;
            this.clinicalDomain = clinicalDomain;
            this.encounterServiceNew = encounterServiceNew;
            $rootScope.$on('WaitingRoomUpdated', function () {
                var practiceId = _this.storageService.getPracticeId();
                _this.getCheckInPatients(practiceId);
            });
        }
        Service.prototype.getPatients = function (practiceId, patientName) {
            this.memoryService.home.searchText = patientName;
            return this.patientDomain.getPatientsByName(practiceId, patientName);
        };
        Service.prototype.getPatientsFromNationalDb = function (practiceId, patientName) {
            return this.patientDomain.getMasterPatientsByName(practiceId, patientName);
        };
        Service.prototype.checkInPatientVisit = function (practiceId, patient) {
            return this.patientDomain.checkPatientVisit(practiceId, patient);
        };
        Service.prototype.addToWaitingRoom = function (practiceId, patientId) {
            return this.patientDomain.addToWaitingRoom(practiceId, patientId);
        };
        Service.prototype.getCheckInPatients = function (practiceId) {
            var _this = this;
            return this.patientDomain.getWaitingRoomPatients(practiceId)
                .then(function (response) {
                if (response) {
                    _this.checkedInPatients = response;
                    _this.$rootScope.$emit('CheckedInPatientsUpdated', response);
                }
                return response;
            });
        };
        Service.prototype.getCachedCheckInPatients = function (practiceId) {
            if (!this.checkedInPatients) {
                return this.getCheckInPatients(practiceId);
            }
            else {
                var d = this.$q.defer();
                d.resolve(this.checkedInPatients);
                return d.promise;
            }
        };
        Service.prototype.importPatientAndCheckIn = function (practiceId, patient) {
            return this.patientDomain.importPatientAndCheckIn(practiceId, patient);
        };
        Service.prototype.removePatient = function (practiceId, patientId) {
            return this.patientDomain.removePatient(practiceId, patientId);
        };
        Service.prototype.getPatientById = function (practiceId, patientId) {
            return this.patientDomain.getPatientById(practiceId, patientId);
        };
        Service.prototype.cancelPatientEvent = function (practiceId, patientEventId) {
            return this.patientDomain.cancelPatientEvent(practiceId, patientEventId);
        };
        Service.prototype.visitAction = function (patientEvent) {
            patientEvent.CheckedIn = true;
            this.locationService.goToClinicalDashboard(patientEvent.PracticeId, patientEvent.Patient.PatientId);
        };
        Service.prototype.getVersion = function () {
            return this.$http.get('version.json?' + new Date().getTime())
                .then(function (response) {
                return response.data;
            });
        };
        Service.prototype.saveSearchText = function (searchText) {
            this.memoryService.home.searchText = searchText;
        };
        Service.prototype.getSearchText = function () {
            return this.memoryService.home.searchText;
        };
        Service.prototype.getClinicalInboxCount = function (practiceId) {
            return this.clinicalDomain.getPathologyReportWorkflowsCount(practiceId);
        };
        return Service;
    })();
    home.Service = Service;
})(home || (home = {}));
angular.module('DoctorApp')
    .service('homeService', home.Service);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../../scripts/definition/moment/moment-node.d.ts" />
/// <reference path="../../screens/practice/practice-service.ts" />
/// <reference path="../../services/show-dialog.ts" />
/// <reference path="../../services/api/domain/patient.ts" />
/// <reference path="../../services/memory-service.ts" />
/// <reference path="../../services/location-service.ts" />
/// <reference path="home-service.ts" />
/// <reference path="../../run.ts" />
var Home;
(function (Home) {
    var ModalWidth = ModalModule.ModalWidth;
    var Collapse = (function () {
        function Collapse() {
        }
        return Collapse;
    })();
    Home.Collapse = Collapse;
    var Controller = (function () {
        Controller.$inject = ["$scope", "$rootScope", "dashboardService", "modalService", "invoiceService", "encounterServiceNew", "notificationService", "$filter", "practiceService", "billingDomain", "locationService", "signalrService", "$log", "$q", "homeService", "moment", "providerService", "$routeParams", "storageService", "trackingService"];
        function Controller($scope, $rootScope, dashboardService, modalService, invoiceService, encounterServiceNew, notificationService, $filter, practiceService, billingDomain, locationService, signalrService, $log, $q, homeService, moment, providerService, $routeParams, storageService, trackingService) {
            "ngInject";
            var _this = this;
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.dashboardService = dashboardService;
            this.modalService = modalService;
            this.invoiceService = invoiceService;
            this.encounterServiceNew = encounterServiceNew;
            this.notificationService = notificationService;
            this.$filter = $filter;
            this.practiceService = practiceService;
            this.billingDomain = billingDomain;
            this.locationService = locationService;
            this.signalrService = signalrService;
            this.$log = $log;
            this.$q = $q;
            this.homeService = homeService;
            this.moment = moment;
            this.providerService = providerService;
            this.$routeParams = $routeParams;
            this.storageService = storageService;
            this.trackingService = trackingService;
            var that = this;
            if (this.storageService.getPracticeId() !== $routeParams.practiceId) {
                practiceService.updateLocalPracticeById($routeParams.practiceId)
                    .then(function (practice) {
                    $scope.practice = practice;
                });
            }
            trackingService.defineUser(this.storageService.getUser().userId);
            $scope.changeSearch = function (searchText) {
                homeService.saveSearchText(searchText);
                _this.clearPatients();
                if (!searchText) {
                    return;
                }
                homeService.getPatients($routeParams.practiceId, searchText)
                    .then(function (patients) {
                    $scope.patients = patients;
                });
                if (Common.isNumber(searchText)) {
                    homeService.getPatientsFromNationalDb($routeParams.practiceId, searchText)
                        .then(function (response) {
                        if (response.Sucess === false) {
                            $scope.accessDB = false;
                        }
                        else {
                            $scope.accessDB = true;
                            $scope.patientsDB = response.Data;
                        }
                    });
                }
                else {
                    $scope.accessDB = true;
                }
            };
            $scope.concatPatient = function (patientDetails) {
                var fullName = (patientDetails.FirstName || '') + ' ' + (patientDetails.Surname || '');
                return $filter('titlecase')(fullName);
            };
            $scope.goToCreatePatient = function () {
                locationService.goToCreatePatient($routeParams.practiceId);
            };
            $scope.getPatientVisitType = function (type) {
                if (type === "RegularConsultation") {
                    return "Regular Consultation";
                }
                if (type === "NoCharge") {
                    return "No charge (follow-up)";
                }
                if (type === "OutOfRooms") {
                    return "Out of rooms";
                }
                if (type === "MedicalInsurance") {
                    return "Medical insurance";
                }
                if (type === "ChronicVisit") {
                    return "Chronic visit";
                }
                if (type === "MedicalCheckUp") {
                    return "Medical check-up";
                }
                if (type === "AntenatalCheckup") {
                    return "Antenatal check-up";
                }
                return type;
            };
            $scope.loadAvatar = function (patient) {
                return _this.dashboardService.getAvatar(_this.$routeParams.practiceId, patient.PatientId)
                    .then(function (document) {
                    if (document) {
                        return _this.dashboardService.getDocumentUrl(_this.$routeParams.practiceId, document.ThumbnailUrl) + "&r=" + document.FileName;
                    }
                    return null;
                });
            };
            $scope.goToChangePatient = function (patientId) {
                locationService.goToChangePatient($routeParams.practiceId, patientId);
            };
            $scope.showDoctorNote = function (visit) {
                if ($scope.isIHealthProvider) {
                    _this.locationService.goToClinicalDashboard(visit.PracticeId, visit.Patient.PatientId);
                }
                else {
                    _this.modalService.info(visit.ProviderNote);
                }
            };
            $scope.checkInPatient = function (patient) {
                if (patient) {
                    homeService.addToWaitingRoom($routeParams.practiceId, patient.PatientId)
                        .then(function (response) {
                        if (response.Sucess === false) {
                            modalService.error(response.ResponseMessage);
                        }
                        else if (response.Data.PatientAlreadyCheckedIn) {
                            modalService.error("This patient is already checked in");
                        }
                        else {
                            if (response.Data.PatientDetailsIncomplete) {
                                $scope.goToChangePatient(patient.PatientId);
                                $rootScope.PatientDetailsIncomplete = true;
                            }
                            $scope.loadCheckedInPatients();
                            $scope.isDisabled = true;
                            setTimeout(function () {
                                _this.$scope.isDisabled = false;
                            }, 200);
                        }
                    });
                }
            };
            $scope.isDisabled = false;
            $scope.goToClinicalDashboard = function (patientId) {
                _this.locationService.goToClinicalDashboard($routeParams.practiceId, patientId);
            };
            $scope.actionVisit = function (patientEvent) {
                homeService.visitAction(patientEvent);
            };
            $scope.cancelVisit = function (patientEvent) {
                var that = _this;
                if (patientEvent.PatientEventXRef) {
                    var dateMoment = moment.utc(patientEvent.CheckInTime, 'YYYY-MM-DDTHH:mm:ssZ');
                    var fullName = $scope.concatPatient(patientEvent.Patient.PatientDetails);
                    var dateMessage = dateMoment.isValid() ?
                        ' (check in time ' + dateMoment.format('DD/MM/YYYY HH:mm:ss') + ')' :
                        '';
                    var message = 'Do you want to cancel the visit for ' + fullName + dateMessage + ' ?';
                    modalService.confirm(message)
                        .then(function () {
                        that.cancelPatientVisit($routeParams.practiceId, patientEvent);
                    });
                }
                else {
                    _this.cancelPatientVisit($routeParams.practiceId, patientEvent);
                }
            };
            $scope.loadCheckedInPatients = function () {
                homeService.getCheckInPatients($routeParams.practiceId)
                    .then(function (newCheckedInPatients) {
                    $scope.checkedInPatients = $filter("filter")(newCheckedInPatients, { Status: 1 });
                    var backItems = $filter("filter")(newCheckedInPatients, { Status: 0 });
                    if (backItems) {
                        for (var i = 0; i < backItems.length; i++) {
                            if (backItems[i].CheckInTime != null) {
                                $scope.checkedInPatients.push(backItems[i]);
                            }
                        }
                    }
                    $scope.inProgressPatients = $filter("filter")(newCheckedInPatients, { Status: 2 });
                });
            };
            $scope.goToCheckPatientData = function (patient) {
                homeService.importPatientAndCheckIn($routeParams.practiceId, patient)
                    .then(function (response) {
                    if (response.Sucess === false) {
                        modalService.error(response.ResponseMessage);
                    }
                    else {
                        $scope.loadCheckedInPatients();
                        if (response.Data.PatientDetailsIncomplete) {
                            $rootScope.PatientDetailsIncomplete = true;
                            return response.Data.PatientId;
                        }
                    }
                    return $q.reject();
                })
                    .then(function (patientId) {
                    $scope.goToChangePatient(patientId);
                });
            };
            $scope.goToDashboard = function (patient) {
                locationService.goToClinicalDashboard($routeParams.practiceId, patient.PatientId);
            };
            $scope.openNotification = function (notification) {
                modalService.showNotification(notification)
                    .then(function () {
                    _this.getNotifications();
                });
            };
            $scope.markNotificationViewed = function (notification) {
                _this.notificationService.markNotificationViewed(notification.ProviderId, notification.NotificationId)
                    .then(function () {
                    _this.getNotifications();
                });
            };
            $scope.markAllNotificationsViewed = function () {
                if ($scope.notifications.length) {
                    var that = _this;
                    $q.all($scope.notifications.map(function (notification) {
                        return that.notificationService.markNotificationViewed(notification.ProviderId, notification.NotificationId);
                    })).then(function (response) {
                        _this.getNotifications();
                    });
                }
            };
            that.init();
            var pathReportSubscription$ = $rootScope.$on('PathReportReceived', function () {
                _this.getClinicalMessageCount();
            });
            var waitingRoomSubscription$ = $rootScope.$on('WaitingRoomUpdated', function () {
                $scope.loadCheckedInPatients();
            });
            var notificationsSubscription$ = $rootScope.$on('NotificationsUpdated', function () {
                _this.getNotifications();
            });
            $scope.$on('$destroy', function () {
                notificationsSubscription$();
                waitingRoomSubscription$();
                pathReportSubscription$();
            });
        }
        Controller.prototype.init = function () {
            var _this = this;
            var $scope = this.$scope;
            var $rootScope = this.$rootScope;
            $rootScope.tabselection = undefined;
            $rootScope.selectedPatient = undefined;
            $rootScope.PatientDetailsIncomplete = false;
            $scope.searchText = this.homeService.getSearchText();
            $scope.checkedInPatients = [];
            $scope.patients = [];
            $scope.patientsDB = [];
            $scope.accessDB = true;
            $scope.collapse = {
                waitingRoom: true,
                practicePatients: true,
                nationalPatients: true,
                inProgress: true
            };
            $scope.practice = this.storageService.getPractice();
            this.invoiceService.setConsultationDate(null);
            this.encounterServiceNew.setConsultationDate(null);
            this.practiceService.updateLocalPractice(this.$routeParams.practiceId, false);
            this.getNotifications();
            this.getClinicalMessageCount();
            $scope.loadCheckedInPatients();
            $scope.changeSearch($scope.searchText);
            if (GlobalVar.isProd) {
                this.homeService.getVersion()
                    .then(function (response) {
                    _this.setVersionDiff(response.clientVersion);
                    _this.$scope.needRefresh = GlobalVar.clientVersion !== response.clientVersion;
                });
            }
            this.billingDomain.getProvider(this.$routeParams.practiceId)
                .then(function (provider) {
                var options = _this.providerService.buildProviderOptions(provider);
                _this.$scope.myPatientFilesEnabled = options.myPatientFilesEnabled;
                _this.$scope.isIHealthProvider = !!provider.PracticeXRef && provider.PracticeXRef.startsWith('iHealth');
                if (options.isHealthbridgeClinicalEnabled && !options.isDrAppAccessAllowed) {
                    _this.trackingService.logHbcRedirect();
                    window.open(GlobalVar.hbcUrl, '_self');
                }
                else {
                    var currentDay = _this.moment().format('DD,dddd');
                    if (['082', '091', '004', '027', '052', '075', '081', '007', '066', '068', '086', '085', '088', '089', '084', '072'].indexOf(provider.SpecialityCode) < 0
                        && currentDay != options.lastSeenImportantNotice) {
                        _this.modalService.info('<b>Important Notice</b>' +
                            '<br><br>The Dr App system will be <b>decommissioned on 31 October 2021</b> and replaced by Healthbridge Clinical,' +
                            ' our new and improved electronic medical record. ' +
                            '<br><br>Healthbridge Clinical is free until 31 January 2022.' +
                            '<br><br><a target="_blank" href="https://docs.google.com/forms/d/e/1FAIpQLSf0oUkVSqqQ0iWzFghvt5E4boSf-DLYYOwgEoJBl5Wp2IfZiA/viewform">Click here</a> to activate your free Healthbridge Clinical trial.', ModalWidth._500px).then(function () {
                            _this.providerService.saveProviderOption(provider.PracticeId, "LastSeenImportantNotice", currentDay);
                        });
                    }
                }
            });
        };
        Controller.prototype.setVersionDiff = function (jsonVersion) {
            var majorIndex = 0;
            var minorIndex = 1;
            var patchIndex = 2;
            var newVersionArr = jsonVersion.split('.');
            var currentVersionArr = GlobalVar.clientVersion.split('.');
            var upgradeType = App.VersionDiff.NoDiff;
            if (parseInt(newVersionArr[majorIndex]) > parseInt(currentVersionArr[majorIndex]) ||
                parseInt(newVersionArr[minorIndex]) > parseInt(currentVersionArr[minorIndex])) {
                upgradeType = App.VersionDiff.Mandatory;
            }
            else if (newVersionArr[patchIndex] !== currentVersionArr[patchIndex]) {
                upgradeType = App.VersionDiff.NoMandatory;
            }
            this.$rootScope.versionDifference = upgradeType;
        };
        Controller.prototype.clearPatients = function () {
            this.$scope.patients = [];
            this.$scope.patientsDB = [];
        };
        Controller.prototype.getNotifications = function () {
            var _this = this;
            this.notificationService.getNotifications(this.$routeParams.practiceId)
                .then(function (response) {
                if (response) {
                    _this.$scope.notifications = response;
                }
            });
        };
        Controller.prototype.getClinicalMessageCount = function () {
            var _this = this;
            this.homeService.getClinicalInboxCount(this.$routeParams.practiceId)
                .then(function (count) {
                if (count && count > 0) {
                    _this.$scope.clinicalMessageCount = count;
                }
            });
        };
        Controller.prototype.cancelPatientVisit = function (practiceId, patientEvent) {
            var _this = this;
            var cancelPatientEvent = function () {
                _this.homeService.cancelPatientEvent(practiceId, patientEvent.PatientEventId)
                    .then(function (response) {
                    if (response.Sucess === false) {
                        _this.modalService.error("Failed to cancel patient visit " + response.ResponseMessage);
                    }
                    else {
                        _this.$scope.loadCheckedInPatients();
                    }
                });
            };
            if (patientEvent.Status === 2) {
                this.modalService.confirm('You are about to remove the patient without completing the encounter.' +
                    '<br>All captured information may be lost if you do so.  Would you like to remove them?')
                    .then(cancelPatientEvent);
            }
            else {
                cancelPatientEvent();
            }
        };
        return Controller;
    })();
    Home.Controller = Controller;
})(Home || (Home = {}));
angular.module('DoctorApp')
    .controller('HomeController', Home.Controller);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../config.ts" />
/// <reference path="../../services/auth-service.ts" />
/// <reference path="../../services/show-dialog.ts" />
/// <reference path="../../run.ts" />
/// <reference path="login-service.ts" />
var LoginModule;
(function (LoginModule) {
    var Controller = (function () {
        Controller.$inject = ["$scope", "$rootScope", "authService", "showDialog", "$q", "loginService", "storageService"];
        function Controller($scope, $rootScope, authService, showDialog, $q, loginService, storageService) {
            "ngInject";
            var _this = this;
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.authService = authService;
            this.showDialog = showDialog;
            this.$q = $q;
            this.loginService = loginService;
            this.storageService = storageService;
            $scope.submitLoginForm = function (isValid) {
                if (isValid) {
                    _this.login($scope.userName, $scope.password);
                }
                else {
                    showDialog.error("Please enter valid login/password.");
                }
            };
            this.init();
        }
        Controller.prototype.init = function () {
        };
        Controller.prototype.login = function (userName, password) {
            var _this = this;
            return this.loginService.login(userName, password)
                .then(function (response) {
                var token = _this.authService.parseTokenDetails(response.data.access_token);
                _this.storageService.setAuthorizationData({
                    token: response.data.access_token,
                    userName: token.payload.full_name
                });
                _this.storageService.setUser({
                    isAuth: true,
                    role: token.payload.role,
                    name: token.payload.full_name,
                    userLogin: userName,
                    userId: token.payload.user_id
                });
                _this.authService.refreshAuthorization();
            }).catch(function (error) {
                _this.authService.logOut();
                if (error.data && error.data.error_description) {
                    _this.showDialog.error(error.data.error_description);
                }
            });
        };
        return Controller;
    })();
    LoginModule.Controller = Controller;
})(LoginModule || (LoginModule = {}));
angular.module('DoctorApp')
    .controller('LoginController', LoginModule.Controller);
var NotificationModule;
(function (NotificationModule) {
    var NotificationSendController = (function () {
        NotificationSendController.$inject = ["$scope", "$q", "moment", "$timeout", "modalService", "practiceService", "providerService", "notificationService"];
        function NotificationSendController($scope, $q, moment, $timeout, modalService, practiceService, providerService, notificationService) {
            "ngInject";
            var _this = this;
            this.$scope = $scope;
            this.$q = $q;
            this.moment = moment;
            this.$timeout = $timeout;
            this.modalService = modalService;
            this.practiceService = practiceService;
            this.providerService = providerService;
            this.notificationService = notificationService;
            $scope.selectedRules = [];
            $scope.providersFilter = 'all';
            $scope.actions = [];
            $scope.tinymceOptions = {
                selector: 'textarea',
                plugins: 'link table preview code template paste',
                toolbar: 'code | template | undo redo | bold italic | fontsizeselect | bullist numlist outdent indent | alignleft aligncenter alignright | file',
                fontsize_formats: '8pt 10pt 12pt 14pt 18pt 24pt 36pt',
                skin_url: GlobalVar.isProd ? 'styles/tinymce/skins/lightgray' : '',
                visual: false,
                browser_spellcheck: true,
                contextmenu: false,
                statusbar: false,
                paste_data_images: true,
                valid_children: "+body[style],+body,+head",
                extended_valid_elements: 'body,head',
                templates: [
                    { title: 'Treating Doctor Name', description: 'Paste Treating Doctor Name', content: '{TreatingDoctorName}' },
                    { title: 'Treating Practice Number', description: 'Paste Treating Practice Number', content: '{TreatingPracticeNumber}' },
                    { title: 'Speciality Description', description: 'Paste Speciality Description', content: '{SpecialityDescription}' },
                    { title: 'Practice Name', description: 'Paste Practice Name', content: '{PracticeName}' },
                    { title: 'Practice Number', description: 'Paste Practice Number', content: '{PracticeNumber}' }
                ],
                init_instance_callback: function (editor) {
                    var contentWraper = $(editor.contentAreaContainer);
                    var content = $(editor.iframeElement);
                    var interval;
                    editor.on('change', function () {
                        if (interval) {
                            $timeout.cancel(interval);
                        }
                        interval = $timeout(function () {
                            var content = editor.getContent();
                            if (content.search(/<img src\=\"/g) > -1) {
                                $scope.body = editor.getContent().replace(/<img src\=\"/g, '<img style="max-width:100%" src="');
                            }
                        }, 100);
                    });
                    content.css('min-height', 400);
                    contentWraper.css('overflow', 'auto');
                }
            };
            $scope.selectRule = function (selectedRule) {
                $scope.providers = $scope.allProviders.filter(function (provider) { return provider.SpecialityCode === selectedRule; });
            };
            $scope.addAction = function () {
                $scope.actions.push({
                    Description: '',
                    Name: '',
                    ActionLink: '',
                    Modal: false
                });
            };
            $scope.removeAction = function (raction) {
                $scope.actions = $scope.actions.filter(function (action) { return action !== raction; });
            };
            $scope.setFilter = function (providersFilter) {
                if (providersFilter === 'all') {
                    $scope.providers = _this.$scope.allProviders;
                }
                else if (providersFilter === 'iHealth') {
                    $scope.providers = _this.$scope.allProviders.filter(function (provider) { return provider.PracticeXRef && provider.PracticeXRef.startsWith('iHealth'); });
                }
                else if (providersFilter === 'myMPS') {
                    $scope.providers = _this.$scope.allProviders.filter(function (provider) { return provider.PracticeXRef && !provider.PracticeXRef.startsWith('iHealth'); });
                }
                else if (providersFilter === 'hbc') {
                    $scope.providers = _this.$scope.allProviders.filter(function (provider) {
                        var options = _this.providerService.buildProviderOptions(provider);
                        return options.isHealthbridgeClinicalEnabled;
                    });
                }
                else if (providersFilter === 'byProvider') {
                    $scope.providers = [];
                }
                else if (providersFilter === 'fromFileUpload') {
                    $scope.providers = [];
                }
            };
            $scope.importByIds = function () {
                var ids = _this.$scope.practiceIds || '';
                if (ids.indexOf('Providers') == -1) {
                    var splittedIds = ids.split(',');
                    $scope.providers = splittedIds.map(function (id) {
                        var practiceId = id.trim();
                        var provider = $scope.allProviders.filter(function (s) { return s.PracticeId === practiceId; });
                        return provider.length > 0 && provider[0];
                    }).filter(function (s) { return !!s; });
                    var notFoundCount = splittedIds.length - _this.$scope.providers.length;
                    var notFoundIds = splittedIds.map(function (s) { return s.trim(); })
                        .map(function (s) { return $scope.providers.filter(function (d) { return d.PracticeId === s; }).length > 0 ? null : s; })
                        .filter(function (s) { return !!s; });
                    $scope.practiceIds = _this.$scope.providers.length + ' Providers';
                    if (notFoundCount > 0) {
                        $scope.practiceIds = $scope.practiceIds + ', not found (' + notFoundCount + '): ' + notFoundIds.join(", ");
                    }
                }
            };
            $scope.submitNotifications = function (isValid) {
                if ($scope.providersFilter === 'bySpeciality') {
                    var rulesArr = $scope.selectedRules.map(function (rule) { return rule.SpecialityCode.match(/\d+/).shift(); });
                    $scope.providers = $scope.allProviders
                        .filter(function (provider) { return rulesArr.indexOf(provider.SpecialityCode) > -1; });
                }
                if (!$scope.providers.length && $scope.providersFilter !== 'fromFileUpload') {
                    modalService.error('Please select providers');
                    return;
                }
                if (isValid && $scope.body.length > 0) {
                    if ($scope.providersFilter === 'fromFileUpload') {
                        var file = document.getElementById('files').files[0];
                        if (file == undefined || file === null) {
                            modalService.error('Please select a .csv file to upload');
                            return;
                        }
                        var formData = new FormData();
                        formData.append('file', file);
                        formData.append('Date', moment.utc().format(ServerDateFormat));
                        formData.append('Context', $scope.context);
                        formData.append('Subject', $scope.subject);
                        formData.append('Category', $scope.category);
                        formData.append('Body', _this.htmlEntities($scope.body));
                        formData.append('BodyType', 'html');
                        formData.append('Actions', JSON.stringify($scope.actions));
                        _this.bulkSendFromFile(formData);
                    }
                    else {
                        var notifications = $scope.providers
                            .map(function (provider) {
                            var date = moment.utc();
                            var notification = {
                                NotificationId: "",
                                NotificationXRef: "",
                                ProviderId: provider.PracticeId,
                                Date: date.format(ServerDateFormat),
                                Context: $scope.context,
                                Subject: $scope.subject,
                                Category: $scope.category,
                                Body: _this.parseBody($scope.body, provider),
                                BodyType: 'html',
                                Actions: $scope.actions,
                                Data: {}
                            };
                            return notification;
                        });
                        if (notifications && notifications.length > 0) {
                            _this.bulkSend(notifications);
                        }
                    }
                }
                else {
                    modalService.error('Please enter all required info');
                }
            };
            practiceService.getAllPractices()
                .then(function (providers) {
                $scope.allProviders = angular.copy(providers);
                $scope.providers = providers;
                return practiceService.getSpecialityRules();
            })
                .then(function (rules) {
                $scope.rules = rules.map(function (rule) {
                    var providers = $scope.allProviders.filter(function (provider) { return provider.SpecialityCode === rule.SpecialityCode; }).length;
                    rule.SpecialityCode += ' (' + providers + ' provider' + (providers !== 1 ? 's' : '') + ')';
                    return rule;
                });
            });
        }
        NotificationSendController.prototype.bulkSend = function (notifications) {
            var _this = this;
            var itemsInPart = 100;
            var partOfNotifications = notifications.splice(0, itemsInPart);
            this.notificationService.notificationBulk(partOfNotifications)
                .then(function (response) {
                if (response.Sucess) {
                    if (notifications.length > 0) {
                        _this.bulkSend(notifications);
                    }
                    else {
                        _this.modalService.info("Notification was sent successfully to " +
                            _this.$scope.providers.length +
                            ' provider' +
                            (_this.$scope.providers.length > 1 ? 's' : ''));
                    }
                }
                else {
                    _this.modalService.error(response.ResponseMessage);
                }
            });
        };
        NotificationSendController.prototype.bulkSendFromFile = function (formData) {
            this.notificationService.notificationBulkFromFile(formData).then(function () { return console.log('tet'); });
        };
        NotificationSendController.prototype.parseBody = function (body, provider) {
            if (body === void 0) { body = ""; }
            return body.replace(/{\w+}/g, function (str) {
                var prop = str.replace(/[{}]/g, '');
                return provider[prop] || "";
            });
        };
        NotificationSendController.prototype.encodeHTML = function (rawStr) {
            return rawStr.replace(/[\u00A0-\u9999<>\&]/gim, function (i) {
                return '&#' + i.charCodeAt(0) + ';';
            });
        };
        NotificationSendController.prototype.htmlEntities = function (str) {
            return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
        };
        return NotificationSendController;
    })();
    NotificationModule.NotificationSendController = NotificationSendController;
})(NotificationModule || (NotificationModule = {}));
angular.module('DoctorApp')
    .controller('NotificationSendController', NotificationModule.NotificationSendController);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../services/http-service.ts" />
/// <reference path="../../services/api/domain/tenant.ts" />
var MedicalHistoryModule;
(function (MedicalHistoryModule) {
    var Service = (function () {
        Service.$inject = ["httpService", "tenantDomainService", "clinicalDomain", "moment", "providerService"];
        function Service(httpService, tenantDomainService, clinicalDomain, moment, providerService) {
            "ngInject";
            this.httpService = httpService;
            this.tenantDomainService = tenantDomainService;
            this.clinicalDomain = clinicalDomain;
            this.moment = moment;
            this.providerService = providerService;
        }
        Service.prototype.getTenants = function () {
            return this.tenantDomainService.getTenantList()
                .then(function (response) {
                if (response) {
                    return response;
                }
                return [];
            });
        };
        Service.prototype.getConditionCodesList = function () {
            return ["J45", "B31", "I50", "J44", "E10", "E11", "I10", "E78.0"];
        };
        Service.prototype.getAllergiesList = function () {
            return [
                [
                    new MedicalHistoryModule.AllergyItem('Dairy', '226760005', 'food'),
                    new MedicalHistoryModule.AllergyItem('Fish', '227037002', 'food'),
                    new MedicalHistoryModule.AllergyItem('Shellfish', '227146005', 'food'),
                    new MedicalHistoryModule.AllergyItem('Other Nuts', '13577000', 'food'),
                    new MedicalHistoryModule.AllergyItem('Peanut', '91935009', 'food'),
                    new MedicalHistoryModule.AllergyItem('Gluten sensitivity', '89811004', 'food'),
                    new MedicalHistoryModule.AllergyItem('Wheat', '420174000', 'food')
                ], [
                    new MedicalHistoryModule.AllergyItem('Penicillin', '373270004', 'medicine'),
                    new MedicalHistoryModule.AllergyItem('Sulphur', '43735007', 'medicine'),
                    new MedicalHistoryModule.AllergyItem('NSAID sensitivity', '372665008', 'medicine'),
                    new MedicalHistoryModule.AllergyItem('Aspirin', '293586001', 'medicine')
                ], [
                    new MedicalHistoryModule.AllergyItem('Dust', '406466009', 'environmental'),
                    new MedicalHistoryModule.AllergyItem('Pollen', '40646007', 'environmental')
                ]
            ];
        };
        Service.prototype.updateAllergies = function (practiceId, patientId, patientAllergies) {
            var body = {
                PatientAllergies: patientAllergies
            };
            return this.httpService.post(this.getUrl(practiceId) + "patientallergies/" + patientId + "/revise", body);
        };
        Service.prototype.getPatientAllergies = function (practiceId, patientId) {
            return this.httpService.get(this.getUrl(practiceId) + "patientallergies/" + patientId);
        };
        Service.prototype.updatePatientNotes = function (practiceId, patientId, patientNotes) {
            var body = {
                PatientClinicalNotes: patientNotes
            };
            return this.httpService.post(this.getUrl(practiceId) + "patientclinicalnotes/" + patientId + "/revise", body);
        };
        Service.prototype.getPatientClinicalNotes = function (practiceId, patientId) {
            return this.httpService.get(this.getUrl(practiceId) + "patientclinicalnotes/" + patientId);
        };
        Service.prototype.getPatientChronicConditions = function (practiceId, patientId) {
            return this.httpService.get(this.getUrl(practiceId) + "patientchronicconditions/" + patientId);
        };
        Service.prototype.getChronicCondition = function (practiceId) {
            return this.httpService.get(this.getUrl(practiceId) + "chroniccondition");
        };
        Service.prototype.getChronicConditionSearch = function (practiceId, searchText) {
            return this.httpService.get(this.getUrl(practiceId) + "chroniccondition/" + searchText);
        };
        Service.prototype.updateChronicConditions = function (practiceId, patientId, patientConditions) {
            var body = {
                ChronicConditions: patientConditions
            };
            return this.httpService.post(this.getUrl(practiceId) + "patientchronicconditions/" + patientId + "/revise", body);
        };
        Service.prototype.getUrl = function (practiceId) {
            return "v1/" + practiceId + "/clinical/";
        };
        return Service;
    })();
    MedicalHistoryModule.Service = Service;
})(MedicalHistoryModule || (MedicalHistoryModule = {}));
angular.module('DoctorApp')
    .service('medicalHistoryService', MedicalHistoryModule.Service);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../../scripts/definition/moment/moment-node.d.ts" />
/// <reference path="../../services/show-dialog.ts" />
/// <reference path="../../run.ts" />
/// <reference path="medical-history-service.ts" />
var MedicalHistoryModule;
(function (MedicalHistoryModule) {
    var PatientAllergies = Domain.Clinical.PatientAllergies;
    var PatientAllergy = Domain.Clinical.PatientAllergy;
    var Allergy = Domain.Clinical.Allergy;
    var PatientChronicConditions = Domain.Clinical.PatientChronicConditions;
    var Other = (function () {
        function Other() {
        }
        return Other;
    })();
    MedicalHistoryModule.Other = Other;
    var ConditionItem = (function () {
        function ConditionItem(condition) {
            this.condition = condition;
            this.selected = false;
        }
        return ConditionItem;
    })();
    MedicalHistoryModule.ConditionItem = ConditionItem;
    var AllergyItem = (function () {
        function AllergyItem(name, code, category) {
            this.selected = false;
            this.name = name;
            this.code = code;
            this.category = category;
        }
        return AllergyItem;
    })();
    MedicalHistoryModule.AllergyItem = AllergyItem;
    var Controller = (function () {
        Controller.$inject = ["$scope", "$filter", "$rootScope", "$routeParams", "$q", "$log", "showDialog", "modalService", "moment", "medicalHistoryService", "locationService", "providerService", "trackingService"];
        function Controller($scope, $filter, $rootScope, $routeParams, $q, $log, showDialog, modalService, moment, medicalHistoryService, locationService, providerService, trackingService) {
            "ngInject";
            var _this = this;
            this.$scope = $scope;
            this.$filter = $filter;
            this.$rootScope = $rootScope;
            this.$routeParams = $routeParams;
            this.$q = $q;
            this.$log = $log;
            this.showDialog = showDialog;
            this.modalService = modalService;
            this.moment = moment;
            this.medicalHistoryService = medicalHistoryService;
            this.locationService = locationService;
            this.providerService = providerService;
            this.trackingService = trackingService;
            var patientId = $routeParams.patientId;
            $scope.patientId = patientId;
            $scope.inputFormat = 'YYYY-MM-DD HH:mm:ss';
            $scope.outputFormat = 'DD MMM, YYYY';
            $scope.memoryClinicalNotes = "";
            $scope.memoryOther = "";
            $scope.selectedItems = [];
            $scope.memorySelectedItems = [];
            $scope.conditionItemsList = [];
            $scope.memoryConditionItemsList = [];
            $scope.goBack = function () {
                var isConditionsChanged = _this.isConditionsChanged();
                var isAllergiesChanged = _this.isAllergiesChanged();
                var isNotesChanged = _this.isNotesChanged();
                var isOthersChanged = _this.isOthersChanged();
                if (isConditionsChanged || isAllergiesChanged || isNotesChanged || isOthersChanged) {
                    showDialog.confirm('You have not saved your changes.<br>Would you like to save your changes before navigating away?', ModalModule.ModalWidth._400px, true)
                        .then(function (result) {
                        if (result) {
                            $q.all([
                                _this.updatePatientAllergies(),
                                _this.updatePatientNotes(),
                                _this.updatePatientConditions()
                            ]).finally(function () {
                                $rootScope.back();
                            });
                        }
                        else {
                            $rootScope.back();
                        }
                    });
                }
                else {
                    $rootScope.back();
                }
            };
            $scope.other = {
                selected: false,
                value: ""
            };
            $scope.patientClinicalNotes = {
                Note: ""
            };
            $scope.selectNone = function () {
                $scope.selectedItems = [];
                $scope.other.selected = false;
                $scope.other.value = '';
                for (var _i = 0, _a = $scope.allergiesList; _i < _a.length; _i++) {
                    var allergyGroup = _a[_i];
                    for (var _b = 0; _b < allergyGroup.length; _b++) {
                        var allergyItem = allergyGroup[_b];
                        allergyItem.selected = false;
                    }
                }
            };
            $scope.allergiesList = medicalHistoryService.getAllergiesList();
            $scope.addMore = function () {
                modalService.showConditionsDetails()
                    .then(function (condition) {
                    var selectedConditions = $filter('filter')($scope.conditionItemsList, condition.DiagnosisCode, true);
                    if (selectedConditions.length === 0) {
                        var conditionItem = new ConditionItem(condition);
                        conditionItem.selected = true;
                        $scope.conditionItemsList.push(conditionItem);
                    }
                    else {
                        selectedConditions[0].selected = true;
                    }
                });
            };
            $scope.changeOther = function (other) {
                if (!$scope.other.selected) {
                    $scope.other.value = "";
                }
            };
            $scope.changeItem = function (item) {
                if (item.selected) {
                    $scope.selectedItems.push(item);
                }
                else {
                    var indexOf = $scope.selectedItems.indexOf(item);
                    if (indexOf !== -1) {
                        $scope.selectedItems.splice(indexOf, 1);
                    }
                }
            };
            $scope.updateRecords = function () {
                $q.all([
                    _this.updatePatientAllergies(),
                    _this.updatePatientNotes(),
                    _this.updatePatientConditions()
                ]).finally(function () {
                    $rootScope.back();
                });
            };
            this.init();
        }
        Controller.prototype.init = function () {
            var _this = this;
            var that = this;
            var patientId = this.$routeParams.patientId;
            var practiceId = this.$routeParams.practiceId;
            this.medicalHistoryService.getPatientClinicalNotes(practiceId, patientId)
                .then(function (result) {
                if (result) {
                    that.$scope.patientClinicalNotes = result;
                    that.$scope.memoryClinicalNotes = that.$scope.patientClinicalNotes.Note || "";
                }
            });
            this.medicalHistoryService.getPatientAllergies(practiceId, patientId)
                .then(function (result) {
                that.$scope.allergies = result;
                if (result && result.PatientAllergies) {
                    for (var k = 0; k < result.PatientAllergies.length; k++) {
                        var item = result.PatientAllergies[k];
                        var allergiesList = _this.$scope.allergiesList;
                        for (var i = 0; i < allergiesList.length; i++) {
                            var allergiesColumn = allergiesList[i];
                            for (var j = 0; j < allergiesColumn.length; j++) {
                                if (allergiesColumn[j].code === item.Allergen.Code) {
                                    allergiesColumn[j].selected = true;
                                    _this.$scope.selectedItems.push(allergiesColumn[j]);
                                }
                            }
                        }
                    }
                    _this.$scope.memorySelectedItems = _this.$scope.selectedItems.map(function (item) { return item.name; });
                    if (result.Other) {
                        that.$scope.other.selected = true;
                        that.$scope.other.value = result.Other;
                    }
                    _this.$scope.memoryOther = that.$scope.other.value || "";
                    _this.$scope.noAllergies = result.NoAllergies;
                }
            });
            this.medicalHistoryService.getChronicCondition(this.$routeParams.practiceId)
                .then(function (conditionsFullList) {
                var conditionItemsList = [];
                var conditionBaseCodes = _this.medicalHistoryService.getConditionCodesList();
                for (var _i = 0; _i < conditionsFullList.length; _i++) {
                    var conditionListItem = conditionsFullList[_i];
                    var index = conditionBaseCodes.indexOf(conditionListItem.DiagnosisCode);
                    if (index >= 0) {
                        conditionItemsList[index] = new ConditionItem(conditionListItem);
                    }
                }
                _this.$scope.conditionItemsList = conditionItemsList.filter(function (item) { return item !== (undefined || ''); });
                _this.updateConditionsList();
            });
        };
        Controller.prototype.isAllergiesChanged = function () {
            return !angular.equals(this.$scope.selectedItems.map(function (item) { return item.name; }), this.$scope.memorySelectedItems);
        };
        Controller.prototype.isConditionsChanged = function () {
            return !angular.equals(this.$scope.conditionItemsList.filter(function (item) { return item.selected; }).map(function (item) { return item.condition.Name; }), this.$scope.memoryConditionItemsList);
        };
        Controller.prototype.isOthersChanged = function () {
            return !angular.equals(this.$scope.memoryOther, this.$scope.other.value);
        };
        Controller.prototype.isNotesChanged = function () {
            return !angular.equals(this.$scope.memoryClinicalNotes, this.$scope.patientClinicalNotes.Note);
        };
        Controller.prototype.updatePatientAllergies = function () {
            var _this = this;
            var patientAllergies = [];
            var allergiesList = this.$scope.selectedItems;
            for (var i = 0; i < allergiesList.length; i++) {
                var item = allergiesList[i];
                var allergen = new Allergy();
                allergen.Code = item.code;
                allergen.Description = item.name;
                var patientAllergy = new PatientAllergy();
                patientAllergy.Allergen = allergen;
                var capturedTime = moment.utc().format(DATE_TIME_PATTERN);
                if (this.$scope.allergies && this.$scope.allergies.PatientAllergies) {
                    for (var k = 0; k < this.$scope.allergies.PatientAllergies.length; k++) {
                        var allergie = this.$scope.allergies.PatientAllergies[k];
                        if (allergie.Allergen.Code === item.code) {
                            capturedTime = allergie.CapturedDate;
                        }
                    }
                }
                patientAllergy.CapturedDate = capturedTime;
                patientAllergies.push(patientAllergy);
            }
            var allergies = new PatientAllergies();
            if (this.$scope.allergies) {
                allergies = this.$scope.allergies;
            }
            allergies.NoAllergies = this.$scope.noAllergies;
            allergies.Other = this.$scope.other.value;
            allergies.PatientAllergies = patientAllergies;
            return this.medicalHistoryService
                .updateAllergies(this.$routeParams.practiceId, this.$scope.patientId, allergies)
                .then(function (response) {
                if (response.Sucess === false) {
                    _this.showDialog.error(response.ResponseMessage);
                }
            });
        };
        Controller.prototype.updatePatientConditions = function () {
            var _this = this;
            var conditions = [];
            var patientConditions = new PatientChronicConditions();
            for (var _i = 0, _a = this.$scope.conditionItemsList; _i < _a.length; _i++) {
                var conditionListItem = _a[_i];
                var capturedTime = moment.utc().format(DATE_TIME_PATTERN);
                if (conditionListItem.selected) {
                    var item = {
                        CapturedDate: capturedTime,
                        Condition: conditionListItem.condition
                    };
                    conditions.push(item);
                }
            }
            patientConditions.Id = this.$scope.patientConditions && this.$scope.patientConditions.Id || "";
            patientConditions.Conditions = conditions;
            return this.medicalHistoryService
                .updateChronicConditions(this.$routeParams.practiceId, this.$routeParams.patientId, patientConditions)
                .then(function (response) {
                if (response.Sucess === false) {
                    _this.showDialog.error(response.ResponseMessage);
                }
            });
        };
        Controller.prototype.updatePatientNotes = function () {
            var _this = this;
            var patientNote = {};
            if (this.$scope.patientClinicalNotes) {
                patientNote = this.$scope.patientClinicalNotes;
            }
            patientNote.CapturedDate = moment.utc().format(DATE_TIME_PATTERN);
            return this.medicalHistoryService.updatePatientNotes(this.$routeParams.practiceId, this.$scope.patientId, patientNote)
                .then(function (response) {
                if (response.Sucess === false) {
                    _this.showDialog.error(response.ResponseMessage);
                }
            });
        };
        Controller.prototype.updateConditionsList = function () {
            var _this = this;
            this.medicalHistoryService
                .getPatientChronicConditions(this.$routeParams.practiceId, this.$routeParams.patientId)
                .then(function (response) {
                if (response) {
                    _this.$scope.patientConditions = response;
                    var conditions = _this.$scope.patientConditions.Conditions;
                    var conditionBaseCodes = _this.medicalHistoryService.getConditionCodesList();
                    for (var _i = 0; _i < conditions.length; _i++) {
                        var patientCondition = conditions[_i];
                        for (var _a = 0, _b = _this.$scope.conditionItemsList; _a < _b.length; _a++) {
                            var conditionItem = _b[_a];
                            if (conditionItem.condition.DiagnosisCode ===
                                patientCondition.Condition.DiagnosisCode) {
                                conditionItem.selected = true;
                            }
                        }
                        if (conditionBaseCodes.indexOf(patientCondition.Condition.DiagnosisCode) < 0) {
                            var conditionNewItem = new ConditionItem(patientCondition.Condition);
                            conditionNewItem.selected = true;
                            _this.$scope.conditionItemsList.push(conditionNewItem);
                        }
                    }
                }
                else {
                    _this.$scope.patientConditions = new PatientChronicConditions();
                }
                _this.$scope.memoryConditionItemsList = _this.$scope.conditionItemsList.filter(function (item) { return item.selected; }).map(function (item) { return item.condition.Name; });
            });
        };
        return Controller;
    })();
    MedicalHistoryModule.Controller = Controller;
})(MedicalHistoryModule || (MedicalHistoryModule = {}));
angular.module('DoctorApp')
    .controller('MedicalHistoryController', MedicalHistoryModule.Controller);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../services/show-dialog.ts" />
/// <reference path="../../screens/searches/search-service.ts" />
/// <reference path="../../screens/searches/search-type.ts" />
/// <reference path="../../run.ts" />
var SearchModule;
(function (SearchModule) {
    var ControllerAbstract = (function () {
        ControllerAbstract.$inject = ["$rootScope", "$scope", "encounterServiceNew", "invoiceService", "$q", "moment", "$location", "showDialog", "searchService"];
        function ControllerAbstract($rootScope, $scope, encounterServiceNew, invoiceService, $q, moment, $location, showDialog, searchService) {
            "ngInject";
            var _this = this;
            this.$rootScope = $rootScope;
            this.$scope = $scope;
            this.encounterServiceNew = encounterServiceNew;
            this.invoiceService = invoiceService;
            this.$q = $q;
            this.moment = moment;
            this.$location = $location;
            this.showDialog = showDialog;
            this.searchService = searchService;
            var caption;
            $scope.searchTemplate = function (func, searchText, practiceId) {
                var deferred = $q.defer();
                caption = searchText;
                $scope.config.caption = searchText;
                $scope.searchResults = [];
                func(practiceId, $scope.eventId, searchText, _this.dateOfService)
                    .then(function (results) {
                    $scope.searchResults = results;
                    deferred.resolve();
                }, function () {
                    deferred.resolve();
                });
                return deferred.promise;
            };
            $scope.selectTemplate = function (template, templateType) {
                var obj = {};
                if (templateType == SearchModule.SearchType.DIAGNOSIS) {
                    if ($scope.isClinical) {
                        obj.EncounterLineItems = { EncounterHeader: template.EncounterHeader };
                    }
                    else {
                        obj.InvoiceLineItemsVo = { InvoiceHeader: template.InvoiceHeader };
                    }
                }
                else if (templateType == SearchModule.SearchType.PRESCRIPTION) {
                    obj.MedicationPrescriptionLines = [template];
                }
                else {
                    if ($scope.isClinical) {
                        obj.EncounterLineItems = { LineItems: template.LineItems, EncounterHeader: {} };
                    }
                    else {
                        obj.InvoiceLineItemsVo = { LineItems: template.LineItems };
                    }
                }
                obj.TemplateType = SearchModule.SearchTypeUtil.getType(templateType);
                obj.Caption = caption;
                searchService.saveSelectedTemplate(obj);
                $rootScope.back();
            };
            $scope.customizeList = function (list, fields) {
                var res = [];
                for (var i = 0; i < list.length; i++) {
                    var searchItem = list[i];
                    var item = {
                        fields: [],
                        object: searchItem
                    };
                    var header = $scope.isClinical ? 'EncounterHeader' : 'InvoiceHeader';
                    var lineItem = searchItem.LineItems ? searchItem.LineItems[0] : searchItem[header].Diagnosis[0];
                    for (var j = 0; j < fields.length; j++) {
                        item.fields[j] = { value: lineItem[fields[j]] };
                    }
                    res[i] = item;
                }
                return res;
            };
            this.init();
        }
        ControllerAbstract.prototype.init = function () {
            var ENCOUNTER = 'encounter';
            var INVOICE = 'invoice';
            var hash = this.$location.hash();
            this.$scope.isClinical = !!(hash && hash == 'clinical');
            this.$scope.searchResults = [];
            this.service = this.$scope.isClinical ? this.encounterServiceNew : this.invoiceService;
            this.eventName = this.$scope.isClinical ? ENCOUNTER : INVOICE;
            var consultationDate = this.encounterServiceNew.getConsultationDate() || this.moment();
            this.dateOfService = consultationDate.format(serverDateFormat);
            this.$scope.eventId = this.searchService.eventId || '00000000-0000-0000-0000-000000000000';
        };
        return ControllerAbstract;
    })();
    SearchModule.ControllerAbstract = ControllerAbstract;
})(SearchModule || (SearchModule = {}));
angular.module('DoctorApp')
    .controller('SearchAbstractController', SearchModule.ControllerAbstract);
/// <reference path="../../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../searches/search-service.ts" />
/// <reference path="../../searches/search-abstract.ts" />
var ModalModule;
(function (ModalModule) {
    var ConditionsController = (function () {
        ConditionsController.$inject = ["$scope", "$filter", "medicalHistoryService", "$controller", "$routeParams", "$modalInstance"];
        function ConditionsController($scope, $filter, medicalHistoryService, $controller, $routeParams, $modalInstance) {
            "ngInject";
            var _this = this;
            this.$scope = $scope;
            this.$filter = $filter;
            this.medicalHistoryService = medicalHistoryService;
            this.$controller = $controller;
            this.$routeParams = $routeParams;
            this.$modalInstance = $modalInstance;
            angular.extend(this, $controller('SearchAbstractController', { $scope: $scope }));
            $scope.cancel = function () {
                $modalInstance.dismiss();
            };
            $scope.search = function (searchText) {
                medicalHistoryService.getChronicConditionSearch($routeParams.practiceId, searchText)
                    .then(function (conditions) {
                    $scope.list = _this.customizeList(conditions);
                    $scope.config.caption = searchText;
                });
            };
            $scope.config = {
                title: [
                    { columnName: 'ICD10', style: { width: 70 + 'px' }, hstyle: { width: 70 + 'px' } },
                    { columnName: 'Description', style: {}, hstyle: {} }
                ],
                placeholder: { value: 'Please type in a condition' }
            };
            $scope.addCondition = function (condition) {
                $modalInstance.close(condition);
            };
        }
        ConditionsController.prototype.customizeList = function (list) {
            var clist = [];
            var fields = ['DiagnosisCode', 'Name'];
            for (var _i = 0; _i < list.length; _i++) {
                var listItem = list[_i];
                var item = {
                    fields: [],
                    object: listItem
                };
                for (var _a = 0; _a < fields.length; _a++) {
                    var field = fields[_a];
                    item.fields.push({ value: listItem[field] });
                }
                clist.push(item);
            }
            return clist;
        };
        return ConditionsController;
    })();
    ModalModule.ConditionsController = ConditionsController;
})(ModalModule || (ModalModule = {}));
angular.module('DoctorApp')
    .controller('ConditionsController', ModalModule.ConditionsController);
/// <reference path="../../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../../../scripts/definition/moment/moment-node.d.ts" />
/// <reference path="patient.ts" />
var Domain;
(function (Domain) {
    var PatientEvent;
    (function (PatientEvent) {
        var PatientEventResult = (function () {
            function PatientEventResult(date, events) {
                this.Date = date;
                this.PatientEvents = events;
            }
            return PatientEventResult;
        })();
        PatientEvent.PatientEventResult = PatientEventResult;
        var Service = (function () {
            Service.$inject = ["httpService", "authService", "moment"];
            function Service(httpService, authService, moment) {
                "ngInject";
                this.httpService = httpService;
                this.authService = authService;
                this.moment = moment;
            }
            Service.prototype.getPatientEvents = function (practiceId) {
                return this.httpService.get(this.getUrl(practiceId) + 'patientevents');
            };
            Service.prototype.getPatientEventByPatientId = function (practiceId, patientId) {
                return this.httpService.get(this.getUrl(practiceId) + 'patientevents/bypatient/' + patientId);
            };
            Service.prototype.getPatientEventsByFilter = function (practiceId, filter) {
                var body = {
                    PracticeId: filter.practiceId || practiceId,
                    DaysToReturn: filter.daysToReturn || 7,
                    DateFrom: filter.dateFrom.format(),
                    DateTo: filter.dateTo.format(),
                    ExcludeStatuses: filter.excludeStatuses
                };
                return this.httpService.post(this.getUrl(practiceId) + 'patientevents', body);
            };
            Service.prototype.getMedicalinsurers = function (practiceId) {
                return this.httpService.get(this.getUrl(practiceId) + 'medicalinsurer');
            };
            Service.prototype.getUrl = function (practiceId) {
                return 'v1/' + practiceId + '/patientevent/';
            };
            return Service;
        })();
        PatientEvent.Service = Service;
    })(PatientEvent = Domain.PatientEvent || (Domain.PatientEvent = {}));
})(Domain || (Domain = {}));
angular.module('DoctorApp')
    .service('patientEventDomain', Domain.PatientEvent.Service);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../services/api/domain/patient-event.ts" />
/// <reference path="../../services/memory-service.ts" />
/// <reference path="../../screens/patient/patient-service.ts" />
var PatientVisits;
(function (PatientVisits) {
    var Service = (function () {
        Service.$inject = ["patientService", "patientEventDomain", "$q", "memoryService", "providerService", "locationService", "clinicalDomain"];
        function Service(patientService, patientEventDomain, $q, memoryService, providerService, locationService, clinicalDomain) {
            "ngInject";
            this.patientService = patientService;
            this.patientEventDomain = patientEventDomain;
            this.$q = $q;
            this.memoryService = memoryService;
            this.providerService = providerService;
            this.locationService = locationService;
            this.clinicalDomain = clinicalDomain;
        }
        Service.prototype.getPatientEvents = function (practiceId) {
            return this.patientEventDomain.getPatientEvents(practiceId);
        };
        Service.prototype.getPatientEventsByFilter = function (practiceId, filter) {
            return this.patientEventDomain.getPatientEventsByFilter(practiceId, filter);
        };
        Service.prototype.goToPatientTimeline = function (practiceId, patientId) {
            this.locationService.goToClinicalDashboard(practiceId, patientId);
        };
        Service.prototype.goToConsultation = function (practiceId, patientEvent) {
            var _this = this;
            this.isClinical(practiceId, patientEvent.PatientEventId)
                .then(function (isClinical) {
                if (isClinical) {
                    _this.locationService.goToEncounter(practiceId, patientEvent.PatientEventId);
                }
                else {
                    _this.goToPatientTimeline(practiceId, patientEvent.Patient.PatientId);
                }
            });
        };
        Service.prototype.isClinical = function (practiceId, patientEventId) {
            return this.clinicalDomain.getEncounterByPatientVisit(practiceId, patientEventId, null, true)
                .then(function (newEncounter) {
                return true;
            }, function (error) {
                var notFound = 'not found';
                if (notFound == error.toLowerCase()) {
                    return false;
                }
            });
        };
        return Service;
    })();
    PatientVisits.Service = Service;
})(PatientVisits || (PatientVisits = {}));
angular.module('DoctorApp')
    .service('patientVisitsService', PatientVisits.Service);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../../scripts/definition/moment/moment-node.d.ts" />
/// <reference path="../../directives/date-picker.ts" />
/// <reference path="../../services/api/domain/patient.ts" />
/// <reference path="../../services/api/domain/patient-event.ts" />
/// <reference path="../../services/show-dialog.ts" />
/// <reference path="../../screens/patient/patient-service.ts" />
/// <reference path="../../run.ts" />
/// <reference path="patient-visits-service.ts" />
var PatientVisits;
(function (PatientVisits) {
    var Controller = (function () {
        Controller.$inject = ["$scope", "$rootScope", "patientService", "showDialog", "$filter", "moment", "patientVisitsService", "$log", "$routeParams"];
        function Controller($scope, $rootScope, patientService, showDialog, $filter, moment, patientVisitsService, $log, $routeParams) {
            "ngInject";
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.patientService = patientService;
            this.showDialog = showDialog;
            this.$filter = $filter;
            this.moment = moment;
            this.patientVisitsService = patientVisitsService;
            this.$log = $log;
            this.$routeParams = $routeParams;
            var that = this;
            $scope.keyPressed = function (event) {
                that.keyEvent = event;
            };
            $scope.concatPatient = function (patientDetails) {
                return that.$filter('titlecase')(patientDetails.FirstName || '') + ' ' + (patientDetails.Surname || '');
            };
            $scope.goToConsultation = function (patientEvent) {
                patientVisitsService.goToConsultation(patientEvent.PracticeId, patientEvent);
            };
            $scope.claimResponse = function (patientEvent) {
                if (that.keyEvent && that.keyEvent.altKey) {
                    if (that.keyEvent.key == Controller.Q_KEY ||
                        that.keyEvent.which == 17 ||
                        that.keyEvent.charCode == Controller.Q_CHAR_CODE) {
                        patientService.claimResponse(patientEvent);
                    }
                    else if (that.keyEvent.key == Controller.W_KEY ||
                        that.keyEvent.which == 18 ||
                        that.keyEvent.charCode == Controller.W_CHAR_CODE) {
                        patientService.auditEvent($routeParams.practiceId, patientEvent);
                    }
                }
            };
            $scope.changeFilter = function () {
                that.loadPatientVisits();
            };
            $scope.changeFilterByDate = function (first) {
                if (first) {
                    $scope.configTo.min = $scope.dateFrom;
                }
                else {
                    $scope.configFrom.max = $scope.dateTo;
                }
                that.loadPatientVisits();
            };
            $scope.$watch('patientGroups', function () {
                $scope.patientsCount = $scope.patientGroups
                    .reduce(function (previousValue, currentValue) {
                    return previousValue + currentValue.PatientEvents.length;
                }, 0);
            });
            that.init();
        }
        Controller.prototype.init = function () {
            var that = this;
            that.$scope.patientGroups = [];
            that.$scope.patientsCount = 0;
            that.$scope.isOpenFilter = false;
            that.setDefaultDates();
            that.loadPatientVisits();
        };
        Controller.prototype.setDefaultDates = function () {
            var now = this.moment.utc();
            this.$scope.dateTo = this.moment(now);
            this.$scope.dateFrom = now.subtract(Controller.DAYS_IN_WEEK, 'days');
            var configFrom = new DatePickerModule.Config();
            configFrom.format = Controller.DATE_PATTERN;
            configFrom.max = this.$scope.dateTo;
            this.$scope.configFrom = configFrom;
            var configTo = new DatePickerModule.Config();
            configTo.format = Controller.DATE_PATTERN;
            configTo.min = this.$scope.dateFrom;
            this.$scope.configTo = configTo;
        };
        Controller.prototype.loadPatientVisits = function () {
            var that = this;
            this.getPatientVisitsQuery()
                .then(function (response) {
                var result = [];
                for (var _i = 0; _i < response.length; _i++) {
                    var item = response[_i];
                    if (item.Date !== "0001-01-01T00:00:00Z") {
                        result.push(item);
                    }
                }
                that.$scope.patientGroups = result;
            })
                .catch(function (error) {
                that.$log.error(error);
            });
        };
        Controller.prototype.getPatientVisitsQuery = function () {
            if (this.$scope.isOpenFilter) {
                var statuses = [];
                if (this.$scope.excludeCancelled) {
                    statuses = ["Canceled"];
                }
                var filter = {
                    dateFrom: this.moment(this.$scope.dateFrom),
                    dateTo: this.moment(this.$scope.dateTo),
                    excludeStatuses: statuses
                };
                return this.patientVisitsService.getPatientEventsByFilter(this.$routeParams.practiceId, filter);
            }
            else {
                return this.patientVisitsService.getPatientEvents(this.$routeParams.practiceId);
            }
        };
        Controller.DATE_PATTERN = 'dd MM, yy';
        Controller.DAYS_IN_WEEK = 7;
        Controller.Q_KEY = 'q';
        Controller.W_KEY = 'w';
        Controller.Q_CHAR_CODE = 17;
        Controller.W_CHAR_CODE = 18;
        return Controller;
    })();
    PatientVisits.Controller = Controller;
})(PatientVisits || (PatientVisits = {}));
angular.module('DoctorApp')
    .controller('PatientVisitsController', PatientVisits.Controller);
/// <reference path="../../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../components/modal/modal-service.ts" />
var UpdateAccountModalModule;
(function (UpdateAccountModalModule) {
    var UpdateAccountController = (function () {
        UpdateAccountController.$inject = ["model", "$scope", "modalService", "$modalInstance", "showDialog"];
        function UpdateAccountController(model, $scope, modalService, $modalInstance, showDialog) {
            "ngInject";
            this.$scope = $scope;
            this.modalService = modalService;
            this.$modalInstance = $modalInstance;
            this.showDialog = showDialog;
            $scope.patient = model.patient;
            $scope.message = model.message;
            $scope.decision = 1;
            $scope.ok = function () {
                $modalInstance.close($scope.decision);
            };
            $scope.cancel = function () {
                $modalInstance.dismiss();
            };
        }
        return UpdateAccountController;
    })();
    UpdateAccountModalModule.UpdateAccountController = UpdateAccountController;
})(UpdateAccountModalModule || (UpdateAccountModalModule = {}));
angular.module('DoctorApp')
    .controller('UpdateAccountController', UpdateAccountModalModule.UpdateAccountController);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../../scripts/definition/moment/moment-node.d.ts" />
/// <reference path="../../services/show-dialog.ts" />
/// <reference path="../../services/auth-service.ts" />
var PatientModule;
(function (PatientModule) {
    var CreateController = (function () {
        CreateController.$inject = ["$scope", "$rootScope", "locationService", "$filter", "patientService", "showDialog", "authService", "moment", "modalService", "$routeParams"];
        function CreateController($scope, $rootScope, locationService, $filter, patientService, showDialog, authService, moment, modalService, $routeParams) {
            "ngInject";
            var _this = this;
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.locationService = locationService;
            this.$filter = $filter;
            this.patientService = patientService;
            this.showDialog = showDialog;
            this.authService = authService;
            this.moment = moment;
            this.modalService = modalService;
            this.$routeParams = $routeParams;
            $scope.Action = "Add";
            $scope.medicalAids = [];
            $scope.plans = [];
            $scope.options = [];
            var configDatePicker = new DatePickerModule.Config();
            configDatePicker.format = 'dd MM, yy';
            configDatePicker.changeMonth = true;
            configDatePicker.changeYear = true;
            $scope.configDatePicker = configDatePicker;
            $scope.fileNoRegex = /^[a-zA-Z0-9\\W\s]+[\\s_/\\-a-zA-Z0-9]*$/;
            var DATE_PATTERN = 'dd MM, yy';
            var MIN_DATE = moment([1900, 0, 1]);
            $scope.mainMemberDoBTemp = {};
            $scope.memberSameAsPatient = false;
            $scope.mainTemp = {
                Title: "",
                FirstName: "",
                Surname: "",
                DateOfBirth: "",
                IdentityNo: "",
                Gender: "",
                ContactNo: "",
                EmailAddress: ""
            };
            $scope.mainMemberDetails =
                {
                    Title: "Mr",
                    FirstName: "",
                    Surname: "",
                    DateOfBirth: "",
                    IdentityNo: "",
                    Gender: "Male",
                    ContactNo: "",
                    EmailAddress: ""
                };
            $scope.newPatient = {
                PatientId: "00000000-0000-0000-0000-000000000000",
                PracticeId: $routeParams.practiceId,
                FileNo: "",
                PatientXRef: null,
                NavigationFrom: null,
                PatientDetails: {
                    Title: "Mr",
                    FirstName: "",
                    Surname: "",
                    DateOfBirth: "",
                    IdentityNo: "",
                    Gender: "Male",
                    ContactNo: "",
                    EmailAddress: ""
                },
                PatientAccountDetails: {
                    AccountId: "00000000-0000-0000-0000-000000000000",
                    AccountNo: "",
                    IsCashAccount: false,
                    MedicalAidName: "",
                    MedicalAidPlan: "",
                    MedicalAidPlanOption: "",
                    MedicalAidMembershipNumber: "",
                    MedicalAidDependentCode: "",
                    MedicalAidMainMemberDetails: {
                        Title: "",
                        FirstName: "",
                        Surname: "",
                        DateOfBirth: "",
                        IdentityNo: "",
                        Gender: "",
                        ContactNo: "",
                        EmailAddress: ""
                    },
                    MedicalAidRoutingCode: "",
                    MedicalAidOptionCode: ""
                }
            };
            $scope.datePattern = (function () {
                return {
                    test: function (value) {
                        var date = moment(value, DATE_PATTERN);
                        if (!date.isValid()) {
                            return false;
                        }
                        var maxDate = moment();
                        return (MIN_DATE.isBefore(date) || MIN_DATE.isSame(date)) && date.isBefore(maxDate);
                    }
                };
            })();
            $scope.changeFilterByDate = function (isMember) {
                if ($scope.memberSameAsPatient) {
                    if (isMember) {
                        $scope.newPatientDoB = $scope.mainMemberDoB;
                    }
                    else {
                        $scope.mainMemberDoB = $scope.newPatientDoB;
                    }
                }
            };
            var populateRoutingCode = function (patient) {
                if (patient.PatientAccountDetails.MedicalAidPlanOption) {
                    var option = $filter('filter')($scope.options, { Name: patient.PatientAccountDetails.MedicalAidPlanOption });
                    if (option.length > 0) {
                        patient.PatientAccountDetails.MedicalAidRoutingCode = option[0].RoutingCode;
                        patient.PatientAccountDetails.MedicalAidOptionCode = option[0].OptionCode;
                    }
                }
            };
            $scope.getPatientByAccNo = function (accountId) {
                if (accountId.length) {
                    _this.patientService.getPatientByAccNo($routeParams.practiceId, accountId.replace(/[\/,\\]+/g, '%2f'))
                        .then(function (patientAccountDetails) {
                        if (patientAccountDetails) {
                            _this.modalService
                                .confirm("You have entered an existing account number.  We will copy the member details for this account for you.")
                                .then(function () {
                                $scope.newPatient.PatientAccountDetails = patientAccountDetails;
                                _this.$scope.mainMemberDoB = moment.utc(patientAccountDetails.MedicalAidMainMemberDetails.DateOfBirth);
                                _this.$scope.mainMemberDetails = patientAccountDetails.MedicalAidMainMemberDetails;
                                _this.$scope.mainMemberDetails.FirstName = _this
                                    .$filter('titlecase')(patientAccountDetails.MedicalAidMainMemberDetails.FirstName);
                                _this.$scope.mainMemberDetails.Surname = _this
                                    .$filter('titlecase')(patientAccountDetails.MedicalAidMainMemberDetails.Surname);
                                _this.$scope.mainMemberDetails.EmailAddress = _this
                                    .$filter('lowercase')(patientAccountDetails.MedicalAidMainMemberDetails
                                    .EmailAddress);
                                _this.$scope.newPatient.PatientAccountDetails.MedicalAidDependentCode = "";
                                $scope.loadMedicalAids()
                                    .then(function () {
                                    $scope.updatePlanOptionDropdowns();
                                });
                            });
                        }
                    });
                }
            };
            $scope.init = function () {
                patientService.getPracticeXRef($routeParams.practiceId)
                    .then(function (practiceXRef) {
                    $scope.isIHealthProvider = practiceXRef && practiceXRef.contains("iHealth");
                    var prePopulatedPatientData = patientService.getPreCreatedPatient();
                    patientService.setPreCreatedPatient(null);
                    if (prePopulatedPatientData) {
                        $scope.newPatient = prePopulatedPatientData;
                        if (prePopulatedPatientData.PatientDetails.DateOfBirth) {
                            $scope.newPatientDoB = moment.utc(prePopulatedPatientData.PatientDetails.DateOfBirth);
                        }
                        $scope.mainMemberDoB = moment.utc(prePopulatedPatientData.PatientAccountDetails
                            .MedicalAidMainMemberDetails.DateOfBirth);
                        $scope.mainMemberDetails = angular
                            .copy($scope.newPatient.PatientAccountDetails.MedicalAidMainMemberDetails);
                        $scope.loadMedicalAids()
                            .then(function () {
                            $scope.updatePlanOptionDropdowns();
                        });
                    }
                    else {
                        $scope.loadMedicalAids();
                    }
                });
            };
            $scope.formatDob = function (date) {
                return moment.utc(date).format("DD/MM/YYYY");
            };
            $scope.changeMainMember = function () {
                if ($scope.memberSameAsPatient) {
                    $scope.mainTemp = angular.copy($scope.mainMemberDetails);
                    $scope.mainMemberDetails = $scope.newPatient.PatientDetails;
                    $scope.mainMemberDoBTemp = angular.copy($scope.mainMemberDoB);
                    $scope.mainMemberDoB = moment($scope.newPatientDoB);
                }
                else {
                    $scope.mainMemberDetails = $scope.mainTemp;
                    $scope.mainMemberDoB = $scope.mainMemberDoBTemp;
                }
            };
            $scope.updatePlanOptionDropdowns = function () {
                var medicalAid = $scope.newPatient.PatientAccountDetails.MedicalAidName;
                var plan = $scope.newPatient.PatientAccountDetails.MedicalAidPlan;
                for (var i = 0; i < $scope.medicalAids.length; i++) {
                    if ($scope.medicalAids[i].Name === medicalAid) {
                        $scope.plans = $scope.medicalAids[i].Plans;
                        for (var j = 0; j < $scope.plans.length; j++) {
                            if ($scope.plans[j].Name === plan) {
                                $scope.options = $scope.plans[j].Options;
                                break;
                            }
                        }
                        break;
                    }
                }
            };
            $scope.toTitleCase = function (value) {
                return $filter('titlecase')(value);
            };
            $scope.submitPatient = function (isValid) {
                if (isValid) {
                    var patientIdNo = $scope.newPatient.PatientDetails.IdentityNo || "";
                    var parsedDate = patientService.parseSaId(patientIdNo).date;
                    var memberIdNo = $scope.mainMemberDetails.IdentityNo || "";
                    var parsedMemberDate = patientService.parseSaId(memberIdNo).date;
                    if (patientIdNo !== "" && moment.utc(parsedDate).date() !== $scope.newPatientDoB.date() ||
                        memberIdNo !== "" && moment.utc(parsedMemberDate).date() !== $scope.mainMemberDoB.date()) {
                        modalService.confirm("ID Number and Date of Birth don't match.<br>Would you like to continue?")
                            .then(function () {
                            _this.submitPatient();
                        });
                    }
                    else {
                        _this.submitPatient();
                    }
                }
                else {
                    showDialog.error("Please enter valid info in the highlighted fields");
                }
            };
            $scope.saIdChanged = function (role) {
                if (role === 'patient' && $scope.newPatient.PatientDetails.IdentityNo) {
                    var id = $scope.newPatient.PatientDetails.IdentityNo;
                    var parsedId = patientService.parseSaId(id);
                    $scope.newPatientDoB = moment.utc(parsedId.date);
                    $scope.newPatient.PatientDetails.Gender = parsedId.gender;
                }
                if (role === 'member' && $scope.mainMemberDetails.IdentityNo && !$scope.memberSameAsPatient) {
                    var id = $scope.mainMemberDetails.IdentityNo;
                    var parsedId = patientService.parseSaId(id);
                    $scope.mainMemberDoB = moment.utc(parsedId.date);
                    $scope.mainMemberDetails.Gender = parsedId.gender;
                }
                $scope.changeFilterByDate(role === 'member');
            };
            $scope.loadMedicalAids = function () {
                return patientService.getMedicalAids($routeParams.practiceId)
                    .then(function (response) {
                    $scope.medicalAids = response;
                });
            };
            $scope.medicalAidChanged = function () {
                var maName = $scope.newPatient.PatientAccountDetails.MedicalAidName;
                $scope.newPatient.PatientAccountDetails.MedicalAidPlan = undefined;
                $scope.plans = [];
                $scope.newPatient.PatientAccountDetails.MedicalAidPlanOption = undefined;
                $scope.options = [];
                for (var i = 0; i < $scope.medicalAids.length; i++) {
                    if ($scope.medicalAids[i].Name === maName) {
                        $scope.plans = $scope.medicalAids[i].Plans;
                        break;
                    }
                }
                $scope.populateMedicalAidData();
            };
            $scope.planChanged = function () {
                var pName = $scope.newPatient.PatientAccountDetails.MedicalAidPlan;
                if (!pName) {
                    $scope.newPatient.PatientAccountDetails.MedicalAidPlanOption = undefined;
                    $scope.options = [];
                }
                else {
                    for (var i = 0; i < $scope.plans.length; i++) {
                        if ($scope.plans[i].Name === pName) {
                            $scope.options = $scope.plans[i].Options;
                            if ($scope.options.length > 0) {
                                $scope.newPatient.PatientAccountDetails.MedicalAidPlanOption = $scope.options[0].Name;
                            }
                            break;
                        }
                    }
                }
            };
            $scope.populateMedicalAidData = function () {
                var medicalAid = $scope.newPatient.PatientAccountDetails.MedicalAidName;
                if (medicalAid) {
                    for (var i = 0; i < $scope.medicalAids.length; i++) {
                        if ($scope.medicalAids[i].Name === medicalAid) {
                            if (($scope.medicalAids[i].Plans.length === 1) &&
                                (!$scope.newPatient.PatientAccountDetails.MedicalAidPlan)) {
                                $scope.newPatient.PatientAccountDetails
                                    .MedicalAidPlan = $scope.medicalAids[i].Plans[0].Name;
                                $scope.planChanged();
                                if (($scope.medicalAids[i].Plans[0].Options.length === 1) &&
                                    (!$scope.newPatient.PatientAccountDetails.MedicalAidPlanOption)) {
                                    $scope.newPatient.PatientAccountDetails
                                        .MedicalAidPlanOption = $scope.medicalAids[i].Plans[0].Options[0].Name;
                                }
                            }
                            break;
                        }
                    }
                }
            };
        }
        CreateController.prototype.submitPatient = function () {
            var _this = this;
            var copyPatient = angular.copy(this.$scope.newPatient);
            var copyMainMemberDetails = angular.copy(this.$scope.mainMemberDetails);
            copyPatient.PatientDetails.DateOfBirth = this.$scope.newPatientDoB.format(ServerDateFormat);
            copyPatient.PatientDetails.FirstName = this.$scope.toTitleCase(copyPatient.PatientDetails.FirstName);
            copyPatient.PatientDetails.Surname = this.$scope.toTitleCase(copyPatient.PatientDetails.Surname);
            copyPatient.PatientDetails.EmailAddress = this.$scope
                .toTitleCase(copyPatient.PatientDetails.EmailAddress);
            copyMainMemberDetails.DateOfBirth = this.$scope.mainMemberDoB.format(ServerDateFormat);
            copyMainMemberDetails.FirstName = this.$scope.toTitleCase(copyMainMemberDetails.FirstName);
            copyMainMemberDetails.Surname = this.$scope.toTitleCase(copyMainMemberDetails.Surname);
            copyMainMemberDetails.EmailAddress = this.$filter('lowercase')(copyMainMemberDetails.EmailAddress);
            copyPatient.PatientAccountDetails.MedicalAidMainMemberDetails = copyMainMemberDetails;
            if (copyPatient.PatientAccountDetails.IsCashAccount) {
            }
            else if (copyPatient.PatientAccountDetails.MedicalAidPlanOption) {
                var option = this.$filter('filter')(this.$scope.options, { Name: copyPatient.PatientAccountDetails.MedicalAidPlanOption });
                if (option.length > 0) {
                    copyPatient.PatientAccountDetails.MedicalAidRoutingCode = option[0].RoutingCode;
                    copyPatient.PatientAccountDetails.MedicalAidOptionCode = option[0].OptionCode;
                }
            }
            this.patientService.createNewPatient(this.$routeParams.practiceId, this.$scope.updateOtherPatientAccountDetails, copyPatient, this.$scope.isIHealthProvider)
                .then(function (response) {
                if (response.Sucess === false) {
                    _this.showDialog.error(response.ResponseMessage);
                }
                else {
                    if (!_this.$scope.newPatient || _this.$scope.newPatient.NavigationFrom !== 'UndeliveredPathReports') {
                        _this.patientService.addToWaitingRoom(_this.$routeParams.practiceId, response.Data)
                            .then(function (response) {
                            if (response.Sucess) {
                                _this.showDialog
                                    .info("The new patient was successfully added and is in the waiting room");
                                _this.$rootScope.back();
                            }
                            else {
                                _this.showDialog.error("Failed to check in patient " + response.ResponseMessage);
                            }
                        });
                    }
                    else {
                        _this.$rootScope.back();
                    }
                }
            });
        };
        return CreateController;
    })();
    PatientModule.CreateController = CreateController;
})(PatientModule || (PatientModule = {}));
angular.module('DoctorApp')
    .controller('PatientCreateController', PatientModule.CreateController);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../../scripts/definition/moment/moment-node.d.ts" />
/// <reference path="../../run.ts" />
/// <reference path="patient-service.ts" />
var PatientModule;
(function (PatientModule) {
    var EditController = (function () {
        EditController.$inject = ["$scope", "$rootScope", "locationService", "$filter", "patientService", "showDialog", "cfpLoadingBar", "moment", "$routeParams", "trackingService", "modalService", "storageService"];
        function EditController($scope, $rootScope, locationService, $filter, patientService, showDialog, cfpLoadingBar, moment, $routeParams, trackingService, modalService, storageService) {
            "ngInject";
            var _this = this;
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.locationService = locationService;
            this.$filter = $filter;
            this.patientService = patientService;
            this.showDialog = showDialog;
            this.cfpLoadingBar = cfpLoadingBar;
            this.moment = moment;
            this.$routeParams = $routeParams;
            this.trackingService = trackingService;
            this.modalService = modalService;
            this.storageService = storageService;
            this.populateRoutingCode = function (patient) {
                if (patient.PatientAccountDetails.MedicalAidPlanOption) {
                    var option = _this.$filter('filter')(_this.$scope.options, { Name: patient.PatientAccountDetails.MedicalAidPlanOption });
                    if (option.length > 0) {
                        patient.PatientAccountDetails.MedicalAidRoutingCode = option[0].RoutingCode;
                        patient.PatientAccountDetails.MedicalAidOptionCode = option[0].OptionCode;
                    }
                }
                else {
                    patient.PatientAccountDetails.MedicalAidRoutingCode = "";
                    patient.PatientAccountDetails.MedicalAidOptionCode = "";
                }
            };
            $scope.Action = "Edit";
            $scope.medicalAids = [];
            $scope.plans = [];
            $scope.options = [];
            $scope.updateOtherPatientAccountDetails = -1;
            var configDatePicker = new DatePickerModule.Config();
            configDatePicker.format = 'dd MM, yy';
            configDatePicker.changeMonth = true;
            configDatePicker.changeYear = true;
            $scope.configDatePicker = configDatePicker;
            $scope.fileNoRegex = /^[a-zA-Z0-9\\W\s]+[\\s_/\\-a-zA-Z0-9]*$/;
            var DATE_PATTERN = 'dd MM, yy';
            var MIN_DATE = moment([1900, 0, 1]);
            storageService.setPracticeId($routeParams.practiceId);
            $scope.datePattern = (function () {
                return {
                    test: function (value) {
                        var date = moment(value, DATE_PATTERN);
                        if (!date.isValid()) {
                            return false;
                        }
                        var maxDate = moment();
                        return (MIN_DATE.isBefore(date) || MIN_DATE.isSame(date)) && (date.isBefore(maxDate) || $scope.isIHealthProvider);
                    }
                };
            })();
            $scope.changeFilterByDate = function (isMember) {
                if ($scope.memberSameAsPatient) {
                    if (isMember) {
                        $scope.newPatientDoB = $scope.mainMemberDoB;
                    }
                    else {
                        $scope.mainMemberDoB = $scope.newPatientDoB;
                    }
                }
            };
            $scope.init = function () {
                var patient;
                _this.patientService.getPatientById($routeParams.practiceId, $routeParams.patientId)
                    .then(function (patientResponse) {
                    patient = patientResponse;
                    if (!patient)
                        _this.locationService.goToHome($routeParams.practiceId);
                    if (_this.$rootScope.PatientDetailsIncomplete) {
                        var message = patient.PatientDetails.FirstName +
                            " checked into the waiting room. \n" +
                            "Patient information not complete. Please review and save patient information to proceed.";
                        showDialog.info(message);
                    }
                    _this.$scope.newPatient = patient;
                    _this.$scope.mainTemp = {
                        Title: "",
                        FirstName: "",
                        Surname: "",
                        DateOfBirth: "",
                        IdentityNo: "",
                        Gender: "",
                        ContactNo: "",
                        EmailAddress: ""
                    };
                    _this.$scope.mainMemberDoBTemp = {};
                    var pInfo = patient.PatientDetails;
                    var mInfo = patient.PatientAccountDetails.MedicalAidMainMemberDetails;
                    if ((pInfo.Title == mInfo.Title) &&
                        (pInfo.FirstName == mInfo.FirstName) &&
                        (pInfo.Surname == mInfo.Surname) &&
                        (pInfo.EmailAddress == mInfo.EmailAddress) &&
                        (pInfo.DateOfBirth == mInfo.DateOfBirth) &&
                        (pInfo.IdentityNo == mInfo.IdentityNo) &&
                        (pInfo.Gender == mInfo.Gender) &&
                        (pInfo.ContactNo == mInfo.ContactNo)) {
                        _this.$scope.memberSameAsPatient = true;
                    }
                    else {
                        _this.$scope.memberSameAsPatient = false;
                    }
                    _this.$scope.newPatientDoB = moment.utc(patient.PatientDetails.DateOfBirth);
                    _this.$scope.mainMemberDoB = moment.utc(patient.PatientAccountDetails.MedicalAidMainMemberDetails.DateOfBirth);
                    _this.$scope.mainMemberDetails = patient.PatientAccountDetails.MedicalAidMainMemberDetails;
                    _this.$scope.newPatient.PatientDetails.DateOfBirth = _this
                        .$filter('date')(new Date(patient.PatientDetails.DateOfBirth), PatientDateFormat);
                    _this.$scope.newPatient.PatientDetails.FirstName = _this
                        .$filter('titlecase')(patient.PatientDetails.FirstName);
                    _this.$scope.newPatient.PatientDetails.Surname = _this
                        .$filter('titlecase')(patient.PatientDetails.Surname);
                    _this.$scope.newPatient.PatientDetails.EmailAddress = _this
                        .$filter('lowercase')(patient.PatientDetails.EmailAddress);
                    _this.$scope.mainMemberDetails.DateOfBirth = _this
                        .$filter('date')(new Date(patient.PatientAccountDetails.MedicalAidMainMemberDetails
                        .DateOfBirth), PatientDateFormat);
                    _this.$scope.mainMemberDetails.FirstName = _this
                        .$filter('titlecase')(patient.PatientAccountDetails.MedicalAidMainMemberDetails.FirstName);
                    _this.$scope.mainMemberDetails.Surname = _this
                        .$filter('titlecase')(patient.PatientAccountDetails.MedicalAidMainMemberDetails.Surname);
                    _this.$scope.mainMemberDetails.EmailAddress = _this
                        .$filter('lowercase')(patient.PatientAccountDetails.MedicalAidMainMemberDetails
                        .EmailAddress);
                    _this.$scope.newPatient.PatientAccountDetails.MedicalAidName = _this
                        .$filter('uppercase')(patient.PatientAccountDetails.MedicalAidName);
                    _this.$scope.newPatient.PatientAccountDetails.MedicalAidPlan = _this
                        .$filter('uppercase')(patient.PatientAccountDetails.MedicalAidPlan);
                    _this.$scope.newPatient.PatientAccountDetails
                        .MedicalAidPlanOption = patient.PatientAccountDetails.MedicalAidPlanOption;
                    if (_this.$scope.memberSameAsPatient) {
                        _this.$scope.changeMainMember();
                    }
                    _this.$scope.loadMedicalAids();
                    _this.patientService.getPracticeXRef($routeParams.practiceId)
                        .then(function (practiceXRef) {
                        $scope.isIHealthProvider = practiceXRef.contains("iHealth");
                        if ($scope.isIHealthProvider) {
                            $scope.fileNoRegex = new RegExp('');
                        }
                        if (!_this.$scope.newPatientDoB) {
                            _this.$scope.newPatientDoB = MIN_DATE;
                        }
                    });
                    _this.trackingService.openedPatientDetails(patient);
                });
            };
            $scope.changeMainMember = function () {
                if ($scope.memberSameAsPatient) {
                    $scope.mainTemp = angular.copy($scope.mainMemberDetails);
                    $scope.mainMemberDetails = $scope.newPatient.PatientDetails;
                    $scope.mainMemberDoBTemp = angular.copy($scope.mainMemberDoB);
                    $scope.mainMemberDoB = moment($scope.newPatientDoB);
                }
                else {
                    $scope.mainMemberDetails = $scope.mainTemp;
                    $scope.mainMemberDoB = $scope.mainMemberDoBTemp;
                }
            };
            $scope.submitPatient = function (isValid) {
                if (isValid) {
                    var patientIdNo = $scope.newPatient.PatientDetails.IdentityNo || "";
                    var parsedDate = patientService.parseSaId(patientIdNo).date;
                    var memberIdNo = $scope.mainMemberDetails.IdentityNo || "";
                    var parsedMemberDate = patientService.parseSaId(memberIdNo).date;
                    if ((patientIdNo !== "" && parsedDate !== $scope.newPatientDoB.format("YYYY/MM/DD")) ||
                        (memberIdNo !== "" && parsedMemberDate !== $scope.mainMemberDoB.format("YYYY/MM/DD"))) {
                        modalService.confirm("ID Number and Date of Birth don't match.<br>Would you like to continue?")
                            .then(function () {
                            _this.submitPatient();
                        });
                    }
                    else {
                        _this.submitPatient();
                    }
                }
                else {
                    showDialog.error("Please enter valid info in the highlighted fields");
                }
            };
            $scope.saIdChanged = function (role) {
                if (role === 'patient' && $scope.newPatient.PatientDetails.IdentityNo) {
                    var id = $scope.newPatient.PatientDetails.IdentityNo;
                    var parsedId = patientService.parseSaId(id);
                    $scope.newPatientDoB = moment.utc(parsedId.date);
                    $scope.newPatient.PatientDetails.Gender = parsedId.gender;
                }
                if (role === 'member' && $scope.mainMemberDetails.IdentityNo && !$scope.memberSameAsPatient) {
                    var id = $scope.mainMemberDetails.IdentityNo;
                    var parsedId = patientService.parseSaId(id);
                    $scope.mainMemberDoB = moment.utc(parsedId.date);
                    $scope.mainMemberDetails.Gender = parsedId.gender;
                }
                $scope.changeFilterByDate(role === 'member');
            };
            $scope.loadMedicalAids = function () {
                cfpLoadingBar.start();
                patientService.getMedicalAids($routeParams.practiceId)
                    .then(function (response) {
                    cfpLoadingBar.complete();
                    $scope.medicalAids = response;
                    var medicalAid = $scope.newPatient.PatientAccountDetails.MedicalAidName;
                    var plan = $scope.newPatient.PatientAccountDetails.MedicalAidPlan;
                    for (var i = 0; i < $scope.medicalAids.length; i++) {
                        if ($scope.medicalAids[i].Name == medicalAid) {
                            $scope.plans = $scope.medicalAids[i].Plans;
                            for (var j = 0; j < $scope.plans.length; j++) {
                                if ($scope.plans[j].Name == plan) {
                                    $scope.options = $scope.plans[j].Options;
                                    break;
                                }
                            }
                            break;
                        }
                    }
                    $scope.populateMedicalAidData();
                    _this.populateRoutingCode($scope.newPatient);
                });
            };
            $scope.medicalAidChanged = function () {
                var maName = $scope.newPatient.PatientAccountDetails.MedicalAidName;
                $scope.newPatient.PatientAccountDetails.MedicalAidPlan = "";
                $scope.plans = [];
                $scope.newPatient.PatientAccountDetails.MedicalAidPlanOption = "";
                $scope.options = [];
                for (var i = 0; i < $scope.medicalAids.length; i++) {
                    if ($scope.medicalAids[i].Name == maName) {
                        $scope.plans = $scope.medicalAids[i].Plans;
                        break;
                    }
                }
                $scope.populateMedicalAidData();
            };
            $scope.planChanged = function () {
                var pName = $scope.newPatient.PatientAccountDetails.MedicalAidPlan;
                if (pName === "") {
                    $scope.newPatient.PatientAccountDetails.MedicalAidPlanOption = "";
                    $scope.options = [];
                }
                else {
                    for (var i = 0; i < $scope.plans.length; i++) {
                        if ($scope.plans[i].Name == pName) {
                            $scope.options = $scope.plans[i].Options;
                            if ($scope.options.length > 0) {
                                $scope.newPatient.PatientAccountDetails.MedicalAidPlanOption = $scope.options[0].Name;
                            }
                            break;
                        }
                    }
                }
            };
            $scope.populateMedicalAidData = function () {
                var medicalAid = $scope.newPatient.PatientAccountDetails.MedicalAidName;
                if (medicalAid) {
                    for (var i = 0; i < $scope.medicalAids.length; i++) {
                        if ($scope.medicalAids[i].Name == medicalAid) {
                            if (($scope.medicalAids[i].Plans.length == 1) &&
                                (!$scope.newPatient.PatientAccountDetails.MedicalAidPlan)) {
                                $scope.newPatient.PatientAccountDetails
                                    .MedicalAidPlan = $scope.medicalAids[i].Plans[0].Name;
                                $scope.planChanged();
                                if (($scope.medicalAids[i].Plans[0].Options.length == 1) &&
                                    (!$scope.newPatient.PatientAccountDetails.MedicalAidPlanOption)) {
                                    $scope.newPatient.PatientAccountDetails
                                        .MedicalAidPlanOption = $scope.medicalAids[i].Plans[0].Options[0].Name;
                                }
                            }
                            break;
                        }
                    }
                }
            };
        }
        EditController.prototype.submitPatient = function () {
            var _this = this;
            this.cfpLoadingBar.start();
            var copyPatient = angular.copy(this.$scope.newPatient);
            var copyMainMemberDetails = angular.copy(this.$scope.mainMemberDetails);
            var patientDateOfBirth = this.$scope.newPatientDoB.format(ServerDateFormat);
            copyPatient.PatientDetails.DateOfBirth = patientDateOfBirth;
            copyPatient.PatientDetails.FirstName = this.$filter('titlecase')(copyPatient.PatientDetails.FirstName);
            copyPatient.PatientDetails.Surname = this.$filter('titlecase')(copyPatient.PatientDetails.Surname);
            copyPatient.PatientDetails
                .EmailAddress = this.$filter('lowercase')(copyPatient.PatientDetails.EmailAddress);
            var memberDateOfBirth = this.$scope.mainMemberDoB.format(ServerDateFormat);
            copyMainMemberDetails.DateOfBirth = memberDateOfBirth;
            copyMainMemberDetails.FirstName = this.$filter('titlecase')(copyMainMemberDetails.FirstName);
            copyMainMemberDetails.Surname = this.$filter('titlecase')(copyMainMemberDetails.Surname);
            copyMainMemberDetails.EmailAddress = this.$filter('lowercase')(copyMainMemberDetails.EmailAddress);
            copyPatient.PatientAccountDetails.MedicalAidMainMemberDetails = copyMainMemberDetails;
            if (copyPatient.PatientAccountDetails.IsCashAccount) {
            }
            this.populateRoutingCode(copyPatient);
            this.patientService.changePatient(this.$routeParams.practiceId, this.$scope.updateOtherPatientAccountDetails, copyPatient, this.$scope.isIHealthProvider)
                .then(function (response) {
                _this.cfpLoadingBar.complete();
                if (response.Sucess === false) {
                    _this.showDialog.error(response.ResponseMessage);
                }
                else if (response.Sucess === true) {
                    setTimeout(function () {
                        //  copyPatient.PatientDetails.DateOfBirth = $filter('date')(copyPatient.PatientDetails.DateOfBirth, consultationDateFormat);
                        //
                        //  copyPatient.PatientAccountDetails.MedicalAidMainMemberDetails.DateOfBirth =
                        //  $filter('date')(copyPatient.PatientAccountDetails.MedicalAidMainMemberDetails.DateOfBirth, consultationDateFormat);
                        _this.$rootScope.selectedPatient = copyPatient;
                        _this.trackingService.editedPatientDetails(copyPatient);
                        _this.$rootScope.back();
                    }, 0);
                }
                else {
                    _this.showDialog.error("Error of changing patient.");
                }
            });
        };
        return EditController;
    })();
    PatientModule.EditController = EditController;
})(PatientModule || (PatientModule = {}));
angular.module('DoctorApp')
    .controller('PatientEditController', PatientModule.EditController);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../run.ts" />
var PowerBIModule;
(function (PowerBIModule) {
    var ReportListController = (function () {
        ReportListController.$inject = ["$scope", "$rootScope", "$routeParams", "powerbiService", "locationService", "showDialog"];
        function ReportListController($scope, $rootScope, $routeParams, powerbiService, locationService, showDialog) {
            "ngInject";
            var _this = this;
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.$routeParams = $routeParams;
            this.powerbiService = powerbiService;
            this.locationService = locationService;
            this.showDialog = showDialog;
            this.getReports($routeParams.practiceId);
            $scope.goToReport = function (report) {
                _this.locationService.goToPowerBiReport(_this.$routeParams.practiceId, report.reportId);
            };
        }
        ReportListController.prototype.getReports = function (practiceId) {
            var _this = this;
            this.$rootScope.showProgressScreen = true;
            this.powerbiService.getReports(practiceId)
                .then(function (response) {
                if (response) {
                    _this.$scope.reports = response;
                }
                else {
                    _this.showDialog.error("Can't get reports list.");
                }
            }).finally(function () {
                _this.$rootScope.showProgressScreen = false;
            });
        };
        return ReportListController;
    })();
    PowerBIModule.ReportListController = ReportListController;
})(PowerBIModule || (PowerBIModule = {}));
angular.module('DoctorApp')
    .controller('PowerBIListController', PowerBIModule.ReportListController);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../run.ts" />
var PowerBIModule;
(function (PowerBIModule) {
    var ReportController = (function () {
        ReportController.$inject = ["$sce", "$scope", "$rootScope", "$routeParams", "powerbiService", "usageService"];
        function ReportController($sce, $scope, $rootScope, $routeParams, powerbiService, usageService) {
            "ngInject";
            this.$sce = $sce;
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.$routeParams = $routeParams;
            this.powerbiService = powerbiService;
            this.usageService = usageService;
            this.getReport($routeParams.practiceId, $routeParams.reportId);
        }
        ReportController.prototype.getReport = function (practiceId, reportId) {
            var _this = this;
            this.powerbiService.getReport(practiceId, reportId)
                .then(function (resp) {
                _this.$scope.report = resp;
                var models = window['powerbi-client'].models;
                var permissions = models.Permissions.All;
                var config = {
                    type: 'report',
                    tokenType: models.TokenType.Embed,
                    accessToken: resp.accessToken,
                    embedUrl: resp.embedUrl,
                    id: resp.reportId,
                    permissions: permissions,
                    settings: {
                        filterPaneEnabled: false,
                        navContentPaneEnabled: true
                    }
                };
                var embedContainer = $('#embedContainer')[0];
                var report = powerbi.embed(embedContainer, config);
                _this.usageService.openPowerBI(practiceId, _this.$scope.report);
            });
        };
        return ReportController;
    })();
    PowerBIModule.ReportController = ReportController;
})(PowerBIModule || (PowerBIModule = {}));
angular.module('DoctorApp')
    .controller('PowerBIController', PowerBIModule.ReportController);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../run.ts" />
/// <reference path="../../global.ts" />
var PracticeModule;
(function (PracticeModule) {
    var OptionsController = (function () {
        OptionsController.$inject = ["$scope", "$filter", "$rootScope", "showDialog", "practiceService", "patientService", "$routeParams"];
        function OptionsController($scope, $filter, $rootScope, showDialog, practiceService, patientService, $routeParams) {
            "ngInject";
            var _this = this;
            this.$scope = $scope;
            this.$filter = $filter;
            this.$rootScope = $rootScope;
            this.showDialog = showDialog;
            this.practiceService = practiceService;
            this.patientService = patientService;
            this.$routeParams = $routeParams;
            $scope.removeOption = function (index) {
                $scope.options.splice(index, 1);
            };
            $scope.addOption = function (key) {
                var options = $scope.options;
                options[options.length] = { key: key || '', value: '', showButton: true };
            };
            $scope.saveOptions = function () {
                var practiceId = $routeParams.practiceId;
                var options = angular.copy($scope.options);
                if (_this.checkOptionsValid(options)) {
                    _this.removeRepeatOptions(options);
                    if (options.length) {
                        practiceService.saveOptions(practiceId, _this.convertArrToObjOptions(options));
                    }
                    $rootScope.back();
                }
                else {
                    showDialog.error("Option names are not unique");
                }
            };
            this.init();
        }
        OptionsController.prototype.init = function () {
            var _this = this;
            var practiceId = this.$routeParams.practiceId;
            this.practiceService.getPracticeById(practiceId)
                .then(function (practice) {
                var options = _this.convertObjToArr(practice.Options);
                _this.$scope.options = options;
                _this.fillDefaultValue(_this.$scope.options);
                _this.$scope.options = _this.$filter("orderBy")(_this.$scope.options, function (value) {
                    return value.key;
                });
                _this.$scope.options = _this.$filter('filter')(_this.$scope.options, function (value) {
                    return value.key !== "IsDisabledForSendingBillingInstructions";
                });
                if (!_this.$scope.options.length) {
                    _this.$scope.addOption();
                }
            });
        };
        OptionsController.prototype.fillDefaultValue = function (options) {
            var keys = GlobalVar.optionKeys;
            for (var i = 0; i < keys.length; i++) {
                var option = this.findByKey(options, keys[i]);
                if (!option) {
                    this.$scope.addOption(keys[i]);
                }
            }
        };
        OptionsController.prototype.findByKey = function (options, key) {
            for (var i = 0; i < options.length; i++) {
                if (options[i].key == key) {
                    return options[i];
                }
            }
        };
        OptionsController.prototype.convertArrToObjOptions = function (arr) {
            var obj = {};
            for (var i in arr) {
                var item = arr[i];
                obj[item.key] = item.value;
            }
            return obj;
        };
        OptionsController.prototype.convertObjToArr = function (obj) {
            var arr = [];
            var options = obj || {};
            for (var i in options) {
                arr[arr.length] = {
                    key: i,
                    value: options[i]
                };
            }
            return arr;
        };
        OptionsController.prototype.removeRepeatOptions = function (options) {
            var i = options.length;
            while (i--) {
                if (!options[i].key) {
                    options.splice(i, 1);
                }
            }
            return options;
        };
        OptionsController.prototype.checkOptionsValid = function (options) {
            for (var i = 0; i < options.length; i++) {
                for (var j = i + 1; j < options.length; j++) {
                    if (options[i].key && options[i].key == options[j].key) {
                        return false;
                    }
                }
            }
            return true;
        };
        return OptionsController;
    })();
    PracticeModule.OptionsController = OptionsController;
})(PracticeModule || (PracticeModule = {}));
angular.module('DoctorApp')
    .controller('PracticeOptionsController', PracticeModule.OptionsController);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../run.ts" />
/// <reference path="practice-service.ts" />
var PracticeModule;
(function (PracticeModule) {
    var PracticeCreateController = (function () {
        PracticeCreateController.$inject = ["$rootScope", "$scope", "practiceService", "$filter", "showDialog", "tenantDomainService", "locationService"];
        function PracticeCreateController($rootScope, $scope, practiceService, $filter, showDialog, tenantDomainService, locationService) {
            "ngInject";
            var _this = this;
            this.$rootScope = $rootScope;
            this.$scope = $scope;
            this.practiceService = practiceService;
            this.$filter = $filter;
            this.showDialog = showDialog;
            this.tenantDomainService = tenantDomainService;
            this.locationService = locationService;
            $scope.savePractice = function (isValid) {
                if (!isValid) {
                    _this.showDialog.error("Please enter valid info in the highlighted fields !");
                    return;
                }
                $scope.practice.NetworkedSchemes = _this.practiceService.convertSchemesToArrStrings(_this.$scope.selectedSchemes, _this.$scope.selectSchemes);
                $scope.practice.ManualPricingSchemes = _this.practiceService.convertSchemesToArrStrings(_this.$scope.manualSelectedSchemes, _this.$scope.manualSelectSchemes);
                practiceService.createPractice($scope.practice)
                    .then(function (response) {
                    if (response.Sucess === false) {
                        showDialog.error(response.ResponseMessage);
                    }
                    else {
                        _this.showDialog.info("The new practice was successfully created.");
                        _this.$rootScope.back();
                    }
                });
            };
            $scope.addAllManualSchemes = function () {
                var items = angular.copy(_this.$scope.medSchemes);
                _this.$scope.manualSelectedSchemes = _this.practiceService.buildSchemes(items);
            };
            $scope.setSpeciality = function () {
                $scope.practice.SpecialityCode = $scope.specialityRule.SpecialityCode;
                $scope.practice.SpecialityDescription = $scope.specialityRule.Speciality;
            };
            this.init();
        }
        PracticeCreateController.prototype.init = function () {
            var _this = this;
            this.$scope.isCreate = true;
            this.$scope.selectedSchemes = [];
            this.$scope.selectSchemes = [];
            this.$scope.manualSelectedSchemes = [];
            this.$scope.manualSelectSchemes = [];
            var practice = new Domain.Billing.Provider(StorageModule.Service.ZERO_PRACTICE_ID);
            this.$scope.practice = practice;
            this.practiceService.getMedSchemes(practice.PracticeId)
                .then(function (medSchemes) {
                _this.$scope.medSchemes = medSchemes;
                _this.$scope.selectSchemes = _this.practiceService.buildSchemes(medSchemes);
                _this.$scope.manualSelectSchemes = _this.practiceService.buildManualSchemes(medSchemes);
            });
            this.tenantDomainService.getTenantList()
                .then(function (response) {
                _this.$scope.PracticeTenantIds = response;
            });
            this.practiceService.getSpecialityRules()
                .then(function (specialityRules) {
                _this.$scope.specialityRules = _this.$filter('orderBy')(specialityRules, "Speciality");
            });
        };
        PracticeCreateController.prototype.loadSpecialityRules = function () {
            var _this = this;
            this.practiceService.getSpecialityRules()
                .then(function (specialityRules) {
                _this.$scope.specialityRules = specialityRules;
                _this.$scope.specialityRule = _this.$filter('filter')(specialityRules, { SpecialityCode: _this.$scope.practice.SpecialityCode })[0];
                _this.$scope.practice.SpecialityDescription = _this.$scope.specialityRule.Speciality;
            });
        };
        return PracticeCreateController;
    })();
    PracticeModule.PracticeCreateController = PracticeCreateController;
})(PracticeModule || (PracticeModule = {}));
angular.module('DoctorApp')
    .controller('PracticeCreateController', PracticeModule.PracticeCreateController);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../run.ts" />
/// <reference path="practice-service.ts" />
var PracticeModule;
(function (PracticeModule) {
    var REMOVE_ALL = "Remove All";
    var EditController = (function () {
        EditController.$inject = ["$scope", "$rootScope", "practiceService", "tenantDomainService", "showDialog", "$filter", "locationService", "$routeParams"];
        function EditController($scope, $rootScope, practiceService, tenantDomainService, showDialog, $filter, locationService, $routeParams) {
            "ngInject";
            var _this = this;
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.practiceService = practiceService;
            this.tenantDomainService = tenantDomainService;
            this.showDialog = showDialog;
            this.$filter = $filter;
            this.locationService = locationService;
            this.$routeParams = $routeParams;
            $scope.savePractice = function (isValid) {
                if (!isValid) {
                    _this.showDialog.error("Please enter valid info in the highlighted fields !");
                    return;
                }
                $scope.practice.NetworkedSchemes = _this.practiceService.convertSchemesToArrStrings($scope.selectedSchemes, $scope.selectSchemes);
                $scope.practice.ManualPricingSchemes = _this.practiceService.convertSchemesToArrStrings($scope.manualSelectedSchemes, $scope.manualSelectSchemes);
                practiceService.updatePractice($scope.practice)
                    .then(function (response) {
                    if (response.Sucess === false) {
                        showDialog.error(response.ResponseMessage);
                    }
                    else {
                        $rootScope.back();
                    }
                });
            };
            $scope.goToSpecRule = function (rule) {
                locationService.goToEditSpecialityRule(rule.SpecialityCode);
            };
            $scope.addAllManualSchemes = function () {
                var items = angular.copy(_this.$scope.medSchemes);
                _this.$scope.manualSelectedSchemes = _this.practiceService.buildSchemes(items);
            };
            $scope.setSpeciality = function () {
                $scope.practice.SpecialityCode = $scope.specialityRule.SpecialityCode;
                $scope.practice.SpecialityDescription = $scope.specialityRule.Speciality;
            };
            $scope.afterSelectItem = function (item) {
                if (item.name === REMOVE_ALL || _this.$scope.manualSelectedSchemes.some(function (a) { return a.name === REMOVE_ALL; })) {
                    showDialog.confirm("Would you like to remove all already selected manual pricing schemes?", null, false, ['Yes', 'No'])
                        .then(function () { return _this.$scope.manualSelectedSchemes = []; })
                        .catch(function () { return _this.$scope.manualSelectedSchemes = _this.$scope.manualSelectedSchemes.filter(function (f) { return f.name !== REMOVE_ALL; }); });
                }
            };
            this.init();
        }
        EditController.prototype.init = function () {
            var _this = this;
            this.$scope.isCreate = false;
            this.$scope.selectedSchemes = [];
            this.$scope.selectSchemes = [];
            this.$scope.manualSelectedSchemes = [];
            this.$scope.manualSelectSchemes = [];
            var practiceId = this.$routeParams.practiceId;
            this.practiceService.getPracticeById(practiceId)
                .then(function (practice) {
                _this.$scope.practice = practice;
                _this.loadSpecialityRules();
                return _this.practiceService.getMedSchemes(practiceId);
            })
                .then(function (medSchemes) {
                _this.$scope.medSchemes = medSchemes;
                _this.$scope.selectSchemes = _this.practiceService.buildSchemes(medSchemes);
                _this.$scope.manualSelectSchemes = [new PracticeModule.Option(0, REMOVE_ALL, "")].concat(_this.practiceService.buildManualSchemes(medSchemes));
                _this.loadSchemesForShow();
            });
            this.tenantDomainService.getTenantList()
                .then(function (response) {
                _this.$scope.PracticeTenantIds = response;
            });
        };
        EditController.prototype.loadSpecialityRules = function () {
            var _this = this;
            this.practiceService.getSpecialityRules()
                .then(function (specialityRules) {
                _this.$scope.specialityRules = specialityRules;
                _this.$scope.specialityRule = _this.$filter('filter')(specialityRules, { SpecialityCode: _this.$scope.practice.SpecialityCode })[0];
                if (!_this.$scope.practice.SpecialityDescription) {
                    _this.$scope.practice.SpecialityDescription = _this.$scope.specialityRule.Speciality;
                }
            });
        };
        EditController.prototype.loadSchemesForShow = function () {
            var practice = this.$scope.practice;
            this.$scope.selectedSchemes = this.practiceService.convertSchemesToArrObjects(practice.NetworkedSchemes, this.$scope.selectSchemes);
            this.$scope.manualSelectedSchemes = this.practiceService.convertSchemesToArrObjects(practice.ManualPricingSchemes, this.$scope.manualSelectSchemes);
        };
        return EditController;
    })();
    PracticeModule.EditController = EditController;
})(PracticeModule || (PracticeModule = {}));
angular.module('DoctorApp')
    .controller('PracticeEditController', PracticeModule.EditController);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../services/memory-service.ts" />
/// <reference path="../../run.ts" />
var PracticeModule;
(function (PracticeModule) {
    var PracticesController = (function () {
        PracticesController.$inject = ["$scope", "$rootScope", "practiceService", "showDialog", "$filter", "memoryService", "locationService", "$routeParams"];
        function PracticesController($scope, $rootScope, practiceService, showDialog, $filter, memoryService, locationService, $routeParams) {
            "ngInject";
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.practiceService = practiceService;
            this.showDialog = showDialog;
            this.$filter = $filter;
            this.memoryService = memoryService;
            this.locationService = locationService;
            this.$routeParams = $routeParams;
            $scope.practices = [];
            $scope.pageSize = 10;
            $scope.pageNo = 0;
            $scope.allPagesLoaded = false;
            $scope.goToCreatePractice = function () {
                locationService.goToCreatePractice();
            };
            $scope.goToPractice = function (practice) {
                locationService.goToHome(practice.PracticeId);
            };
            $scope.goToUsers = function (practice) {
                locationService.goToUsers(practice.PracticeId);
            };
            $scope.goToEditPractice = function (practice) {
                locationService.goToEditPractice(practice.PracticeId);
            };
            $scope.goToEditSpecialityCode = function (practice) {
                locationService.goToEditSpecialityRule(practice.SpecialityCode);
            };
            $scope.goToEditOptions = function (practice) {
                locationService.goToPracticeOptions(practice.PracticeId);
            };
            $scope.deletePractice = function (practice) {
                showDialog.confirm("Are you sure want to delete practice: " + practice.PracticeName)
                    .then(function () {
                    return practiceService.deletePractice(practice.PracticeId);
                })
                    .then(function (response) {
                    if (response.Sucess === false) {
                        showDialog.error(response.ResponseMessage);
                    }
                    else {
                        $scope.doSearch();
                    }
                });
            };
            $scope.loadNextPage = function () {
                if (!$scope.allPagesLoaded && !$scope.isRunningPage) {
                    $scope.pageNo = $scope.pageNo + 1;
                    $scope.isRunningPage = true;
                    practiceService.getProvidersPageAndSearch($scope.searchText, $scope.pageNo, $scope.pageSize)
                        .then(function (practicesPage) {
                        if (practicesPage) {
                            for (var i = 0; i < practicesPage.length; i++) {
                                $scope.practices.push(practicesPage[i]);
                            }
                        }
                        $scope.allPagesLoaded = !practicesPage ||
                            practicesPage.length !== $scope.pageSize;
                        $scope.isRunningPage = false;
                    });
                }
            };
            $scope.doSearch = function () {
                var text = $scope.searchText;
                memoryService.practices.searchText = text;
                $scope.pageNo = 0;
                $scope.practices = [];
                practiceService.getProvidersPageAndSearch(text, $scope.pageNo, $scope.pageSize)
                    .then(function (practicesPage) {
                    $scope.practices = practicesPage;
                    $scope.allPagesLoaded = !practicesPage ||
                        practicesPage.length !== $scope.pageSize;
                    $scope.isRunningPage = false;
                });
            };
            this.init();
        }
        PracticesController.prototype.init = function () {
            this.$scope.practices = [];
            this.$scope.searchText = this.memoryService.practices.searchText;
            this.$scope.doSearch();
        };
        return PracticesController;
    })();
    PracticeModule.PracticesController = PracticesController;
})(PracticeModule || (PracticeModule = {}));
angular.module('DoctorApp')
    .controller('PracticesController', PracticeModule.PracticesController);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../services/http-service.ts" />
var PublicKeysModule;
(function (PublicKeysModule) {
    var Service = (function () {
        Service.$inject = ["httpService"];
        function Service(httpService) {
            "ngInject";
            this.httpService = httpService;
        }
        Service.prototype.getPublicKeys = function () {
            return this.httpService.get("v1/infrastructure/node/publickeylist");
        };
        Service.prototype.validatePublicKey = function (nodePublicKey, validated) {
            nodePublicKey.Validated = validated;
            if (validated) {
                nodePublicKey.ValidatedTime = new Date();
                return this.httpService.post("v1/infrastructure/node/" + nodePublicKey.Id + "/validate", nodePublicKey);
            }
            else {
                nodePublicKey.RevokedTime = new Date();
                return this.httpService.post("v1/infrastructure/node/" + nodePublicKey.Id + "/revoke", nodePublicKey);
            }
        };
        return Service;
    })();
    PublicKeysModule.Service = Service;
})(PublicKeysModule || (PublicKeysModule = {}));
angular.module('DoctorApp')
    .service('publicKeyService', PublicKeysModule.Service);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="public-keys-service.ts" />
var PublicKeysModule;
(function (PublicKeysModule) {
    var Controller = (function () {
        Controller.$inject = ["$scope", "publicKeyService", "$filter", "memoryService"];
        function Controller($scope, publicKeyService, $filter, memoryService) {
            "ngInject";
            this.$scope = $scope;
            this.publicKeyService = publicKeyService;
            this.$filter = $filter;
            this.memoryService = memoryService;
            $scope.validateKey = function (publicKey) {
                return publicKeyService.validatePublicKey(publicKey, true);
            };
            $scope.revokeKey = function (publicKey) {
                return publicKeyService.validatePublicKey(publicKey, false);
            };
            $scope.updatePublicKeys = function () {
                publicKeyService.getPublicKeys()
                    .then(function (publicKeys) {
                    $scope.memoryPublicKeys = publicKeys;
                    $scope.searchUpdate();
                });
            };
            $scope.searchUpdate = function () {
                var text = $scope.searchText;
                memoryService.publicKeys.searchText = text;
                $scope.publicKeys = text && text.length
                    ? $filter('filter')($scope.memoryPublicKeys, text)
                    : $scope.memoryPublicKeys;
            };
            this.init();
        }
        Controller.prototype.init = function () {
            this.$scope.publicKeys = [];
            this.$scope.searchText = this.memoryService.publicKeys.searchText;
            this.$scope.updatePublicKeys();
        };
        return Controller;
    })();
    PublicKeysModule.Controller = Controller;
})(PublicKeysModule || (PublicKeysModule = {}));
angular.module('DoctorApp')
    .controller('PublicKeysController', PublicKeysModule.Controller);
/// <reference path="../../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../search-service.ts" />
/// <reference path="../search-abstract.ts" />
/// <reference path="../search-type.ts" />
var SearchModule;
(function (SearchModule) {
    var ConsumableController = (function () {
        ConsumableController.$inject = ["$scope", "searchService", "$controller", "$routeParams"];
        function ConsumableController($scope, searchService, $controller, $routeParams) {
            "ngInject";
            this.$scope = $scope;
            this.searchService = searchService;
            this.$controller = $controller;
            this.$routeParams = $routeParams;
            angular.extend(this, $controller('SearchAbstractController', { $scope: $scope }));
            $scope.search = function (searchText) {
                var func = $scope.isClinical ? searchService.getClinicalConsumable : searchService.getConsumable;
                return $scope.searchTemplate(func.bind(searchService), searchText, $routeParams.practiceId);
            };
            $scope.addConsumable = function (template) {
                var templateType = SearchModule.SearchType.CONSUMABLE;
                $scope.selectTemplate(template, templateType);
            };
            $scope.$watch('searchResults', function () {
                var fields = ['NappiCode', 'LineType', 'ChargeDesc'];
                $scope.list = $scope.customizeList($scope.searchResults, fields);
            });
            $scope.config = {
                minLength: 3,
                title: [
                    { columnName: 'Nappi code', style: { width: 115 + 'px' }, hstyle: { width: 115 + 'px' } },
                    { columnName: 'Type', style: { width: 115 + 'px' }, hstyle: { width: 115 + 'px' } },
                    { columnName: 'Description', style: {}, hstyle: {} }
                ],
                placeholder: { value: 'Please type in a consumables' }
            };
        }
        return ConsumableController;
    })();
    SearchModule.ConsumableController = ConsumableController;
})(SearchModule || (SearchModule = {}));
angular.module('DoctorApp')
    .controller('SearchConsumableController', SearchModule.ConsumableController);
/// <reference path="../../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../search-service.ts" />
/// <reference path="../search-abstract.ts" />
var SearchModule;
(function (SearchModule) {
    var DiagnosisController = (function () {
        DiagnosisController.$inject = ["$scope", "searchService", "$filter", "$controller", "$routeParams"];
        function DiagnosisController($scope, searchService, $filter, $controller, $routeParams) {
            "ngInject";
            angular.extend(this, $controller('SearchAbstractController', { $scope: $scope }));
            $scope.search = function (searchText) {
                var func = $scope.isClinical ? searchService.getClinicalDiagnosesRanking : searchService.getDiagnosesRanking;
                return $scope.searchTemplate(func.bind(searchService), searchText, $routeParams.practiceId);
            };
            $scope.addDiagnosis = function (template) {
                var templateType = SearchModule.SearchType.DIAGNOSIS;
                $scope.selectTemplate(template, templateType);
            };
            $scope.$watch('searchResults', function () {
                var fields = ['DiagnosisCode', 'DiagnosisDescription'];
                var list = $filter('orderBy')($scope.searchResults, 'Rank', true);
                $scope.list = $scope.customizeList(list, fields);
            });
            $scope.config = {
                title: [
                    { columnName: 'ICD10', style: { width: 90 + 'px' }, hstyle: { width: 90 + 'px' } },
                    { columnName: 'Description', style: {}, hstyle: {} }
                ],
                placeholder: { value: 'Please type in a diagnosis or ICD10 code' }
            };
        }
        return DiagnosisController;
    })();
    SearchModule.DiagnosisController = DiagnosisController;
})(SearchModule || (SearchModule = {}));
angular.module('DoctorApp')
    .controller('SearchDiagnosisController', SearchModule.DiagnosisController);
/// <reference path="../../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../search-service.ts" />
/// <reference path="../search-abstract.ts" />
var SearchModule;
(function (SearchModule) {
    var MIProcedureController = (function () {
        MIProcedureController.$inject = ["$scope", "encounterServiceNew", "$q", "$filter", "$controller", "$routeParams"];
        function MIProcedureController($scope, encounterServiceNew, $q, $filter, $controller, $routeParams) {
            "ngInject";
            var _this = this;
            this.encounterServiceNew = encounterServiceNew;
            this.$q = $q;
            this.$filter = $filter;
            this.$controller = $controller;
            this.$routeParams = $routeParams;
            angular.extend(this, $controller('SearchAbstractController', { $scope: $scope }));
            $scope.search = function (searchText) {
                var func = function () {
                    var deferred = $q.defer();
                    var memoryProcedures = _this.encounterServiceNew.getMemoryInsurerProcedures();
                    var procedures = _this.$filter('filter')(memoryProcedures, searchText);
                    var lines = [];
                    for (var _i = 0; _i < procedures.length; _i++) {
                        var procedure = procedures[_i];
                        var lineItems = procedure.EncounterLineItems;
                        lines.push(lineItems);
                    }
                    deferred.resolve(lines);
                    return deferred.promise;
                };
                return $scope.searchTemplate(func, searchText, $routeParams.practiceId);
            };
            $scope.addMedicalInsurerProcedure = function (template) {
                var templateType = SearchModule.SearchType.MIPROCEDURE;
                $scope.selectTemplate(template, templateType);
            };
            $scope.$watch('searchResults', function () {
                var fields = ['ChargeCode', 'ChargeDesc'];
                $scope.list = $scope.customizeList($scope.searchResults, fields);
            });
            $scope.config = {
                minLength: 3,
                title: [
                    { columnName: 'Tariff code', style: { width: 115 + 'px' }, hstyle: { width: 115 + 'px' } },
                    { columnName: 'Description', style: {}, hstyle: {} }
                ],
                placeholder: { value: 'Please type in a procedure description or tariff code' }
            };
        }
        return MIProcedureController;
    })();
    SearchModule.MIProcedureController = MIProcedureController;
})(SearchModule || (SearchModule = {}));
angular.module('DoctorApp')
    .controller('SearchMIProcedureController', SearchModule.MIProcedureController);
/// <reference path="../../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../search-service.ts" />
/// <reference path="../search-abstract.ts" />
var SearchModule;
(function (SearchModule) {
    var MedicineController = (function () {
        MedicineController.$inject = ["$scope", "searchService", "$controller", "encounterServiceNew", "$routeParams"];
        function MedicineController($scope, searchService, $controller, encounterServiceNew, $routeParams) {
            "ngInject";
            var _this = this;
            this.$scope = $scope;
            this.searchService = searchService;
            this.$controller = $controller;
            this.encounterServiceNew = encounterServiceNew;
            this.$routeParams = $routeParams;
            this.fields = ['NappiCode', 'LineType', 'SchemeRule', 'ChargeDesc'];
            angular.extend(this, $controller('SearchAbstractController', { $scope: $scope }));
            $scope.search = function (searchText) {
                var func = $scope.isClinical ? searchService.getClinicalMedicine : searchService.getMedicine;
                return $scope.searchTemplate(func.bind(searchService), searchText, $routeParams.practiceId);
            };
            $scope.addMedicine = function (template) {
                var templateType = SearchModule.SearchType.MEDICINE;
                $scope.selectTemplate(template, templateType);
            };
            $scope.$watch('searchResults', function () {
                $scope.list = $scope.customizeList($scope.searchResults, _this.fields);
            });
            $scope.config = {
                minLength: 3,
                title: [
                    { columnName: 'Nappi code', style: { width: 115 + 'px' }, hstyle: { width: 115 + 'px' } },
                    { columnName: 'Type', style: { width: 100 + 'px' }, hstyle: { width: 100 + 'px' } },
                    { columnName: 'KeyCare acute formulary', style: { width: 150 + 'px', 'text-align': 'center' }, hstyle: { width: 150 + 'px' } },
                    { columnName: 'Description', style: {}, hstyle: {} }
                ],
                placeholder: { value: 'Please type in a medicine' }
            };
            this.init();
        }
        MedicineController.prototype.init = function () {
            var encounter = this.encounterServiceNew.getEncounter();
            if (!encounter || encounter && encounter.PatientEventDetails.Patient.PatientAccountDetails.MedicalAidName !== 'DISCOVERY KEYCARE') {
                this.fields = this.fields.filter(function (value) { return value !== 'SchemeRule'; });
                this.$scope.config.title = this.$scope.config.title.filter(function (value) { return value.columnName !== 'KeyCare acute formulary'; });
            }
        };
        return MedicineController;
    })();
    SearchModule.MedicineController = MedicineController;
})(SearchModule || (SearchModule = {}));
angular.module('DoctorApp')
    .controller('SearchMedicineController', SearchModule.MedicineController);
/// <reference path="../../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../search-service.ts" />
/// <reference path="../search-abstract.ts" />
var SearchModule;
(function (SearchModule) {
    var PrescriptionController = (function () {
        PrescriptionController.$inject = ["$scope", "searchService", "$controller", "$routeParams"];
        function PrescriptionController($scope, searchService, $controller, $routeParams) {
            "ngInject";
            angular.extend(this, $controller('SearchAbstractController', { $scope: $scope }));
            $scope.search = function (searchText) {
                var func = $scope.isClinical ? searchService.getClinicalPrescription : searchService.getMedicine;
                return $scope.searchTemplate(func.bind(searchService), searchText, $routeParams.practiceId);
            };
            $scope.addPrescription = function (template) {
                var templateType = SearchModule.SearchType.PRESCRIPTION;
                $scope.selectTemplate(template, templateType);
            };
            $scope.$watch('searchResults', function () {
                var fields = ['NappiCode', 'MedicationDescription'];
                var res = [];
                var list = $scope.searchResults;
                for (var i = 0; i < list.length; i++) {
                    var searchItem = list[i];
                    var item = {
                        fields: [],
                        object: searchItem
                    };
                    for (var j = 0; j < fields.length; j++) {
                        item.fields[j] = { value: searchItem[fields[j]] };
                    }
                    res[i] = item;
                }
                $scope.list = res;
            });
            $scope.config = {
                minLength: 3,
                title: [
                    { columnName: 'Nappi code', style: { width: 115 + 'px' }, hstyle: { width: 115 + 'px' } },
                    { columnName: 'Description', style: {}, hstyle: {} }
                ],
                placeholder: { value: 'Please type in a prescription' }
            };
        }
        return PrescriptionController;
    })();
    SearchModule.PrescriptionController = PrescriptionController;
})(SearchModule || (SearchModule = {}));
angular.module('DoctorApp')
    .controller('SearchPrescriptionController', SearchModule.PrescriptionController);
/// <reference path="../../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../search-service.ts" />
/// <reference path="../search-abstract.ts" />
var SearchModule;
(function (SearchModule) {
    var ProcedureController = (function () {
        ProcedureController.$inject = ["$scope", "searchService", "$controller", "$routeParams"];
        function ProcedureController($scope, searchService, $controller, $routeParams) {
            "ngInject";
            angular.extend(this, $controller('SearchAbstractController', { $scope: $scope }));
            $scope.search = function (searchText) {
                var func = $scope.isClinical ? searchService.getClinicalProcedures : searchService.getProcedures;
                return $scope.searchTemplate(func.bind(searchService), searchText, $routeParams.practiceId);
            };
            $scope.addProcedure = function (template) {
                var templateType = SearchModule.SearchType.PROCEDURE;
                $scope.selectTemplate(template, templateType);
            };
            $scope.$watch('searchResults', function () {
                var fields = ['ChargeCode', 'ChargeDesc'];
                $scope.list = $scope.customizeList($scope.searchResults, fields);
            });
            $scope.config = {
                minLength: 3,
                title: [
                    { columnName: 'Tariff code', style: { width: 115 + 'px' }, hstyle: { width: 115 + 'px' } },
                    { columnName: 'Description', style: {}, hstyle: {} }
                ],
                placeholder: { value: 'Please type in a procedure description or tariff code' }
            };
        }
        return ProcedureController;
    })();
    SearchModule.ProcedureController = ProcedureController;
})(SearchModule || (SearchModule = {}));
angular.module('DoctorApp')
    .controller('SearchProcedureController', SearchModule.ProcedureController);
var SentInvoices;
(function (SentInvoices) {
    var SentInvoicesController = (function () {
        SentInvoicesController.$inject = ["$scope", "httpService", "billingDomain", "modalService", "locationService", "moment", "$routeParams"];
        function SentInvoicesController($scope, httpService, billingDomain, modalService, locationService, moment, $routeParams) {
            "ngInject";
            var _this = this;
            this.$scope = $scope;
            this.httpService = httpService;
            this.billingDomain = billingDomain;
            this.modalService = modalService;
            this.locationService = locationService;
            this.moment = moment;
            this.$routeParams = $routeParams;
            $scope.list = [];
            $scope.openFullText = function (reason) {
                if (reason.length > 34) {
                    modalService.info(reason, ModalModule.ModalWidth._550px);
                }
            };
            $scope.openInvoice = function (item) {
                _this.locationService.goToAuditEvents("BIL:PRO:" + item.PracticeId, item.InvoiceId);
            };
            $scope.changeSentDate = function (bool) {
                _this.$scope.load();
            };
            $scope.init = function () {
                _this.$scope.sentDate = _this.moment($routeParams.sentDate);
                if (!$routeParams.sentDate) {
                    _this.$scope.sentDate = _this.moment();
                }
                var configFrom = new DatePickerModule.Config();
                configFrom.format = 'dd MM, yy';
                configFrom.max = _this.moment();
                _this.$scope.configFrom = configFrom;
            };
            $scope.load = function () {
                if (!_this.moment.isDate(_this.$scope.sentDate)) {
                    _this.$scope.sentDate = _this.moment(_this.$scope.sentDate);
                }
                _this.billingDomain.getSentInvoices(_this.$scope.sentDate)
                    .then(function (list) {
                    $scope.list = list;
                });
            };
            $scope.init();
            $scope.load();
        }
        return SentInvoicesController;
    })();
    SentInvoices.SentInvoicesController = SentInvoicesController;
})(SentInvoices || (SentInvoices = {}));
angular.module('DoctorApp')
    .controller('SentInvoicesController', SentInvoices.SentInvoicesController);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../run.ts" />
var SpecialityRuleModule;
(function (SpecialityRuleModule) {
    var SpecialityRuleAbsController = (function () {
        SpecialityRuleAbsController.$inject = ["$rootScope", "$scope", "showDialog", "billingDomain", "locationService"];
        function SpecialityRuleAbsController($rootScope, $scope, showDialog, billingDomain, locationService) {
            "ngInject";
            this.$rootScope = $rootScope;
            this.$scope = $scope;
            this.showDialog = showDialog;
            this.billingDomain = billingDomain;
            this.locationService = locationService;
            $scope.create = false;
            $scope.title = '';
            $scope.wardsStr = 'ICU, High care, General ward';
            $scope.removeCode = function (code, group) {
                var position = group.indexOf(code);
                if (position !== -1) {
                    group.splice(position, 1);
                }
            };
            $scope.addOption = function () {
                var newItemName = '';
                if (!$scope.ruleOptions.some(function (o) {
                    return o.key === newItemName;
                })) {
                    $scope.ruleOptions.push({ key: newItemName, value: '' });
                }
            };
            $scope.removeOption = function (option) {
                var index = $scope.ruleOptions.indexOf(option);
                if (index !== -1) {
                    $scope.ruleOptions.splice(index, 1);
                }
            };
            $scope.addCode = function (group) {
                if (group.newExclusiveCode && group.indexOf(group.newExclusiveCode) == -1) {
                    group.push(group.newExclusiveCode);
                    group.newExclusiveCode = "";
                }
            };
            $scope.removeCodeGroup = function (group) {
                var position = $scope.rule.MutuallyExclusiveCodes.indexOf(group);
                if (position !== -1) {
                    $scope.rule.MutuallyExclusiveCodes.splice(position, 1);
                }
            };
            $scope.addExclusiveCodeGroup = function () {
                $scope.rule.MutuallyExclusiveCodes.push([]);
            };
            $scope.save = function (isValid) {
                if (isValid) {
                    saveRule($scope.rule);
                }
            };
            function saveRule(rule) {
                rule.Options = Common.toDictionaryObject($scope.ruleOptions);
                rule.AvailableWards = $scope.wardsStr.split(',').map(function (s) { return s.trim(); }).filter(function (s) { return s.length > 0; });
                billingDomain.updateSpecialityRule(rule).then(function (response) {
                    if (response.Sucess === false) {
                        showDialog.error(response.ResponseMessage);
                    }
                    else {
                        showDialog.info("The speciality rule was successfully edited.");
                        $rootScope.back();
                    }
                });
            }
        }
        return SpecialityRuleAbsController;
    })();
    SpecialityRuleModule.SpecialityRuleAbsController = SpecialityRuleAbsController;
})(SpecialityRuleModule || (SpecialityRuleModule = {}));
angular.module('DoctorApp')
    .controller('SpecialityRuleAbsController', SpecialityRuleModule.SpecialityRuleAbsController);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../services/show-dialog.ts" />
/// <reference path="../../run.ts" />
/// <reference path="speciality-rule-abstract.ts" />
var SpecialityRuleModule;
(function (SpecialityRuleModule) {
    var SpecialityRuleCreateController = (function () {
        SpecialityRuleCreateController.$inject = ["$scope", "locationService", "showDialog", "$controller"];
        function SpecialityRuleCreateController($scope, locationService, showDialog, $controller) {
            "ngInject";
            this.$scope = $scope;
            this.locationService = locationService;
            this.showDialog = showDialog;
            this.$controller = $controller;
            angular.extend(this, $controller('SpecialityRuleAbsController', { $scope: $scope }));
            this.init();
        }
        SpecialityRuleCreateController.prototype.init = function () {
            this.$scope.title = 'Create Speciality Rule';
            this.$scope.create = true;
            this.$scope.rule = new Domain.Billing.SpecialityRule();
            this.$scope.rule.ConsumableProcedureCode = "0201";
            this.$scope.ruleOptions = Common.toArray(new Domain.Billing.FeatureAllows());
        };
        return SpecialityRuleCreateController;
    })();
    SpecialityRuleModule.SpecialityRuleCreateController = SpecialityRuleCreateController;
})(SpecialityRuleModule || (SpecialityRuleModule = {}));
angular.module('DoctorApp')
    .controller('SpecialityRuleCreateController', SpecialityRuleModule.SpecialityRuleCreateController);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../run.ts" />
/// <reference path="../../services/show-dialog.ts" />
/// <reference path="speciality-rule-abstract.ts" />
var SpecialityRuleModule;
(function (SpecialityRuleModule) {
    var SpecialityRuleEditController = (function () {
        SpecialityRuleEditController.$inject = ["$scope", "$rootScope", "$controller", "showDialog", "billingDomain", "locationService", "$routeParams"];
        function SpecialityRuleEditController($scope, $rootScope, $controller, showDialog, billingDomain, locationService, $routeParams) {
            "ngInject";
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.$controller = $controller;
            this.showDialog = showDialog;
            this.billingDomain = billingDomain;
            this.locationService = locationService;
            this.$routeParams = $routeParams;
            angular.extend(this, $controller('SpecialityRuleAbsController', { $scope: $scope }));
            this.init();
        }
        SpecialityRuleEditController.prototype.init = function () {
            this.$scope.title = 'Edit Speciality Rule';
            this.loadRule();
        };
        SpecialityRuleEditController.prototype.loadRule = function () {
            var _this = this;
            this.billingDomain.getSpecialityRulesByCode(this.$routeParams.specialityCode).then(function (response) {
                if (response) {
                    _this.$scope.rule = response;
                    var respOptions = Common.toArray(response.Options);
                    var defaultOpts = Common.toArray(new Domain.Billing.FeatureAllows());
                    for (var _i = 0; _i < defaultOpts.length; _i++) {
                        var defaultOpt = defaultOpts[_i];
                        var includedOption = false;
                        for (var _a = 0; _a < respOptions.length; _a++) {
                            var respOption = respOptions[_a];
                            if (respOption.key === defaultOpt.key) {
                                includedOption = true;
                            }
                        }
                        if (!includedOption) {
                            respOptions.push(defaultOpt);
                        }
                    }
                    _this.$scope.ruleOptions = respOptions;
                    if (response.AvailableWards != null && response.AvailableWards.length > 0) {
                        _this.$scope.wardsStr = response.AvailableWards.join(", ");
                    }
                }
                else {
                    _this.showDialog.info("Can't load speciality rule.");
                    _this.$rootScope.back();
                }
            });
        };
        return SpecialityRuleEditController;
    })();
    SpecialityRuleModule.SpecialityRuleEditController = SpecialityRuleEditController;
})(SpecialityRuleModule || (SpecialityRuleModule = {}));
angular.module('DoctorApp')
    .controller('SpecialityRuleEditController', SpecialityRuleModule.SpecialityRuleEditController);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../services/api/result-api.ts" />
/// <reference path="../../services/api/domain/billing.ts" />
/// <reference path="../../services/show-dialog.ts" />
/// <reference path="../../run.ts" />
var SpecialityRuleModule;
(function (SpecialityRuleModule) {
    var SpecialityRulesController = (function () {
        SpecialityRulesController.$inject = ["$scope", "$rootScope", "billingDomain", "locationService", "showDialog", "$filter"];
        function SpecialityRulesController($scope, $rootScope, billingDomain, locationService, showDialog, $filter) {
            "ngInject";
            var _this = this;
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.billingDomain = billingDomain;
            this.locationService = locationService;
            this.showDialog = showDialog;
            this.$filter = $filter;
            $scope.rules = [];
            $scope.searchText = '';
            $scope.goToCreateRule = function () {
                locationService.goToCreateSpecialityRule();
            };
            $scope.editRule = function (rule) {
                locationService.goToEditSpecialityRule(rule.SpecialityCode);
            };
            $scope.deleteRule = function (rule) {
                showDialog.confirm("Are you sure want to delete Rule: " + rule.DefaultProcedureCode).then(function () {
                    var deactivte = new Domain.Billing.DeactivateSpecialityRule();
                    deactivte.Reason = "Deactivated from Doctor App UI";
                    deactivte.SpecialityRuleId = rule.Id;
                    billingDomain.deactivateSpecialityRule(deactivte)
                        .then(function (response) {
                        if (response.Sucess === false) {
                            showDialog.error(response.ResponseMessage);
                        }
                        else {
                            _this.updateRules();
                            showDialog.info("The Rule: " + rule.Id + " was successfully deleted.");
                        }
                    });
                });
            };
            $scope.changeSearchText = function (text) {
                $scope.rules = text ? $filter('filter')($scope.rulesInMemory, text) : $scope.rulesInMemory;
            };
            this.init();
        }
        SpecialityRulesController.prototype.init = function () {
            this.updateRules();
        };
        SpecialityRulesController.prototype.updateRules = function () {
            var that = this;
            that.billingDomain.getSpecialityRules().then(function (response) {
                that.$scope.rulesInMemory = response;
                that.$scope.changeSearchText(that.$scope.searchText);
            });
        };
        return SpecialityRulesController;
    })();
    SpecialityRuleModule.SpecialityRulesController = SpecialityRulesController;
})(SpecialityRuleModule || (SpecialityRuleModule = {}));
angular.module('DoctorApp')
    .controller('SpecialityRulesController', SpecialityRuleModule.SpecialityRulesController);
var TemplateImportModule;
(function (TemplateImportModule) {
    var TemplateImportController = (function () {
        TemplateImportController.$inject = ["$scope", "modalService", "httpService", "clinicalDomain", "locationService", "$routeParams"];
        function TemplateImportController($scope, modalService, httpService, clinicalDomain, locationService, $routeParams) {
            "ngInject";
            var _this = this;
            this.$scope = $scope;
            this.modalService = modalService;
            this.httpService = httpService;
            this.clinicalDomain = clinicalDomain;
            this.locationService = locationService;
            this.$routeParams = $routeParams;
            $scope.type = TemplateImportController.CLEAR_AND_IMPORT;
            $scope.items = "";
            $scope.validateMessages = [];
            $scope.types = [
                { label: 'Clear All and Import', value: TemplateImportController.CLEAR_AND_IMPORT },
                { label: 'Merge with existing items', value: TemplateImportController.MERGE }
            ];
            $scope.validate = function () {
                clinicalDomain.importMultipleTemplates($routeParams.practiceId, $scope.items, $scope.type, true)
                    .then(function (response) {
                    $scope.validateMessages = response.Data;
                });
            };
            $scope.onItemsChanged = function (items) {
                if (items) {
                    $scope.validateMessages = [];
                }
            };
            $scope.gotoMyFavorites = function () {
                _this.locationService.goToClinicalTemplates($routeParams.practiceId);
            };
            $scope.run = function () {
                clinicalDomain.importMultipleTemplates($routeParams.practiceId, $scope.items, $scope.type, true)
                    .then(function (response) {
                    if (response.Sucess) {
                        return _this.modalService.confirm(response.Data.join('<br>'), ModalModule.ModalWidth._500px)
                            .then(function () { return response; });
                    }
                    _this.modalService.error(response.ResponseMessage);
                    return response;
                })
                    .then(function (response) {
                    if (response.Sucess) {
                        return clinicalDomain.importMultipleTemplates($routeParams.practiceId, $scope.items, $scope.type, false);
                    }
                    return response;
                })
                    .then(function (response) {
                    $scope.validateMessages = response.Data || [response.ResponseMessage];
                });
            };
        }
        TemplateImportController.CLEAR_AND_IMPORT = "ClearAndImport";
        TemplateImportController.MERGE = "Merge";
        return TemplateImportController;
    })();
    TemplateImportModule.TemplateImportController = TemplateImportController;
})(TemplateImportModule || (TemplateImportModule = {}));
angular.module('DoctorApp')
    .controller('TemplateImportModule', TemplateImportModule.TemplateImportController);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../components/template-panel/template-panel.ts" />
/// <reference path="template-service.ts" />
/// <reference path="../consultation/encounter/encounter-service.ts" />
var TemplateModule;
(function (TemplateModule) {
    var TemplateAbstractController = (function () {
        TemplateAbstractController.$inject = ["$scope", "$rootScope", "locationService", "invoiceTemplateService", "showDialog", "$filter", "searchService", "modalService"];
        function TemplateAbstractController($scope, $rootScope, locationService, invoiceTemplateService, showDialog, $filter, searchService, modalService) {
            "ngInject";
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.locationService = locationService;
            this.invoiceTemplateService = invoiceTemplateService;
            this.showDialog = showDialog;
            this.$filter = $filter;
            this.searchService = searchService;
            this.modalService = modalService;
            var that = this;
            $scope.controlTemplate = {
                selectTemplate: function (template) {
                    $scope.selectTemplate(template);
                },
                isMedicine: true,
                isClinical: false,
                isPrescription: false
            };
            $scope.saveTemplate = function () {
                var error = that.validTemplate($scope.mainTemplate);
                if (error) {
                    showDialog.error(error);
                }
                else {
                    var request = $scope.create
                        ? invoiceTemplateService.saveTemplate($scope.mainTemplate)
                        : invoiceTemplateService.updateTemplate($scope.mainTemplate);
                    request.then(function (response) {
                        if (response.Sucess === false) {
                            showDialog.error(response.ResponseMessage);
                        }
                        else {
                            that.invoiceTemplateService.setMainTemplate(null);
                            $rootScope.back();
                        }
                    });
                }
            };
            $scope.templateTypeChanged = function () {
                var groupTemplates = $filter('filter')($scope.templates, { TemplateType: $scope.mainTemplate.TemplateType });
                groupTemplates = $filter('orderBy')(groupTemplates, '-SortOrder');
                $scope.tempSortOrder = groupTemplates[0] ? (1 + groupTemplates[0].SortOrder) : 0;
                $scope.mainTemplate.SortOrder = $scope.tempSortOrder;
            };
            $scope.removeTemplate = function (template, type) {
                $scope.mainTemplate = invoiceTemplateService.removeTemplateFromTemplate($scope.mainTemplate, template, type);
            };
            $scope.selectTemplate = function (template) {
                invoiceTemplateService.mergeTemplates($scope.mainTemplate, template);
            };
            $scope.showQuantityCalc = function (i, type) {
                var item = $filter('filter')($scope.mainTemplate.InvoiceLineItemsVo.LineItems, { LineType: type })[i];
                modalService.openNumbers('int', 'Enter quantity')
                    .then(function (quantity) {
                    if (quantity) {
                        item.ChargeQuan = quantity;
                    }
                });
            };
            $scope.validateOrder = function () {
                var templateType = $scope.mainTemplate.TemplateType;
                var error = that.validateOrder($scope.mainTemplate, templateType, $scope.templates);
                if (error) {
                    $scope.mainTemplate.SortOrder = $scope.tempSortOrder;
                    showDialog.error(error);
                }
            };
        }
        TemplateAbstractController.prototype.init = function () {
            var that = this;
            that.invoiceTemplateService.loadPracticeTemplates()
                .then(function (templates) {
                that.$scope.templates = templates;
            });
            var saveTemplate = this.searchService.getSelectedTemplate();
            if (saveTemplate) {
                that.invoiceTemplateService.mergeTemplates(that.$scope.mainTemplate, saveTemplate)
                    .then(function () {
                    that.searchService.saveSelectedTemplate(null);
                });
            }
        };
        TemplateAbstractController.prototype.validTemplate = function (template) {
            if (!template.SortOrder && template.SortOrder !== 0) {
                return "Sort order is empty!";
            }
            else {
                var templateType = this.$scope.mainTemplate.TemplateType;
                return this.validateOrder(this.$scope.mainTemplate, templateType, this.$scope.templates);
            }
        };
        TemplateAbstractController.prototype.validateOrder = function (mainTemplate, templateType, templates) {
            var order = mainTemplate.SortOrder;
            var groupTemplates = this.$filter('filter')(templates, { TemplateType: templateType });
            if (groupTemplates.length && order != this.$scope.tempSortOrder) {
                for (var i = 0; i < groupTemplates.length; i++) {
                    var template = groupTemplates[i];
                    if (template.TemplateId != mainTemplate.TemplateId && template.SortOrder == order) {
                        return "This order number already used by template : " + groupTemplates[i].Caption;
                    }
                }
            }
            return null;
        };
        return TemplateAbstractController;
    })();
    TemplateModule.TemplateAbstractController = TemplateAbstractController;
})(TemplateModule || (TemplateModule = {}));
angular.module('DoctorApp')
    .controller('TemplateAbstractController', TemplateModule.TemplateAbstractController);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="template-abstract.ts" />
/// <reference path="template-service.ts" />
var TemplateModule;
(function (TemplateModule) {
    var CreateTemplateController = (function () {
        CreateTemplateController.$inject = ["$scope", "$controller"];
        function CreateTemplateController($scope, $controller) {
            "ngInject";
            this.$scope = $scope;
            this.$controller = $controller;
            this.parent = $controller('TemplateAbstractController', { $scope: $scope });
            angular.extend(this, this.parent);
            this.init();
        }
        CreateTemplateController.prototype.init = function () {
            var that = this;
            that.$scope.create = true;
            var saveTemplate = this.parent.invoiceTemplateService.getMainTemplate();
            if (!saveTemplate) {
                saveTemplate = new Domain.Billing.Template();
                saveTemplate.TemplateId = '00000000-0000-0000-0000-000000000000';
                that.parent.invoiceTemplateService.setMainTemplate(saveTemplate);
            }
            that.$scope.mainTemplate = saveTemplate;
            that.$scope.tempSortOrder = saveTemplate.SortOrder;
            that.parent.init();
        };
        return CreateTemplateController;
    })();
    TemplateModule.CreateTemplateController = CreateTemplateController;
})(TemplateModule || (TemplateModule = {}));
angular.module('DoctorApp')
    .controller('CreateTemplateController', TemplateModule.CreateTemplateController);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="template-abstract.ts" />
/// <reference path="template-service.ts" />
var TemplateModule;
(function (TemplateModule) {
    var EditTemplateController = (function () {
        EditTemplateController.$inject = ["$scope", "$routeParams", "$q", "$controller"];
        function EditTemplateController($scope, $routeParams, $q, $controller) {
            "ngInject";
            this.$scope = $scope;
            this.$routeParams = $routeParams;
            this.$q = $q;
            this.$controller = $controller;
            this.parent = $controller('TemplateAbstractController', { $scope: $scope });
            angular.extend(this, this.parent);
            this.init();
        }
        EditTemplateController.prototype.init = function () {
            var that = this;
            that.$scope.create = false;
            var templateId = this.$routeParams.templateId;
            that.getMainTemplate(templateId)
                .then(function (template) {
                if (!template) {
                    that.parent.locationService.goToTemplates(that.$routeParams.practiceId);
                }
                that.$scope.mainTemplate = template;
                that.$scope.tempSortOrder = that.$scope.mainTemplate.SortOrder;
                that.parent.init();
            })
                .catch(function (error) {
                that.parent.locationService.goToTemplates(that.$routeParams.practiceId);
            });
        };
        EditTemplateController.prototype.getMainTemplate = function (templateId) {
            var that = this;
            var saveTemplate = this.parent.invoiceTemplateService.getMainTemplate();
            if (saveTemplate) {
                return this.$q.when(saveTemplate);
            }
            return this.parent.invoiceTemplateService.execGetPracticeTemplate(templateId)
                .then(function (template) {
                that.parent.invoiceTemplateService.setMainTemplate(template);
                return template;
            });
        };
        return EditTemplateController;
    })();
    TemplateModule.EditTemplateController = EditTemplateController;
})(TemplateModule || (TemplateModule = {}));
angular.module('DoctorApp')
    .controller('EditTemplateController', TemplateModule.EditTemplateController);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../services/show-dialog.ts" />
/// <reference path="../../common/common.ts" />
/// <reference path="../../run.ts" />
/// <reference path="../template/template-service.ts" />
/// <reference path="templates-service.ts" />
var TemplatesM;
(function (TemplatesM) {
    var Controller = (function () {
        Controller.$inject = ["$scope", "$rootScope", "$routeParams", "locationService", "invoiceTemplateService", "showDialog", "templatesService"];
        function Controller($scope, $rootScope, $routeParams, locationService, invoiceTemplateService, showDialog, templatesService) {
            "ngInject";
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.$routeParams = $routeParams;
            this.locationService = locationService;
            this.invoiceTemplateService = invoiceTemplateService;
            this.showDialog = showDialog;
            this.templatesService = templatesService;
            var that = this;
            $scope.search = function (text) {
                $scope.templates = templatesService.search($scope.loadTemplates, text);
            };
            $scope.goToEditTemplate = function (template) {
                invoiceTemplateService.setMainTemplate(null);
                locationService.goToEditTemplate($routeParams.practiceId, template.TemplateId);
            };
            $scope.goToCreateTemplate = function () {
                invoiceTemplateService.setMainTemplate(null);
                locationService.goToCreateTemplate($routeParams.practiceId);
            };
            $scope.removeTemplate = function (template) {
                var message = 'Are you sure want to delete template: ' + template.Caption;
                showDialog.confirm(message)
                    .then(function () {
                    return templatesService.removeTemplate(template);
                })
                    .then(function () {
                    that.loadTemplates();
                })
                    .catch(function (error) {
                    if (error) {
                        showDialog.error(error);
                    }
                });
            };
            this.init();
        }
        Controller.prototype.init = function () {
            this.$scope.loadTemplates = [];
            this.$scope.templates = [];
            this.loadTemplates();
        };
        Controller.prototype.loadTemplates = function () {
            var that = this;
            that.invoiceTemplateService.loadPracticeTemplates()
                .then(function (templates) {
                that.$scope.loadTemplates = templates;
                that.$scope.search();
            });
        };
        return Controller;
    })();
    TemplatesM.Controller = Controller;
})(TemplatesM || (TemplatesM = {}));
angular.module('DoctorApp')
    .controller('TemplatesController', TemplatesM.Controller);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../services/api/result-api.ts" />
/// <reference path="../../services/api/domain/tenant.ts" />
/// <reference path="../../services/show-dialog.ts" />
/// <reference path="../../run.ts" />
var TenantModule;
(function (TenantModule) {
    var CreateTenantController = (function () {
        CreateTenantController.$inject = ["$scope", "$rootScope", "tenantDomainService", "locationService", "showDialog"];
        function CreateTenantController($scope, $rootScope, tenantDomainService, locationService, showDialog) {
            "ngInject";
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.tenantDomainService = tenantDomainService;
            this.locationService = locationService;
            this.showDialog = showDialog;
            $scope.create = true;
            $scope.title = 'Create tenant';
            $scope.saveTenant = function (tenant) {
                tenantDomainService.createTenant(tenant).then(function (response) {
                    if (response.Sucess === false) {
                        showDialog.error(response.ResponseMessage);
                    }
                    else {
                        showDialog.info("The new tenant was successfully created.");
                        $rootScope.back();
                    }
                });
            };
            $scope.done = function (isValid) {
                if (isValid) {
                    $scope.saveTenant($scope.tenant);
                }
            };
            $scope.tenant = {
                "TenantId": "",
                "TenantXRef": "",
                "Description": ""
            };
        }
        return CreateTenantController;
    })();
    TenantModule.CreateTenantController = CreateTenantController;
})(TenantModule || (TenantModule = {}));
angular.module('DoctorApp')
    .controller('CreateTenantController', TenantModule.CreateTenantController);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../services/api/result-api.ts" />
/// <reference path="../../services/api/domain/tenant.ts" />
/// <reference path="../../services/show-dialog.ts" />
/// <reference path="../../run.ts" />
var TenantModule;
(function (TenantModule) {
    var EditTenantController = (function () {
        EditTenantController.$inject = ["$scope", "$rootScope", "tenantDomainService", "locationService", "showDialog", "$routeParams"];
        function EditTenantController($scope, $rootScope, tenantDomainService, locationService, showDialog, $routeParams) {
            "ngInject";
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.tenantDomainService = tenantDomainService;
            this.locationService = locationService;
            this.showDialog = showDialog;
            this.$routeParams = $routeParams;
            $scope.title = 'Edit tenant';
            $scope.done = function (isValid) {
                if (isValid) {
                    this.saveTenant($scope.tenant);
                }
            };
            $scope.saveTenant = function (tenant) {
                tenantDomainService.updateTenant(tenant).then(function (response) {
                    if (response.Sucess === false) {
                        showDialog.error(response.ResponseMessage);
                    }
                    else {
                        $rootScope.back();
                    }
                });
            };
            this.init();
        }
        EditTenantController.prototype.init = function () {
            this.getTenant();
        };
        EditTenantController.prototype.getTenant = function () {
            var that = this;
            that.tenantDomainService.getTenant(that.$routeParams.tenantId).then(function (response) {
                if (response) {
                    that.$scope.tenant = response;
                }
                else {
                    that.locationService.goToTenants();
                }
            });
        };
        return EditTenantController;
    })();
    TenantModule.EditTenantController = EditTenantController;
})(TenantModule || (TenantModule = {}));
angular.module('DoctorApp')
    .controller('EditTenantController', TenantModule.EditTenantController);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../services/api/result-api.ts" />
/// <reference path="../../services/api/domain/tenant.ts" />
/// <reference path="../../services/show-dialog.ts" />
/// <reference path="../../run.ts" />
var TenantModule;
(function (TenantModule) {
    var TenantController = (function () {
        TenantController.$inject = ["$scope", "$rootScope", "tenantDomainService", "locationService", "memoryService", "showDialog", "$filter"];
        function TenantController($scope, $rootScope, tenantDomainService, locationService, memoryService, showDialog, $filter) {
            "ngInject";
            var _this = this;
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.tenantDomainService = tenantDomainService;
            this.locationService = locationService;
            this.memoryService = memoryService;
            this.showDialog = showDialog;
            this.$filter = $filter;
            $scope.tenants = [];
            $scope.searchText = '';
            $scope.goToCreateTenant = function () {
                locationService.goToCreateTenant();
            };
            $scope.editTenant = function (tenant) {
                locationService.goToEditTenant(tenant.TenantId);
            };
            $scope.deleteTenant = function (tenant) {
                showDialog.confirm("Are you sure want to delete tenant: " + tenant.Description).then(function () {
                    tenantDomainService.deleteTenant(tenant.TenantId)
                        .then(function (response) {
                        if (response.Sucess === false) {
                            showDialog.error(response.ResponseMessage);
                        }
                        else {
                            _this.updateTenants();
                            showDialog.info("The tenant: " + tenant.Description + " was successfully deleted.");
                        }
                    });
                });
            };
            $scope.goToPractices = function (tenant) {
                _this.memoryService.practices.searchText = tenant.TenantId;
                locationService.goToPractices();
            };
            $scope.changeSearchText = function (text) {
                $scope.tenants = text ? $filter('filter')($scope.tenantsInMemory, text) : $scope.tenantsInMemory;
            };
            this.init();
        }
        TenantController.prototype.init = function () {
            this.updateTenants();
        };
        TenantController.prototype.updateTenants = function () {
            var that = this;
            that.tenantDomainService.getTenantList().then(function (response) {
                that.$scope.tenantsInMemory = response;
                that.$scope.changeSearchText(that.$scope.searchText);
            });
        };
        return TenantController;
    })();
    TenantModule.TenantController = TenantController;
})(TenantModule || (TenantModule = {}));
angular.module('DoctorApp')
    .controller('TenantController', TenantModule.TenantController);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../services/http-service.ts" />
/// <reference path="../../screens/practice/practice-service.ts" />
var TestApiModule;
(function (TestApiModule) {
    var Service = (function () {
        Service.$inject = ["$http", "httpService", "practiceService", "cfpLoadingBar", "$q", "storageService"];
        function Service($http, httpService, practiceService, cfpLoadingBar, $q, storageService) {
            "ngInject";
            this.$http = $http;
            this.httpService = httpService;
            this.practiceService = practiceService;
            this.cfpLoadingBar = cfpLoadingBar;
            this.$q = $q;
            this.storageService = storageService;
        }
        Service.prototype.getPracticeId = function () {
            return this.storageService.getPracticeId();
        };
        Service.prototype.execGetRoutes = function () {
            var _this = this;
            var deferred = this.$q.defer();
            this.cfpLoadingBar.start();
            this.httpService.get('v1/infrastructure/api/routes')
                .then(function (response) {
                for (var i = 0; i < response.length; i++) {
                    response[i].RoutePath = response[i].RoutePath.replace('api/', '');
                }
                deferred.resolve(response);
            }, function (response) {
                deferred.reject(response);
            })
                .finally(function () {
                _this.cfpLoadingBar.complete();
            });
            return deferred.promise;
        };
        Service.prototype.execQuery = function (request) {
            var _this = this;
            var deferred = this.$q.defer();
            this.cfpLoadingBar.start();
            this.$http(request)
                .then(function (response) {
                _this.cfpLoadingBar.complete();
                deferred.resolve(response.data);
            }, function (response) {
                _this.cfpLoadingBar.complete();
                deferred.reject(response.data);
            });
            return deferred.promise;
        };
        return Service;
    })();
    TestApiModule.Service = Service;
})(TestApiModule || (TestApiModule = {}));
angular.module('DoctorApp')
    .service('testApiService', TestApiModule.Service);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../run.ts" />
/// <reference path="test-api-service.ts" />
var TestApiModule;
(function (TestApiModule) {
    var ModalWidth = ModalModule.ModalWidth;
    var Body = (function () {
        function Body() {
            this.isExists = false;
            this.content = '';
        }
        return Body;
    })();
    TestApiModule.Body = Body;
    var Header = (function () {
        function Header() {
            this.key = '';
            this.value = '';
        }
        return Header;
    })();
    TestApiModule.Header = Header;
    var Url = (function () {
        function Url() {
        }
        return Url;
    })();
    TestApiModule.Url = Url;
    var Controller = (function () {
        Controller.$inject = ["$scope", "$rootScope", "$filter", "testApiService", "$compile", "$timeout", "$routeParams", "$location", "showDialog"];
        function Controller($scope, $rootScope, $filter, testApiService, $compile, $timeout, $routeParams, $location, showDialog) {
            "ngInject";
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.$filter = $filter;
            this.testApiService = testApiService;
            this.$compile = $compile;
            this.$timeout = $timeout;
            this.$routeParams = $routeParams;
            this.$location = $location;
            this.showDialog = showDialog;
            $scope.defaultUrl = $routeParams.url;
            var POST_INDEX = 1;
            var PUT_INDEX = 2;
            var ERROR = "Error";
            var SUCCESS = "Success";
            var that = this;
            $scope.updateUrls = function () {
                $scope.url.list = [];
                testApiService.execGetRoutes()
                    .then(function (response) {
                    $scope.url.list = response;
                    that.changeUrlInput($scope.url.input);
                    if ($scope.defaultUrl) {
                        var url = $scope.url.displayedList[0];
                        $scope.selectedItem = url;
                        $scope.url.input = url.RoutePath;
                        $scope.method = url.HttpMethod;
                    }
                });
            };
            (function init() {
                $scope.methods = ['GET', 'POST', 'PUT', 'DELETE'];
                $scope.method = $scope.methods[0];
                $scope.url = {
                    input: $scope.defaultUrl ? $scope.defaultUrl : '',
                    showPopup: false,
                    displayedList: [],
                    list: [],
                    variables: []
                };
                $scope.headers = [];
                $scope.body = new Body();
                $scope.showResponse = false;
                $scope.supportedCopy = !document.queryCommandSupported('copy');
                $scope.updateUrls();
            })();
            $scope.send = function () {
                $scope.formatBody();
                var req = createRequest();
                testApiService.execQuery(req)
                    .then(function (responseSuccess) {
                    appendResponse(responseSuccess, SUCCESS);
                }, function (responseError) {
                    appendResponse(responseError, ERROR);
                });
            };
            function createRequest() {
                var method = $scope.method;
                var url = buildUrlWithVariables($scope.url.input, $scope.url.variables);
                var headerObj = buildHeaders();
                var body = $scope.body;
                var data = body.isExists ? body.content : {};
                return {
                    method: method,
                    url: GlobalVar.serverURL + url,
                    headers: headerObj,
                    data: data
                };
            }
            function buildUrlWithVariables(urlTemp, params) {
                for (var i = 0; i < params.length; i++) {
                    var param = params[i];
                    urlTemp = urlTemp.replace(new RegExp(param.key, 'g'), param.value);
                }
                return urlTemp;
            }
            function buildHeaders() {
                var res = [];
                $scope.headers.forEach(function (item) {
                    if (item.key && item.value) {
                        res[item.key] = item.value;
                    }
                });
                return res;
            }
            function appendResponse(response, type) {
                $scope.result = type;
                $scope.showResponse = true;
                var responseContainer = angular.element('#response-container');
                responseContainer.children().remove();
                if (ERROR === type) {
                    appendError(responseContainer, response);
                }
                else {
                    appendSuccess(responseContainer, response);
                }
            }
            function appendError(responseContainer, response) {
                var template = '<iframe id="frame-response" class="full-size"></iframe>';
                responseContainer.append(template);
                $timeout(function () {
                    var frameResponse = angular.element('#frame-response');
                    var body = frameResponse.contents().find('body');
                    body.html(response);
                }, 50);
            }
            function appendSuccess(responseContainer, response) {
                var template = '<textarea id="textarea-response" ng-bind="response" readonly style="resize: none;"></textarea>';
                responseContainer.append($compile(template)($scope));
                $scope.response = angular.toJson(response, true);
            }
            $scope.selectItem = function (url) {
                $scope.selectedItem = url;
                $scope.url.input = url.RoutePath;
                $scope.url.displayedList = $scope.url.list;
                $scope.method = url.HttpMethod;
            };
            $scope.shareLink = function () {
                if ($scope.selectedItem) {
                    var absUrl = $location.absUrl();
                    var contextRoot = absUrl.substring(0, absUrl.lastIndexOf("/")) + $location.path();
                    showDialog.info(contextRoot + "?url=" + $scope.selectedItem.RoutePath, ModalWidth._550px);
                }
            };
            $scope.$watch('method', function (newValue, oldValue) {
                var methods = $scope.methods;
                $scope.body.isExists = (newValue == methods[POST_INDEX] || newValue == methods[PUT_INDEX]);
            });
            $scope.$watch('url.input', function (newValue, oldValue) {
                that.changeUrlInput(newValue);
            });
            $scope.addHeader = function () {
                $scope.headers[$scope.headers.length] = new Header();
            };
            $scope.deleteHeader = function (index) {
                $scope.headers.splice(index, 1);
            };
            $scope.toggleDropdown = function ($event) {
                $event.preventDefault();
                $event.stopPropagation();
                $scope.url.showPopup = true;
            };
            $scope.copy = function () {
                var response = document.querySelector('#response');
                var range = document.createRange();
                range.selectNode(response);
                window.getSelection().addRange(range);
                try {
                    document.execCommand('copy');
                }
                catch (err) {
                }
                window.getSelection().removeAllRanges();
            };
            $scope.formatBody = function () {
                try {
                    if ($scope.body && $scope.body.content) {
                        var obj = JSON.parse($scope.body.content);
                        $scope.body.content = JSON.stringify(obj, undefined, 4);
                    }
                }
                catch (e) {
                    console.log(e);
                }
            };
            $scope.shieldBody = function () {
                try {
                    if ($scope.body && $scope.body.content) {
                        var body = $scope.body.content;
                        if (body.indexOf('\\"') === -1) {
                            body = body.replace(/"/g, '\\"');
                        }
                        else {
                            body = body.replace(/\\"/g, '"');
                        }
                        $scope.body.content = body;
                    }
                }
                catch (e) {
                    console.log(e);
                }
            };
        }
        Controller.prototype.changeUrlInput = function (inputText) {
            var urls = this.$scope.url.list;
            this.$scope.url.displayedList = inputText ? this.$filter('filter')(urls, inputText) : urls;
            this.$scope.url.variables = this.parseUrl(inputText);
            if (!inputText) {
                this.$scope.selectedItem = null;
            }
        };
        Controller.prototype.parseUrl = function (url) {
            var NOT_FOUND = -1;
            var startIndex = -1;
            var elements = [];
            do {
                startIndex++;
                startIndex = url.indexOf('{', startIndex);
                var endIndex = url.indexOf('}', startIndex);
                if (startIndex !== NOT_FOUND && endIndex !== NOT_FOUND) {
                    var urlName = url.substring(startIndex, endIndex + 1);
                    elements[elements.length] = { key: urlName, value: this.getDefaultUrlVariable(urlName) };
                }
            } while (startIndex !== NOT_FOUND);
            return elements;
        };
        Controller.prototype.getDefaultUrlVariable = function (variableName) {
            var name = variableName.toLowerCase();
            switch (name) {
                case '{tenantid}':
                case '{practiceid}':
                case '{providerid}':
                    return this.testApiService.getPracticeId();
                default:
                    return '';
            }
        };
        return Controller;
    })();
    TestApiModule.Controller = Controller;
})(TestApiModule || (TestApiModule = {}));
angular.module('DoctorApp')
    .controller('TestApiController', TestApiModule.Controller);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../services/api/result-api.ts" />
/// <reference path="../../services/api/domain/tenant.ts" />
/// <reference path="../../services/show-dialog.ts" />
/// <reference path="../../run.ts" />
var Plugins = (function () {
    function Plugins() {
    }
    Plugins.getPlugin = function (index) {
        return this.items[index];
    };
    Plugins.addItem = function (component) {
        this.items.push(component);
    };
    Plugins.getCount = function () {
        return this.items.length;
    };
    Plugins.items = [];
    return Plugins;
})();
var TestModule;
(function (TestModule) {
    var Controller = (function () {
        Controller.$inject = ["$scope", "modalService", "$parse"];
        function Controller($scope, modalService, $parse) {
            "ngInject";
            this.$scope = $scope;
            this.modalService = modalService;
            this.$parse = $parse;
            $scope.mbi = function () {
            };
            $scope.exec = function () {
                eval('(function(window,navigator,angular){"use strict";' +
                    $scope.jsCode +
                    '})({},{},{})');
            };
            $scope.run = function () {
                var count = Plugins.getCount();
                for (var i = 0; i < count; i++) {
                    var plugin = Plugins.getPlugin(i);
                    plugin.processEnc({ message: 'message' });
                }
            };
            $scope.schema = {
                type: "object",
                properties: {
                    name: {
                        type: "string",
                        minLength: 2,
                        title: "First name",
                        description: "Patient first name"
                    },
                    title: {
                        type: "string",
                        title: "Title",
                        enum: ['dr', 'jr', 'sir', 'mrs', 'mr', 'NaN', 'dj']
                    },
                    cashAccount: {
                        type: "boolean",
                        title: "Is cash account"
                    },
                    radios: {
                        title: "Basic radio button example",
                        type: "string",
                        enum: [
                            "a",
                            "b",
                            "c"
                        ]
                    },
                    comment: {
                        title: "Comment",
                        type: "string",
                        maxLength: 20,
                        validationMessage: "Don't be greedy!"
                    }
                }
            };
            $scope.form = [
                "*",
                {
                    "key": "radios",
                    "type": "radios",
                    "titleMap": [
                        {
                            "value": "c",
                            "name": "C"
                        },
                        {
                            "value": "b",
                            "name": "B"
                        },
                        {
                            "value": "a",
                            "name": "A"
                        }
                    ]
                },
                {
                    "key": "comment",
                    "type": "textarea",
                    "placeholder": "Make a comment"
                },
                {
                    type: "submit",
                    title: "Save"
                }
            ];
            $scope.tinymceOptions = {
                selector: 'textarea',
                plugins: 'link image table preview print code',
                toolbar: 'undo redo | bold italic | fontsizeselect | bullist numlist outdent indent | alignleft aligncenter alignright | file | code',
                fontsize_formats: '8pt 10pt 12pt 14pt 18pt 24pt 36pt',
                height: 300,
                skin_url: GlobalVar.isProd ? 'styles/tinymce/skins/lightgray' : '',
                visual: false,
                browser_spellcheck: true,
                contextmenu: false,
                statusbar: false,
                valid_children: "+body[style]"
            };
            $scope.model = { name: "default" };
        }
        return Controller;
    })();
    TestModule.Controller = Controller;
})(TestModule || (TestModule = {}));
angular.module('DoctorApp')
    .controller('TestController', TestModule.Controller);
/// <reference path="../../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../http-service.ts" />
/// <reference path="../result-api.ts" />
var Domain;
(function (Domain) {
    var Timer;
    (function (Timer) {
        var TimerVo = (function () {
            function TimerVo() {
            }
            return TimerVo;
        })();
        Timer.TimerVo = TimerVo;
        var Service = (function () {
            Service.$inject = ["httpService"];
            function Service(httpService) {
                "ngInject";
                this.httpService = httpService;
            }
            Service.prototype.getTimerList = function (dateFrom, dateTo) {
                return this.httpService.get(this.getUrl() +
                    'fromdate/' +
                    dateFrom.format('YYYY-MM-DD') +
                    '/todate/' +
                    dateTo.format('YYYY-MM-DD'));
            };
            Service.prototype.getTimer = function (nodeId) {
                return this.httpService.get(this.getUrl() + nodeId);
            };
            Service.prototype.setTimer = function (timer) {
                var timerRequest = new TimerRequest();
                timerRequest.FollowUpDateTime = timer.FollowUpDateTime;
                timerRequest.CallbackCommand = timer.CallbackCommand;
                return this.httpService.post(this.getUrl(), timerRequest);
            };
            Service.prototype.cancelTimer = function (timerId) {
                return this.httpService.post(this.getUrl() + timerId);
            };
            Service.prototype.getUrl = function () {
                return 'v1/infrastructure/timer/';
            };
            return Service;
        })();
        Timer.Service = Service;
        var TimerRequest = (function () {
            function TimerRequest() {
            }
            return TimerRequest;
        })();
    })(Timer = Domain.Timer || (Domain.Timer = {}));
})(Domain || (Domain = {}));
angular.module('DoctorApp')
    .service('timerDomainService', Domain.Timer.Service);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../services/api/result-api.ts" />
/// <reference path="../../services/api/domain/timer.ts" />
/// <reference path="../../../scripts/definition/moment/moment-node.d.ts" />
/// <reference path="../../services/show-dialog.ts" />
/// <reference path="../../run.ts" />
var TimerModule;
(function (TimerModule) {
    var Timer = Domain.Timer.TimerVo;
    var SetTimerController = (function () {
        SetTimerController.$inject = ["$scope", "$rootScope", "timerDomainService", "locationService", "showDialog", "moment", "$filter"];
        function SetTimerController($scope, $rootScope, timerDomainService, locationService, showDialog, moment, $filter) {
            "ngInject";
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.timerDomainService = timerDomainService;
            this.locationService = locationService;
            this.showDialog = showDialog;
            this.moment = moment;
            this.$filter = $filter;
            $scope.title = 'Set timer';
            $scope.saveTimer = function (timer) {
                $scope.timer.FollowUpDateTime = moment($scope.timer.FollowUpDateTime, "DD/MM/YYYY HH:mm").toJSON();
                timerDomainService.setTimer(timer).then(function (response) {
                    if (response.Sucess === false) {
                        showDialog.error(response.ResponseMessage);
                    }
                    else {
                        showDialog.info("The new timer was successfully setted.");
                        $rootScope.back();
                    }
                });
            };
            $scope.done = function (isValid) {
                if (isValid) {
                    $scope.saveTimer($scope.timer);
                }
            };
            $scope.timer = new Timer();
        }
        return SetTimerController;
    })();
    TimerModule.SetTimerController = SetTimerController;
})(TimerModule || (TimerModule = {}));
angular.module('DoctorApp')
    .controller('SetTimerController', TimerModule.SetTimerController);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../services/api/result-api.ts" />
/// <reference path="../../services/api/domain/timer.ts" />
/// <reference path="../../services/show-dialog.ts" />
/// <reference path="../../run.ts" />
var TimerModule;
(function (TimerModule) {
    var TimerController = (function () {
        TimerController.$inject = ["$scope", "$rootScope", "timerDomainService", "locationService", "showDialog", "$filter", "moment"];
        function TimerController($scope, $rootScope, timerDomainService, locationService, showDialog, $filter, moment) {
            "ngInject";
            var _this = this;
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.timerDomainService = timerDomainService;
            this.locationService = locationService;
            this.showDialog = showDialog;
            this.$filter = $filter;
            this.moment = moment;
            $scope.datePattern = "dd/MM/yyyy HH:mm";
            $scope.timers = [];
            $scope.searchText = '';
            $scope.goToCreateTimer = function () {
                locationService.goToCreateTimer();
            };
            $scope.deleteTimer = function (timer) {
                showDialog.confirm("Are you sure want to cancel timer: " + timer.TimerId)
                    .then(function () {
                    timerDomainService.cancelTimer(timer.TimerId)
                        .then(function (response) {
                        if (response.Sucess === false) {
                            showDialog.error(response.ResponseMessage);
                        }
                        else {
                            showDialog.info("The timer: " + timer.TimerId + " was successfully canceled.");
                            _this.updateTimers();
                        }
                    });
                });
            };
            $scope.changeSearchText = function (text) {
                $scope.timers = text ? $filter('filter')($scope.timersInMemory, text) : $scope.timersInMemory;
            };
            $scope.changeFilterByDate = function (first) {
                if (first) {
                    $scope.configTo.min = $scope.dateFrom;
                }
                else {
                    $scope.configFrom.max = $scope.dateTo;
                }
                _this.updateTimers();
            };
            $scope.$watch('timersInMemory', function () {
                $scope.timersCount = $scope.timersInMemory
                    .reduce(function (previousValue, currentValue) { return (previousValue + currentValue.Timers.length); }, 0);
            });
            this.init();
        }
        TimerController.prototype.init = function () {
            this.setDefaultFilterValues();
            this.updateTimers();
        };
        TimerController.prototype.setDefaultFilterValues = function () {
            var now = this.moment.utc();
            this.$scope.dateFrom = this.moment(now);
            this.$scope.dateTo = this.moment(now).add(1, 'months');
            var configFrom = new DatePickerModule.Config();
            configFrom.format = 'dd MM, yy';
            configFrom.max = this.$scope.dateTo;
            configFrom.min = this.moment(now);
            this.$scope.configFrom = configFrom;
            var configTo = new DatePickerModule.Config();
            configTo.format = 'dd MM, yy';
            configTo.min = this.$scope.dateFrom;
            this.$scope.configTo = configTo;
        };
        TimerController.prototype.updateTimers = function () {
            var _this = this;
            var that = this;
            that.timerDomainService.getTimerList(that.$scope.dateFrom, that.$scope.dateTo)
                .then(function (response) {
                _this.$scope.timersInMemory = response;
                _this.$scope.changeSearchText(_this.$scope.searchText);
            });
        };
        return TimerController;
    })();
    TimerModule.TimerController = TimerController;
})(TimerModule || (TimerModule = {}));
angular.module('DoctorApp')
    .controller('TimerController', TimerModule.TimerController);
/// <reference path="../../../../scripts/definition/angularjs/angular.d.ts" />
var ModalModule;
(function (ModalModule) {
    var InviteDoctorController = (function () {
        InviteDoctorController.$inject = ["$scope", "modalService", "$modalInstance", "clinicalDomain", "$routeParams"];
        function InviteDoctorController($scope, modalService, $modalInstance, clinicalDomain, $routeParams) {
            "ngInject";
            this.$scope = $scope;
            this.modalService = modalService;
            this.$modalInstance = $modalInstance;
            this.clinicalDomain = clinicalDomain;
            this.$routeParams = $routeParams;
            $scope.openCellPhoneDialog = function () {
                modalService.openNumbers('cellphone', 'Enter cellphone')
                    .then(function (cellPhone) {
                    if (cellPhone) {
                        $scope.model.cellphone = cellPhone;
                    }
                });
            };
            $scope.cancel = function () {
                $modalInstance.dismiss();
            };
            $scope.invite = function () {
                if ($scope.model.cellphone !== "" && $scope.model.email !== "" && $scope.model.name !== "") {
                    var body = {
                        ContactNumber: $scope.model.cellphone,
                        Name: $scope.model.name,
                        Email: $scope.model.email
                    };
                    clinicalDomain.inviteDoctor($routeParams.practiceId, body).
                        then(function (response) {
                        if (!response.Sucess) {
                            modalService.error(response.ResponseMessage);
                        }
                        else {
                            modalService.info("Thank you for sending an invite");
                            $modalInstance.close($scope.model);
                        }
                    });
                }
                else {
                    modalService.error("Please enter valid info in the highlighted fields");
                }
            };
            $scope.model = {};
            $scope.model.cellphone = "";
        }
        return InviteDoctorController;
    })();
    ModalModule.InviteDoctorController = InviteDoctorController;
})(ModalModule || (ModalModule = {}));
angular.module('DoctorApp')
    .controller('InviteDoctorController', ModalModule.InviteDoctorController);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
var UserAccountModule;
(function (UserAccountModule) {
    var UserAccountController = (function () {
        UserAccountController.$inject = ["$scope", "$routeParams", "$rootScope", "userService", "showDialog", "$filter", "accountDomain", "modalService", "locationService", "providerService"];
        function UserAccountController($scope, $routeParams, $rootScope, userService, showDialog, $filter, accountDomain, modalService, locationService, providerService) {
            "ngInject";
            var _this = this;
            this.$scope = $scope;
            this.$routeParams = $routeParams;
            this.$rootScope = $rootScope;
            this.userService = userService;
            this.showDialog = showDialog;
            this.$filter = $filter;
            this.accountDomain = accountDomain;
            this.modalService = modalService;
            this.locationService = locationService;
            this.providerService = providerService;
            $scope.userId = $routeParams.userId;
            $scope.changePassword = function () {
                _this.locationService.goToChangePassword($routeParams.practiceId, $scope.userId);
            };
            $scope.goToHome = function () {
                _this.locationService.goToHome($routeParams.practiceId);
            };
            $scope.editUser = function () {
                if (_this.$scope.showAdminLinks) {
                    _this.locationService.goToEditUser($scope.userId);
                }
            };
            $scope.openAddressBook = function () {
                _this.locationService.goToAddressBook($routeParams.practiceId);
            };
            $scope.openNotificationsBulkSend = function () {
                _this.locationService.goToNotificationsBulkSend($routeParams.practiceId);
            };
            $scope.openTemplates = function () {
                _this.locationService.goToClinicalTemplates($routeParams.practiceId);
            };
            $scope.openTemplatesBulkImport = function () {
                _this.locationService.goToTemplatesBulkImport($routeParams.practiceId);
            };
            $scope.openPractices = function () {
                _this.locationService.goToPractices();
            };
            $scope.editPractice = function () {
                var practiceId = $routeParams.practiceId;
                _this.locationService.goToEditPractice(practiceId);
            };
            $scope.openPracticeOptions = function () {
                var practiceId = $routeParams.practiceId;
                _this.locationService.goToPracticeOptions(practiceId);
            };
            $scope.openReports = function () {
                var practiceId = $routeParams.practiceId;
                _this.locationService.goToPowerBi(practiceId);
            };
            $scope.openFailedInvoices = function () {
                _this.locationService.goToFailedInvoices();
            };
            $scope.openUsers = function () {
                _this.locationService.goToUsers();
            };
            $scope.openTenants = function () {
                _this.locationService.goToTenants();
            };
            $scope.openCardReaders = function () {
                _this.locationService.goToCardReaders();
            };
            $scope.openCardPayments = function () {
                _this.locationService.goToCardPayments();
            };
            $scope.openPublicKeys = function () {
                _this.locationService.goToPublicKeys();
            };
            $scope.openAudit = function () {
                _this.locationService.gotToAudit();
            };
            $scope.openTenantEvents = function () {
                var practiceId = $routeParams.practiceId;
                _this.locationService.goToTenantEvents(practiceId);
            };
            $scope.openSpecialityRules = function () {
                _this.locationService.goToSpecialityRules();
            };
            $scope.openTestAPI = function () {
                _this.locationService.gotToTestApi();
            };
            this.init();
        }
        UserAccountController.prototype.init = function () {
            var _this = this;
            this.accountDomain.getUser(this.$scope.userId)
                .then(function (response) {
                _this.$scope.user = response;
                for (var i = 0; i < response.Claims.length; i++) {
                    if (response.Claims[i].ClaimScope === '*') {
                        _this.$scope.showAdminLinks = true;
                        return;
                    }
                }
            });
            var practiceId = this.$routeParams.practiceId;
            this.providerService.getProviderOptions(practiceId)
                .then(function (options) {
                _this.$scope.isPowerBIEnabled = options.isPowerBIEnabled;
            });
        };
        UserAccountController.prototype.updateUsers = function () {
        };
        return UserAccountController;
    })();
    UserAccountModule.UserAccountController = UserAccountController;
})(UserAccountModule || (UserAccountModule = {}));
angular.module('DoctorApp')
    .controller('UserAccountController', UserAccountModule.UserAccountController);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../practice/practice-service.ts" />
/// <reference path="../../services/api/domain/account.ts" />
/// <reference path="../../run.ts" />
var UserModule;
(function (UserModule) {
    var ConfirmPassword = (function () {
        function ConfirmPassword() {
        }
        return ConfirmPassword;
    })();
    UserModule.ConfirmPassword = ConfirmPassword;
    var UserAbsController = (function () {
        UserAbsController.$inject = ["$rootScope", "$scope", "moment", "practiceService"];
        function UserAbsController($rootScope, $scope, moment, practiceService) {
            "ngInject";
            var _this = this;
            this.$rootScope = $rootScope;
            this.$scope = $scope;
            this.moment = moment;
            this.practiceService = practiceService;
            $scope.roles = ["doctor", "front-office-user", "receptionist", "system-admin", "practicing-nurse", "triage-nurse"];
            $scope.changePassword = function () {
                if ($scope.user && $scope.confirmPassword) {
                    $scope.confirmPassword.matched = $scope.confirmPassword.value == $scope.user.Password;
                    $scope.userForm.confirm.$setValidity('notMatched', $scope.confirmPassword.matched);
                }
            };
            $scope.addRole = function () {
                var role = new Domain.Account.Claim();
                role.ClaimType = 'role';
                if (!$scope.user.Claims) {
                    $scope.user.Claims = [];
                }
                $scope.user.Claims.push(role);
            };
            $scope.deleteRole = function (index) {
                if ($scope.user.Claims && index >= 0) {
                    $scope.user.Claims.splice(index, 1);
                }
            };
            $scope.searchPractices = function (text) {
                if (text === '' || text === 'All') {
                    text = '';
                }
                practiceService.getProvidersPageAndSearch(text, 0, 100)
                    .then(function (practicesPage) {
                    if (practicesPage) {
                        $scope.practices = [].concat(practicesPage);
                    }
                });
            };
            $scope.loadPractices = function () {
                practiceService.getAllPractices()
                    .then(function (response) {
                    $scope.practices = response;
                });
            };
            $scope.rollbackUserRoles = function () {
                $scope.user.Claims.splice(1, $scope.user.Claims.length - 1);
            };
            $scope.validate = function (isValid, funcSuccess, funcError) {
                if (!$scope.confirmPassword.matched) {
                    funcError(UserAbsController.PASSWORD_NOT_MATCHED);
                }
                else if (!isValid) {
                    funcError(UserAbsController.FIELD_NOT_FILL);
                }
                else {
                    funcSuccess();
                }
            };
            $scope.clearExpirationTime = function () {
                _this.$scope.user.ExpirationTime = null;
                _this.$scope.expirationTimeStr = null;
            };
            $scope.onTimeOfServiceChange = function (date) {
                var consMoment = moment(new Date(date));
                _this.$scope.user.ExpirationTime = consMoment.utc().format(ServerDateFormat);
            };
            this.init();
        }
        UserAbsController.prototype.init = function () {
            this.$scope.practices = [];
            this.$scope.confirmPassword = new ConfirmPassword();
        };
        UserAbsController.PASSWORD_NOT_MATCHED = "Passwords doesn't matched !";
        UserAbsController.FIELD_NOT_FILL = "Please enter valid info in the highlighted fields !";
        return UserAbsController;
    })();
    UserModule.UserAbsController = UserAbsController;
})(UserModule || (UserModule = {}));
angular.module('DoctorApp')
    .controller('UserController', UserModule.UserAbsController);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../services/http-service.ts" />
/// <reference path="../../services/api/domain/account.ts" />
var UserModule;
(function (UserModule) {
    var Service = (function () {
        Service.$inject = ["accountDomain"];
        function Service(accountDomain) {
            "ngInject";
            this.accountDomain = accountDomain;
        }
        Service.prototype.createUser = function (user) {
            return this.accountDomain.createUser(user);
        };
        Service.prototype.getUsers = function () {
            return this.accountDomain.getUsers();
        };
        Service.prototype.updateUser = function (user) {
            return this.accountDomain.updateUser(user);
        };
        Service.prototype.getUsersPageAndSearch = function (filter, pageCount, pageSize) {
            return this.accountDomain.getUsersPage(filter, pageCount, pageSize);
        };
        Service.prototype.getUser = function (userId) {
            return this.accountDomain.getUser(userId);
        };
        Service.prototype.deleteUser = function (userId) {
            return this.accountDomain.deleteUser(userId);
        };
        return Service;
    })();
    UserModule.Service = Service;
})(UserModule || (UserModule = {}));
angular.module('DoctorApp')
    .service('userService', UserModule.Service);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../services/show-dialog.ts" />
/// <reference path="../../run.ts" />
/// <reference path="user-service.ts" />
/// <reference path="user-abstract.ts" />
var UserModule;
(function (UserModule) {
    var UserCreateController = (function () {
        UserCreateController.$inject = ["$scope", "$rootScope", "locationService", "showDialog", "userService", "$controller"];
        function UserCreateController($scope, $rootScope, locationService, showDialog, userService, $controller) {
            "ngInject";
            var _this = this;
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.locationService = locationService;
            this.showDialog = showDialog;
            this.userService = userService;
            this.$controller = $controller;
            angular.extend(this, $controller('UserController', { $scope: $scope }));
            $scope.done = function (isValid) {
                $scope.validate(isValid, function () {
                    _this.saveUser($scope.user);
                }, function (error) {
                    showDialog.error(error);
                });
            };
            this.init();
        }
        UserCreateController.prototype.init = function () {
            this.$scope.create = true;
            this.$scope.title = 'Create user';
            this.$scope.user = new Domain.Account.User();
            this.$scope.user.RequirePasswordChange = true;
            this.$scope.addRole();
            this.$scope.loadPractices();
        };
        UserCreateController.prototype.saveUser = function (user) {
            var _this = this;
            this.userService.createUser(user)
                .then(function (response) {
                if (response.Sucess) {
                    _this.showDialog.info("The new user was successfully created.");
                    _this.$rootScope.back();
                }
                else {
                    _this.showDialog.error(response.ResponseMessage);
                    _this.$scope.rollbackUserRoles();
                }
            })
                .catch(function (error) {
                _this.$scope.rollbackUserRoles();
            });
        };
        return UserCreateController;
    })();
    UserModule.UserCreateController = UserCreateController;
})(UserModule || (UserModule = {}));
angular.module('DoctorApp')
    .controller('UserCreateController', UserModule.UserCreateController);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="user-abstract.ts" />
/// <reference path="user-service.ts" />
/// <reference path="../../run.ts" />
/// <reference path="../../services/show-dialog.ts" />
var UserModule;
(function (UserModule) {
    var UserEditController = (function () {
        UserEditController.$inject = ["$scope", "$rootScope", "locationService", "showDialog", "userService", "moment", "$routeParams", "$controller"];
        function UserEditController($scope, $rootScope, locationService, showDialog, userService, moment, $routeParams, $controller) {
            "ngInject";
            var _this = this;
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.locationService = locationService;
            this.showDialog = showDialog;
            this.userService = userService;
            this.moment = moment;
            this.$routeParams = $routeParams;
            this.$controller = $controller;
            this.PASSWORD_TO_MEET_VALIDATION = 'Charlie1!';
            angular.extend(this, $controller('UserController', { $scope: $scope }));
            $scope.done = function (isValid) {
                $scope.validate(isValid, function () {
                    _this.updateUser($scope.user);
                }, function (error) {
                    showDialog.error(error);
                });
            };
            this.init();
        }
        UserEditController.prototype.init = function () {
            this.$scope.create = false;
            this.$scope.title = 'Edit user';
            this.getUser();
        };
        UserEditController.prototype.getUser = function () {
            var _this = this;
            var userId = this.$routeParams.userId;
            return this.userService.getUser(userId)
                .then(function (user) {
                _this.$scope.user = user;
                _this.$scope.user.Password = _this.PASSWORD_TO_MEET_VALIDATION;
                _this.$scope.confirmPassword.value = _this.PASSWORD_TO_MEET_VALIDATION;
                _this.$scope.confirmPassword.matched = true;
                _this.$scope.expirationTimeStr = _this.moment(user.ExpirationTime).format('D MMMM, YYYY LT');
                var providerId = user.Claims.length && user.Claims[0].ClaimScope;
                _this.$scope.searchPractices(providerId);
            })
                .catch(function () {
                _this.$rootScope.back();
            });
        };
        UserEditController.prototype.updateUser = function (user) {
            var _this = this;
            var userCopy = angular.copy(user);
            if (userCopy.Password === this.PASSWORD_TO_MEET_VALIDATION) {
                userCopy.Password = null;
            }
            this.userService.updateUser(userCopy)
                .then(function (response) {
                _this.$rootScope.back();
            });
        };
        UserEditController.DATE_OUT_PATTERN = 'D MMMM, YYYY';
        return UserEditController;
    })();
    UserModule.UserEditController = UserEditController;
})(UserModule || (UserModule = {}));
angular.module('DoctorApp')
    .controller('UserEditController', UserModule.UserEditController);
/// <reference path="../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../user/user-service.ts" />
/// <reference path="../../services/show-dialog.ts" />
/// <reference path="../../run.ts" />
var UserModule;
(function (UserModule) {
    var UsersController = (function () {
        UsersController.$inject = ["$scope", "$rootScope", "userService", "locationService", "showDialog", "$filter", "modalService", "$routeParams"];
        function UsersController($scope, $rootScope, userService, locationService, showDialog, $filter, modalService, $routeParams) {
            "ngInject";
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.userService = userService;
            this.locationService = locationService;
            this.showDialog = showDialog;
            this.$filter = $filter;
            this.modalService = modalService;
            this.$routeParams = $routeParams;
            $scope.goToCreateUser = function () {
                locationService.goToCreateUser();
            };
            $scope.editUser = function (user) {
                locationService.goToEditUser(user.UserId);
            };
            $scope.deleteUser = function (user) {
                showDialog.confirm("Are you sure want to delete user: " + user.Username)
                    .then(function () {
                    return userService.deleteUser(user.UserId);
                })
                    .then(function () {
                    showDialog.info("The user: " + user.Username + " was successfully deleted.");
                })
                    .catch(function (error) {
                    if (error) {
                        showDialog.error(error);
                    }
                });
            };
            $scope.loadNextPage = function () {
                if (!$scope.allPagesLoaded && !$scope.isRunningPage) {
                    $scope.pageNo = $scope.pageNo + 1;
                    $scope.isRunningPage = true;
                    userService.getUsersPageAndSearch($scope.searchText, $scope.pageNo, $scope.pageSize)
                        .then(function (usersPage) {
                        if (usersPage) {
                            for (var i = 0; i < usersPage.length; i++) {
                                $scope.users.push(usersPage[i]);
                            }
                        }
                        $scope.allPagesLoaded = !usersPage ||
                            usersPage.length !== $scope.pageSize;
                        $scope.isRunningPage = false;
                    });
                }
            };
            $scope.doSearch = function () {
                var text = $scope.searchText;
                $scope.pageNo = 0;
                $scope.users = [];
                userService.getUsersPageAndSearch(text, $scope.pageNo, $scope.pageSize)
                    .then(function (usersPage) {
                    $scope.users = usersPage;
                    $scope.allPagesLoaded = !usersPage ||
                        usersPage.length !== $scope.pageSize;
                    $scope.isRunningPage = false;
                });
            };
            this.init();
        }
        UsersController.prototype.init = function () {
            this.$scope.users = [];
            this.$scope.pageSize = 10;
            this.$scope.pageNo = 0;
            this.$scope.allPagesLoaded = false;
            this.$scope.searchText = this.$routeParams.practiceId || '';
            this.$scope.doSearch();
        };
        return UsersController;
    })();
    UserModule.UsersController = UsersController;
})(UserModule || (UserModule = {}));
angular.module('DoctorApp')
    .controller('UsersController', UserModule.UsersController);
/// <reference path="../../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../http-service.ts" />
/// <reference path="../../auth-service.ts" />
var Domain;
(function (Domain) {
    var ChargeCode;
    (function (ChargeCode) {
        var Service = (function () {
            Service.$inject = ["httpService", "authService", "$q"];
            function Service(httpService, authService, $q) {
                "ngInject";
                this.httpService = httpService;
                this.authService = authService;
                this.$q = $q;
            }
            Service.prototype.getUrl = function () {
                return '';
            };
            return Service;
        })();
        ChargeCode.Service = Service;
    })(ChargeCode = Domain.ChargeCode || (Domain.ChargeCode = {}));
})(Domain || (Domain = {}));
angular.module('DoctorApp')
    .service('chargeCodeDomain', Domain.ChargeCode.Service);
/// <reference path="../../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../http-service.ts" />
/// <reference path="../../auth-service.ts" />
var Domain;
(function (Domain) {
    var Claim;
    (function (Claim) {
        var Service = (function () {
            Service.$inject = ["httpService", "authService", "$q"];
            function Service(httpService, authService, $q) {
                "ngInject";
                this.httpService = httpService;
                this.authService = authService;
                this.$q = $q;
            }
            Service.prototype.getUrl = function () {
                return '';
            };
            return Service;
        })();
        Claim.Service = Service;
    })(Claim = Domain.Claim || (Domain.Claim = {}));
})(Domain || (Domain = {}));
angular.module('DoctorApp')
    .service('claimDomain', Domain.Claim.Service);
/// <reference path="../../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../http-service.ts" />
/// <reference path="../../auth-service.ts" />
var Domain;
(function (Domain) {
    var Infrastructure;
    (function (Infrastructure) {
        var Service = (function () {
            Service.$inject = ["httpService", "authService", "$q"];
            function Service(httpService, authService, $q) {
                "ngInject";
                this.httpService = httpService;
                this.authService = authService;
                this.$q = $q;
            }
            Service.prototype.getUrl = function () {
                return '';
            };
            return Service;
        })();
        Infrastructure.Service = Service;
    })(Infrastructure = Domain.Infrastructure || (Domain.Infrastructure = {}));
})(Domain || (Domain = {}));
angular.module('DoctorApp')
    .service('infrastructureDomain', Domain.Infrastructure.Service);
/// <reference path="../../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../http-service.ts" />
/// <reference path="../../auth-service.ts" />
var Domain;
(function (Domain) {
    var NodePublic;
    (function (NodePublic) {
        var Service = (function () {
            Service.$inject = ["httpService", "authService", "$q"];
            function Service(httpService, authService, $q) {
                "ngInject";
                this.httpService = httpService;
                this.authService = authService;
                this.$q = $q;
            }
            Service.prototype.getUrl = function () {
                return '';
            };
            return Service;
        })();
        NodePublic.Service = Service;
    })(NodePublic = Domain.NodePublic || (Domain.NodePublic = {}));
})(Domain || (Domain = {}));
angular.module('DoctorApp')
    .service('nodePublicDomain', Domain.NodePublic.Service);
/// <reference path="../../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../http-service.ts" />
var Domain;
(function (Domain) {
    var PowerBI;
    (function (PowerBI) {
        var PowerBIReport = (function () {
            function PowerBIReport() {
            }
            return PowerBIReport;
        })();
        PowerBI.PowerBIReport = PowerBIReport;
        var Service = (function () {
            Service.$inject = ["httpService", "$q", "$timeout"];
            function Service(httpService, $q, $timeout) {
                "ngInject";
                this.httpService = httpService;
                this.$q = $q;
                this.$timeout = $timeout;
            }
            Service.prototype.getReports = function (practiceId) {
                return this.httpService.get("v1/" + practiceId + "/powerbi/reports/");
            };
            Service.prototype.getReport = function (practiceId, reportId) {
                return this.httpService.get("v1/" + practiceId + "/powerbi/reports/" + reportId);
            };
            return Service;
        })();
        PowerBI.Service = Service;
    })(PowerBI = Domain.PowerBI || (Domain.PowerBI = {}));
})(Domain || (Domain = {}));
angular.module('DoctorApp')
    .service('powerbiService', Domain.PowerBI.Service);
/// <reference path="../../../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../http-service.ts" />
/// <reference path="../../auth-service.ts" />
var Domain;
(function (Domain) {
    var WaitingRoom;
    (function (WaitingRoom) {
        var Service = (function () {
            Service.$inject = ["httpService", "authService", "$q"];
            function Service(httpService, authService, $q) {
                "ngInject";
                this.httpService = httpService;
                this.authService = authService;
                this.$q = $q;
            }
            Service.prototype.getUrl = function () {
                return '';
            };
            return Service;
        })();
        WaitingRoom.Service = Service;
    })(WaitingRoom = Domain.WaitingRoom || (Domain.WaitingRoom = {}));
})(Domain || (Domain = {}));
angular.module('DoctorApp')
    .service('waitingRoomDomain', Domain.WaitingRoom.Service);
var UsageModule;
(function (UsageModule) {
    (function (FeatureType) {
        FeatureType[FeatureType["HealthID"] = 0] = "HealthID";
        FeatureType[FeatureType["HealthDocs"] = 1] = "HealthDocs";
        FeatureType[FeatureType["PowerBI"] = 2] = "PowerBI";
        FeatureType[FeatureType["PatientReport"] = 3] = "PatientReport";
        FeatureType[FeatureType["PatientFiles"] = 4] = "PatientFiles";
        FeatureType[FeatureType["AddressBook"] = 5] = "AddressBook";
        FeatureType[FeatureType["PathologyReport"] = 6] = "PathologyReport";
        FeatureType[FeatureType["PathologyReportWorkflow"] = 7] = "PathologyReportWorkflow";
    })(UsageModule.FeatureType || (UsageModule.FeatureType = {}));
    var FeatureType = UsageModule.FeatureType;
    (function (ActionType) {
        ActionType[ActionType["ViewPatient"] = 0] = "ViewPatient";
        ActionType[ActionType["ViewDocument"] = 1] = "ViewDocument";
        ActionType[ActionType["ViewReport"] = 2] = "ViewReport";
        ActionType[ActionType["SendEmail"] = 3] = "SendEmail";
        ActionType[ActionType["NewContact"] = 4] = "NewContact";
        ActionType[ActionType["UpdateContact"] = 5] = "UpdateContact";
        ActionType[ActionType["DeleteContact"] = 6] = "DeleteContact";
        ActionType[ActionType["UseContact"] = 7] = "UseContact";
    })(UsageModule.ActionType || (UsageModule.ActionType = {}));
    var ActionType = UsageModule.ActionType;
    var UsageTypeUtil = (function () {
        function UsageTypeUtil() {
        }
        UsageTypeUtil.getFeature = function (featureType) {
            return this.FEATURES[featureType];
        };
        UsageTypeUtil.getAction = function (actionType) {
            return this.ACTIONS[actionType];
        };
        UsageTypeUtil.FEATURES = [
            'HealthID',
            'HealthDocs',
            'PowerBI',
            'PatientReport',
            'myPatientFiles',
            'AddressBook',
            'PathologyReport',
            'PathologyReportWorkflow'
        ];
        UsageTypeUtil.ACTIONS = [
            'View Patient',
            'View Document',
            'View Report',
            'Send Email',
            'New Contact',
            'Update Contact',
            'Delete Contact',
            'Use Contact'
        ];
        return UsageTypeUtil;
    })();
    UsageModule.UsageTypeUtil = UsageTypeUtil;
})(UsageModule || (UsageModule = {}));
/// <reference path="../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="auth-service.ts" />
var InterceptorModule;
(function (InterceptorModule) {
    var AuthService = (function () {
        AuthService.$inject = ["$q", "locationService", "storageService"];
        function AuthService($q, locationService, storageService) {
            "ngInject";
            var service = {};
            service.request = function (config) {
                var badChars = ['*'];
                config.headers = config.headers || {};
                var authData = storageService.getAuthorizationData();
                if (authData) {
                    if (config.url.indexOf(GlobalVar.serverURL) >= 0) {
                        config.headers.Authorization = 'Bearer ' + authData.token;
                    }
                }
                if ((config.url.indexOf("billing/providers") >= 0) &&
                    (config.method == "DELETE")) {
                    config.headers.Accept = "application/json, text/json, */*";
                    config.headers["Content-Type"] = "application/json; charset=UTF-8";
                }
                if ((config.method == "GET") && ((config.url.lastIndexOf("lookup") > 0) || (config.url.lastIndexOf("/patient/patients/") > 0))) {
                    var search = config.url.substr(config.url.lastIndexOf("/") + 1);
                    var response = {
                        "status": 777,
                        "statusText": "Search field cannot contain special characters."
                    };
                    if (search.lastIndexOf(".") === 0) {
                        return $q.reject(response);
                    }
                    for (var i = 0; i < badChars.length; i++) {
                        if (search.lastIndexOf(badChars[i]) >= 0) {
                            return $q.reject(response);
                        }
                    }
                }
                return config;
            };
            service.responseError = function (rejection) {
                return $q.reject(rejection);
            };
            return service;
        }
        return AuthService;
    })();
    InterceptorModule.AuthService = AuthService;
})(InterceptorModule || (InterceptorModule = {}));
angular.module('DoctorApp')
    .service('authInterceptorService', InterceptorModule.AuthService);
/// <reference path="../../scripts/definition/angularjs/angular.d.ts" />
var BrowserModule;
(function (BrowserModule) {
    (function (Type) {
        Type[Type["CHROME"] = 0] = "CHROME";
        Type[Type["SAFARI"] = 1] = "SAFARI";
        Type[Type["FIREFOX"] = 2] = "FIREFOX";
        Type[Type["IE"] = 3] = "IE";
        Type[Type["UNKNOWN"] = 4] = "UNKNOWN";
    })(BrowserModule.Type || (BrowserModule.Type = {}));
    var Type = BrowserModule.Type;
    var Service = (function () {
        Service.$inject = ["$window"];
        function Service($window) {
            "ngInject";
            this.$window = $window;
        }
        Service.prototype.getType = function () {
            var userAgent = this.$window.navigator.userAgent;
            var browsers = [/chrome/i, /safari/i, /firefox/i, /trident/i];
            for (var i = 0; i < browsers.length; i++) {
                if (browsers[i].test(userAgent)) {
                    return i;
                }
            }
            return Type.UNKNOWN;
        };
        return Service;
    })();
    BrowserModule.Service = Service;
})(BrowserModule || (BrowserModule = {}));
angular.module('DoctorApp')
    .service('browser', BrowserModule.Service);
/// <reference path="../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="auth-service.ts" />
var InfrastructureModule;
(function (InfrastructureModule) {
    var Service = (function () {
        Service.$inject = ["$http", "$q", "authService"];
        function Service($http, $q, authService) {
            "ngInject";
            this.$http = $http;
            this.$q = $q;
            this.authService = authService;
            this.offline = false;
        }
        Service.prototype.getNetworkState = function (practiceId) {
            var responseFail = { Sucess: false };
            var deferred = this.$q.defer();
            if (!practiceId) {
                deferred.resolve(responseFail);
            }
            else {
                var query = GlobalVar.serverURL + 'v1/' + practiceId + '/infrastructure/network/state';
                this.$http.get(query)
                    .then(function (response) {
                    deferred.resolve(response.data);
                })
                    .catch(function () {
                    deferred.resolve(responseFail);
                });
            }
            return deferred.promise;
        };
        return Service;
    })();
    InfrastructureModule.Service = Service;
})(InfrastructureModule || (InfrastructureModule = {}));
angular.module('DoctorApp')
    .service('infrastructureService', InfrastructureModule.Service);
/// <reference path="../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../scripts/definition/moment/moment-node.d.ts" />
angular.module('DoctorApp')
    .service('moment', function () {
    moment.defaultFormat = 'YYYY-MM-DDTHH:mm:ss[Z]';
    return moment;
});
/// <reference path="../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../app/services/http-service.ts" />
var NotificationModule;
(function (NotificationModule) {
    var Notification = (function () {
        function Notification() {
        }
        return Notification;
    })();
    NotificationModule.Notification = Notification;
    var Action = (function () {
        function Action() {
        }
        return Action;
    })();
    NotificationModule.Action = Action;
    var Service = (function () {
        Service.$inject = ["httpService", "$q", "modalService"];
        function Service(httpService, $q, modalService) {
            "ngInject";
            this.httpService = httpService;
            this.$q = $q;
            this.modalService = modalService;
        }
        Service.prototype.inviteDoctor = function (practiceId) {
            return this.modalService.showInviteDoctorDialog();
        };
        Service.prototype.notificationBulk = function (notifications) {
            return this.httpService.post(this.getUrl() + "infrastructure/notifications/bulk", notifications);
        };
        Service.prototype.notificationBulkFromFile = function (formData) {
            return this.httpService.post(this.getUrl() + "infrastructure/notifications/bulkfromfile", formData, {
                transformRequest: angular.identity,
                headers: { 'Content-Type': undefined }
            });
        };
        Service.prototype.raiseNotification = function (practiceId, notification) {
            var body = {
                Notification: notification,
                CorrelationId: [],
                OriginatedSystem: 'DoctorAppUI'
            };
            return this.httpService.post(this.getUrl() + practiceId + "/infrastructure/notifications", body);
        };
        Service.prototype.getNotifications = function (practiceId) {
            return this.httpService.get(this.getUrl() + practiceId + "/infrastructure/notifications");
        };
        Service.prototype.notificationAction = function (practiceId, notificationId, action) {
            return this.httpService.post(this.getUrl() + practiceId + "/infrastructure/notifications/" + notificationId + "/action", action);
        };
        Service.prototype.markNotificationViewed = function (practiceId, notificationId) {
            return this.httpService.post(this.getUrl() + practiceId + "/infrastructure/notifications/" + notificationId + "/view", {});
        };
        Service.prototype.getUrl = function () {
            return 'v1/';
        };
        return Service;
    })();
    NotificationModule.Service = Service;
})(NotificationModule || (NotificationModule = {}));
angular.module('DoctorApp')
    .service('notificationService', NotificationModule.Service);
/// <reference path="../../scripts/definition/angularjs/angular.d.ts" />
angular.module('DoctorApp')
    .service('promiseService', promiseService);
function promiseService() {
    var service = {
        defer: function () {
            return new CreateDefer();
        }
    };
    function CreateDefer() {
        var context = this;
        this.resolve = function () {
            context.success.apply(this, arguments);
        };
        this.reject = function () {
            context.error.apply(this, arguments);
        };
        this.promise = {
            then: function (success, error) {
                context.success = success ? success : function () {
                };
                context.error = error ? error : function () {
                };
            }
        };
    }
    return service;
}
/// <reference path="../../scripts/definition/angularjs/angular.d.ts" />
/// <reference path="../../app/services/api/usage-type.ts" />
/// <reference path="../../app/services/api/domain/billing.ts" />
/// <reference path="../../app/services/http-service.ts" />
/// <reference path="../../app/screens/patient/patient-service.ts" />
var UsageModule;
(function (UsageModule) {
    var FeatureUsageBody = (function () {
        function FeatureUsageBody() {
            this.FeatureUsage = new FeatureUsage();
        }
        return FeatureUsageBody;
    })();
    UsageModule.FeatureUsageBody = FeatureUsageBody;
    var FeatureUsage = (function () {
        function FeatureUsage() {
            this.Id = "";
        }
        return FeatureUsage;
    })();
    UsageModule.FeatureUsage = FeatureUsage;
    var Service = (function () {
        Service.$inject = ["httpService", "patientService", "storageService", "billingDomain", "moment"];
        function Service(httpService, patientService, storageService, billingDomain, moment) {
            "ngInject";
            this.httpService = httpService;
            this.patientService = patientService;
            this.storageService = storageService;
            this.billingDomain = billingDomain;
            this.moment = moment;
        }
        Service.prototype.logFeatureUsed = function (body) {
            return this.httpService.put(this.getUrl() + 'infrastructure/featureusage', body);
        };
        Service.prototype.sendEmail = function (practiceId, subject, email, bodyText) {
            var body = new FeatureUsageBody();
            var featureType = UsageModule.FeatureType.PatientReport;
            var actionType = UsageModule.ActionType.SendEmail;
            body.FeatureUsage.TenantId = practiceId;
            body.FeatureUsage.Feature = UsageModule.UsageTypeUtil.getFeature(featureType);
            body.FeatureUsage.Action = UsageModule.UsageTypeUtil.getAction(actionType);
            body.FeatureUsage.Parameters = {
                Subject: subject,
                Email: email,
                Body: bodyText
            };
            body.FeatureUsage.Date = this.getToday();
            this.logFeatureUsed(body);
        };
        Service.prototype.useAddressBook = function (practiceId, username, actionType, entry) {
            var body = new FeatureUsageBody();
            var featureType = UsageModule.FeatureType.AddressBook;
            body.FeatureUsage.TenantId = practiceId;
            body.FeatureUsage.Feature = UsageModule.UsageTypeUtil.getFeature(featureType);
            body.FeatureUsage.Action = UsageModule.UsageTypeUtil.getAction(actionType);
            body.FeatureUsage.Parameters = {
                Category: entry.Category,
                Username: username,
            };
            if (actionType !== UsageModule.ActionType.NewContact) {
                body.FeatureUsage.Parameters.EntryId = entry.AddressBookEntryId;
            }
            body.FeatureUsage.Date = this.getToday();
            this.logFeatureUsed(body);
        };
        Service.prototype.openHealthDocs = function (practiceId, patientId) {
            var body = new FeatureUsageBody();
            var featureType = UsageModule.FeatureType.HealthDocs;
            var actionType = UsageModule.ActionType.ViewDocument;
            body.FeatureUsage.TenantId = practiceId;
            body.FeatureUsage.Feature = UsageModule.UsageTypeUtil.getFeature(featureType);
            body.FeatureUsage.Action = UsageModule.UsageTypeUtil.getAction(actionType);
            body.FeatureUsage.Date = this.getToday();
            body.FeatureUsage.Parameters = {
                PatientId: patientId
            };
            this.logFeatureUsed(body);
        };
        Service.prototype.openPatientFiles = function (practiceId, patientId, documentId, username) {
            var body = new FeatureUsageBody();
            var featureType = UsageModule.FeatureType.PatientFiles;
            var actionType = UsageModule.ActionType.ViewDocument;
            body.FeatureUsage.TenantId = practiceId;
            body.FeatureUsage.Feature = UsageModule.UsageTypeUtil.getFeature(featureType);
            body.FeatureUsage.Action = UsageModule.UsageTypeUtil.getAction(actionType);
            body.FeatureUsage.Date = this.getToday();
            body.FeatureUsage.Parameters = {
                PatientId: patientId,
                DocumentId: documentId,
                Username: username,
                System: "DoctorApp Patient Timeline"
            };
            this.logFeatureUsed(body);
        };
        Service.prototype.openHealthID = function (practiceId, patientId) {
            var _this = this;
            var body = new FeatureUsageBody();
            var featureType = UsageModule.FeatureType.HealthID;
            var actionType = UsageModule.ActionType.ViewPatient;
            body.FeatureUsage.TenantId = practiceId;
            body.FeatureUsage.Feature = UsageModule.UsageTypeUtil.getFeature(featureType);
            body.FeatureUsage.Action = UsageModule.UsageTypeUtil.getAction(actionType);
            body.FeatureUsage.Date = this.getToday();
            this.patientService.getPatientById(practiceId, patientId)
                .then(function (patient) {
                if (patient) {
                    body.FeatureUsage.Parameters = {
                        PatientID: patient.PatientId,
                        PatientName: patient.PatientDetails.FirstName,
                        PatientSurname: patient.PatientDetails.Surname,
                        PatientDOB: patient.PatientDetails.DateOfBirth,
                        PatientMemberNumber: patient.PatientDetails.IdentityNo
                    };
                    _this.logFeatureUsed(body);
                }
            });
        };
        Service.prototype.openPowerBI = function (practiceId, report) {
            var _this = this;
            var body = new FeatureUsageBody();
            var featureType = UsageModule.FeatureType.PowerBI;
            var actionType = UsageModule.ActionType.ViewReport;
            body.FeatureUsage.TenantId = practiceId;
            body.FeatureUsage.Feature = UsageModule.UsageTypeUtil.getFeature(featureType);
            body.FeatureUsage.Action = UsageModule.UsageTypeUtil.getAction(actionType);
            body.FeatureUsage.Date = this.getToday();
            this.billingDomain.getProviderById(practiceId)
                .then(function (provider) {
                body.FeatureUsage.Parameters = {
                    ReportId: report.reportId,
                    ReportName: report.name,
                    BillingPracticeNumber: provider.PracticeNumber
                };
                _this.logFeatureUsed(body);
            });
        };
        Service.prototype.openedPathReport = function (practiceId, reportId, dateTime) {
            var body = new FeatureUsageBody();
            var featureType = UsageModule.FeatureType.PathologyReport;
            var actionType = UsageModule.ActionType.ViewReport;
            body.FeatureUsage.TenantId = practiceId;
            body.FeatureUsage.Feature = UsageModule.UsageTypeUtil.getFeature(featureType);
            body.FeatureUsage.Action = UsageModule.UsageTypeUtil.getAction(actionType);
            body.FeatureUsage.Date = this.getToday();
            body.FeatureUsage.Parameters = {
                ReportId: reportId,
                UserName: this.getUserName(),
                DateTime: dateTime
            };
            this.logFeatureUsed(body);
        };
        Service.prototype.openedPathReportWorkflow = function (practiceId, reportId, dateTime) {
            var body = new FeatureUsageBody();
            var featureType = UsageModule.FeatureType.PathologyReportWorkflow;
            var actionType = UsageModule.ActionType.ViewReport;
            body.FeatureUsage.TenantId = practiceId;
            body.FeatureUsage.Feature = UsageModule.UsageTypeUtil.getFeature(featureType);
            body.FeatureUsage.Action = UsageModule.UsageTypeUtil.getAction(actionType);
            body.FeatureUsage.Date = this.getToday();
            body.FeatureUsage.Parameters = {
                ReportId: reportId,
                UserName: this.getUserName(),
                DateTime: dateTime
            };
            this.logFeatureUsed(body);
        };
        Service.prototype.getUserName = function () {
            return this.storageService.getUser().name;
        };
        Service.prototype.getToday = function () {
            var now = this.moment.utc();
            return this.moment(now).format();
        };
        Service.prototype.getUrl = function () {
            return 'v1/';
        };
        return Service;
    })();
    UsageModule.Service = Service;
})(UsageModule || (UsageModule = {}));
angular.module('DoctorApp')
    .service('usageService', UsageModule.Service);
var UtilsXml = (function () {
    function UtilsXml() {
    }
    UtilsXml.loadXMLDoc = function (url) {
        if (!this.isIE()) {
            var xhttp = new XMLHttpRequest();
            xhttp.open("GET", url, false);
            xhttp.send("");
            return xhttp.responseXML;
        }
        else {
            var xmlDom = new ActiveXObject("Microsoft.XMLDOM");
            xmlDom.async = false;
            xmlDom.validateOnParse = false;
            xmlDom.load(url);
            return xmlDom;
        }
    };
    UtilsXml.loadXMLString = function (xmlText) {
        if (!this.isIE()) {
            var parser = new DOMParser();
            return parser.parseFromString(xmlText, "text/xml");
        }
        else {
            var xmlDom = new ActiveXObject("Microsoft.XMLDOM");
            xmlDom.async = false;
            xmlDom.loadXML(xmlText);
            return xmlDom;
        }
    };
    UtilsXml.generateContent = function (xml) {
        var xslUrl = this.checkStyle(xml);
        var xmlDoc = this.loadXMLString(xml);
        var xslDoc = this.loadXMLDoc(xslUrl);
        if (!this.isIE()) {
            var xsltProcessor = new XSLTProcessor();
            xsltProcessor.importStylesheet(xslDoc);
            return xsltProcessor.transformToFragment(xmlDoc, document);
        }
        else if (document.implementation && document.implementation.createDocument) {
            return xmlDoc.transformNode(xslDoc);
        }
    };
    UtilsXml.checkStyle = function (xml) {
        var reg = /ampath/gi;
        var isAmpath = reg.test(xml);
        return isAmpath ? this.ampathStylePath
            : this.lancetStylePath;
    };
    UtilsXml.isIE = function () {
        return !(DOMParser && XSLTProcessor);
    };
    UtilsXml.lancetStylePath = 'styles/clinical/labs/lancet/viewable-ext.xsl';
    UtilsXml.ampathStylePath = 'styles/clinical/labs/ampath/rs_xsl.xsl';
    return UtilsXml;
})();
//# sourceMappingURL=scripts.v4.71.2.js.map